function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire12de"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire12de"] = parcelRequire;
}
parcelRequire.register("0qhf8", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $0014624a040e5105$export$ffb0004e005737fa; }, function (v) { return $0014624a040e5105$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $0014624a040e5105$export$34b9dba7ce09269b; }, function (v) { return $0014624a040e5105$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $0014624a040e5105$export$25062201e9e25d76; }, function (v) { return $0014624a040e5105$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0014624a040e5105$export$ffb0004e005737fa;
var $0014624a040e5105$export$34b9dba7ce09269b;
var $0014624a040e5105$export$25062201e9e25d76;
"use strict";

var $bh6RR = parcelRequire("bh6RR");
var $0014624a040e5105$var$k = Symbol.for("react.element"), $0014624a040e5105$var$l = Symbol.for("react.fragment"), $0014624a040e5105$var$m = Object.prototype.hasOwnProperty, $0014624a040e5105$var$n = $bh6RR.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0014624a040e5105$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0014624a040e5105$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0014624a040e5105$var$m.call(a, b) && !$0014624a040e5105$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0014624a040e5105$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0014624a040e5105$var$n.current
    };
}
$0014624a040e5105$export$ffb0004e005737fa = $0014624a040e5105$var$l;
$0014624a040e5105$export$34b9dba7ce09269b = $0014624a040e5105$var$q;
$0014624a040e5105$export$25062201e9e25d76 = $0014624a040e5105$var$q;

});
parcelRequire.register("bh6RR", function(module, exports) {
"use strict";

module.exports = (parcelRequire("cCfq4"));

});
parcelRequire.register("cCfq4", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $92f4fea5bc247620$export$dca3b0875bd9a954; }, function (v) { return $92f4fea5bc247620$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $92f4fea5bc247620$export$16fa2f45be04daa8; }, function (v) { return $92f4fea5bc247620$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $92f4fea5bc247620$export$ffb0004e005737fa; }, function (v) { return $92f4fea5bc247620$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $92f4fea5bc247620$export$e2c29f18771995cb; }, function (v) { return $92f4fea5bc247620$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $92f4fea5bc247620$export$221d75b3f55bb0bd; }, function (v) { return $92f4fea5bc247620$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $92f4fea5bc247620$export$5f8d39834fd61797; }, function (v) { return $92f4fea5bc247620$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $92f4fea5bc247620$export$74bf444e3cd11ea5; }, function (v) { return $92f4fea5bc247620$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $92f4fea5bc247620$export$ae55be85d98224ed; }, function (v) { return $92f4fea5bc247620$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $92f4fea5bc247620$export$e530037191fcd5d7; }, function (v) { return $92f4fea5bc247620$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $92f4fea5bc247620$export$fd42f52fd3ae1109; }, function (v) { return $92f4fea5bc247620$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $92f4fea5bc247620$export$c8a8987d4410bf2d; }, function (v) { return $92f4fea5bc247620$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $92f4fea5bc247620$export$d38cd72104c1f0e9; }, function (v) { return $92f4fea5bc247620$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $92f4fea5bc247620$export$7d1e3a5e95ceca43; }, function (v) { return $92f4fea5bc247620$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $92f4fea5bc247620$export$257a8862b851cb5b; }, function (v) { return $92f4fea5bc247620$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $92f4fea5bc247620$export$a8257692ac88316c; }, function (v) { return $92f4fea5bc247620$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $92f4fea5bc247620$export$488013bae63b21da; }, function (v) { return $92f4fea5bc247620$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $92f4fea5bc247620$export$7c73462e0d25e514; }, function (v) { return $92f4fea5bc247620$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $92f4fea5bc247620$export$7568632d0d33d16d; }, function (v) { return $92f4fea5bc247620$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $92f4fea5bc247620$export$88948ce120ea2619; }, function (v) { return $92f4fea5bc247620$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $92f4fea5bc247620$export$35808ee640e87ca7; }, function (v) { return $92f4fea5bc247620$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $92f4fea5bc247620$export$fae74005e78b1a27; }, function (v) { return $92f4fea5bc247620$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $92f4fea5bc247620$export$dc8fbce3eb94dc1e; }, function (v) { return $92f4fea5bc247620$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $92f4fea5bc247620$export$6a7bc4e911dc01cf; }, function (v) { return $92f4fea5bc247620$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $92f4fea5bc247620$export$6d9c69b0de29b591; }, function (v) { return $92f4fea5bc247620$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $92f4fea5bc247620$export$f680877a34711e37; }, function (v) { return $92f4fea5bc247620$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $92f4fea5bc247620$export$d5a552a76deda3c2; }, function (v) { return $92f4fea5bc247620$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $92f4fea5bc247620$export$aaabe4eda9ed9969; }, function (v) { return $92f4fea5bc247620$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $92f4fea5bc247620$export$e5c5a5f917a5871c; }, function (v) { return $92f4fea5bc247620$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $92f4fea5bc247620$export$1538c33de8887b59; }, function (v) { return $92f4fea5bc247620$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $92f4fea5bc247620$export$13e3392192263954; }, function (v) { return $92f4fea5bc247620$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $92f4fea5bc247620$export$b8f5890fc79d6aca; }, function (v) { return $92f4fea5bc247620$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $92f4fea5bc247620$export$60241385465d0a34; }, function (v) { return $92f4fea5bc247620$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $92f4fea5bc247620$export$306c0aa65ff9ec16; }, function (v) { return $92f4fea5bc247620$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $92f4fea5bc247620$export$7b286972b8d8ccbf; }, function (v) { return $92f4fea5bc247620$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $92f4fea5bc247620$export$83d89fbfd8236492; }, function (v) { return $92f4fea5bc247620$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $92f4fea5bc247620$export$dca3b0875bd9a954;
var $92f4fea5bc247620$export$16fa2f45be04daa8;
var $92f4fea5bc247620$export$ffb0004e005737fa;
var $92f4fea5bc247620$export$e2c29f18771995cb;
var $92f4fea5bc247620$export$221d75b3f55bb0bd;
var $92f4fea5bc247620$export$5f8d39834fd61797;
var $92f4fea5bc247620$export$74bf444e3cd11ea5;
var $92f4fea5bc247620$export$ae55be85d98224ed;
var $92f4fea5bc247620$export$e530037191fcd5d7;
var $92f4fea5bc247620$export$fd42f52fd3ae1109;
var $92f4fea5bc247620$export$c8a8987d4410bf2d;
var $92f4fea5bc247620$export$d38cd72104c1f0e9;
var $92f4fea5bc247620$export$7d1e3a5e95ceca43;
var $92f4fea5bc247620$export$257a8862b851cb5b;
var $92f4fea5bc247620$export$a8257692ac88316c;
var $92f4fea5bc247620$export$488013bae63b21da;
var $92f4fea5bc247620$export$7c73462e0d25e514;
var $92f4fea5bc247620$export$7568632d0d33d16d;
var $92f4fea5bc247620$export$88948ce120ea2619;
var $92f4fea5bc247620$export$35808ee640e87ca7;
var $92f4fea5bc247620$export$fae74005e78b1a27;
var $92f4fea5bc247620$export$dc8fbce3eb94dc1e;
var $92f4fea5bc247620$export$6a7bc4e911dc01cf;
var $92f4fea5bc247620$export$6d9c69b0de29b591;
var $92f4fea5bc247620$export$f680877a34711e37;
var $92f4fea5bc247620$export$d5a552a76deda3c2;
var $92f4fea5bc247620$export$aaabe4eda9ed9969;
var $92f4fea5bc247620$export$e5c5a5f917a5871c;
var $92f4fea5bc247620$export$1538c33de8887b59;
var $92f4fea5bc247620$export$13e3392192263954;
var $92f4fea5bc247620$export$b8f5890fc79d6aca;
var $92f4fea5bc247620$export$60241385465d0a34;
var $92f4fea5bc247620$export$306c0aa65ff9ec16;
var $92f4fea5bc247620$export$7b286972b8d8ccbf;
var $92f4fea5bc247620$export$83d89fbfd8236492;
"use strict";
var $92f4fea5bc247620$var$l = Symbol.for("react.element"), $92f4fea5bc247620$var$n = Symbol.for("react.portal"), $92f4fea5bc247620$var$p = Symbol.for("react.fragment"), $92f4fea5bc247620$var$q = Symbol.for("react.strict_mode"), $92f4fea5bc247620$var$r = Symbol.for("react.profiler"), $92f4fea5bc247620$var$t = Symbol.for("react.provider"), $92f4fea5bc247620$var$u = Symbol.for("react.context"), $92f4fea5bc247620$var$v = Symbol.for("react.forward_ref"), $92f4fea5bc247620$var$w = Symbol.for("react.suspense"), $92f4fea5bc247620$var$x = Symbol.for("react.memo"), $92f4fea5bc247620$var$y = Symbol.for("react.lazy"), $92f4fea5bc247620$var$z = Symbol.iterator;
function $92f4fea5bc247620$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $92f4fea5bc247620$var$z && a[$92f4fea5bc247620$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $92f4fea5bc247620$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $92f4fea5bc247620$var$C = Object.assign, $92f4fea5bc247620$var$D = {};
function $92f4fea5bc247620$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $92f4fea5bc247620$var$D;
    this.updater = e || $92f4fea5bc247620$var$B;
}
$92f4fea5bc247620$var$E.prototype.isReactComponent = {};
$92f4fea5bc247620$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$92f4fea5bc247620$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $92f4fea5bc247620$var$F() {}
$92f4fea5bc247620$var$F.prototype = $92f4fea5bc247620$var$E.prototype;
function $92f4fea5bc247620$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $92f4fea5bc247620$var$D;
    this.updater = e || $92f4fea5bc247620$var$B;
}
var $92f4fea5bc247620$var$H = $92f4fea5bc247620$var$G.prototype = new $92f4fea5bc247620$var$F;
$92f4fea5bc247620$var$H.constructor = $92f4fea5bc247620$var$G;
$92f4fea5bc247620$var$C($92f4fea5bc247620$var$H, $92f4fea5bc247620$var$E.prototype);
$92f4fea5bc247620$var$H.isPureReactComponent = !0;
var $92f4fea5bc247620$var$I = Array.isArray, $92f4fea5bc247620$var$J = Object.prototype.hasOwnProperty, $92f4fea5bc247620$var$K = {
    current: null
}, $92f4fea5bc247620$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $92f4fea5bc247620$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$92f4fea5bc247620$var$J.call(b, d) && !$92f4fea5bc247620$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $92f4fea5bc247620$var$K.current
    };
}
function $92f4fea5bc247620$var$N(a, b) {
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $92f4fea5bc247620$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $92f4fea5bc247620$var$l;
}
function $92f4fea5bc247620$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $92f4fea5bc247620$var$P = /\/+/g;
function $92f4fea5bc247620$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $92f4fea5bc247620$var$escape("" + a.key) : b.toString(36);
}
function $92f4fea5bc247620$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $92f4fea5bc247620$var$l:
                case $92f4fea5bc247620$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $92f4fea5bc247620$var$Q(h, 0) : d, $92f4fea5bc247620$var$I(c) ? (e = "", null != a && (e = a.replace($92f4fea5bc247620$var$P, "$&/") + "/"), $92f4fea5bc247620$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($92f4fea5bc247620$var$O(c) && (c = $92f4fea5bc247620$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($92f4fea5bc247620$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($92f4fea5bc247620$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $92f4fea5bc247620$var$Q(k, g);
        h += $92f4fea5bc247620$var$R(k, b, e, f, c);
    }
    else if (f = $92f4fea5bc247620$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $92f4fea5bc247620$var$Q(k, g++), h += $92f4fea5bc247620$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $92f4fea5bc247620$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $92f4fea5bc247620$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $92f4fea5bc247620$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $92f4fea5bc247620$var$U = {
    current: null
}, $92f4fea5bc247620$var$V = {
    transition: null
}, $92f4fea5bc247620$var$W = {
    ReactCurrentDispatcher: $92f4fea5bc247620$var$U,
    ReactCurrentBatchConfig: $92f4fea5bc247620$var$V,
    ReactCurrentOwner: $92f4fea5bc247620$var$K
};
$92f4fea5bc247620$export$dca3b0875bd9a954 = {
    map: $92f4fea5bc247620$var$S,
    forEach: function(a, b, e) {
        $92f4fea5bc247620$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $92f4fea5bc247620$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $92f4fea5bc247620$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$92f4fea5bc247620$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$92f4fea5bc247620$export$16fa2f45be04daa8 = $92f4fea5bc247620$var$E;
$92f4fea5bc247620$export$ffb0004e005737fa = $92f4fea5bc247620$var$p;
$92f4fea5bc247620$export$e2c29f18771995cb = $92f4fea5bc247620$var$r;
$92f4fea5bc247620$export$221d75b3f55bb0bd = $92f4fea5bc247620$var$G;
$92f4fea5bc247620$export$5f8d39834fd61797 = $92f4fea5bc247620$var$q;
$92f4fea5bc247620$export$74bf444e3cd11ea5 = $92f4fea5bc247620$var$w;
$92f4fea5bc247620$export$ae55be85d98224ed = $92f4fea5bc247620$var$W;
$92f4fea5bc247620$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $92f4fea5bc247620$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $92f4fea5bc247620$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$92f4fea5bc247620$var$J.call(b, f) && !$92f4fea5bc247620$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$92f4fea5bc247620$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $92f4fea5bc247620$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $92f4fea5bc247620$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$92f4fea5bc247620$export$c8a8987d4410bf2d = $92f4fea5bc247620$var$M;
$92f4fea5bc247620$export$d38cd72104c1f0e9 = function(a) {
    var b = $92f4fea5bc247620$var$M.bind(null, a);
    b.type = a;
    return b;
};
$92f4fea5bc247620$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$92f4fea5bc247620$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $92f4fea5bc247620$var$v,
        render: a
    };
};
$92f4fea5bc247620$export$a8257692ac88316c = $92f4fea5bc247620$var$O;
$92f4fea5bc247620$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $92f4fea5bc247620$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $92f4fea5bc247620$var$T
    };
};
$92f4fea5bc247620$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $92f4fea5bc247620$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$92f4fea5bc247620$export$7568632d0d33d16d = function(a) {
    var b = $92f4fea5bc247620$var$V.transition;
    $92f4fea5bc247620$var$V.transition = {};
    try {
        a();
    } finally{
        $92f4fea5bc247620$var$V.transition = b;
    }
};
$92f4fea5bc247620$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$92f4fea5bc247620$export$35808ee640e87ca7 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useCallback(a, b);
};
$92f4fea5bc247620$export$fae74005e78b1a27 = function(a) {
    return $92f4fea5bc247620$var$U.current.useContext(a);
};
$92f4fea5bc247620$export$dc8fbce3eb94dc1e = function() {};
$92f4fea5bc247620$export$6a7bc4e911dc01cf = function(a) {
    return $92f4fea5bc247620$var$U.current.useDeferredValue(a);
};
$92f4fea5bc247620$export$6d9c69b0de29b591 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useEffect(a, b);
};
$92f4fea5bc247620$export$f680877a34711e37 = function() {
    return $92f4fea5bc247620$var$U.current.useId();
};
$92f4fea5bc247620$export$d5a552a76deda3c2 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useImperativeHandle(a, b, e);
};
$92f4fea5bc247620$export$aaabe4eda9ed9969 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useInsertionEffect(a, b);
};
$92f4fea5bc247620$export$e5c5a5f917a5871c = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useLayoutEffect(a, b);
};
$92f4fea5bc247620$export$1538c33de8887b59 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useMemo(a, b);
};
$92f4fea5bc247620$export$13e3392192263954 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useReducer(a, b, e);
};
$92f4fea5bc247620$export$b8f5890fc79d6aca = function(a) {
    return $92f4fea5bc247620$var$U.current.useRef(a);
};
$92f4fea5bc247620$export$60241385465d0a34 = function(a) {
    return $92f4fea5bc247620$var$U.current.useState(a);
};
$92f4fea5bc247620$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useSyncExternalStore(a, b, e);
};
$92f4fea5bc247620$export$7b286972b8d8ccbf = function() {
    return $92f4fea5bc247620$var$U.current.useTransition();
};
$92f4fea5bc247620$export$83d89fbfd8236492 = "18.2.0";

});



parcelRequire.register("foRq4", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $b36288e2db101ba3$export$ae55be85d98224ed; }, function (v) { return $b36288e2db101ba3$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $b36288e2db101ba3$export$d39a5bbd09211389; }, function (v) { return $b36288e2db101ba3$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $b36288e2db101ba3$export$882461b6382ed46c; }, function (v) { return $b36288e2db101ba3$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $b36288e2db101ba3$export$466bfc07425424d5; }, function (v) { return $b36288e2db101ba3$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $b36288e2db101ba3$export$cd75ccfd720a3cd4; }, function (v) { return $b36288e2db101ba3$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $b36288e2db101ba3$export$fa8d919ba61d84db; }, function (v) { return $b36288e2db101ba3$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $b36288e2db101ba3$export$757ceba2d55c277e; }, function (v) { return $b36288e2db101ba3$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $b36288e2db101ba3$export$b3890eb0ae9dca99; }, function (v) { return $b36288e2db101ba3$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $b36288e2db101ba3$export$502457920280e6be; }, function (v) { return $b36288e2db101ba3$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $b36288e2db101ba3$export$c78a37762a8d58e1; }, function (v) { return $b36288e2db101ba3$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $b36288e2db101ba3$export$dc54d992c10e8a18; }, function (v) { return $b36288e2db101ba3$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $b36288e2db101ba3$export$83d89fbfd8236492; }, function (v) { return $b36288e2db101ba3$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $b36288e2db101ba3$export$ae55be85d98224ed;
var $b36288e2db101ba3$export$d39a5bbd09211389;
var $b36288e2db101ba3$export$882461b6382ed46c;
var $b36288e2db101ba3$export$466bfc07425424d5;
var $b36288e2db101ba3$export$cd75ccfd720a3cd4;
var $b36288e2db101ba3$export$fa8d919ba61d84db;
var $b36288e2db101ba3$export$757ceba2d55c277e;
var $b36288e2db101ba3$export$b3890eb0ae9dca99;
var $b36288e2db101ba3$export$502457920280e6be;
var $b36288e2db101ba3$export$c78a37762a8d58e1;
var $b36288e2db101ba3$export$dc54d992c10e8a18;
var $b36288e2db101ba3$export$83d89fbfd8236492;
"use strict";

var $bh6RR = parcelRequire("bh6RR");

var $4LCdk = parcelRequire("4LCdk");
function $b36288e2db101ba3$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $b36288e2db101ba3$var$da = new Set, $b36288e2db101ba3$var$ea = {};
function $b36288e2db101ba3$var$fa(a, b) {
    $b36288e2db101ba3$var$ha(a, b);
    $b36288e2db101ba3$var$ha(a + "Capture", b);
}
function $b36288e2db101ba3$var$ha(a, b) {
    $b36288e2db101ba3$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$b36288e2db101ba3$var$da.add(b[a]);
}
var $b36288e2db101ba3$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $b36288e2db101ba3$var$ja = Object.prototype.hasOwnProperty, $b36288e2db101ba3$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $b36288e2db101ba3$var$la = {}, $b36288e2db101ba3$var$ma = {};
function $b36288e2db101ba3$var$oa(a) {
    if ($b36288e2db101ba3$var$ja.call($b36288e2db101ba3$var$ma, a)) return !0;
    if ($b36288e2db101ba3$var$ja.call($b36288e2db101ba3$var$la, a)) return !1;
    if ($b36288e2db101ba3$var$ka.test(a)) return $b36288e2db101ba3$var$ma[a] = !0;
    $b36288e2db101ba3$var$la[a] = !0;
    return !1;
}
function $b36288e2db101ba3$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $b36288e2db101ba3$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $b36288e2db101ba3$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $b36288e2db101ba3$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $b36288e2db101ba3$var$ra = /[\-:]([a-z])/g;
function $b36288e2db101ba3$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$b36288e2db101ba3$var$z.xlinkHref = new $b36288e2db101ba3$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $b36288e2db101ba3$var$ta(a, b, c, d) {
    var e = $b36288e2db101ba3$var$z.hasOwnProperty(b) ? $b36288e2db101ba3$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $b36288e2db101ba3$var$qa(b, c, e, d) && (c = null), d || null === e ? $b36288e2db101ba3$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $b36288e2db101ba3$var$ua = $bh6RR.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $b36288e2db101ba3$var$va = Symbol.for("react.element"), $b36288e2db101ba3$var$wa = Symbol.for("react.portal"), $b36288e2db101ba3$var$ya = Symbol.for("react.fragment"), $b36288e2db101ba3$var$za = Symbol.for("react.strict_mode"), $b36288e2db101ba3$var$Aa = Symbol.for("react.profiler"), $b36288e2db101ba3$var$Ba = Symbol.for("react.provider"), $b36288e2db101ba3$var$Ca = Symbol.for("react.context"), $b36288e2db101ba3$var$Da = Symbol.for("react.forward_ref"), $b36288e2db101ba3$var$Ea = Symbol.for("react.suspense"), $b36288e2db101ba3$var$Fa = Symbol.for("react.suspense_list"), $b36288e2db101ba3$var$Ga = Symbol.for("react.memo"), $b36288e2db101ba3$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $b36288e2db101ba3$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $b36288e2db101ba3$var$Ja = Symbol.iterator;
function $b36288e2db101ba3$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $b36288e2db101ba3$var$Ja && a[$b36288e2db101ba3$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $b36288e2db101ba3$var$A = Object.assign, $b36288e2db101ba3$var$La;
function $b36288e2db101ba3$var$Ma(a) {
    if (void 0 === $b36288e2db101ba3$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $b36288e2db101ba3$var$La = b && b[1] || "";
    }
    return "\n" + $b36288e2db101ba3$var$La + a;
}
var $b36288e2db101ba3$var$Na = !1;
function $b36288e2db101ba3$var$Oa(a, b) {
    if (!a || $b36288e2db101ba3$var$Na) return "";
    $b36288e2db101ba3$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $b36288e2db101ba3$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $b36288e2db101ba3$var$Ma(a) : "";
}
function $b36288e2db101ba3$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $b36288e2db101ba3$var$Ma(a.type);
        case 16:
            return $b36288e2db101ba3$var$Ma("Lazy");
        case 13:
            return $b36288e2db101ba3$var$Ma("Suspense");
        case 19:
            return $b36288e2db101ba3$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $b36288e2db101ba3$var$Oa(a.type, !1), a;
        case 11:
            return a = $b36288e2db101ba3$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $b36288e2db101ba3$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $b36288e2db101ba3$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $b36288e2db101ba3$var$ya:
            return "Fragment";
        case $b36288e2db101ba3$var$wa:
            return "Portal";
        case $b36288e2db101ba3$var$Aa:
            return "Profiler";
        case $b36288e2db101ba3$var$za:
            return "StrictMode";
        case $b36288e2db101ba3$var$Ea:
            return "Suspense";
        case $b36288e2db101ba3$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $b36288e2db101ba3$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $b36288e2db101ba3$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $b36288e2db101ba3$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $b36288e2db101ba3$var$Ga:
            return b = a.displayName || null, null !== b ? b : $b36288e2db101ba3$var$Qa(a.type) || "Memo";
        case $b36288e2db101ba3$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $b36288e2db101ba3$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $b36288e2db101ba3$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $b36288e2db101ba3$var$Qa(b);
        case 8:
            return b === $b36288e2db101ba3$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $b36288e2db101ba3$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $b36288e2db101ba3$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $b36288e2db101ba3$var$Ua(a) {
    var b = $b36288e2db101ba3$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $b36288e2db101ba3$var$Va(a) {
    a._valueTracker || (a._valueTracker = $b36288e2db101ba3$var$Ua(a));
}
function $b36288e2db101ba3$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $b36288e2db101ba3$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $b36288e2db101ba3$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $b36288e2db101ba3$var$Ya(a, b) {
    var c = b.checked;
    return $b36288e2db101ba3$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $b36288e2db101ba3$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $b36288e2db101ba3$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $b36288e2db101ba3$var$ab(a, b) {
    b = b.checked;
    null != b && $b36288e2db101ba3$var$ta(a, "checked", b, !1);
}
function $b36288e2db101ba3$var$bb(a, b) {
    $b36288e2db101ba3$var$ab(a, b);
    var c = $b36288e2db101ba3$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $b36288e2db101ba3$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $b36288e2db101ba3$var$cb(a, b.type, $b36288e2db101ba3$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $b36288e2db101ba3$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $b36288e2db101ba3$var$cb(a, b, c) {
    if ("number" !== b || $b36288e2db101ba3$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $b36288e2db101ba3$var$eb = Array.isArray;
function $b36288e2db101ba3$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $b36288e2db101ba3$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $b36288e2db101ba3$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($b36288e2db101ba3$var$p(91));
    return $b36288e2db101ba3$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $b36288e2db101ba3$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($b36288e2db101ba3$var$p(92));
            if ($b36288e2db101ba3$var$eb(c)) {
                if (1 < c.length) throw Error($b36288e2db101ba3$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $b36288e2db101ba3$var$Sa(c)
    };
}
function $b36288e2db101ba3$var$ib(a, b) {
    var c = $b36288e2db101ba3$var$Sa(b.value), d = $b36288e2db101ba3$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $b36288e2db101ba3$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $b36288e2db101ba3$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $b36288e2db101ba3$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $b36288e2db101ba3$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $b36288e2db101ba3$var$mb, $b36288e2db101ba3$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $b36288e2db101ba3$var$mb = $b36288e2db101ba3$var$mb || document.createElement("div");
        $b36288e2db101ba3$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $b36288e2db101ba3$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $b36288e2db101ba3$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $b36288e2db101ba3$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $b36288e2db101ba3$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($b36288e2db101ba3$var$pb).forEach(function(a) {
    $b36288e2db101ba3$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $b36288e2db101ba3$var$pb[b] = $b36288e2db101ba3$var$pb[a];
    });
});
function $b36288e2db101ba3$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $b36288e2db101ba3$var$pb.hasOwnProperty(a) && $b36288e2db101ba3$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $b36288e2db101ba3$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $b36288e2db101ba3$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $b36288e2db101ba3$var$tb = $b36288e2db101ba3$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $b36288e2db101ba3$var$ub(a, b) {
    if (b) {
        if ($b36288e2db101ba3$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($b36288e2db101ba3$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($b36288e2db101ba3$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($b36288e2db101ba3$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($b36288e2db101ba3$var$p(62));
    }
}
function $b36288e2db101ba3$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $b36288e2db101ba3$var$wb = null;
function $b36288e2db101ba3$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $b36288e2db101ba3$var$yb = null, $b36288e2db101ba3$var$zb = null, $b36288e2db101ba3$var$Ab = null;
function $b36288e2db101ba3$var$Bb(a) {
    if (a = $b36288e2db101ba3$var$Cb(a)) {
        if ("function" !== typeof $b36288e2db101ba3$var$yb) throw Error($b36288e2db101ba3$var$p(280));
        var b = a.stateNode;
        b && (b = $b36288e2db101ba3$var$Db(b), $b36288e2db101ba3$var$yb(a.stateNode, a.type, b));
    }
}
function $b36288e2db101ba3$var$Eb(a) {
    $b36288e2db101ba3$var$zb ? $b36288e2db101ba3$var$Ab ? $b36288e2db101ba3$var$Ab.push(a) : $b36288e2db101ba3$var$Ab = [
        a
    ] : $b36288e2db101ba3$var$zb = a;
}
function $b36288e2db101ba3$var$Fb() {
    if ($b36288e2db101ba3$var$zb) {
        var a = $b36288e2db101ba3$var$zb, b = $b36288e2db101ba3$var$Ab;
        $b36288e2db101ba3$var$Ab = $b36288e2db101ba3$var$zb = null;
        $b36288e2db101ba3$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$b36288e2db101ba3$var$Bb(b[a]);
    }
}
function $b36288e2db101ba3$var$Gb(a, b) {
    return a(b);
}
function $b36288e2db101ba3$var$Hb() {}
var $b36288e2db101ba3$var$Ib = !1;
function $b36288e2db101ba3$var$Jb(a, b, c) {
    if ($b36288e2db101ba3$var$Ib) return a(b, c);
    $b36288e2db101ba3$var$Ib = !0;
    try {
        return $b36288e2db101ba3$var$Gb(a, b, c);
    } finally{
        if ($b36288e2db101ba3$var$Ib = !1, null !== $b36288e2db101ba3$var$zb || null !== $b36288e2db101ba3$var$Ab) $b36288e2db101ba3$var$Hb(), $b36288e2db101ba3$var$Fb();
    }
}
function $b36288e2db101ba3$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $b36288e2db101ba3$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($b36288e2db101ba3$var$p(231, b, typeof c));
    return c;
}
var $b36288e2db101ba3$var$Lb = !1;
if ($b36288e2db101ba3$var$ia) try {
    var $b36288e2db101ba3$var$Mb = {};
    Object.defineProperty($b36288e2db101ba3$var$Mb, "passive", {
        get: function() {
            $b36288e2db101ba3$var$Lb = !0;
        }
    });
    window.addEventListener("test", $b36288e2db101ba3$var$Mb, $b36288e2db101ba3$var$Mb);
    window.removeEventListener("test", $b36288e2db101ba3$var$Mb, $b36288e2db101ba3$var$Mb);
} catch (a) {
    $b36288e2db101ba3$var$Lb = !1;
}
function $b36288e2db101ba3$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $b36288e2db101ba3$var$Ob = !1, $b36288e2db101ba3$var$Pb = null, $b36288e2db101ba3$var$Qb = !1, $b36288e2db101ba3$var$Rb = null, $b36288e2db101ba3$var$Sb = {
    onError: function(a) {
        $b36288e2db101ba3$var$Ob = !0;
        $b36288e2db101ba3$var$Pb = a;
    }
};
function $b36288e2db101ba3$var$Tb(a, b, c, d, e, f, g, h, k) {
    $b36288e2db101ba3$var$Ob = !1;
    $b36288e2db101ba3$var$Pb = null;
    $b36288e2db101ba3$var$Nb.apply($b36288e2db101ba3$var$Sb, arguments);
}
function $b36288e2db101ba3$var$Ub(a, b, c, d, e, f, g, h, k) {
    $b36288e2db101ba3$var$Tb.apply(this, arguments);
    if ($b36288e2db101ba3$var$Ob) {
        if ($b36288e2db101ba3$var$Ob) {
            var l = $b36288e2db101ba3$var$Pb;
            $b36288e2db101ba3$var$Ob = !1;
            $b36288e2db101ba3$var$Pb = null;
        } else throw Error($b36288e2db101ba3$var$p(198));
        $b36288e2db101ba3$var$Qb || ($b36288e2db101ba3$var$Qb = !0, $b36288e2db101ba3$var$Rb = l);
    }
}
function $b36288e2db101ba3$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b36288e2db101ba3$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $b36288e2db101ba3$var$Xb(a) {
    if ($b36288e2db101ba3$var$Vb(a) !== a) throw Error($b36288e2db101ba3$var$p(188));
}
function $b36288e2db101ba3$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $b36288e2db101ba3$var$Vb(a);
        if (null === b) throw Error($b36288e2db101ba3$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $b36288e2db101ba3$var$Xb(e), a;
                if (f === d) return $b36288e2db101ba3$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($b36288e2db101ba3$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($b36288e2db101ba3$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($b36288e2db101ba3$var$p(190));
    }
    if (3 !== c.tag) throw Error($b36288e2db101ba3$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $b36288e2db101ba3$var$Zb(a) {
    a = $b36288e2db101ba3$var$Yb(a);
    return null !== a ? $b36288e2db101ba3$var$$b(a) : null;
}
function $b36288e2db101ba3$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $b36288e2db101ba3$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $b36288e2db101ba3$var$ac = $4LCdk.unstable_scheduleCallback, $b36288e2db101ba3$var$bc = $4LCdk.unstable_cancelCallback, $b36288e2db101ba3$var$cc = $4LCdk.unstable_shouldYield, $b36288e2db101ba3$var$dc = $4LCdk.unstable_requestPaint, $b36288e2db101ba3$var$B = $4LCdk.unstable_now, $b36288e2db101ba3$var$ec = $4LCdk.unstable_getCurrentPriorityLevel, $b36288e2db101ba3$var$fc = $4LCdk.unstable_ImmediatePriority, $b36288e2db101ba3$var$gc = $4LCdk.unstable_UserBlockingPriority, $b36288e2db101ba3$var$hc = $4LCdk.unstable_NormalPriority, $b36288e2db101ba3$var$ic = $4LCdk.unstable_LowPriority, $b36288e2db101ba3$var$jc = $4LCdk.unstable_IdlePriority, $b36288e2db101ba3$var$kc = null, $b36288e2db101ba3$var$lc = null;
function $b36288e2db101ba3$var$mc(a) {
    if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onCommitFiberRoot) try {
        $b36288e2db101ba3$var$lc.onCommitFiberRoot($b36288e2db101ba3$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $b36288e2db101ba3$var$oc = Math.clz32 ? Math.clz32 : $b36288e2db101ba3$var$nc, $b36288e2db101ba3$var$pc = Math.log, $b36288e2db101ba3$var$qc = Math.LN2;
function $b36288e2db101ba3$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($b36288e2db101ba3$var$pc(a) / $b36288e2db101ba3$var$qc | 0) | 0;
}
var $b36288e2db101ba3$var$rc = 64, $b36288e2db101ba3$var$sc = 4194304;
function $b36288e2db101ba3$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $b36288e2db101ba3$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $b36288e2db101ba3$var$tc(h) : (f &= g, 0 !== f && (d = $b36288e2db101ba3$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $b36288e2db101ba3$var$tc(g) : 0 !== f && (d = $b36288e2db101ba3$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $b36288e2db101ba3$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $b36288e2db101ba3$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $b36288e2db101ba3$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $b36288e2db101ba3$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $b36288e2db101ba3$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $b36288e2db101ba3$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $b36288e2db101ba3$var$yc() {
    var a = $b36288e2db101ba3$var$rc;
    $b36288e2db101ba3$var$rc <<= 1;
    0 === ($b36288e2db101ba3$var$rc & 4194240) && ($b36288e2db101ba3$var$rc = 64);
    return a;
}
function $b36288e2db101ba3$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $b36288e2db101ba3$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $b36288e2db101ba3$var$oc(b);
    a[b] = c;
}
function $b36288e2db101ba3$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $b36288e2db101ba3$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $b36288e2db101ba3$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $b36288e2db101ba3$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $b36288e2db101ba3$var$C = 0;
function $b36288e2db101ba3$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $b36288e2db101ba3$var$Ec, $b36288e2db101ba3$var$Fc, $b36288e2db101ba3$var$Gc, $b36288e2db101ba3$var$Hc, $b36288e2db101ba3$var$Ic, $b36288e2db101ba3$var$Jc = !1, $b36288e2db101ba3$var$Kc = [], $b36288e2db101ba3$var$Lc = null, $b36288e2db101ba3$var$Mc = null, $b36288e2db101ba3$var$Nc = null, $b36288e2db101ba3$var$Oc = new Map, $b36288e2db101ba3$var$Pc = new Map, $b36288e2db101ba3$var$Qc = [], $b36288e2db101ba3$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $b36288e2db101ba3$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $b36288e2db101ba3$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $b36288e2db101ba3$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $b36288e2db101ba3$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $b36288e2db101ba3$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $b36288e2db101ba3$var$Pc.delete(b.pointerId);
    }
}
function $b36288e2db101ba3$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $b36288e2db101ba3$var$Cb(b), null !== b && $b36288e2db101ba3$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $b36288e2db101ba3$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $b36288e2db101ba3$var$Lc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $b36288e2db101ba3$var$Mc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $b36288e2db101ba3$var$Nc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $b36288e2db101ba3$var$Oc.set(f, $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $b36288e2db101ba3$var$Pc.set(f, $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $b36288e2db101ba3$var$Vc(a) {
    var b = $b36288e2db101ba3$var$Wc(a.target);
    if (null !== b) {
        var c = $b36288e2db101ba3$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b36288e2db101ba3$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $b36288e2db101ba3$var$Ic(a.priority, function() {
                        $b36288e2db101ba3$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $b36288e2db101ba3$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $b36288e2db101ba3$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $b36288e2db101ba3$var$wb = d;
            c.target.dispatchEvent(d);
            $b36288e2db101ba3$var$wb = null;
        } else return b = $b36288e2db101ba3$var$Cb(c), null !== b && $b36288e2db101ba3$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $b36288e2db101ba3$var$Zc(a, b, c) {
    $b36288e2db101ba3$var$Xc(a) && c.delete(b);
}
function $b36288e2db101ba3$var$$c() {
    $b36288e2db101ba3$var$Jc = !1;
    null !== $b36288e2db101ba3$var$Lc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Lc) && ($b36288e2db101ba3$var$Lc = null);
    null !== $b36288e2db101ba3$var$Mc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Mc) && ($b36288e2db101ba3$var$Mc = null);
    null !== $b36288e2db101ba3$var$Nc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Nc) && ($b36288e2db101ba3$var$Nc = null);
    $b36288e2db101ba3$var$Oc.forEach($b36288e2db101ba3$var$Zc);
    $b36288e2db101ba3$var$Pc.forEach($b36288e2db101ba3$var$Zc);
}
function $b36288e2db101ba3$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $b36288e2db101ba3$var$Jc || ($b36288e2db101ba3$var$Jc = !0, $4LCdk.unstable_scheduleCallback($4LCdk.unstable_NormalPriority, $b36288e2db101ba3$var$$c)));
}
function $b36288e2db101ba3$var$bd(a) {
    function b(b) {
        return $b36288e2db101ba3$var$ad(b, a);
    }
    if (0 < $b36288e2db101ba3$var$Kc.length) {
        $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Kc[0], a);
        for(var c = 1; c < $b36288e2db101ba3$var$Kc.length; c++){
            var d = $b36288e2db101ba3$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $b36288e2db101ba3$var$Lc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Lc, a);
    null !== $b36288e2db101ba3$var$Mc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Mc, a);
    null !== $b36288e2db101ba3$var$Nc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Nc, a);
    $b36288e2db101ba3$var$Oc.forEach(b);
    $b36288e2db101ba3$var$Pc.forEach(b);
    for(c = 0; c < $b36288e2db101ba3$var$Qc.length; c++)d = $b36288e2db101ba3$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $b36288e2db101ba3$var$Qc.length && (c = $b36288e2db101ba3$var$Qc[0], null === c.blockedOn);)$b36288e2db101ba3$var$Vc(c), null === c.blockedOn && $b36288e2db101ba3$var$Qc.shift();
}
var $b36288e2db101ba3$var$cd = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$dd = !0;
function $b36288e2db101ba3$var$ed(a, b, c, d) {
    var e = $b36288e2db101ba3$var$C, f = $b36288e2db101ba3$var$cd.transition;
    $b36288e2db101ba3$var$cd.transition = null;
    try {
        $b36288e2db101ba3$var$C = 1, $b36288e2db101ba3$var$fd(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$C = e, $b36288e2db101ba3$var$cd.transition = f;
    }
}
function $b36288e2db101ba3$var$gd(a, b, c, d) {
    var e = $b36288e2db101ba3$var$C, f = $b36288e2db101ba3$var$cd.transition;
    $b36288e2db101ba3$var$cd.transition = null;
    try {
        $b36288e2db101ba3$var$C = 4, $b36288e2db101ba3$var$fd(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$C = e, $b36288e2db101ba3$var$cd.transition = f;
    }
}
function $b36288e2db101ba3$var$fd(a, b, c, d) {
    if ($b36288e2db101ba3$var$dd) {
        var e = $b36288e2db101ba3$var$Yc(a, b, c, d);
        if (null === e) $b36288e2db101ba3$var$hd(a, b, d, $b36288e2db101ba3$var$id, c), $b36288e2db101ba3$var$Sc(a, d);
        else if ($b36288e2db101ba3$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($b36288e2db101ba3$var$Sc(a, d), b & 4 && -1 < $b36288e2db101ba3$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $b36288e2db101ba3$var$Cb(e);
                null !== f && $b36288e2db101ba3$var$Ec(f);
                f = $b36288e2db101ba3$var$Yc(a, b, c, d);
                null === f && $b36288e2db101ba3$var$hd(a, b, d, $b36288e2db101ba3$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $b36288e2db101ba3$var$hd(a, b, d, null, c);
    }
}
var $b36288e2db101ba3$var$id = null;
function $b36288e2db101ba3$var$Yc(a, b, c, d) {
    $b36288e2db101ba3$var$id = null;
    a = $b36288e2db101ba3$var$xb(d);
    a = $b36288e2db101ba3$var$Wc(a);
    if (null !== a) {
        if (b = $b36288e2db101ba3$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $b36288e2db101ba3$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $b36288e2db101ba3$var$id = a;
    return null;
}
function $b36288e2db101ba3$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($b36288e2db101ba3$var$ec()){
                case $b36288e2db101ba3$var$fc:
                    return 1;
                case $b36288e2db101ba3$var$gc:
                    return 4;
                case $b36288e2db101ba3$var$hc:
                case $b36288e2db101ba3$var$ic:
                    return 16;
                case $b36288e2db101ba3$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $b36288e2db101ba3$var$kd = null, $b36288e2db101ba3$var$ld = null, $b36288e2db101ba3$var$md = null;
function $b36288e2db101ba3$var$nd() {
    if ($b36288e2db101ba3$var$md) return $b36288e2db101ba3$var$md;
    var a, b = $b36288e2db101ba3$var$ld, c = b.length, d, e = "value" in $b36288e2db101ba3$var$kd ? $b36288e2db101ba3$var$kd.value : $b36288e2db101ba3$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $b36288e2db101ba3$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $b36288e2db101ba3$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $b36288e2db101ba3$var$pd() {
    return !0;
}
function $b36288e2db101ba3$var$qd() {
    return !1;
}
function $b36288e2db101ba3$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $b36288e2db101ba3$var$pd : $b36288e2db101ba3$var$qd;
        this.isPropagationStopped = $b36288e2db101ba3$var$qd;
        return this;
    }
    $b36288e2db101ba3$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $b36288e2db101ba3$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $b36288e2db101ba3$var$pd);
        },
        persist: function() {},
        isPersistent: $b36288e2db101ba3$var$pd
    });
    return b;
}
var $b36288e2db101ba3$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $b36288e2db101ba3$var$td = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$sd), $b36288e2db101ba3$var$ud = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    view: 0,
    detail: 0
}), $b36288e2db101ba3$var$vd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$ud), $b36288e2db101ba3$var$wd, $b36288e2db101ba3$var$xd, $b36288e2db101ba3$var$yd, $b36288e2db101ba3$var$Ad = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $b36288e2db101ba3$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $b36288e2db101ba3$var$yd && ($b36288e2db101ba3$var$yd && "mousemove" === a.type ? ($b36288e2db101ba3$var$wd = a.screenX - $b36288e2db101ba3$var$yd.screenX, $b36288e2db101ba3$var$xd = a.screenY - $b36288e2db101ba3$var$yd.screenY) : $b36288e2db101ba3$var$xd = $b36288e2db101ba3$var$wd = 0, $b36288e2db101ba3$var$yd = a);
        return $b36288e2db101ba3$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $b36288e2db101ba3$var$xd;
    }
}), $b36288e2db101ba3$var$Bd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ad), $b36288e2db101ba3$var$Cd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    dataTransfer: 0
}), $b36288e2db101ba3$var$Dd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Cd), $b36288e2db101ba3$var$Ed = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    relatedTarget: 0
}), $b36288e2db101ba3$var$Fd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ed), $b36288e2db101ba3$var$Gd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b36288e2db101ba3$var$Hd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Gd), $b36288e2db101ba3$var$Id = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $b36288e2db101ba3$var$Jd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Id), $b36288e2db101ba3$var$Kd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    data: 0
}), $b36288e2db101ba3$var$Ld = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Kd), $b36288e2db101ba3$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $b36288e2db101ba3$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $b36288e2db101ba3$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $b36288e2db101ba3$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $b36288e2db101ba3$var$Od[a]) ? !!b[a] : !1;
}
function $b36288e2db101ba3$var$zd() {
    return $b36288e2db101ba3$var$Pd;
}
var $b36288e2db101ba3$var$Qd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $b36288e2db101ba3$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $b36288e2db101ba3$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $b36288e2db101ba3$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $b36288e2db101ba3$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $b36288e2db101ba3$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $b36288e2db101ba3$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $b36288e2db101ba3$var$Rd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Qd), $b36288e2db101ba3$var$Sd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $b36288e2db101ba3$var$Td = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Sd), $b36288e2db101ba3$var$Ud = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $b36288e2db101ba3$var$zd
}), $b36288e2db101ba3$var$Vd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ud), $b36288e2db101ba3$var$Wd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b36288e2db101ba3$var$Xd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Wd), $b36288e2db101ba3$var$Yd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $b36288e2db101ba3$var$Zd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Yd), $b36288e2db101ba3$var$$d = [
    9,
    13,
    27,
    32
], $b36288e2db101ba3$var$ae = $b36288e2db101ba3$var$ia && "CompositionEvent" in window, $b36288e2db101ba3$var$be = null;
$b36288e2db101ba3$var$ia && "documentMode" in document && ($b36288e2db101ba3$var$be = document.documentMode);
var $b36288e2db101ba3$var$ce = $b36288e2db101ba3$var$ia && "TextEvent" in window && !$b36288e2db101ba3$var$be, $b36288e2db101ba3$var$de = $b36288e2db101ba3$var$ia && (!$b36288e2db101ba3$var$ae || $b36288e2db101ba3$var$be && 8 < $b36288e2db101ba3$var$be && 11 >= $b36288e2db101ba3$var$be), $b36288e2db101ba3$var$ee = String.fromCharCode(32), $b36288e2db101ba3$var$fe = !1;
function $b36288e2db101ba3$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $b36288e2db101ba3$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $b36288e2db101ba3$var$ie = !1;
function $b36288e2db101ba3$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $b36288e2db101ba3$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $b36288e2db101ba3$var$fe = !0;
            return $b36288e2db101ba3$var$ee;
        case "textInput":
            return a = b.data, a === $b36288e2db101ba3$var$ee && $b36288e2db101ba3$var$fe ? null : a;
        default:
            return null;
    }
}
function $b36288e2db101ba3$var$ke(a, b) {
    if ($b36288e2db101ba3$var$ie) return "compositionend" === a || !$b36288e2db101ba3$var$ae && $b36288e2db101ba3$var$ge(a, b) ? (a = $b36288e2db101ba3$var$nd(), $b36288e2db101ba3$var$md = $b36288e2db101ba3$var$ld = $b36288e2db101ba3$var$kd = null, $b36288e2db101ba3$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $b36288e2db101ba3$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $b36288e2db101ba3$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $b36288e2db101ba3$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$b36288e2db101ba3$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $b36288e2db101ba3$var$ne(a, b, c, d) {
    $b36288e2db101ba3$var$Eb(d);
    b = $b36288e2db101ba3$var$oe(b, "onChange");
    0 < b.length && (c = new $b36288e2db101ba3$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $b36288e2db101ba3$var$pe = null, $b36288e2db101ba3$var$qe = null;
function $b36288e2db101ba3$var$re(a) {
    $b36288e2db101ba3$var$se(a, 0);
}
function $b36288e2db101ba3$var$te(a) {
    var b = $b36288e2db101ba3$var$ue(a);
    if ($b36288e2db101ba3$var$Wa(b)) return a;
}
function $b36288e2db101ba3$var$ve(a, b) {
    if ("change" === a) return b;
}
var $b36288e2db101ba3$var$we = !1;
if ($b36288e2db101ba3$var$ia) {
    var $b36288e2db101ba3$var$xe;
    if ($b36288e2db101ba3$var$ia) {
        var $b36288e2db101ba3$var$ye = "oninput" in document;
        if (!$b36288e2db101ba3$var$ye) {
            var $b36288e2db101ba3$var$ze = document.createElement("div");
            $b36288e2db101ba3$var$ze.setAttribute("oninput", "return;");
            $b36288e2db101ba3$var$ye = "function" === typeof $b36288e2db101ba3$var$ze.oninput;
        }
        $b36288e2db101ba3$var$xe = $b36288e2db101ba3$var$ye;
    } else $b36288e2db101ba3$var$xe = !1;
    $b36288e2db101ba3$var$we = $b36288e2db101ba3$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $b36288e2db101ba3$var$Ae() {
    $b36288e2db101ba3$var$pe && ($b36288e2db101ba3$var$pe.detachEvent("onpropertychange", $b36288e2db101ba3$var$Be), $b36288e2db101ba3$var$qe = $b36288e2db101ba3$var$pe = null);
}
function $b36288e2db101ba3$var$Be(a) {
    if ("value" === a.propertyName && $b36288e2db101ba3$var$te($b36288e2db101ba3$var$qe)) {
        var b = [];
        $b36288e2db101ba3$var$ne(b, $b36288e2db101ba3$var$qe, a, $b36288e2db101ba3$var$xb(a));
        $b36288e2db101ba3$var$Jb($b36288e2db101ba3$var$re, b);
    }
}
function $b36288e2db101ba3$var$Ce(a, b, c) {
    "focusin" === a ? ($b36288e2db101ba3$var$Ae(), $b36288e2db101ba3$var$pe = b, $b36288e2db101ba3$var$qe = c, $b36288e2db101ba3$var$pe.attachEvent("onpropertychange", $b36288e2db101ba3$var$Be)) : "focusout" === a && $b36288e2db101ba3$var$Ae();
}
function $b36288e2db101ba3$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $b36288e2db101ba3$var$te($b36288e2db101ba3$var$qe);
}
function $b36288e2db101ba3$var$Ee(a, b) {
    if ("click" === a) return $b36288e2db101ba3$var$te(b);
}
function $b36288e2db101ba3$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $b36288e2db101ba3$var$te(b);
}
function $b36288e2db101ba3$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $b36288e2db101ba3$var$He = "function" === typeof Object.is ? Object.is : $b36288e2db101ba3$var$Ge;
function $b36288e2db101ba3$var$Ie(a, b) {
    if ($b36288e2db101ba3$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$b36288e2db101ba3$var$ja.call(b, e) || !$b36288e2db101ba3$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $b36288e2db101ba3$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $b36288e2db101ba3$var$Ke(a, b) {
    var c = $b36288e2db101ba3$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $b36288e2db101ba3$var$Je(c);
    }
}
function $b36288e2db101ba3$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $b36288e2db101ba3$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $b36288e2db101ba3$var$Me() {
    for(var a = window, b = $b36288e2db101ba3$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $b36288e2db101ba3$var$Xa(a.document);
    }
    return b;
}
function $b36288e2db101ba3$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $b36288e2db101ba3$var$Oe(a) {
    var b = $b36288e2db101ba3$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $b36288e2db101ba3$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $b36288e2db101ba3$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $b36288e2db101ba3$var$Ke(c, f);
                var g = $b36288e2db101ba3$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $b36288e2db101ba3$var$Pe = $b36288e2db101ba3$var$ia && "documentMode" in document && 11 >= document.documentMode, $b36288e2db101ba3$var$Qe = null, $b36288e2db101ba3$var$Re = null, $b36288e2db101ba3$var$Se = null, $b36288e2db101ba3$var$Te = !1;
function $b36288e2db101ba3$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $b36288e2db101ba3$var$Te || null == $b36288e2db101ba3$var$Qe || $b36288e2db101ba3$var$Qe !== $b36288e2db101ba3$var$Xa(d) || (d = $b36288e2db101ba3$var$Qe, "selectionStart" in d && $b36288e2db101ba3$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $b36288e2db101ba3$var$Se && $b36288e2db101ba3$var$Ie($b36288e2db101ba3$var$Se, d) || ($b36288e2db101ba3$var$Se = d, d = $b36288e2db101ba3$var$oe($b36288e2db101ba3$var$Re, "onSelect"), 0 < d.length && (b = new $b36288e2db101ba3$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $b36288e2db101ba3$var$Qe)));
}
function $b36288e2db101ba3$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $b36288e2db101ba3$var$We = {
    animationend: $b36288e2db101ba3$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $b36288e2db101ba3$var$Ve("Animation", "AnimationIteration"),
    animationstart: $b36288e2db101ba3$var$Ve("Animation", "AnimationStart"),
    transitionend: $b36288e2db101ba3$var$Ve("Transition", "TransitionEnd")
}, $b36288e2db101ba3$var$Xe = {}, $b36288e2db101ba3$var$Ye = {};
$b36288e2db101ba3$var$ia && ($b36288e2db101ba3$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $b36288e2db101ba3$var$We.animationend.animation, delete $b36288e2db101ba3$var$We.animationiteration.animation, delete $b36288e2db101ba3$var$We.animationstart.animation), "TransitionEvent" in window || delete $b36288e2db101ba3$var$We.transitionend.transition);
function $b36288e2db101ba3$var$Ze(a) {
    if ($b36288e2db101ba3$var$Xe[a]) return $b36288e2db101ba3$var$Xe[a];
    if (!$b36288e2db101ba3$var$We[a]) return a;
    var b = $b36288e2db101ba3$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $b36288e2db101ba3$var$Ye) return $b36288e2db101ba3$var$Xe[a] = b[c];
    return a;
}
var $b36288e2db101ba3$var$$e = $b36288e2db101ba3$var$Ze("animationend"), $b36288e2db101ba3$var$af = $b36288e2db101ba3$var$Ze("animationiteration"), $b36288e2db101ba3$var$bf = $b36288e2db101ba3$var$Ze("animationstart"), $b36288e2db101ba3$var$cf = $b36288e2db101ba3$var$Ze("transitionend"), $b36288e2db101ba3$var$df = new Map, $b36288e2db101ba3$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $b36288e2db101ba3$var$ff(a, b) {
    $b36288e2db101ba3$var$df.set(a, b);
    $b36288e2db101ba3$var$fa(b, [
        a
    ]);
}
for(var $b36288e2db101ba3$var$gf = 0; $b36288e2db101ba3$var$gf < $b36288e2db101ba3$var$ef.length; $b36288e2db101ba3$var$gf++){
    var $b36288e2db101ba3$var$hf = $b36288e2db101ba3$var$ef[$b36288e2db101ba3$var$gf], $b36288e2db101ba3$var$jf = $b36288e2db101ba3$var$hf.toLowerCase(), $b36288e2db101ba3$var$kf = $b36288e2db101ba3$var$hf[0].toUpperCase() + $b36288e2db101ba3$var$hf.slice(1);
    $b36288e2db101ba3$var$ff($b36288e2db101ba3$var$jf, "on" + $b36288e2db101ba3$var$kf);
}
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$$e, "onAnimationEnd");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$af, "onAnimationIteration");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$bf, "onAnimationStart");
$b36288e2db101ba3$var$ff("dblclick", "onDoubleClick");
$b36288e2db101ba3$var$ff("focusin", "onFocus");
$b36288e2db101ba3$var$ff("focusout", "onBlur");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$cf, "onTransitionEnd");
$b36288e2db101ba3$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$b36288e2db101ba3$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$b36288e2db101ba3$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$b36288e2db101ba3$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$b36288e2db101ba3$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$b36288e2db101ba3$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$b36288e2db101ba3$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$b36288e2db101ba3$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$b36288e2db101ba3$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$b36288e2db101ba3$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $b36288e2db101ba3$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $b36288e2db101ba3$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($b36288e2db101ba3$var$lf));
function $b36288e2db101ba3$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $b36288e2db101ba3$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $b36288e2db101ba3$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b36288e2db101ba3$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b36288e2db101ba3$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($b36288e2db101ba3$var$Qb) throw a = $b36288e2db101ba3$var$Rb, $b36288e2db101ba3$var$Qb = !1, $b36288e2db101ba3$var$Rb = null, a;
}
function $b36288e2db101ba3$var$D(a, b) {
    var c = b[$b36288e2db101ba3$var$of];
    void 0 === c && (c = b[$b36288e2db101ba3$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($b36288e2db101ba3$var$pf(b, a, 2, !1), c.add(d));
}
function $b36288e2db101ba3$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $b36288e2db101ba3$var$pf(c, a, d, b);
}
var $b36288e2db101ba3$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $b36288e2db101ba3$var$sf(a) {
    if (!a[$b36288e2db101ba3$var$rf]) {
        a[$b36288e2db101ba3$var$rf] = !0;
        $b36288e2db101ba3$var$da.forEach(function(b) {
            "selectionchange" !== b && ($b36288e2db101ba3$var$mf.has(b) || $b36288e2db101ba3$var$qf(b, !1, a), $b36288e2db101ba3$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$b36288e2db101ba3$var$rf] || (b[$b36288e2db101ba3$var$rf] = !0, $b36288e2db101ba3$var$qf("selectionchange", !1, b));
    }
}
function $b36288e2db101ba3$var$pf(a, b, c, d) {
    switch($b36288e2db101ba3$var$jd(b)){
        case 1:
            var e = $b36288e2db101ba3$var$ed;
            break;
        case 4:
            e = $b36288e2db101ba3$var$gd;
            break;
        default:
            e = $b36288e2db101ba3$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$b36288e2db101ba3$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $b36288e2db101ba3$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $b36288e2db101ba3$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $b36288e2db101ba3$var$Jb(function() {
        var d = f, e = $b36288e2db101ba3$var$xb(c), g = [];
        a: {
            var h = $b36288e2db101ba3$var$df.get(a);
            if (void 0 !== h) {
                var k = $b36288e2db101ba3$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $b36288e2db101ba3$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $b36288e2db101ba3$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $b36288e2db101ba3$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $b36288e2db101ba3$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $b36288e2db101ba3$var$Vd;
                        break;
                    case $b36288e2db101ba3$var$$e:
                    case $b36288e2db101ba3$var$af:
                    case $b36288e2db101ba3$var$bf:
                        k = $b36288e2db101ba3$var$Hd;
                        break;
                    case $b36288e2db101ba3$var$cf:
                        k = $b36288e2db101ba3$var$Xd;
                        break;
                    case "scroll":
                        k = $b36288e2db101ba3$var$vd;
                        break;
                    case "wheel":
                        k = $b36288e2db101ba3$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $b36288e2db101ba3$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $b36288e2db101ba3$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $b36288e2db101ba3$var$Kb(w, x), null != F && t.push($b36288e2db101ba3$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $b36288e2db101ba3$var$wb && (n = c.relatedTarget || c.fromElement) && ($b36288e2db101ba3$var$Wc(n) || n[$b36288e2db101ba3$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $b36288e2db101ba3$var$Wc(n) : null, null !== n && (J = $b36288e2db101ba3$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $b36288e2db101ba3$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $b36288e2db101ba3$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $b36288e2db101ba3$var$ue(k);
                        u = null == n ? h : $b36288e2db101ba3$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $b36288e2db101ba3$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $b36288e2db101ba3$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $b36288e2db101ba3$var$vf(F))u++;
                            for(; 0 < w - u;)t = $b36288e2db101ba3$var$vf(t), w--;
                            for(; 0 < u - w;)x = $b36288e2db101ba3$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $b36288e2db101ba3$var$vf(t);
                                x = $b36288e2db101ba3$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $b36288e2db101ba3$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $b36288e2db101ba3$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $b36288e2db101ba3$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $b36288e2db101ba3$var$ve;
                else if ($b36288e2db101ba3$var$me(h)) {
                    if ($b36288e2db101ba3$var$we) na = $b36288e2db101ba3$var$Fe;
                    else {
                        na = $b36288e2db101ba3$var$De;
                        var xa = $b36288e2db101ba3$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $b36288e2db101ba3$var$Ee);
                if (na && (na = na(a, d))) {
                    $b36288e2db101ba3$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $b36288e2db101ba3$var$cb(h, "number", h.value);
            }
            xa = d ? $b36288e2db101ba3$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($b36288e2db101ba3$var$me(xa) || "true" === xa.contentEditable) $b36288e2db101ba3$var$Qe = xa, $b36288e2db101ba3$var$Re = d, $b36288e2db101ba3$var$Se = null;
                    break;
                case "focusout":
                    $b36288e2db101ba3$var$Se = $b36288e2db101ba3$var$Re = $b36288e2db101ba3$var$Qe = null;
                    break;
                case "mousedown":
                    $b36288e2db101ba3$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $b36288e2db101ba3$var$Te = !1;
                    $b36288e2db101ba3$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($b36288e2db101ba3$var$Pe) break;
                case "keydown":
                case "keyup":
                    $b36288e2db101ba3$var$Ue(g, c, e);
            }
            var $a;
            if ($b36288e2db101ba3$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $b36288e2db101ba3$var$ie ? $b36288e2db101ba3$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($b36288e2db101ba3$var$de && "ko" !== c.locale && ($b36288e2db101ba3$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $b36288e2db101ba3$var$ie && ($a = $b36288e2db101ba3$var$nd()) : ($b36288e2db101ba3$var$kd = e, $b36288e2db101ba3$var$ld = "value" in $b36288e2db101ba3$var$kd ? $b36288e2db101ba3$var$kd.value : $b36288e2db101ba3$var$kd.textContent, $b36288e2db101ba3$var$ie = !0)), xa = $b36288e2db101ba3$var$oe(d, ba), 0 < xa.length && (ba = new $b36288e2db101ba3$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $b36288e2db101ba3$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $b36288e2db101ba3$var$ce ? $b36288e2db101ba3$var$je(a, c) : $b36288e2db101ba3$var$ke(a, c)) d = $b36288e2db101ba3$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $b36288e2db101ba3$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $b36288e2db101ba3$var$se(g, b);
    });
}
function $b36288e2db101ba3$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $b36288e2db101ba3$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $b36288e2db101ba3$var$Kb(a, c), null != f && d.unshift($b36288e2db101ba3$var$tf(a, f, e)), f = $b36288e2db101ba3$var$Kb(a, b), null != f && d.push($b36288e2db101ba3$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $b36288e2db101ba3$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $b36288e2db101ba3$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $b36288e2db101ba3$var$Kb(c, f), null != k && g.unshift($b36288e2db101ba3$var$tf(c, k, h))) : e || (k = $b36288e2db101ba3$var$Kb(c, f), null != k && g.push($b36288e2db101ba3$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $b36288e2db101ba3$var$xf = /\r\n?/g, $b36288e2db101ba3$var$yf = /\u0000|\uFFFD/g;
function $b36288e2db101ba3$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($b36288e2db101ba3$var$xf, "\n").replace($b36288e2db101ba3$var$yf, "");
}
function $b36288e2db101ba3$var$Af(a, b, c) {
    b = $b36288e2db101ba3$var$zf(b);
    if ($b36288e2db101ba3$var$zf(a) !== b && c) throw Error($b36288e2db101ba3$var$p(425));
}
function $b36288e2db101ba3$var$Bf() {}
var $b36288e2db101ba3$var$Cf = null, $b36288e2db101ba3$var$Df = null;
function $b36288e2db101ba3$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $b36288e2db101ba3$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $b36288e2db101ba3$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $b36288e2db101ba3$var$Hf = "function" === typeof Promise ? Promise : void 0, $b36288e2db101ba3$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $b36288e2db101ba3$var$Hf ? function(a) {
    return $b36288e2db101ba3$var$Hf.resolve(null).then(a).catch($b36288e2db101ba3$var$If);
} : $b36288e2db101ba3$var$Ff;
function $b36288e2db101ba3$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $b36288e2db101ba3$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $b36288e2db101ba3$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $b36288e2db101ba3$var$bd(b);
}
function $b36288e2db101ba3$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $b36288e2db101ba3$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $b36288e2db101ba3$var$Nf = Math.random().toString(36).slice(2), $b36288e2db101ba3$var$Of = "__reactFiber$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Pf = "__reactProps$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$uf = "__reactContainer$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$of = "__reactEvents$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Qf = "__reactListeners$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Rf = "__reactHandles$" + $b36288e2db101ba3$var$Nf;
function $b36288e2db101ba3$var$Wc(a) {
    var b = a[$b36288e2db101ba3$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$b36288e2db101ba3$var$uf] || c[$b36288e2db101ba3$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $b36288e2db101ba3$var$Mf(a); null !== a;){
                if (c = a[$b36288e2db101ba3$var$Of]) return c;
                a = $b36288e2db101ba3$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $b36288e2db101ba3$var$Cb(a) {
    a = a[$b36288e2db101ba3$var$Of] || a[$b36288e2db101ba3$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $b36288e2db101ba3$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($b36288e2db101ba3$var$p(33));
}
function $b36288e2db101ba3$var$Db(a) {
    return a[$b36288e2db101ba3$var$Pf] || null;
}
var $b36288e2db101ba3$var$Sf = [], $b36288e2db101ba3$var$Tf = -1;
function $b36288e2db101ba3$var$Uf(a) {
    return {
        current: a
    };
}
function $b36288e2db101ba3$var$E(a) {
    0 > $b36288e2db101ba3$var$Tf || (a.current = $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf], $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf] = null, $b36288e2db101ba3$var$Tf--);
}
function $b36288e2db101ba3$var$G(a, b) {
    $b36288e2db101ba3$var$Tf++;
    $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf] = a.current;
    a.current = b;
}
var $b36288e2db101ba3$var$Vf = {}, $b36288e2db101ba3$var$H = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$Vf), $b36288e2db101ba3$var$Wf = $b36288e2db101ba3$var$Uf(!1), $b36288e2db101ba3$var$Xf = $b36288e2db101ba3$var$Vf;
function $b36288e2db101ba3$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $b36288e2db101ba3$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $b36288e2db101ba3$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $b36288e2db101ba3$var$$f() {
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
}
function $b36288e2db101ba3$var$ag(a, b, c) {
    if ($b36288e2db101ba3$var$H.current !== $b36288e2db101ba3$var$Vf) throw Error($b36288e2db101ba3$var$p(168));
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, b);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, c);
}
function $b36288e2db101ba3$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($b36288e2db101ba3$var$p(108, $b36288e2db101ba3$var$Ra(a) || "Unknown", e));
    return $b36288e2db101ba3$var$A({}, c, d);
}
function $b36288e2db101ba3$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $b36288e2db101ba3$var$Vf;
    $b36288e2db101ba3$var$Xf = $b36288e2db101ba3$var$H.current;
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, a);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, $b36288e2db101ba3$var$Wf.current);
    return !0;
}
function $b36288e2db101ba3$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($b36288e2db101ba3$var$p(169));
    c ? (a = $b36288e2db101ba3$var$bg(a, b, $b36288e2db101ba3$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H), $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, a)) : $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, c);
}
var $b36288e2db101ba3$var$eg = null, $b36288e2db101ba3$var$fg = !1, $b36288e2db101ba3$var$gg = !1;
function $b36288e2db101ba3$var$hg(a) {
    null === $b36288e2db101ba3$var$eg ? $b36288e2db101ba3$var$eg = [
        a
    ] : $b36288e2db101ba3$var$eg.push(a);
}
function $b36288e2db101ba3$var$ig(a) {
    $b36288e2db101ba3$var$fg = !0;
    $b36288e2db101ba3$var$hg(a);
}
function $b36288e2db101ba3$var$jg() {
    if (!$b36288e2db101ba3$var$gg && null !== $b36288e2db101ba3$var$eg) {
        $b36288e2db101ba3$var$gg = !0;
        var a = 0, b = $b36288e2db101ba3$var$C;
        try {
            var c = $b36288e2db101ba3$var$eg;
            for($b36288e2db101ba3$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $b36288e2db101ba3$var$eg = null;
            $b36288e2db101ba3$var$fg = !1;
        } catch (e) {
            throw null !== $b36288e2db101ba3$var$eg && ($b36288e2db101ba3$var$eg = $b36288e2db101ba3$var$eg.slice(a + 1)), $b36288e2db101ba3$var$ac($b36288e2db101ba3$var$fc, $b36288e2db101ba3$var$jg), e;
        } finally{
            $b36288e2db101ba3$var$C = b, $b36288e2db101ba3$var$gg = !1;
        }
    }
    return null;
}
var $b36288e2db101ba3$var$kg = [], $b36288e2db101ba3$var$lg = 0, $b36288e2db101ba3$var$mg = null, $b36288e2db101ba3$var$ng = 0, $b36288e2db101ba3$var$og = [], $b36288e2db101ba3$var$pg = 0, $b36288e2db101ba3$var$qg = null, $b36288e2db101ba3$var$rg = 1, $b36288e2db101ba3$var$sg = "";
function $b36288e2db101ba3$var$tg(a, b) {
    $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg++] = $b36288e2db101ba3$var$ng;
    $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg++] = $b36288e2db101ba3$var$mg;
    $b36288e2db101ba3$var$mg = a;
    $b36288e2db101ba3$var$ng = b;
}
function $b36288e2db101ba3$var$ug(a, b, c) {
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$rg;
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$sg;
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$qg;
    $b36288e2db101ba3$var$qg = a;
    var d = $b36288e2db101ba3$var$rg;
    a = $b36288e2db101ba3$var$sg;
    var e = 32 - $b36288e2db101ba3$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $b36288e2db101ba3$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $b36288e2db101ba3$var$rg = 1 << 32 - $b36288e2db101ba3$var$oc(b) + e | c << e | d;
        $b36288e2db101ba3$var$sg = f + a;
    } else $b36288e2db101ba3$var$rg = 1 << f | c << e | d, $b36288e2db101ba3$var$sg = a;
}
function $b36288e2db101ba3$var$vg(a) {
    null !== a.return && ($b36288e2db101ba3$var$tg(a, 1), $b36288e2db101ba3$var$ug(a, 1, 0));
}
function $b36288e2db101ba3$var$wg(a) {
    for(; a === $b36288e2db101ba3$var$mg;)$b36288e2db101ba3$var$mg = $b36288e2db101ba3$var$kg[--$b36288e2db101ba3$var$lg], $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg] = null, $b36288e2db101ba3$var$ng = $b36288e2db101ba3$var$kg[--$b36288e2db101ba3$var$lg], $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg] = null;
    for(; a === $b36288e2db101ba3$var$qg;)$b36288e2db101ba3$var$qg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null, $b36288e2db101ba3$var$sg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null, $b36288e2db101ba3$var$rg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null;
}
var $b36288e2db101ba3$var$xg = null, $b36288e2db101ba3$var$yg = null, $b36288e2db101ba3$var$I = !1, $b36288e2db101ba3$var$zg = null;
function $b36288e2db101ba3$var$Ag(a, b) {
    var c = $b36288e2db101ba3$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $b36288e2db101ba3$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $b36288e2db101ba3$var$qg ? {
                id: $b36288e2db101ba3$var$rg,
                overflow: $b36288e2db101ba3$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $b36288e2db101ba3$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $b36288e2db101ba3$var$Eg(a) {
    if ($b36288e2db101ba3$var$I) {
        var b = $b36288e2db101ba3$var$yg;
        if (b) {
            var c = b;
            if (!$b36288e2db101ba3$var$Cg(a, b)) {
                if ($b36288e2db101ba3$var$Dg(a)) throw Error($b36288e2db101ba3$var$p(418));
                b = $b36288e2db101ba3$var$Lf(c.nextSibling);
                var d = $b36288e2db101ba3$var$xg;
                b && $b36288e2db101ba3$var$Cg(a, b) ? $b36288e2db101ba3$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $b36288e2db101ba3$var$I = !1, $b36288e2db101ba3$var$xg = a);
            }
        } else {
            if ($b36288e2db101ba3$var$Dg(a)) throw Error($b36288e2db101ba3$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $b36288e2db101ba3$var$I = !1;
            $b36288e2db101ba3$var$xg = a;
        }
    }
}
function $b36288e2db101ba3$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $b36288e2db101ba3$var$xg = a;
}
function $b36288e2db101ba3$var$Gg(a) {
    if (a !== $b36288e2db101ba3$var$xg) return !1;
    if (!$b36288e2db101ba3$var$I) return $b36288e2db101ba3$var$Fg(a), $b36288e2db101ba3$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$b36288e2db101ba3$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $b36288e2db101ba3$var$yg)) {
        if ($b36288e2db101ba3$var$Dg(a)) throw $b36288e2db101ba3$var$Hg(), Error($b36288e2db101ba3$var$p(418));
        for(; b;)$b36288e2db101ba3$var$Ag(a, b), b = $b36288e2db101ba3$var$Lf(b.nextSibling);
    }
    $b36288e2db101ba3$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($b36288e2db101ba3$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $b36288e2db101ba3$var$yg = null;
        }
    } else $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$xg ? $b36288e2db101ba3$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $b36288e2db101ba3$var$Hg() {
    for(var a = $b36288e2db101ba3$var$yg; a;)a = $b36288e2db101ba3$var$Lf(a.nextSibling);
}
function $b36288e2db101ba3$var$Ig() {
    $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$xg = null;
    $b36288e2db101ba3$var$I = !1;
}
function $b36288e2db101ba3$var$Jg(a) {
    null === $b36288e2db101ba3$var$zg ? $b36288e2db101ba3$var$zg = [
        a
    ] : $b36288e2db101ba3$var$zg.push(a);
}
var $b36288e2db101ba3$var$Kg = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig;
function $b36288e2db101ba3$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $b36288e2db101ba3$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $b36288e2db101ba3$var$Mg = $b36288e2db101ba3$var$Uf(null), $b36288e2db101ba3$var$Ng = null, $b36288e2db101ba3$var$Og = null, $b36288e2db101ba3$var$Pg = null;
function $b36288e2db101ba3$var$Qg() {
    $b36288e2db101ba3$var$Pg = $b36288e2db101ba3$var$Og = $b36288e2db101ba3$var$Ng = null;
}
function $b36288e2db101ba3$var$Rg(a) {
    var b = $b36288e2db101ba3$var$Mg.current;
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Mg);
    a._currentValue = b;
}
function $b36288e2db101ba3$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $b36288e2db101ba3$var$Tg(a, b) {
    $b36288e2db101ba3$var$Ng = a;
    $b36288e2db101ba3$var$Pg = $b36288e2db101ba3$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($b36288e2db101ba3$var$Ug = !0), a.firstContext = null);
}
function $b36288e2db101ba3$var$Vg(a) {
    var b = a._currentValue;
    if ($b36288e2db101ba3$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $b36288e2db101ba3$var$Og) {
            if (null === $b36288e2db101ba3$var$Ng) throw Error($b36288e2db101ba3$var$p(308));
            $b36288e2db101ba3$var$Og = a;
            $b36288e2db101ba3$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $b36288e2db101ba3$var$Og = $b36288e2db101ba3$var$Og.next = a;
    }
    return b;
}
var $b36288e2db101ba3$var$Wg = null;
function $b36288e2db101ba3$var$Xg(a) {
    null === $b36288e2db101ba3$var$Wg ? $b36288e2db101ba3$var$Wg = [
        a
    ] : $b36288e2db101ba3$var$Wg.push(a);
}
function $b36288e2db101ba3$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $b36288e2db101ba3$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $b36288e2db101ba3$var$Zg(a, d);
}
function $b36288e2db101ba3$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $b36288e2db101ba3$var$$g = !1;
function $b36288e2db101ba3$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $b36288e2db101ba3$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $b36288e2db101ba3$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $b36288e2db101ba3$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($b36288e2db101ba3$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $b36288e2db101ba3$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $b36288e2db101ba3$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $b36288e2db101ba3$var$Zg(a, c);
}
function $b36288e2db101ba3$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b36288e2db101ba3$var$Cc(a, c);
    }
}
function $b36288e2db101ba3$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $b36288e2db101ba3$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $b36288e2db101ba3$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $b36288e2db101ba3$var$A({}, q, r);
                            break a;
                        case 2:
                            $b36288e2db101ba3$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $b36288e2db101ba3$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $b36288e2db101ba3$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($b36288e2db101ba3$var$p(191, e));
            e.call(d);
        }
    }
}
var $b36288e2db101ba3$var$jh = (new $bh6RR.Component).refs;
function $b36288e2db101ba3$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $b36288e2db101ba3$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $b36288e2db101ba3$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $b36288e2db101ba3$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $b36288e2db101ba3$var$L(), e = $b36288e2db101ba3$var$lh(a), f = $b36288e2db101ba3$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b36288e2db101ba3$var$dh(a, f, e);
        null !== b && ($b36288e2db101ba3$var$mh(b, a, e, d), $b36288e2db101ba3$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $b36288e2db101ba3$var$L(), e = $b36288e2db101ba3$var$lh(a), f = $b36288e2db101ba3$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b36288e2db101ba3$var$dh(a, f, e);
        null !== b && ($b36288e2db101ba3$var$mh(b, a, e, d), $b36288e2db101ba3$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $b36288e2db101ba3$var$L(), d = $b36288e2db101ba3$var$lh(a), e = $b36288e2db101ba3$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $b36288e2db101ba3$var$dh(a, e, d);
        null !== b && ($b36288e2db101ba3$var$mh(b, a, d, c), $b36288e2db101ba3$var$eh(b, a, d));
    }
};
function $b36288e2db101ba3$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$b36288e2db101ba3$var$Ie(c, d) || !$b36288e2db101ba3$var$Ie(e, f) : !0;
}
function $b36288e2db101ba3$var$ph(a, b, c) {
    var d = !1, e = $b36288e2db101ba3$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $b36288e2db101ba3$var$Vg(f) : (e = $b36288e2db101ba3$var$Zf(b) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $b36288e2db101ba3$var$Yf(a, e) : $b36288e2db101ba3$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $b36288e2db101ba3$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $b36288e2db101ba3$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $b36288e2db101ba3$var$nh.enqueueReplaceState(b, b.state, null);
}
function $b36288e2db101ba3$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $b36288e2db101ba3$var$jh;
    $b36288e2db101ba3$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $b36288e2db101ba3$var$Vg(f) : (f = $b36288e2db101ba3$var$Zf(b) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, e.context = $b36288e2db101ba3$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($b36288e2db101ba3$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $b36288e2db101ba3$var$nh.enqueueReplaceState(e, e.state, null), $b36288e2db101ba3$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $b36288e2db101ba3$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($b36288e2db101ba3$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($b36288e2db101ba3$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $b36288e2db101ba3$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($b36288e2db101ba3$var$p(284));
        if (!c._owner) throw Error($b36288e2db101ba3$var$p(290, a));
    }
    return a;
}
function $b36288e2db101ba3$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($b36288e2db101ba3$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $b36288e2db101ba3$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $b36288e2db101ba3$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $b36288e2db101ba3$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $b36288e2db101ba3$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $b36288e2db101ba3$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $b36288e2db101ba3$var$Ha && $b36288e2db101ba3$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $b36288e2db101ba3$var$sh(a, b, c), d.return = a, d;
        d = $b36288e2db101ba3$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $b36288e2db101ba3$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $b36288e2db101ba3$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $b36288e2db101ba3$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $b36288e2db101ba3$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return c = $b36288e2db101ba3$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $b36288e2db101ba3$var$sh(a, null, b), c.return = a, c;
                case $b36288e2db101ba3$var$wa:
                    return b = $b36288e2db101ba3$var$zh(b, a.mode, c), b.return = a, b;
                case $b36288e2db101ba3$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($b36288e2db101ba3$var$eb(b) || $b36288e2db101ba3$var$Ka(b)) return b = $b36288e2db101ba3$var$Ah(b, a.mode, c, null), b.return = a, b;
            $b36288e2db101ba3$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $b36288e2db101ba3$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $b36288e2db101ba3$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($b36288e2db101ba3$var$eb(c) || $b36288e2db101ba3$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $b36288e2db101ba3$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $b36288e2db101ba3$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $b36288e2db101ba3$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($b36288e2db101ba3$var$eb(d) || $b36288e2db101ba3$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $b36288e2db101ba3$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $b36288e2db101ba3$var$Ka(h);
        if ("function" !== typeof l) throw Error($b36288e2db101ba3$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($b36288e2db101ba3$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $b36288e2db101ba3$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $b36288e2db101ba3$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $b36288e2db101ba3$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $b36288e2db101ba3$var$Ha && $b36288e2db101ba3$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $b36288e2db101ba3$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $b36288e2db101ba3$var$ya ? (d = $b36288e2db101ba3$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $b36288e2db101ba3$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $b36288e2db101ba3$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $b36288e2db101ba3$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $b36288e2db101ba3$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $b36288e2db101ba3$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($b36288e2db101ba3$var$eb(f)) return n(a, d, f, h);
            if ($b36288e2db101ba3$var$Ka(f)) return t(a, d, f, h);
            $b36288e2db101ba3$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $b36288e2db101ba3$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $b36288e2db101ba3$var$Bh = $b36288e2db101ba3$var$vh(!0), $b36288e2db101ba3$var$Ch = $b36288e2db101ba3$var$vh(!1), $b36288e2db101ba3$var$Dh = {}, $b36288e2db101ba3$var$Eh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$Dh), $b36288e2db101ba3$var$Fh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$Dh), $b36288e2db101ba3$var$Gh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$Dh);
function $b36288e2db101ba3$var$Hh(a) {
    if (a === $b36288e2db101ba3$var$Dh) throw Error($b36288e2db101ba3$var$p(174));
    return a;
}
function $b36288e2db101ba3$var$Ih(a, b) {
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Gh, b);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Fh, a);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Eh, $b36288e2db101ba3$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $b36288e2db101ba3$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $b36288e2db101ba3$var$lb(b, a);
    }
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Eh);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Eh, b);
}
function $b36288e2db101ba3$var$Jh() {
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Eh);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Fh);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Gh);
}
function $b36288e2db101ba3$var$Kh(a) {
    $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Gh.current);
    var b = $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Eh.current);
    var c = $b36288e2db101ba3$var$lb(b, a.type);
    b !== c && ($b36288e2db101ba3$var$G($b36288e2db101ba3$var$Fh, a), $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Eh, c));
}
function $b36288e2db101ba3$var$Lh(a) {
    $b36288e2db101ba3$var$Fh.current === a && ($b36288e2db101ba3$var$E($b36288e2db101ba3$var$Eh), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Fh));
}
var $b36288e2db101ba3$var$M = $b36288e2db101ba3$var$Uf(0);
function $b36288e2db101ba3$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $b36288e2db101ba3$var$Nh = [];
function $b36288e2db101ba3$var$Oh() {
    for(var a = 0; a < $b36288e2db101ba3$var$Nh.length; a++)$b36288e2db101ba3$var$Nh[a]._workInProgressVersionPrimary = null;
    $b36288e2db101ba3$var$Nh.length = 0;
}
var $b36288e2db101ba3$var$Ph = $b36288e2db101ba3$var$ua.ReactCurrentDispatcher, $b36288e2db101ba3$var$Qh = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$Rh = 0, $b36288e2db101ba3$var$N = null, $b36288e2db101ba3$var$O = null, $b36288e2db101ba3$var$P = null, $b36288e2db101ba3$var$Sh = !1, $b36288e2db101ba3$var$Th = !1, $b36288e2db101ba3$var$Uh = 0, $b36288e2db101ba3$var$Vh = 0;
function $b36288e2db101ba3$var$Q() {
    throw Error($b36288e2db101ba3$var$p(321));
}
function $b36288e2db101ba3$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$b36288e2db101ba3$var$He(a[c], b[c])) return !1;
    return !0;
}
function $b36288e2db101ba3$var$Xh(a, b, c, d, e, f) {
    $b36288e2db101ba3$var$Rh = f;
    $b36288e2db101ba3$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $b36288e2db101ba3$var$Ph.current = null === a || null === a.memoizedState ? $b36288e2db101ba3$var$Yh : $b36288e2db101ba3$var$Zh;
    a = c(d, e);
    if ($b36288e2db101ba3$var$Th) {
        f = 0;
        do {
            $b36288e2db101ba3$var$Th = !1;
            $b36288e2db101ba3$var$Uh = 0;
            if (25 <= f) throw Error($b36288e2db101ba3$var$p(301));
            f += 1;
            $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$O = null;
            b.updateQueue = null;
            $b36288e2db101ba3$var$Ph.current = $b36288e2db101ba3$var$$h;
            a = c(d, e);
        }while ($b36288e2db101ba3$var$Th);
    }
    $b36288e2db101ba3$var$Ph.current = $b36288e2db101ba3$var$ai;
    b = null !== $b36288e2db101ba3$var$O && null !== $b36288e2db101ba3$var$O.next;
    $b36288e2db101ba3$var$Rh = 0;
    $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$N = null;
    $b36288e2db101ba3$var$Sh = !1;
    if (b) throw Error($b36288e2db101ba3$var$p(300));
    return a;
}
function $b36288e2db101ba3$var$bi() {
    var a = 0 !== $b36288e2db101ba3$var$Uh;
    $b36288e2db101ba3$var$Uh = 0;
    return a;
}
function $b36288e2db101ba3$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $b36288e2db101ba3$var$P ? $b36288e2db101ba3$var$N.memoizedState = $b36288e2db101ba3$var$P = a : $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$P.next = a;
    return $b36288e2db101ba3$var$P;
}
function $b36288e2db101ba3$var$di() {
    if (null === $b36288e2db101ba3$var$O) {
        var a = $b36288e2db101ba3$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $b36288e2db101ba3$var$O.next;
    var b = null === $b36288e2db101ba3$var$P ? $b36288e2db101ba3$var$N.memoizedState : $b36288e2db101ba3$var$P.next;
    if (null !== b) $b36288e2db101ba3$var$P = b, $b36288e2db101ba3$var$O = a;
    else {
        if (null === a) throw Error($b36288e2db101ba3$var$p(310));
        $b36288e2db101ba3$var$O = a;
        a = {
            memoizedState: $b36288e2db101ba3$var$O.memoizedState,
            baseState: $b36288e2db101ba3$var$O.baseState,
            baseQueue: $b36288e2db101ba3$var$O.baseQueue,
            queue: $b36288e2db101ba3$var$O.queue,
            next: null
        };
        null === $b36288e2db101ba3$var$P ? $b36288e2db101ba3$var$N.memoizedState = $b36288e2db101ba3$var$P = a : $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$P.next = a;
    }
    return $b36288e2db101ba3$var$P;
}
function $b36288e2db101ba3$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $b36288e2db101ba3$var$fi(a) {
    var b = $b36288e2db101ba3$var$di(), c = b.queue;
    if (null === c) throw Error($b36288e2db101ba3$var$p(311));
    c.lastRenderedReducer = a;
    var d = $b36288e2db101ba3$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($b36288e2db101ba3$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $b36288e2db101ba3$var$N.lanes |= m;
                $b36288e2db101ba3$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $b36288e2db101ba3$var$He(d, b.memoizedState) || ($b36288e2db101ba3$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $b36288e2db101ba3$var$N.lanes |= f, $b36288e2db101ba3$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $b36288e2db101ba3$var$gi(a) {
    var b = $b36288e2db101ba3$var$di(), c = b.queue;
    if (null === c) throw Error($b36288e2db101ba3$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $b36288e2db101ba3$var$He(f, b.memoizedState) || ($b36288e2db101ba3$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $b36288e2db101ba3$var$hi() {}
function $b36288e2db101ba3$var$ii(a, b) {
    var c = $b36288e2db101ba3$var$N, d = $b36288e2db101ba3$var$di(), e = b(), f = !$b36288e2db101ba3$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $b36288e2db101ba3$var$Ug = !0);
    d = d.queue;
    $b36288e2db101ba3$var$ji($b36288e2db101ba3$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $b36288e2db101ba3$var$P && $b36288e2db101ba3$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $b36288e2db101ba3$var$li(9, $b36288e2db101ba3$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $b36288e2db101ba3$var$R) throw Error($b36288e2db101ba3$var$p(349));
        0 !== ($b36288e2db101ba3$var$Rh & 30) || $b36288e2db101ba3$var$ni(c, b, e);
    }
    return e;
}
function $b36288e2db101ba3$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $b36288e2db101ba3$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b36288e2db101ba3$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $b36288e2db101ba3$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $b36288e2db101ba3$var$oi(b) && $b36288e2db101ba3$var$pi(a);
}
function $b36288e2db101ba3$var$ki(a, b, c) {
    return c(function() {
        $b36288e2db101ba3$var$oi(b) && $b36288e2db101ba3$var$pi(a);
    });
}
function $b36288e2db101ba3$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$b36288e2db101ba3$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $b36288e2db101ba3$var$pi(a) {
    var b = $b36288e2db101ba3$var$Zg(a, 1);
    null !== b && $b36288e2db101ba3$var$mh(b, a, 1, -1);
}
function $b36288e2db101ba3$var$qi(a) {
    var b = $b36288e2db101ba3$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $b36288e2db101ba3$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $b36288e2db101ba3$var$ri.bind(null, $b36288e2db101ba3$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $b36288e2db101ba3$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $b36288e2db101ba3$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b36288e2db101ba3$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $b36288e2db101ba3$var$si() {
    return $b36288e2db101ba3$var$di().memoizedState;
}
function $b36288e2db101ba3$var$ti(a, b, c, d) {
    var e = $b36288e2db101ba3$var$ci();
    $b36288e2db101ba3$var$N.flags |= a;
    e.memoizedState = $b36288e2db101ba3$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $b36288e2db101ba3$var$ui(a, b, c, d) {
    var e = $b36288e2db101ba3$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $b36288e2db101ba3$var$O) {
        var g = $b36288e2db101ba3$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $b36288e2db101ba3$var$Wh(d, g.deps)) {
            e.memoizedState = $b36288e2db101ba3$var$li(b, c, f, d);
            return;
        }
    }
    $b36288e2db101ba3$var$N.flags |= a;
    e.memoizedState = $b36288e2db101ba3$var$li(1 | b, c, f, d);
}
function $b36288e2db101ba3$var$vi(a, b) {
    return $b36288e2db101ba3$var$ti(8390656, 8, a, b);
}
function $b36288e2db101ba3$var$ji(a, b) {
    return $b36288e2db101ba3$var$ui(2048, 8, a, b);
}
function $b36288e2db101ba3$var$wi(a, b) {
    return $b36288e2db101ba3$var$ui(4, 2, a, b);
}
function $b36288e2db101ba3$var$xi(a, b) {
    return $b36288e2db101ba3$var$ui(4, 4, a, b);
}
function $b36288e2db101ba3$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $b36288e2db101ba3$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $b36288e2db101ba3$var$ui(4, 4, $b36288e2db101ba3$var$yi.bind(null, b, a), c);
}
function $b36288e2db101ba3$var$Ai() {}
function $b36288e2db101ba3$var$Bi(a, b) {
    var c = $b36288e2db101ba3$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b36288e2db101ba3$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b36288e2db101ba3$var$Ci(a, b) {
    var c = $b36288e2db101ba3$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b36288e2db101ba3$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b36288e2db101ba3$var$Di(a, b, c) {
    if (0 === ($b36288e2db101ba3$var$Rh & 21)) return a.baseState && (a.baseState = !1, $b36288e2db101ba3$var$Ug = !0), a.memoizedState = c;
    $b36288e2db101ba3$var$He(c, b) || (c = $b36288e2db101ba3$var$yc(), $b36288e2db101ba3$var$N.lanes |= c, $b36288e2db101ba3$var$hh |= c, a.baseState = !0);
    return b;
}
function $b36288e2db101ba3$var$Ei(a, b) {
    var c = $b36288e2db101ba3$var$C;
    $b36288e2db101ba3$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $b36288e2db101ba3$var$Qh.transition;
    $b36288e2db101ba3$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $b36288e2db101ba3$var$C = c, $b36288e2db101ba3$var$Qh.transition = d;
    }
}
function $b36288e2db101ba3$var$Fi() {
    return $b36288e2db101ba3$var$di().memoizedState;
}
function $b36288e2db101ba3$var$Gi(a, b, c) {
    var d = $b36288e2db101ba3$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b36288e2db101ba3$var$Hi(a)) $b36288e2db101ba3$var$Ii(b, c);
    else if (c = $b36288e2db101ba3$var$Yg(a, b, c, d), null !== c) {
        var e = $b36288e2db101ba3$var$L();
        $b36288e2db101ba3$var$mh(c, a, d, e);
        $b36288e2db101ba3$var$Ji(c, b, d);
    }
}
function $b36288e2db101ba3$var$ri(a, b, c) {
    var d = $b36288e2db101ba3$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b36288e2db101ba3$var$Hi(a)) $b36288e2db101ba3$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($b36288e2db101ba3$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $b36288e2db101ba3$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $b36288e2db101ba3$var$Yg(a, b, e, d);
        null !== c && (e = $b36288e2db101ba3$var$L(), $b36288e2db101ba3$var$mh(c, a, d, e), $b36288e2db101ba3$var$Ji(c, b, d));
    }
}
function $b36288e2db101ba3$var$Hi(a) {
    var b = a.alternate;
    return a === $b36288e2db101ba3$var$N || null !== b && b === $b36288e2db101ba3$var$N;
}
function $b36288e2db101ba3$var$Ii(a, b) {
    $b36288e2db101ba3$var$Th = $b36288e2db101ba3$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $b36288e2db101ba3$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b36288e2db101ba3$var$Cc(a, c);
    }
}
var $b36288e2db101ba3$var$ai = {
    readContext: $b36288e2db101ba3$var$Vg,
    useCallback: $b36288e2db101ba3$var$Q,
    useContext: $b36288e2db101ba3$var$Q,
    useEffect: $b36288e2db101ba3$var$Q,
    useImperativeHandle: $b36288e2db101ba3$var$Q,
    useInsertionEffect: $b36288e2db101ba3$var$Q,
    useLayoutEffect: $b36288e2db101ba3$var$Q,
    useMemo: $b36288e2db101ba3$var$Q,
    useReducer: $b36288e2db101ba3$var$Q,
    useRef: $b36288e2db101ba3$var$Q,
    useState: $b36288e2db101ba3$var$Q,
    useDebugValue: $b36288e2db101ba3$var$Q,
    useDeferredValue: $b36288e2db101ba3$var$Q,
    useTransition: $b36288e2db101ba3$var$Q,
    useMutableSource: $b36288e2db101ba3$var$Q,
    useSyncExternalStore: $b36288e2db101ba3$var$Q,
    useId: $b36288e2db101ba3$var$Q,
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$Yh = {
    readContext: $b36288e2db101ba3$var$Vg,
    useCallback: function(a, b) {
        $b36288e2db101ba3$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $b36288e2db101ba3$var$Vg,
    useEffect: $b36288e2db101ba3$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $b36288e2db101ba3$var$ti(4194308, 4, $b36288e2db101ba3$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $b36288e2db101ba3$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $b36288e2db101ba3$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $b36288e2db101ba3$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $b36288e2db101ba3$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $b36288e2db101ba3$var$Gi.bind(null, $b36288e2db101ba3$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $b36288e2db101ba3$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $b36288e2db101ba3$var$qi,
    useDebugValue: $b36288e2db101ba3$var$Ai,
    useDeferredValue: function(a) {
        return $b36288e2db101ba3$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$qi(!1), b = a[0];
        a = $b36288e2db101ba3$var$Ei.bind(null, a[1]);
        $b36288e2db101ba3$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $b36288e2db101ba3$var$N, e = $b36288e2db101ba3$var$ci();
        if ($b36288e2db101ba3$var$I) {
            if (void 0 === c) throw Error($b36288e2db101ba3$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $b36288e2db101ba3$var$R) throw Error($b36288e2db101ba3$var$p(349));
            0 !== ($b36288e2db101ba3$var$Rh & 30) || $b36288e2db101ba3$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $b36288e2db101ba3$var$vi($b36288e2db101ba3$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $b36288e2db101ba3$var$li(9, $b36288e2db101ba3$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $b36288e2db101ba3$var$ci(), b = $b36288e2db101ba3$var$R.identifierPrefix;
        if ($b36288e2db101ba3$var$I) {
            var c = $b36288e2db101ba3$var$sg;
            var d = $b36288e2db101ba3$var$rg;
            c = (d & ~(1 << 32 - $b36288e2db101ba3$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $b36288e2db101ba3$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $b36288e2db101ba3$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$Zh = {
    readContext: $b36288e2db101ba3$var$Vg,
    useCallback: $b36288e2db101ba3$var$Bi,
    useContext: $b36288e2db101ba3$var$Vg,
    useEffect: $b36288e2db101ba3$var$ji,
    useImperativeHandle: $b36288e2db101ba3$var$zi,
    useInsertionEffect: $b36288e2db101ba3$var$wi,
    useLayoutEffect: $b36288e2db101ba3$var$xi,
    useMemo: $b36288e2db101ba3$var$Ci,
    useReducer: $b36288e2db101ba3$var$fi,
    useRef: $b36288e2db101ba3$var$si,
    useState: function() {
        return $b36288e2db101ba3$var$fi($b36288e2db101ba3$var$ei);
    },
    useDebugValue: $b36288e2db101ba3$var$Ai,
    useDeferredValue: function(a) {
        var b = $b36288e2db101ba3$var$di();
        return $b36288e2db101ba3$var$Di(b, $b36288e2db101ba3$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$fi($b36288e2db101ba3$var$ei)[0], b = $b36288e2db101ba3$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b36288e2db101ba3$var$hi,
    useSyncExternalStore: $b36288e2db101ba3$var$ii,
    useId: $b36288e2db101ba3$var$Fi,
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$$h = {
    readContext: $b36288e2db101ba3$var$Vg,
    useCallback: $b36288e2db101ba3$var$Bi,
    useContext: $b36288e2db101ba3$var$Vg,
    useEffect: $b36288e2db101ba3$var$ji,
    useImperativeHandle: $b36288e2db101ba3$var$zi,
    useInsertionEffect: $b36288e2db101ba3$var$wi,
    useLayoutEffect: $b36288e2db101ba3$var$xi,
    useMemo: $b36288e2db101ba3$var$Ci,
    useReducer: $b36288e2db101ba3$var$gi,
    useRef: $b36288e2db101ba3$var$si,
    useState: function() {
        return $b36288e2db101ba3$var$gi($b36288e2db101ba3$var$ei);
    },
    useDebugValue: $b36288e2db101ba3$var$Ai,
    useDeferredValue: function(a) {
        var b = $b36288e2db101ba3$var$di();
        return null === $b36288e2db101ba3$var$O ? b.memoizedState = a : $b36288e2db101ba3$var$Di(b, $b36288e2db101ba3$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$gi($b36288e2db101ba3$var$ei)[0], b = $b36288e2db101ba3$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b36288e2db101ba3$var$hi,
    useSyncExternalStore: $b36288e2db101ba3$var$ii,
    useId: $b36288e2db101ba3$var$Fi,
    unstable_isNewReconciler: !1
};
function $b36288e2db101ba3$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $b36288e2db101ba3$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $b36288e2db101ba3$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $b36288e2db101ba3$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $b36288e2db101ba3$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $b36288e2db101ba3$var$Oi(a, b, c) {
    c = $b36288e2db101ba3$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $b36288e2db101ba3$var$Pi || ($b36288e2db101ba3$var$Pi = !0, $b36288e2db101ba3$var$Qi = d);
        $b36288e2db101ba3$var$Mi(a, b);
    };
    return c;
}
function $b36288e2db101ba3$var$Ri(a, b, c) {
    c = $b36288e2db101ba3$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $b36288e2db101ba3$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $b36288e2db101ba3$var$Mi(a, b);
        "function" !== typeof d && (null === $b36288e2db101ba3$var$Si ? $b36288e2db101ba3$var$Si = new Set([
            this
        ]) : $b36288e2db101ba3$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $b36288e2db101ba3$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $b36288e2db101ba3$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $b36288e2db101ba3$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $b36288e2db101ba3$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $b36288e2db101ba3$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $b36288e2db101ba3$var$ch(-1, 1), b.tag = 2, $b36288e2db101ba3$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $b36288e2db101ba3$var$Xi = $b36288e2db101ba3$var$ua.ReactCurrentOwner, $b36288e2db101ba3$var$Ug = !1;
function $b36288e2db101ba3$var$Yi(a, b, c, d) {
    b.child = null === a ? $b36288e2db101ba3$var$Ch(b, null, c, d) : $b36288e2db101ba3$var$Bh(b, a.child, c, d);
}
function $b36288e2db101ba3$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $b36288e2db101ba3$var$Tg(b, e);
    d = $b36288e2db101ba3$var$Xh(a, b, c, d, f, e);
    c = $b36288e2db101ba3$var$bi();
    if (null !== a && !$b36288e2db101ba3$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b36288e2db101ba3$var$$i(a, b, e);
    $b36288e2db101ba3$var$I && c && $b36288e2db101ba3$var$vg(b);
    b.flags |= 1;
    $b36288e2db101ba3$var$Yi(a, b, d, e);
    return b.child;
}
function $b36288e2db101ba3$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$b36288e2db101ba3$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $b36288e2db101ba3$var$cj(a, b, f, d, e);
        a = $b36288e2db101ba3$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $b36288e2db101ba3$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $b36288e2db101ba3$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $b36288e2db101ba3$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $b36288e2db101ba3$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($b36288e2db101ba3$var$Ie(f, d) && a.ref === b.ref) {
            if ($b36288e2db101ba3$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($b36288e2db101ba3$var$Ug = !0);
            else return b.lanes = a.lanes, $b36288e2db101ba3$var$$i(a, b, e);
        }
    }
    return $b36288e2db101ba3$var$dj(a, b, c, d, e);
}
function $b36288e2db101ba3$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$fj, $b36288e2db101ba3$var$gj), $b36288e2db101ba3$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$fj, $b36288e2db101ba3$var$gj), $b36288e2db101ba3$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$fj, $b36288e2db101ba3$var$gj);
            $b36288e2db101ba3$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$fj, $b36288e2db101ba3$var$gj), $b36288e2db101ba3$var$gj |= d;
    $b36288e2db101ba3$var$Yi(a, b, e, c);
    return b.child;
}
function $b36288e2db101ba3$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $b36288e2db101ba3$var$dj(a, b, c, d, e) {
    var f = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current;
    f = $b36288e2db101ba3$var$Yf(b, f);
    $b36288e2db101ba3$var$Tg(b, e);
    c = $b36288e2db101ba3$var$Xh(a, b, c, d, f, e);
    d = $b36288e2db101ba3$var$bi();
    if (null !== a && !$b36288e2db101ba3$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b36288e2db101ba3$var$$i(a, b, e);
    $b36288e2db101ba3$var$I && d && $b36288e2db101ba3$var$vg(b);
    b.flags |= 1;
    $b36288e2db101ba3$var$Yi(a, b, c, e);
    return b.child;
}
function $b36288e2db101ba3$var$ij(a, b, c, d, e) {
    if ($b36288e2db101ba3$var$Zf(c)) {
        var f = !0;
        $b36288e2db101ba3$var$cg(b);
    } else f = !1;
    $b36288e2db101ba3$var$Tg(b, e);
    if (null === b.stateNode) $b36288e2db101ba3$var$jj(a, b), $b36288e2db101ba3$var$ph(b, c, d), $b36288e2db101ba3$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $b36288e2db101ba3$var$Vg(l) : (l = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, l = $b36288e2db101ba3$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $b36288e2db101ba3$var$qh(b, g, d, l);
        $b36288e2db101ba3$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $b36288e2db101ba3$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $b36288e2db101ba3$var$Wf.current || $b36288e2db101ba3$var$$g ? ("function" === typeof m && ($b36288e2db101ba3$var$kh(b, c, m, d), k = b.memoizedState), (h = $b36288e2db101ba3$var$$g || $b36288e2db101ba3$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $b36288e2db101ba3$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $b36288e2db101ba3$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $b36288e2db101ba3$var$Vg(k) : (k = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, k = $b36288e2db101ba3$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $b36288e2db101ba3$var$qh(b, g, d, k);
        $b36288e2db101ba3$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $b36288e2db101ba3$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $b36288e2db101ba3$var$Wf.current || $b36288e2db101ba3$var$$g ? ("function" === typeof y && ($b36288e2db101ba3$var$kh(b, c, y, d), n = b.memoizedState), (l = $b36288e2db101ba3$var$$g || $b36288e2db101ba3$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $b36288e2db101ba3$var$kj(a, b, c, d, f, e);
}
function $b36288e2db101ba3$var$kj(a, b, c, d, e, f) {
    $b36288e2db101ba3$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $b36288e2db101ba3$var$dg(b, c, !1), $b36288e2db101ba3$var$$i(a, b, f);
    d = b.stateNode;
    $b36288e2db101ba3$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $b36288e2db101ba3$var$Bh(b, a.child, null, f), b.child = $b36288e2db101ba3$var$Bh(b, null, h, f)) : $b36288e2db101ba3$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $b36288e2db101ba3$var$dg(b, c, !0);
    return b.child;
}
function $b36288e2db101ba3$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $b36288e2db101ba3$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $b36288e2db101ba3$var$ag(a, b.context, !1);
    $b36288e2db101ba3$var$Ih(a, b.containerInfo);
}
function $b36288e2db101ba3$var$mj(a, b, c, d, e) {
    $b36288e2db101ba3$var$Ig();
    $b36288e2db101ba3$var$Jg(e);
    b.flags |= 256;
    $b36288e2db101ba3$var$Yi(a, b, c, d);
    return b.child;
}
var $b36288e2db101ba3$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $b36288e2db101ba3$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $b36288e2db101ba3$var$pj(a, b, c) {
    var d = b.pendingProps, e = $b36288e2db101ba3$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, e & 1);
    if (null === a) {
        $b36288e2db101ba3$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $b36288e2db101ba3$var$qj(g, d, 0, null), a = $b36288e2db101ba3$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $b36288e2db101ba3$var$oj(c), b.memoizedState = $b36288e2db101ba3$var$nj, a) : $b36288e2db101ba3$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $b36288e2db101ba3$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $b36288e2db101ba3$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $b36288e2db101ba3$var$wh(h, f) : (f = $b36288e2db101ba3$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $b36288e2db101ba3$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $b36288e2db101ba3$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $b36288e2db101ba3$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $b36288e2db101ba3$var$rj(a, b) {
    b = $b36288e2db101ba3$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $b36288e2db101ba3$var$tj(a, b, c, d) {
    null !== d && $b36288e2db101ba3$var$Jg(d);
    $b36288e2db101ba3$var$Bh(b, a.child, null, c);
    a = $b36288e2db101ba3$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $b36288e2db101ba3$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $b36288e2db101ba3$var$Li(Error($b36288e2db101ba3$var$p(422))), $b36288e2db101ba3$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $b36288e2db101ba3$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $b36288e2db101ba3$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $b36288e2db101ba3$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $b36288e2db101ba3$var$oj(g);
        b.memoizedState = $b36288e2db101ba3$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $b36288e2db101ba3$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($b36288e2db101ba3$var$p(419));
        d = $b36288e2db101ba3$var$Li(f, d, void 0);
        return $b36288e2db101ba3$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($b36288e2db101ba3$var$Ug || h) {
        d = $b36288e2db101ba3$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $b36288e2db101ba3$var$Zg(a, e), $b36288e2db101ba3$var$mh(d, a, e, -1));
        }
        $b36288e2db101ba3$var$uj();
        d = $b36288e2db101ba3$var$Li(Error($b36288e2db101ba3$var$p(421)));
        return $b36288e2db101ba3$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $b36288e2db101ba3$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(e.nextSibling);
    $b36288e2db101ba3$var$xg = b;
    $b36288e2db101ba3$var$I = !0;
    $b36288e2db101ba3$var$zg = null;
    null !== a && ($b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$rg, $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$sg, $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$qg, $b36288e2db101ba3$var$rg = a.id, $b36288e2db101ba3$var$sg = a.overflow, $b36288e2db101ba3$var$qg = b);
    b = $b36288e2db101ba3$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $b36288e2db101ba3$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $b36288e2db101ba3$var$Sg(a.return, b, c);
}
function $b36288e2db101ba3$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $b36288e2db101ba3$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $b36288e2db101ba3$var$Yi(a, b, d.children, c);
    d = $b36288e2db101ba3$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $b36288e2db101ba3$var$wj(a, c, b);
            else if (19 === a.tag) $b36288e2db101ba3$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $b36288e2db101ba3$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $b36288e2db101ba3$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $b36288e2db101ba3$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $b36288e2db101ba3$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $b36288e2db101ba3$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $b36288e2db101ba3$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $b36288e2db101ba3$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $b36288e2db101ba3$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($b36288e2db101ba3$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $b36288e2db101ba3$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $b36288e2db101ba3$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $b36288e2db101ba3$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $b36288e2db101ba3$var$lj(b);
            $b36288e2db101ba3$var$Ig();
            break;
        case 5:
            $b36288e2db101ba3$var$Kh(b);
            break;
        case 1:
            $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$cg(b);
            break;
        case 4:
            $b36288e2db101ba3$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $b36288e2db101ba3$var$pj(a, b, c);
                $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current & 1);
                a = $b36288e2db101ba3$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $b36288e2db101ba3$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $b36288e2db101ba3$var$ej(a, b, c);
    }
    return $b36288e2db101ba3$var$$i(a, b, c);
}
var $b36288e2db101ba3$var$Aj, $b36288e2db101ba3$var$Bj, $b36288e2db101ba3$var$Cj, $b36288e2db101ba3$var$Dj;
$b36288e2db101ba3$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$b36288e2db101ba3$var$Bj = function() {};
$b36288e2db101ba3$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $b36288e2db101ba3$var$Ya(a, e);
                d = $b36288e2db101ba3$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $b36288e2db101ba3$var$A({}, e, {
                    value: void 0
                });
                d = $b36288e2db101ba3$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $b36288e2db101ba3$var$gb(a, e);
                d = $b36288e2db101ba3$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $b36288e2db101ba3$var$Bf);
        }
        $b36288e2db101ba3$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($b36288e2db101ba3$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($b36288e2db101ba3$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $b36288e2db101ba3$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$b36288e2db101ba3$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $b36288e2db101ba3$var$Ej(a, b) {
    if (!$b36288e2db101ba3$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $b36288e2db101ba3$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $b36288e2db101ba3$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $b36288e2db101ba3$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $b36288e2db101ba3$var$S(b), null;
        case 1:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), $b36288e2db101ba3$var$S(b), null;
        case 3:
            d = b.stateNode;
            $b36288e2db101ba3$var$Jh();
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
            $b36288e2db101ba3$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $b36288e2db101ba3$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $b36288e2db101ba3$var$zg && ($b36288e2db101ba3$var$Gj($b36288e2db101ba3$var$zg), $b36288e2db101ba3$var$zg = null));
            $b36288e2db101ba3$var$Bj(a, b);
            $b36288e2db101ba3$var$S(b);
            return null;
        case 5:
            $b36288e2db101ba3$var$Lh(b);
            var e = $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $b36288e2db101ba3$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($b36288e2db101ba3$var$p(166));
                    $b36288e2db101ba3$var$S(b);
                    return null;
                }
                a = $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Eh.current);
                if ($b36288e2db101ba3$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$b36288e2db101ba3$var$Of] = b;
                    d[$b36288e2db101ba3$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $b36288e2db101ba3$var$D("cancel", d);
                            $b36288e2db101ba3$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $b36288e2db101ba3$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $b36288e2db101ba3$var$lf.length; e++)$b36288e2db101ba3$var$D($b36288e2db101ba3$var$lf[e], d);
                            break;
                        case "source":
                            $b36288e2db101ba3$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $b36288e2db101ba3$var$D("error", d);
                            $b36288e2db101ba3$var$D("load", d);
                            break;
                        case "details":
                            $b36288e2db101ba3$var$D("toggle", d);
                            break;
                        case "input":
                            $b36288e2db101ba3$var$Za(d, f);
                            $b36288e2db101ba3$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $b36288e2db101ba3$var$D("invalid", d);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$hb(d, f), $b36288e2db101ba3$var$D("invalid", d);
                    }
                    $b36288e2db101ba3$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $b36288e2db101ba3$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $b36288e2db101ba3$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $b36288e2db101ba3$var$Va(d);
                            $b36288e2db101ba3$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$Va(d);
                            $b36288e2db101ba3$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $b36288e2db101ba3$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $b36288e2db101ba3$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$b36288e2db101ba3$var$Of] = b;
                    a[$b36288e2db101ba3$var$Pf] = d;
                    $b36288e2db101ba3$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $b36288e2db101ba3$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $b36288e2db101ba3$var$D("cancel", a);
                                $b36288e2db101ba3$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $b36288e2db101ba3$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $b36288e2db101ba3$var$lf.length; e++)$b36288e2db101ba3$var$D($b36288e2db101ba3$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $b36288e2db101ba3$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $b36288e2db101ba3$var$D("error", a);
                                $b36288e2db101ba3$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $b36288e2db101ba3$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $b36288e2db101ba3$var$Za(a, d);
                                e = $b36288e2db101ba3$var$Ya(a, d);
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $b36288e2db101ba3$var$A({}, d, {
                                    value: void 0
                                });
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            case "textarea":
                                $b36288e2db101ba3$var$hb(a, d);
                                e = $b36288e2db101ba3$var$gb(a, d);
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $b36288e2db101ba3$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $b36288e2db101ba3$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $b36288e2db101ba3$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $b36288e2db101ba3$var$ob(a, k) : "number" === typeof k && $b36288e2db101ba3$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($b36288e2db101ba3$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $b36288e2db101ba3$var$D("scroll", a) : null != k && $b36288e2db101ba3$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $b36288e2db101ba3$var$Va(a);
                                $b36288e2db101ba3$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $b36288e2db101ba3$var$Va(a);
                                $b36288e2db101ba3$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $b36288e2db101ba3$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $b36288e2db101ba3$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $b36288e2db101ba3$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $b36288e2db101ba3$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $b36288e2db101ba3$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $b36288e2db101ba3$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($b36288e2db101ba3$var$p(166));
                c = $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Gh.current);
                $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Eh.current);
                if ($b36288e2db101ba3$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$b36288e2db101ba3$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $b36288e2db101ba3$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $b36288e2db101ba3$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$b36288e2db101ba3$var$Of] = b, b.stateNode = d;
            }
            $b36288e2db101ba3$var$S(b);
            return null;
        case 13:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($b36288e2db101ba3$var$I && null !== $b36288e2db101ba3$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $b36288e2db101ba3$var$Hg(), $b36288e2db101ba3$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $b36288e2db101ba3$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($b36288e2db101ba3$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($b36288e2db101ba3$var$p(317));
                        f[$b36288e2db101ba3$var$Of] = b;
                    } else $b36288e2db101ba3$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $b36288e2db101ba3$var$S(b);
                    f = !1;
                } else null !== $b36288e2db101ba3$var$zg && ($b36288e2db101ba3$var$Gj($b36288e2db101ba3$var$zg), $b36288e2db101ba3$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($b36288e2db101ba3$var$M.current & 1) ? 0 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 3) : $b36288e2db101ba3$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $b36288e2db101ba3$var$S(b);
            return null;
        case 4:
            return $b36288e2db101ba3$var$Jh(), $b36288e2db101ba3$var$Bj(a, b), null === a && $b36288e2db101ba3$var$sf(b.stateNode.containerInfo), $b36288e2db101ba3$var$S(b), null;
        case 10:
            return $b36288e2db101ba3$var$Rg(b.type._context), $b36288e2db101ba3$var$S(b), null;
        case 17:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), $b36288e2db101ba3$var$S(b), null;
        case 19:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
            f = b.memoizedState;
            if (null === f) return $b36288e2db101ba3$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $b36288e2db101ba3$var$Ej(f, !1);
                else {
                    if (0 !== $b36288e2db101ba3$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $b36288e2db101ba3$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $b36288e2db101ba3$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $b36288e2db101ba3$var$B() > $b36288e2db101ba3$var$Hj && (b.flags |= 128, d = !0, $b36288e2db101ba3$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $b36288e2db101ba3$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $b36288e2db101ba3$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$b36288e2db101ba3$var$I) return $b36288e2db101ba3$var$S(b), null;
                    } else 2 * $b36288e2db101ba3$var$B() - f.renderingStartTime > $b36288e2db101ba3$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $b36288e2db101ba3$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $b36288e2db101ba3$var$B(), b.sibling = null, c = $b36288e2db101ba3$var$M.current, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, d ? c & 1 | 2 : c & 1), b;
            $b36288e2db101ba3$var$S(b);
            return null;
        case 22:
        case 23:
            return $b36288e2db101ba3$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($b36288e2db101ba3$var$gj & 1073741824) && ($b36288e2db101ba3$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $b36288e2db101ba3$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($b36288e2db101ba3$var$p(156, b.tag));
}
function $b36288e2db101ba3$var$Jj(a, b) {
    $b36288e2db101ba3$var$wg(b);
    switch(b.tag){
        case 1:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $b36288e2db101ba3$var$Jh(), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H), $b36288e2db101ba3$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $b36288e2db101ba3$var$Lh(b), null;
        case 13:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($b36288e2db101ba3$var$p(340));
                $b36288e2db101ba3$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M), null;
        case 4:
            return $b36288e2db101ba3$var$Jh(), null;
        case 10:
            return $b36288e2db101ba3$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $b36288e2db101ba3$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $b36288e2db101ba3$var$Kj = !1, $b36288e2db101ba3$var$U = !1, $b36288e2db101ba3$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $b36288e2db101ba3$var$V = null;
function $b36288e2db101ba3$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $b36288e2db101ba3$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $b36288e2db101ba3$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $b36288e2db101ba3$var$W(a, b, d);
    }
}
var $b36288e2db101ba3$var$Oj = !1;
function $b36288e2db101ba3$var$Pj(a, b) {
    $b36288e2db101ba3$var$Cf = $b36288e2db101ba3$var$dd;
    a = $b36288e2db101ba3$var$Me();
    if ($b36288e2db101ba3$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $b36288e2db101ba3$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $b36288e2db101ba3$var$dd = !1;
    for($b36288e2db101ba3$var$V = b; null !== $b36288e2db101ba3$var$V;)if (b = $b36288e2db101ba3$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $b36288e2db101ba3$var$V = a;
    else for(; null !== $b36288e2db101ba3$var$V;){
        b = $b36288e2db101ba3$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $b36288e2db101ba3$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(163));
            }
        } catch (F) {
            $b36288e2db101ba3$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $b36288e2db101ba3$var$V = a;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
    n = $b36288e2db101ba3$var$Oj;
    $b36288e2db101ba3$var$Oj = !1;
    return n;
}
function $b36288e2db101ba3$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $b36288e2db101ba3$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $b36288e2db101ba3$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $b36288e2db101ba3$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $b36288e2db101ba3$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $b36288e2db101ba3$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$b36288e2db101ba3$var$Of], delete b[$b36288e2db101ba3$var$Pf], delete b[$b36288e2db101ba3$var$of], delete b[$b36288e2db101ba3$var$Qf], delete b[$b36288e2db101ba3$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $b36288e2db101ba3$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $b36288e2db101ba3$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $b36288e2db101ba3$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $b36288e2db101ba3$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $b36288e2db101ba3$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($b36288e2db101ba3$var$Wj(a, b, c), a = a.sibling; null !== a;)$b36288e2db101ba3$var$Wj(a, b, c), a = a.sibling;
}
function $b36288e2db101ba3$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($b36288e2db101ba3$var$Xj(a, b, c), a = a.sibling; null !== a;)$b36288e2db101ba3$var$Xj(a, b, c), a = a.sibling;
}
var $b36288e2db101ba3$var$X = null, $b36288e2db101ba3$var$Yj = !1;
function $b36288e2db101ba3$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$b36288e2db101ba3$var$ak(a, b, c), c = c.sibling;
}
function $b36288e2db101ba3$var$ak(a, b, c) {
    if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onCommitFiberUnmount) try {
        $b36288e2db101ba3$var$lc.onCommitFiberUnmount($b36288e2db101ba3$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $b36288e2db101ba3$var$U || $b36288e2db101ba3$var$Mj(c, b);
        case 6:
            var d = $b36288e2db101ba3$var$X, e = $b36288e2db101ba3$var$Yj;
            $b36288e2db101ba3$var$X = null;
            $b36288e2db101ba3$var$Zj(a, b, c);
            $b36288e2db101ba3$var$X = d;
            $b36288e2db101ba3$var$Yj = e;
            null !== $b36288e2db101ba3$var$X && ($b36288e2db101ba3$var$Yj ? (a = $b36288e2db101ba3$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $b36288e2db101ba3$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $b36288e2db101ba3$var$X && ($b36288e2db101ba3$var$Yj ? (a = $b36288e2db101ba3$var$X, c = c.stateNode, 8 === a.nodeType ? $b36288e2db101ba3$var$Kf(a.parentNode, c) : 1 === a.nodeType && $b36288e2db101ba3$var$Kf(a, c), $b36288e2db101ba3$var$bd(a)) : $b36288e2db101ba3$var$Kf($b36288e2db101ba3$var$X, c.stateNode));
            break;
        case 4:
            d = $b36288e2db101ba3$var$X;
            e = $b36288e2db101ba3$var$Yj;
            $b36288e2db101ba3$var$X = c.stateNode.containerInfo;
            $b36288e2db101ba3$var$Yj = !0;
            $b36288e2db101ba3$var$Zj(a, b, c);
            $b36288e2db101ba3$var$X = d;
            $b36288e2db101ba3$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$b36288e2db101ba3$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $b36288e2db101ba3$var$Nj(c, b, g) : 0 !== (f & 4) && $b36288e2db101ba3$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $b36288e2db101ba3$var$Zj(a, b, c);
            break;
        case 1:
            if (!$b36288e2db101ba3$var$U && ($b36288e2db101ba3$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $b36288e2db101ba3$var$W(c, b, h);
            }
            $b36288e2db101ba3$var$Zj(a, b, c);
            break;
        case 21:
            $b36288e2db101ba3$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($b36288e2db101ba3$var$U = (d = $b36288e2db101ba3$var$U) || null !== c.memoizedState, $b36288e2db101ba3$var$Zj(a, b, c), $b36288e2db101ba3$var$U = d) : $b36288e2db101ba3$var$Zj(a, b, c);
            break;
        default:
            $b36288e2db101ba3$var$Zj(a, b, c);
    }
}
function $b36288e2db101ba3$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $b36288e2db101ba3$var$Lj);
        b.forEach(function(b) {
            var d = $b36288e2db101ba3$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $b36288e2db101ba3$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $b36288e2db101ba3$var$X = h.stateNode;
                        $b36288e2db101ba3$var$Yj = !1;
                        break a;
                    case 3:
                        $b36288e2db101ba3$var$X = h.stateNode.containerInfo;
                        $b36288e2db101ba3$var$Yj = !0;
                        break a;
                    case 4:
                        $b36288e2db101ba3$var$X = h.stateNode.containerInfo;
                        $b36288e2db101ba3$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $b36288e2db101ba3$var$X) throw Error($b36288e2db101ba3$var$p(160));
            $b36288e2db101ba3$var$ak(f, g, e);
            $b36288e2db101ba3$var$X = null;
            $b36288e2db101ba3$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $b36288e2db101ba3$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$b36288e2db101ba3$var$ek(b, a), b = b.sibling;
}
function $b36288e2db101ba3$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            if (d & 4) {
                try {
                    $b36288e2db101ba3$var$Qj(3, a, a.return), $b36288e2db101ba3$var$Rj(3, a);
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
                try {
                    $b36288e2db101ba3$var$Qj(5, a, a.return);
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            d & 512 && null !== c && $b36288e2db101ba3$var$Mj(c, c.return);
            break;
        case 5:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            d & 512 && null !== c && $b36288e2db101ba3$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $b36288e2db101ba3$var$ob(e, "");
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $b36288e2db101ba3$var$ab(e, f);
                    $b36288e2db101ba3$var$vb(h, g);
                    var l = $b36288e2db101ba3$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $b36288e2db101ba3$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $b36288e2db101ba3$var$nb(e, q) : "children" === m ? $b36288e2db101ba3$var$ob(e, q) : $b36288e2db101ba3$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $b36288e2db101ba3$var$bb(e, f);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $b36288e2db101ba3$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $b36288e2db101ba3$var$fb(e, !!f.multiple, f.defaultValue, !0) : $b36288e2db101ba3$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$b36288e2db101ba3$var$Pf] = f;
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($b36288e2db101ba3$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $b36288e2db101ba3$var$bd(b.containerInfo);
            } catch (t) {
                $b36288e2db101ba3$var$W(a, a.return, t);
            }
            break;
        case 4:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            break;
        case 13:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($b36288e2db101ba3$var$gk = $b36288e2db101ba3$var$B()));
            d & 4 && $b36288e2db101ba3$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($b36288e2db101ba3$var$U = (l = $b36288e2db101ba3$var$U) || m, $b36288e2db101ba3$var$dk(b, a), $b36288e2db101ba3$var$U = l) : $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($b36288e2db101ba3$var$V = a, m = a.child; null !== m;){
                    for(q = $b36288e2db101ba3$var$V = m; null !== $b36288e2db101ba3$var$V;){
                        r = $b36288e2db101ba3$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $b36288e2db101ba3$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $b36288e2db101ba3$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $b36288e2db101ba3$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $b36288e2db101ba3$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $b36288e2db101ba3$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $b36288e2db101ba3$var$V = y) : $b36288e2db101ba3$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $b36288e2db101ba3$var$rb("display", g));
                            } catch (t) {
                                $b36288e2db101ba3$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $b36288e2db101ba3$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            d & 4 && $b36288e2db101ba3$var$bk(a);
            break;
        case 21:
            break;
        default:
            $b36288e2db101ba3$var$dk(b, a), $b36288e2db101ba3$var$fk(a);
    }
}
function $b36288e2db101ba3$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($b36288e2db101ba3$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($b36288e2db101ba3$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($b36288e2db101ba3$var$ob(e, ""), d.flags &= -33);
                    var f = $b36288e2db101ba3$var$Vj(a);
                    $b36288e2db101ba3$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $b36288e2db101ba3$var$Vj(a);
                    $b36288e2db101ba3$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(161));
            }
        } catch (k) {
            $b36288e2db101ba3$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $b36288e2db101ba3$var$ik(a, b, c) {
    $b36288e2db101ba3$var$V = a;
    $b36288e2db101ba3$var$jk(a, b, c);
}
function $b36288e2db101ba3$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $b36288e2db101ba3$var$V;){
        var e = $b36288e2db101ba3$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $b36288e2db101ba3$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $b36288e2db101ba3$var$U;
                h = $b36288e2db101ba3$var$Kj;
                var l = $b36288e2db101ba3$var$U;
                $b36288e2db101ba3$var$Kj = g;
                if (($b36288e2db101ba3$var$U = k) && !l) for($b36288e2db101ba3$var$V = e; null !== $b36288e2db101ba3$var$V;)g = $b36288e2db101ba3$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $b36288e2db101ba3$var$kk(e) : null !== k ? (k.return = g, $b36288e2db101ba3$var$V = k) : $b36288e2db101ba3$var$kk(e);
                for(; null !== f;)$b36288e2db101ba3$var$V = f, $b36288e2db101ba3$var$jk(f, b, c), f = f.sibling;
                $b36288e2db101ba3$var$V = e;
                $b36288e2db101ba3$var$Kj = h;
                $b36288e2db101ba3$var$U = l;
            }
            $b36288e2db101ba3$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $b36288e2db101ba3$var$V = f) : $b36288e2db101ba3$var$lk(a, b, c);
    }
}
function $b36288e2db101ba3$var$lk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $b36288e2db101ba3$var$U || $b36288e2db101ba3$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$b36288e2db101ba3$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $b36288e2db101ba3$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $b36288e2db101ba3$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $b36288e2db101ba3$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $b36288e2db101ba3$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($b36288e2db101ba3$var$p(163));
                }
                $b36288e2db101ba3$var$U || b.flags & 512 && $b36288e2db101ba3$var$Sj(b);
            } catch (r) {
                $b36288e2db101ba3$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $b36288e2db101ba3$var$V = c;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
function $b36288e2db101ba3$var$hk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $b36288e2db101ba3$var$V = c;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
function $b36288e2db101ba3$var$kk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $b36288e2db101ba3$var$Rj(4, b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $b36288e2db101ba3$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $b36288e2db101ba3$var$Sj(b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $b36288e2db101ba3$var$Sj(b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $b36288e2db101ba3$var$W(b, b.return, k);
        }
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $b36288e2db101ba3$var$V = h;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
var $b36288e2db101ba3$var$mk = Math.ceil, $b36288e2db101ba3$var$nk = $b36288e2db101ba3$var$ua.ReactCurrentDispatcher, $b36288e2db101ba3$var$ok = $b36288e2db101ba3$var$ua.ReactCurrentOwner, $b36288e2db101ba3$var$pk = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$K = 0, $b36288e2db101ba3$var$R = null, $b36288e2db101ba3$var$Y = null, $b36288e2db101ba3$var$Z = 0, $b36288e2db101ba3$var$gj = 0, $b36288e2db101ba3$var$fj = $b36288e2db101ba3$var$Uf(0), $b36288e2db101ba3$var$T = 0, $b36288e2db101ba3$var$qk = null, $b36288e2db101ba3$var$hh = 0, $b36288e2db101ba3$var$rk = 0, $b36288e2db101ba3$var$sk = 0, $b36288e2db101ba3$var$tk = null, $b36288e2db101ba3$var$uk = null, $b36288e2db101ba3$var$gk = 0, $b36288e2db101ba3$var$Hj = Infinity, $b36288e2db101ba3$var$vk = null, $b36288e2db101ba3$var$Pi = !1, $b36288e2db101ba3$var$Qi = null, $b36288e2db101ba3$var$Si = null, $b36288e2db101ba3$var$wk = !1, $b36288e2db101ba3$var$xk = null, $b36288e2db101ba3$var$yk = 0, $b36288e2db101ba3$var$zk = 0, $b36288e2db101ba3$var$Ak = null, $b36288e2db101ba3$var$Bk = -1, $b36288e2db101ba3$var$Ck = 0;
function $b36288e2db101ba3$var$L() {
    return 0 !== ($b36288e2db101ba3$var$K & 6) ? $b36288e2db101ba3$var$B() : -1 !== $b36288e2db101ba3$var$Bk ? $b36288e2db101ba3$var$Bk : $b36288e2db101ba3$var$Bk = $b36288e2db101ba3$var$B();
}
function $b36288e2db101ba3$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($b36288e2db101ba3$var$K & 2) && 0 !== $b36288e2db101ba3$var$Z) return $b36288e2db101ba3$var$Z & -$b36288e2db101ba3$var$Z;
    if (null !== $b36288e2db101ba3$var$Kg.transition) return 0 === $b36288e2db101ba3$var$Ck && ($b36288e2db101ba3$var$Ck = $b36288e2db101ba3$var$yc()), $b36288e2db101ba3$var$Ck;
    a = $b36288e2db101ba3$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $b36288e2db101ba3$var$jd(a.type);
    return a;
}
function $b36288e2db101ba3$var$mh(a, b, c, d) {
    if (50 < $b36288e2db101ba3$var$zk) throw $b36288e2db101ba3$var$zk = 0, $b36288e2db101ba3$var$Ak = null, Error($b36288e2db101ba3$var$p(185));
    $b36288e2db101ba3$var$Ac(a, c, d);
    if (0 === ($b36288e2db101ba3$var$K & 2) || a !== $b36288e2db101ba3$var$R) a === $b36288e2db101ba3$var$R && (0 === ($b36288e2db101ba3$var$K & 2) && ($b36288e2db101ba3$var$rk |= c), 4 === $b36288e2db101ba3$var$T && $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$Z)), $b36288e2db101ba3$var$Ek(a, d), 1 === c && 0 === $b36288e2db101ba3$var$K && 0 === (b.mode & 1) && ($b36288e2db101ba3$var$Hj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$fg && $b36288e2db101ba3$var$jg());
}
function $b36288e2db101ba3$var$Ek(a, b) {
    var c = a.callbackNode;
    $b36288e2db101ba3$var$wc(a, b);
    var d = $b36288e2db101ba3$var$uc(a, a === $b36288e2db101ba3$var$R ? $b36288e2db101ba3$var$Z : 0);
    if (0 === d) null !== c && $b36288e2db101ba3$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $b36288e2db101ba3$var$bc(c);
        if (1 === b) 0 === a.tag ? $b36288e2db101ba3$var$ig($b36288e2db101ba3$var$Fk.bind(null, a)) : $b36288e2db101ba3$var$hg($b36288e2db101ba3$var$Fk.bind(null, a)), $b36288e2db101ba3$var$Jf(function() {
            0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$jg();
        }), c = null;
        else {
            switch($b36288e2db101ba3$var$Dc(d)){
                case 1:
                    c = $b36288e2db101ba3$var$fc;
                    break;
                case 4:
                    c = $b36288e2db101ba3$var$gc;
                    break;
                case 16:
                    c = $b36288e2db101ba3$var$hc;
                    break;
                case 536870912:
                    c = $b36288e2db101ba3$var$jc;
                    break;
                default:
                    c = $b36288e2db101ba3$var$hc;
            }
            c = $b36288e2db101ba3$var$Gk(c, $b36288e2db101ba3$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $b36288e2db101ba3$var$Hk(a, b) {
    $b36288e2db101ba3$var$Bk = -1;
    $b36288e2db101ba3$var$Ck = 0;
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    var c = a.callbackNode;
    if ($b36288e2db101ba3$var$Ik() && a.callbackNode !== c) return null;
    var d = $b36288e2db101ba3$var$uc(a, a === $b36288e2db101ba3$var$R ? $b36288e2db101ba3$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $b36288e2db101ba3$var$Jk(a, d);
    else {
        b = d;
        var e = $b36288e2db101ba3$var$K;
        $b36288e2db101ba3$var$K |= 2;
        var f = $b36288e2db101ba3$var$Kk();
        if ($b36288e2db101ba3$var$R !== a || $b36288e2db101ba3$var$Z !== b) $b36288e2db101ba3$var$vk = null, $b36288e2db101ba3$var$Hj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$Lk(a, b);
        for(;;)try {
            $b36288e2db101ba3$var$Mk();
            break;
        } catch (h) {
            $b36288e2db101ba3$var$Nk(a, h);
        }
        $b36288e2db101ba3$var$Qg();
        $b36288e2db101ba3$var$nk.current = f;
        $b36288e2db101ba3$var$K = e;
        null !== $b36288e2db101ba3$var$Y ? b = 0 : ($b36288e2db101ba3$var$R = null, $b36288e2db101ba3$var$Z = 0, b = $b36288e2db101ba3$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $b36288e2db101ba3$var$xc(a), 0 !== e && (d = e, b = $b36288e2db101ba3$var$Ok(a, e)));
        if (1 === b) throw c = $b36288e2db101ba3$var$qk, $b36288e2db101ba3$var$Lk(a, 0), $b36288e2db101ba3$var$Dk(a, d), $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B()), c;
        if (6 === b) $b36288e2db101ba3$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$b36288e2db101ba3$var$Pk(e) && (b = $b36288e2db101ba3$var$Jk(a, d), 2 === b && (f = $b36288e2db101ba3$var$xc(a), 0 !== f && (d = f, b = $b36288e2db101ba3$var$Ok(a, f))), 1 === b)) throw c = $b36288e2db101ba3$var$qk, $b36288e2db101ba3$var$Lk(a, 0), $b36288e2db101ba3$var$Dk(a, d), $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($b36288e2db101ba3$var$p(345));
                case 2:
                    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
                    break;
                case 3:
                    $b36288e2db101ba3$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $b36288e2db101ba3$var$gk + 500 - $b36288e2db101ba3$var$B(), 10 < b)) {
                        if (0 !== $b36288e2db101ba3$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $b36288e2db101ba3$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $b36288e2db101ba3$var$Ff($b36288e2db101ba3$var$Qk.bind(null, a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk), b);
                        break;
                    }
                    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
                    break;
                case 4:
                    $b36288e2db101ba3$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $b36288e2db101ba3$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $b36288e2db101ba3$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $b36288e2db101ba3$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $b36288e2db101ba3$var$Ff($b36288e2db101ba3$var$Qk.bind(null, a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk), d);
                        break;
                    }
                    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
                    break;
                case 5:
                    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(329));
            }
        }
    }
    $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B());
    return a.callbackNode === c ? $b36288e2db101ba3$var$Hk.bind(null, a) : null;
}
function $b36288e2db101ba3$var$Ok(a, b) {
    var c = $b36288e2db101ba3$var$tk;
    a.current.memoizedState.isDehydrated && ($b36288e2db101ba3$var$Lk(a, b).flags |= 256);
    a = $b36288e2db101ba3$var$Jk(a, b);
    2 !== a && (b = $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$uk = c, null !== b && $b36288e2db101ba3$var$Gj(b));
    return a;
}
function $b36288e2db101ba3$var$Gj(a) {
    null === $b36288e2db101ba3$var$uk ? $b36288e2db101ba3$var$uk = a : $b36288e2db101ba3$var$uk.push.apply($b36288e2db101ba3$var$uk, a);
}
function $b36288e2db101ba3$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$b36288e2db101ba3$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $b36288e2db101ba3$var$Dk(a, b) {
    b &= ~$b36288e2db101ba3$var$sk;
    b &= ~$b36288e2db101ba3$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $b36288e2db101ba3$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $b36288e2db101ba3$var$Fk(a) {
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    $b36288e2db101ba3$var$Ik();
    var b = $b36288e2db101ba3$var$uc(a, 0);
    if (0 === (b & 1)) return $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B()), null;
    var c = $b36288e2db101ba3$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $b36288e2db101ba3$var$xc(a);
        0 !== d && (b = d, c = $b36288e2db101ba3$var$Ok(a, d));
    }
    if (1 === c) throw c = $b36288e2db101ba3$var$qk, $b36288e2db101ba3$var$Lk(a, 0), $b36288e2db101ba3$var$Dk(a, b), $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B()), c;
    if (6 === c) throw Error($b36288e2db101ba3$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
    $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B());
    return null;
}
function $b36288e2db101ba3$var$Rk(a, b) {
    var c = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 1;
    try {
        return a(b);
    } finally{
        $b36288e2db101ba3$var$K = c, 0 === $b36288e2db101ba3$var$K && ($b36288e2db101ba3$var$Hj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$fg && $b36288e2db101ba3$var$jg());
    }
}
function $b36288e2db101ba3$var$Sk(a) {
    null !== $b36288e2db101ba3$var$xk && 0 === $b36288e2db101ba3$var$xk.tag && 0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$Ik();
    var b = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 1;
    var c = $b36288e2db101ba3$var$pk.transition, d = $b36288e2db101ba3$var$C;
    try {
        if ($b36288e2db101ba3$var$pk.transition = null, $b36288e2db101ba3$var$C = 1, a) return a();
    } finally{
        $b36288e2db101ba3$var$C = d, $b36288e2db101ba3$var$pk.transition = c, $b36288e2db101ba3$var$K = b, 0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$jg();
    }
}
function $b36288e2db101ba3$var$Ij() {
    $b36288e2db101ba3$var$gj = $b36288e2db101ba3$var$fj.current;
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$fj);
}
function $b36288e2db101ba3$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $b36288e2db101ba3$var$Gf(c));
    if (null !== $b36288e2db101ba3$var$Y) for(c = $b36288e2db101ba3$var$Y.return; null !== c;){
        var d = c;
        $b36288e2db101ba3$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $b36288e2db101ba3$var$$f();
                break;
            case 3:
                $b36288e2db101ba3$var$Jh();
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
                $b36288e2db101ba3$var$Oh();
                break;
            case 5:
                $b36288e2db101ba3$var$Lh(d);
                break;
            case 4:
                $b36288e2db101ba3$var$Jh();
                break;
            case 13:
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
                break;
            case 19:
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
                break;
            case 10:
                $b36288e2db101ba3$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $b36288e2db101ba3$var$Ij();
        }
        c = c.return;
    }
    $b36288e2db101ba3$var$R = a;
    $b36288e2db101ba3$var$Y = a = $b36288e2db101ba3$var$wh(a.current, null);
    $b36288e2db101ba3$var$Z = $b36288e2db101ba3$var$gj = b;
    $b36288e2db101ba3$var$T = 0;
    $b36288e2db101ba3$var$qk = null;
    $b36288e2db101ba3$var$sk = $b36288e2db101ba3$var$rk = $b36288e2db101ba3$var$hh = 0;
    $b36288e2db101ba3$var$uk = $b36288e2db101ba3$var$tk = null;
    if (null !== $b36288e2db101ba3$var$Wg) {
        for(b = 0; b < $b36288e2db101ba3$var$Wg.length; b++)if (c = $b36288e2db101ba3$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $b36288e2db101ba3$var$Wg = null;
    }
    return a;
}
function $b36288e2db101ba3$var$Nk(a, b) {
    do {
        var c = $b36288e2db101ba3$var$Y;
        try {
            $b36288e2db101ba3$var$Qg();
            $b36288e2db101ba3$var$Ph.current = $b36288e2db101ba3$var$ai;
            if ($b36288e2db101ba3$var$Sh) {
                for(var d = $b36288e2db101ba3$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $b36288e2db101ba3$var$Sh = !1;
            }
            $b36288e2db101ba3$var$Rh = 0;
            $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$N = null;
            $b36288e2db101ba3$var$Th = !1;
            $b36288e2db101ba3$var$Uh = 0;
            $b36288e2db101ba3$var$ok.current = null;
            if (null === c || null === c.return) {
                $b36288e2db101ba3$var$T = 1;
                $b36288e2db101ba3$var$qk = b;
                $b36288e2db101ba3$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $b36288e2db101ba3$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $b36288e2db101ba3$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $b36288e2db101ba3$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $b36288e2db101ba3$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $b36288e2db101ba3$var$Ti(f, l, b);
                            $b36288e2db101ba3$var$uj();
                            break a;
                        }
                        k = Error($b36288e2db101ba3$var$p(426));
                    }
                } else if ($b36288e2db101ba3$var$I && h.mode & 1) {
                    var J = $b36288e2db101ba3$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $b36288e2db101ba3$var$Wi(J, g, h, f, b);
                        $b36288e2db101ba3$var$Jg($b36288e2db101ba3$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $b36288e2db101ba3$var$Ki(k, h);
                4 !== $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 2);
                null === $b36288e2db101ba3$var$tk ? $b36288e2db101ba3$var$tk = [
                    f
                ] : $b36288e2db101ba3$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $b36288e2db101ba3$var$Oi(f, k, b);
                            $b36288e2db101ba3$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $b36288e2db101ba3$var$Si || !$b36288e2db101ba3$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $b36288e2db101ba3$var$Ri(f, h, b);
                                $b36288e2db101ba3$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $b36288e2db101ba3$var$Tk(c);
        } catch (na) {
            b = na;
            $b36288e2db101ba3$var$Y === c && null !== c && ($b36288e2db101ba3$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $b36288e2db101ba3$var$Kk() {
    var a = $b36288e2db101ba3$var$nk.current;
    $b36288e2db101ba3$var$nk.current = $b36288e2db101ba3$var$ai;
    return null === a ? $b36288e2db101ba3$var$ai : a;
}
function $b36288e2db101ba3$var$uj() {
    if (0 === $b36288e2db101ba3$var$T || 3 === $b36288e2db101ba3$var$T || 2 === $b36288e2db101ba3$var$T) $b36288e2db101ba3$var$T = 4;
    null === $b36288e2db101ba3$var$R || 0 === ($b36288e2db101ba3$var$hh & 268435455) && 0 === ($b36288e2db101ba3$var$rk & 268435455) || $b36288e2db101ba3$var$Dk($b36288e2db101ba3$var$R, $b36288e2db101ba3$var$Z);
}
function $b36288e2db101ba3$var$Jk(a, b) {
    var c = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 2;
    var d = $b36288e2db101ba3$var$Kk();
    if ($b36288e2db101ba3$var$R !== a || $b36288e2db101ba3$var$Z !== b) $b36288e2db101ba3$var$vk = null, $b36288e2db101ba3$var$Lk(a, b);
    for(;;)try {
        $b36288e2db101ba3$var$Uk();
        break;
    } catch (e) {
        $b36288e2db101ba3$var$Nk(a, e);
    }
    $b36288e2db101ba3$var$Qg();
    $b36288e2db101ba3$var$K = c;
    $b36288e2db101ba3$var$nk.current = d;
    if (null !== $b36288e2db101ba3$var$Y) throw Error($b36288e2db101ba3$var$p(261));
    $b36288e2db101ba3$var$R = null;
    $b36288e2db101ba3$var$Z = 0;
    return $b36288e2db101ba3$var$T;
}
function $b36288e2db101ba3$var$Uk() {
    for(; null !== $b36288e2db101ba3$var$Y;)$b36288e2db101ba3$var$Vk($b36288e2db101ba3$var$Y);
}
function $b36288e2db101ba3$var$Mk() {
    for(; null !== $b36288e2db101ba3$var$Y && !$b36288e2db101ba3$var$cc();)$b36288e2db101ba3$var$Vk($b36288e2db101ba3$var$Y);
}
function $b36288e2db101ba3$var$Vk(a) {
    var b = $b36288e2db101ba3$var$Wk(a.alternate, a, $b36288e2db101ba3$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $b36288e2db101ba3$var$Tk(a) : $b36288e2db101ba3$var$Y = b;
    $b36288e2db101ba3$var$ok.current = null;
}
function $b36288e2db101ba3$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $b36288e2db101ba3$var$Fj(c, b, $b36288e2db101ba3$var$gj), null !== c) {
                $b36288e2db101ba3$var$Y = c;
                return;
            }
        } else {
            c = $b36288e2db101ba3$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $b36288e2db101ba3$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $b36288e2db101ba3$var$T = 6;
                $b36288e2db101ba3$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $b36288e2db101ba3$var$Y = b;
            return;
        }
        $b36288e2db101ba3$var$Y = b = a;
    }while (null !== b);
    0 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 5);
}
function $b36288e2db101ba3$var$Qk(a, b, c) {
    var d = $b36288e2db101ba3$var$C, e = $b36288e2db101ba3$var$pk.transition;
    try {
        $b36288e2db101ba3$var$pk.transition = null, $b36288e2db101ba3$var$C = 1, $b36288e2db101ba3$var$Xk(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$pk.transition = e, $b36288e2db101ba3$var$C = d;
    }
    return null;
}
function $b36288e2db101ba3$var$Xk(a, b, c, d) {
    do $b36288e2db101ba3$var$Ik();
    while (null !== $b36288e2db101ba3$var$xk);
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($b36288e2db101ba3$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $b36288e2db101ba3$var$Bc(a, f);
    a === $b36288e2db101ba3$var$R && ($b36288e2db101ba3$var$Y = $b36288e2db101ba3$var$R = null, $b36288e2db101ba3$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $b36288e2db101ba3$var$wk || ($b36288e2db101ba3$var$wk = !0, $b36288e2db101ba3$var$Gk($b36288e2db101ba3$var$hc, function() {
        $b36288e2db101ba3$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $b36288e2db101ba3$var$pk.transition;
        $b36288e2db101ba3$var$pk.transition = null;
        var g = $b36288e2db101ba3$var$C;
        $b36288e2db101ba3$var$C = 1;
        var h = $b36288e2db101ba3$var$K;
        $b36288e2db101ba3$var$K |= 4;
        $b36288e2db101ba3$var$ok.current = null;
        $b36288e2db101ba3$var$Pj(a, c);
        $b36288e2db101ba3$var$ek(c, a);
        $b36288e2db101ba3$var$Oe($b36288e2db101ba3$var$Df);
        $b36288e2db101ba3$var$dd = !!$b36288e2db101ba3$var$Cf;
        $b36288e2db101ba3$var$Df = $b36288e2db101ba3$var$Cf = null;
        a.current = c;
        $b36288e2db101ba3$var$ik(c, a, e);
        $b36288e2db101ba3$var$dc();
        $b36288e2db101ba3$var$K = h;
        $b36288e2db101ba3$var$C = g;
        $b36288e2db101ba3$var$pk.transition = f;
    } else a.current = c;
    $b36288e2db101ba3$var$wk && ($b36288e2db101ba3$var$wk = !1, $b36288e2db101ba3$var$xk = a, $b36288e2db101ba3$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($b36288e2db101ba3$var$Si = null);
    $b36288e2db101ba3$var$mc(c.stateNode, d);
    $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($b36288e2db101ba3$var$Pi) throw $b36288e2db101ba3$var$Pi = !1, a = $b36288e2db101ba3$var$Qi, $b36288e2db101ba3$var$Qi = null, a;
    0 !== ($b36288e2db101ba3$var$yk & 1) && 0 !== a.tag && $b36288e2db101ba3$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $b36288e2db101ba3$var$Ak ? $b36288e2db101ba3$var$zk++ : ($b36288e2db101ba3$var$zk = 0, $b36288e2db101ba3$var$Ak = a) : $b36288e2db101ba3$var$zk = 0;
    $b36288e2db101ba3$var$jg();
    return null;
}
function $b36288e2db101ba3$var$Ik() {
    if (null !== $b36288e2db101ba3$var$xk) {
        var a = $b36288e2db101ba3$var$Dc($b36288e2db101ba3$var$yk), b = $b36288e2db101ba3$var$pk.transition, c = $b36288e2db101ba3$var$C;
        try {
            $b36288e2db101ba3$var$pk.transition = null;
            $b36288e2db101ba3$var$C = 16 > a ? 16 : a;
            if (null === $b36288e2db101ba3$var$xk) var d = !1;
            else {
                a = $b36288e2db101ba3$var$xk;
                $b36288e2db101ba3$var$xk = null;
                $b36288e2db101ba3$var$yk = 0;
                if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(331));
                var e = $b36288e2db101ba3$var$K;
                $b36288e2db101ba3$var$K |= 4;
                for($b36288e2db101ba3$var$V = a.current; null !== $b36288e2db101ba3$var$V;){
                    var f = $b36288e2db101ba3$var$V, g = f.child;
                    if (0 !== ($b36288e2db101ba3$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($b36288e2db101ba3$var$V = l; null !== $b36288e2db101ba3$var$V;){
                                    var m = $b36288e2db101ba3$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $b36288e2db101ba3$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $b36288e2db101ba3$var$V = q;
                                    else for(; null !== $b36288e2db101ba3$var$V;){
                                        m = $b36288e2db101ba3$var$V;
                                        var r = m.sibling, y = m.return;
                                        $b36288e2db101ba3$var$Tj(m);
                                        if (m === l) {
                                            $b36288e2db101ba3$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $b36288e2db101ba3$var$V = r;
                                            break;
                                        }
                                        $b36288e2db101ba3$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $b36288e2db101ba3$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $b36288e2db101ba3$var$V = g;
                    else b: for(; null !== $b36288e2db101ba3$var$V;){
                        f = $b36288e2db101ba3$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $b36288e2db101ba3$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $b36288e2db101ba3$var$V = x;
                            break b;
                        }
                        $b36288e2db101ba3$var$V = f.return;
                    }
                }
                var w = a.current;
                for($b36288e2db101ba3$var$V = w; null !== $b36288e2db101ba3$var$V;){
                    g = $b36288e2db101ba3$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $b36288e2db101ba3$var$V = u;
                    else b: for(g = w; null !== $b36288e2db101ba3$var$V;){
                        h = $b36288e2db101ba3$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $b36288e2db101ba3$var$Rj(9, h);
                            }
                        } catch (na) {
                            $b36288e2db101ba3$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $b36288e2db101ba3$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $b36288e2db101ba3$var$V = F;
                            break b;
                        }
                        $b36288e2db101ba3$var$V = h.return;
                    }
                }
                $b36288e2db101ba3$var$K = e;
                $b36288e2db101ba3$var$jg();
                if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onPostCommitFiberRoot) try {
                    $b36288e2db101ba3$var$lc.onPostCommitFiberRoot($b36288e2db101ba3$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $b36288e2db101ba3$var$C = c, $b36288e2db101ba3$var$pk.transition = b;
        }
    }
    return !1;
}
function $b36288e2db101ba3$var$Yk(a, b, c) {
    b = $b36288e2db101ba3$var$Ki(c, b);
    b = $b36288e2db101ba3$var$Oi(a, b, 1);
    a = $b36288e2db101ba3$var$dh(a, b, 1);
    b = $b36288e2db101ba3$var$L();
    null !== a && ($b36288e2db101ba3$var$Ac(a, 1, b), $b36288e2db101ba3$var$Ek(a, b));
}
function $b36288e2db101ba3$var$W(a, b, c) {
    if (3 === a.tag) $b36288e2db101ba3$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $b36288e2db101ba3$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $b36288e2db101ba3$var$Si || !$b36288e2db101ba3$var$Si.has(d))) {
                a = $b36288e2db101ba3$var$Ki(c, a);
                a = $b36288e2db101ba3$var$Ri(b, a, 1);
                b = $b36288e2db101ba3$var$dh(b, a, 1);
                a = $b36288e2db101ba3$var$L();
                null !== b && ($b36288e2db101ba3$var$Ac(b, 1, a), $b36288e2db101ba3$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $b36288e2db101ba3$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $b36288e2db101ba3$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $b36288e2db101ba3$var$R === a && ($b36288e2db101ba3$var$Z & c) === c && (4 === $b36288e2db101ba3$var$T || 3 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$Z & 130023424) === $b36288e2db101ba3$var$Z && 500 > $b36288e2db101ba3$var$B() - $b36288e2db101ba3$var$gk ? $b36288e2db101ba3$var$Lk(a, 0) : $b36288e2db101ba3$var$sk |= c);
    $b36288e2db101ba3$var$Ek(a, b);
}
function $b36288e2db101ba3$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $b36288e2db101ba3$var$sc, $b36288e2db101ba3$var$sc <<= 1, 0 === ($b36288e2db101ba3$var$sc & 130023424) && ($b36288e2db101ba3$var$sc = 4194304)));
    var c = $b36288e2db101ba3$var$L();
    a = $b36288e2db101ba3$var$Zg(a, b);
    null !== a && ($b36288e2db101ba3$var$Ac(a, b, c), $b36288e2db101ba3$var$Ek(a, c));
}
function $b36288e2db101ba3$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $b36288e2db101ba3$var$Zk(a, c);
}
function $b36288e2db101ba3$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($b36288e2db101ba3$var$p(314));
    }
    null !== d && d.delete(b);
    $b36288e2db101ba3$var$Zk(a, c);
}
var $b36288e2db101ba3$var$Wk;
$b36288e2db101ba3$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $b36288e2db101ba3$var$Wf.current) $b36288e2db101ba3$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $b36288e2db101ba3$var$Ug = !1, $b36288e2db101ba3$var$zj(a, b, c);
            $b36288e2db101ba3$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $b36288e2db101ba3$var$Ug = !1, $b36288e2db101ba3$var$I && 0 !== (b.flags & 1048576) && $b36288e2db101ba3$var$ug(b, $b36288e2db101ba3$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $b36288e2db101ba3$var$jj(a, b);
            a = b.pendingProps;
            var e = $b36288e2db101ba3$var$Yf(b, $b36288e2db101ba3$var$H.current);
            $b36288e2db101ba3$var$Tg(b, c);
            e = $b36288e2db101ba3$var$Xh(null, b, d, a, e, c);
            var f = $b36288e2db101ba3$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $b36288e2db101ba3$var$Zf(d) ? (f = !0, $b36288e2db101ba3$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $b36288e2db101ba3$var$ah(b), e.updater = $b36288e2db101ba3$var$nh, b.stateNode = e, e._reactInternals = b, $b36288e2db101ba3$var$rh(b, d, a, c), b = $b36288e2db101ba3$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $b36288e2db101ba3$var$I && f && $b36288e2db101ba3$var$vg(b), $b36288e2db101ba3$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $b36288e2db101ba3$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $b36288e2db101ba3$var$$k(d);
                a = $b36288e2db101ba3$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $b36288e2db101ba3$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $b36288e2db101ba3$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $b36288e2db101ba3$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $b36288e2db101ba3$var$aj(null, b, d, $b36288e2db101ba3$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($b36288e2db101ba3$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Lg(d, e), $b36288e2db101ba3$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Lg(d, e), $b36288e2db101ba3$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $b36288e2db101ba3$var$lj(b);
                if (null === a) throw Error($b36288e2db101ba3$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $b36288e2db101ba3$var$bh(a, b);
                $b36288e2db101ba3$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $b36288e2db101ba3$var$Ki(Error($b36288e2db101ba3$var$p(423)), b);
                        b = $b36288e2db101ba3$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $b36288e2db101ba3$var$Ki(Error($b36288e2db101ba3$var$p(424)), b);
                        b = $b36288e2db101ba3$var$mj(a, b, d, c, e);
                        break a;
                    } else for($b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(b.stateNode.containerInfo.firstChild), $b36288e2db101ba3$var$xg = b, $b36288e2db101ba3$var$I = !0, $b36288e2db101ba3$var$zg = null, c = $b36288e2db101ba3$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $b36288e2db101ba3$var$Ig();
                    if (d === e) {
                        b = $b36288e2db101ba3$var$$i(a, b, c);
                        break a;
                    }
                    $b36288e2db101ba3$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $b36288e2db101ba3$var$Kh(b), null === a && $b36288e2db101ba3$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $b36288e2db101ba3$var$Ef(d, e) ? g = null : null !== f && $b36288e2db101ba3$var$Ef(d, f) && (b.flags |= 32), $b36288e2db101ba3$var$hj(a, b), $b36288e2db101ba3$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $b36288e2db101ba3$var$Eg(b), null;
        case 13:
            return $b36288e2db101ba3$var$pj(a, b, c);
        case 4:
            return $b36288e2db101ba3$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $b36288e2db101ba3$var$Bh(b, null, d, c) : $b36288e2db101ba3$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Lg(d, e), $b36288e2db101ba3$var$Zi(a, b, d, e, c);
        case 7:
            return $b36288e2db101ba3$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $b36288e2db101ba3$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $b36288e2db101ba3$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($b36288e2db101ba3$var$He(f.value, g)) {
                        if (f.children === e.children && !$b36288e2db101ba3$var$Wf.current) {
                            b = $b36288e2db101ba3$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $b36288e2db101ba3$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $b36288e2db101ba3$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($b36288e2db101ba3$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $b36288e2db101ba3$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $b36288e2db101ba3$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $b36288e2db101ba3$var$Tg(b, c), e = $b36288e2db101ba3$var$Vg(e), d = d(e), b.flags |= 1, $b36288e2db101ba3$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $b36288e2db101ba3$var$Lg(d, b.pendingProps), e = $b36288e2db101ba3$var$Lg(d.type, e), $b36288e2db101ba3$var$aj(a, b, d, e, c);
        case 15:
            return $b36288e2db101ba3$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Lg(d, e), $b36288e2db101ba3$var$jj(a, b), b.tag = 1, $b36288e2db101ba3$var$Zf(d) ? (a = !0, $b36288e2db101ba3$var$cg(b)) : a = !1, $b36288e2db101ba3$var$Tg(b, c), $b36288e2db101ba3$var$ph(b, d, e), $b36288e2db101ba3$var$rh(b, d, e, c), $b36288e2db101ba3$var$kj(null, b, d, !0, a, c);
        case 19:
            return $b36288e2db101ba3$var$yj(a, b, c);
        case 22:
            return $b36288e2db101ba3$var$ej(a, b, c);
    }
    throw Error($b36288e2db101ba3$var$p(156, b.tag));
};
function $b36288e2db101ba3$var$Gk(a, b) {
    return $b36288e2db101ba3$var$ac(a, b);
}
function $b36288e2db101ba3$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $b36288e2db101ba3$var$Bg(a, b, c, d) {
    return new $b36288e2db101ba3$var$al(a, b, c, d);
}
function $b36288e2db101ba3$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $b36288e2db101ba3$var$$k(a) {
    if ("function" === typeof a) return $b36288e2db101ba3$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $b36288e2db101ba3$var$Da) return 11;
        if (a === $b36288e2db101ba3$var$Ga) return 14;
    }
    return 2;
}
function $b36288e2db101ba3$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $b36288e2db101ba3$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $b36288e2db101ba3$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $b36288e2db101ba3$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $b36288e2db101ba3$var$ya:
            return $b36288e2db101ba3$var$Ah(c.children, e, f, b);
        case $b36288e2db101ba3$var$za:
            g = 8;
            e |= 8;
            break;
        case $b36288e2db101ba3$var$Aa:
            return a = $b36288e2db101ba3$var$Bg(12, c, b, e | 2), a.elementType = $b36288e2db101ba3$var$Aa, a.lanes = f, a;
        case $b36288e2db101ba3$var$Ea:
            return a = $b36288e2db101ba3$var$Bg(13, c, b, e), a.elementType = $b36288e2db101ba3$var$Ea, a.lanes = f, a;
        case $b36288e2db101ba3$var$Fa:
            return a = $b36288e2db101ba3$var$Bg(19, c, b, e), a.elementType = $b36288e2db101ba3$var$Fa, a.lanes = f, a;
        case $b36288e2db101ba3$var$Ia:
            return $b36288e2db101ba3$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $b36288e2db101ba3$var$Ba:
                    g = 10;
                    break a;
                case $b36288e2db101ba3$var$Ca:
                    g = 9;
                    break a;
                case $b36288e2db101ba3$var$Da:
                    g = 11;
                    break a;
                case $b36288e2db101ba3$var$Ga:
                    g = 14;
                    break a;
                case $b36288e2db101ba3$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($b36288e2db101ba3$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $b36288e2db101ba3$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $b36288e2db101ba3$var$Ah(a, b, c, d) {
    a = $b36288e2db101ba3$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $b36288e2db101ba3$var$qj(a, b, c, d) {
    a = $b36288e2db101ba3$var$Bg(22, a, d, b);
    a.elementType = $b36288e2db101ba3$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $b36288e2db101ba3$var$xh(a, b, c) {
    a = $b36288e2db101ba3$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $b36288e2db101ba3$var$zh(a, b, c) {
    b = $b36288e2db101ba3$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $b36288e2db101ba3$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $b36288e2db101ba3$var$zc(0);
    this.expirationTimes = $b36288e2db101ba3$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $b36288e2db101ba3$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $b36288e2db101ba3$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $b36288e2db101ba3$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $b36288e2db101ba3$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $b36288e2db101ba3$var$ah(f);
    return a;
}
function $b36288e2db101ba3$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $b36288e2db101ba3$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $b36288e2db101ba3$var$el(a) {
    if (!a) return $b36288e2db101ba3$var$Vf;
    a = a._reactInternals;
    a: {
        if ($b36288e2db101ba3$var$Vb(a) !== a || 1 !== a.tag) throw Error($b36288e2db101ba3$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($b36288e2db101ba3$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($b36288e2db101ba3$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($b36288e2db101ba3$var$Zf(c)) return $b36288e2db101ba3$var$bg(a, c, b);
    }
    return b;
}
function $b36288e2db101ba3$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $b36288e2db101ba3$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $b36288e2db101ba3$var$el(null);
    c = a.current;
    d = $b36288e2db101ba3$var$L();
    e = $b36288e2db101ba3$var$lh(c);
    f = $b36288e2db101ba3$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $b36288e2db101ba3$var$dh(c, f, e);
    a.current.lanes = e;
    $b36288e2db101ba3$var$Ac(a, e, d);
    $b36288e2db101ba3$var$Ek(a, d);
    return a;
}
function $b36288e2db101ba3$var$gl(a, b, c, d) {
    var e = b.current, f = $b36288e2db101ba3$var$L(), g = $b36288e2db101ba3$var$lh(e);
    c = $b36288e2db101ba3$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $b36288e2db101ba3$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $b36288e2db101ba3$var$dh(e, b, g);
    null !== a && ($b36288e2db101ba3$var$mh(a, e, g, f), $b36288e2db101ba3$var$eh(a, e, g));
    return g;
}
function $b36288e2db101ba3$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $b36288e2db101ba3$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $b36288e2db101ba3$var$jl(a, b) {
    $b36288e2db101ba3$var$il(a, b);
    (a = a.alternate) && $b36288e2db101ba3$var$il(a, b);
}
function $b36288e2db101ba3$var$kl() {
    return null;
}
var $b36288e2db101ba3$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $b36288e2db101ba3$var$ml(a) {
    this._internalRoot = a;
}
$b36288e2db101ba3$var$nl.prototype.render = $b36288e2db101ba3$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($b36288e2db101ba3$var$p(409));
    $b36288e2db101ba3$var$gl(a, b, null, null);
};
$b36288e2db101ba3$var$nl.prototype.unmount = $b36288e2db101ba3$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $b36288e2db101ba3$var$Sk(function() {
            $b36288e2db101ba3$var$gl(null, a, null, null);
        });
        b[$b36288e2db101ba3$var$uf] = null;
    }
};
function $b36288e2db101ba3$var$nl(a) {
    this._internalRoot = a;
}
$b36288e2db101ba3$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $b36288e2db101ba3$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $b36288e2db101ba3$var$Qc.length && 0 !== b && b < $b36288e2db101ba3$var$Qc[c].priority; c++);
        $b36288e2db101ba3$var$Qc.splice(c, 0, a);
        0 === c && $b36288e2db101ba3$var$Vc(a);
    }
};
function $b36288e2db101ba3$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $b36288e2db101ba3$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $b36288e2db101ba3$var$ql() {}
function $b36288e2db101ba3$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $b36288e2db101ba3$var$hl(g);
                f.call(a);
            };
        }
        var g = $b36288e2db101ba3$var$fl(b, d, a, 0, null, !1, !1, "", $b36288e2db101ba3$var$ql);
        a._reactRootContainer = g;
        a[$b36288e2db101ba3$var$uf] = g.current;
        $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
        $b36288e2db101ba3$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $b36288e2db101ba3$var$hl(k);
            h.call(a);
        };
    }
    var k = $b36288e2db101ba3$var$cl(a, 0, !1, null, null, !1, !1, "", $b36288e2db101ba3$var$ql);
    a._reactRootContainer = k;
    a[$b36288e2db101ba3$var$uf] = k.current;
    $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
    $b36288e2db101ba3$var$Sk(function() {
        $b36288e2db101ba3$var$gl(b, k, c, d);
    });
    return k;
}
function $b36288e2db101ba3$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $b36288e2db101ba3$var$hl(g);
                h.call(a);
            };
        }
        $b36288e2db101ba3$var$gl(b, g, a, e);
    } else g = $b36288e2db101ba3$var$rl(c, b, a, e, d);
    return $b36288e2db101ba3$var$hl(g);
}
$b36288e2db101ba3$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $b36288e2db101ba3$var$tc(b.pendingLanes);
                0 !== c && ($b36288e2db101ba3$var$Cc(b, c | 1), $b36288e2db101ba3$var$Ek(b, $b36288e2db101ba3$var$B()), 0 === ($b36288e2db101ba3$var$K & 6) && ($b36288e2db101ba3$var$Hj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$jg()));
            }
            break;
        case 13:
            $b36288e2db101ba3$var$Sk(function() {
                var b = $b36288e2db101ba3$var$Zg(a, 1);
                if (null !== b) {
                    var c = $b36288e2db101ba3$var$L();
                    $b36288e2db101ba3$var$mh(b, a, 1, c);
                }
            }), $b36288e2db101ba3$var$jl(a, 1);
    }
};
$b36288e2db101ba3$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $b36288e2db101ba3$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $b36288e2db101ba3$var$L();
            $b36288e2db101ba3$var$mh(b, a, 134217728, c);
        }
        $b36288e2db101ba3$var$jl(a, 134217728);
    }
};
$b36288e2db101ba3$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $b36288e2db101ba3$var$lh(a), c = $b36288e2db101ba3$var$Zg(a, b);
        if (null !== c) {
            var d = $b36288e2db101ba3$var$L();
            $b36288e2db101ba3$var$mh(c, a, b, d);
        }
        $b36288e2db101ba3$var$jl(a, b);
    }
};
$b36288e2db101ba3$var$Hc = function() {
    return $b36288e2db101ba3$var$C;
};
$b36288e2db101ba3$var$Ic = function(a, b) {
    var c = $b36288e2db101ba3$var$C;
    try {
        return $b36288e2db101ba3$var$C = a, b();
    } finally{
        $b36288e2db101ba3$var$C = c;
    }
};
$b36288e2db101ba3$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $b36288e2db101ba3$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $b36288e2db101ba3$var$Db(d);
                        if (!e) throw Error($b36288e2db101ba3$var$p(90));
                        $b36288e2db101ba3$var$Wa(d);
                        $b36288e2db101ba3$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $b36288e2db101ba3$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $b36288e2db101ba3$var$fb(a, !!c.multiple, b, !1);
    }
};
$b36288e2db101ba3$var$Gb = $b36288e2db101ba3$var$Rk;
$b36288e2db101ba3$var$Hb = $b36288e2db101ba3$var$Sk;
var $b36288e2db101ba3$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $b36288e2db101ba3$var$Cb,
        $b36288e2db101ba3$var$ue,
        $b36288e2db101ba3$var$Db,
        $b36288e2db101ba3$var$Eb,
        $b36288e2db101ba3$var$Fb,
        $b36288e2db101ba3$var$Rk
    ]
}, $b36288e2db101ba3$var$ul = {
    findFiberByHostInstance: $b36288e2db101ba3$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $b36288e2db101ba3$var$vl = {
    bundleType: $b36288e2db101ba3$var$ul.bundleType,
    version: $b36288e2db101ba3$var$ul.version,
    rendererPackageName: $b36288e2db101ba3$var$ul.rendererPackageName,
    rendererConfig: $b36288e2db101ba3$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $b36288e2db101ba3$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $b36288e2db101ba3$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $b36288e2db101ba3$var$ul.findFiberByHostInstance || $b36288e2db101ba3$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $b36288e2db101ba3$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$b36288e2db101ba3$var$wl.isDisabled && $b36288e2db101ba3$var$wl.supportsFiber) try {
        $b36288e2db101ba3$var$kc = $b36288e2db101ba3$var$wl.inject($b36288e2db101ba3$var$vl), $b36288e2db101ba3$var$lc = $b36288e2db101ba3$var$wl;
    } catch (a) {}
}
$b36288e2db101ba3$export$ae55be85d98224ed = $b36288e2db101ba3$var$tl;
$b36288e2db101ba3$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$b36288e2db101ba3$var$ol(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$dl(a, b, null, c);
};
$b36288e2db101ba3$export$882461b6382ed46c = function(a, b) {
    if (!$b36288e2db101ba3$var$ol(a)) throw Error($b36288e2db101ba3$var$p(299));
    var c = !1, d = "", e = $b36288e2db101ba3$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $b36288e2db101ba3$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$b36288e2db101ba3$var$uf] = b.current;
    $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $b36288e2db101ba3$var$ml(b);
};
$b36288e2db101ba3$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($b36288e2db101ba3$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($b36288e2db101ba3$var$p(268, a));
    }
    a = $b36288e2db101ba3$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$b36288e2db101ba3$export$cd75ccfd720a3cd4 = function(a) {
    return $b36288e2db101ba3$var$Sk(a);
};
$b36288e2db101ba3$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$b36288e2db101ba3$var$pl(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$sl(null, a, b, !0, c);
};
$b36288e2db101ba3$export$757ceba2d55c277e = function(a, b, c) {
    if (!$b36288e2db101ba3$var$ol(a)) throw Error($b36288e2db101ba3$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $b36288e2db101ba3$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $b36288e2db101ba3$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$b36288e2db101ba3$var$uf] = b.current;
    $b36288e2db101ba3$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $b36288e2db101ba3$var$nl(b);
};
$b36288e2db101ba3$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$b36288e2db101ba3$var$pl(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$sl(null, a, b, !1, c);
};
$b36288e2db101ba3$export$502457920280e6be = function(a) {
    if (!$b36288e2db101ba3$var$pl(a)) throw Error($b36288e2db101ba3$var$p(40));
    return a._reactRootContainer ? ($b36288e2db101ba3$var$Sk(function() {
        $b36288e2db101ba3$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$b36288e2db101ba3$var$uf] = null;
        });
    }), !0) : !1;
};
$b36288e2db101ba3$export$c78a37762a8d58e1 = $b36288e2db101ba3$var$Rk;
$b36288e2db101ba3$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$b36288e2db101ba3$var$pl(c)) throw Error($b36288e2db101ba3$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($b36288e2db101ba3$var$p(38));
    return $b36288e2db101ba3$var$sl(a, b, c, !1, d);
};
$b36288e2db101ba3$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRequire.register("4LCdk", function(module, exports) {
"use strict";

module.exports = (parcelRequire("8BKFp"));

});
parcelRequire.register("8BKFp", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $6445fa7f31ec0ca5$export$c4744153514ff05d; }, function (v) { return $6445fa7f31ec0ca5$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7; }, function (v) { return $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $6445fa7f31ec0ca5$export$e26fe2ed2fa76875; }, function (v) { return $6445fa7f31ec0ca5$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $6445fa7f31ec0ca5$export$502329bbf4b505b1; }, function (v) { return $6445fa7f31ec0ca5$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $6445fa7f31ec0ca5$export$6e3807111c4874c4; }, function (v) { return $6445fa7f31ec0ca5$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $6445fa7f31ec0ca5$export$c27134553091fb3a; }, function (v) { return $6445fa7f31ec0ca5$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2; }, function (v) { return $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $6445fa7f31ec0ca5$export$b00a404bbd5edef2; }, function (v) { return $6445fa7f31ec0ca5$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $6445fa7f31ec0ca5$export$8352ce38b91d0c62; }, function (v) { return $6445fa7f31ec0ca5$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $6445fa7f31ec0ca5$export$d66a1c1c77bd778b; }, function (v) { return $6445fa7f31ec0ca5$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $6445fa7f31ec0ca5$export$d3dfb8e4810cb555; }, function (v) { return $6445fa7f31ec0ca5$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $6445fa7f31ec0ca5$export$839f9183b0465a69; }, function (v) { return $6445fa7f31ec0ca5$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $6445fa7f31ec0ca5$export$72fdf0e06517287b; }, function (v) { return $6445fa7f31ec0ca5$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $6445fa7f31ec0ca5$export$4b844e58a3e414b4; }, function (v) { return $6445fa7f31ec0ca5$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $6445fa7f31ec0ca5$export$816d2913ae6b83b1; }, function (v) { return $6445fa7f31ec0ca5$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $6445fa7f31ec0ca5$export$61bcfe829111a1d0; }, function (v) { return $6445fa7f31ec0ca5$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f; }, function (v) { return $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $6445fa7f31ec0ca5$export$b5836b71941fa3ed; }, function (v) { return $6445fa7f31ec0ca5$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $6445fa7f31ec0ca5$export$cf845f2c119da08a; }, function (v) { return $6445fa7f31ec0ca5$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6445fa7f31ec0ca5$export$c4744153514ff05d;
var $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7;
var $6445fa7f31ec0ca5$export$e26fe2ed2fa76875;
var $6445fa7f31ec0ca5$export$502329bbf4b505b1;
var $6445fa7f31ec0ca5$export$6e3807111c4874c4;
var $6445fa7f31ec0ca5$export$c27134553091fb3a;
var $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2;
var $6445fa7f31ec0ca5$export$b00a404bbd5edef2;
var $6445fa7f31ec0ca5$export$8352ce38b91d0c62;
var $6445fa7f31ec0ca5$export$d66a1c1c77bd778b;
var $6445fa7f31ec0ca5$export$d3dfb8e4810cb555;
var $6445fa7f31ec0ca5$export$839f9183b0465a69;
var $6445fa7f31ec0ca5$export$72fdf0e06517287b;
var $6445fa7f31ec0ca5$export$4b844e58a3e414b4;
var $6445fa7f31ec0ca5$export$816d2913ae6b83b1;
var $6445fa7f31ec0ca5$export$61bcfe829111a1d0;
var $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f;
var $6445fa7f31ec0ca5$export$b5836b71941fa3ed;
var $6445fa7f31ec0ca5$export$cf845f2c119da08a;
"use strict";
function $6445fa7f31ec0ca5$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $6445fa7f31ec0ca5$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $6445fa7f31ec0ca5$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $6445fa7f31ec0ca5$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $6445fa7f31ec0ca5$var$g(C, c)) n < e && 0 > $6445fa7f31ec0ca5$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $6445fa7f31ec0ca5$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $6445fa7f31ec0ca5$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $6445fa7f31ec0ca5$var$l = performance;
    $6445fa7f31ec0ca5$export$c4744153514ff05d = function() {
        return $6445fa7f31ec0ca5$var$l.now();
    };
} else {
    var $6445fa7f31ec0ca5$var$p = Date, $6445fa7f31ec0ca5$var$q = $6445fa7f31ec0ca5$var$p.now();
    $6445fa7f31ec0ca5$export$c4744153514ff05d = function() {
        return $6445fa7f31ec0ca5$var$p.now() - $6445fa7f31ec0ca5$var$q;
    };
}
var $6445fa7f31ec0ca5$var$r = [], $6445fa7f31ec0ca5$var$t = [], $6445fa7f31ec0ca5$var$u = 1, $6445fa7f31ec0ca5$var$v = null, $6445fa7f31ec0ca5$var$y = 3, $6445fa7f31ec0ca5$var$z = !1, $6445fa7f31ec0ca5$var$A = !1, $6445fa7f31ec0ca5$var$B = !1, $6445fa7f31ec0ca5$var$D = "function" === typeof setTimeout ? setTimeout : null, $6445fa7f31ec0ca5$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $6445fa7f31ec0ca5$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $6445fa7f31ec0ca5$var$G(a) {
    for(var b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t); null !== b;){
        if (null === b.callback) $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$t);
        else if (b.startTime <= a) $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$t), b.sortIndex = b.expirationTime, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$r, b);
        else break;
        b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
    }
}
function $6445fa7f31ec0ca5$var$H(a) {
    $6445fa7f31ec0ca5$var$B = !1;
    $6445fa7f31ec0ca5$var$G(a);
    if (!$6445fa7f31ec0ca5$var$A) {
        if (null !== $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r)) $6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J);
        else {
            var b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
            null !== b && $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, b.startTime - a);
        }
    }
}
function $6445fa7f31ec0ca5$var$J(a, b) {
    $6445fa7f31ec0ca5$var$A = !1;
    $6445fa7f31ec0ca5$var$B && ($6445fa7f31ec0ca5$var$B = !1, $6445fa7f31ec0ca5$var$E($6445fa7f31ec0ca5$var$L), $6445fa7f31ec0ca5$var$L = -1);
    $6445fa7f31ec0ca5$var$z = !0;
    var c = $6445fa7f31ec0ca5$var$y;
    try {
        $6445fa7f31ec0ca5$var$G(b);
        for($6445fa7f31ec0ca5$var$v = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r); null !== $6445fa7f31ec0ca5$var$v && (!($6445fa7f31ec0ca5$var$v.expirationTime > b) || a && !$6445fa7f31ec0ca5$var$M());){
            var d = $6445fa7f31ec0ca5$var$v.callback;
            if ("function" === typeof d) {
                $6445fa7f31ec0ca5$var$v.callback = null;
                $6445fa7f31ec0ca5$var$y = $6445fa7f31ec0ca5$var$v.priorityLevel;
                var e = d($6445fa7f31ec0ca5$var$v.expirationTime <= b);
                b = $6445fa7f31ec0ca5$export$c4744153514ff05d();
                "function" === typeof e ? $6445fa7f31ec0ca5$var$v.callback = e : $6445fa7f31ec0ca5$var$v === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r) && $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$r);
                $6445fa7f31ec0ca5$var$G(b);
            } else $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$r);
            $6445fa7f31ec0ca5$var$v = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r);
        }
        if (null !== $6445fa7f31ec0ca5$var$v) var w = !0;
        else {
            var m = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
            null !== m && $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $6445fa7f31ec0ca5$var$v = null, $6445fa7f31ec0ca5$var$y = c, $6445fa7f31ec0ca5$var$z = !1;
    }
}
var $6445fa7f31ec0ca5$var$N = !1, $6445fa7f31ec0ca5$var$O = null, $6445fa7f31ec0ca5$var$L = -1, $6445fa7f31ec0ca5$var$P = 5, $6445fa7f31ec0ca5$var$Q = -1;
function $6445fa7f31ec0ca5$var$M() {
    return $6445fa7f31ec0ca5$export$c4744153514ff05d() - $6445fa7f31ec0ca5$var$Q < $6445fa7f31ec0ca5$var$P ? !1 : !0;
}
function $6445fa7f31ec0ca5$var$R() {
    if (null !== $6445fa7f31ec0ca5$var$O) {
        var a = $6445fa7f31ec0ca5$export$c4744153514ff05d();
        $6445fa7f31ec0ca5$var$Q = a;
        var b = !0;
        try {
            b = $6445fa7f31ec0ca5$var$O(!0, a);
        } finally{
            b ? $6445fa7f31ec0ca5$var$S() : ($6445fa7f31ec0ca5$var$N = !1, $6445fa7f31ec0ca5$var$O = null);
        }
    } else $6445fa7f31ec0ca5$var$N = !1;
}
var $6445fa7f31ec0ca5$var$S;
if ("function" === typeof $6445fa7f31ec0ca5$var$F) $6445fa7f31ec0ca5$var$S = function() {
    $6445fa7f31ec0ca5$var$F($6445fa7f31ec0ca5$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $6445fa7f31ec0ca5$var$T = new MessageChannel, $6445fa7f31ec0ca5$var$U = $6445fa7f31ec0ca5$var$T.port2;
    $6445fa7f31ec0ca5$var$T.port1.onmessage = $6445fa7f31ec0ca5$var$R;
    $6445fa7f31ec0ca5$var$S = function() {
        $6445fa7f31ec0ca5$var$U.postMessage(null);
    };
} else $6445fa7f31ec0ca5$var$S = function() {
    $6445fa7f31ec0ca5$var$D($6445fa7f31ec0ca5$var$R, 0);
};
function $6445fa7f31ec0ca5$var$I(a) {
    $6445fa7f31ec0ca5$var$O = a;
    $6445fa7f31ec0ca5$var$N || ($6445fa7f31ec0ca5$var$N = !0, $6445fa7f31ec0ca5$var$S());
}
function $6445fa7f31ec0ca5$var$K(a, b) {
    $6445fa7f31ec0ca5$var$L = $6445fa7f31ec0ca5$var$D(function() {
        a($6445fa7f31ec0ca5$export$c4744153514ff05d());
    }, b);
}
$6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7 = 5;
$6445fa7f31ec0ca5$export$e26fe2ed2fa76875 = 1;
$6445fa7f31ec0ca5$export$502329bbf4b505b1 = 4;
$6445fa7f31ec0ca5$export$6e3807111c4874c4 = 3;
$6445fa7f31ec0ca5$export$c27134553091fb3a = null;
$6445fa7f31ec0ca5$export$33ee1acdc04fd2a2 = 2;
$6445fa7f31ec0ca5$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$6445fa7f31ec0ca5$export$8352ce38b91d0c62 = function() {
    $6445fa7f31ec0ca5$var$A || $6445fa7f31ec0ca5$var$z || ($6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J));
};
$6445fa7f31ec0ca5$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $6445fa7f31ec0ca5$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$6445fa7f31ec0ca5$export$d3dfb8e4810cb555 = function() {
    return $6445fa7f31ec0ca5$var$y;
};
$6445fa7f31ec0ca5$export$839f9183b0465a69 = function() {
    return $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r);
};
$6445fa7f31ec0ca5$export$72fdf0e06517287b = function(a) {
    switch($6445fa7f31ec0ca5$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $6445fa7f31ec0ca5$var$y;
    }
    var c = $6445fa7f31ec0ca5$var$y;
    $6445fa7f31ec0ca5$var$y = b;
    try {
        return a();
    } finally{
        $6445fa7f31ec0ca5$var$y = c;
    }
};
$6445fa7f31ec0ca5$export$4b844e58a3e414b4 = function() {};
$6445fa7f31ec0ca5$export$816d2913ae6b83b1 = function() {};
$6445fa7f31ec0ca5$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $6445fa7f31ec0ca5$var$y;
    $6445fa7f31ec0ca5$var$y = a;
    try {
        return b();
    } finally{
        $6445fa7f31ec0ca5$var$y = c;
    }
};
$6445fa7f31ec0ca5$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $6445fa7f31ec0ca5$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $6445fa7f31ec0ca5$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$t, a), null === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r) && a === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t) && ($6445fa7f31ec0ca5$var$B ? ($6445fa7f31ec0ca5$var$E($6445fa7f31ec0ca5$var$L), $6445fa7f31ec0ca5$var$L = -1) : $6445fa7f31ec0ca5$var$B = !0, $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, c - d))) : (a.sortIndex = e, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$r, a), $6445fa7f31ec0ca5$var$A || $6445fa7f31ec0ca5$var$z || ($6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J)));
    return a;
};
$6445fa7f31ec0ca5$export$b5836b71941fa3ed = $6445fa7f31ec0ca5$var$M;
$6445fa7f31ec0ca5$export$cf845f2c119da08a = function(a) {
    var b = $6445fa7f31ec0ca5$var$y;
    return function() {
        var c = $6445fa7f31ec0ca5$var$y;
        $6445fa7f31ec0ca5$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $6445fa7f31ec0ca5$var$y = c;
        }
    };
};

});



parcelRequire.register("e94ba", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4c525d7dbc25949$export$2e2bcd8739ae039; });

var $cthCm = parcelRequire("cthCm");
var $a4c525d7dbc25949$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $a4c525d7dbc25949$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $cthCm.default)(function(prop) {
    return $a4c525d7dbc25949$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});
parcelRequire.register("cthCm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9145dbf8e0e857b1$export$2e2bcd8739ae039; });
function $9145dbf8e0e857b1$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRequire.register("3vQgY", function(module, exports) {

module.exports = import("./" + (parcelRequire("kyEFX")).resolve("2sgnw")).then(()=>parcelRequire("4ZFd2"));

});

var $d4dab640dcbe486c$exports = {};
"use strict";

$d4dab640dcbe486c$exports = (parcelRequire("0qhf8"));


parcelRequire("bh6RR");
var $6fc264ec92100d3a$export$882461b6382ed46c;
var $6fc264ec92100d3a$export$757ceba2d55c277e;
"use strict";
var $47cfd4084854a574$exports = {};
"use strict";
function $47cfd4084854a574$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($47cfd4084854a574$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$47cfd4084854a574$var$checkDCE();

$47cfd4084854a574$exports = (parcelRequire("foRq4"));


var $6fc264ec92100d3a$var$i;
$6fc264ec92100d3a$export$882461b6382ed46c = $47cfd4084854a574$exports.createRoot;
$6fc264ec92100d3a$export$757ceba2d55c277e = $47cfd4084854a574$exports.hydrateRoot;





var $bh6RR = parcelRequire("bh6RR");
var $7f3c0863fade5429$export$38e42c68cf43b5d4;
var $7f3c0863fade5429$export$385906a4ef528034;
var $7f3c0863fade5429$export$69d0d1846105bbd3;
var $7f3c0863fade5429$export$a4e0ccd0af956942;
$7f3c0863fade5429$export$38e42c68cf43b5d4 = `MqZHCq_header`;
$7f3c0863fade5429$export$385906a4ef528034 = `MqZHCq_headerSuccess`;
$7f3c0863fade5429$export$69d0d1846105bbd3 = `MqZHCq_invisiblePlaceholder`;
$7f3c0863fade5429$export$a4e0ccd0af956942 = `MqZHCq_nothingFake1234`;




var $bh6RR = parcelRequire("bh6RR");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $5606419dfe2e9b1b$var$extendStatics = function(d, b) {
    $5606419dfe2e9b1b$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5606419dfe2e9b1b$var$extendStatics(d, b);
};
function $5606419dfe2e9b1b$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5606419dfe2e9b1b$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5606419dfe2e9b1b$export$18ce0697a983be9b = function() {
    $5606419dfe2e9b1b$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5606419dfe2e9b1b$export$18ce0697a983be9b.apply(this, arguments);
};
function $5606419dfe2e9b1b$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5606419dfe2e9b1b$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5606419dfe2e9b1b$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5606419dfe2e9b1b$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5606419dfe2e9b1b$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5606419dfe2e9b1b$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5606419dfe2e9b1b$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5606419dfe2e9b1b$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5606419dfe2e9b1b$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5606419dfe2e9b1b$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5606419dfe2e9b1b$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5606419dfe2e9b1b$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5606419dfe2e9b1b$export$45d3717a4c69092e(o, m, p);
}
function $5606419dfe2e9b1b$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5606419dfe2e9b1b$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5606419dfe2e9b1b$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5606419dfe2e9b1b$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5606419dfe2e9b1b$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5606419dfe2e9b1b$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5606419dfe2e9b1b$export$10c90e4f7922046c(v) {
    return this instanceof $5606419dfe2e9b1b$export$10c90e4f7922046c ? (this.v = v, this) : new $5606419dfe2e9b1b$export$10c90e4f7922046c(v);
}
function $5606419dfe2e9b1b$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5606419dfe2e9b1b$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5606419dfe2e9b1b$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5606419dfe2e9b1b$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5606419dfe2e9b1b$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5606419dfe2e9b1b$export$19a8beecd37a4c45 === "function" ? $5606419dfe2e9b1b$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5606419dfe2e9b1b$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5606419dfe2e9b1b$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $5606419dfe2e9b1b$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5606419dfe2e9b1b$export$45d3717a4c69092e(result, mod, k);
    }
    $5606419dfe2e9b1b$var$__setModuleDefault(result, mod);
    return result;
}
function $5606419dfe2e9b1b$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5606419dfe2e9b1b$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5606419dfe2e9b1b$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5606419dfe2e9b1b$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5606419dfe2e9b1b$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5606419dfe2e9b1b$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5606419dfe2e9b1b$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5606419dfe2e9b1b$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $5606419dfe2e9b1b$export$2e2bcd8739ae039 = {
    __extends: $5606419dfe2e9b1b$export$a8ba968b8961cb8a,
    __assign: $5606419dfe2e9b1b$export$18ce0697a983be9b,
    __rest: $5606419dfe2e9b1b$export$3c9a16f847548506,
    __decorate: $5606419dfe2e9b1b$export$29e00dfd3077644b,
    __param: $5606419dfe2e9b1b$export$d5ad3fd78186038f,
    __metadata: $5606419dfe2e9b1b$export$f1db080c865becb9,
    __awaiter: $5606419dfe2e9b1b$export$1050f835b63b671e,
    __generator: $5606419dfe2e9b1b$export$67ebef60e6f28a6,
    __createBinding: $5606419dfe2e9b1b$export$45d3717a4c69092e,
    __exportStar: $5606419dfe2e9b1b$export$f33643c0debef087,
    __values: $5606419dfe2e9b1b$export$19a8beecd37a4c45,
    __read: $5606419dfe2e9b1b$export$8d051b38c9118094,
    __spread: $5606419dfe2e9b1b$export$afc72e2116322959,
    __spreadArrays: $5606419dfe2e9b1b$export$6388937ca91ccae8,
    __spreadArray: $5606419dfe2e9b1b$export$1216008129fb82ed,
    __await: $5606419dfe2e9b1b$export$10c90e4f7922046c,
    __asyncGenerator: $5606419dfe2e9b1b$export$e427f37a30a4de9b,
    __asyncDelegator: $5606419dfe2e9b1b$export$bbd80228419bb833,
    __asyncValues: $5606419dfe2e9b1b$export$e3b29a3d6162315f,
    __makeTemplateObject: $5606419dfe2e9b1b$export$4fb47efe1390b86f,
    __importStar: $5606419dfe2e9b1b$export$c21735bcef00d192,
    __importDefault: $5606419dfe2e9b1b$export$da59b14a69baef04,
    __classPrivateFieldGet: $5606419dfe2e9b1b$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5606419dfe2e9b1b$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5606419dfe2e9b1b$export$81fdc39f203e4e04,
    __addDisposableResource: $5606419dfe2e9b1b$export$88ac25d8e944e405,
    __disposeResources: $5606419dfe2e9b1b$export$8f076105dc360e92
};


parcelRequire("e94ba");

var $bh6RR = parcelRequire("bh6RR");
var $53a106364dbd0a1b$exports = {};
//
$53a106364dbd0a1b$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


var $783faa7ec18221fc$export$71ad59f2e432cfe8 = "-ms-";
var $783faa7ec18221fc$export$2c0f367103c8d01c = "-moz-";
var $783faa7ec18221fc$export$39dfd62a25e0fe93 = "-webkit-";
var $783faa7ec18221fc$export$a29989082612d0d9 = "comm";
var $783faa7ec18221fc$export$aa3a2e812ca8570d = "rule";
var $783faa7ec18221fc$export$527d108ccf083c2b = "decl";
var $783faa7ec18221fc$export$d3d35020fa5b54f0 = "@page";
var $783faa7ec18221fc$export$500415a86c544f73 = "@media";
var $783faa7ec18221fc$export$a763edbf796b780a = "@import";
var $783faa7ec18221fc$export$2790aeb8b4e5c826 = "@charset";
var $783faa7ec18221fc$export$1cc683e23b84b133 = "@viewport";
var $783faa7ec18221fc$export$9447a5efea57e862 = "@supports";
var $783faa7ec18221fc$export$ef011b4e114b1fba = "@document";
var $783faa7ec18221fc$export$6aad947bda0f3f46 = "@namespace";
var $783faa7ec18221fc$export$b44a8529a35fcb60 = "@keyframes";
var $783faa7ec18221fc$export$2c16de31893252e6 = "@font-face";
var $783faa7ec18221fc$export$3d846dd52e150c6f = "@counter-style";
var $783faa7ec18221fc$export$22314bfbb57653fe = "@font-feature-values";
var $783faa7ec18221fc$export$d773506282b3cfe6 = "@layer";
var $783faa7ec18221fc$export$1c5a554c78c0cd12 = "@scope";
var $783faa7ec18221fc$export$2335f513bbd82c6d = Math.abs;
var $783faa7ec18221fc$export$6788812c4e6611e6 = String.fromCharCode;
var $783faa7ec18221fc$export$e6e34fd1f2686227 = Object.assign;
function $783faa7ec18221fc$export$d6af199866bfb566(e, r) {
    return $783faa7ec18221fc$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $783faa7ec18221fc$export$a9db5e087081082d(e, 0)) << 2 ^ $783faa7ec18221fc$export$a9db5e087081082d(e, 1)) << 2 ^ $783faa7ec18221fc$export$a9db5e087081082d(e, 2)) << 2 ^ $783faa7ec18221fc$export$a9db5e087081082d(e, 3) : 0;
}
function $783faa7ec18221fc$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $783faa7ec18221fc$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $783faa7ec18221fc$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $783faa7ec18221fc$export$f8e21b1e77979a08(e, r, a) {
    return e.indexOf(r, a);
}
function $783faa7ec18221fc$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $783faa7ec18221fc$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $783faa7ec18221fc$export$36776f635604f274(e) {
    return e.length;
}
function $783faa7ec18221fc$export$f9084667e487ed46(e) {
    return e.length;
}
function $783faa7ec18221fc$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $783faa7ec18221fc$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
function $783faa7ec18221fc$export$3dea766d36a8935f(e, r) {
    return e.filter(function(e) {
        return !$783faa7ec18221fc$export$4659b591c19bdf3d(e, r);
    });
}
var $783faa7ec18221fc$export$53f1d5ea8de3d7c = 1;
var $783faa7ec18221fc$export$4e0c71f277ca26b3 = 1;
var $783faa7ec18221fc$export$f24224f1c91d8156 = 0;
var $783faa7ec18221fc$export$5880b8b5730aff45 = 0;
var $783faa7ec18221fc$export$c0306caf338ac095 = 0;
var $783faa7ec18221fc$export$30a86d91af8ff6e6 = "";
function $783faa7ec18221fc$export$35059013cd4a06db(e, r, a, n, c, s, t, u) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $783faa7ec18221fc$export$53f1d5ea8de3d7c,
        column: $783faa7ec18221fc$export$4e0c71f277ca26b3,
        length: t,
        return: "",
        siblings: u
    };
}
function $783faa7ec18221fc$export$784d13d8ee351f07(e, r) {
    return $783faa7ec18221fc$export$e6e34fd1f2686227($783faa7ec18221fc$export$35059013cd4a06db("", null, null, "", null, null, 0, e.siblings), e, {
        length: -e.length
    }, r);
}
function $783faa7ec18221fc$export$590e8b2c435046d9(e) {
    while(e.root)e = $783faa7ec18221fc$export$784d13d8ee351f07(e.root, {
        children: [
            e
        ]
    });
    $783faa7ec18221fc$export$10d8903dec122b9d(e, e.siblings);
}
function $783faa7ec18221fc$export$eba6f6f03b0a92e7() {
    return $783faa7ec18221fc$export$c0306caf338ac095;
}
function $783faa7ec18221fc$export$232faf9add678146() {
    $783faa7ec18221fc$export$c0306caf338ac095 = $783faa7ec18221fc$export$5880b8b5730aff45 > 0 ? $783faa7ec18221fc$export$a9db5e087081082d($783faa7ec18221fc$export$30a86d91af8ff6e6, --$783faa7ec18221fc$export$5880b8b5730aff45) : 0;
    if ($783faa7ec18221fc$export$4e0c71f277ca26b3--, $783faa7ec18221fc$export$c0306caf338ac095 === 10) $783faa7ec18221fc$export$4e0c71f277ca26b3 = 1, $783faa7ec18221fc$export$53f1d5ea8de3d7c--;
    return $783faa7ec18221fc$export$c0306caf338ac095;
}
function $783faa7ec18221fc$export$48cfd1e771a65c4f() {
    $783faa7ec18221fc$export$c0306caf338ac095 = $783faa7ec18221fc$export$5880b8b5730aff45 < $783faa7ec18221fc$export$f24224f1c91d8156 ? $783faa7ec18221fc$export$a9db5e087081082d($783faa7ec18221fc$export$30a86d91af8ff6e6, $783faa7ec18221fc$export$5880b8b5730aff45++) : 0;
    if ($783faa7ec18221fc$export$4e0c71f277ca26b3++, $783faa7ec18221fc$export$c0306caf338ac095 === 10) $783faa7ec18221fc$export$4e0c71f277ca26b3 = 1, $783faa7ec18221fc$export$53f1d5ea8de3d7c++;
    return $783faa7ec18221fc$export$c0306caf338ac095;
}
function $783faa7ec18221fc$export$4d3fb11e950abb9e() {
    return $783faa7ec18221fc$export$a9db5e087081082d($783faa7ec18221fc$export$30a86d91af8ff6e6, $783faa7ec18221fc$export$5880b8b5730aff45);
}
function $783faa7ec18221fc$export$e88cb2efb12ae807() {
    return $783faa7ec18221fc$export$5880b8b5730aff45;
}
function $783faa7ec18221fc$export$58adb3bec8346d0f(e, r) {
    return $783faa7ec18221fc$export$2f35ab04d2335697($783faa7ec18221fc$export$30a86d91af8ff6e6, e, r);
}
function $783faa7ec18221fc$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $783faa7ec18221fc$export$2de70f21292aac9e(e) {
    return $783faa7ec18221fc$export$53f1d5ea8de3d7c = $783faa7ec18221fc$export$4e0c71f277ca26b3 = 1, $783faa7ec18221fc$export$f24224f1c91d8156 = $783faa7ec18221fc$export$36776f635604f274($783faa7ec18221fc$export$30a86d91af8ff6e6 = e), $783faa7ec18221fc$export$5880b8b5730aff45 = 0, [];
}
function $783faa7ec18221fc$export$45918ac1574455b1(e) {
    return $783faa7ec18221fc$export$30a86d91af8ff6e6 = "", e;
}
function $783faa7ec18221fc$export$410ac95b9ec204b8(e) {
    return $783faa7ec18221fc$export$87c2784dc9fc4ab($783faa7ec18221fc$export$58adb3bec8346d0f($783faa7ec18221fc$export$5880b8b5730aff45 - 1, $783faa7ec18221fc$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $783faa7ec18221fc$export$660b2ee2d4fb4eff(e) {
    return $783faa7ec18221fc$export$45918ac1574455b1($783faa7ec18221fc$export$5f8c09e3ae6f64e1($783faa7ec18221fc$export$2de70f21292aac9e(e)));
}
function $783faa7ec18221fc$export$7af1228ff777d175(e) {
    while($783faa7ec18221fc$export$c0306caf338ac095 = $783faa7ec18221fc$export$4d3fb11e950abb9e())if ($783faa7ec18221fc$export$c0306caf338ac095 < 33) $783faa7ec18221fc$export$48cfd1e771a65c4f();
    else break;
    return $783faa7ec18221fc$export$9e1725a4cfeada27(e) > 2 || $783faa7ec18221fc$export$9e1725a4cfeada27($783faa7ec18221fc$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $783faa7ec18221fc$export$5f8c09e3ae6f64e1(e) {
    while($783faa7ec18221fc$export$48cfd1e771a65c4f())switch($783faa7ec18221fc$export$9e1725a4cfeada27($783faa7ec18221fc$export$c0306caf338ac095)){
        case 0:
            $783faa7ec18221fc$export$10d8903dec122b9d($783faa7ec18221fc$export$c2ab62c7bf24634($783faa7ec18221fc$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $783faa7ec18221fc$export$10d8903dec122b9d($783faa7ec18221fc$export$410ac95b9ec204b8($783faa7ec18221fc$export$c0306caf338ac095), e);
            break;
        default:
            $783faa7ec18221fc$export$10d8903dec122b9d($783faa7ec18221fc$export$6788812c4e6611e6($783faa7ec18221fc$export$c0306caf338ac095), e);
    }
    return e;
}
function $783faa7ec18221fc$export$955ba06d119e085e(e, r) {
    while(--r && $783faa7ec18221fc$export$48cfd1e771a65c4f())if ($783faa7ec18221fc$export$c0306caf338ac095 < 48 || $783faa7ec18221fc$export$c0306caf338ac095 > 102 || $783faa7ec18221fc$export$c0306caf338ac095 > 57 && $783faa7ec18221fc$export$c0306caf338ac095 < 65 || $783faa7ec18221fc$export$c0306caf338ac095 > 70 && $783faa7ec18221fc$export$c0306caf338ac095 < 97) break;
    return $783faa7ec18221fc$export$58adb3bec8346d0f(e, $783faa7ec18221fc$export$e88cb2efb12ae807() + (r < 6 && $783faa7ec18221fc$export$4d3fb11e950abb9e() == 32 && $783faa7ec18221fc$export$48cfd1e771a65c4f() == 32));
}
function $783faa7ec18221fc$export$c889f2fcc19dbf12(e) {
    while($783faa7ec18221fc$export$48cfd1e771a65c4f())switch($783faa7ec18221fc$export$c0306caf338ac095){
        case e:
            return $783faa7ec18221fc$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $783faa7ec18221fc$export$c889f2fcc19dbf12($783faa7ec18221fc$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $783faa7ec18221fc$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $783faa7ec18221fc$export$48cfd1e771a65c4f();
            break;
    }
    return $783faa7ec18221fc$export$5880b8b5730aff45;
}
function $783faa7ec18221fc$export$4254d4e2b3745c4c(e, r) {
    while($783faa7ec18221fc$export$48cfd1e771a65c4f())if (e + $783faa7ec18221fc$export$c0306caf338ac095 === 57) break;
    else if (e + $783faa7ec18221fc$export$c0306caf338ac095 === 84 && $783faa7ec18221fc$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $783faa7ec18221fc$export$58adb3bec8346d0f(r, $783faa7ec18221fc$export$5880b8b5730aff45 - 1) + "*" + $783faa7ec18221fc$export$6788812c4e6611e6(e === 47 ? e : $783faa7ec18221fc$export$48cfd1e771a65c4f());
}
function $783faa7ec18221fc$export$c2ab62c7bf24634(e) {
    while(!$783faa7ec18221fc$export$9e1725a4cfeada27($783faa7ec18221fc$export$4d3fb11e950abb9e()))$783faa7ec18221fc$export$48cfd1e771a65c4f();
    return $783faa7ec18221fc$export$58adb3bec8346d0f(e, $783faa7ec18221fc$export$5880b8b5730aff45);
}
function $783faa7ec18221fc$export$ef7acd7185315e22(e) {
    return $783faa7ec18221fc$export$45918ac1574455b1($783faa7ec18221fc$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $783faa7ec18221fc$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $783faa7ec18221fc$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var g = 0;
    var k = "";
    var x = c;
    var y = s;
    var j = n;
    var z = k;
    while(w)switch(h = g, g = $783faa7ec18221fc$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $783faa7ec18221fc$export$a9db5e087081082d(z, l - 1) == 58) {
                if ($783faa7ec18221fc$export$f8e21b1e77979a08(z += $783faa7ec18221fc$export$77ad94ebf1c2b9ed($783faa7ec18221fc$export$410ac95b9ec204b8(g), "&", "&\f"), "&\f", $783faa7ec18221fc$export$2335f513bbd82c6d(f ? u[f - 1] : 0)) != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            z += $783faa7ec18221fc$export$410ac95b9ec204b8(g);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            z += $783faa7ec18221fc$export$7af1228ff777d175(h);
            break;
        case 92:
            z += $783faa7ec18221fc$export$955ba06d119e085e($783faa7ec18221fc$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($783faa7ec18221fc$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $783faa7ec18221fc$export$10d8903dec122b9d($783faa7ec18221fc$export$4a34f930e789283c($783faa7ec18221fc$export$4254d4e2b3745c4c($783faa7ec18221fc$export$48cfd1e771a65c4f(), $783faa7ec18221fc$export$e88cb2efb12ae807()), r, a, i), i);
                    break;
                default:
                    z += "/";
            }
            break;
        case 123 * b:
            u[f++] = $783faa7ec18221fc$export$36776f635604f274(z) * d;
        case 125 * b:
        case 59:
        case 0:
            switch(g){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) z = $783faa7ec18221fc$export$77ad94ebf1c2b9ed(z, /\f/g, "");
                    if (p > 0 && $783faa7ec18221fc$export$36776f635604f274(z) - l) $783faa7ec18221fc$export$10d8903dec122b9d(p > 32 ? $783faa7ec18221fc$export$f8483753829ec8f3(z + ";", n, a, l - 1, i) : $783faa7ec18221fc$export$f8483753829ec8f3($783faa7ec18221fc$export$77ad94ebf1c2b9ed(z, " ", "") + ";", n, a, l - 2, i), i);
                    break;
                case 59:
                    z += ";";
                default:
                    $783faa7ec18221fc$export$10d8903dec122b9d(j = $783faa7ec18221fc$export$3307ffa7023ede1e(z, r, a, f, o, c, u, k, x = [], y = [], l, s), s);
                    if (g === 123) {
                        if (o === 0) $783faa7ec18221fc$export$98e6a39c04603d36(z, r, j, j, x, s, l, u, y);
                        else switch(v === 99 && $783faa7ec18221fc$export$a9db5e087081082d(z, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $783faa7ec18221fc$export$98e6a39c04603d36(e, j, j, n && $783faa7ec18221fc$export$10d8903dec122b9d($783faa7ec18221fc$export$3307ffa7023ede1e(e, j, j, 0, 0, c, u, k, c, x = [], l, y), y), c, y, l, u, n ? x : y);
                                break;
                            default:
                                $783faa7ec18221fc$export$98e6a39c04603d36(z, j, j, j, [
                                    ""
                                ], y, 0, u, y);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, k = z = "", l = t;
            break;
        case 58:
            l = 1 + $783faa7ec18221fc$export$36776f635604f274(z), p = h;
        default:
            if (b < 1) {
                if (g == 123) --b;
                else if (g == 125 && b++ == 0 && $783faa7ec18221fc$export$232faf9add678146() == 125) continue;
            }
            switch(z += $783faa7ec18221fc$export$6788812c4e6611e6(g), g * b){
                case 38:
                    d = o > 0 ? 1 : (z += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($783faa7ec18221fc$export$36776f635604f274(z) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($783faa7ec18221fc$export$4d3fb11e950abb9e() === 45) z += $783faa7ec18221fc$export$410ac95b9ec204b8($783faa7ec18221fc$export$48cfd1e771a65c4f());
                    v = $783faa7ec18221fc$export$4d3fb11e950abb9e(), o = l = $783faa7ec18221fc$export$36776f635604f274(k = z += $783faa7ec18221fc$export$c2ab62c7bf24634($783faa7ec18221fc$export$e88cb2efb12ae807())), g++;
                    break;
                case 45:
                    if (h === 45 && $783faa7ec18221fc$export$36776f635604f274(z) == 2) b = 0;
            }
    }
    return s;
}
function $783faa7ec18221fc$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l, v) {
    var p = s - 1;
    var h = s === 0 ? t : [
        ""
    ];
    var b = $783faa7ec18221fc$export$f9084667e487ed46(h);
    for(var w = 0, d = 0, g = 0; w < n; ++w)for(var k = 0, m = $783faa7ec18221fc$export$2f35ab04d2335697(e, p + 1, p = $783faa7ec18221fc$export$2335f513bbd82c6d(d = u[w])), x = e; k < b; ++k)if (x = $783faa7ec18221fc$export$87c2784dc9fc4ab(d > 0 ? h[k] + " " + m : $783faa7ec18221fc$export$77ad94ebf1c2b9ed(m, /&\f/g, h[k]))) f[g++] = x;
    return $783faa7ec18221fc$export$35059013cd4a06db(e, r, a, s === 0 ? $783faa7ec18221fc$export$aa3a2e812ca8570d : i, f, o, l, v);
}
function $783faa7ec18221fc$export$4a34f930e789283c(e, r, a, c) {
    return $783faa7ec18221fc$export$35059013cd4a06db(e, r, a, $783faa7ec18221fc$export$a29989082612d0d9, $783faa7ec18221fc$export$6788812c4e6611e6($783faa7ec18221fc$export$eba6f6f03b0a92e7()), $783faa7ec18221fc$export$2f35ab04d2335697(e, 2, -2), 0, c);
}
function $783faa7ec18221fc$export$f8483753829ec8f3(e, r, a, n, c) {
    return $783faa7ec18221fc$export$35059013cd4a06db(e, r, a, $783faa7ec18221fc$export$527d108ccf083c2b, $783faa7ec18221fc$export$2f35ab04d2335697(e, 0, n), $783faa7ec18221fc$export$2f35ab04d2335697(e, n + 1, -1), n, c);
}
function $783faa7ec18221fc$export$82e9f45cca5ba907(n, c, s) {
    switch($783faa7ec18221fc$export$d6af199866bfb566(n, c)){
        case 5103:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $783faa7ec18221fc$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$2c0f367103c8d01c + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($783faa7ec18221fc$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "box-$1$2" + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "flex-item-" + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$783faa7ec18221fc$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $783faa7ec18221fc$export$71ad59f2e432cfe8 + "grid-row-" + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "flex-line-pack" + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + "box-" + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "-grow", "") + $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed($783faa7ec18221fc$export$77ad94ebf1c2b9ed($783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed($783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "box-pack:$3" + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$783faa7ec18221fc$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $783faa7ec18221fc$export$71ad59f2e432cfe8 + "grid-column-align" + $783faa7ec18221fc$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $783faa7ec18221fc$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$783faa7ec18221fc$export$f8e21b1e77979a08(n + (s = s[c].value), "span", 0) ? n : $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$783faa7ec18221fc$export$f8e21b1e77979a08(s, "span", 0) ? $783faa7ec18221fc$export$4659b591c19bdf3d(s, /\d+/) : +$783faa7ec18221fc$export$4659b591c19bdf3d(s, /\d+/) - +$783faa7ec18221fc$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $783faa7ec18221fc$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed($783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($783faa7ec18221fc$export$36776f635604f274(n) - 1 - c > 6) switch($783faa7ec18221fc$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($783faa7ec18221fc$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $783faa7ec18221fc$export$2c0f367103c8d01c + ($783faa7ec18221fc$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$783faa7ec18221fc$export$f8e21b1e77979a08(n, "stretch", 0) ? $783faa7ec18221fc$export$82e9f45cca5ba907($783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $783faa7ec18221fc$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $783faa7ec18221fc$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($783faa7ec18221fc$export$a9db5e087081082d(n, c + 6) === 121) return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, ":", ":" + $783faa7ec18221fc$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($783faa7ec18221fc$export$a9db5e087081082d(n, $783faa7ec18221fc$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $783faa7ec18221fc$export$39dfd62a25e0fe93 + ($783faa7ec18221fc$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, ":", ":" + $783faa7ec18221fc$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $783faa7ec18221fc$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    for(var n = 0; n < e.length; n++)a += r(e[n], n, e, r) || "";
    return a;
}
function $783faa7ec18221fc$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $783faa7ec18221fc$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $783faa7ec18221fc$export$a763edbf796b780a:
        case $783faa7ec18221fc$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $783faa7ec18221fc$export$a29989082612d0d9:
            return "";
        case $783faa7ec18221fc$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $783faa7ec18221fc$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $783faa7ec18221fc$export$aa3a2e812ca8570d:
            if (!$783faa7ec18221fc$export$36776f635604f274(e.value = e.props.join(","))) return "";
    }
    return $783faa7ec18221fc$export$36776f635604f274(a = $783faa7ec18221fc$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $783faa7ec18221fc$export$5a7767152ae0305f(e) {
    var r = $783faa7ec18221fc$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $783faa7ec18221fc$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $783faa7ec18221fc$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $783faa7ec18221fc$export$527d108ccf083c2b:
                n.return = $783faa7ec18221fc$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $783faa7ec18221fc$export$b44a8529a35fcb60:
                return $783faa7ec18221fc$export$dfdc1655ccc5b9cb([
                    $783faa7ec18221fc$export$784d13d8ee351f07(n, {
                        value: $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $783faa7ec18221fc$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $783faa7ec18221fc$export$aa3a2e812ca8570d:
                if (n.length) return $783faa7ec18221fc$export$1be1fc439b849fdf(u = n.props, function(c) {
                    switch($783faa7ec18221fc$export$4659b591c19bdf3d(c, i = /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            $783faa7ec18221fc$export$590e8b2c435046d9($783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                props: [
                                    $783faa7ec18221fc$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $783faa7ec18221fc$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $783faa7ec18221fc$export$590e8b2c435046d9($783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $783faa7ec18221fc$export$e6e34fd1f2686227(n, {
                                props: $783faa7ec18221fc$export$3dea766d36a8935f(u, i)
                            });
                            break;
                        case "::placeholder":
                            $783faa7ec18221fc$export$590e8b2c435046d9($783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                props: [
                                    $783faa7ec18221fc$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $783faa7ec18221fc$export$39dfd62a25e0fe93 + "input-$1")
                                ]
                            }));
                            $783faa7ec18221fc$export$590e8b2c435046d9($783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                props: [
                                    $783faa7ec18221fc$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $783faa7ec18221fc$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $783faa7ec18221fc$export$590e8b2c435046d9($783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                props: [
                                    $783faa7ec18221fc$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $783faa7ec18221fc$export$71ad59f2e432cfe8 + "input-$1")
                                ]
                            }));
                            $783faa7ec18221fc$export$590e8b2c435046d9($783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $783faa7ec18221fc$export$e6e34fd1f2686227(n, {
                                props: $783faa7ec18221fc$export$3dea766d36a8935f(u, i)
                            });
                            break;
                    }
                    return "";
                });
        }
    }
}
function $783faa7ec18221fc$export$76a88f7de6507443(e) {
    switch(e.type){
        case $783faa7ec18221fc$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $783faa7ec18221fc$export$1be1fc439b849fdf($783faa7ec18221fc$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($783faa7ec18221fc$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $783faa7ec18221fc$export$2f35ab04d2335697(r, 1, $783faa7ec18221fc$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $783faa7ec18221fc$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $783faa7ec18221fc$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $783faa7ec18221fc$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $78b52bced097bc64$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};


var $391299e0893a3dfa$exports = {};
// shim for using process in browser
var $391299e0893a3dfa$var$process = $391299e0893a3dfa$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $391299e0893a3dfa$var$cachedSetTimeout;
var $391299e0893a3dfa$var$cachedClearTimeout;
function $391299e0893a3dfa$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $391299e0893a3dfa$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $391299e0893a3dfa$var$cachedSetTimeout = setTimeout;
        else $391299e0893a3dfa$var$cachedSetTimeout = $391299e0893a3dfa$var$defaultSetTimout;
    } catch (e) {
        $391299e0893a3dfa$var$cachedSetTimeout = $391299e0893a3dfa$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $391299e0893a3dfa$var$cachedClearTimeout = clearTimeout;
        else $391299e0893a3dfa$var$cachedClearTimeout = $391299e0893a3dfa$var$defaultClearTimeout;
    } catch (e) {
        $391299e0893a3dfa$var$cachedClearTimeout = $391299e0893a3dfa$var$defaultClearTimeout;
    }
})();
function $391299e0893a3dfa$var$runTimeout(fun) {
    if ($391299e0893a3dfa$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($391299e0893a3dfa$var$cachedSetTimeout === $391299e0893a3dfa$var$defaultSetTimout || !$391299e0893a3dfa$var$cachedSetTimeout) && setTimeout) {
        $391299e0893a3dfa$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $391299e0893a3dfa$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $391299e0893a3dfa$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $391299e0893a3dfa$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $391299e0893a3dfa$var$runClearTimeout(marker) {
    if ($391299e0893a3dfa$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($391299e0893a3dfa$var$cachedClearTimeout === $391299e0893a3dfa$var$defaultClearTimeout || !$391299e0893a3dfa$var$cachedClearTimeout) && clearTimeout) {
        $391299e0893a3dfa$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $391299e0893a3dfa$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $391299e0893a3dfa$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $391299e0893a3dfa$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $391299e0893a3dfa$var$queue = [];
var $391299e0893a3dfa$var$draining = false;
var $391299e0893a3dfa$var$currentQueue;
var $391299e0893a3dfa$var$queueIndex = -1;
function $391299e0893a3dfa$var$cleanUpNextTick() {
    if (!$391299e0893a3dfa$var$draining || !$391299e0893a3dfa$var$currentQueue) return;
    $391299e0893a3dfa$var$draining = false;
    if ($391299e0893a3dfa$var$currentQueue.length) $391299e0893a3dfa$var$queue = $391299e0893a3dfa$var$currentQueue.concat($391299e0893a3dfa$var$queue);
    else $391299e0893a3dfa$var$queueIndex = -1;
    if ($391299e0893a3dfa$var$queue.length) $391299e0893a3dfa$var$drainQueue();
}
function $391299e0893a3dfa$var$drainQueue() {
    if ($391299e0893a3dfa$var$draining) return;
    var timeout = $391299e0893a3dfa$var$runTimeout($391299e0893a3dfa$var$cleanUpNextTick);
    $391299e0893a3dfa$var$draining = true;
    var len = $391299e0893a3dfa$var$queue.length;
    while(len){
        $391299e0893a3dfa$var$currentQueue = $391299e0893a3dfa$var$queue;
        $391299e0893a3dfa$var$queue = [];
        while(++$391299e0893a3dfa$var$queueIndex < len)if ($391299e0893a3dfa$var$currentQueue) $391299e0893a3dfa$var$currentQueue[$391299e0893a3dfa$var$queueIndex].run();
        $391299e0893a3dfa$var$queueIndex = -1;
        len = $391299e0893a3dfa$var$queue.length;
    }
    $391299e0893a3dfa$var$currentQueue = null;
    $391299e0893a3dfa$var$draining = false;
    $391299e0893a3dfa$var$runClearTimeout(timeout);
}
$391299e0893a3dfa$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $391299e0893a3dfa$var$queue.push(new $391299e0893a3dfa$var$Item(fun, args));
    if ($391299e0893a3dfa$var$queue.length === 1 && !$391299e0893a3dfa$var$draining) $391299e0893a3dfa$var$runTimeout($391299e0893a3dfa$var$drainQueue);
};
// v8 likes predictible objects
function $391299e0893a3dfa$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$391299e0893a3dfa$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$391299e0893a3dfa$var$process.title = "browser";
$391299e0893a3dfa$var$process.browser = true;
$391299e0893a3dfa$var$process.env = {};
$391299e0893a3dfa$var$process.argv = [];
$391299e0893a3dfa$var$process.version = ""; // empty string to avoid regexp issues
$391299e0893a3dfa$var$process.versions = {};
function $391299e0893a3dfa$var$noop() {}
$391299e0893a3dfa$var$process.on = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.addListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.once = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.off = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.removeListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.removeAllListeners = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.emit = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.prependListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.prependOnceListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.listeners = function(name) {
    return [];
};
$391299e0893a3dfa$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$391299e0893a3dfa$var$process.cwd = function() {
    return "/";
};
$391299e0893a3dfa$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$391299e0893a3dfa$var$process.umask = function() {
    return 0;
};


var $e484c752f3f06549$var$f = ("undefined" != typeof $391299e0893a3dfa$exports && void 0 !== $391299e0893a3dfa$exports.env && undefined, "data-styled"), $e484c752f3f06549$var$m = "active", $e484c752f3f06549$var$y = "data-styled-version", $e484c752f3f06549$export$83d89fbfd8236492 = "6.1.13", $e484c752f3f06549$var$g = "/*!sc*/\n", $e484c752f3f06549$var$S = "undefined" != typeof window && "HTMLElement" in window, $e484c752f3f06549$var$w = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : ("undefined" != typeof $391299e0893a3dfa$exports && $391299e0893a3dfa$exports.env, "undefined" != typeof $391299e0893a3dfa$exports && $391299e0893a3dfa$exports.env, false)), $e484c752f3f06549$var$b = {}, $e484c752f3f06549$var$E = /invalid hook call/i, $e484c752f3f06549$var$N = new Set, $e484c752f3f06549$var$P = function(t, n) {
    var o, s, i, a, e;
}, $e484c752f3f06549$var$_ = Object.freeze([]), $e484c752f3f06549$var$C = Object.freeze({});
function $e484c752f3f06549$var$I(e, t, n) {
    return void 0 === n && (n = $e484c752f3f06549$var$C), e.theme !== n.theme && e.theme || t || n.theme;
}
var $e484c752f3f06549$var$A = new Set([
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "track",
    "u",
    "ul",
    "use",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
]), $e484c752f3f06549$var$O = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $e484c752f3f06549$var$D = /(^-|-$)/g;
function $e484c752f3f06549$var$R(e) {
    return e.replace($e484c752f3f06549$var$O, "-").replace($e484c752f3f06549$var$D, "");
}
var $e484c752f3f06549$var$T = /(a)(d)/gi, $e484c752f3f06549$var$k = 52, $e484c752f3f06549$var$j = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $e484c752f3f06549$var$x(e) {
    var t, n = "";
    for(t = Math.abs(e); t > $e484c752f3f06549$var$k; t = t / $e484c752f3f06549$var$k | 0)n = $e484c752f3f06549$var$j(t % $e484c752f3f06549$var$k) + n;
    return ($e484c752f3f06549$var$j(t % $e484c752f3f06549$var$k) + n).replace($e484c752f3f06549$var$T, "$1-$2");
}
var $e484c752f3f06549$var$V, $e484c752f3f06549$var$F = 5381, $e484c752f3f06549$var$M = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $e484c752f3f06549$var$z = function(e) {
    return $e484c752f3f06549$var$M($e484c752f3f06549$var$F, e);
};
function $e484c752f3f06549$var$$(e) {
    return $e484c752f3f06549$var$x($e484c752f3f06549$var$z(e) >>> 0);
}
function $e484c752f3f06549$var$B(e) {
    return (0, e.displayName) || e.name || "Component";
}
function $e484c752f3f06549$var$L(e) {
    return "string" == typeof e && true;
}
var $e484c752f3f06549$var$G = "function" == typeof Symbol && Symbol.for, $e484c752f3f06549$var$Y = $e484c752f3f06549$var$G ? Symbol.for("react.memo") : 60115, $e484c752f3f06549$var$W = $e484c752f3f06549$var$G ? Symbol.for("react.forward_ref") : 60112, $e484c752f3f06549$var$q = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
}, $e484c752f3f06549$var$H = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
}, $e484c752f3f06549$var$U = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
}, $e484c752f3f06549$var$J = (($e484c752f3f06549$var$V = {})[$e484c752f3f06549$var$W] = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
}, $e484c752f3f06549$var$V[$e484c752f3f06549$var$Y] = $e484c752f3f06549$var$U, $e484c752f3f06549$var$V);
function $e484c752f3f06549$var$X(e) {
    var t;
    return ("type" in (t = e) && t.type.$$typeof) === $e484c752f3f06549$var$Y ? $e484c752f3f06549$var$U : "$$typeof" in e ? $e484c752f3f06549$var$J[e.$$typeof] : $e484c752f3f06549$var$q;
}
var $e484c752f3f06549$var$Z = Object.defineProperty, $e484c752f3f06549$var$K = Object.getOwnPropertyNames, $e484c752f3f06549$var$Q = Object.getOwnPropertySymbols, $e484c752f3f06549$var$ee = Object.getOwnPropertyDescriptor, $e484c752f3f06549$var$te = Object.getPrototypeOf, $e484c752f3f06549$var$ne = Object.prototype;
function $e484c752f3f06549$var$oe(e, t, n) {
    if ("string" != typeof t) {
        if ($e484c752f3f06549$var$ne) {
            var o = $e484c752f3f06549$var$te(t);
            o && o !== $e484c752f3f06549$var$ne && $e484c752f3f06549$var$oe(e, o, n);
        }
        var r = $e484c752f3f06549$var$K(t);
        $e484c752f3f06549$var$Q && (r = r.concat($e484c752f3f06549$var$Q(t)));
        for(var s = $e484c752f3f06549$var$X(e), i = $e484c752f3f06549$var$X(t), a = 0; a < r.length; ++a){
            var c = r[a];
            if (!(c in $e484c752f3f06549$var$H || n && n[c] || i && c in i || s && c in s)) {
                var l = $e484c752f3f06549$var$ee(t, c);
                try {
                    $e484c752f3f06549$var$Z(e, c, l);
                } catch (e) {}
            }
        }
    }
    return e;
}
function $e484c752f3f06549$var$re(e) {
    return "function" == typeof e;
}
function $e484c752f3f06549$export$7ba318d8d2f06c76(e) {
    return "object" == typeof e && "styledComponentId" in e;
}
function $e484c752f3f06549$var$ie(e, t) {
    return e && t ? "".concat(e, " ").concat(t) : e || t || "";
}
function $e484c752f3f06549$var$ae(e, t) {
    if (0 === e.length) return "";
    for(var n = e[0], o = 1; o < e.length; o++)n += t ? t + e[o] : e[o];
    return n;
}
function $e484c752f3f06549$var$ce(e) {
    return null !== e && "object" == typeof e && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function $e484c752f3f06549$var$le(e, t, n) {
    if (void 0 === n && (n = !1), !n && !$e484c752f3f06549$var$ce(e) && !Array.isArray(e)) return t;
    if (Array.isArray(t)) for(var o = 0; o < t.length; o++)e[o] = $e484c752f3f06549$var$le(e[o], t[o]);
    else if ($e484c752f3f06549$var$ce(t)) for(var o in t)e[o] = $e484c752f3f06549$var$le(e[o], t[o]);
    return e;
}
function $e484c752f3f06549$var$ue(e, t) {
    Object.defineProperty(e, "toString", {
        value: t
    });
}
var $e484c752f3f06549$var$pe = {};
function $e484c752f3f06549$var$de() {
    for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
    for(var n = e[0], o = [], r = 1, s = e.length; r < s; r += 1)o.push(e[r]);
    return o.forEach(function(e) {
        n = n.replace(/%[a-z]/, e);
    }), n;
}
function $e484c752f3f06549$var$he(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    return new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(t, " for more information.").concat(n.length > 0 ? " Args: ".concat(n.join(", ")) : ""));
}
var $e484c752f3f06549$var$fe = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    return e.prototype.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, e.prototype.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, o = n.length, r = o; e >= r;)if ((r <<= 1) < 0) throw $e484c752f3f06549$var$he(16, "".concat(e));
            this.groupSizes = new Uint32Array(r), this.groupSizes.set(n), this.length = r;
            for(var s = o; s < r; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = (s = 0, t.length); s < a; s++)this.tag.insertRule(i, t[s]) && (this.groupSizes[e]++, i++);
    }, e.prototype.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), o = n + t;
            this.groupSizes[e] = 0;
            for(var r = n; r < o; r++)this.tag.deleteRule(n);
        }
    }, e.prototype.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], o = this.indexOfGroup(e), r = o + n, s = o; s < r; s++)t += "".concat(this.tag.getRule(s)).concat($e484c752f3f06549$var$g);
        return t;
    }, e;
}(), $e484c752f3f06549$var$me = 1073741824, $e484c752f3f06549$var$ye = new Map, $e484c752f3f06549$var$ve = new Map, $e484c752f3f06549$var$ge = 1, $e484c752f3f06549$var$Se = function(e) {
    if ($e484c752f3f06549$var$ye.has(e)) return $e484c752f3f06549$var$ye.get(e);
    for(; $e484c752f3f06549$var$ve.has($e484c752f3f06549$var$ge);)$e484c752f3f06549$var$ge++;
    var t = $e484c752f3f06549$var$ge++;
    return $e484c752f3f06549$var$ye.set(e, t), $e484c752f3f06549$var$ve.set(t, e), t;
}, $e484c752f3f06549$var$we = function(e, t) {
    $e484c752f3f06549$var$ge = t + 1, $e484c752f3f06549$var$ye.set(e, t), $e484c752f3f06549$var$ve.set(t, e);
}, $e484c752f3f06549$var$be = "style[".concat($e484c752f3f06549$var$f, "][").concat($e484c752f3f06549$var$y, '="').concat($e484c752f3f06549$export$83d89fbfd8236492, '"]'), $e484c752f3f06549$var$Ee = new RegExp("^".concat($e484c752f3f06549$var$f, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), $e484c752f3f06549$var$Ne = function(e, t, n) {
    for(var o, r = n.split(","), s = 0, i = r.length; s < i; s++)(o = r[s]) && e.registerName(t, o);
}, $e484c752f3f06549$var$Pe = function(e, t) {
    for(var n, o = (null !== (n = t.textContent) && void 0 !== n ? n : "").split($e484c752f3f06549$var$g), r = [], s = 0, i = o.length; s < i; s++){
        var a = o[s].trim();
        if (a) {
            var c = a.match($e484c752f3f06549$var$Ee);
            if (c) {
                var l = 0 | parseInt(c[1], 10), u = c[2];
                0 !== l && ($e484c752f3f06549$var$we(u, l), $e484c752f3f06549$var$Ne(e, u, c[3]), e.getTag().insertRules(l, r)), r.length = 0;
            } else r.push(a);
        }
    }
}, $e484c752f3f06549$var$_e = function(e) {
    for(var t = document.querySelectorAll($e484c752f3f06549$var$be), n = 0, o = t.length; n < o; n++){
        var r = t[n];
        r && r.getAttribute($e484c752f3f06549$var$f) !== $e484c752f3f06549$var$m && ($e484c752f3f06549$var$Pe(e, r), r.parentNode && r.parentNode.removeChild(r));
    }
};
function $e484c752f3f06549$var$Ce() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}
var $e484c752f3f06549$var$Ie = function(e) {
    var t = document.head, n = e || t, o = document.createElement("style"), r = function(e) {
        var t = Array.from(e.querySelectorAll("style[".concat($e484c752f3f06549$var$f, "]")));
        return t[t.length - 1];
    }(n), s = void 0 !== r ? r.nextSibling : null;
    o.setAttribute($e484c752f3f06549$var$f, $e484c752f3f06549$var$m), o.setAttribute($e484c752f3f06549$var$y, $e484c752f3f06549$export$83d89fbfd8236492);
    var i = $e484c752f3f06549$var$Ce();
    return i && o.setAttribute("nonce", i), n.insertBefore(o, s), o;
}, $e484c752f3f06549$var$Ae = function() {
    function e(e) {
        this.element = $e484c752f3f06549$var$Ie(e), this.element.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, o = t.length; n < o; n++){
                var r = t[n];
                if (r.ownerNode === e) return r;
            }
            throw $e484c752f3f06549$var$he(17);
        }(this.element), this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, e.prototype.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, e.prototype.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return t && t.cssText ? t.cssText : "";
    }, e;
}(), $e484c752f3f06549$var$Oe = function() {
    function e(e) {
        this.element = $e484c752f3f06549$var$Ie(e), this.nodes = this.element.childNodes, this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t);
            return this.element.insertBefore(n, this.nodes[e] || null), this.length++, !0;
        }
        return !1;
    }, e.prototype.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $e484c752f3f06549$var$De = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, e.prototype.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $e484c752f3f06549$var$Re = $e484c752f3f06549$var$S, $e484c752f3f06549$var$Te = {
    isServer: !$e484c752f3f06549$var$S,
    useCSSOMInjection: !$e484c752f3f06549$var$w
}, $e484c752f3f06549$var$ke = function() {
    function e(e, n, o) {
        void 0 === e && (e = $e484c752f3f06549$var$C), void 0 === n && (n = {});
        var r = this;
        this.options = (0, $5606419dfe2e9b1b$export$18ce0697a983be9b)((0, $5606419dfe2e9b1b$export$18ce0697a983be9b)({}, $e484c752f3f06549$var$Te), e), this.gs = n, this.names = new Map(o), this.server = !!e.isServer, !this.server && $e484c752f3f06549$var$S && $e484c752f3f06549$var$Re && ($e484c752f3f06549$var$Re = !1, $e484c752f3f06549$var$_e(this)), $e484c752f3f06549$var$ue(this, function() {
            return function(e) {
                for(var t = e.getTag(), n = t.length, o = "", r = function(n) {
                    var r = function(e) {
                        return $e484c752f3f06549$var$ve.get(e);
                    }(n);
                    if (void 0 === r) return "continue";
                    var s = e.names.get(r), i = t.getGroup(n);
                    if (void 0 === s || !s.size || 0 === i.length) return "continue";
                    var a = "".concat($e484c752f3f06549$var$f, ".g").concat(n, '[id="').concat(r, '"]'), c = "";
                    void 0 !== s && s.forEach(function(e) {
                        e.length > 0 && (c += "".concat(e, ","));
                    }), o += "".concat(i).concat(a, '{content:"').concat(c, '"}').concat($e484c752f3f06549$var$g);
                }, s = 0; s < n; s++)r(s);
                return o;
            }(r);
        });
    }
    return e.registerId = function(e) {
        return $e484c752f3f06549$var$Se(e);
    }, e.prototype.rehydrate = function() {
        !this.server && $e484c752f3f06549$var$S && $e484c752f3f06549$var$_e(this);
    }, e.prototype.reconstructWithOptions = function(n, o) {
        return void 0 === o && (o = !0), new e((0, $5606419dfe2e9b1b$export$18ce0697a983be9b)((0, $5606419dfe2e9b1b$export$18ce0697a983be9b)({}, this.options), n), this.gs, o && this.names || void 0);
    }, e.prototype.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, e.prototype.getTag = function() {
        var e;
        return this.tag || (this.tag = (e = function(e) {
            var t = e.useCSSOMInjection, n = e.target;
            return e.isServer ? new $e484c752f3f06549$var$De(n) : t ? new $e484c752f3f06549$var$Ae(n) : new $e484c752f3f06549$var$Oe(n);
        }(this.options), new $e484c752f3f06549$var$fe(e)));
    }, e.prototype.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, e.prototype.registerName = function(e, t) {
        if ($e484c752f3f06549$var$Se(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, e.prototype.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($e484c752f3f06549$var$Se(e), n);
    }, e.prototype.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, e.prototype.clearRules = function(e) {
        this.getTag().clearGroup($e484c752f3f06549$var$Se(e)), this.clearNames(e);
    }, e.prototype.clearTag = function() {
        this.tag = void 0;
    }, e;
}(), $e484c752f3f06549$var$je = /&/g, $e484c752f3f06549$var$xe = /^\s*\/\/.*$/gm;
function $e484c752f3f06549$var$Ve(e, t) {
    return e.map(function(e) {
        return "rule" === e.type && (e.value = "".concat(t, " ").concat(e.value), e.value = e.value.replaceAll(",", ",".concat(t, " ")), e.props = e.props.map(function(e) {
            return "".concat(t, " ").concat(e);
        })), Array.isArray(e.children) && "@keyframes" !== e.type && (e.children = $e484c752f3f06549$var$Ve(e.children, t)), e;
    });
}
function $e484c752f3f06549$var$Fe(e) {
    var t, n, o, r = void 0 === e ? $e484c752f3f06549$var$C : e, s = r.options, i = void 0 === s ? $e484c752f3f06549$var$C : s, a = r.plugins, c = void 0 === a ? $e484c752f3f06549$var$_ : a, l = function(e, o, r) {
        return r.startsWith(n) && r.endsWith(n) && r.replaceAll(n, "").length > 0 ? ".".concat(t) : e;
    }, u = c.slice();
    u.push(function(e) {
        e.type === $783faa7ec18221fc$export$aa3a2e812ca8570d && e.value.includes("&") && (e.props[0] = e.props[0].replace($e484c752f3f06549$var$je, n).replace(o, l));
    }), i.prefix && u.push($783faa7ec18221fc$export$e08c7d021b829b7a), u.push($783faa7ec18221fc$export$fac44ee5b035f737);
    var p = function(e, r, s, a) {
        void 0 === r && (r = ""), void 0 === s && (s = ""), void 0 === a && (a = "&"), t = a, n = r, o = new RegExp("\\".concat(n, "\\b"), "g");
        var c = e.replace($e484c752f3f06549$var$xe, ""), l = $783faa7ec18221fc$export$ef7acd7185315e22(s || r ? "".concat(s, " ").concat(r, " { ").concat(c, " }") : c);
        i.namespace && (l = $e484c752f3f06549$var$Ve(l, i.namespace));
        var p = [];
        return $783faa7ec18221fc$export$dfdc1655ccc5b9cb(l, $783faa7ec18221fc$export$5a7767152ae0305f(u.concat($783faa7ec18221fc$export$38bcb760f1d4871c(function(e) {
            return p.push(e);
        })))), p;
    };
    return p.hash = c.length ? c.reduce(function(e, t) {
        return t.name || $e484c752f3f06549$var$he(15), $e484c752f3f06549$var$M(e, t.name);
    }, $e484c752f3f06549$var$F).toString() : "", p;
}
var $e484c752f3f06549$var$Me = new $e484c752f3f06549$var$ke, $e484c752f3f06549$var$ze = $e484c752f3f06549$var$Fe(), $e484c752f3f06549$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext({
    shouldForwardProp: void 0,
    styleSheet: $e484c752f3f06549$var$Me,
    stylis: $e484c752f3f06549$var$ze
}), $e484c752f3f06549$export$91317688fc694efa = $e484c752f3f06549$export$8c190ef828af4c86.Consumer, $e484c752f3f06549$var$Le = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext(void 0);
function $e484c752f3f06549$var$Ge() {
    return (0, $bh6RR.useContext)($e484c752f3f06549$export$8c190ef828af4c86);
}
function $e484c752f3f06549$export$a473771da2f0ff7c(e) {
    var t = (0, $bh6RR.useState)(e.stylisPlugins), n = t[0], r = t[1], c = $e484c752f3f06549$var$Ge().styleSheet, l = (0, $bh6RR.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target,
        c
    ]), u = (0, $bh6RR.useMemo)(function() {
        return $e484c752f3f06549$var$Fe({
            options: {
                namespace: e.namespace,
                prefix: e.enableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.enableVendorPrefixes,
        e.namespace,
        n
    ]);
    (0, $bh6RR.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($53a106364dbd0a1b$exports)))(n, e.stylisPlugins) || r(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]);
    var d = (0, $bh6RR.useMemo)(function() {
        return {
            shouldForwardProp: e.shouldForwardProp,
            styleSheet: l,
            stylis: u
        };
    }, [
        e.shouldForwardProp,
        l,
        u
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($e484c752f3f06549$export$8c190ef828af4c86.Provider, {
        value: d
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($e484c752f3f06549$var$Le.Provider, {
        value: u
    }, e.children));
}
var $e484c752f3f06549$var$We = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $e484c752f3f06549$var$ze);
            var o = n.name + t.hash;
            e.hasNameForId(n.id, o) || e.insertRules(n.id, o, t(n.rules, o, "@keyframes"));
        }, this.name = e, this.id = "sc-keyframes-".concat(e), this.rules = t, $e484c752f3f06549$var$ue(this, function() {
            throw $e484c752f3f06549$var$he(12, String(n.name));
        });
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $e484c752f3f06549$var$ze), this.name + e.hash;
    }, e;
}(), $e484c752f3f06549$var$qe = function(e) {
    return e >= "A" && e <= "Z";
};
function $e484c752f3f06549$var$He(e) {
    for(var t = "", n = 0; n < e.length; n++){
        var o = e[n];
        if (1 === n && "-" === o && "-" === e[0]) return e;
        $e484c752f3f06549$var$qe(o) ? t += "-" + o.toLowerCase() : t += o;
    }
    return t.startsWith("ms-") ? "-" + t : t;
}
var $e484c752f3f06549$var$Ue = function(e) {
    return null == e || !1 === e || "" === e;
}, $e484c752f3f06549$var$Je = function(t) {
    var n, o, r = [];
    for(var s in t){
        var i = t[s];
        t.hasOwnProperty(s) && !$e484c752f3f06549$var$Ue(i) && (Array.isArray(i) && i.isCss || $e484c752f3f06549$var$re(i) ? r.push("".concat($e484c752f3f06549$var$He(s), ":"), i, ";") : $e484c752f3f06549$var$ce(i) ? r.push.apply(r, (0, $5606419dfe2e9b1b$export$1216008129fb82ed)((0, $5606419dfe2e9b1b$export$1216008129fb82ed)([
            "".concat(s, " {")
        ], $e484c752f3f06549$var$Je(i), !1), [
            "}"
        ], !1)) : r.push("".concat($e484c752f3f06549$var$He(s), ": ").concat((n = s, null == (o = i) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || n in (0, $78b52bced097bc64$export$2e2bcd8739ae039) || n.startsWith("--") ? String(o).trim() : "".concat(o, "px")), ";")));
    }
    return r;
};
function $e484c752f3f06549$var$Xe(e, t, n, o) {
    if ($e484c752f3f06549$var$Ue(e)) return [];
    if ($e484c752f3f06549$export$7ba318d8d2f06c76(e)) return [
        ".".concat(e.styledComponentId)
    ];
    if ($e484c752f3f06549$var$re(e)) {
        if (!$e484c752f3f06549$var$re(s = e) || s.prototype && s.prototype.isReactComponent || !t) return [
            e
        ];
        var r = e(t);
        return $e484c752f3f06549$var$Xe(r, t, n, o);
    }
    var s;
    return e instanceof $e484c752f3f06549$var$We ? n ? (e.inject(n, o), [
        e.getName(o)
    ]) : [
        e
    ] : $e484c752f3f06549$var$ce(e) ? $e484c752f3f06549$var$Je(e) : Array.isArray(e) ? Array.prototype.concat.apply($e484c752f3f06549$var$_, e.map(function(e) {
        return $e484c752f3f06549$var$Xe(e, t, n, o);
    })) : [
        e.toString()
    ];
}
function $e484c752f3f06549$var$Ze(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($e484c752f3f06549$var$re(n) && !$e484c752f3f06549$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $e484c752f3f06549$var$Ke = $e484c752f3f06549$var$z($e484c752f3f06549$export$83d89fbfd8236492), $e484c752f3f06549$var$Qe = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $e484c752f3f06549$var$Ze(e), this.componentId = t, this.baseHash = $e484c752f3f06549$var$M($e484c752f3f06549$var$Ke, t), this.baseStyle = n, $e484c752f3f06549$var$ke.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var o = this.baseStyle ? this.baseStyle.generateAndInjectStyles(e, t, n) : "";
        if (this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(this.componentId, this.staticRulesId)) o = $e484c752f3f06549$var$ie(o, this.staticRulesId);
            else {
                var r = $e484c752f3f06549$var$ae($e484c752f3f06549$var$Xe(this.rules, e, t, n)), s = $e484c752f3f06549$var$x($e484c752f3f06549$var$M(this.baseHash, r) >>> 0);
                if (!t.hasNameForId(this.componentId, s)) {
                    var i = n(r, ".".concat(s), void 0, this.componentId);
                    t.insertRules(this.componentId, s, i);
                }
                o = $e484c752f3f06549$var$ie(o, s), this.staticRulesId = s;
            }
        } else {
            for(var a = $e484c752f3f06549$var$M(this.baseHash, n.hash), c = "", l = 0; l < this.rules.length; l++){
                var u = this.rules[l];
                if ("string" == typeof u) c += u;
                else if (u) {
                    var p = $e484c752f3f06549$var$ae($e484c752f3f06549$var$Xe(u, e, t, n));
                    a = $e484c752f3f06549$var$M(a, p + l), c += p;
                }
            }
            if (c) {
                var d = $e484c752f3f06549$var$x(a >>> 0);
                t.hasNameForId(this.componentId, d) || t.insertRules(this.componentId, d, n(c, ".".concat(d), void 0, this.componentId)), o = $e484c752f3f06549$var$ie(o, d);
            }
        }
        return o;
    }, e;
}(), $e484c752f3f06549$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext(void 0), $e484c752f3f06549$export$b631efc24e9d5e2f = $e484c752f3f06549$export$2c657da244d00bd6.Consumer;
function $e484c752f3f06549$export$93d4e7f90805808f() {
    var e = (0, $bh6RR.useContext)($e484c752f3f06549$export$2c657da244d00bd6);
    if (!e) throw $e484c752f3f06549$var$he(18);
    return e;
}
function $e484c752f3f06549$export$d8964aec282183a3(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext($e484c752f3f06549$export$2c657da244d00bd6), r = (0, $bh6RR.useMemo)(function() {
        return function(e, n) {
            if (!e) throw $e484c752f3f06549$var$he(14);
            if ($e484c752f3f06549$var$re(e)) {
                var o = e(n);
                return o;
            }
            if (Array.isArray(e) || "object" != typeof e) throw $e484c752f3f06549$var$he(8);
            return n ? (0, $5606419dfe2e9b1b$export$18ce0697a983be9b)((0, $5606419dfe2e9b1b$export$18ce0697a983be9b)({}, n), e) : e;
        }(e.theme, n);
    }, [
        e.theme,
        n
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($e484c752f3f06549$export$2c657da244d00bd6.Provider, {
        value: r
    }, e.children) : null;
}
var $e484c752f3f06549$var$rt = {}, $e484c752f3f06549$var$st = new Set;
function $e484c752f3f06549$var$it(e, r, s) {
    var i = $e484c752f3f06549$export$7ba318d8d2f06c76(e), a = e, c = !$e484c752f3f06549$var$L(e), p = r.attrs, d = void 0 === p ? $e484c752f3f06549$var$_ : p, h = r.componentId, f = void 0 === h ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $e484c752f3f06549$var$R(e);
        $e484c752f3f06549$var$rt[n] = ($e484c752f3f06549$var$rt[n] || 0) + 1;
        var o = "".concat(n, "-").concat($e484c752f3f06549$var$$($e484c752f3f06549$export$83d89fbfd8236492 + n + $e484c752f3f06549$var$rt[n]));
        return t ? "".concat(t, "-").concat(o) : o;
    }(r.displayName, r.parentComponentId) : h, m = r.displayName, y = void 0 === m ? function(e) {
        return $e484c752f3f06549$var$L(e) ? "styled.".concat(e) : "Styled(".concat($e484c752f3f06549$var$B(e), ")");
    }(e) : m, g = r.displayName && r.componentId ? "".concat($e484c752f3f06549$var$R(r.displayName), "-").concat(r.componentId) : r.componentId || f, S = i && a.attrs ? a.attrs.concat(d).filter(Boolean) : d, w = r.shouldForwardProp;
    if (i && a.shouldForwardProp) {
        var b = a.shouldForwardProp;
        if (r.shouldForwardProp) {
            var E = r.shouldForwardProp;
            w = function(e, t) {
                return b(e, t) && E(e, t);
            };
        } else w = b;
    }
    var N = new $e484c752f3f06549$var$Qe(s, g, i ? a.componentStyle : void 0);
    function O(e, r) {
        return function(e, r, s) {
            var i = e.attrs, a = e.componentStyle, c = e.defaultProps, p = e.foldedComponentIds, d = e.styledComponentId, h = e.target, f = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext($e484c752f3f06549$export$2c657da244d00bd6), m = $e484c752f3f06549$var$Ge(), y = e.shouldForwardProp || m.shouldForwardProp;
            var v = $e484c752f3f06549$var$I(r, f, c) || $e484c752f3f06549$var$C, g = function(e, n, o) {
                for(var r, s = (0, $5606419dfe2e9b1b$export$18ce0697a983be9b)((0, $5606419dfe2e9b1b$export$18ce0697a983be9b)({}, n), {
                    className: void 0,
                    theme: o
                }), i = 0; i < e.length; i += 1){
                    var a = $e484c752f3f06549$var$re(r = e[i]) ? r(s) : r;
                    for(var c in a)s[c] = "className" === c ? $e484c752f3f06549$var$ie(s[c], a[c]) : "style" === c ? (0, $5606419dfe2e9b1b$export$18ce0697a983be9b)((0, $5606419dfe2e9b1b$export$18ce0697a983be9b)({}, s[c]), a[c]) : a[c];
                }
                return n.className && (s.className = $e484c752f3f06549$var$ie(s.className, n.className)), s;
            }(i, r, v), S = g.as || h, w = {};
            for(var b in g)void 0 === g[b] || "$" === b[0] || "as" === b || "theme" === b && g.theme === v || ("forwardedAs" === b ? w.as = g.forwardedAs : y && !y(b, S) || (w[b] = g[b], y));
            var E = function(e, t) {
                var n = $e484c752f3f06549$var$Ge(), o = e.generateAndInjectStyles(t, n.styleSheet, n.stylis);
                return o;
            }(a, g);
            var N = $e484c752f3f06549$var$ie(p, d);
            return E && (N += " " + E), g.className && (N += " " + g.className), w[$e484c752f3f06549$var$L(S) && !$e484c752f3f06549$var$A.has(S) ? "class" : "className"] = N, w.ref = s, (0, $bh6RR.createElement)(S, w);
        }(D, e, r);
    }
    O.displayName = y;
    var D = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef(O);
    return D.attrs = S, D.componentStyle = N, D.displayName = y, D.shouldForwardProp = w, D.foldedComponentIds = i ? $e484c752f3f06549$var$ie(a.foldedComponentIds, a.styledComponentId) : "", D.styledComponentId = g, D.target = i ? a.target : e, Object.defineProperty(D, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(e) {
            this._foldedDefaultProps = i ? function(e) {
                for(var t = [], n = 1; n < arguments.length; n++)t[n - 1] = arguments[n];
                for(var o = 0, r = t; o < r.length; o++)$e484c752f3f06549$var$le(e, r[o], !0);
                return e;
            }({}, a.defaultProps, e) : e;
        }
    }), $e484c752f3f06549$var$ue(D, function() {
        return ".".concat(D.styledComponentId);
    }), c && $e484c752f3f06549$var$oe(D, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0
    }), D;
}
function $e484c752f3f06549$var$at(e, t) {
    for(var n = [
        e[0]
    ], o = 0, r = t.length; o < r; o += 1)n.push(t[o], e[o + 1]);
    return n;
}
var $e484c752f3f06549$var$ct = function(e) {
    return Object.assign(e, {
        isCss: !0
    });
};
function $e484c752f3f06549$export$dbf350e5966cf602(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    if ($e484c752f3f06549$var$re(t) || $e484c752f3f06549$var$ce(t)) return $e484c752f3f06549$var$ct($e484c752f3f06549$var$Xe($e484c752f3f06549$var$at($e484c752f3f06549$var$_, (0, $5606419dfe2e9b1b$export$1216008129fb82ed)([
        t
    ], n, !0))));
    var r = t;
    return 0 === n.length && 1 === r.length && "string" == typeof r[0] ? $e484c752f3f06549$var$Xe(r) : $e484c752f3f06549$var$ct($e484c752f3f06549$var$Xe($e484c752f3f06549$var$at(r, n)));
}
function $e484c752f3f06549$var$ut(n, o, r) {
    if (void 0 === r && (r = $e484c752f3f06549$var$C), !o) throw $e484c752f3f06549$var$he(1, o);
    var s = function(t) {
        for(var s = [], i = 1; i < arguments.length; i++)s[i - 1] = arguments[i];
        return n(o, r, $e484c752f3f06549$export$dbf350e5966cf602.apply(void 0, (0, $5606419dfe2e9b1b$export$1216008129fb82ed)([
            t
        ], s, !1)));
    };
    return s.attrs = function(e) {
        return $e484c752f3f06549$var$ut(n, o, (0, $5606419dfe2e9b1b$export$18ce0697a983be9b)((0, $5606419dfe2e9b1b$export$18ce0697a983be9b)({}, r), {
            attrs: Array.prototype.concat(r.attrs, e).filter(Boolean)
        }));
    }, s.withConfig = function(e) {
        return $e484c752f3f06549$var$ut(n, o, (0, $5606419dfe2e9b1b$export$18ce0697a983be9b)((0, $5606419dfe2e9b1b$export$18ce0697a983be9b)({}, r), e));
    }, s;
}
var $e484c752f3f06549$var$pt = function(e) {
    return $e484c752f3f06549$var$ut($e484c752f3f06549$var$it, e);
}, $e484c752f3f06549$export$2e2bcd8739ae039 = $e484c752f3f06549$var$pt;
$e484c752f3f06549$var$A.forEach(function(e) {
    $e484c752f3f06549$export$2e2bcd8739ae039[e] = $e484c752f3f06549$var$pt(e);
});
var $e484c752f3f06549$var$ht = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $e484c752f3f06549$var$Ze(e), $e484c752f3f06549$var$ke.registerId(this.componentId + 1);
    }
    return e.prototype.createStyles = function(e, t, n, o) {
        var r = o($e484c752f3f06549$var$ae($e484c752f3f06549$var$Xe(this.rules, t, n, o)), ""), s = this.componentId + e;
        n.insertRules(s, s, r);
    }, e.prototype.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, e.prototype.renderStyles = function(e, t, n, o) {
        e > 2 && $e484c752f3f06549$var$ke.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, o);
    }, e;
}();
function $e484c752f3f06549$export$f0f03736edb61697(n) {
    for(var r = [], s = 1; s < arguments.length; s++)r[s - 1] = arguments[s];
    var i = $e484c752f3f06549$export$dbf350e5966cf602.apply(void 0, (0, $5606419dfe2e9b1b$export$1216008129fb82ed)([
        n
    ], r, !1)), a = "sc-global-".concat($e484c752f3f06549$var$$(JSON.stringify(i))), c = new $e484c752f3f06549$var$ht(i, a);
    var l = function(e) {
        var t = $e484c752f3f06549$var$Ge(), n = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext($e484c752f3f06549$export$2c657da244d00bd6), r = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(t.styleSheet.allocateGSInstance(a)).current;
        return t.styleSheet.server && u(r, e, t.styleSheet, n, t.stylis), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useLayoutEffect(function() {
            if (!t.styleSheet.server) return u(r, e, t.styleSheet, n, t.stylis), function() {
                return c.removeStyles(r, t.styleSheet);
            };
        }, [
            r,
            e,
            t.styleSheet,
            n,
            t.stylis
        ]), null;
    };
    function u(e, n, o, r, s) {
        if (c.isStatic) c.renderStyles(e, $e484c752f3f06549$var$b, o, s);
        else {
            var i = (0, $5606419dfe2e9b1b$export$18ce0697a983be9b)((0, $5606419dfe2e9b1b$export$18ce0697a983be9b)({}, n), {
                theme: $e484c752f3f06549$var$I(n, r, l.defaultProps)
            });
            c.renderStyles(e, i, o, s);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).memo(l);
}
function $e484c752f3f06549$export$d25ddfdf17c3ad3e(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    var r = $e484c752f3f06549$var$ae($e484c752f3f06549$export$dbf350e5966cf602.apply(void 0, (0, $5606419dfe2e9b1b$export$1216008129fb82ed)([
        t
    ], n, !1))), s = $e484c752f3f06549$var$$(r);
    return new $e484c752f3f06549$var$We(s, r);
}
function $e484c752f3f06549$export$e8748c6a27b910dc(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef(function(n, r) {
        var s = $e484c752f3f06549$var$I(n, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext($e484c752f3f06549$export$2c657da244d00bd6), e.defaultProps);
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(e, (0, $5606419dfe2e9b1b$export$18ce0697a983be9b)({}, n, {
            theme: s,
            ref: r
        }));
    });
    return n.displayName = "WithTheme(".concat($e484c752f3f06549$var$B(e), ")"), $e484c752f3f06549$var$oe(n, e);
}
var $e484c752f3f06549$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString();
            if (!t) return "";
            var n = $e484c752f3f06549$var$Ce(), o = $e484c752f3f06549$var$ae([
                n && 'nonce="'.concat(n, '"'),
                "".concat($e484c752f3f06549$var$f, '="true"'),
                "".concat($e484c752f3f06549$var$y, '="').concat($e484c752f3f06549$export$83d89fbfd8236492, '"')
            ].filter(Boolean), " ");
            return "<style ".concat(o, ">").concat(t, "</style>");
        }, this.getStyleTags = function() {
            if (e.sealed) throw $e484c752f3f06549$var$he(2);
            return e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var n;
            if (e.sealed) throw $e484c752f3f06549$var$he(2);
            var r = e.instance.toString();
            if (!r) return [];
            var s = ((n = {})[$e484c752f3f06549$var$f] = "", n[$e484c752f3f06549$var$y] = $e484c752f3f06549$export$83d89fbfd8236492, n.dangerouslySetInnerHTML = {
                __html: r
            }, n), i = $e484c752f3f06549$var$Ce();
            return i && (s.nonce = i), [
                (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("style", (0, $5606419dfe2e9b1b$export$18ce0697a983be9b)({}, s, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $e484c752f3f06549$var$ke({
            isServer: !0
        }), this.sealed = !1;
    }
    return e.prototype.collectStyles = function(e) {
        if (this.sealed) throw $e484c752f3f06549$var$he(2);
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($e484c752f3f06549$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, e.prototype.interleaveWithNodeStream = function(e) {
        throw $e484c752f3f06549$var$he(3);
    }, e;
}(), $e484c752f3f06549$export$5c87cfe6c475f500 = {
    StyleSheet: $e484c752f3f06549$var$ke,
    mainSheet: $e484c752f3f06549$var$Me
};
var $e484c752f3f06549$var$St = "__sc-".concat($e484c752f3f06549$var$f, "__");


/**
 * @license
 * Copyright (c) 2023, Jeff Hlywa (jhlywa@gmail.com)
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice,
 *    this list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
 * ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
 * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
 * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
 * CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 * ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */ const $e1e1f1f3cd154daa$export$29814851e0aa981f = "w";
const $e1e1f1f3cd154daa$export$7a91b0fde7ec420f = "b";
const $e1e1f1f3cd154daa$export$4c32fd1f222ff2b0 = "p";
const $e1e1f1f3cd154daa$export$ce32bc8c2a29bae6 = "n";
const $e1e1f1f3cd154daa$export$54a167f801c5dba3 = "b";
const $e1e1f1f3cd154daa$export$68d4c913908dc245 = "r";
const $e1e1f1f3cd154daa$export$36a8946792f13ec9 = "q";
const $e1e1f1f3cd154daa$export$42387107bb0d6206 = "k";
const $e1e1f1f3cd154daa$export$1264a6620073cfaa = "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1";
const $e1e1f1f3cd154daa$var$EMPTY = -1;
const $e1e1f1f3cd154daa$var$FLAGS = {
    NORMAL: "n",
    CAPTURE: "c",
    BIG_PAWN: "b",
    EP_CAPTURE: "e",
    PROMOTION: "p",
    KSIDE_CASTLE: "k",
    QSIDE_CASTLE: "q"
};
const $e1e1f1f3cd154daa$export$5fc67852ab417150 = [
    "a8",
    "b8",
    "c8",
    "d8",
    "e8",
    "f8",
    "g8",
    "h8",
    "a7",
    "b7",
    "c7",
    "d7",
    "e7",
    "f7",
    "g7",
    "h7",
    "a6",
    "b6",
    "c6",
    "d6",
    "e6",
    "f6",
    "g6",
    "h6",
    "a5",
    "b5",
    "c5",
    "d5",
    "e5",
    "f5",
    "g5",
    "h5",
    "a4",
    "b4",
    "c4",
    "d4",
    "e4",
    "f4",
    "g4",
    "h4",
    "a3",
    "b3",
    "c3",
    "d3",
    "e3",
    "f3",
    "g3",
    "h3",
    "a2",
    "b2",
    "c2",
    "d2",
    "e2",
    "f2",
    "g2",
    "h2",
    "a1",
    "b1",
    "c1",
    "d1",
    "e1",
    "f1",
    "g1",
    "h1"
];
const $e1e1f1f3cd154daa$var$BITS = {
    NORMAL: 1,
    CAPTURE: 2,
    BIG_PAWN: 4,
    EP_CAPTURE: 8,
    PROMOTION: 16,
    KSIDE_CASTLE: 32,
    QSIDE_CASTLE: 64
};
/*
 * NOTES ABOUT 0x88 MOVE GENERATION ALGORITHM
 * ----------------------------------------------------------------------------
 * From https://github.com/jhlywa/chess.js/issues/230
 *
 * A lot of people are confused when they first see the internal representation
 * of chess.js. It uses the 0x88 Move Generation Algorithm which internally
 * stores the board as an 8x16 array. This is purely for efficiency but has a
 * couple of interesting benefits:
 *
 * 1. 0x88 offers a very inexpensive "off the board" check. Bitwise AND (&) any
 *    square with 0x88, if the result is non-zero then the square is off the
 *    board. For example, assuming a knight square A8 (0 in 0x88 notation),
 *    there are 8 possible directions in which the knight can move. These
 *    directions are relative to the 8x16 board and are stored in the
 *    PIECE_OFFSETS map. One possible move is A8 - 18 (up one square, and two
 *    squares to the left - which is off the board). 0 - 18 = -18 & 0x88 = 0x88
 *    (because of two-complement representation of -18). The non-zero result
 *    means the square is off the board and the move is illegal. Take the
 *    opposite move (from A8 to C7), 0 + 18 = 18 & 0x88 = 0. A result of zero
 *    means the square is on the board.
 *
 * 2. The relative distance (or difference) between two squares on a 8x16 board
 *    is unique and can be used to inexpensively determine if a piece on a
 *    square can attack any other arbitrary square. For example, let's see if a
 *    pawn on E7 can attack E2. The difference between E7 (20) - E2 (100) is
 *    -80. We add 119 to make the ATTACKS array index non-negative (because the
 *    worst case difference is A8 - H1 = -119). The ATTACKS array contains a
 *    bitmask of pieces that can attack from that distance and direction.
 *    ATTACKS[-80 + 119=39] gives us 24 or 0b11000 in binary. Look at the
 *    PIECE_MASKS map to determine the mask for a given piece type. In our pawn
 *    example, we would check to see if 24 & 0x1 is non-zero, which it is
 *    not. So, naturally, a pawn on E7 can't attack a piece on E2. However, a
 *    rook can since 24 & 0x8 is non-zero. The only thing left to check is that
 *    there are no blocking pieces between E7 and E2. That's where the RAYS
 *    array comes in. It provides an offset (in this case 16) to add to E7 (20)
 *    to check for blocking pieces. E7 (20) + 16 = E6 (36) + 16 = E5 (52) etc.
 */ // prettier-ignore
// eslint-disable-next-line
const $e1e1f1f3cd154daa$var$Ox88 = {
    a8: 0,
    b8: 1,
    c8: 2,
    d8: 3,
    e8: 4,
    f8: 5,
    g8: 6,
    h8: 7,
    a7: 16,
    b7: 17,
    c7: 18,
    d7: 19,
    e7: 20,
    f7: 21,
    g7: 22,
    h7: 23,
    a6: 32,
    b6: 33,
    c6: 34,
    d6: 35,
    e6: 36,
    f6: 37,
    g6: 38,
    h6: 39,
    a5: 48,
    b5: 49,
    c5: 50,
    d5: 51,
    e5: 52,
    f5: 53,
    g5: 54,
    h5: 55,
    a4: 64,
    b4: 65,
    c4: 66,
    d4: 67,
    e4: 68,
    f4: 69,
    g4: 70,
    h4: 71,
    a3: 80,
    b3: 81,
    c3: 82,
    d3: 83,
    e3: 84,
    f3: 85,
    g3: 86,
    h3: 87,
    a2: 96,
    b2: 97,
    c2: 98,
    d2: 99,
    e2: 100,
    f2: 101,
    g2: 102,
    h2: 103,
    a1: 112,
    b1: 113,
    c1: 114,
    d1: 115,
    e1: 116,
    f1: 117,
    g1: 118,
    h1: 119
};
const $e1e1f1f3cd154daa$var$PAWN_OFFSETS = {
    b: [
        16,
        32,
        17,
        15
    ],
    w: [
        -16,
        -32,
        -17,
        -15
    ]
};
const $e1e1f1f3cd154daa$var$PIECE_OFFSETS = {
    n: [
        -18,
        -33,
        -31,
        -14,
        18,
        33,
        31,
        14
    ],
    b: [
        -17,
        -15,
        17,
        15
    ],
    r: [
        -16,
        1,
        16,
        -1
    ],
    q: [
        -17,
        -16,
        -15,
        1,
        17,
        16,
        15,
        -1
    ],
    k: [
        -17,
        -16,
        -15,
        1,
        17,
        16,
        15,
        -1
    ]
};
// prettier-ignore
const $e1e1f1f3cd154daa$var$ATTACKS = [
    20,
    0,
    0,
    0,
    0,
    0,
    0,
    24,
    0,
    0,
    0,
    0,
    0,
    0,
    20,
    0,
    0,
    20,
    0,
    0,
    0,
    0,
    0,
    24,
    0,
    0,
    0,
    0,
    0,
    20,
    0,
    0,
    0,
    0,
    20,
    0,
    0,
    0,
    0,
    24,
    0,
    0,
    0,
    0,
    20,
    0,
    0,
    0,
    0,
    0,
    0,
    20,
    0,
    0,
    0,
    24,
    0,
    0,
    0,
    20,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    20,
    0,
    0,
    24,
    0,
    0,
    20,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    20,
    2,
    24,
    2,
    20,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    53,
    56,
    53,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    24,
    24,
    24,
    24,
    24,
    24,
    56,
    0,
    56,
    24,
    24,
    24,
    24,
    24,
    24,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    53,
    56,
    53,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    20,
    2,
    24,
    2,
    20,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    20,
    0,
    0,
    24,
    0,
    0,
    20,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    20,
    0,
    0,
    0,
    24,
    0,
    0,
    0,
    20,
    0,
    0,
    0,
    0,
    0,
    0,
    20,
    0,
    0,
    0,
    0,
    24,
    0,
    0,
    0,
    0,
    20,
    0,
    0,
    0,
    0,
    20,
    0,
    0,
    0,
    0,
    0,
    24,
    0,
    0,
    0,
    0,
    0,
    20,
    0,
    0,
    20,
    0,
    0,
    0,
    0,
    0,
    0,
    24,
    0,
    0,
    0,
    0,
    0,
    0,
    20
];
// prettier-ignore
const $e1e1f1f3cd154daa$var$RAYS = [
    17,
    0,
    0,
    0,
    0,
    0,
    0,
    16,
    0,
    0,
    0,
    0,
    0,
    0,
    15,
    0,
    0,
    17,
    0,
    0,
    0,
    0,
    0,
    16,
    0,
    0,
    0,
    0,
    0,
    15,
    0,
    0,
    0,
    0,
    17,
    0,
    0,
    0,
    0,
    16,
    0,
    0,
    0,
    0,
    15,
    0,
    0,
    0,
    0,
    0,
    0,
    17,
    0,
    0,
    0,
    16,
    0,
    0,
    0,
    15,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    17,
    0,
    0,
    16,
    0,
    0,
    15,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    17,
    0,
    16,
    0,
    15,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    17,
    16,
    15,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -15,
    -16,
    -17,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -15,
    0,
    -16,
    0,
    -17,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -15,
    0,
    0,
    -16,
    0,
    0,
    -17,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -15,
    0,
    0,
    0,
    -16,
    0,
    0,
    0,
    -17,
    0,
    0,
    0,
    0,
    0,
    0,
    -15,
    0,
    0,
    0,
    0,
    -16,
    0,
    0,
    0,
    0,
    -17,
    0,
    0,
    0,
    0,
    -15,
    0,
    0,
    0,
    0,
    0,
    -16,
    0,
    0,
    0,
    0,
    0,
    -17,
    0,
    0,
    -15,
    0,
    0,
    0,
    0,
    0,
    0,
    -16,
    0,
    0,
    0,
    0,
    0,
    0,
    -17
];
const $e1e1f1f3cd154daa$var$PIECE_MASKS = {
    p: 0x1,
    n: 0x2,
    b: 0x4,
    r: 0x8,
    q: 0x10,
    k: 0x20
};
const $e1e1f1f3cd154daa$var$SYMBOLS = "pnbrqkPNBRQK";
const $e1e1f1f3cd154daa$var$PROMOTIONS = [
    $e1e1f1f3cd154daa$export$ce32bc8c2a29bae6,
    $e1e1f1f3cd154daa$export$54a167f801c5dba3,
    $e1e1f1f3cd154daa$export$68d4c913908dc245,
    $e1e1f1f3cd154daa$export$36a8946792f13ec9
];
const $e1e1f1f3cd154daa$var$RANK_1 = 7;
const $e1e1f1f3cd154daa$var$RANK_2 = 6;
/*
 * const RANK_3 = 5
 * const RANK_4 = 4
 * const RANK_5 = 3
 * const RANK_6 = 2
 */ const $e1e1f1f3cd154daa$var$RANK_7 = 1;
const $e1e1f1f3cd154daa$var$RANK_8 = 0;
const $e1e1f1f3cd154daa$var$SIDES = {
    [$e1e1f1f3cd154daa$export$42387107bb0d6206]: $e1e1f1f3cd154daa$var$BITS.KSIDE_CASTLE,
    [$e1e1f1f3cd154daa$export$36a8946792f13ec9]: $e1e1f1f3cd154daa$var$BITS.QSIDE_CASTLE
};
const $e1e1f1f3cd154daa$var$ROOKS = {
    w: [
        {
            square: $e1e1f1f3cd154daa$var$Ox88.a1,
            flag: $e1e1f1f3cd154daa$var$BITS.QSIDE_CASTLE
        },
        {
            square: $e1e1f1f3cd154daa$var$Ox88.h1,
            flag: $e1e1f1f3cd154daa$var$BITS.KSIDE_CASTLE
        }
    ],
    b: [
        {
            square: $e1e1f1f3cd154daa$var$Ox88.a8,
            flag: $e1e1f1f3cd154daa$var$BITS.QSIDE_CASTLE
        },
        {
            square: $e1e1f1f3cd154daa$var$Ox88.h8,
            flag: $e1e1f1f3cd154daa$var$BITS.KSIDE_CASTLE
        }
    ]
};
const $e1e1f1f3cd154daa$var$SECOND_RANK = {
    b: $e1e1f1f3cd154daa$var$RANK_7,
    w: $e1e1f1f3cd154daa$var$RANK_2
};
const $e1e1f1f3cd154daa$var$TERMINATION_MARKERS = [
    "1-0",
    "0-1",
    "1/2-1/2",
    "*"
];
// Extracts the zero-based rank of an 0x88 square.
function $e1e1f1f3cd154daa$var$rank(square) {
    return square >> 4;
}
// Extracts the zero-based file of an 0x88 square.
function $e1e1f1f3cd154daa$var$file(square) {
    return square & 0xf;
}
function $e1e1f1f3cd154daa$var$isDigit(c) {
    return "0123456789".indexOf(c) !== -1;
}
// Converts a 0x88 square to algebraic notation.
function $e1e1f1f3cd154daa$var$algebraic(square) {
    const f = $e1e1f1f3cd154daa$var$file(square);
    const r = $e1e1f1f3cd154daa$var$rank(square);
    return "abcdefgh".substring(f, f + 1) + "87654321".substring(r, r + 1);
}
function $e1e1f1f3cd154daa$var$swapColor(color) {
    return color === $e1e1f1f3cd154daa$export$29814851e0aa981f ? $e1e1f1f3cd154daa$export$7a91b0fde7ec420f : $e1e1f1f3cd154daa$export$29814851e0aa981f;
}
function $e1e1f1f3cd154daa$export$d9e02ca3a6185312(fen) {
    // 1st criterion: 6 space-seperated fields?
    const tokens = fen.split(/\s+/);
    if (tokens.length !== 6) return {
        ok: false,
        error: "Invalid FEN: must contain six space-delimited fields"
    };
    // 2nd criterion: move number field is a integer value > 0?
    const moveNumber = parseInt(tokens[5], 10);
    if (isNaN(moveNumber) || moveNumber <= 0) return {
        ok: false,
        error: "Invalid FEN: move number must be a positive integer"
    };
    // 3rd criterion: half move counter is an integer >= 0?
    const halfMoves = parseInt(tokens[4], 10);
    if (isNaN(halfMoves) || halfMoves < 0) return {
        ok: false,
        error: "Invalid FEN: half move counter number must be a non-negative integer"
    };
    // 4th criterion: 4th field is a valid e.p.-string?
    if (!/^(-|[abcdefgh][36])$/.test(tokens[3])) return {
        ok: false,
        error: "Invalid FEN: en-passant square is invalid"
    };
    // 5th criterion: 3th field is a valid castle-string?
    if (/[^kKqQ-]/.test(tokens[2])) return {
        ok: false,
        error: "Invalid FEN: castling availability is invalid"
    };
    // 6th criterion: 2nd field is "w" (white) or "b" (black)?
    if (!/^(w|b)$/.test(tokens[1])) return {
        ok: false,
        error: "Invalid FEN: side-to-move is invalid"
    };
    // 7th criterion: 1st field contains 8 rows?
    const rows = tokens[0].split("/");
    if (rows.length !== 8) return {
        ok: false,
        error: "Invalid FEN: piece data does not contain 8 '/'-delimited rows"
    };
    // 8th criterion: every row is valid?
    for(let i = 0; i < rows.length; i++){
        // check for right sum of fields AND not two numbers in succession
        let sumFields = 0;
        let previousWasNumber = false;
        for(let k = 0; k < rows[i].length; k++)if ($e1e1f1f3cd154daa$var$isDigit(rows[i][k])) {
            if (previousWasNumber) return {
                ok: false,
                error: "Invalid FEN: piece data is invalid (consecutive number)"
            };
            sumFields += parseInt(rows[i][k], 10);
            previousWasNumber = true;
        } else {
            if (!/^[prnbqkPRNBQK]$/.test(rows[i][k])) return {
                ok: false,
                error: "Invalid FEN: piece data is invalid (invalid piece)"
            };
            sumFields += 1;
            previousWasNumber = false;
        }
        if (sumFields !== 8) return {
            ok: false,
            error: "Invalid FEN: piece data is invalid (too many squares in rank)"
        };
    }
    // 9th criterion: is en-passant square legal?
    if (tokens[3][1] == "3" && tokens[1] == "w" || tokens[3][1] == "6" && tokens[1] == "b") return {
        ok: false,
        error: "Invalid FEN: illegal en-passant square"
    };
    // 10th criterion: does chess position contain exact two kings?
    const kings = [
        {
            color: "white",
            regex: /K/g
        },
        {
            color: "black",
            regex: /k/g
        }
    ];
    for (const { color: color , regex: regex  } of kings){
        if (!regex.test(tokens[0])) return {
            ok: false,
            error: `Invalid FEN: missing ${color} king`
        };
        if ((tokens[0].match(regex) || []).length > 1) return {
            ok: false,
            error: `Invalid FEN: too many ${color} kings`
        };
    }
    // 11th criterion: are any pawns on the first or eighth rows?
    if (Array.from(rows[0] + rows[7]).some((char)=>char.toUpperCase() === "P")) return {
        ok: false,
        error: "Invalid FEN: some pawns are on the edge rows"
    };
    return {
        ok: true
    };
}
// this function is used to uniquely identify ambiguous moves
function $e1e1f1f3cd154daa$var$getDisambiguator(move, moves) {
    const from = move.from;
    const to = move.to;
    const piece = move.piece;
    let ambiguities = 0;
    let sameRank = 0;
    let sameFile = 0;
    for(let i = 0, len = moves.length; i < len; i++){
        const ambigFrom = moves[i].from;
        const ambigTo = moves[i].to;
        const ambigPiece = moves[i].piece;
        /*
         * if a move of the same piece type ends on the same to square, we'll need
         * to add a disambiguator to the algebraic notation
         */ if (piece === ambigPiece && from !== ambigFrom && to === ambigTo) {
            ambiguities++;
            if ($e1e1f1f3cd154daa$var$rank(from) === $e1e1f1f3cd154daa$var$rank(ambigFrom)) sameRank++;
            if ($e1e1f1f3cd154daa$var$file(from) === $e1e1f1f3cd154daa$var$file(ambigFrom)) sameFile++;
        }
    }
    if (ambiguities > 0) {
        if (sameRank > 0 && sameFile > 0) /*
             * if there exists a similar moving piece on the same rank and file as
             * the move in question, use the square as the disambiguator
             */ return $e1e1f1f3cd154daa$var$algebraic(from);
        else if (sameFile > 0) /*
             * if the moving piece rests on the same file, use the rank symbol as the
             * disambiguator
             */ return $e1e1f1f3cd154daa$var$algebraic(from).charAt(1);
        else // else use the file symbol
        return $e1e1f1f3cd154daa$var$algebraic(from).charAt(0);
    }
    return "";
}
function $e1e1f1f3cd154daa$var$addMove(moves, color, from, to, piece, captured, flags = $e1e1f1f3cd154daa$var$BITS.NORMAL) {
    const r = $e1e1f1f3cd154daa$var$rank(to);
    if (piece === $e1e1f1f3cd154daa$export$4c32fd1f222ff2b0 && (r === $e1e1f1f3cd154daa$var$RANK_1 || r === $e1e1f1f3cd154daa$var$RANK_8)) for(let i = 0; i < $e1e1f1f3cd154daa$var$PROMOTIONS.length; i++){
        const promotion = $e1e1f1f3cd154daa$var$PROMOTIONS[i];
        moves.push({
            color: color,
            from: from,
            to: to,
            piece: piece,
            captured: captured,
            promotion: promotion,
            flags: flags | $e1e1f1f3cd154daa$var$BITS.PROMOTION
        });
    }
    else moves.push({
        color: color,
        from: from,
        to: to,
        piece: piece,
        captured: captured,
        flags: flags
    });
}
function $e1e1f1f3cd154daa$var$inferPieceType(san) {
    let pieceType = san.charAt(0);
    if (pieceType >= "a" && pieceType <= "h") {
        const matches = san.match(/[a-h]\d.*[a-h]\d/);
        if (matches) return undefined;
        return $e1e1f1f3cd154daa$export$4c32fd1f222ff2b0;
    }
    pieceType = pieceType.toLowerCase();
    if (pieceType === "o") return $e1e1f1f3cd154daa$export$42387107bb0d6206;
    return pieceType;
}
// parses all of the decorators out of a SAN string
function $e1e1f1f3cd154daa$var$strippedSan(move) {
    return move.replace(/=/, "").replace(/[+#]?[?!]*$/, "");
}
function $e1e1f1f3cd154daa$var$trimFen(fen) {
    /*
     * remove last two fields in FEN string as they're not needed when checking
     * for repetition
     */ return fen.split(" ").slice(0, 4).join(" ");
}
class $e1e1f1f3cd154daa$export$a4d6ea685c300d39 {
    _board = new Array(128);
    _turn = $e1e1f1f3cd154daa$export$29814851e0aa981f;
    _header = {};
    _kings = {
        w: $e1e1f1f3cd154daa$var$EMPTY,
        b: $e1e1f1f3cd154daa$var$EMPTY
    };
    _epSquare = -1;
    _halfMoves = 0;
    _moveNumber = 0;
    _history = [];
    _comments = {};
    _castling = {
        w: 0,
        b: 0
    };
    // tracks number of times a position has been seen for repetition checking
    _positionCount = {};
    constructor(fen = $e1e1f1f3cd154daa$export$1264a6620073cfaa){
        this.load(fen);
    }
    clear({ preserveHeaders: preserveHeaders = false  } = {}) {
        this._board = new Array(128);
        this._kings = {
            w: $e1e1f1f3cd154daa$var$EMPTY,
            b: $e1e1f1f3cd154daa$var$EMPTY
        };
        this._turn = $e1e1f1f3cd154daa$export$29814851e0aa981f;
        this._castling = {
            w: 0,
            b: 0
        };
        this._epSquare = $e1e1f1f3cd154daa$var$EMPTY;
        this._halfMoves = 0;
        this._moveNumber = 1;
        this._history = [];
        this._comments = {};
        this._header = preserveHeaders ? this._header : {};
        this._positionCount = {};
        /*
         * Delete the SetUp and FEN headers (if preserved), the board is empty and
         * these headers don't make sense in this state. They'll get added later
         * via .load() or .put()
         */ delete this._header["SetUp"];
        delete this._header["FEN"];
    }
    removeHeader(key) {
        if (key in this._header) delete this._header[key];
    }
    load(fen, { skipValidation: skipValidation = false , preserveHeaders: preserveHeaders = false  } = {}) {
        let tokens = fen.split(/\s+/);
        // append commonly omitted fen tokens
        if (tokens.length >= 2 && tokens.length < 6) {
            const adjustments = [
                "-",
                "-",
                "0",
                "1"
            ];
            fen = tokens.concat(adjustments.slice(-(6 - tokens.length))).join(" ");
        }
        tokens = fen.split(/\s+/);
        if (!skipValidation) {
            const { ok: ok , error: error  } = $e1e1f1f3cd154daa$export$d9e02ca3a6185312(fen);
            if (!ok) throw new Error(error);
        }
        const position = tokens[0];
        let square = 0;
        this.clear({
            preserveHeaders: preserveHeaders
        });
        for(let i = 0; i < position.length; i++){
            const piece = position.charAt(i);
            if (piece === "/") square += 8;
            else if ($e1e1f1f3cd154daa$var$isDigit(piece)) square += parseInt(piece, 10);
            else {
                const color = piece < "a" ? $e1e1f1f3cd154daa$export$29814851e0aa981f : $e1e1f1f3cd154daa$export$7a91b0fde7ec420f;
                this._put({
                    type: piece.toLowerCase(),
                    color: color
                }, $e1e1f1f3cd154daa$var$algebraic(square));
                square++;
            }
        }
        this._turn = tokens[1];
        if (tokens[2].indexOf("K") > -1) this._castling.w |= $e1e1f1f3cd154daa$var$BITS.KSIDE_CASTLE;
        if (tokens[2].indexOf("Q") > -1) this._castling.w |= $e1e1f1f3cd154daa$var$BITS.QSIDE_CASTLE;
        if (tokens[2].indexOf("k") > -1) this._castling.b |= $e1e1f1f3cd154daa$var$BITS.KSIDE_CASTLE;
        if (tokens[2].indexOf("q") > -1) this._castling.b |= $e1e1f1f3cd154daa$var$BITS.QSIDE_CASTLE;
        this._epSquare = tokens[3] === "-" ? $e1e1f1f3cd154daa$var$EMPTY : $e1e1f1f3cd154daa$var$Ox88[tokens[3]];
        this._halfMoves = parseInt(tokens[4], 10);
        this._moveNumber = parseInt(tokens[5], 10);
        this._updateSetup(fen);
        this._incPositionCount(fen);
    }
    fen() {
        let empty = 0;
        let fen = "";
        for(let i = $e1e1f1f3cd154daa$var$Ox88.a8; i <= $e1e1f1f3cd154daa$var$Ox88.h1; i++){
            if (this._board[i]) {
                if (empty > 0) {
                    fen += empty;
                    empty = 0;
                }
                const { color: color , type: piece  } = this._board[i];
                fen += color === $e1e1f1f3cd154daa$export$29814851e0aa981f ? piece.toUpperCase() : piece.toLowerCase();
            } else empty++;
            if (i + 1 & 0x88) {
                if (empty > 0) fen += empty;
                if (i !== $e1e1f1f3cd154daa$var$Ox88.h1) fen += "/";
                empty = 0;
                i += 8;
            }
        }
        let castling = "";
        if (this._castling[$e1e1f1f3cd154daa$export$29814851e0aa981f] & $e1e1f1f3cd154daa$var$BITS.KSIDE_CASTLE) castling += "K";
        if (this._castling[$e1e1f1f3cd154daa$export$29814851e0aa981f] & $e1e1f1f3cd154daa$var$BITS.QSIDE_CASTLE) castling += "Q";
        if (this._castling[$e1e1f1f3cd154daa$export$7a91b0fde7ec420f] & $e1e1f1f3cd154daa$var$BITS.KSIDE_CASTLE) castling += "k";
        if (this._castling[$e1e1f1f3cd154daa$export$7a91b0fde7ec420f] & $e1e1f1f3cd154daa$var$BITS.QSIDE_CASTLE) castling += "q";
        // do we have an empty castling flag?
        castling = castling || "-";
        let epSquare = "-";
        /*
         * only print the ep square if en passant is a valid move (pawn is present
         * and ep capture is not pinned)
         */ if (this._epSquare !== $e1e1f1f3cd154daa$var$EMPTY) {
            const bigPawnSquare = this._epSquare + (this._turn === $e1e1f1f3cd154daa$export$29814851e0aa981f ? 16 : -16);
            const squares = [
                bigPawnSquare + 1,
                bigPawnSquare - 1
            ];
            for (const square of squares){
                // is the square off the board?
                if (square & 0x88) continue;
                const color = this._turn;
                // is there a pawn that can capture the epSquare?
                if (this._board[square]?.color === color && this._board[square]?.type === $e1e1f1f3cd154daa$export$4c32fd1f222ff2b0) {
                    // if the pawn makes an ep capture, does it leave it's king in check?
                    this._makeMove({
                        color: color,
                        from: square,
                        to: this._epSquare,
                        piece: $e1e1f1f3cd154daa$export$4c32fd1f222ff2b0,
                        captured: $e1e1f1f3cd154daa$export$4c32fd1f222ff2b0,
                        flags: $e1e1f1f3cd154daa$var$BITS.EP_CAPTURE
                    });
                    const isLegal = !this._isKingAttacked(color);
                    this._undoMove();
                    // if ep is legal, break and set the ep square in the FEN output
                    if (isLegal) {
                        epSquare = $e1e1f1f3cd154daa$var$algebraic(this._epSquare);
                        break;
                    }
                }
            }
        }
        return [
            fen,
            this._turn,
            castling,
            epSquare,
            this._halfMoves,
            this._moveNumber
        ].join(" ");
    }
    /*
     * Called when the initial board setup is changed with put() or remove().
     * modifies the SetUp and FEN properties of the header object. If the FEN
     * is equal to the default position, the SetUp and FEN are deleted the setup
     * is only updated if history.length is zero, ie moves haven't been made.
     */ _updateSetup(fen) {
        if (this._history.length > 0) return;
        if (fen !== $e1e1f1f3cd154daa$export$1264a6620073cfaa) {
            this._header["SetUp"] = "1";
            this._header["FEN"] = fen;
        } else {
            delete this._header["SetUp"];
            delete this._header["FEN"];
        }
    }
    reset() {
        this.load($e1e1f1f3cd154daa$export$1264a6620073cfaa);
    }
    get(square) {
        return this._board[$e1e1f1f3cd154daa$var$Ox88[square]] || false;
    }
    put({ type: type , color: color  }, square) {
        if (this._put({
            type: type,
            color: color
        }, square)) {
            this._updateCastlingRights();
            this._updateEnPassantSquare();
            this._updateSetup(this.fen());
            return true;
        }
        return false;
    }
    _put({ type: type , color: color  }, square) {
        // check for piece
        if ($e1e1f1f3cd154daa$var$SYMBOLS.indexOf(type.toLowerCase()) === -1) return false;
        // check for valid square
        if (!(square in $e1e1f1f3cd154daa$var$Ox88)) return false;
        const sq = $e1e1f1f3cd154daa$var$Ox88[square];
        // don't let the user place more than one king
        if (type == $e1e1f1f3cd154daa$export$42387107bb0d6206 && !(this._kings[color] == $e1e1f1f3cd154daa$var$EMPTY || this._kings[color] == sq)) return false;
        const currentPieceOnSquare = this._board[sq];
        // if one of the kings will be replaced by the piece from args, set the `_kings` respective entry to `EMPTY`
        if (currentPieceOnSquare && currentPieceOnSquare.type === $e1e1f1f3cd154daa$export$42387107bb0d6206) this._kings[currentPieceOnSquare.color] = $e1e1f1f3cd154daa$var$EMPTY;
        this._board[sq] = {
            type: type,
            color: color
        };
        if (type === $e1e1f1f3cd154daa$export$42387107bb0d6206) this._kings[color] = sq;
        return true;
    }
    remove(square) {
        const piece = this.get(square);
        delete this._board[$e1e1f1f3cd154daa$var$Ox88[square]];
        if (piece && piece.type === $e1e1f1f3cd154daa$export$42387107bb0d6206) this._kings[piece.color] = $e1e1f1f3cd154daa$var$EMPTY;
        this._updateCastlingRights();
        this._updateEnPassantSquare();
        this._updateSetup(this.fen());
        return piece;
    }
    _updateCastlingRights() {
        const whiteKingInPlace = this._board[$e1e1f1f3cd154daa$var$Ox88.e1]?.type === $e1e1f1f3cd154daa$export$42387107bb0d6206 && this._board[$e1e1f1f3cd154daa$var$Ox88.e1]?.color === $e1e1f1f3cd154daa$export$29814851e0aa981f;
        const blackKingInPlace = this._board[$e1e1f1f3cd154daa$var$Ox88.e8]?.type === $e1e1f1f3cd154daa$export$42387107bb0d6206 && this._board[$e1e1f1f3cd154daa$var$Ox88.e8]?.color === $e1e1f1f3cd154daa$export$7a91b0fde7ec420f;
        if (!whiteKingInPlace || this._board[$e1e1f1f3cd154daa$var$Ox88.a1]?.type !== $e1e1f1f3cd154daa$export$68d4c913908dc245 || this._board[$e1e1f1f3cd154daa$var$Ox88.a1]?.color !== $e1e1f1f3cd154daa$export$29814851e0aa981f) this._castling.w &= ~$e1e1f1f3cd154daa$var$BITS.QSIDE_CASTLE;
        if (!whiteKingInPlace || this._board[$e1e1f1f3cd154daa$var$Ox88.h1]?.type !== $e1e1f1f3cd154daa$export$68d4c913908dc245 || this._board[$e1e1f1f3cd154daa$var$Ox88.h1]?.color !== $e1e1f1f3cd154daa$export$29814851e0aa981f) this._castling.w &= ~$e1e1f1f3cd154daa$var$BITS.KSIDE_CASTLE;
        if (!blackKingInPlace || this._board[$e1e1f1f3cd154daa$var$Ox88.a8]?.type !== $e1e1f1f3cd154daa$export$68d4c913908dc245 || this._board[$e1e1f1f3cd154daa$var$Ox88.a8]?.color !== $e1e1f1f3cd154daa$export$7a91b0fde7ec420f) this._castling.b &= ~$e1e1f1f3cd154daa$var$BITS.QSIDE_CASTLE;
        if (!blackKingInPlace || this._board[$e1e1f1f3cd154daa$var$Ox88.h8]?.type !== $e1e1f1f3cd154daa$export$68d4c913908dc245 || this._board[$e1e1f1f3cd154daa$var$Ox88.h8]?.color !== $e1e1f1f3cd154daa$export$7a91b0fde7ec420f) this._castling.b &= ~$e1e1f1f3cd154daa$var$BITS.KSIDE_CASTLE;
    }
    _updateEnPassantSquare() {
        if (this._epSquare === $e1e1f1f3cd154daa$var$EMPTY) return;
        const startSquare = this._epSquare + (this._turn === $e1e1f1f3cd154daa$export$29814851e0aa981f ? -16 : 16);
        const currentSquare = this._epSquare + (this._turn === $e1e1f1f3cd154daa$export$29814851e0aa981f ? 16 : -16);
        const attackers = [
            currentSquare + 1,
            currentSquare - 1
        ];
        if (this._board[startSquare] !== null || this._board[this._epSquare] !== null || this._board[currentSquare]?.color !== $e1e1f1f3cd154daa$var$swapColor(this._turn) || this._board[currentSquare]?.type !== $e1e1f1f3cd154daa$export$4c32fd1f222ff2b0) {
            this._epSquare = $e1e1f1f3cd154daa$var$EMPTY;
            return;
        }
        const canCapture = (square)=>!(square & 0x88) && this._board[square]?.color === this._turn && this._board[square]?.type === $e1e1f1f3cd154daa$export$4c32fd1f222ff2b0;
        if (!attackers.some(canCapture)) this._epSquare = $e1e1f1f3cd154daa$var$EMPTY;
    }
    _attacked(color, square) {
        for(let i = $e1e1f1f3cd154daa$var$Ox88.a8; i <= $e1e1f1f3cd154daa$var$Ox88.h1; i++){
            // did we run off the end of the board
            if (i & 0x88) {
                i += 7;
                continue;
            }
            // if empty square or wrong color
            if (this._board[i] === undefined || this._board[i].color !== color) continue;
            const piece = this._board[i];
            const difference = i - square;
            // skip - to/from square are the same
            if (difference === 0) continue;
            const index = difference + 119;
            if ($e1e1f1f3cd154daa$var$ATTACKS[index] & $e1e1f1f3cd154daa$var$PIECE_MASKS[piece.type]) {
                if (piece.type === $e1e1f1f3cd154daa$export$4c32fd1f222ff2b0) {
                    if (difference > 0) {
                        if (piece.color === $e1e1f1f3cd154daa$export$29814851e0aa981f) return true;
                    } else {
                        if (piece.color === $e1e1f1f3cd154daa$export$7a91b0fde7ec420f) return true;
                    }
                    continue;
                }
                // if the piece is a knight or a king
                if (piece.type === "n" || piece.type === "k") return true;
                const offset = $e1e1f1f3cd154daa$var$RAYS[index];
                let j = i + offset;
                let blocked = false;
                while(j !== square){
                    if (this._board[j] != null) {
                        blocked = true;
                        break;
                    }
                    j += offset;
                }
                if (!blocked) return true;
            }
        }
        return false;
    }
    _isKingAttacked(color) {
        const square = this._kings[color];
        return square === -1 ? false : this._attacked($e1e1f1f3cd154daa$var$swapColor(color), square);
    }
    isAttacked(square, attackedBy) {
        return this._attacked(attackedBy, $e1e1f1f3cd154daa$var$Ox88[square]);
    }
    isCheck() {
        return this._isKingAttacked(this._turn);
    }
    inCheck() {
        return this.isCheck();
    }
    isCheckmate() {
        return this.isCheck() && this._moves().length === 0;
    }
    isStalemate() {
        return !this.isCheck() && this._moves().length === 0;
    }
    isInsufficientMaterial() {
        /*
         * k.b. vs k.b. (of opposite colors) with mate in 1:
         * 8/8/8/8/1b6/8/B1k5/K7 b - - 0 1
         *
         * k.b. vs k.n. with mate in 1:
         * 8/8/8/8/1n6/8/B7/K1k5 b - - 2 1
         */ const pieces = {
            b: 0,
            n: 0,
            r: 0,
            q: 0,
            k: 0,
            p: 0
        };
        const bishops = [];
        let numPieces = 0;
        let squareColor = 0;
        for(let i = $e1e1f1f3cd154daa$var$Ox88.a8; i <= $e1e1f1f3cd154daa$var$Ox88.h1; i++){
            squareColor = (squareColor + 1) % 2;
            if (i & 0x88) {
                i += 7;
                continue;
            }
            const piece = this._board[i];
            if (piece) {
                pieces[piece.type] = piece.type in pieces ? pieces[piece.type] + 1 : 1;
                if (piece.type === $e1e1f1f3cd154daa$export$54a167f801c5dba3) bishops.push(squareColor);
                numPieces++;
            }
        }
        // k vs. k
        if (numPieces === 2) return true;
        else if (// k vs. kn .... or .... k vs. kb
        numPieces === 3 && (pieces[$e1e1f1f3cd154daa$export$54a167f801c5dba3] === 1 || pieces[$e1e1f1f3cd154daa$export$ce32bc8c2a29bae6] === 1)) return true;
        else if (numPieces === pieces[$e1e1f1f3cd154daa$export$54a167f801c5dba3] + 2) {
            // kb vs. kb where any number of bishops are all on the same color
            let sum = 0;
            const len = bishops.length;
            for(let i = 0; i < len; i++)sum += bishops[i];
            if (sum === 0 || sum === len) return true;
        }
        return false;
    }
    isThreefoldRepetition() {
        return this._getPositionCount(this.fen()) >= 3;
    }
    isDraw() {
        return this._halfMoves >= 100 || // 50 moves per side = 100 half moves
        this.isStalemate() || this.isInsufficientMaterial() || this.isThreefoldRepetition();
    }
    isGameOver() {
        return this.isCheckmate() || this.isStalemate() || this.isDraw();
    }
    moves({ verbose: verbose = false , square: square , piece: piece  } = {}) {
        const moves = this._moves({
            square: square,
            piece: piece
        });
        if (verbose) return moves.map((move)=>this._makePretty(move));
        else return moves.map((move)=>this._moveToSan(move, moves));
    }
    _moves({ legal: legal = true , piece: piece , square: square  } = {}) {
        const forSquare = square ? square.toLowerCase() : undefined;
        const forPiece = piece?.toLowerCase();
        const moves = [];
        const us = this._turn;
        const them = $e1e1f1f3cd154daa$var$swapColor(us);
        let firstSquare = $e1e1f1f3cd154daa$var$Ox88.a8;
        let lastSquare = $e1e1f1f3cd154daa$var$Ox88.h1;
        let singleSquare = false;
        // are we generating moves for a single square?
        if (forSquare) {
            // illegal square, return empty moves
            if (!(forSquare in $e1e1f1f3cd154daa$var$Ox88)) return [];
            else {
                firstSquare = lastSquare = $e1e1f1f3cd154daa$var$Ox88[forSquare];
                singleSquare = true;
            }
        }
        for(let from = firstSquare; from <= lastSquare; from++){
            // did we run off the end of the board
            if (from & 0x88) {
                from += 7;
                continue;
            }
            // empty square or opponent, skip
            if (!this._board[from] || this._board[from].color === them) continue;
            const { type: type  } = this._board[from];
            let to;
            if (type === $e1e1f1f3cd154daa$export$4c32fd1f222ff2b0) {
                if (forPiece && forPiece !== type) continue;
                // single square, non-capturing
                to = from + $e1e1f1f3cd154daa$var$PAWN_OFFSETS[us][0];
                if (!this._board[to]) {
                    $e1e1f1f3cd154daa$var$addMove(moves, us, from, to, $e1e1f1f3cd154daa$export$4c32fd1f222ff2b0);
                    // double square
                    to = from + $e1e1f1f3cd154daa$var$PAWN_OFFSETS[us][1];
                    if ($e1e1f1f3cd154daa$var$SECOND_RANK[us] === $e1e1f1f3cd154daa$var$rank(from) && !this._board[to]) $e1e1f1f3cd154daa$var$addMove(moves, us, from, to, $e1e1f1f3cd154daa$export$4c32fd1f222ff2b0, undefined, $e1e1f1f3cd154daa$var$BITS.BIG_PAWN);
                }
                // pawn captures
                for(let j = 2; j < 4; j++){
                    to = from + $e1e1f1f3cd154daa$var$PAWN_OFFSETS[us][j];
                    if (to & 0x88) continue;
                    if (this._board[to]?.color === them) $e1e1f1f3cd154daa$var$addMove(moves, us, from, to, $e1e1f1f3cd154daa$export$4c32fd1f222ff2b0, this._board[to].type, $e1e1f1f3cd154daa$var$BITS.CAPTURE);
                    else if (to === this._epSquare) $e1e1f1f3cd154daa$var$addMove(moves, us, from, to, $e1e1f1f3cd154daa$export$4c32fd1f222ff2b0, $e1e1f1f3cd154daa$export$4c32fd1f222ff2b0, $e1e1f1f3cd154daa$var$BITS.EP_CAPTURE);
                }
            } else {
                if (forPiece && forPiece !== type) continue;
                for(let j = 0, len = $e1e1f1f3cd154daa$var$PIECE_OFFSETS[type].length; j < len; j++){
                    const offset = $e1e1f1f3cd154daa$var$PIECE_OFFSETS[type][j];
                    to = from;
                    while(true){
                        to += offset;
                        if (to & 0x88) break;
                        if (!this._board[to]) $e1e1f1f3cd154daa$var$addMove(moves, us, from, to, type);
                        else {
                            // own color, stop loop
                            if (this._board[to].color === us) break;
                            $e1e1f1f3cd154daa$var$addMove(moves, us, from, to, type, this._board[to].type, $e1e1f1f3cd154daa$var$BITS.CAPTURE);
                            break;
                        }
                        /* break, if knight or king */ if (type === $e1e1f1f3cd154daa$export$ce32bc8c2a29bae6 || type === $e1e1f1f3cd154daa$export$42387107bb0d6206) break;
                    }
                }
            }
        }
        /*
         * check for castling if we're:
         *   a) generating all moves, or
         *   b) doing single square move generation on the king's square
         */ if (forPiece === undefined || forPiece === $e1e1f1f3cd154daa$export$42387107bb0d6206) {
            if (!singleSquare || lastSquare === this._kings[us]) {
                // king-side castling
                if (this._castling[us] & $e1e1f1f3cd154daa$var$BITS.KSIDE_CASTLE) {
                    const castlingFrom = this._kings[us];
                    const castlingTo = castlingFrom + 2;
                    if (!this._board[castlingFrom + 1] && !this._board[castlingTo] && !this._attacked(them, this._kings[us]) && !this._attacked(them, castlingFrom + 1) && !this._attacked(them, castlingTo)) $e1e1f1f3cd154daa$var$addMove(moves, us, this._kings[us], castlingTo, $e1e1f1f3cd154daa$export$42387107bb0d6206, undefined, $e1e1f1f3cd154daa$var$BITS.KSIDE_CASTLE);
                }
                // queen-side castling
                if (this._castling[us] & $e1e1f1f3cd154daa$var$BITS.QSIDE_CASTLE) {
                    const castlingFrom = this._kings[us];
                    const castlingTo = castlingFrom - 2;
                    if (!this._board[castlingFrom - 1] && !this._board[castlingFrom - 2] && !this._board[castlingFrom - 3] && !this._attacked(them, this._kings[us]) && !this._attacked(them, castlingFrom - 1) && !this._attacked(them, castlingTo)) $e1e1f1f3cd154daa$var$addMove(moves, us, this._kings[us], castlingTo, $e1e1f1f3cd154daa$export$42387107bb0d6206, undefined, $e1e1f1f3cd154daa$var$BITS.QSIDE_CASTLE);
                }
            }
        }
        /*
         * return all pseudo-legal moves (this includes moves that allow the king
         * to be captured)
         */ if (!legal || this._kings[us] === -1) return moves;
        // filter out illegal moves
        const legalMoves = [];
        for(let i = 0, len = moves.length; i < len; i++){
            this._makeMove(moves[i]);
            if (!this._isKingAttacked(us)) legalMoves.push(moves[i]);
            this._undoMove();
        }
        return legalMoves;
    }
    move(move, { strict: strict = false  } = {}) {
        /*
         * The move function can be called with in the following parameters:
         *
         * .move('Nxb7')       <- argument is a case-sensitive SAN string
         *
         * .move({ from: 'h7', <- argument is a move object
         *         to :'h8',
         *         promotion: 'q' })
         *
         *
         * An optional strict argument may be supplied to tell chess.js to
         * strictly follow the SAN specification.
         */ let moveObj = null;
        if (typeof move === "string") moveObj = this._moveFromSan(move, strict);
        else if (typeof move === "object") {
            const moves = this._moves();
            // convert the pretty move object to an ugly move object
            for(let i = 0, len = moves.length; i < len; i++)if (move.from === $e1e1f1f3cd154daa$var$algebraic(moves[i].from) && move.to === $e1e1f1f3cd154daa$var$algebraic(moves[i].to) && (!("promotion" in moves[i]) || move.promotion === moves[i].promotion)) {
                moveObj = moves[i];
                break;
            }
        }
        // failed to find move
        if (!moveObj) {
            if (typeof move === "string") throw new Error(`Invalid move: ${move}`);
            else throw new Error(`Invalid move: ${JSON.stringify(move)}`);
        }
        /*
         * need to make a copy of move because we can't generate SAN after the move
         * is made
         */ const prettyMove = this._makePretty(moveObj);
        this._makeMove(moveObj);
        this._incPositionCount(prettyMove.after);
        return prettyMove;
    }
    _push(move) {
        this._history.push({
            move: move,
            kings: {
                b: this._kings.b,
                w: this._kings.w
            },
            turn: this._turn,
            castling: {
                b: this._castling.b,
                w: this._castling.w
            },
            epSquare: this._epSquare,
            halfMoves: this._halfMoves,
            moveNumber: this._moveNumber
        });
    }
    _makeMove(move) {
        const us = this._turn;
        const them = $e1e1f1f3cd154daa$var$swapColor(us);
        this._push(move);
        this._board[move.to] = this._board[move.from];
        delete this._board[move.from];
        // if ep capture, remove the captured pawn
        if (move.flags & $e1e1f1f3cd154daa$var$BITS.EP_CAPTURE) {
            if (this._turn === $e1e1f1f3cd154daa$export$7a91b0fde7ec420f) delete this._board[move.to - 16];
            else delete this._board[move.to + 16];
        }
        // if pawn promotion, replace with new piece
        if (move.promotion) this._board[move.to] = {
            type: move.promotion,
            color: us
        };
        // if we moved the king
        if (this._board[move.to].type === $e1e1f1f3cd154daa$export$42387107bb0d6206) {
            this._kings[us] = move.to;
            // if we castled, move the rook next to the king
            if (move.flags & $e1e1f1f3cd154daa$var$BITS.KSIDE_CASTLE) {
                const castlingTo = move.to - 1;
                const castlingFrom = move.to + 1;
                this._board[castlingTo] = this._board[castlingFrom];
                delete this._board[castlingFrom];
            } else if (move.flags & $e1e1f1f3cd154daa$var$BITS.QSIDE_CASTLE) {
                const castlingTo = move.to + 1;
                const castlingFrom = move.to - 2;
                this._board[castlingTo] = this._board[castlingFrom];
                delete this._board[castlingFrom];
            }
            // turn off castling
            this._castling[us] = 0;
        }
        // turn off castling if we move a rook
        if (this._castling[us]) {
            for(let i = 0, len = $e1e1f1f3cd154daa$var$ROOKS[us].length; i < len; i++)if (move.from === $e1e1f1f3cd154daa$var$ROOKS[us][i].square && this._castling[us] & $e1e1f1f3cd154daa$var$ROOKS[us][i].flag) {
                this._castling[us] ^= $e1e1f1f3cd154daa$var$ROOKS[us][i].flag;
                break;
            }
        }
        // turn off castling if we capture a rook
        if (this._castling[them]) {
            for(let i = 0, len = $e1e1f1f3cd154daa$var$ROOKS[them].length; i < len; i++)if (move.to === $e1e1f1f3cd154daa$var$ROOKS[them][i].square && this._castling[them] & $e1e1f1f3cd154daa$var$ROOKS[them][i].flag) {
                this._castling[them] ^= $e1e1f1f3cd154daa$var$ROOKS[them][i].flag;
                break;
            }
        }
        // if big pawn move, update the en passant square
        if (move.flags & $e1e1f1f3cd154daa$var$BITS.BIG_PAWN) {
            if (us === $e1e1f1f3cd154daa$export$7a91b0fde7ec420f) this._epSquare = move.to - 16;
            else this._epSquare = move.to + 16;
        } else this._epSquare = $e1e1f1f3cd154daa$var$EMPTY;
        // reset the 50 move counter if a pawn is moved or a piece is captured
        if (move.piece === $e1e1f1f3cd154daa$export$4c32fd1f222ff2b0) this._halfMoves = 0;
        else if (move.flags & ($e1e1f1f3cd154daa$var$BITS.CAPTURE | $e1e1f1f3cd154daa$var$BITS.EP_CAPTURE)) this._halfMoves = 0;
        else this._halfMoves++;
        if (us === $e1e1f1f3cd154daa$export$7a91b0fde7ec420f) this._moveNumber++;
        this._turn = them;
    }
    undo() {
        const move = this._undoMove();
        if (move) {
            const prettyMove = this._makePretty(move);
            this._decPositionCount(prettyMove.after);
            return prettyMove;
        }
        return null;
    }
    _undoMove() {
        const old = this._history.pop();
        if (old === undefined) return null;
        const move = old.move;
        this._kings = old.kings;
        this._turn = old.turn;
        this._castling = old.castling;
        this._epSquare = old.epSquare;
        this._halfMoves = old.halfMoves;
        this._moveNumber = old.moveNumber;
        const us = this._turn;
        const them = $e1e1f1f3cd154daa$var$swapColor(us);
        this._board[move.from] = this._board[move.to];
        this._board[move.from].type = move.piece; // to undo any promotions
        delete this._board[move.to];
        if (move.captured) {
            if (move.flags & $e1e1f1f3cd154daa$var$BITS.EP_CAPTURE) {
                // en passant capture
                let index;
                if (us === $e1e1f1f3cd154daa$export$7a91b0fde7ec420f) index = move.to - 16;
                else index = move.to + 16;
                this._board[index] = {
                    type: $e1e1f1f3cd154daa$export$4c32fd1f222ff2b0,
                    color: them
                };
            } else // regular capture
            this._board[move.to] = {
                type: move.captured,
                color: them
            };
        }
        if (move.flags & ($e1e1f1f3cd154daa$var$BITS.KSIDE_CASTLE | $e1e1f1f3cd154daa$var$BITS.QSIDE_CASTLE)) {
            let castlingTo, castlingFrom;
            if (move.flags & $e1e1f1f3cd154daa$var$BITS.KSIDE_CASTLE) {
                castlingTo = move.to + 1;
                castlingFrom = move.to - 1;
            } else {
                castlingTo = move.to - 2;
                castlingFrom = move.to + 1;
            }
            this._board[castlingTo] = this._board[castlingFrom];
            delete this._board[castlingFrom];
        }
        return move;
    }
    pgn({ newline: newline = "\n" , maxWidth: maxWidth = 0  } = {}) {
        /*
         * using the specification from http://www.chessclub.com/help/PGN-spec
         * example for html usage: .pgn({ max_width: 72, newline_char: "<br />" })
         */ const result = [];
        let headerExists = false;
        /* add the PGN header information */ for(const i in this._header){
            /*
             * TODO: order of enumerated properties in header object is not
             * guaranteed, see ECMA-262 spec (section 12.6.4)
             */ result.push("[" + i + ' "' + this._header[i] + '"]' + newline);
            headerExists = true;
        }
        if (headerExists && this._history.length) result.push(newline);
        const appendComment = (moveString)=>{
            const comment = this._comments[this.fen()];
            if (typeof comment !== "undefined") {
                const delimiter = moveString.length > 0 ? " " : "";
                moveString = `${moveString}${delimiter}{${comment}}`;
            }
            return moveString;
        };
        // pop all of history onto reversed_history
        const reversedHistory = [];
        while(this._history.length > 0)reversedHistory.push(this._undoMove());
        const moves = [];
        let moveString = "";
        // special case of a commented starting position with no moves
        if (reversedHistory.length === 0) moves.push(appendComment(""));
        // build the list of moves.  a move_string looks like: "3. e3 e6"
        while(reversedHistory.length > 0){
            moveString = appendComment(moveString);
            const move = reversedHistory.pop();
            // make TypeScript stop complaining about move being undefined
            if (!move) break;
            // if the position started with black to move, start PGN with #. ...
            if (!this._history.length && move.color === "b") {
                const prefix = `${this._moveNumber}. ...`;
                // is there a comment preceding the first move?
                moveString = moveString ? `${moveString} ${prefix}` : prefix;
            } else if (move.color === "w") {
                // store the previous generated move_string if we have one
                if (moveString.length) moves.push(moveString);
                moveString = this._moveNumber + ".";
            }
            moveString = moveString + " " + this._moveToSan(move, this._moves({
                legal: true
            }));
            this._makeMove(move);
        }
        // are there any other leftover moves?
        if (moveString.length) moves.push(appendComment(moveString));
        // is there a result?
        if (typeof this._header.Result !== "undefined") moves.push(this._header.Result);
        /*
         * history should be back to what it was before we started generating PGN,
         * so join together moves
         */ if (maxWidth === 0) return result.join("") + moves.join(" ");
        // TODO (jah): huh?
        const strip = function() {
            if (result.length > 0 && result[result.length - 1] === " ") {
                result.pop();
                return true;
            }
            return false;
        };
        // NB: this does not preserve comment whitespace.
        const wrapComment = function(width, move) {
            for (const token of move.split(" ")){
                if (!token) continue;
                if (width + token.length > maxWidth) {
                    while(strip())width--;
                    result.push(newline);
                    width = 0;
                }
                result.push(token);
                width += token.length;
                result.push(" ");
                width++;
            }
            if (strip()) width--;
            return width;
        };
        // wrap the PGN output at max_width
        let currentWidth = 0;
        for(let i = 0; i < moves.length; i++){
            if (currentWidth + moves[i].length > maxWidth) {
                if (moves[i].includes("{")) {
                    currentWidth = wrapComment(currentWidth, moves[i]);
                    continue;
                }
            }
            // if the current move will push past max_width
            if (currentWidth + moves[i].length > maxWidth && i !== 0) {
                // don't end the line with whitespace
                if (result[result.length - 1] === " ") result.pop();
                result.push(newline);
                currentWidth = 0;
            } else if (i !== 0) {
                result.push(" ");
                currentWidth++;
            }
            result.push(moves[i]);
            currentWidth += moves[i].length;
        }
        return result.join("");
    }
    header(...args) {
        for(let i = 0; i < args.length; i += 2)if (typeof args[i] === "string" && typeof args[i + 1] === "string") this._header[args[i]] = args[i + 1];
        return this._header;
    }
    loadPgn(pgn, { strict: strict = false , newlineChar: newlineChar = "\r?\n"  } = {}) {
        function mask(str) {
            return str.replace(/\\/g, "\\");
        }
        function parsePgnHeader(header) {
            const headerObj = {};
            const headers = header.split(new RegExp(mask(newlineChar)));
            let key = "";
            let value = "";
            for(let i = 0; i < headers.length; i++){
                const regex = /^\s*\[\s*([A-Za-z]+)\s*"(.*)"\s*\]\s*$/;
                key = headers[i].replace(regex, "$1");
                value = headers[i].replace(regex, "$2");
                if (key.trim().length > 0) headerObj[key] = value;
            }
            return headerObj;
        }
        // strip whitespace from head/tail of PGN block
        pgn = pgn.trim();
        /*
         * RegExp to split header. Takes advantage of the fact that header and movetext
         * will always have a blank line between them (ie, two newline_char's). Handles
         * case where movetext is empty by matching newlineChar until end of string is
         * matched - effectively trimming from the end extra newlineChar.
         *
         * With default newline_char, will equal:
         * /^(\[((?:\r?\n)|.)*\])((?:\s*\r?\n){2}|(?:\s*\r?\n)*$)/
         */ const headerRegex = new RegExp("^(\\[((?:" + mask(newlineChar) + ")|.)*\\])" + "((?:\\s*" + mask(newlineChar) + "){2}|(?:\\s*" + mask(newlineChar) + ")*$)");
        // If no header given, begin with moves.
        const headerRegexResults = headerRegex.exec(pgn);
        const headerString = headerRegexResults ? headerRegexResults.length >= 2 ? headerRegexResults[1] : "" : "";
        // Put the board in the starting position
        this.reset();
        // parse PGN header
        const headers = parsePgnHeader(headerString);
        let fen = "";
        for(const key in headers){
            // check to see user is including fen (possibly with wrong tag case)
            if (key.toLowerCase() === "fen") fen = headers[key];
            this.header(key, headers[key]);
        }
        /*
         * the permissive parser should attempt to load a fen tag, even if it's the
         * wrong case and doesn't include a corresponding [SetUp "1"] tag
         */ if (!strict) {
            if (fen) this.load(fen, {
                preserveHeaders: true
            });
        } else /*
             * strict parser - load the starting position indicated by [Setup '1']
             * and [FEN position]
             */ if (headers["SetUp"] === "1") {
            if (!("FEN" in headers)) throw new Error("Invalid PGN: FEN tag must be supplied with SetUp tag");
            // don't clear the headers when loading
            this.load(headers["FEN"], {
                preserveHeaders: true
            });
        }
        /*
         * NB: the regexes below that delete move numbers, recursive annotations,
         * and numeric annotation glyphs may also match text in comments. To
         * prevent this, we transform comments by hex-encoding them in place and
         * decoding them again after the other tokens have been deleted.
         *
         * While the spec states that PGN files should be ASCII encoded, we use
         * {en,de}codeURIComponent here to support arbitrary UTF8 as a convenience
         * for modern users
         */ function toHex(s) {
            return Array.from(s).map(function(c) {
                /*
                 * encodeURI doesn't transform most ASCII characters, so we handle
                 * these ourselves
                 */ return c.charCodeAt(0) < 128 ? c.charCodeAt(0).toString(16) : encodeURIComponent(c).replace(/%/g, "").toLowerCase();
            }).join("");
        }
        function fromHex(s) {
            return s.length == 0 ? "" : decodeURIComponent("%" + (s.match(/.{1,2}/g) || []).join("%"));
        }
        const encodeComment = function(s) {
            s = s.replace(new RegExp(mask(newlineChar), "g"), " ");
            return `{${toHex(s.slice(1, s.length - 1))}}`;
        };
        const decodeComment = function(s) {
            if (s.startsWith("{") && s.endsWith("}")) return fromHex(s.slice(1, s.length - 1));
        };
        // delete header to get the moves
        let ms = pgn.replace(headerString, "").replace(// encode comments so they don't get deleted below
        new RegExp(`({[^}]*})+?|;([^${mask(newlineChar)}]*)`, "g"), function(_match, bracket, semicolon) {
            return bracket !== undefined ? encodeComment(bracket) : " " + encodeComment(`{${semicolon.slice(1)}}`);
        }).replace(new RegExp(mask(newlineChar), "g"), " ");
        // delete recursive annotation variations
        const ravRegex = /(\([^()]+\))+?/g;
        while(ravRegex.test(ms))ms = ms.replace(ravRegex, "");
        // delete move numbers
        ms = ms.replace(/\d+\.(\.\.)?/g, "");
        // delete ... indicating black to move
        ms = ms.replace(/\.\.\./g, "");
        /* delete numeric annotation glyphs */ ms = ms.replace(/\$\d+/g, "");
        // trim and get array of moves
        let moves = ms.trim().split(new RegExp(/\s+/));
        // delete empty entries
        moves = moves.filter((move)=>move !== "");
        let result = "";
        for(let halfMove = 0; halfMove < moves.length; halfMove++){
            const comment = decodeComment(moves[halfMove]);
            if (comment !== undefined) {
                this._comments[this.fen()] = comment;
                continue;
            }
            const move = this._moveFromSan(moves[halfMove], strict);
            // invalid move
            if (move == null) {
                // was the move an end of game marker
                if ($e1e1f1f3cd154daa$var$TERMINATION_MARKERS.indexOf(moves[halfMove]) > -1) result = moves[halfMove];
                else throw new Error(`Invalid move in PGN: ${moves[halfMove]}`);
            } else {
                // reset the end of game marker if making a valid move
                result = "";
                this._makeMove(move);
                this._incPositionCount(this.fen());
            }
        }
        /*
         * Per section 8.2.6 of the PGN spec, the Result tag pair must match match
         * the termination marker. Only do this when headers are present, but the
         * result tag is missing
         */ if (result && Object.keys(this._header).length && !this._header["Result"]) this.header("Result", result);
    }
    /*
     * Convert a move from 0x88 coordinates to Standard Algebraic Notation
     * (SAN)
     *
     * @param {boolean} strict Use the strict SAN parser. It will throw errors
     * on overly disambiguated moves (see below):
     *
     * r1bqkbnr/ppp2ppp/2n5/1B1pP3/4P3/8/PPPP2PP/RNBQK1NR b KQkq - 2 4
     * 4. ... Nge7 is overly disambiguated because the knight on c6 is pinned
     * 4. ... Ne7 is technically the valid SAN
     */ _moveToSan(move, moves) {
        let output = "";
        if (move.flags & $e1e1f1f3cd154daa$var$BITS.KSIDE_CASTLE) output = "O-O";
        else if (move.flags & $e1e1f1f3cd154daa$var$BITS.QSIDE_CASTLE) output = "O-O-O";
        else {
            if (move.piece !== $e1e1f1f3cd154daa$export$4c32fd1f222ff2b0) {
                const disambiguator = $e1e1f1f3cd154daa$var$getDisambiguator(move, moves);
                output += move.piece.toUpperCase() + disambiguator;
            }
            if (move.flags & ($e1e1f1f3cd154daa$var$BITS.CAPTURE | $e1e1f1f3cd154daa$var$BITS.EP_CAPTURE)) {
                if (move.piece === $e1e1f1f3cd154daa$export$4c32fd1f222ff2b0) output += $e1e1f1f3cd154daa$var$algebraic(move.from)[0];
                output += "x";
            }
            output += $e1e1f1f3cd154daa$var$algebraic(move.to);
            if (move.promotion) output += "=" + move.promotion.toUpperCase();
        }
        this._makeMove(move);
        if (this.isCheck()) {
            if (this.isCheckmate()) output += "#";
            else output += "+";
        }
        this._undoMove();
        return output;
    }
    // convert a move from Standard Algebraic Notation (SAN) to 0x88 coordinates
    _moveFromSan(move, strict = false) {
        // strip off any move decorations: e.g Nf3+?! becomes Nf3
        const cleanMove = $e1e1f1f3cd154daa$var$strippedSan(move);
        let pieceType = $e1e1f1f3cd154daa$var$inferPieceType(cleanMove);
        let moves = this._moves({
            legal: true,
            piece: pieceType
        });
        // strict parser
        for(let i = 0, len = moves.length; i < len; i++){
            if (cleanMove === $e1e1f1f3cd154daa$var$strippedSan(this._moveToSan(moves[i], moves))) return moves[i];
        }
        // the strict parser failed
        if (strict) return null;
        let piece = undefined;
        let matches = undefined;
        let from = undefined;
        let to = undefined;
        let promotion = undefined;
        /*
         * The default permissive (non-strict) parser allows the user to parse
         * non-standard chess notations. This parser is only run after the strict
         * Standard Algebraic Notation (SAN) parser has failed.
         *
         * When running the permissive parser, we'll run a regex to grab the piece, the
         * to/from square, and an optional promotion piece. This regex will
         * parse common non-standard notation like: Pe2-e4, Rc1c4, Qf3xf7,
         * f7f8q, b1c3
         *
         * NOTE: Some positions and moves may be ambiguous when using the permissive
         * parser. For example, in this position: 6k1/8/8/B7/8/8/8/BN4K1 w - - 0 1,
         * the move b1c3 may be interpreted as Nc3 or B1c3 (a disambiguated bishop
         * move). In these cases, the permissive parser will default to the most
         * basic interpretation (which is b1c3 parsing to Nc3).
         */ let overlyDisambiguated = false;
        matches = cleanMove.match(/([pnbrqkPNBRQK])?([a-h][1-8])x?-?([a-h][1-8])([qrbnQRBN])?/);
        if (matches) {
            piece = matches[1];
            from = matches[2];
            to = matches[3];
            promotion = matches[4];
            if (from.length == 1) overlyDisambiguated = true;
        } else {
            /*
             * The [a-h]?[1-8]? portion of the regex below handles moves that may be
             * overly disambiguated (e.g. Nge7 is unnecessary and non-standard when
             * there is one legal knight move to e7). In this case, the value of
             * 'from' variable will be a rank or file, not a square.
             */ matches = cleanMove.match(/([pnbrqkPNBRQK])?([a-h]?[1-8]?)x?-?([a-h][1-8])([qrbnQRBN])?/);
            if (matches) {
                piece = matches[1];
                from = matches[2];
                to = matches[3];
                promotion = matches[4];
                if (from.length == 1) overlyDisambiguated = true;
            }
        }
        pieceType = $e1e1f1f3cd154daa$var$inferPieceType(cleanMove);
        moves = this._moves({
            legal: true,
            piece: piece ? piece : pieceType
        });
        if (!to) return null;
        for(let i = 0, len = moves.length; i < len; i++){
            if (!from) {
                // if there is no from square, it could be just 'x' missing from a capture
                if (cleanMove === $e1e1f1f3cd154daa$var$strippedSan(this._moveToSan(moves[i], moves)).replace("x", "")) return moves[i];
            // hand-compare move properties with the results from our permissive regex
            } else if ((!piece || piece.toLowerCase() == moves[i].piece) && $e1e1f1f3cd154daa$var$Ox88[from] == moves[i].from && $e1e1f1f3cd154daa$var$Ox88[to] == moves[i].to && (!promotion || promotion.toLowerCase() == moves[i].promotion)) return moves[i];
            else if (overlyDisambiguated) {
                /*
                 * SPECIAL CASE: we parsed a move string that may have an unneeded
                 * rank/file disambiguator (e.g. Nge7).  The 'from' variable will
                 */ const square = $e1e1f1f3cd154daa$var$algebraic(moves[i].from);
                if ((!piece || piece.toLowerCase() == moves[i].piece) && $e1e1f1f3cd154daa$var$Ox88[to] == moves[i].to && (from == square[0] || from == square[1]) && (!promotion || promotion.toLowerCase() == moves[i].promotion)) return moves[i];
            }
        }
        return null;
    }
    ascii() {
        let s = "   +------------------------+\n";
        for(let i = $e1e1f1f3cd154daa$var$Ox88.a8; i <= $e1e1f1f3cd154daa$var$Ox88.h1; i++){
            // display the rank
            if ($e1e1f1f3cd154daa$var$file(i) === 0) s += " " + "87654321"[$e1e1f1f3cd154daa$var$rank(i)] + " |";
            if (this._board[i]) {
                const piece = this._board[i].type;
                const color = this._board[i].color;
                const symbol = color === $e1e1f1f3cd154daa$export$29814851e0aa981f ? piece.toUpperCase() : piece.toLowerCase();
                s += " " + symbol + " ";
            } else s += " . ";
            if (i + 1 & 0x88) {
                s += "|\n";
                i += 8;
            }
        }
        s += "   +------------------------+\n";
        s += "     a  b  c  d  e  f  g  h";
        return s;
    }
    perft(depth) {
        const moves = this._moves({
            legal: false
        });
        let nodes = 0;
        const color = this._turn;
        for(let i = 0, len = moves.length; i < len; i++){
            this._makeMove(moves[i]);
            if (!this._isKingAttacked(color)) {
                if (depth - 1 > 0) nodes += this.perft(depth - 1);
                else nodes++;
            }
            this._undoMove();
        }
        return nodes;
    }
    // pretty = external move object
    _makePretty(uglyMove) {
        const { color: color , piece: piece , from: from , to: to , flags: flags , captured: captured , promotion: promotion  } = uglyMove;
        let prettyFlags = "";
        for(const flag in $e1e1f1f3cd154daa$var$BITS)if ($e1e1f1f3cd154daa$var$BITS[flag] & flags) prettyFlags += $e1e1f1f3cd154daa$var$FLAGS[flag];
        const fromAlgebraic = $e1e1f1f3cd154daa$var$algebraic(from);
        const toAlgebraic = $e1e1f1f3cd154daa$var$algebraic(to);
        const move = {
            color: color,
            piece: piece,
            from: fromAlgebraic,
            to: toAlgebraic,
            san: this._moveToSan(uglyMove, this._moves({
                legal: true
            })),
            flags: prettyFlags,
            lan: fromAlgebraic + toAlgebraic,
            before: this.fen(),
            after: ""
        };
        // generate the FEN for the 'after' key
        this._makeMove(uglyMove);
        move.after = this.fen();
        this._undoMove();
        if (captured) move.captured = captured;
        if (promotion) {
            move.promotion = promotion;
            move.lan += promotion;
        }
        return move;
    }
    turn() {
        return this._turn;
    }
    board() {
        const output = [];
        let row = [];
        for(let i = $e1e1f1f3cd154daa$var$Ox88.a8; i <= $e1e1f1f3cd154daa$var$Ox88.h1; i++){
            if (this._board[i] == null) row.push(null);
            else row.push({
                square: $e1e1f1f3cd154daa$var$algebraic(i),
                type: this._board[i].type,
                color: this._board[i].color
            });
            if (i + 1 & 0x88) {
                output.push(row);
                row = [];
                i += 8;
            }
        }
        return output;
    }
    squareColor(square) {
        if (square in $e1e1f1f3cd154daa$var$Ox88) {
            const sq = $e1e1f1f3cd154daa$var$Ox88[square];
            return ($e1e1f1f3cd154daa$var$rank(sq) + $e1e1f1f3cd154daa$var$file(sq)) % 2 === 0 ? "light" : "dark";
        }
        return null;
    }
    history({ verbose: verbose = false  } = {}) {
        const reversedHistory = [];
        const moveHistory = [];
        while(this._history.length > 0)reversedHistory.push(this._undoMove());
        while(true){
            const move = reversedHistory.pop();
            if (!move) break;
            if (verbose) moveHistory.push(this._makePretty(move));
            else moveHistory.push(this._moveToSan(move, this._moves()));
            this._makeMove(move);
        }
        return moveHistory;
    }
    /*
     * Keeps track of position occurrence counts for the purpose of repetition
     * checking. All three methods (`_inc`, `_dec`, and `_get`) trim the
     * irrelevent information from the fen, initialising new positions, and
     * removing old positions from the record if their counts are reduced to 0.
     */ _getPositionCount(fen) {
        const trimmedFen = $e1e1f1f3cd154daa$var$trimFen(fen);
        return this._positionCount[trimmedFen] || 0;
    }
    _incPositionCount(fen) {
        const trimmedFen = $e1e1f1f3cd154daa$var$trimFen(fen);
        if (this._positionCount[trimmedFen] === undefined) this._positionCount[trimmedFen] = 0;
        this._positionCount[trimmedFen] += 1;
    }
    _decPositionCount(fen) {
        const trimmedFen = $e1e1f1f3cd154daa$var$trimFen(fen);
        if (this._positionCount[trimmedFen] === 1) delete this._positionCount[trimmedFen];
        else this._positionCount[trimmedFen] -= 1;
    }
    _pruneComments() {
        const reversedHistory = [];
        const currentComments = {};
        const copyComment = (fen)=>{
            if (fen in this._comments) currentComments[fen] = this._comments[fen];
        };
        while(this._history.length > 0)reversedHistory.push(this._undoMove());
        copyComment(this.fen());
        while(true){
            const move = reversedHistory.pop();
            if (!move) break;
            this._makeMove(move);
            copyComment(this.fen());
        }
        this._comments = currentComments;
    }
    getComment() {
        return this._comments[this.fen()];
    }
    setComment(comment) {
        this._comments[this.fen()] = comment.replace("{", "[").replace("}", "]");
    }
    deleteComment() {
        const comment = this._comments[this.fen()];
        delete this._comments[this.fen()];
        return comment;
    }
    getComments() {
        this._pruneComments();
        return Object.keys(this._comments).map((fen)=>{
            return {
                fen: fen,
                comment: this._comments[fen]
            };
        });
    }
    deleteComments() {
        this._pruneComments();
        return Object.keys(this._comments).map((fen)=>{
            const comment = this._comments[fen];
            delete this._comments[fen];
            return {
                fen: fen,
                comment: comment
            };
        });
    }
    setCastlingRights(color, rights) {
        for (const side of [
            $e1e1f1f3cd154daa$export$42387107bb0d6206,
            $e1e1f1f3cd154daa$export$36a8946792f13ec9
        ])if (rights[side] !== undefined) {
            if (rights[side]) this._castling[color] |= $e1e1f1f3cd154daa$var$SIDES[side];
            else this._castling[color] &= ~$e1e1f1f3cd154daa$var$SIDES[side];
        }
        this._updateCastlingRights();
        const result = this.getCastlingRights(color);
        return (rights[$e1e1f1f3cd154daa$export$42387107bb0d6206] === undefined || rights[$e1e1f1f3cd154daa$export$42387107bb0d6206] === result[$e1e1f1f3cd154daa$export$42387107bb0d6206]) && (rights[$e1e1f1f3cd154daa$export$36a8946792f13ec9] === undefined || rights[$e1e1f1f3cd154daa$export$36a8946792f13ec9] === result[$e1e1f1f3cd154daa$export$36a8946792f13ec9]);
    }
    getCastlingRights(color) {
        return {
            [$e1e1f1f3cd154daa$export$42387107bb0d6206]: (this._castling[color] & $e1e1f1f3cd154daa$var$SIDES[$e1e1f1f3cd154daa$export$42387107bb0d6206]) !== 0,
            [$e1e1f1f3cd154daa$export$36a8946792f13ec9]: (this._castling[color] & $e1e1f1f3cd154daa$var$SIDES[$e1e1f1f3cd154daa$export$36a8946792f13ec9]) !== 0
        };
    }
    moveNumber() {
        return this._moveNumber;
    }
}


const $7ead3b1a9a673b0a$export$58d75f9829cbe158 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext();
const $7ead3b1a9a673b0a$var$ENDPOINT = "https://[TODO_ADD_API_HERE].execute-api.us-east-1.amazonaws.com/dev/";
function $7ead3b1a9a673b0a$var$DataProvider({ children: children  }) {
    const randomItem = "random item";
    const [chess] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(new (0, $e1e1f1f3cd154daa$export$a4d6ea685c300d39)());
    const [positionFen, setPositionFen] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(chess.fen());
    const [items, setItems] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState([]);
    const [apiWasRequested, setApiWasRequested] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(true);
    const [requestWasHandled, setRequestWasHandled] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const [tags, setTags] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState("");
    const [toggle, setToggle] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState("training");
    const [notes, setNotes] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState("");
    const [isPlanningMode, setIsPlanningMode] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const [isMistake, setIsMistake] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const [playerSolvedExercise, setPlayerSolvedExercise] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const [playerFailedExercise, setPlayerFailedExercise] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const [numCorrectExercisePlan, setNumCorrectExercisePlan] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(0);
    const [exercisePlans, setExercisePlans] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState([]);
    const [moveHistory, setMoveHistory] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState([]);
    const [selectedMove, setSelectedMove] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(null);
    function resetAll() {
        // setTags('');
        setToggle("training");
        setNotes("");
        setPlayerSolvedExercise(false);
        setPlayerFailedExercise(false);
        setNumCorrectExercisePlan(0);
        setExercisePlans([]);
    }
    // React.useEffect(() => {
    //   async function fetchData() {
    //     const URL = ENDPOINT + 'last-tag';
    //     const request = new Request(URL, {
    //       method: 'GET',
    //       headers: {
    //         'Content-Type': 'application/json',
    //         Authorization: token,
    //       },
    //       timeout: 100000,
    //     });
    //     console.log(`API Was Requested!`);
    //     console.log(`${URL}`);
    //     const response = await fetch(request);
    //     const json = await response.json();
    //     const data = json.data;
    //     const lastTag = data.LAST_TAG;
    //     setTags(lastTag);
    //     console.log(`json=${JSON.stringify(json)}`);
    //     return json;
    //   }
    //   if (apiWasRequested && !requestWasHandled && token) {
    //     fetchData();
    //     setApiWasRequested(false);
    //     setRequestWasHandled(true);
    //   }
    // }, [apiWasRequested, requestWasHandled, token]);
    function createItem(content, variant) {
        const nextItems = [
            ...items,
            {
                id: crypto.randomUUID(),
                content: content,
                variant: variant
            }
        ];
        setItems(nextItems);
    }
    function clearItem(id) {
        const nextItems = items.filter((item)=>{
            return item.id !== id;
        });
        setItems(nextItems);
    }
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($7ead3b1a9a673b0a$export$58d75f9829cbe158.Provider, {
        value: {
            items: items,
            createItem: createItem,
            clearItem: clearItem,
            randomItem: randomItem,
            setApiWasRequested: setApiWasRequested,
            setRequestWasHandled: setRequestWasHandled,
            tags: tags,
            setTags: setTags,
            resetAll: resetAll,
            toggle: toggle,
            setToggle: setToggle,
            notes: notes,
            setNotes: setNotes,
            isPlanningMode: isPlanningMode,
            isMistake: isMistake,
            setIsPlanningMode: setIsPlanningMode,
            setIsMistake: setIsMistake,
            playerSolvedExercise: playerSolvedExercise,
            setPlayerSolvedExercise: setPlayerSolvedExercise,
            playerFailedExercise: playerFailedExercise,
            setPlayerFailedExercise: setPlayerFailedExercise,
            numCorrectExercisePlan: numCorrectExercisePlan,
            setNumCorrectExercisePlan: setNumCorrectExercisePlan,
            exercisePlans: exercisePlans,
            setExercisePlans: setExercisePlans,
            moveHistory: moveHistory,
            setMoveHistory: setMoveHistory,
            selectedMove: selectedMove,
            setSelectedMove: setSelectedMove,
            chess: chess,
            positionFen: positionFen,
            setPositionFen: setPositionFen
        },
        children: children
    });
}
var $7ead3b1a9a673b0a$export$2e2bcd8739ae039 = $7ead3b1a9a673b0a$var$DataProvider;
const $7ead3b1a9a673b0a$var$CheckboxLabel = (0, $e484c752f3f06549$export$2e2bcd8739ae039).label`
  display: block;
  margin: 10px 0;
`;
const $7ead3b1a9a673b0a$var$Checkbox = (0, $e484c752f3f06549$export$2e2bcd8739ae039).input`
  width: 20px;
  height: 20px;
  margin-right: 5px;
`;






var $bh6RR = parcelRequire("bh6RR");



var $bh6RR = parcelRequire("bh6RR");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Logging constants
const $1c0814b68d3ed1c1$export$13470c6f1642bbce = "Logging";
const $1c0814b68d3ed1c1$export$16032fc466434892 = "x-amz-user-agent";
// Error exception code constants
const $1c0814b68d3ed1c1$export$86d53207c3c20049 = "NoHubcallbackProvidedException";


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $60ad4ba2ce2d6709$export$a0472aa3a356446c;
(function(LogType) {
    LogType["DEBUG"] = "DEBUG";
    LogType["ERROR"] = "ERROR";
    LogType["INFO"] = "INFO";
    LogType["WARN"] = "WARN";
    LogType["VERBOSE"] = "VERBOSE";
    LogType["NONE"] = "NONE";
})($60ad4ba2ce2d6709$export$a0472aa3a356446c || ($60ad4ba2ce2d6709$export$a0472aa3a356446c = {}));


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $39a0f4f2bf9492b0$var$LOG_LEVELS = {
    VERBOSE: 1,
    DEBUG: 2,
    INFO: 3,
    WARN: 4,
    ERROR: 5,
    NONE: 6
};
/**
 * Write logs
 * @class Logger
 */ class $39a0f4f2bf9492b0$export$ba6a9c7ac8291f7f {
    /**
     * @constructor
     * @param {string} name - Name of the logger
     */ constructor(name, level = (0, $60ad4ba2ce2d6709$export$a0472aa3a356446c).WARN){
        this.name = name;
        this.level = level;
        this._pluggables = [];
    }
    _padding(n) {
        return n < 10 ? "0" + n : "" + n;
    }
    _ts() {
        const dt = new Date();
        return [
            this._padding(dt.getMinutes()),
            this._padding(dt.getSeconds())
        ].join(":") + "." + dt.getMilliseconds();
    }
    configure(config) {
        if (!config) return this._config;
        this._config = config;
        return this._config;
    }
    /**
     * Write log
     * @method
     * @memeberof Logger
     * @param {LogType|string} type - log type, default INFO
     * @param {string|object} msg - Logging message or object
     */ _log(type, ...msg) {
        let loggerLevelName = this.level;
        if ($39a0f4f2bf9492b0$export$ba6a9c7ac8291f7f.LOG_LEVEL) loggerLevelName = $39a0f4f2bf9492b0$export$ba6a9c7ac8291f7f.LOG_LEVEL;
        if (typeof window !== "undefined" && window.LOG_LEVEL) loggerLevelName = window.LOG_LEVEL;
        const loggerLevel = $39a0f4f2bf9492b0$var$LOG_LEVELS[loggerLevelName];
        const typeLevel = $39a0f4f2bf9492b0$var$LOG_LEVELS[type];
        if (!(typeLevel >= loggerLevel)) // Do nothing if type is not greater than or equal to logger level (handle undefined)
        return;
        let log = console.log.bind(console);
        if (type === (0, $60ad4ba2ce2d6709$export$a0472aa3a356446c).ERROR && console.error) log = console.error.bind(console);
        if (type === (0, $60ad4ba2ce2d6709$export$a0472aa3a356446c).WARN && console.warn) log = console.warn.bind(console);
        if ($39a0f4f2bf9492b0$export$ba6a9c7ac8291f7f.BIND_ALL_LOG_LEVELS) {
            if (type === (0, $60ad4ba2ce2d6709$export$a0472aa3a356446c).INFO && console.info) log = console.info.bind(console);
            if (type === (0, $60ad4ba2ce2d6709$export$a0472aa3a356446c).DEBUG && console.debug) log = console.debug.bind(console);
        }
        const prefix = `[${type}] ${this._ts()} ${this.name}`;
        let message = "";
        if (msg.length === 1 && typeof msg[0] === "string") {
            message = `${prefix} - ${msg[0]}`;
            log(message);
        } else if (msg.length === 1) {
            message = `${prefix} ${msg[0]}`;
            log(prefix, msg[0]);
        } else if (typeof msg[0] === "string") {
            let obj = msg.slice(1);
            if (obj.length === 1) obj = obj[0];
            message = `${prefix} - ${msg[0]} ${obj}`;
            log(`${prefix} - ${msg[0]}`, obj);
        } else {
            message = `${prefix} ${msg}`;
            log(prefix, msg);
        }
        for (const plugin of this._pluggables){
            const logEvent = {
                message: message,
                timestamp: Date.now()
            };
            plugin.pushLogs([
                logEvent
            ]);
        }
    }
    /**
     * Write General log. Default to INFO
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ log(...msg) {
        this._log((0, $60ad4ba2ce2d6709$export$a0472aa3a356446c).INFO, ...msg);
    }
    /**
     * Write INFO log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ info(...msg) {
        this._log((0, $60ad4ba2ce2d6709$export$a0472aa3a356446c).INFO, ...msg);
    }
    /**
     * Write WARN log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ warn(...msg) {
        this._log((0, $60ad4ba2ce2d6709$export$a0472aa3a356446c).WARN, ...msg);
    }
    /**
     * Write ERROR log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ error(...msg) {
        this._log((0, $60ad4ba2ce2d6709$export$a0472aa3a356446c).ERROR, ...msg);
    }
    /**
     * Write DEBUG log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ debug(...msg) {
        this._log((0, $60ad4ba2ce2d6709$export$a0472aa3a356446c).DEBUG, ...msg);
    }
    /**
     * Write VERBOSE log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ verbose(...msg) {
        this._log((0, $60ad4ba2ce2d6709$export$a0472aa3a356446c).VERBOSE, ...msg);
    }
    addPluggable(pluggable) {
        if (pluggable && pluggable.getCategoryName() === (0, $1c0814b68d3ed1c1$export$13470c6f1642bbce)) {
            this._pluggables.push(pluggable);
            pluggable.configure(this._config);
        }
    }
    listPluggables() {
        return this._pluggables;
    }
}
$39a0f4f2bf9492b0$export$ba6a9c7ac8291f7f.LOG_LEVEL = null;
$39a0f4f2bf9492b0$export$ba6a9c7ac8291f7f.BIND_ALL_LOG_LEVELS = false;



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $d153492e067ac8ab$export$37321a6dace1881c extends Error {
    /**
     *  Constructs an AmplifyError.
     *
     * @param message text that describes the main problem.
     * @param underlyingError the underlying cause of the error.
     * @param recoverySuggestion suggestion to recover from the error.
     *
     */ constructor({ message: message , name: name , recoverySuggestion: recoverySuggestion , underlyingError: underlyingError  }){
        super(message);
        this.name = name;
        this.underlyingError = underlyingError;
        this.recoverySuggestion = recoverySuggestion;
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        this.constructor = $d153492e067ac8ab$export$37321a6dace1881c;
        Object.setPrototypeOf(this, $d153492e067ac8ab$export$37321a6dace1881c.prototype);
    }
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $9464725044e9d769$export$aadf71dd9875dd20 = typeof Symbol !== "undefined" ? Symbol("amplify_default") : "@@amplify_default";
const $9464725044e9d769$var$logger = new (0, $39a0f4f2bf9492b0$export$ba6a9c7ac8291f7f)("Hub");
class $9464725044e9d769$export$6b38ef2be9abbbb9 {
    constructor(name){
        this.listeners = new Map();
        this.protectedChannels = [
            "core",
            "auth",
            "api",
            "analytics",
            "interactions",
            "pubsub",
            "storage",
            "ui",
            "xr"
        ];
        this.name = name;
    }
    /**
     * Used internally to remove a Hub listener.
     *
     * @remarks
     * This private method is for internal use only. Instead of calling Hub.remove, call the result of Hub.listen.
     */ _remove(channel, listener) {
        const holder = this.listeners.get(channel);
        if (!holder) {
            $9464725044e9d769$var$logger.warn(`No listeners for ${channel}`);
            return;
        }
        this.listeners.set(channel, [
            ...holder.filter(({ callback: callback  })=>callback !== listener)
        ]);
    }
    dispatch(channel, payload, source, ampSymbol) {
        if (typeof channel === "string" && this.protectedChannels.indexOf(channel) > -1) {
            const hasAccess = ampSymbol === $9464725044e9d769$export$aadf71dd9875dd20;
            if (!hasAccess) $9464725044e9d769$var$logger.warn(`WARNING: ${channel} is protected and dispatching on it can have unintended consequences`);
        }
        const capsule = {
            channel: channel,
            payload: {
                ...payload
            },
            source: source,
            patternInfo: []
        };
        try {
            this._toListeners(capsule);
        } catch (e) {
            $9464725044e9d769$var$logger.error(e);
        }
    }
    listen(channel, callback, listenerName = "noname") {
        let cb;
        if (typeof callback !== "function") throw new (0, $d153492e067ac8ab$export$37321a6dace1881c)({
            name: (0, $1c0814b68d3ed1c1$export$86d53207c3c20049),
            message: "No callback supplied to Hub"
        });
        else // Needs to be casted as a more generic type
        cb = callback;
        let holder = this.listeners.get(channel);
        if (!holder) {
            holder = [];
            this.listeners.set(channel, holder);
        }
        holder.push({
            name: listenerName,
            callback: cb
        });
        return ()=>{
            this._remove(channel, cb);
        };
    }
    _toListeners(capsule) {
        const { channel: channel , payload: payload  } = capsule;
        const holder = this.listeners.get(channel);
        if (holder) holder.forEach((listener)=>{
            $9464725044e9d769$var$logger.debug(`Dispatching to ${channel} with `, payload);
            try {
                listener.callback(capsule);
            } catch (e) {
                $9464725044e9d769$var$logger.error(e);
            }
        });
    }
}
/* We export a __default__ instance of HubClass to use it as a
pseudo Singleton for the main messaging bus, however you can still create
your own instance of HubClass() for a separate "private bus" of events. */ const $9464725044e9d769$export$8c41bb232f1008b1 = new $9464725044e9d769$export$6b38ef2be9abbbb9("__default__");
/**
 * @internal
 *
 * Internal hub used for core Amplify functionality. Not intended for use outside of Amplify.
 *
 */ const $9464725044e9d769$export$45dde0743a4c8d6e = new $9464725044e9d769$export$6b38ef2be9abbbb9("internal-hub");




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $881d00c083789f41$export$7e32b29e1cb162e1 = (object)=>{
    const propNames = Reflect.ownKeys(object);
    for (const name of propNames){
        const value = object[name];
        if (value && typeof value === "object" || typeof value === "function") $881d00c083789f41$export$7e32b29e1cb162e1(value);
    }
    return Object.freeze(object);
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $81f263cde83633b9$export$35210b3191d26437 = Symbol("oauth-listener");







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $e13fb36a267dd892$var$logger = new (0, $39a0f4f2bf9492b0$export$ba6a9c7ac8291f7f)("parseAWSExports");
const $e13fb36a267dd892$var$authTypeMapping = {
    API_KEY: "apiKey",
    AWS_IAM: "iam",
    AMAZON_COGNITO_USER_POOLS: "userPool",
    OPENID_CONNECT: "oidc",
    NONE: "none",
    AWS_LAMBDA: "lambda",
    // `LAMBDA` is an incorrect value that was added during the v6 rewrite.
    // Keeping it as a valid value until v7 to prevent breaking customers who might
    // be relying on it as a workaround.
    // ref: https://github.com/aws-amplify/amplify-js/pull/12922
    // TODO: @v7 remove next line
    LAMBDA: "lambda"
};
/**
 * Converts the object imported from `aws-exports.js` or `amplifyconfiguration.json` files generated by
 * the Amplify CLI into an object that conforms to the {@link ResourcesConfig}.
 *
 * @param config A configuration object imported  from `aws-exports.js` or `amplifyconfiguration.json`.
 *
 * @returns An object that conforms to the {@link ResourcesConfig} .
 */ const $e13fb36a267dd892$export$1ef2e9c2da492d = (config = {})=>{
    if (!Object.prototype.hasOwnProperty.call(config, "aws_project_region")) throw new (0, $d153492e067ac8ab$export$37321a6dace1881c)({
        name: "InvalidParameterException",
        message: "Invalid config parameter.",
        recoverySuggestion: "Ensure passing the config object imported from  `amplifyconfiguration.json`."
    });
    const { aws_appsync_apiKey: aws_appsync_apiKey , aws_appsync_authenticationType: aws_appsync_authenticationType , aws_appsync_graphqlEndpoint: aws_appsync_graphqlEndpoint , aws_appsync_region: aws_appsync_region , aws_bots_config: aws_bots_config , aws_cognito_identity_pool_id: aws_cognito_identity_pool_id , aws_cognito_sign_up_verification_method: aws_cognito_sign_up_verification_method , aws_cognito_mfa_configuration: aws_cognito_mfa_configuration , aws_cognito_mfa_types: aws_cognito_mfa_types , aws_cognito_password_protection_settings: aws_cognito_password_protection_settings , aws_cognito_verification_mechanisms: aws_cognito_verification_mechanisms , aws_cognito_signup_attributes: aws_cognito_signup_attributes , aws_cognito_social_providers: aws_cognito_social_providers , aws_cognito_username_attributes: aws_cognito_username_attributes , aws_mandatory_sign_in: aws_mandatory_sign_in , aws_mobile_analytics_app_id: aws_mobile_analytics_app_id , aws_mobile_analytics_app_region: aws_mobile_analytics_app_region , aws_user_files_s3_bucket: aws_user_files_s3_bucket , aws_user_files_s3_bucket_region: aws_user_files_s3_bucket_region , aws_user_files_s3_dangerously_connect_to_http_endpoint_for_testing: aws_user_files_s3_dangerously_connect_to_http_endpoint_for_testing , aws_user_pools_id: aws_user_pools_id , aws_user_pools_web_client_id: aws_user_pools_web_client_id , geo: geo , oauth: oauth , predictions: predictions , aws_cloud_logic_custom: aws_cloud_logic_custom , Notifications: Notifications , modelIntrospection: modelIntrospection  } = config;
    const amplifyConfig = {};
    // Analytics
    if (aws_mobile_analytics_app_id) amplifyConfig.Analytics = {
        Pinpoint: {
            appId: aws_mobile_analytics_app_id,
            region: aws_mobile_analytics_app_region
        }
    };
    // Notifications
    const { InAppMessaging: InAppMessaging , Push: Push  } = Notifications ?? {};
    if (InAppMessaging?.AWSPinpoint || Push?.AWSPinpoint) {
        if (InAppMessaging?.AWSPinpoint) {
            const { appId: appId , region: region  } = InAppMessaging.AWSPinpoint;
            amplifyConfig.Notifications = {
                InAppMessaging: {
                    Pinpoint: {
                        appId: appId,
                        region: region
                    }
                }
            };
        }
        if (Push?.AWSPinpoint) {
            const { appId: appId , region: region  } = Push.AWSPinpoint;
            amplifyConfig.Notifications = {
                ...amplifyConfig.Notifications,
                PushNotification: {
                    Pinpoint: {
                        appId: appId,
                        region: region
                    }
                }
            };
        }
    }
    // Interactions
    if (Array.isArray(aws_bots_config)) amplifyConfig.Interactions = {
        LexV1: Object.fromEntries(aws_bots_config.map((bot)=>[
                bot.name,
                bot
            ]))
    };
    // API
    if (aws_appsync_graphqlEndpoint) {
        const defaultAuthMode = $e13fb36a267dd892$var$authTypeMapping[aws_appsync_authenticationType];
        if (!defaultAuthMode) $e13fb36a267dd892$var$logger.debug(`Invalid authentication type ${aws_appsync_authenticationType}. Falling back to IAM.`);
        amplifyConfig.API = {
            GraphQL: {
                endpoint: aws_appsync_graphqlEndpoint,
                apiKey: aws_appsync_apiKey,
                region: aws_appsync_region,
                defaultAuthMode: defaultAuthMode ?? "iam"
            }
        };
        if (modelIntrospection) amplifyConfig.API.GraphQL.modelIntrospection = modelIntrospection;
    }
    // Auth
    const mfaConfig = aws_cognito_mfa_configuration ? {
        status: aws_cognito_mfa_configuration && aws_cognito_mfa_configuration.toLowerCase(),
        totpEnabled: aws_cognito_mfa_types?.includes("TOTP") ?? false,
        smsEnabled: aws_cognito_mfa_types?.includes("SMS") ?? false
    } : undefined;
    const passwordFormatConfig = aws_cognito_password_protection_settings ? {
        minLength: aws_cognito_password_protection_settings.passwordPolicyMinLength,
        requireLowercase: aws_cognito_password_protection_settings.passwordPolicyCharacters?.includes("REQUIRES_LOWERCASE") ?? false,
        requireUppercase: aws_cognito_password_protection_settings.passwordPolicyCharacters?.includes("REQUIRES_UPPERCASE") ?? false,
        requireNumbers: aws_cognito_password_protection_settings.passwordPolicyCharacters?.includes("REQUIRES_NUMBERS") ?? false,
        requireSpecialCharacters: aws_cognito_password_protection_settings.passwordPolicyCharacters?.includes("REQUIRES_SYMBOLS") ?? false
    } : undefined;
    const mergedUserAttributes = Array.from(new Set([
        ...aws_cognito_verification_mechanisms ?? [],
        ...aws_cognito_signup_attributes ?? []
    ]));
    const userAttributes = mergedUserAttributes.reduce((attributes, key)=>({
            ...attributes,
            // All user attributes generated by the CLI are required
            [key.toLowerCase()]: {
                required: true
            }
        }), {});
    const loginWithEmailEnabled = aws_cognito_username_attributes?.includes("EMAIL") ?? false;
    const loginWithPhoneEnabled = aws_cognito_username_attributes?.includes("PHONE_NUMBER") ?? false;
    if (aws_cognito_identity_pool_id || aws_user_pools_id) amplifyConfig.Auth = {
        Cognito: {
            identityPoolId: aws_cognito_identity_pool_id,
            allowGuestAccess: aws_mandatory_sign_in !== "enable",
            signUpVerificationMethod: aws_cognito_sign_up_verification_method,
            userAttributes: userAttributes,
            userPoolClientId: aws_user_pools_web_client_id,
            userPoolId: aws_user_pools_id,
            mfa: mfaConfig,
            passwordFormat: passwordFormatConfig,
            loginWith: {
                username: !(loginWithEmailEnabled || loginWithPhoneEnabled),
                email: loginWithEmailEnabled,
                phone: loginWithPhoneEnabled
            }
        }
    };
    const hasOAuthConfig = oauth ? Object.keys(oauth).length > 0 : false;
    const hasSocialProviderConfig = aws_cognito_social_providers ? aws_cognito_social_providers.length > 0 : false;
    if (amplifyConfig.Auth && hasOAuthConfig) amplifyConfig.Auth.Cognito.loginWith = {
        ...amplifyConfig.Auth.Cognito.loginWith,
        oauth: {
            ...$e13fb36a267dd892$var$getOAuthConfig(oauth),
            ...hasSocialProviderConfig && {
                providers: $e13fb36a267dd892$var$parseSocialProviders(aws_cognito_social_providers)
            }
        }
    };
    // Storage
    if (aws_user_files_s3_bucket) amplifyConfig.Storage = {
        S3: {
            bucket: aws_user_files_s3_bucket,
            region: aws_user_files_s3_bucket_region,
            dangerouslyConnectToHttpEndpointForTesting: aws_user_files_s3_dangerously_connect_to_http_endpoint_for_testing
        }
    };
    // Geo
    if (geo) {
        const { amazon_location_service: amazon_location_service  } = geo;
        amplifyConfig.Geo = {
            LocationService: {
                maps: amazon_location_service.maps,
                geofenceCollections: amazon_location_service.geofenceCollections,
                searchIndices: amazon_location_service.search_indices,
                region: amazon_location_service.region
            }
        };
    }
    // REST API
    if (aws_cloud_logic_custom) amplifyConfig.API = {
        ...amplifyConfig.API,
        REST: aws_cloud_logic_custom.reduce((acc, api)=>{
            const { name: name , endpoint: endpoint , region: region , service: service  } = api;
            return {
                ...acc,
                [name]: {
                    endpoint: endpoint,
                    ...service ? {
                        service: service
                    } : undefined,
                    ...region ? {
                        region: region
                    } : undefined
                }
            };
        }, {})
    };
    // Predictions
    if (predictions) {
        // map VoiceId from speechGenerator defaults to voiceId
        const { VoiceId: voiceId  } = predictions?.convert?.speechGenerator?.defaults ?? {};
        amplifyConfig.Predictions = voiceId ? {
            ...predictions,
            convert: {
                ...predictions.convert,
                speechGenerator: {
                    ...predictions.convert.speechGenerator,
                    defaults: {
                        voiceId: voiceId
                    }
                }
            }
        } : predictions;
    }
    return amplifyConfig;
};
const $e13fb36a267dd892$var$getRedirectUrl = (redirectStr)=>redirectStr?.split(",") ?? [];
const $e13fb36a267dd892$var$getOAuthConfig = ({ domain: domain , scope: scope , redirectSignIn: redirectSignIn , redirectSignOut: redirectSignOut , responseType: responseType  })=>({
        domain: domain,
        scopes: scope,
        redirectSignIn: $e13fb36a267dd892$var$getRedirectUrl(redirectSignIn),
        redirectSignOut: $e13fb36a267dd892$var$getRedirectUrl(redirectSignOut),
        responseType: responseType
    });
const $e13fb36a267dd892$var$parseSocialProviders = (aws_cognito_social_providers)=>{
    return aws_cognito_social_providers.map((provider)=>{
        const updatedProvider = provider.toLowerCase();
        return updatedProvider.charAt(0).toUpperCase() + updatedProvider.slice(1);
    });
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $50774c0f2576411d$export$99bf765e6322c00(config) {
    // version format initially will be '1' but is expected to be something like x.y where x is major and y minor version
    const { version: version  } = config;
    if (!version) return false;
    return version.startsWith("1");
}
function $50774c0f2576411d$var$parseStorage(amplifyOutputsStorageProperties) {
    if (!amplifyOutputsStorageProperties) return undefined;
    const { bucket_name: bucket_name , aws_region: aws_region , buckets: buckets  } = amplifyOutputsStorageProperties;
    return {
        S3: {
            bucket: bucket_name,
            region: aws_region,
            buckets: buckets && $50774c0f2576411d$var$createBucketInfoMap(buckets)
        }
    };
}
function $50774c0f2576411d$var$parseAuth(amplifyOutputsAuthProperties) {
    if (!amplifyOutputsAuthProperties) return undefined;
    const { user_pool_id: user_pool_id , user_pool_client_id: user_pool_client_id , identity_pool_id: identity_pool_id , password_policy: password_policy , mfa_configuration: mfa_configuration , mfa_methods: mfa_methods , unauthenticated_identities_enabled: unauthenticated_identities_enabled , oauth: oauth , username_attributes: username_attributes , standard_required_attributes: standard_required_attributes , groups: groups  } = amplifyOutputsAuthProperties;
    const authConfig = {
        Cognito: {
            userPoolId: user_pool_id,
            userPoolClientId: user_pool_client_id,
            groups: groups
        }
    };
    if (identity_pool_id) authConfig.Cognito = {
        ...authConfig.Cognito,
        identityPoolId: identity_pool_id
    };
    if (password_policy) authConfig.Cognito.passwordFormat = {
        requireLowercase: password_policy.require_lowercase,
        requireNumbers: password_policy.require_numbers,
        requireUppercase: password_policy.require_uppercase,
        requireSpecialCharacters: password_policy.require_symbols,
        minLength: password_policy.min_length ?? 6
    };
    if (mfa_configuration) authConfig.Cognito.mfa = {
        status: $50774c0f2576411d$var$getMfaStatus(mfa_configuration),
        smsEnabled: mfa_methods?.includes("SMS"),
        totpEnabled: mfa_methods?.includes("TOTP")
    };
    if (unauthenticated_identities_enabled) authConfig.Cognito.allowGuestAccess = unauthenticated_identities_enabled;
    if (oauth) authConfig.Cognito.loginWith = {
        oauth: {
            domain: oauth.domain,
            redirectSignIn: oauth.redirect_sign_in_uri,
            redirectSignOut: oauth.redirect_sign_out_uri,
            responseType: oauth.response_type === "token" ? "token" : "code",
            scopes: oauth.scopes,
            providers: $50774c0f2576411d$var$getOAuthProviders(oauth.identity_providers)
        }
    };
    if (username_attributes) authConfig.Cognito.loginWith = {
        ...authConfig.Cognito.loginWith,
        email: username_attributes.includes("email"),
        phone: username_attributes.includes("phone_number"),
        // Signing in with a username is not currently supported in Gen2, this should always evaluate to false
        username: username_attributes.includes("username")
    };
    if (standard_required_attributes) authConfig.Cognito.userAttributes = standard_required_attributes.reduce((acc, curr)=>({
            ...acc,
            [curr]: {
                required: true
            }
        }), {});
    return authConfig;
}
function $50774c0f2576411d$export$fbb0a2a08db9629a(amplifyOutputsAnalyticsProperties) {
    if (!amplifyOutputsAnalyticsProperties?.amazon_pinpoint) return undefined;
    const { amazon_pinpoint: amazon_pinpoint  } = amplifyOutputsAnalyticsProperties;
    return {
        Pinpoint: {
            appId: amazon_pinpoint.app_id,
            region: amazon_pinpoint.aws_region
        }
    };
}
function $50774c0f2576411d$var$parseGeo(amplifyOutputsAnalyticsProperties) {
    if (!amplifyOutputsAnalyticsProperties) return undefined;
    const { aws_region: aws_region , geofence_collections: geofence_collections , maps: maps , search_indices: search_indices  } = amplifyOutputsAnalyticsProperties;
    return {
        LocationService: {
            region: aws_region,
            searchIndices: search_indices,
            geofenceCollections: geofence_collections,
            maps: maps
        }
    };
}
function $50774c0f2576411d$var$parseData(amplifyOutputsDataProperties) {
    if (!amplifyOutputsDataProperties) return undefined;
    const { aws_region: aws_region , default_authorization_type: default_authorization_type , url: url , api_key: api_key , model_introspection: model_introspection  } = amplifyOutputsDataProperties;
    const GraphQL = {
        endpoint: url,
        defaultAuthMode: $50774c0f2576411d$var$getGraphQLAuthMode(default_authorization_type),
        region: aws_region,
        apiKey: api_key,
        modelIntrospection: model_introspection
    };
    return {
        GraphQL: GraphQL
    };
}
function $50774c0f2576411d$var$parseCustom(amplifyOutputsCustomProperties) {
    if (!amplifyOutputsCustomProperties?.events) return undefined;
    const { url: url , aws_region: aws_region , api_key: api_key , default_authorization_type: default_authorization_type  } = amplifyOutputsCustomProperties.events;
    const Events = {
        endpoint: url,
        defaultAuthMode: $50774c0f2576411d$var$getGraphQLAuthMode(default_authorization_type),
        region: aws_region,
        apiKey: api_key
    };
    return {
        Events: Events
    };
}
function $50774c0f2576411d$var$parseNotifications(amplifyOutputsNotificationsProperties) {
    if (!amplifyOutputsNotificationsProperties) return undefined;
    const { aws_region: aws_region , channels: channels , amazon_pinpoint_app_id: amazon_pinpoint_app_id  } = amplifyOutputsNotificationsProperties;
    const hasInAppMessaging = channels.includes("IN_APP_MESSAGING");
    const hasPushNotification = channels.includes("APNS") || channels.includes("FCM");
    if (!(hasInAppMessaging || hasPushNotification)) return undefined;
    // At this point, we know the Amplify outputs contains at least one supported channel
    const notificationsConfig = {};
    if (hasInAppMessaging) notificationsConfig.InAppMessaging = {
        Pinpoint: {
            appId: amazon_pinpoint_app_id,
            region: aws_region
        }
    };
    if (hasPushNotification) notificationsConfig.PushNotification = {
        Pinpoint: {
            appId: amazon_pinpoint_app_id,
            region: aws_region
        }
    };
    return notificationsConfig;
}
function $50774c0f2576411d$export$11d0da171d17ab63(amplifyOutputs) {
    const resourcesConfig = {};
    if (amplifyOutputs.storage) resourcesConfig.Storage = $50774c0f2576411d$var$parseStorage(amplifyOutputs.storage);
    if (amplifyOutputs.auth) resourcesConfig.Auth = $50774c0f2576411d$var$parseAuth(amplifyOutputs.auth);
    if (amplifyOutputs.analytics) resourcesConfig.Analytics = $50774c0f2576411d$export$fbb0a2a08db9629a(amplifyOutputs.analytics);
    if (amplifyOutputs.geo) resourcesConfig.Geo = $50774c0f2576411d$var$parseGeo(amplifyOutputs.geo);
    if (amplifyOutputs.data) resourcesConfig.API = $50774c0f2576411d$var$parseData(amplifyOutputs.data);
    if (amplifyOutputs.custom) {
        const customConfig = $50774c0f2576411d$var$parseCustom(amplifyOutputs.custom);
        if (customConfig && "Events" in customConfig) resourcesConfig.API = {
            ...resourcesConfig.API,
            ...customConfig
        };
    }
    if (amplifyOutputs.notifications) resourcesConfig.Notifications = $50774c0f2576411d$var$parseNotifications(amplifyOutputs.notifications);
    return resourcesConfig;
}
const $50774c0f2576411d$var$authModeNames = {
    AMAZON_COGNITO_USER_POOLS: "userPool",
    API_KEY: "apiKey",
    AWS_IAM: "iam",
    AWS_LAMBDA: "lambda",
    OPENID_CONNECT: "oidc"
};
function $50774c0f2576411d$var$getGraphQLAuthMode(authType) {
    return $50774c0f2576411d$var$authModeNames[authType];
}
const $50774c0f2576411d$var$providerNames = {
    GOOGLE: "Google",
    LOGIN_WITH_AMAZON: "Amazon",
    FACEBOOK: "Facebook",
    SIGN_IN_WITH_APPLE: "Apple"
};
function $50774c0f2576411d$var$getOAuthProviders(providers = []) {
    return providers.reduce((oAuthProviders, provider)=>{
        if ($50774c0f2576411d$var$providerNames[provider] !== undefined) oAuthProviders.push($50774c0f2576411d$var$providerNames[provider]);
        return oAuthProviders;
    }, []);
}
function $50774c0f2576411d$var$getMfaStatus(mfaConfiguration) {
    if (mfaConfiguration === "OPTIONAL") return "optional";
    if (mfaConfiguration === "REQUIRED") return "on";
    return "off";
}
function $50774c0f2576411d$var$createBucketInfoMap(buckets) {
    const mappedBuckets = {};
    buckets.forEach(({ name: name , bucket_name: bucketName , aws_region: region , paths: paths  })=>{
        if (name in mappedBuckets) throw new Error(`Duplicate friendly name found: ${name}. Name must be unique.`);
        mappedBuckets[name] = {
            bucketName: bucketName,
            region: region,
            paths: paths
        };
    });
    return mappedBuckets;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Parses the variety of configuration shapes that Amplify can accept into a ResourcesConfig.
 *
 * @param amplifyConfig An Amplify configuration object conforming to one of the supported schemas.
 * @return A ResourcesConfig for the provided configuration object.
 */ const $129dea0cb92517e9$export$f101a69cd6dc6202 = (amplifyConfig)=>{
    if (Object.keys(amplifyConfig).some((key)=>key.startsWith("aws_"))) return (0, $e13fb36a267dd892$export$1ef2e9c2da492d)(amplifyConfig);
    else if ((0, $50774c0f2576411d$export$99bf765e6322c00)(amplifyConfig)) return (0, $50774c0f2576411d$export$11d0da171d17ab63)(amplifyConfig);
    else return amplifyConfig;
};





function $a494572fc02f1800$export$b007d77a962aa175({ expiresAt: expiresAt , clockDrift: clockDrift  }) {
    const currentTime = Date.now();
    return currentTime + clockDrift > expiresAt;
}
class $a494572fc02f1800$export$eeff9d1a8b8c057b {
    /**
     * Configure Auth category
     *
     * @internal
     *
     * @param authResourcesConfig - Resources configurations required by Auth providers.
     * @param authOptions - Client options used by library
     *
     * @returns void
     */ configure(authResourcesConfig, authOptions) {
        this.authConfig = authResourcesConfig;
        this.authOptions = authOptions;
    }
    /**
     * Fetch the auth tokens, and the temporary AWS credentials and identity if they are configured. By default it
     * does not refresh the auth tokens or credentials if they are loaded in storage already. You can force a refresh
     * with `{ forceRefresh: true }` input.
     *
     * @param options - Options configuring the fetch behavior.
     *
     * @returns Promise of current auth session {@link AuthSession}.
     */ async fetchAuthSession(options = {}) {
        let credentialsAndIdentityId;
        let userSub;
        // Get tokens will throw if session cannot be refreshed (network or service error) or return null if not available
        const tokens = await this.getTokens(options);
        if (tokens) {
            userSub = tokens.accessToken?.payload?.sub;
            // getCredentialsAndIdentityId will throw if cannot get credentials (network or service error)
            credentialsAndIdentityId = await this.authOptions?.credentialsProvider?.getCredentialsAndIdentityId({
                authConfig: this.authConfig,
                tokens: tokens,
                authenticated: true,
                forceRefresh: options.forceRefresh
            });
        } else // getCredentialsAndIdentityId will throw if cannot get credentials (network or service error)
        credentialsAndIdentityId = await this.authOptions?.credentialsProvider?.getCredentialsAndIdentityId({
            authConfig: this.authConfig,
            authenticated: false,
            forceRefresh: options.forceRefresh
        });
        return {
            tokens: tokens,
            credentials: credentialsAndIdentityId?.credentials,
            identityId: credentialsAndIdentityId?.identityId,
            userSub: userSub
        };
    }
    async clearCredentials() {
        await this.authOptions?.credentialsProvider?.clearCredentialsAndIdentityId();
    }
    async getTokens(options) {
        return await this.authOptions?.tokenProvider?.getTokens(options) ?? undefined;
    }
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $f5ed4ab2a4d1861b$var$extendStatics = function(d, b) {
    $f5ed4ab2a4d1861b$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $f5ed4ab2a4d1861b$var$extendStatics(d, b);
};
function $f5ed4ab2a4d1861b$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $f5ed4ab2a4d1861b$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $f5ed4ab2a4d1861b$export$18ce0697a983be9b = function() {
    $f5ed4ab2a4d1861b$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f5ed4ab2a4d1861b$export$18ce0697a983be9b.apply(this, arguments);
};
function $f5ed4ab2a4d1861b$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $f5ed4ab2a4d1861b$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $f5ed4ab2a4d1861b$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $f5ed4ab2a4d1861b$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $f5ed4ab2a4d1861b$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $f5ed4ab2a4d1861b$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $f5ed4ab2a4d1861b$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $f5ed4ab2a4d1861b$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $f5ed4ab2a4d1861b$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $f5ed4ab2a4d1861b$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $f5ed4ab2a4d1861b$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $f5ed4ab2a4d1861b$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $f5ed4ab2a4d1861b$export$45d3717a4c69092e(o, m, p);
}
function $f5ed4ab2a4d1861b$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $f5ed4ab2a4d1861b$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $f5ed4ab2a4d1861b$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($f5ed4ab2a4d1861b$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $f5ed4ab2a4d1861b$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $f5ed4ab2a4d1861b$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $f5ed4ab2a4d1861b$export$10c90e4f7922046c(v) {
    return this instanceof $f5ed4ab2a4d1861b$export$10c90e4f7922046c ? (this.v = v, this) : new $f5ed4ab2a4d1861b$export$10c90e4f7922046c(v);
}
function $f5ed4ab2a4d1861b$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $f5ed4ab2a4d1861b$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $f5ed4ab2a4d1861b$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $f5ed4ab2a4d1861b$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $f5ed4ab2a4d1861b$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $f5ed4ab2a4d1861b$export$19a8beecd37a4c45 === "function" ? $f5ed4ab2a4d1861b$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $f5ed4ab2a4d1861b$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $f5ed4ab2a4d1861b$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $f5ed4ab2a4d1861b$var$ownKeys = function(o) {
    $f5ed4ab2a4d1861b$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $f5ed4ab2a4d1861b$var$ownKeys(o);
};
function $f5ed4ab2a4d1861b$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $f5ed4ab2a4d1861b$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $f5ed4ab2a4d1861b$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $f5ed4ab2a4d1861b$var$__setModuleDefault(result, mod);
    return result;
}
function $f5ed4ab2a4d1861b$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $f5ed4ab2a4d1861b$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $f5ed4ab2a4d1861b$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $f5ed4ab2a4d1861b$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $f5ed4ab2a4d1861b$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $f5ed4ab2a4d1861b$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $f5ed4ab2a4d1861b$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $f5ed4ab2a4d1861b$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $f5ed4ab2a4d1861b$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $f5ed4ab2a4d1861b$export$2e2bcd8739ae039 = {
    __extends: $f5ed4ab2a4d1861b$export$a8ba968b8961cb8a,
    __assign: $f5ed4ab2a4d1861b$export$18ce0697a983be9b,
    __rest: $f5ed4ab2a4d1861b$export$3c9a16f847548506,
    __decorate: $f5ed4ab2a4d1861b$export$29e00dfd3077644b,
    __param: $f5ed4ab2a4d1861b$export$d5ad3fd78186038f,
    __esDecorate: $f5ed4ab2a4d1861b$export$3a84e1ae4e97e9b0,
    __runInitializers: $f5ed4ab2a4d1861b$export$d831c04e792af3d,
    __propKey: $f5ed4ab2a4d1861b$export$6a2a36740a146cb8,
    __setFunctionName: $f5ed4ab2a4d1861b$export$d1a06452d3489bc7,
    __metadata: $f5ed4ab2a4d1861b$export$f1db080c865becb9,
    __awaiter: $f5ed4ab2a4d1861b$export$1050f835b63b671e,
    __generator: $f5ed4ab2a4d1861b$export$67ebef60e6f28a6,
    __createBinding: $f5ed4ab2a4d1861b$export$45d3717a4c69092e,
    __exportStar: $f5ed4ab2a4d1861b$export$f33643c0debef087,
    __values: $f5ed4ab2a4d1861b$export$19a8beecd37a4c45,
    __read: $f5ed4ab2a4d1861b$export$8d051b38c9118094,
    __spread: $f5ed4ab2a4d1861b$export$afc72e2116322959,
    __spreadArrays: $f5ed4ab2a4d1861b$export$6388937ca91ccae8,
    __spreadArray: $f5ed4ab2a4d1861b$export$1216008129fb82ed,
    __await: $f5ed4ab2a4d1861b$export$10c90e4f7922046c,
    __asyncGenerator: $f5ed4ab2a4d1861b$export$e427f37a30a4de9b,
    __asyncDelegator: $f5ed4ab2a4d1861b$export$bbd80228419bb833,
    __asyncValues: $f5ed4ab2a4d1861b$export$e3b29a3d6162315f,
    __makeTemplateObject: $f5ed4ab2a4d1861b$export$4fb47efe1390b86f,
    __importStar: $f5ed4ab2a4d1861b$export$c21735bcef00d192,
    __importDefault: $f5ed4ab2a4d1861b$export$da59b14a69baef04,
    __classPrivateFieldGet: $f5ed4ab2a4d1861b$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $f5ed4ab2a4d1861b$export$d40a35129aaff81f,
    __classPrivateFieldIn: $f5ed4ab2a4d1861b$export$81fdc39f203e4e04,
    __addDisposableResource: $f5ed4ab2a4d1861b$export$88ac25d8e944e405,
    __disposeResources: $f5ed4ab2a4d1861b$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $f5ed4ab2a4d1861b$export$889dfb5d17574b0b
};


/**
 * @internal
 */ var $b5a4ecd5156e000d$export$b2e3d6d444266a5c = 64;
var $b5a4ecd5156e000d$export$d7bd469488748c5f = 32;
var $b5a4ecd5156e000d$export$7167c830cefcb6b5 = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
var $b5a4ecd5156e000d$export$d788bc089976c004 = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
var $b5a4ecd5156e000d$export$856b3d11dc447b50 = Math.pow(2, 53) - 1;



/**
 * @internal
 */ var $9683a5d1f0beed32$export$aab6bc1ad3c77a42 = /** @class */ function() {
    function RawSha256() {
        this.state = Int32Array.from((0, $b5a4ecd5156e000d$export$d788bc089976c004));
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */ this.finished = false;
    }
    RawSha256.prototype.update = function(data) {
        if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > (0, $b5a4ecd5156e000d$export$856b3d11dc447b50)) throw new Error("Cannot hash more than 2^53 - 1 bits");
        while(byteLength > 0){
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === (0, $b5a4ecd5156e000d$export$b2e3d6d444266a5c)) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function() {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % (0, $b5a4ecd5156e000d$export$b2e3d6d444266a5c) >= (0, $b5a4ecd5156e000d$export$b2e3d6d444266a5c) - 8) {
                for(var i = this.bufferLength; i < (0, $b5a4ecd5156e000d$export$b2e3d6d444266a5c); i++)bufferView.setUint8(i, 0);
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for(var i = this.bufferLength; i < (0, $b5a4ecd5156e000d$export$b2e3d6d444266a5c) - 8; i++)bufferView.setUint8(i, 0);
            bufferView.setUint32((0, $b5a4ecd5156e000d$export$b2e3d6d444266a5c) - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32((0, $b5a4ecd5156e000d$export$b2e3d6d444266a5c) - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array((0, $b5a4ecd5156e000d$export$d7bd469488748c5f));
        for(var i = 0; i < 8; i++){
            out[i * 4] = this.state[i] >>> 24 & 0xff;
            out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
            out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
            out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for(var i = 0; i < (0, $b5a4ecd5156e000d$export$b2e3d6d444266a5c); i++){
            if (i < 16) this.temp[i] = (buffer[i * 4] & 0xff) << 24 | (buffer[i * 4 + 1] & 0xff) << 16 | (buffer[i * 4 + 2] & 0xff) << 8 | buffer[i * 4 + 3] & 0xff;
            else {
                var u = this.temp[i - 2];
                var t1_1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                u = this.temp[i - 15];
                var t2_1 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                this.temp[i] = (t1_1 + this.temp[i - 7] | 0) + (t2_1 + this.temp[i - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + ((0, $b5a4ecd5156e000d$export$7167c830cefcb6b5)[i] + this.temp[i] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}();


// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $5aebd7bbf9362f55$export$c7c5cef950a4d2fc = (input)=>new TextEncoder().encode(input);



const $d806e3bfdcadf915$export$73470fd2221e6aef = (data)=>{
    if (typeof data === "string") return (0, $5aebd7bbf9362f55$export$c7c5cef950a4d2fc)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
};


const $df3d483d21bdf8fb$export$b4b216764bb846eb = (input)=>new TextDecoder("utf-8").decode(input);




/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $d4ecdbf520e63dca$export$a143d493d941bafc;
var $d4ecdbf520e63dca$export$e4cf37d7f6fb9e0a;
var $d4ecdbf520e63dca$export$f99ded8fe4b79145;
var $d4ecdbf520e63dca$export$599f31c3813fae4d;
"use strict";
var $034686670a8a195b$export$a48f0734ac7c2329;
var $034686670a8a195b$export$d622b2ad8d90c771;
var $034686670a8a195b$export$6100ba28696e12de;
"use strict";
$034686670a8a195b$export$a48f0734ac7c2329 = $034686670a8a195b$var$byteLength;
$034686670a8a195b$export$d622b2ad8d90c771 = $034686670a8a195b$var$toByteArray;
$034686670a8a195b$export$6100ba28696e12de = $034686670a8a195b$var$fromByteArray;
var $034686670a8a195b$var$lookup = [];
var $034686670a8a195b$var$revLookup = [];
var $034686670a8a195b$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $034686670a8a195b$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $034686670a8a195b$var$i = 0, $034686670a8a195b$var$len = $034686670a8a195b$var$code.length; $034686670a8a195b$var$i < $034686670a8a195b$var$len; ++$034686670a8a195b$var$i){
    $034686670a8a195b$var$lookup[$034686670a8a195b$var$i] = $034686670a8a195b$var$code[$034686670a8a195b$var$i];
    $034686670a8a195b$var$revLookup[$034686670a8a195b$var$code.charCodeAt($034686670a8a195b$var$i)] = $034686670a8a195b$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$034686670a8a195b$var$revLookup["-".charCodeAt(0)] = 62;
$034686670a8a195b$var$revLookup["_".charCodeAt(0)] = 63;
function $034686670a8a195b$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $034686670a8a195b$var$byteLength(b64) {
    var lens = $034686670a8a195b$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $034686670a8a195b$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $034686670a8a195b$var$toByteArray(b64) {
    var tmp;
    var lens = $034686670a8a195b$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $034686670a8a195b$var$Arr($034686670a8a195b$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $034686670a8a195b$var$revLookup[b64.charCodeAt(i)] << 18 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $034686670a8a195b$var$revLookup[b64.charCodeAt(i)] << 2 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $034686670a8a195b$var$revLookup[b64.charCodeAt(i)] << 10 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $034686670a8a195b$var$tripletToBase64(num) {
    return $034686670a8a195b$var$lookup[num >> 18 & 0x3F] + $034686670a8a195b$var$lookup[num >> 12 & 0x3F] + $034686670a8a195b$var$lookup[num >> 6 & 0x3F] + $034686670a8a195b$var$lookup[num & 0x3F];
}
function $034686670a8a195b$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($034686670a8a195b$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $034686670a8a195b$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($034686670a8a195b$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($034686670a8a195b$var$lookup[tmp >> 2] + $034686670a8a195b$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($034686670a8a195b$var$lookup[tmp >> 10] + $034686670a8a195b$var$lookup[tmp >> 4 & 0x3F] + $034686670a8a195b$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $454af19f7384844b$export$aafa59e2e03f2942;
var $454af19f7384844b$export$68d8715fc104d294;
$454af19f7384844b$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$454af19f7384844b$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $d4ecdbf520e63dca$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$d4ecdbf520e63dca$export$a143d493d941bafc = $d4ecdbf520e63dca$var$Buffer;
$d4ecdbf520e63dca$export$e4cf37d7f6fb9e0a = $d4ecdbf520e63dca$var$SlowBuffer;
$d4ecdbf520e63dca$export$f99ded8fe4b79145 = 50;
const $d4ecdbf520e63dca$var$K_MAX_LENGTH = 0x7fffffff;
$d4ecdbf520e63dca$export$599f31c3813fae4d = $d4ecdbf520e63dca$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $d4ecdbf520e63dca$var$Buffer.TYPED_ARRAY_SUPPORT = $d4ecdbf520e63dca$var$typedArraySupport();
if (!$d4ecdbf520e63dca$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $d4ecdbf520e63dca$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($d4ecdbf520e63dca$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($d4ecdbf520e63dca$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $d4ecdbf520e63dca$var$createBuffer(length) {
    if (length > $d4ecdbf520e63dca$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $d4ecdbf520e63dca$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $d4ecdbf520e63dca$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $d4ecdbf520e63dca$var$allocUnsafe(arg);
    }
    return $d4ecdbf520e63dca$var$from(arg, encodingOrOffset, length);
}
$d4ecdbf520e63dca$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $d4ecdbf520e63dca$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $d4ecdbf520e63dca$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $d4ecdbf520e63dca$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($d4ecdbf520e63dca$var$isInstance(value, ArrayBuffer) || value && $d4ecdbf520e63dca$var$isInstance(value.buffer, ArrayBuffer)) return $d4ecdbf520e63dca$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($d4ecdbf520e63dca$var$isInstance(value, SharedArrayBuffer) || value && $d4ecdbf520e63dca$var$isInstance(value.buffer, SharedArrayBuffer))) return $d4ecdbf520e63dca$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $d4ecdbf520e63dca$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $d4ecdbf520e63dca$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $d4ecdbf520e63dca$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $d4ecdbf520e63dca$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $d4ecdbf520e63dca$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($d4ecdbf520e63dca$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($d4ecdbf520e63dca$var$Buffer, Uint8Array);
function $d4ecdbf520e63dca$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $d4ecdbf520e63dca$var$alloc(size, fill, encoding) {
    $d4ecdbf520e63dca$var$assertSize(size);
    if (size <= 0) return $d4ecdbf520e63dca$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $d4ecdbf520e63dca$var$createBuffer(size).fill(fill, encoding) : $d4ecdbf520e63dca$var$createBuffer(size).fill(fill);
    return $d4ecdbf520e63dca$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $d4ecdbf520e63dca$var$Buffer.alloc = function(size, fill, encoding) {
    return $d4ecdbf520e63dca$var$alloc(size, fill, encoding);
};
function $d4ecdbf520e63dca$var$allocUnsafe(size) {
    $d4ecdbf520e63dca$var$assertSize(size);
    return $d4ecdbf520e63dca$var$createBuffer(size < 0 ? 0 : $d4ecdbf520e63dca$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $d4ecdbf520e63dca$var$Buffer.allocUnsafe = function(size) {
    return $d4ecdbf520e63dca$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $d4ecdbf520e63dca$var$Buffer.allocUnsafeSlow = function(size) {
    return $d4ecdbf520e63dca$var$allocUnsafe(size);
};
function $d4ecdbf520e63dca$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$d4ecdbf520e63dca$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $d4ecdbf520e63dca$var$byteLength(string, encoding) | 0;
    let buf = $d4ecdbf520e63dca$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $d4ecdbf520e63dca$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $d4ecdbf520e63dca$var$checked(array.length) | 0;
    const buf = $d4ecdbf520e63dca$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $d4ecdbf520e63dca$var$fromArrayView(arrayView) {
    if ($d4ecdbf520e63dca$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $d4ecdbf520e63dca$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $d4ecdbf520e63dca$var$fromArrayLike(arrayView);
}
function $d4ecdbf520e63dca$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $d4ecdbf520e63dca$var$Buffer.prototype);
    return buf;
}
function $d4ecdbf520e63dca$var$fromObject(obj) {
    if ($d4ecdbf520e63dca$var$Buffer.isBuffer(obj)) {
        const len = $d4ecdbf520e63dca$var$checked(obj.length) | 0;
        const buf = $d4ecdbf520e63dca$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $d4ecdbf520e63dca$var$numberIsNaN(obj.length)) return $d4ecdbf520e63dca$var$createBuffer(0);
        return $d4ecdbf520e63dca$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $d4ecdbf520e63dca$var$fromArrayLike(obj.data);
}
function $d4ecdbf520e63dca$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $d4ecdbf520e63dca$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $d4ecdbf520e63dca$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $d4ecdbf520e63dca$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $d4ecdbf520e63dca$var$Buffer.alloc(+length);
}
$d4ecdbf520e63dca$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $d4ecdbf520e63dca$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$d4ecdbf520e63dca$var$Buffer.compare = function compare(a, b) {
    if ($d4ecdbf520e63dca$var$isInstance(a, Uint8Array)) a = $d4ecdbf520e63dca$var$Buffer.from(a, a.offset, a.byteLength);
    if ($d4ecdbf520e63dca$var$isInstance(b, Uint8Array)) b = $d4ecdbf520e63dca$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(a) || !$d4ecdbf520e63dca$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$d4ecdbf520e63dca$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$d4ecdbf520e63dca$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $d4ecdbf520e63dca$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $d4ecdbf520e63dca$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($d4ecdbf520e63dca$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(buf)) buf = $d4ecdbf520e63dca$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $d4ecdbf520e63dca$var$byteLength(string, encoding) {
    if ($d4ecdbf520e63dca$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $d4ecdbf520e63dca$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $d4ecdbf520e63dca$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $d4ecdbf520e63dca$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $d4ecdbf520e63dca$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$d4ecdbf520e63dca$var$Buffer.byteLength = $d4ecdbf520e63dca$var$byteLength;
function $d4ecdbf520e63dca$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $d4ecdbf520e63dca$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $d4ecdbf520e63dca$var$utf8Slice(this, start, end);
        case "ascii":
            return $d4ecdbf520e63dca$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $d4ecdbf520e63dca$var$latin1Slice(this, start, end);
        case "base64":
            return $d4ecdbf520e63dca$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $d4ecdbf520e63dca$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$d4ecdbf520e63dca$var$Buffer.prototype._isBuffer = true;
function $d4ecdbf520e63dca$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$d4ecdbf520e63dca$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$d4ecdbf520e63dca$var$swap(this, i, i + 1);
    return this;
};
$d4ecdbf520e63dca$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $d4ecdbf520e63dca$var$swap(this, i, i + 3);
        $d4ecdbf520e63dca$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$d4ecdbf520e63dca$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $d4ecdbf520e63dca$var$swap(this, i, i + 7);
        $d4ecdbf520e63dca$var$swap(this, i + 1, i + 6);
        $d4ecdbf520e63dca$var$swap(this, i + 2, i + 5);
        $d4ecdbf520e63dca$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$d4ecdbf520e63dca$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $d4ecdbf520e63dca$var$utf8Slice(this, 0, length);
    return $d4ecdbf520e63dca$var$slowToString.apply(this, arguments);
};
$d4ecdbf520e63dca$var$Buffer.prototype.toLocaleString = $d4ecdbf520e63dca$var$Buffer.prototype.toString;
$d4ecdbf520e63dca$var$Buffer.prototype.equals = function equals(b) {
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $d4ecdbf520e63dca$var$Buffer.compare(this, b) === 0;
};
$d4ecdbf520e63dca$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $d4ecdbf520e63dca$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($d4ecdbf520e63dca$var$customInspectSymbol) $d4ecdbf520e63dca$var$Buffer.prototype[$d4ecdbf520e63dca$var$customInspectSymbol] = $d4ecdbf520e63dca$var$Buffer.prototype.inspect;
$d4ecdbf520e63dca$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($d4ecdbf520e63dca$var$isInstance(target, Uint8Array)) target = $d4ecdbf520e63dca$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $d4ecdbf520e63dca$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($d4ecdbf520e63dca$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $d4ecdbf520e63dca$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($d4ecdbf520e63dca$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $d4ecdbf520e63dca$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $d4ecdbf520e63dca$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $d4ecdbf520e63dca$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$d4ecdbf520e63dca$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $d4ecdbf520e63dca$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$d4ecdbf520e63dca$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $d4ecdbf520e63dca$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $d4ecdbf520e63dca$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($d4ecdbf520e63dca$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $d4ecdbf520e63dca$var$utf8Write(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $d4ecdbf520e63dca$var$asciiWrite(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$asciiToBytes(string), buf, offset, length);
}
function $d4ecdbf520e63dca$var$base64Write(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$base64ToBytes(string), buf, offset, length);
}
function $d4ecdbf520e63dca$var$ucs2Write(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$d4ecdbf520e63dca$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $d4ecdbf520e63dca$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $d4ecdbf520e63dca$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $d4ecdbf520e63dca$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $d4ecdbf520e63dca$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $d4ecdbf520e63dca$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$d4ecdbf520e63dca$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $d4ecdbf520e63dca$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $034686670a8a195b$export$6100ba28696e12de(buf);
    else return $034686670a8a195b$export$6100ba28696e12de(buf.slice(start, end));
}
function $d4ecdbf520e63dca$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $d4ecdbf520e63dca$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $d4ecdbf520e63dca$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $d4ecdbf520e63dca$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $d4ecdbf520e63dca$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $d4ecdbf520e63dca$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $d4ecdbf520e63dca$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $d4ecdbf520e63dca$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $d4ecdbf520e63dca$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $d4ecdbf520e63dca$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $d4ecdbf520e63dca$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$d4ecdbf520e63dca$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $d4ecdbf520e63dca$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $d4ecdbf520e63dca$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$d4ecdbf520e63dca$var$Buffer.prototype.readUintLE = $d4ecdbf520e63dca$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUintBE = $d4ecdbf520e63dca$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint8 = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint16LE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint16BE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint32LE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint32BE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readBigUInt64LE = $d4ecdbf520e63dca$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $d4ecdbf520e63dca$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $d4ecdbf520e63dca$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$d4ecdbf520e63dca$var$Buffer.prototype.readBigUInt64BE = $d4ecdbf520e63dca$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $d4ecdbf520e63dca$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $d4ecdbf520e63dca$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$d4ecdbf520e63dca$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$d4ecdbf520e63dca$var$Buffer.prototype.readBigInt64LE = $d4ecdbf520e63dca$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $d4ecdbf520e63dca$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $d4ecdbf520e63dca$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$d4ecdbf520e63dca$var$Buffer.prototype.readBigInt64BE = $d4ecdbf520e63dca$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $d4ecdbf520e63dca$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $d4ecdbf520e63dca$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$d4ecdbf520e63dca$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return $454af19f7384844b$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return $454af19f7384844b$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 8, this.length);
    return $454af19f7384844b$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 8, this.length);
    return $454af19f7384844b$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $d4ecdbf520e63dca$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$d4ecdbf520e63dca$var$Buffer.prototype.writeUintLE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUintBE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint8 = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint16LE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint16BE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint32LE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint32BE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $d4ecdbf520e63dca$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $d4ecdbf520e63dca$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $d4ecdbf520e63dca$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $d4ecdbf520e63dca$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$d4ecdbf520e63dca$var$Buffer.prototype.writeBigUInt64LE = $d4ecdbf520e63dca$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $d4ecdbf520e63dca$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$d4ecdbf520e63dca$var$Buffer.prototype.writeBigUInt64BE = $d4ecdbf520e63dca$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $d4ecdbf520e63dca$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$d4ecdbf520e63dca$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeBigInt64LE = $d4ecdbf520e63dca$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $d4ecdbf520e63dca$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$d4ecdbf520e63dca$var$Buffer.prototype.writeBigInt64BE = $d4ecdbf520e63dca$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $d4ecdbf520e63dca$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $d4ecdbf520e63dca$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $d4ecdbf520e63dca$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $454af19f7384844b$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$d4ecdbf520e63dca$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeFloat(this, value, offset, true, noAssert);
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeFloat(this, value, offset, false, noAssert);
};
function $d4ecdbf520e63dca$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $454af19f7384844b$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$d4ecdbf520e63dca$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeDouble(this, value, offset, true, noAssert);
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$d4ecdbf520e63dca$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$d4ecdbf520e63dca$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$d4ecdbf520e63dca$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $d4ecdbf520e63dca$var$Buffer.isBuffer(val) ? val : $d4ecdbf520e63dca$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $d4ecdbf520e63dca$var$errors = {};
function $d4ecdbf520e63dca$var$E(sym, getMessage, Base) {
    $d4ecdbf520e63dca$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$d4ecdbf520e63dca$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$d4ecdbf520e63dca$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$d4ecdbf520e63dca$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $d4ecdbf520e63dca$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $d4ecdbf520e63dca$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $d4ecdbf520e63dca$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $d4ecdbf520e63dca$var$checkBounds(buf, offset, byteLength) {
    $d4ecdbf520e63dca$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $d4ecdbf520e63dca$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $d4ecdbf520e63dca$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $d4ecdbf520e63dca$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $d4ecdbf520e63dca$var$checkBounds(buf, offset, byteLength);
}
function $d4ecdbf520e63dca$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $d4ecdbf520e63dca$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $d4ecdbf520e63dca$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $d4ecdbf520e63dca$var$validateNumber(value, type);
        throw new $d4ecdbf520e63dca$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $d4ecdbf520e63dca$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $d4ecdbf520e63dca$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $d4ecdbf520e63dca$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $d4ecdbf520e63dca$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($d4ecdbf520e63dca$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $d4ecdbf520e63dca$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $d4ecdbf520e63dca$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $d4ecdbf520e63dca$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $d4ecdbf520e63dca$var$base64ToBytes(str) {
    return $034686670a8a195b$export$d622b2ad8d90c771($d4ecdbf520e63dca$var$base64clean(str));
}
function $d4ecdbf520e63dca$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $d4ecdbf520e63dca$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $d4ecdbf520e63dca$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $d4ecdbf520e63dca$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $d4ecdbf520e63dca$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $d4ecdbf520e63dca$var$BufferBigIntNotDefined : fn;
}
function $d4ecdbf520e63dca$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}


var $a8b3104de383d739$require$Buffer = $d4ecdbf520e63dca$export$a143d493d941bafc;
// Quick polyfill
var $a8b3104de383d739$var$fromUtf8 = typeof $a8b3104de383d739$require$Buffer !== "undefined" && $a8b3104de383d739$require$Buffer.from ? function(input) {
    return $a8b3104de383d739$require$Buffer.from(input, "utf8");
} : (0, $5aebd7bbf9362f55$export$c7c5cef950a4d2fc);
function $a8b3104de383d739$export$4f21f20c2f1a9063(data) {
    // Already a Uint8, do nothing
    if (data instanceof Uint8Array) return data;
    if (typeof data === "string") return $a8b3104de383d739$var$fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}


// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $413b933ff0fcbf9e$export$ea55f474a468804e(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}


// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $5039f17952806170$export$2527dfa2a193fcfa(num) {
    return new Uint8Array([
        (num & 0xff000000) >> 24,
        (num & 0x00ff0000) >> 16,
        (num & 0x0000ff00) >> 8,
        num & 0x000000ff
    ]);
}


// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// IE 11 does not support Array.from, so we do it manually
function $52575d3913ebdf99$export$b6739cd5a63159f9(a_lookUpTable) {
    if (!Uint32Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while(a_index < a_lookUpTable.length){
            return_array[a_index] = a_lookUpTable[a_index];
            a_index += 1;
        }
        return return_array;
    }
    return Uint32Array.from(a_lookUpTable);
}




var $2127c60713693f53$export$3b58ea8124ac5e28 = /** @class */ function() {
    function Sha256(secret) {
        this.secret = secret;
        this.hash = new (0, $9683a5d1f0beed32$export$aab6bc1ad3c77a42)();
        this.reset();
    }
    Sha256.prototype.update = function(toHash) {
        if ((0, $413b933ff0fcbf9e$export$ea55f474a468804e)(toHash) || this.error) return;
        try {
            this.hash.update((0, $a8b3104de383d739$export$4f21f20c2f1a9063)(toHash));
        } catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */ Sha256.prototype.digestSync = function() {
        if (this.error) throw this.error;
        if (this.outer) {
            if (!this.outer.finished) this.outer.update(this.hash.digest());
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */ Sha256.prototype.digest = function() {
        return (0, $f5ed4ab2a4d1861b$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $f5ed4ab2a4d1861b$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.digestSync()
                ];
            });
        });
    };
    Sha256.prototype.reset = function() {
        this.hash = new (0, $9683a5d1f0beed32$export$aab6bc1ad3c77a42)();
        if (this.secret) {
            this.outer = new (0, $9683a5d1f0beed32$export$aab6bc1ad3c77a42)();
            var inner = $2127c60713693f53$var$bufferFromSecret(this.secret);
            var outer = new Uint8Array((0, $b5a4ecd5156e000d$export$b2e3d6d444266a5c));
            outer.set(inner);
            for(var i = 0; i < (0, $b5a4ecd5156e000d$export$b2e3d6d444266a5c); i++){
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for(var i = 0; i < inner.byteLength; i++)inner[i] = 0;
        }
    };
    return Sha256;
}();
function $2127c60713693f53$var$bufferFromSecret(secret) {
    var input = (0, $a8b3104de383d739$export$4f21f20c2f1a9063)(secret);
    if (input.byteLength > (0, $b5a4ecd5156e000d$export$b2e3d6d444266a5c)) {
        var bufferHash = new (0, $9683a5d1f0beed32$export$aab6bc1ad3c77a42)();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array((0, $b5a4ecd5156e000d$export$b2e3d6d444266a5c));
    buffer.set(input);
    return buffer;
}




const $960024b72c198b30$var$SHORT_TO_HEX = {};
const $960024b72c198b30$var$HEX_TO_SHORT = {};
for(let i = 0; i < 256; i++){
    let encodedByte = i.toString(16).toLowerCase();
    if (encodedByte.length === 1) encodedByte = `0${encodedByte}`;
    $960024b72c198b30$var$SHORT_TO_HEX[i] = encodedByte;
    $960024b72c198b30$var$HEX_TO_SHORT[encodedByte] = i;
}
function $960024b72c198b30$export$1a8ceedbd5845648(encoded) {
    if (encoded.length % 2 !== 0) throw new Error("Hex encoded strings must have an even number length");
    const out = new Uint8Array(encoded.length / 2);
    for(let i = 0; i < encoded.length; i += 2){
        const encodedByte = encoded.slice(i, i + 2).toLowerCase();
        if (encodedByte in $960024b72c198b30$var$HEX_TO_SHORT) out[i / 2] = $960024b72c198b30$var$HEX_TO_SHORT[encodedByte];
        else throw new Error(`Cannot decode unrecognized sequence ${encodedByte} as hexadecimal`);
    }
    return out;
}
function $960024b72c198b30$export$7ea66e3774a60b67(bytes) {
    let out = "";
    for(let i = 0; i < bytes.byteLength; i++)out += $960024b72c198b30$var$SHORT_TO_HEX[bytes[i]];
    return out;
}







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $44174d4eb465d133$export$b412d755cfa0136 {
    constructor(){
        this.oAuthListener = undefined;
        this.resourcesConfig = {};
        this.libraryOptions = {};
        this.Auth = new (0, $a494572fc02f1800$export$eeff9d1a8b8c057b)();
    }
    /**
     * Configures Amplify for use with your back-end resources.
     *
     * @remarks
     * This API does not perform any merging of either `resourcesConfig` or `libraryOptions`. The most recently
     * provided values will be used after configuration.
     *
     * @remarks
     * `configure` can be used to specify additional library options where available for supported categories.
     *
     * @param resourceConfig - Back-end resource configuration. Typically provided via the `aws-exports.js` file.
     * @param libraryOptions - Additional options for customizing the behavior of the library.
     */ configure(resourcesConfig, libraryOptions) {
        const resolvedResourceConfig = (0, $129dea0cb92517e9$export$f101a69cd6dc6202)(resourcesConfig);
        this.resourcesConfig = resolvedResourceConfig;
        if (libraryOptions) this.libraryOptions = libraryOptions;
        // Make resource config immutable
        this.resourcesConfig = (0, $881d00c083789f41$export$7e32b29e1cb162e1)(this.resourcesConfig);
        this.Auth.configure(this.resourcesConfig.Auth, this.libraryOptions.Auth);
        (0, $9464725044e9d769$export$8c41bb232f1008b1).dispatch("core", {
            event: "configure",
            data: this.resourcesConfig
        }, "Configure", (0, $9464725044e9d769$export$aadf71dd9875dd20));
        this.notifyOAuthListener();
    }
    /**
     * Provides access to the current back-end resource configuration for the Library.
     *
     * @returns Returns the immutable back-end resource configuration.
     */ getConfig() {
        return this.resourcesConfig;
    }
    /** @internal */ [(0, $81f263cde83633b9$export$35210b3191d26437)](listener) {
        if (this.resourcesConfig.Auth?.Cognito.loginWith?.oauth) // when Amplify has been configured with a valid OAuth config while adding the listener, run it directly
        listener(this.resourcesConfig.Auth?.Cognito);
        else // otherwise register the listener and run it later when Amplify gets configured with a valid oauth config
        this.oAuthListener = listener;
    }
    notifyOAuthListener() {
        if (!this.resourcesConfig.Auth?.Cognito.loginWith?.oauth || !this.oAuthListener) return;
        this.oAuthListener(this.resourcesConfig.Auth?.Cognito);
        // the listener should only be notified once with a valid oauth config
        this.oAuthListener = undefined;
    }
}
/**
 * The `Amplify` utility is used to configure the library.
 *
 * @remarks
 * `Amplify` orchestrates cross-category communication within the library.
 */ const $44174d4eb465d133$export$a3858a9a153cffc7 = new $44174d4eb465d133$export$b412d755cfa0136();

var $6f98ce5fa2dc1234$exports = {};
(function(global, factory) {
    $6f98ce5fa2dc1234$exports = factory();
})($6f98ce5fa2dc1234$exports, function() {
    "use strict";
    /* eslint-disable no-var */ function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)target[key] = source[key];
        }
        return target;
    }
    /* eslint-enable no-var */ /* eslint-disable no-var */ var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    /* eslint-enable no-var */ /* eslint-disable no-var */ function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = name + "=" + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === "undefined" || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var value = parts.slice(1).join("=");
                try {
                    var found = decodeURIComponent(parts[0]);
                    jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (e) {}
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function(name, attributes) {
                set(name, "", assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: "/"
    });
    /* eslint-enable no-var */ return api;
});


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $cd7d6a3de8efc093$export$dae7d845015939d5 {
    constructor(data = {}){
        const { path: path , domain: domain , expires: expires , sameSite: sameSite , secure: secure  } = data;
        this.domain = domain;
        this.path = path || "/";
        this.expires = Object.prototype.hasOwnProperty.call(data, "expires") ? expires : 365;
        this.secure = Object.prototype.hasOwnProperty.call(data, "secure") ? secure : true;
        if (Object.prototype.hasOwnProperty.call(data, "sameSite")) {
            if (!sameSite || ![
                "strict",
                "lax",
                "none"
            ].includes(sameSite)) throw new Error('The sameSite value of cookieStorage must be "lax", "strict" or "none".');
            if (sameSite === "none" && !this.secure) throw new Error("sameSite = None requires the Secure attribute in latest browser versions.");
            this.sameSite = sameSite;
        }
    }
    async setItem(key, value) {
        (0, (/*@__PURE__*/$parcel$interopDefault($6f98ce5fa2dc1234$exports))).set(key, value, this.getData());
    }
    async getItem(key) {
        const item = (0, (/*@__PURE__*/$parcel$interopDefault($6f98ce5fa2dc1234$exports))).get(key);
        return item ?? null;
    }
    async removeItem(key) {
        (0, (/*@__PURE__*/$parcel$interopDefault($6f98ce5fa2dc1234$exports))).remove(key, this.getData());
    }
    async clear() {
        const cookie = (0, (/*@__PURE__*/$parcel$interopDefault($6f98ce5fa2dc1234$exports))).get();
        const promises = Object.keys(cookie).map((key)=>this.removeItem(key));
        await Promise.all(promises);
    }
    getData() {
        return {
            path: this.path,
            expires: this.expires,
            domain: this.domain,
            secure: this.secure,
            ...this.sameSite && {
                sameSite: this.sameSite
            }
        };
    }
}

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $f5d3b7601afe1953$export$4e712df6b850c8d0;
(function(AmplifyErrorCode) {
    AmplifyErrorCode["NoEndpointId"] = "NoEndpointId";
    AmplifyErrorCode["PlatformNotSupported"] = "PlatformNotSupported";
    AmplifyErrorCode["Unknown"] = "Unknown";
    AmplifyErrorCode["NetworkError"] = "NetworkError";
})($f5d3b7601afe1953$export$4e712df6b850c8d0 || ($f5d3b7601afe1953$export$4e712df6b850c8d0 = {}));



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $a1a461091d7049fe$export$f5362e8a6666a455 extends (0, $d153492e067ac8ab$export$37321a6dace1881c) {
    constructor(){
        super({
            name: (0, $f5d3b7601afe1953$export$4e712df6b850c8d0).PlatformNotSupported,
            message: "Function not supported on current platform"
        });
    }
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ class $4acb0e8bcdcac298$export$8536778e426ddf92 {
    constructor(storage){
        this.storage = storage;
    }
    /**
     * This is used to set a specific item in storage
     * @param {string} key - the key for the item
     * @param {object} value - the value
     * @returns {string} value that was set
     */ async setItem(key, value) {
        if (!this.storage) throw new (0, $a1a461091d7049fe$export$f5362e8a6666a455)();
        this.storage.setItem(key, value);
    }
    /**
     * This is used to get a specific key from storage
     * @param {string} key - the key for the item
     * This is used to clear the storage
     * @returns {string} the data item
     */ async getItem(key) {
        if (!this.storage) throw new (0, $a1a461091d7049fe$export$f5362e8a6666a455)();
        return this.storage.getItem(key);
    }
    /**
     * This is used to remove an item from storage
     * @param {string} key - the key being set
     * @returns {string} value - value that was deleted
     */ async removeItem(key) {
        if (!this.storage) throw new (0, $a1a461091d7049fe$export$f5362e8a6666a455)();
        this.storage.removeItem(key);
    }
    /**
     * This is used to clear the storage
     * @returns {string} nothing
     */ async clear() {
        if (!this.storage) throw new (0, $a1a461091d7049fe$export$f5362e8a6666a455)();
        this.storage.clear();
    }
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ class $fb3276c454108430$export$e4315e25b840a0ea {
    constructor(){
        this.storage = new Map();
    }
    get length() {
        return this.storage.size;
    }
    key(index) {
        if (index > this.length - 1) return null;
        return Array.from(this.storage.keys())[index];
    }
    setItem(key, value) {
        this.storage.set(key, value);
    }
    getItem(key) {
        return this.storage.get(key) ?? null;
    }
    removeItem(key) {
        this.storage.delete(key);
    }
    clear() {
        this.storage.clear();
    }
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 * @returns Either a reference to window.localStorage or an in-memory storage as fallback
 */ const $e26eadfdbe3ab4b1$var$logger = new (0, $39a0f4f2bf9492b0$export$ba6a9c7ac8291f7f)("CoreStorageUtils");
const $e26eadfdbe3ab4b1$export$5d9abaf8ff62cd65 = ()=>{
    try {
        // Attempt to use localStorage directly
        if (typeof window !== "undefined" && window.localStorage) return window.localStorage;
    } catch (e) {
        // Handle any errors related to localStorage access
        $e26eadfdbe3ab4b1$var$logger.info("localStorage not found. InMemoryStorage is used as a fallback.");
    }
    // Return in-memory storage as a fallback if localStorage is not accessible
    return new (0, $fb3276c454108430$export$e4315e25b840a0ea)();
};
/**
 * @internal
 * @returns Either a reference to window.sessionStorage or an in-memory storage as fallback
 */ const $e26eadfdbe3ab4b1$export$518dcc1598f87b = ()=>{
    try {
        // Attempt to use sessionStorage directly
        if (typeof window !== "undefined" && window.sessionStorage) {
            // Verify we can actually use it by testing access
            window.sessionStorage.getItem("test");
            return window.sessionStorage;
        }
        throw new Error("sessionStorage is not defined");
    } catch (e) {
        // Handle any errors related to sessionStorage access
        $e26eadfdbe3ab4b1$var$logger.info("sessionStorage not found. InMemoryStorage is used as a fallback.");
        return new (0, $fb3276c454108430$export$e4315e25b840a0ea)();
    }
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ class $4cc2459090bfa83f$export$bec45e7703e93690 extends (0, $4acb0e8bcdcac298$export$8536778e426ddf92) {
    constructor(){
        super((0, $e26eadfdbe3ab4b1$export$5d9abaf8ff62cd65)());
    }
}






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ class $7d010781d1d47f20$export$2c4b17e1c2e0931 extends (0, $4acb0e8bcdcac298$export$8536778e426ddf92) {
    constructor(){
        super((0, $e26eadfdbe3ab4b1$export$518dcc1598f87b)());
    }
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ class $9bdd0dca204f22dd$export$f7640313c5d17c27 {
    constructor(storage){
        this._storage = storage;
    }
    get storage() {
        if (!this._storage) throw new (0, $a1a461091d7049fe$export$f5362e8a6666a455)();
        return this._storage;
    }
    /**
     * This is used to set a specific item in storage
     * @param {string} key - the key for the item
     * @param {object} value - the value
     * @returns {string} value that was set
     */ setItem(key, value) {
        this.storage.setItem(key, value);
    }
    /**
     * This is used to get a specific key from storage
     * @param {string} key - the key for the item
     * This is used to clear the storage
     * @returns {string} the data item
     */ getItem(key) {
        return this.storage.getItem(key);
    }
    /**
     * This is used to remove an item from storage
     * @param {string} key - the key being set
     * @returns {string} value - value that was deleted
     */ removeItem(key) {
        this.storage.removeItem(key);
    }
    /**
     * This is used to clear the storage
     * @returns {string} nothing
     */ clear() {
        this.storage.clear();
    }
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ class $73813927cdc92330$export$eb7b875b75a2c8df extends (0, $9bdd0dca204f22dd$export$f7640313c5d17c27) {
    constructor(){
        super((0, $e26eadfdbe3ab4b1$export$518dcc1598f87b)());
    }
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $d6350db11aa681cd$export$586b30dcaeecb901 = new (0, $4cc2459090bfa83f$export$bec45e7703e93690)();
const $d6350db11aa681cd$export$f119d83aa936d634 = new (0, $7d010781d1d47f20$export$2c4b17e1c2e0931)();
const $d6350db11aa681cd$export$9015f19b74348a18 = new (0, $73813927cdc92330$export$eb7b875b75a2c8df)();
const $d6350db11aa681cd$export$41feb988b3a84f03 = new (0, $4acb0e8bcdcac298$export$8536778e426ddf92)(new (0, $fb3276c454108430$export$e4315e25b840a0ea)());








// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $7b380da28ef680be$export$e003cc239f955cb6 = ()=>{
    if (typeof window === "object" && typeof window.crypto === "object") return window.crypto;
    // Next.js global polyfill
    if (typeof crypto === "object") return crypto;
    throw new (0, $d153492e067ac8ab$export$37321a6dace1881c)({
        name: "MissingPolyfill",
        message: "Cannot resolve the `crypto` function from the environment."
    });
};
const $7b380da28ef680be$export$94f295707b435c6d = ()=>{
    // browser
    if (typeof window !== "undefined" && typeof window.btoa === "function") return window.btoa;
    // Next.js global polyfill
    if (typeof btoa === "function") return btoa;
    throw new (0, $d153492e067ac8ab$export$37321a6dace1881c)({
        name: "Base64EncoderError",
        message: "Cannot resolve the `btoa` function from the environment."
    });
};
const $7b380da28ef680be$export$ea737e7700106b27 = ()=>{
    // browser
    if (typeof window !== "undefined" && typeof window.atob === "function") return window.atob;
    // Next.js global polyfill
    if (typeof atob === "function") return atob;
    throw new (0, $d153492e067ac8ab$export$37321a6dace1881c)({
        name: "Base64EncoderError",
        message: "Cannot resolve the `atob` function from the environment."
    });
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $01459b747c81c3e7$export$1e303d38dab7b376 = {
    convert (input, options) {
        let inputStr = input;
        // urlSafe character replacement options conform to the base64 url spec
        // https://datatracker.ietf.org/doc/html/rfc4648#page-7
        if (options?.urlSafe) inputStr = inputStr.replace(/-/g, "+").replace(/_/g, "/");
        return (0, $7b380da28ef680be$export$ea737e7700106b27)()(inputStr);
    }
};





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $318f49e195f770af$export$5cb8fc27ccbe9d40 = (errorMap, AssertionError = (0, $d153492e067ac8ab$export$37321a6dace1881c))=>(assertion, name, additionalContext)=>{
        const { message: message , recoverySuggestion: recoverySuggestion  } = errorMap[name];
        if (!assertion) throw new AssertionError({
            name: name,
            message: additionalContext ? `${message} ${additionalContext}` : message,
            recoverySuggestion: recoverySuggestion
        });
    };




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $bb394460481fda70$export$7b5c8b570ea8407;
(function(AuthConfigurationErrorCode) {
    AuthConfigurationErrorCode["AuthTokenConfigException"] = "AuthTokenConfigException";
    AuthConfigurationErrorCode["AuthUserPoolAndIdentityPoolException"] = "AuthUserPoolAndIdentityPoolException";
    AuthConfigurationErrorCode["AuthUserPoolException"] = "AuthUserPoolException";
    AuthConfigurationErrorCode["InvalidIdentityPoolIdException"] = "InvalidIdentityPoolIdException";
    AuthConfigurationErrorCode["OAuthNotConfigureException"] = "OAuthNotConfigureException";
})($bb394460481fda70$export$7b5c8b570ea8407 || ($bb394460481fda70$export$7b5c8b570ea8407 = {}));
const $bb394460481fda70$var$authConfigurationErrorMap = {
    [$bb394460481fda70$export$7b5c8b570ea8407.AuthTokenConfigException]: {
        message: "Auth Token Provider not configured.",
        recoverySuggestion: "Make sure to call Amplify.configure in your app."
    },
    [$bb394460481fda70$export$7b5c8b570ea8407.AuthUserPoolAndIdentityPoolException]: {
        message: "Auth UserPool or IdentityPool not configured.",
        recoverySuggestion: "Make sure to call Amplify.configure in your app with UserPoolId and IdentityPoolId."
    },
    [$bb394460481fda70$export$7b5c8b570ea8407.AuthUserPoolException]: {
        message: "Auth UserPool not configured.",
        recoverySuggestion: "Make sure to call Amplify.configure in your app with userPoolId and userPoolClientId."
    },
    [$bb394460481fda70$export$7b5c8b570ea8407.InvalidIdentityPoolIdException]: {
        message: "Invalid identity pool id provided.",
        recoverySuggestion: "Make sure a valid identityPoolId is given in the config."
    },
    [$bb394460481fda70$export$7b5c8b570ea8407.OAuthNotConfigureException]: {
        message: "oauth param not configured.",
        recoverySuggestion: "Make sure to call Amplify.configure with oauth parameter in your app."
    }
};
const $bb394460481fda70$export$a7a9523472993e97 = (0, $318f49e195f770af$export$5cb8fc27ccbe9d40)($bb394460481fda70$var$authConfigurationErrorMap);


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $da35d46b99b5d98d$export$80c92581e59ed502(cognitoConfig) {
    let assertionValid = true; // assume valid until otherwise proveed
    if (!cognitoConfig) assertionValid = false;
    else assertionValid = !!cognitoConfig.userPoolId && !!cognitoConfig.userPoolClientId;
    (0, $bb394460481fda70$export$a7a9523472993e97)(assertionValid, (0, $bb394460481fda70$export$7b5c8b570ea8407).AuthUserPoolException);
}
function $da35d46b99b5d98d$export$c13e6dbaf90a8e5f(cognitoConfig) {
    const validOAuthConfig = !!cognitoConfig?.loginWith?.oauth?.domain && !!cognitoConfig?.loginWith?.oauth?.redirectSignOut && !!cognitoConfig?.loginWith?.oauth?.redirectSignIn && !!cognitoConfig?.loginWith?.oauth?.responseType;
    (0, $bb394460481fda70$export$a7a9523472993e97)(validOAuthConfig, (0, $bb394460481fda70$export$7b5c8b570ea8407).OAuthNotConfigureException);
}
function $da35d46b99b5d98d$export$8a2f5318ea3215e3(cognitoConfig) {
    const validConfig = !!cognitoConfig?.identityPoolId;
    (0, $bb394460481fda70$export$a7a9523472993e97)(validConfig, (0, $bb394460481fda70$export$7b5c8b570ea8407).InvalidIdentityPoolIdException);
}
/**
 * Decodes payload of JWT token
 *
 * @param {String} token A string representing a token to be decoded
 * @throws {@link Error} - Throws error when token is invalid or payload malformed.
 */ function $da35d46b99b5d98d$export$9a62e6c0a30e00bc(token) {
    const tokenParts = token.split(".");
    if (tokenParts.length !== 3) throw new Error("Invalid token");
    try {
        const base64WithUrlSafe = tokenParts[1];
        const base64 = base64WithUrlSafe.replace(/-/g, "+").replace(/_/g, "/");
        const jsonStr = decodeURIComponent((0, $01459b747c81c3e7$export$1e303d38dab7b376).convert(base64).split("").map((char)=>`%${`00${char.charCodeAt(0).toString(16)}`.slice(-2)}`).join(""));
        const payload = JSON.parse(jsonStr);
        return {
            toString: ()=>token,
            payload: payload
        };
    } catch (err) {
        throw new Error("Invalid token payload");
    }
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $03e5abb25dfabdd6$export$145273558d58e0ac extends (0, $d153492e067ac8ab$export$37321a6dace1881c) {
    constructor(params){
        super(params);
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        this.constructor = $03e5abb25dfabdd6$export$145273558d58e0ac;
        Object.setPrototypeOf(this, $03e5abb25dfabdd6$export$145273558d58e0ac.prototype);
    }
}


const $51fefc0f242b4091$export$b8429d1428aad8ba = {
    accessToken: "accessToken",
    idToken: "idToken",
    oidcProvider: "oidcProvider",
    clockDrift: "clockDrift",
    refreshToken: "refreshToken",
    deviceKey: "deviceKey",
    randomPasswordKey: "randomPasswordKey",
    deviceGroupKey: "deviceGroupKey",
    signInDetails: "signInDetails",
    oauthMetadata: "oauthMetadata"
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $5cbe89a4f402275f$export$cc5909720f29144;
(function(TokenProviderErrorCode) {
    TokenProviderErrorCode["InvalidAuthTokens"] = "InvalidAuthTokens";
})($5cbe89a4f402275f$export$cc5909720f29144 || ($5cbe89a4f402275f$export$cc5909720f29144 = {}));
const $5cbe89a4f402275f$var$tokenValidationErrorMap = {
    [$5cbe89a4f402275f$export$cc5909720f29144.InvalidAuthTokens]: {
        message: "Invalid tokens.",
        recoverySuggestion: "Make sure the tokens are valid."
    }
};
const $5cbe89a4f402275f$export$a7a9523472993e97 = (0, $318f49e195f770af$export$5cb8fc27ccbe9d40)($5cbe89a4f402275f$var$tokenValidationErrorMap);


class $36e2942275e8945a$export$a36be852d43d512 {
    constructor(){
        this.name = "CognitoIdentityServiceProvider"; // To be backwards compatible with V5, no migration needed
    }
    getKeyValueStorage() {
        if (!this.keyValueStorage) throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
            name: "KeyValueStorageNotFoundException",
            message: "KeyValueStorage was not found in TokenStore"
        });
        return this.keyValueStorage;
    }
    setKeyValueStorage(keyValueStorage) {
        this.keyValueStorage = keyValueStorage;
    }
    setAuthConfig(authConfig) {
        this.authConfig = authConfig;
    }
    async loadTokens() {
        // TODO(v6): migration logic should be here
        // Reading V5 tokens old format
        try {
            const authKeys = await this.getAuthKeys();
            const accessTokenString = await this.getKeyValueStorage().getItem(authKeys.accessToken);
            if (!accessTokenString) throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
                name: "NoSessionFoundException",
                message: "Auth session was not found. Make sure to call signIn."
            });
            const accessToken = (0, $da35d46b99b5d98d$export$9a62e6c0a30e00bc)(accessTokenString);
            const itString = await this.getKeyValueStorage().getItem(authKeys.idToken);
            const idToken = itString ? (0, $da35d46b99b5d98d$export$9a62e6c0a30e00bc)(itString) : undefined;
            const refreshToken = await this.getKeyValueStorage().getItem(authKeys.refreshToken) ?? undefined;
            const clockDriftString = await this.getKeyValueStorage().getItem(authKeys.clockDrift) ?? "0";
            const clockDrift = Number.parseInt(clockDriftString);
            const signInDetails = await this.getKeyValueStorage().getItem(authKeys.signInDetails);
            const tokens = {
                accessToken: accessToken,
                idToken: idToken,
                refreshToken: refreshToken,
                deviceMetadata: await this.getDeviceMetadata() ?? undefined,
                clockDrift: clockDrift,
                username: await this.getLastAuthUser()
            };
            if (signInDetails) tokens.signInDetails = JSON.parse(signInDetails);
            return tokens;
        } catch (err) {
            return null;
        }
    }
    async storeTokens(tokens) {
        (0, $5cbe89a4f402275f$export$a7a9523472993e97)(tokens !== undefined, (0, $5cbe89a4f402275f$export$cc5909720f29144).InvalidAuthTokens);
        await this.clearTokens();
        const lastAuthUser = tokens.username;
        await this.getKeyValueStorage().setItem(this.getLastAuthUserKey(), lastAuthUser);
        const authKeys = await this.getAuthKeys();
        await this.getKeyValueStorage().setItem(authKeys.accessToken, tokens.accessToken.toString());
        if (tokens.idToken) await this.getKeyValueStorage().setItem(authKeys.idToken, tokens.idToken.toString());
        if (tokens.refreshToken) await this.getKeyValueStorage().setItem(authKeys.refreshToken, tokens.refreshToken);
        if (tokens.deviceMetadata) {
            if (tokens.deviceMetadata.deviceKey) await this.getKeyValueStorage().setItem(authKeys.deviceKey, tokens.deviceMetadata.deviceKey);
            if (tokens.deviceMetadata.deviceGroupKey) await this.getKeyValueStorage().setItem(authKeys.deviceGroupKey, tokens.deviceMetadata.deviceGroupKey);
            await this.getKeyValueStorage().setItem(authKeys.randomPasswordKey, tokens.deviceMetadata.randomPassword);
        }
        if (tokens.signInDetails) await this.getKeyValueStorage().setItem(authKeys.signInDetails, JSON.stringify(tokens.signInDetails));
        await this.getKeyValueStorage().setItem(authKeys.clockDrift, `${tokens.clockDrift}`);
    }
    async clearTokens() {
        const authKeys = await this.getAuthKeys();
        // Not calling clear because it can remove data that is not managed by AuthTokenStore
        await Promise.all([
            this.getKeyValueStorage().removeItem(authKeys.accessToken),
            this.getKeyValueStorage().removeItem(authKeys.idToken),
            this.getKeyValueStorage().removeItem(authKeys.clockDrift),
            this.getKeyValueStorage().removeItem(authKeys.refreshToken),
            this.getKeyValueStorage().removeItem(authKeys.signInDetails),
            this.getKeyValueStorage().removeItem(this.getLastAuthUserKey()),
            this.getKeyValueStorage().removeItem(authKeys.oauthMetadata)
        ]);
    }
    async getDeviceMetadata(username) {
        const authKeys = await this.getAuthKeys(username);
        const deviceKey = await this.getKeyValueStorage().getItem(authKeys.deviceKey);
        const deviceGroupKey = await this.getKeyValueStorage().getItem(authKeys.deviceGroupKey);
        const randomPassword = await this.getKeyValueStorage().getItem(authKeys.randomPasswordKey);
        return randomPassword && deviceGroupKey && deviceKey ? {
            deviceKey: deviceKey,
            deviceGroupKey: deviceGroupKey,
            randomPassword: randomPassword
        } : null;
    }
    async clearDeviceMetadata(username) {
        const authKeys = await this.getAuthKeys(username);
        await Promise.all([
            this.getKeyValueStorage().removeItem(authKeys.deviceKey),
            this.getKeyValueStorage().removeItem(authKeys.deviceGroupKey),
            this.getKeyValueStorage().removeItem(authKeys.randomPasswordKey)
        ]);
    }
    async getAuthKeys(username) {
        (0, $da35d46b99b5d98d$export$80c92581e59ed502)(this.authConfig?.Cognito);
        const lastAuthUser = username ?? await this.getLastAuthUser();
        return $36e2942275e8945a$export$4647c72f6828a74d(this.name, `${this.authConfig.Cognito.userPoolClientId}.${lastAuthUser}`);
    }
    getLastAuthUserKey() {
        (0, $da35d46b99b5d98d$export$80c92581e59ed502)(this.authConfig?.Cognito);
        const identifier = this.authConfig.Cognito.userPoolClientId;
        return `${this.name}.${identifier}.LastAuthUser`;
    }
    async getLastAuthUser() {
        const lastAuthUser = await this.getKeyValueStorage().getItem(this.getLastAuthUserKey()) ?? "username";
        return lastAuthUser;
    }
    async setOAuthMetadata(metadata) {
        const { oauthMetadata: oauthMetadataKey  } = await this.getAuthKeys();
        await this.getKeyValueStorage().setItem(oauthMetadataKey, JSON.stringify(metadata));
    }
    async getOAuthMetadata() {
        const { oauthMetadata: oauthMetadataKey  } = await this.getAuthKeys();
        const oauthMetadata = await this.getKeyValueStorage().getItem(oauthMetadataKey);
        return oauthMetadata && JSON.parse(oauthMetadata);
    }
}
const $36e2942275e8945a$export$4647c72f6828a74d = (provider, identifier)=>{
    return $36e2942275e8945a$export$dfb8da757ca62eed((0, $51fefc0f242b4091$export$b8429d1428aad8ba))(`${provider}`, identifier);
};
function $36e2942275e8945a$export$dfb8da757ca62eed(authKeys) {
    const keys = Object.values({
        ...authKeys
    });
    return (prefix, identifier)=>keys.reduce((acc, authKey)=>({
                ...acc,
                [authKey]: `${prefix}.${identifier}.${authKey}`
            }), {});
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $9c6e28f6741ba4d6$export$dad1700b96c3a835 = {
    identityId: "identityId"
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $6597ba25b1800063$var$logger = new (0, $39a0f4f2bf9492b0$export$ba6a9c7ac8291f7f)("DefaultIdentityIdStore");
class $6597ba25b1800063$export$3e97b78667a539a0 {
    setAuthConfig(authConfigParam) {
        (0, $da35d46b99b5d98d$export$8a2f5318ea3215e3)(authConfigParam.Cognito);
        this.authConfig = authConfigParam;
        this._authKeys = $6597ba25b1800063$var$createKeysForAuthStorage("Cognito", authConfigParam.Cognito.identityPoolId);
    }
    constructor(keyValueStorage){
        this._authKeys = {};
        this._hasGuestIdentityId = false;
        this.keyValueStorage = keyValueStorage;
    }
    async loadIdentityId() {
        (0, $da35d46b99b5d98d$export$8a2f5318ea3215e3)(this.authConfig?.Cognito);
        try {
            if (this._primaryIdentityId) return {
                id: this._primaryIdentityId,
                type: "primary"
            };
            else {
                const storedIdentityId = await this.keyValueStorage.getItem(this._authKeys.identityId);
                if (storedIdentityId) {
                    this._hasGuestIdentityId = true;
                    return {
                        id: storedIdentityId,
                        type: "guest"
                    };
                }
                return null;
            }
        } catch (err) {
            $6597ba25b1800063$var$logger.log("Error getting stored IdentityId.", err);
            return null;
        }
    }
    async storeIdentityId(identity) {
        (0, $da35d46b99b5d98d$export$8a2f5318ea3215e3)(this.authConfig?.Cognito);
        if (identity.type === "guest") {
            this.keyValueStorage.setItem(this._authKeys.identityId, identity.id);
            // Clear in-memory storage of primary identityId
            this._primaryIdentityId = undefined;
            this._hasGuestIdentityId = true;
        } else {
            this._primaryIdentityId = identity.id;
            // Clear locally stored guest id
            if (this._hasGuestIdentityId) {
                this.keyValueStorage.removeItem(this._authKeys.identityId);
                this._hasGuestIdentityId = false;
            }
        }
    }
    async clearIdentityId() {
        this._primaryIdentityId = undefined;
        await this.keyValueStorage.removeItem(this._authKeys.identityId);
    }
}
const $6597ba25b1800063$var$createKeysForAuthStorage = (provider, identifier)=>{
    return (0, $36e2942275e8945a$export$dfb8da757ca62eed)((0, $9c6e28f6741ba4d6$export$dad1700b96c3a835))(`com.amplify.${provider}`, identifier);
};








// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $ad9ac2a297598208$export$978f9418fe0cb26c = (response)=>{
    const { headers: headers , statusCode: statusCode  } = response;
    return {
        ...$ad9ac2a297598208$var$isMetadataBearer(response) ? response.$metadata : {},
        httpStatusCode: statusCode,
        requestId: headers["x-amzn-requestid"] ?? headers["x-amzn-request-id"] ?? headers["x-amz-request-id"],
        extendedRequestId: headers["x-amz-id-2"],
        cfId: headers["x-amz-cf-id"]
    };
};
const $ad9ac2a297598208$var$isMetadataBearer = (response)=>typeof response?.$metadata === "object";



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Utility functions for serializing and deserializing of JSON protocol in general(including: REST-JSON, JSON-RPC, etc.)
 */ /**
 * Error parser for AWS JSON protocol.
 */ const $c9219ddc4f5544cf$export$be467dfcc0538e25 = async (response)=>{
    if (!response || response.statusCode < 300) return;
    const body = await $c9219ddc4f5544cf$export$759bcb35b0d1bf81(response);
    const sanitizeErrorCode = (rawValue)=>{
        const [cleanValue] = rawValue.toString().split(/[,:]+/);
        if (cleanValue.includes("#")) return cleanValue.split("#")[1];
        return cleanValue;
    };
    const code = sanitizeErrorCode(response.headers["x-amzn-errortype"] ?? body.code ?? body.__type ?? "UnknownError");
    const message = body.message ?? body.Message ?? "Unknown error";
    const error = new Error(message);
    return Object.assign(error, {
        name: code,
        $metadata: (0, $ad9ac2a297598208$export$978f9418fe0cb26c)(response)
    });
};
/**
 * Parse JSON response body to JavaScript object.
 */ const $c9219ddc4f5544cf$export$759bcb35b0d1bf81 = async (response)=>{
    if (!response.body) throw new Error("Missing response payload");
    const output = await response.body.json();
    return Object.assign(output, {
        $metadata: (0, $ad9ac2a297598208$export$978f9418fe0cb26c)(response)
    });
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Compose a service API handler that accepts input as defined shape and responds conforming to defined output shape.
 * A service API handler is composed with:
 * * A transfer handler
 * * A serializer function
 * * A deserializer function
 * * A default config object
 *
 * The returned service API handler, when called, will trigger the following workflow:
 * 1. When calling the service API handler function, the default config object is merged into the input config
 * object to assign the default values of some omitted configs, resulting to a resolved config object.
 * 2. The `endpointResolver` function from the default config object will be invoked with the resolved config object and
 * API input object resulting to an endpoint instance.
 * 3. The serializer function is invoked with API input object and the endpoint instance resulting to an HTTP request
 * instance.
 * 4. The HTTP request instance and the resolved config object is passed to the transfer handler function.
 * 5. The transfer handler function resolves to an HTTP response instance(can be either successful or failed status code).
 * 6. The deserializer function is invoked with the HTTP response instance resulting to the API output object, and
 * return to the caller.
 *
 *
 * @param transferHandler Async function for dispatching HTTP requests and returning HTTP response.
 * @param serializer  Async function for converting object in defined input shape into HTTP request targeting a given
 * 	endpoint.
 * @param deserializer Async function for converting HTTP response into output object in defined output shape, or error
 * 	shape.
 * @param defaultConfig  object containing default options to be consumed by transfer handler, serializer and
 *  deserializer.
 * @returns a async service API handler function that accepts a config object and input object in defined shape, returns
 * 	an output object in defined shape. It may also throw error instance in defined shape in deserializer. The config
 *  object type is composed with options type of transferHandler, endpointResolver function as well as endpointResolver
 *  function's input options type, region string. The config object property will be marked as optional if it's also
 * 	defined in defaultConfig.
 *
 * @internal
 */ const $29600698f92385b7$export$880429a8ae983d4d = (transferHandler, serializer, deserializer, defaultConfig)=>{
    return async (config, input)=>{
        const resolvedConfig = {
            ...defaultConfig,
            ...config
        };
        // We need to allow different endpoints based on both given config(other than region) and input.
        // However for most of non-S3 services, region is the only input for endpoint resolver.
        const endpoint = await resolvedConfig.endpointResolver(resolvedConfig, input);
        // Unlike AWS SDK clients, a serializer should NOT populate the `host` or `content-length` headers.
        // Both of these headers are prohibited per Spec(https://developer.mozilla.org/en-US/docs/Glossary/Forbidden_header_name).
        // They will be populated automatically by browser, or node-fetch polyfill.
        const request = await serializer(input, endpoint);
        const response = await transferHandler(request, {
            ...resolvedConfig
        });
        return deserializer(response);
    };
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Default partition for AWS services. This is used when the region is not provided or the region is not recognized.
 *
 * @internal
 */ const $5d2942164da17ff7$export$72f3cee421ee8a74 = {
    id: "aws",
    outputs: {
        dnsSuffix: "amazonaws.com"
    },
    regionRegex: "^(us|eu|ap|sa|ca|me|af)\\-\\w+\\-\\d+$",
    regions: [
        "aws-global"
    ]
};
/**
 * This data is adapted from the partition file from AWS SDK shared utilities but remove some contents for bundle size
 * concern. Information removed are `dualStackDnsSuffix`, `supportDualStack`, `supportFIPS`, restricted partitions, and
 * list of regions for each partition other than global regions.
 *
 * * Ref: https://docs.aws.amazon.com/general/latest/gr/rande.html#regional-endpoints
 * * Ref: https://github.com/aws/aws-sdk-js-v3/blob/0201baef03c2379f1f6f7150b9d401d4b230d488/packages/util-endpoints/src/lib/aws/partitions.json#L1
 *
 * @internal
 */ const $5d2942164da17ff7$export$d7c12af0c0f12206 = {
    partitions: [
        $5d2942164da17ff7$export$72f3cee421ee8a74,
        {
            id: "aws-cn",
            outputs: {
                dnsSuffix: "amazonaws.com.cn"
            },
            regionRegex: "^cn\\-\\w+\\-\\d+$",
            regions: [
                "aws-cn-global"
            ]
        }
    ]
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Get the AWS Services endpoint URL's DNS suffix for a given region. A typical AWS regional service endpoint URL will
 * follow this pattern: {endpointPrefix}.{region}.{dnsSuffix}. For example, the endpoint URL for Cognito Identity in
 * us-east-1 will be cognito-identity.us-east-1.amazonaws.com. Here the DnsSuffix is `amazonaws.com`.
 *
 * @param region
 * @returns The DNS suffix
 *
 * @internal
 */ const $f91fa1e3d8be306f$export$1c28e37cdcc37f6d = (region)=>{
    const { partitions: partitions  } = (0, $5d2942164da17ff7$export$d7c12af0c0f12206);
    for (const { regions: regions , outputs: outputs , regionRegex: regionRegex  } of partitions){
        const regex = new RegExp(regionRegex);
        if (regions.includes(region) || regex.test(region)) return outputs.dnsSuffix;
    }
    return (0, $5d2942164da17ff7$export$72f3cee421ee8a74).outputs.dnsSuffix;
};




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $802afeb1ad7c8f0f$var$DEFAULT_RETRY_ATTEMPTS = 3;
/**
 * Retry middleware
 */ const $802afeb1ad7c8f0f$export$72f002d3da1a429f = ({ maxAttempts: maxAttempts = $802afeb1ad7c8f0f$var$DEFAULT_RETRY_ATTEMPTS , retryDecider: retryDecider , computeDelay: computeDelay , abortSignal: abortSignal  })=>{
    if (maxAttempts < 1) throw new Error("maxAttempts must be greater than 0");
    return (next, context)=>async function retryMiddleware(request) {
            let error;
            let attemptsCount = context.attemptsCount ?? 0;
            let response;
            // When retry is not needed or max attempts is reached, either error or response will be set. This function handles either cases.
            const handleTerminalErrorOrResponse = ()=>{
                if (response) {
                    $802afeb1ad7c8f0f$var$addOrIncrementMetadataAttempts(response, attemptsCount);
                    return response;
                } else {
                    $802afeb1ad7c8f0f$var$addOrIncrementMetadataAttempts(error, attemptsCount);
                    throw error;
                }
            };
            while(!abortSignal?.aborted && attemptsCount < maxAttempts){
                try {
                    response = await next(request);
                    error = undefined;
                } catch (e) {
                    error = e;
                    response = undefined;
                }
                // context.attemptsCount may be updated after calling next handler which may retry the request by itself.
                attemptsCount = (context.attemptsCount ?? 0) > attemptsCount ? context.attemptsCount ?? 0 : attemptsCount + 1;
                context.attemptsCount = attemptsCount;
                const { isCredentialsExpiredError: isCredentialsExpiredError , retryable: retryable  } = await retryDecider(response, error, context);
                if (retryable) {
                    // Setting isCredentialsInvalid flag to notify signing middleware to forceRefresh credentials provider.
                    context.isCredentialsExpired = !!isCredentialsExpiredError;
                    if (!abortSignal?.aborted && attemptsCount < maxAttempts) {
                        // prevent sleep for last attempt or cancelled request;
                        const delay = computeDelay(attemptsCount);
                        await $802afeb1ad7c8f0f$var$cancellableSleep(delay, abortSignal);
                    }
                    continue;
                } else return handleTerminalErrorOrResponse();
            }
            if (abortSignal?.aborted) throw new Error("Request aborted.");
            else return handleTerminalErrorOrResponse();
        };
};
const $802afeb1ad7c8f0f$var$cancellableSleep = (timeoutMs, abortSignal)=>{
    if (abortSignal?.aborted) return Promise.resolve();
    let timeoutId;
    let sleepPromiseResolveFn;
    const sleepPromise = new Promise((resolve)=>{
        sleepPromiseResolveFn = resolve;
        timeoutId = setTimeout(resolve, timeoutMs);
    });
    abortSignal?.addEventListener("abort", function cancelSleep(_) {
        clearTimeout(timeoutId);
        abortSignal?.removeEventListener("abort", cancelSleep);
        sleepPromiseResolveFn();
    });
    return sleepPromise;
};
const $802afeb1ad7c8f0f$var$addOrIncrementMetadataAttempts = (nextHandlerOutput, attempts)=>{
    if (Object.prototype.toString.call(nextHandlerOutput) !== "[object Object]") return;
    nextHandlerOutput.$metadata = {
        ...nextHandlerOutput.$metadata ?? {},
        attempts: attempts
    };
};





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Middleware injects user agent string to specified header(default to 'x-amz-user-agent'),
 * if the header is not set already.
 *
 * TODO: incorporate new user agent design
 */ const $515400266cf6cb5b$export$ff28171a05413bc5 = ({ userAgentHeader: userAgentHeader = "x-amz-user-agent" , userAgentValue: userAgentValue = ""  })=>(next)=>{
        return async function userAgentMiddleware(request) {
            if (userAgentValue.trim().length === 0) {
                const result = await next(request);
                return result;
            } else {
                const headerName = userAgentHeader.toLowerCase();
                request.headers[headerName] = request.headers[headerName] ? `${request.headers[headerName]} ${userAgentValue}` : userAgentValue;
                const response = await next(request);
                return response;
            }
        };
    };


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Compose a transfer handler with a core transfer handler and a list of middleware.
 * @param coreHandler Core transfer handler
 * @param middleware	List of middleware
 * @returns A transfer handler whose option type is the union of the core
 * 	transfer handler's option type and the middleware's option type.
 * @internal
 */ const $a989f58fee6d43e0$export$f074d76e52925468 = (coreHandler, middleware)=>(request, options)=>{
        const context = {};
        let composedHandler = (composeHandlerRequest)=>coreHandler(composeHandlerRequest, options);
        for(let i = middleware.length - 1; i >= 0; i--){
            const m = middleware[i];
            const resolvedMiddleware = m(options);
            composedHandler = resolvedMiddleware(composedHandler, context);
        }
        return composedHandler(request);
    };





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Cache the payload of a response body. It allows multiple calls to the body,
 * for example, when reading the body in both retry decider and error deserializer.
 * Caching body is allowed here because we call the body accessor(blob(), json(),
 * etc.) when body is small or streaming implementation is not available(RN).
 *
 * @internal
 */ const $bdc6a88d25bd6134$export$580ad1ce15092b15 = (payloadAccessor)=>{
    let cached;
    return ()=>{
        if (!cached) // Explicitly not awaiting. Intermediate await would add overhead and
        // introduce a possible race in the event that this wrapper is called
        // again before the first `payloadAccessor` call resolves.
        cached = payloadAccessor();
        return cached;
    };
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $4b0d223caa1b6173$var$shouldSendBody = (method)=>![
        "HEAD",
        "GET",
        "DELETE"
    ].includes(method.toUpperCase());
// TODO[AllanZhengYP]: we need to provide isCanceledError utility
const $4b0d223caa1b6173$export$d2573baf35521e4c = async ({ url: url , method: method , headers: headers , body: body  }, { abortSignal: abortSignal , cache: cache , withCrossDomainCredentials: withCrossDomainCredentials  })=>{
    let resp;
    try {
        resp = await fetch(url, {
            method: method,
            headers: headers,
            body: $4b0d223caa1b6173$var$shouldSendBody(method) ? body : undefined,
            signal: abortSignal,
            cache: cache,
            credentials: withCrossDomainCredentials ? "include" : "same-origin"
        });
    } catch (e) {
        if (e instanceof TypeError) throw new (0, $d153492e067ac8ab$export$37321a6dace1881c)({
            name: (0, $f5d3b7601afe1953$export$4e712df6b850c8d0).NetworkError,
            message: "A network error has occurred.",
            underlyingError: e
        });
        throw e;
    }
    const responseHeaders = {};
    resp.headers?.forEach((value, key)=>{
        responseHeaders[key.toLowerCase()] = value;
    });
    const httpResponse = {
        statusCode: resp.status,
        headers: responseHeaders,
        body: null
    };
    // resp.body is a ReadableStream according to Fetch API spec, but React Native
    // does not implement it.
    const bodyWithMixin = Object.assign(resp.body ?? {}, {
        text: (0, $bdc6a88d25bd6134$export$580ad1ce15092b15)(()=>resp.text()),
        blob: (0, $bdc6a88d25bd6134$export$580ad1ce15092b15)(()=>resp.blob()),
        json: (0, $bdc6a88d25bd6134$export$580ad1ce15092b15)(()=>resp.json())
    });
    return {
        ...httpResponse,
        body: bodyWithMixin
    };
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $06a5c13f13cb78e5$export$ed7e1ccf00f39c4a = (0, $a989f58fee6d43e0$export$f074d76e52925468)((0, $4b0d223caa1b6173$export$d2573baf35521e4c), [
    (0, $515400266cf6cb5b$export$ff28171a05413bc5),
    (0, $802afeb1ad7c8f0f$export$72f002d3da1a429f)
]);



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $55c3deaff7ce43ff$export$76041b1400befb8b = 300000;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @private
 * Internal use of Amplify only
 */ function $ebf615981b3eb20c$export$caea50bde345f648(maxDelayMs = (0, $55c3deaff7ce43ff$export$76041b1400befb8b)) {
    const BASE_TIME_MS = 100;
    const JITTER_FACTOR = 100;
    return (attempt)=>{
        const delay = 2 ** attempt * BASE_TIME_MS + JITTER_FACTOR * Math.random();
        return delay > maxDelayMs ? false : delay;
    };
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// TODO: [v6] The separate retry utility is used by Data packages now and will replaced by retry middleware.
const $46ded7b7e9d65568$var$DEFAULT_MAX_DELAY_MS = 300000;
const $46ded7b7e9d65568$export$caea50bde345f648 = (attempt)=>{
    const delayFunction = (0, $ebf615981b3eb20c$export$caea50bde345f648)($46ded7b7e9d65568$var$DEFAULT_MAX_DELAY_MS);
    const delay = delayFunction(attempt);
    // The delayFunction returns false when the delay is greater than the max delay(5 mins).
    // In this case, the retry middleware will delay 5 mins instead, as a ceiling of the delay.
    return delay === false ? $46ded7b7e9d65568$var$DEFAULT_MAX_DELAY_MS : delay;
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// via https://github.com/aws/aws-sdk-js-v3/blob/ab0e7be36e7e7f8a0c04834357aaad643c7912c3/packages/service-error-classification/src/constants.ts#L8
const $53f6ccb7532bc03d$var$CLOCK_SKEW_ERROR_CODES = [
    "AuthFailure",
    "InvalidSignatureException",
    "RequestExpired",
    "RequestInTheFuture",
    "RequestTimeTooSkewed",
    "SignatureDoesNotMatch",
    "BadRequestException"
];
/**
 * Given an error code, returns true if it is related to a clock skew error.
 *
 * @param errorCode String representation of some error.
 * @returns True if given error is present in `CLOCK_SKEW_ERROR_CODES`, false otherwise.
 *
 * @internal
 */ const $53f6ccb7532bc03d$export$7b87435661177a94 = (errorCode)=>!!errorCode && $53f6ccb7532bc03d$var$CLOCK_SKEW_ERROR_CODES.includes(errorCode);


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Get retry decider function
 * @param errorParser Function to load JavaScript error from HTTP response
 */ const $006c1d5500f41923$export$b919d98317a7685f = (errorParser)=>async (response, error)=>{
        const parsedError = error ?? await errorParser(response) ?? undefined;
        const errorCode = parsedError?.code || parsedError?.name;
        const statusCode = response?.statusCode;
        const isRetryable = $006c1d5500f41923$var$isConnectionError(error) || $006c1d5500f41923$var$isThrottlingError(statusCode, errorCode) || (0, $53f6ccb7532bc03d$export$7b87435661177a94)(errorCode) || $006c1d5500f41923$var$isServerSideError(statusCode, errorCode);
        return {
            retryable: isRetryable
        };
    };
// reference: https://github.com/aws/aws-sdk-js-v3/blob/ab0e7be36e7e7f8a0c04834357aaad643c7912c3/packages/service-error-classification/src/constants.ts#L22-L37
const $006c1d5500f41923$var$THROTTLING_ERROR_CODES = [
    "BandwidthLimitExceeded",
    "EC2ThrottledException",
    "LimitExceededException",
    "PriorRequestNotComplete",
    "ProvisionedThroughputExceededException",
    "RequestLimitExceeded",
    "RequestThrottled",
    "RequestThrottledException",
    "SlowDown",
    "ThrottledException",
    "Throttling",
    "ThrottlingException",
    "TooManyRequestsException"
];
const $006c1d5500f41923$var$TIMEOUT_ERROR_CODES = [
    "TimeoutError",
    "RequestTimeout",
    "RequestTimeoutException"
];
const $006c1d5500f41923$var$isThrottlingError = (statusCode, errorCode)=>statusCode === 429 || !!errorCode && $006c1d5500f41923$var$THROTTLING_ERROR_CODES.includes(errorCode);
const $006c1d5500f41923$var$isConnectionError = (error)=>[
        (0, $f5d3b7601afe1953$export$4e712df6b850c8d0).NetworkError,
        // TODO(vNext): unify the error code `ERR_NETWORK` used by the Storage XHR handler
        "ERR_NETWORK"
    ].includes(error?.name);
const $006c1d5500f41923$var$isServerSideError = (statusCode, errorCode)=>!!statusCode && [
        500,
        502,
        503,
        504
    ].includes(statusCode) || !!errorCode && $006c1d5500f41923$var$TIMEOUT_ERROR_CODES.includes(errorCode);




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $b0f1ea60776570d9$export$beb82d9d9136c16e = URL;
const $b0f1ea60776570d9$export$4ea7bbdac595b5fb = URLSearchParams;




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $80240862ea60f1f3$export$638889172ebce0c4;
(function(Framework) {
    // < 100 - Web frameworks
    Framework["WebUnknown"] = "0";
    Framework["React"] = "1";
    Framework["NextJs"] = "2";
    Framework["Angular"] = "3";
    Framework["VueJs"] = "4";
    Framework["Nuxt"] = "5";
    Framework["Svelte"] = "6";
    // 100s - Server side frameworks
    Framework["ServerSideUnknown"] = "100";
    Framework["ReactSSR"] = "101";
    Framework["NextJsSSR"] = "102";
    Framework["AngularSSR"] = "103";
    Framework["VueJsSSR"] = "104";
    Framework["NuxtSSR"] = "105";
    Framework["SvelteSSR"] = "106";
    // 200s - Mobile framework
    Framework["ReactNative"] = "201";
    Framework["Expo"] = "202";
})($80240862ea60f1f3$export$638889172ebce0c4 || ($80240862ea60f1f3$export$638889172ebce0c4 = {}));
var $80240862ea60f1f3$export$3a8840c5b2ecf003;
(function(Category) {
    Category["AI"] = "ai";
    Category["API"] = "api";
    Category["Auth"] = "auth";
    Category["Analytics"] = "analytics";
    Category["DataStore"] = "datastore";
    Category["Geo"] = "geo";
    Category["InAppMessaging"] = "inappmessaging";
    Category["Interactions"] = "interactions";
    Category["Predictions"] = "predictions";
    Category["PubSub"] = "pubsub";
    Category["PushNotification"] = "pushnotification";
    Category["Storage"] = "storage";
})($80240862ea60f1f3$export$3a8840c5b2ecf003 || ($80240862ea60f1f3$export$3a8840c5b2ecf003 = {}));
var $80240862ea60f1f3$export$89656a7f296a8665;
(function(AiAction) {
    AiAction["CreateConversation"] = "1";
    AiAction["GetConversation"] = "2";
    AiAction["ListConversations"] = "3";
    AiAction["DeleteConversation"] = "4";
    AiAction["SendMessage"] = "5";
    AiAction["ListMessages"] = "6";
    AiAction["OnMessage"] = "7";
    AiAction["Generation"] = "8";
    AiAction["UpdateConversation"] = "9";
})($80240862ea60f1f3$export$89656a7f296a8665 || ($80240862ea60f1f3$export$89656a7f296a8665 = {}));
var $80240862ea60f1f3$export$30c16f5c43437fd7;
(function(AnalyticsAction) {
    AnalyticsAction["Record"] = "1";
    AnalyticsAction["IdentifyUser"] = "2";
})($80240862ea60f1f3$export$30c16f5c43437fd7 || ($80240862ea60f1f3$export$30c16f5c43437fd7 = {}));
var $80240862ea60f1f3$export$126e20fdc0f0d34b;
(function(ApiAction) {
    ApiAction["GraphQl"] = "1";
    ApiAction["Get"] = "2";
    ApiAction["Post"] = "3";
    ApiAction["Put"] = "4";
    ApiAction["Patch"] = "5";
    ApiAction["Del"] = "6";
    ApiAction["Head"] = "7";
})($80240862ea60f1f3$export$126e20fdc0f0d34b || ($80240862ea60f1f3$export$126e20fdc0f0d34b = {}));
var $80240862ea60f1f3$export$900b1436d7e65f4;
(function(AuthAction) {
    AuthAction["SignUp"] = "1";
    AuthAction["ConfirmSignUp"] = "2";
    AuthAction["ResendSignUpCode"] = "3";
    AuthAction["SignIn"] = "4";
    AuthAction["FetchMFAPreference"] = "6";
    AuthAction["UpdateMFAPreference"] = "7";
    AuthAction["SetUpTOTP"] = "10";
    AuthAction["VerifyTOTPSetup"] = "11";
    AuthAction["ConfirmSignIn"] = "12";
    AuthAction["DeleteUserAttributes"] = "15";
    AuthAction["DeleteUser"] = "16";
    AuthAction["UpdateUserAttributes"] = "17";
    AuthAction["FetchUserAttributes"] = "18";
    AuthAction["ConfirmUserAttribute"] = "22";
    AuthAction["SignOut"] = "26";
    AuthAction["UpdatePassword"] = "27";
    AuthAction["ResetPassword"] = "28";
    AuthAction["ConfirmResetPassword"] = "29";
    AuthAction["FederatedSignIn"] = "30";
    AuthAction["RememberDevice"] = "32";
    AuthAction["ForgetDevice"] = "33";
    AuthAction["FetchDevices"] = "34";
    AuthAction["SendUserAttributeVerificationCode"] = "35";
    AuthAction["SignInWithRedirect"] = "36";
    AuthAction["StartWebAuthnRegistration"] = "37";
    AuthAction["CompleteWebAuthnRegistration"] = "38";
    AuthAction["ListWebAuthnCredentials"] = "39";
    AuthAction["DeleteWebAuthnCredential"] = "40";
})($80240862ea60f1f3$export$900b1436d7e65f4 || ($80240862ea60f1f3$export$900b1436d7e65f4 = {}));
var $80240862ea60f1f3$export$2f5a715aba4cde93;
(function(DataStoreAction) {
    DataStoreAction["Subscribe"] = "1";
    DataStoreAction["GraphQl"] = "2";
})($80240862ea60f1f3$export$2f5a715aba4cde93 || ($80240862ea60f1f3$export$2f5a715aba4cde93 = {}));
var $80240862ea60f1f3$export$afafab3eb8fc6fef;
(function(GeoAction) {
    GeoAction["SearchByText"] = "0";
    GeoAction["SearchByCoordinates"] = "1";
    GeoAction["SearchForSuggestions"] = "2";
    GeoAction["SearchByPlaceId"] = "3";
    GeoAction["SaveGeofences"] = "4";
    GeoAction["GetGeofence"] = "5";
    GeoAction["ListGeofences"] = "6";
    GeoAction["DeleteGeofences"] = "7";
})($80240862ea60f1f3$export$afafab3eb8fc6fef || ($80240862ea60f1f3$export$afafab3eb8fc6fef = {}));
var $80240862ea60f1f3$export$c01a8c16ffda791e;
(function(InAppMessagingAction) {
    InAppMessagingAction["SyncMessages"] = "1";
    InAppMessagingAction["IdentifyUser"] = "2";
    InAppMessagingAction["NotifyMessageInteraction"] = "3";
})($80240862ea60f1f3$export$c01a8c16ffda791e || ($80240862ea60f1f3$export$c01a8c16ffda791e = {}));
var $80240862ea60f1f3$export$68e0695a774ab7fa;
(function(InteractionsAction) {
    InteractionsAction["None"] = "0";
})($80240862ea60f1f3$export$68e0695a774ab7fa || ($80240862ea60f1f3$export$68e0695a774ab7fa = {}));
var $80240862ea60f1f3$export$aa89b4c447a07cee;
(function(PredictionsAction) {
    PredictionsAction["Convert"] = "1";
    PredictionsAction["Identify"] = "2";
    PredictionsAction["Interpret"] = "3";
})($80240862ea60f1f3$export$aa89b4c447a07cee || ($80240862ea60f1f3$export$aa89b4c447a07cee = {}));
var $80240862ea60f1f3$export$ade48b30f1e78672;
(function(PubSubAction) {
    PubSubAction["Subscribe"] = "1";
})($80240862ea60f1f3$export$ade48b30f1e78672 || ($80240862ea60f1f3$export$ade48b30f1e78672 = {}));
var $80240862ea60f1f3$export$2c5ee06ab9fa5040;
(function(PushNotificationAction) {
    PushNotificationAction["InitializePushNotifications"] = "1";
    PushNotificationAction["IdentifyUser"] = "2";
})($80240862ea60f1f3$export$2c5ee06ab9fa5040 || ($80240862ea60f1f3$export$2c5ee06ab9fa5040 = {}));
var $80240862ea60f1f3$export$d4f3c54b808b00ce;
(function(StorageAction) {
    StorageAction["UploadData"] = "1";
    StorageAction["DownloadData"] = "2";
    StorageAction["List"] = "3";
    StorageAction["Copy"] = "4";
    StorageAction["Remove"] = "5";
    StorageAction["GetProperties"] = "6";
    StorageAction["GetUrl"] = "7";
    StorageAction["GetDataAccess"] = "8";
    StorageAction["ListCallerAccessGrants"] = "9";
})($80240862ea60f1f3$export$d4f3c54b808b00ce || ($80240862ea60f1f3$export$d4f3c54b808b00ce = {}));


// generated by genversion
const $61dcbfd9387cc58d$export$83d89fbfd8236492 = "6.11.0";




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

const $07a5cc9121afbe58$export$a15eed0e463030a9 = ()=>{
    return typeof $parcel$global !== "undefined";
};
const $07a5cc9121afbe58$export$a5e7eb32e5221222 = ()=>{
    return typeof globalThis !== "undefined";
};
const $07a5cc9121afbe58$export$daba2802a1a41c1f = ()=>{
    return typeof window !== "undefined";
};
const $07a5cc9121afbe58$export$b949ebcb877faa59 = ()=>{
    return typeof document !== "undefined";
};
const $07a5cc9121afbe58$export$ba10401363d0f7f6 = ()=>{
    return typeof $391299e0893a3dfa$exports !== "undefined";
};
const $07a5cc9121afbe58$export$252f88727cff70c7 = (object, prefix)=>{
    return !!Object.keys(object).find((key)=>key.startsWith(prefix));
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with react 18.2 - built using Vite
function $bcfa9edffcd864f0$export$ba3f37c54f0f7805() {
    const elementKeyPrefixedWithReact = (key)=>{
        return key.startsWith("_react") || key.startsWith("__react");
    };
    const elementIsReactEnabled = (element)=>{
        return Object.keys(element).find(elementKeyPrefixedWithReact);
    };
    const allElementsWithId = ()=>Array.from(document.querySelectorAll("[id]"));
    return (0, $07a5cc9121afbe58$export$b949ebcb877faa59)() && allElementsWithId().some(elementIsReactEnabled);
}
function $bcfa9edffcd864f0$export$86269c582305790() {
    return (0, $07a5cc9121afbe58$export$ba10401363d0f7f6)() && typeof $391299e0893a3dfa$exports.env !== "undefined" && !!Object.keys($391299e0893a3dfa$exports.env).find((key)=>key.includes("react"));
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with vue 3.3.2
function $4882a2b989e1c3eb$export$d91d90d62b78936d() {
    return (0, $07a5cc9121afbe58$export$daba2802a1a41c1f)() && (0, $07a5cc9121afbe58$export$252f88727cff70c7)(window, "__VUE");
}
function $4882a2b989e1c3eb$export$257a4c0f8294a101() {
    return (0, $07a5cc9121afbe58$export$a15eed0e463030a9)() && (0, $07a5cc9121afbe58$export$252f88727cff70c7)($parcel$global, "__VUE");
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with svelte 3.59
function $0c517a50b1eac5d6$export$6dafc32a94edaed3() {
    return (0, $07a5cc9121afbe58$export$daba2802a1a41c1f)() && (0, $07a5cc9121afbe58$export$252f88727cff70c7)(window, "__SVELTE");
}
function $0c517a50b1eac5d6$export$819dcb7fe144d8b0() {
    return (0, $07a5cc9121afbe58$export$ba10401363d0f7f6)() && typeof $391299e0893a3dfa$exports.env !== "undefined" && !!Object.keys($391299e0893a3dfa$exports.env).find((key)=>key.includes("svelte"));
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with next 13.4 / react 18.2
function $1b543a05b969025e$export$f8462bcf03110eff() {
    return (0, $07a5cc9121afbe58$export$daba2802a1a41c1f)() && window.next && typeof window.next === "object";
}
function $1b543a05b969025e$export$61c08ed144a5d4ca() {
    return (0, $07a5cc9121afbe58$export$a15eed0e463030a9)() && ((0, $07a5cc9121afbe58$export$252f88727cff70c7)($parcel$global, "__next") || (0, $07a5cc9121afbe58$export$252f88727cff70c7)($parcel$global, "__NEXT"));
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with nuxt 2.15 / vue 2.7
function $54456e2dc9ae4c87$export$bed54a4e6d9d25fb() {
    return (0, $07a5cc9121afbe58$export$daba2802a1a41c1f)() && (window.__NUXT__ !== undefined || window.$nuxt !== undefined);
}
function $54456e2dc9ae4c87$export$fb3ce982948d27e8() {
    return (0, $07a5cc9121afbe58$export$a15eed0e463030a9)() && typeof $parcel$global.__NUXT_PATHS__ !== "undefined";
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with @angular/core 16.0.0
function $24d63ab186dd89d1$export$b5a20bd39eb02ba0() {
    const angularVersionSetInDocument = Boolean((0, $07a5cc9121afbe58$export$b949ebcb877faa59)() && document.querySelector("[ng-version]"));
    const angularContentSetInWindow = Boolean((0, $07a5cc9121afbe58$export$daba2802a1a41c1f)() && typeof window.ng !== "undefined");
    return angularVersionSetInDocument || angularContentSetInWindow;
}
function $24d63ab186dd89d1$export$8ab518c8987c870f() {
    return (0, $07a5cc9121afbe58$export$ba10401363d0f7f6)() && typeof $391299e0893a3dfa$exports.env === "object" && undefined?.startsWith("ng ") || false;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with react-native 0.17.7
function $3c908fced1c0b9b0$export$1c8414c1859e3748() {
    return typeof navigator !== "undefined" && typeof navigator.product !== "undefined" && navigator.product === "ReactNative";
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with expo 48 / react-native 0.71.3
function $0634f71a29d835cd$export$85fd46d5e29a4f7e() {
    return (0, $07a5cc9121afbe58$export$a15eed0e463030a9)() && typeof $parcel$global.expo !== "undefined";
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $4e84bc68b3a29494$export$41b1270b988065fb() {
    return (0, $07a5cc9121afbe58$export$daba2802a1a41c1f)();
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// These are in the order of detection where when both are detectable, the early Framework will be reported
const $8eae9bb90d2a57f8$var$detectionMap = [
    // First, detect mobile
    {
        platform: (0, $80240862ea60f1f3$export$638889172ebce0c4).Expo,
        detectionMethod: (0, $0634f71a29d835cd$export$85fd46d5e29a4f7e)
    },
    {
        platform: (0, $80240862ea60f1f3$export$638889172ebce0c4).ReactNative,
        detectionMethod: (0, $3c908fced1c0b9b0$export$1c8414c1859e3748)
    },
    // Next, detect web frameworks
    {
        platform: (0, $80240862ea60f1f3$export$638889172ebce0c4).NextJs,
        detectionMethod: (0, $1b543a05b969025e$export$f8462bcf03110eff)
    },
    {
        platform: (0, $80240862ea60f1f3$export$638889172ebce0c4).Nuxt,
        detectionMethod: (0, $54456e2dc9ae4c87$export$bed54a4e6d9d25fb)
    },
    {
        platform: (0, $80240862ea60f1f3$export$638889172ebce0c4).Angular,
        detectionMethod: (0, $24d63ab186dd89d1$export$b5a20bd39eb02ba0)
    },
    {
        platform: (0, $80240862ea60f1f3$export$638889172ebce0c4).React,
        detectionMethod: (0, $bcfa9edffcd864f0$export$ba3f37c54f0f7805)
    },
    {
        platform: (0, $80240862ea60f1f3$export$638889172ebce0c4).VueJs,
        detectionMethod: (0, $4882a2b989e1c3eb$export$d91d90d62b78936d)
    },
    {
        platform: (0, $80240862ea60f1f3$export$638889172ebce0c4).Svelte,
        detectionMethod: (0, $0c517a50b1eac5d6$export$6dafc32a94edaed3)
    },
    {
        platform: (0, $80240862ea60f1f3$export$638889172ebce0c4).WebUnknown,
        detectionMethod: (0, $4e84bc68b3a29494$export$41b1270b988065fb)
    },
    // Last, detect ssr frameworks
    {
        platform: (0, $80240862ea60f1f3$export$638889172ebce0c4).NextJsSSR,
        detectionMethod: (0, $1b543a05b969025e$export$61c08ed144a5d4ca)
    },
    {
        platform: (0, $80240862ea60f1f3$export$638889172ebce0c4).NuxtSSR,
        detectionMethod: (0, $54456e2dc9ae4c87$export$fb3ce982948d27e8)
    },
    {
        platform: (0, $80240862ea60f1f3$export$638889172ebce0c4).ReactSSR,
        detectionMethod: (0, $bcfa9edffcd864f0$export$86269c582305790)
    },
    {
        platform: (0, $80240862ea60f1f3$export$638889172ebce0c4).VueJsSSR,
        detectionMethod: (0, $4882a2b989e1c3eb$export$257a4c0f8294a101)
    },
    {
        platform: (0, $80240862ea60f1f3$export$638889172ebce0c4).AngularSSR,
        detectionMethod: (0, $24d63ab186dd89d1$export$8ab518c8987c870f)
    },
    {
        platform: (0, $80240862ea60f1f3$export$638889172ebce0c4).SvelteSSR,
        detectionMethod: (0, $0c517a50b1eac5d6$export$819dcb7fe144d8b0)
    }
];
function $8eae9bb90d2a57f8$export$17b446b869dad473() {
    return $8eae9bb90d2a57f8$var$detectionMap.find((detectionEntry)=>detectionEntry.detectionMethod())?.platform || (0, $80240862ea60f1f3$export$638889172ebce0c4).ServerSideUnknown;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// We want to cache detection since the framework won't change
let $3e4308e2a31b96d6$var$frameworkCache;
const $3e4308e2a31b96d6$export$d56891f33aa26edc = [];
// Setup the detection reset tracking / timeout delays
let $3e4308e2a31b96d6$var$resetTriggered = false;
const $3e4308e2a31b96d6$var$SSR_RESET_TIMEOUT = 10; // ms
const $3e4308e2a31b96d6$var$WEB_RESET_TIMEOUT = 10; // ms
const $3e4308e2a31b96d6$var$PRIME_FRAMEWORK_DELAY = 1000; // ms
const $3e4308e2a31b96d6$export$9ce73e459ec93b6a = ()=>{
    if (!$3e4308e2a31b96d6$var$frameworkCache) {
        $3e4308e2a31b96d6$var$frameworkCache = (0, $8eae9bb90d2a57f8$export$17b446b869dad473)();
        if ($3e4308e2a31b96d6$var$resetTriggered) // The final run of detectFramework:
        // Starting from this point, the `frameworkCache` becomes "final".
        // So we don't need to notify the observers again so the observer
        // can be removed after the final notice.
        while($3e4308e2a31b96d6$export$d56891f33aa26edc.length)$3e4308e2a31b96d6$export$d56891f33aa26edc.pop()?.();
        else // The first run of detectFramework:
        // Every time we update the cache, call each observer function
        $3e4308e2a31b96d6$export$d56891f33aa26edc.forEach((fcn)=>{
            fcn();
        });
        // Retry once for either Unknown type after a delay (explained below)
        $3e4308e2a31b96d6$var$resetTimeout((0, $80240862ea60f1f3$export$638889172ebce0c4).ServerSideUnknown, $3e4308e2a31b96d6$var$SSR_RESET_TIMEOUT);
        $3e4308e2a31b96d6$var$resetTimeout((0, $80240862ea60f1f3$export$638889172ebce0c4).WebUnknown, $3e4308e2a31b96d6$var$WEB_RESET_TIMEOUT);
    }
    return $3e4308e2a31b96d6$var$frameworkCache;
};
/**
 * @internal Setup observer callback that will be called everytime the framework changes
 */ const $3e4308e2a31b96d6$export$5d5c467ce0b213f = (fcn)=>{
    // When the `frameworkCache` won't be updated again, we ignore all incoming
    // observers.
    if ($3e4308e2a31b96d6$var$resetTriggered) return;
    $3e4308e2a31b96d6$export$d56891f33aa26edc.push(fcn);
};
function $3e4308e2a31b96d6$export$d2adf65b87e47523() {
    $3e4308e2a31b96d6$var$frameworkCache = undefined;
}
// For a framework type and a delay amount, setup the event to re-detect
//   During the runtime boot, it is possible that framework detection will
//   be triggered before the framework has made modifications to the
//   global/window/etc needed for detection. When no framework is detected
//   we will reset and try again to ensure we don't use a cached
//   non-framework detection result for all requests.
function $3e4308e2a31b96d6$var$resetTimeout(framework, delay) {
    if ($3e4308e2a31b96d6$var$frameworkCache === framework && !$3e4308e2a31b96d6$var$resetTriggered) setTimeout(()=>{
        $3e4308e2a31b96d6$export$d2adf65b87e47523();
        $3e4308e2a31b96d6$var$resetTriggered = true;
        setTimeout($3e4308e2a31b96d6$export$9ce73e459ec93b6a, $3e4308e2a31b96d6$var$PRIME_FRAMEWORK_DELAY);
    }, delay);
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Maintains custom user-agent state set by external consumers.
const $3e40eb963c318bdb$var$customUserAgentState = {};
/**
 * Sets custom user agent state which will be appended to applicable requests. Returns a function that can be used to
 * clean up any custom state set with this API.
 *
 * @note
 * This API operates globally. Calling this API multiple times will result in the most recently set values for a
 * particular API being used.
 *
 * @note
 * This utility IS NOT compatible with SSR.
 *
 * @param input - SetCustomUserAgentInput that defines custom state to apply to the specified APIs.
 */ const $3e40eb963c318bdb$export$20cd2fa9001e90da = (input)=>{
    // Save custom user-agent state & increment reference counter
    // TODO Remove `any` when we upgrade to TypeScript 5.2, see: https://github.com/microsoft/TypeScript/issues/44373
    $3e40eb963c318bdb$var$customUserAgentState[input.category] = input.apis.reduce((acc, api)=>({
            ...acc,
            [api]: {
                refCount: acc[api]?.refCount ? acc[api].refCount + 1 : 1,
                additionalDetails: input.additionalDetails
            }
        }), $3e40eb963c318bdb$var$customUserAgentState[input.category] ?? {});
    // Callback that cleans up state for APIs recorded by this call
    let cleanUpCallbackCalled = false;
    const cleanUpCallback = ()=>{
        // Only allow the cleanup callback to be called once
        if (cleanUpCallbackCalled) return;
        cleanUpCallbackCalled = true;
        input.apis.forEach((api)=>{
            const apiRefCount = $3e40eb963c318bdb$var$customUserAgentState[input.category][api].refCount;
            if (apiRefCount > 1) $3e40eb963c318bdb$var$customUserAgentState[input.category][api].refCount = apiRefCount - 1;
            else {
                delete $3e40eb963c318bdb$var$customUserAgentState[input.category][api];
                // Clean up category if no more APIs set
                if (!Object.keys($3e40eb963c318bdb$var$customUserAgentState[input.category]).length) delete $3e40eb963c318bdb$var$customUserAgentState[input.category];
            }
        });
    };
    return cleanUpCallback;
};
const $3e40eb963c318bdb$export$e399dbcfd99a2928 = (category, api)=>$3e40eb963c318bdb$var$customUserAgentState[category]?.[api]?.additionalDetails;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $0c7e08523dc29e90$var$BASE_USER_AGENT = `aws-amplify`;
/** Sanitize Amplify version string be removing special character + and character post the special character  */ const $0c7e08523dc29e90$export$b8f78c57ec316f83 = (amplifyVersion)=>amplifyVersion.replace(/\+.*/, "");
class $0c7e08523dc29e90$var$PlatformBuilder {
    constructor(){
        this.userAgent = `${$0c7e08523dc29e90$var$BASE_USER_AGENT}/${$0c7e08523dc29e90$export$b8f78c57ec316f83((0, $61dcbfd9387cc58d$export$83d89fbfd8236492))}`;
    }
    get framework() {
        return (0, $3e4308e2a31b96d6$export$9ce73e459ec93b6a)();
    }
    get isReactNative() {
        return this.framework === (0, $80240862ea60f1f3$export$638889172ebce0c4).ReactNative || this.framework === (0, $80240862ea60f1f3$export$638889172ebce0c4).Expo;
    }
    observeFrameworkChanges(fcn) {
        (0, $3e4308e2a31b96d6$export$5d5c467ce0b213f)(fcn);
    }
}
const $0c7e08523dc29e90$export$2dffd0b5373a4389 = new $0c7e08523dc29e90$var$PlatformBuilder();
const $0c7e08523dc29e90$export$7d201307d8979e21 = ({ category: category , action: action  } = {})=>{
    const userAgent = [
        [
            $0c7e08523dc29e90$var$BASE_USER_AGENT,
            $0c7e08523dc29e90$export$b8f78c57ec316f83((0, $61dcbfd9387cc58d$export$83d89fbfd8236492))
        ]
    ];
    if (category) userAgent.push([
        category,
        action
    ]);
    userAgent.push([
        "framework",
        (0, $3e4308e2a31b96d6$export$9ce73e459ec93b6a)()
    ]);
    if (category && action) {
        const customState = (0, $3e40eb963c318bdb$export$e399dbcfd99a2928)(category, action);
        if (customState) customState.forEach((state)=>{
            userAgent.push(state);
        });
    }
    return userAgent;
};
const $0c7e08523dc29e90$export$ede38edb26c0bfdf = (customUserAgentDetails)=>{
    const userAgent = $0c7e08523dc29e90$export$7d201307d8979e21(customUserAgentDetails);
    const userAgentString = userAgent.map(([agentKey, agentValue])=>agentKey && agentValue ? `${agentKey}/${agentValue}` : agentKey).join(" ");
    return userAgentString;
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * The service name used to sign requests if the API requires authentication.
 */ const $5388bad426dc15c3$var$SERVICE_NAME = "cognito-identity";
/**
 * The endpoint resolver function that returns the endpoint URL for a given region.
 */ const $5388bad426dc15c3$var$endpointResolver = ({ region: region  })=>({
        url: new (0, $b0f1ea60776570d9$export$beb82d9d9136c16e)(`https://cognito-identity.${region}.${(0, $f91fa1e3d8be306f$export$1c28e37cdcc37f6d)(region)}`)
    });
/**
 * A Cognito Identity-specific middleware that disables caching for all requests.
 */ const $5388bad426dc15c3$var$disableCacheMiddlewareFactory = ()=>(next)=>async function disableCacheMiddleware(request) {
            request.headers["cache-control"] = "no-store";
            return next(request);
        };
/**
 * A Cognito Identity-specific transfer handler that does NOT sign requests, and
 * disables caching.
 *
 * @internal
 */ const $5388bad426dc15c3$export$8029646671d2c482 = (0, $a989f58fee6d43e0$export$f074d76e52925468)((0, $06a5c13f13cb78e5$export$ed7e1ccf00f39c4a), [
    $5388bad426dc15c3$var$disableCacheMiddlewareFactory
]);
/**
 * @internal
 */ const $5388bad426dc15c3$export$f84bd70098573c5c = {
    service: $5388bad426dc15c3$var$SERVICE_NAME,
    endpointResolver: $5388bad426dc15c3$var$endpointResolver,
    retryDecider: (0, $006c1d5500f41923$export$b919d98317a7685f)((0, $c9219ddc4f5544cf$export$be467dfcc0538e25)),
    computeDelay: (0, $46ded7b7e9d65568$export$caea50bde345f648),
    userAgentValue: (0, $0c7e08523dc29e90$export$ede38edb26c0bfdf)(),
    cache: "no-store"
};
(0, $3e4308e2a31b96d6$export$5d5c467ce0b213f)(()=>{
    $5388bad426dc15c3$export$f84bd70098573c5c.userAgentValue = (0, $0c7e08523dc29e90$export$ede38edb26c0bfdf)();
});
/**
 * @internal
 */ const $5388bad426dc15c3$export$a46bbeaba09f7285 = (operation)=>({
        "content-type": "application/x-amz-json-1.1",
        "x-amz-target": `AWSCognitoIdentityService.${operation}`
    });
/**
 * @internal
 */ const $5388bad426dc15c3$export$a692bdb7eb624f96 = ({ url: url  }, headers, body)=>({
        headers: headers,
        url: url,
        body: body,
        method: "POST"
    });


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $4d75eccb58ec11d3$var$getCredentialsForIdentitySerializer = (input, endpoint)=>{
    const headers = (0, $5388bad426dc15c3$export$a46bbeaba09f7285)("GetCredentialsForIdentity");
    const body = JSON.stringify(input);
    return (0, $5388bad426dc15c3$export$a692bdb7eb624f96)(endpoint, headers, body);
};
const $4d75eccb58ec11d3$var$getCredentialsForIdentityDeserializer = async (response)=>{
    if (response.statusCode >= 300) {
        const error = await (0, $c9219ddc4f5544cf$export$be467dfcc0538e25)(response);
        throw error;
    } else {
        const body = await (0, $c9219ddc4f5544cf$export$759bcb35b0d1bf81)(response);
        return {
            IdentityId: body.IdentityId,
            Credentials: $4d75eccb58ec11d3$var$deserializeCredentials(body.Credentials),
            $metadata: (0, $ad9ac2a297598208$export$978f9418fe0cb26c)(response)
        };
    }
};
const $4d75eccb58ec11d3$var$deserializeCredentials = ({ AccessKeyId: AccessKeyId , SecretKey: SecretKey , SessionToken: SessionToken , Expiration: Expiration  } = {})=>{
    return {
        AccessKeyId: AccessKeyId,
        SecretKey: SecretKey,
        SessionToken: SessionToken,
        Expiration: Expiration && new Date(Expiration * 1000)
    };
};
/**
 * @internal
 */ const $4d75eccb58ec11d3$export$a49c1c173ab96b58 = (0, $29600698f92385b7$export$880429a8ae983d4d)((0, $5388bad426dc15c3$export$8029646671d2c482), $4d75eccb58ec11d3$var$getCredentialsForIdentitySerializer, $4d75eccb58ec11d3$var$getCredentialsForIdentityDeserializer, (0, $5388bad426dc15c3$export$f84bd70098573c5c));





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $f3a37e3ae41d4905$export$5f7eb9761ac2d0d9(userPoolId) {
    const region = userPoolId?.split("_")[0];
    if (!userPoolId || userPoolId.indexOf("_") < 0 || !region || typeof region !== "string") throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
        name: "InvalidUserPoolId",
        message: "Invalid user pool id provided."
    });
    return region;
}
function $f3a37e3ae41d4905$export$8fb32fba519c460(identityPoolId) {
    if (!identityPoolId || !identityPoolId.includes(":")) throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
        name: "InvalidIdentityPoolIdException",
        message: "Invalid identity pool id provided.",
        recoverySuggestion: "Make sure a valid identityPoolId is given in the config."
    });
    return identityPoolId.split(":")[0];
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $e4cb7b306ced9230$export$d29d1996d6b6f5e3 = "UserUnAuthenticatedException";
const $e4cb7b306ced9230$export$bdd0e7e9babcd5c8 = "UserAlreadyAuthenticatedException";
const $e4cb7b306ced9230$export$740e7000ac27ebf3 = "DeviceMetadataNotFoundException";
const $e4cb7b306ced9230$export$fe46a12932d2550a = "AutoSignInException";
const $e4cb7b306ced9230$export$36f9d08d6bc647dd = "InvalidRedirectException";
const $e4cb7b306ced9230$export$a2095d473f418f40 = "InvalidAppSchemeException";
const $e4cb7b306ced9230$export$818bb4aeac915442 = "InvalidPreferredRedirectUrlException";
const $e4cb7b306ced9230$export$60b68b138a52e5ae = new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
    name: $e4cb7b306ced9230$export$36f9d08d6bc647dd,
    message: "signInRedirect or signOutRedirect had an invalid format or was not found.",
    recoverySuggestion: "Please make sure the signIn/Out redirect in your oauth config is valid."
});
const $e4cb7b306ced9230$export$c1829c2a0b9b2e21 = new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
    name: $e4cb7b306ced9230$export$a2095d473f418f40,
    message: "A valid non-http app scheme was not found in the config.",
    recoverySuggestion: "Please make sure a valid custom app scheme is present in the config."
});
const $e4cb7b306ced9230$export$41a56a70fc1a4962 = new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
    name: $e4cb7b306ced9230$export$818bb4aeac915442,
    message: "The given preferredRedirectUrl does not match any items in the redirectSignOutUrls array from the config.",
    recoverySuggestion: "Please make sure a matching preferredRedirectUrl is provided."
});
const $e4cb7b306ced9230$export$27ddc47447101bcf = "InvalidOriginException";
const $e4cb7b306ced9230$export$c01b4acd6291e035 = new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
    name: $e4cb7b306ced9230$export$27ddc47447101bcf,
    message: "redirect is coming from a different origin. The oauth flow needs to be initiated from the same origin",
    recoverySuggestion: "Please call signInWithRedirect from the same origin."
});
const $e4cb7b306ced9230$export$625255707e22459c = "OAuthSignOutException";
const $e4cb7b306ced9230$export$a0a904daf48e2c33 = "TokenRefreshException";
const $e4cb7b306ced9230$export$606cffc85964c24b = "UnexpectedSignInInterruptionException";


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $6e9371ee52a401af$export$d76f9f8544dc304d(authConfig) {
    if (authConfig && authConfig.Cognito.userPoolId && authConfig.Cognito.userPoolClientId) return true;
    return false;
}
function $6e9371ee52a401af$export$77712ea5882cac9f(tokens) {
    if (!tokens || !tokens.accessToken) throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
        name: (0, $e4cb7b306ced9230$export$d29d1996d6b6f5e3),
        message: "User needs to be authenticated to call this API.",
        recoverySuggestion: "Sign in before calling this API again."
    });
}
function $6e9371ee52a401af$export$f4d99632f0717a4b(tokens) {
    if (!tokens || !tokens.idToken) throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
        name: (0, $e4cb7b306ced9230$export$d29d1996d6b6f5e3),
        message: "User needs to be authenticated to call this API.",
        recoverySuggestion: "Sign in before calling this API again."
    });
}
const $6e9371ee52a401af$export$31fce2aaeafa4b60 = new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
    name: (0, $e4cb7b306ced9230$export$a0a904daf48e2c33),
    message: `Token refresh is not supported when authenticated with the 'implicit grant' (token) oauth flow. 
	Please change your oauth configuration to use 'code grant' flow.`,
    recoverySuggestion: `Please logout and change your Amplify configuration to use "code grant" flow. 
	E.g { responseType: 'code' }`
});
const $6e9371ee52a401af$export$35cfa8cbd2d5bcdd = new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
    name: (0, $e4cb7b306ced9230$export$d29d1996d6b6f5e3),
    message: "User needs to be authenticated to call this API.",
    recoverySuggestion: "Sign in before calling this API again."
});
function $6e9371ee52a401af$export$be38b2d22222d505(tokens) {
    if ($6e9371ee52a401af$var$isAuthenticatedWithImplicitOauthFlow(tokens)) throw $6e9371ee52a401af$export$31fce2aaeafa4b60;
    if (!$6e9371ee52a401af$var$isAuthenticatedWithRefreshToken(tokens)) throw $6e9371ee52a401af$export$35cfa8cbd2d5bcdd;
}
function $6e9371ee52a401af$export$b6f03be79626ab0f(deviceMetadata) {
    if (!deviceMetadata || !deviceMetadata.deviceKey || !deviceMetadata.deviceGroupKey || !deviceMetadata.randomPassword) throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
        name: (0, $e4cb7b306ced9230$export$740e7000ac27ebf3),
        message: "Either deviceKey, deviceGroupKey or secretPassword were not found during the sign-in process.",
        recoverySuggestion: "Make sure to not clear storage after calling the signIn API."
    });
}
const $6e9371ee52a401af$export$3820b4ff343394ea = {
    inflightOAuth: "inflightOAuth",
    oauthSignIn: "oauthSignIn",
    oauthPKCE: "oauthPKCE",
    oauthState: "oauthState"
};
function $6e9371ee52a401af$var$isAuthenticated(tokens) {
    return tokens?.accessToken || tokens?.idToken;
}
function $6e9371ee52a401af$var$isAuthenticatedWithRefreshToken(tokens) {
    return $6e9371ee52a401af$var$isAuthenticated(tokens) && tokens?.refreshToken;
}
function $6e9371ee52a401af$var$isAuthenticatedWithImplicitOauthFlow(tokens) {
    return $6e9371ee52a401af$var$isAuthenticated(tokens) && !tokens?.refreshToken;
}












// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $011669ce549234aa$var$getIdSerializer = (input, endpoint)=>{
    const headers = (0, $5388bad426dc15c3$export$a46bbeaba09f7285)("GetId");
    const body = JSON.stringify(input);
    return (0, $5388bad426dc15c3$export$a692bdb7eb624f96)(endpoint, headers, body);
};
const $011669ce549234aa$var$getIdDeserializer = async (response)=>{
    if (response.statusCode >= 300) {
        const error = await (0, $c9219ddc4f5544cf$export$be467dfcc0538e25)(response);
        throw error;
    } else {
        const body = await (0, $c9219ddc4f5544cf$export$759bcb35b0d1bf81)(response);
        return {
            IdentityId: body.IdentityId,
            $metadata: (0, $ad9ac2a297598208$export$978f9418fe0cb26c)(response)
        };
    }
};
/**
 * @internal
 */ const $011669ce549234aa$export$218c8c3169c024d2 = (0, $29600698f92385b7$export$880429a8ae983d4d)((0, $5388bad426dc15c3$export$8029646671d2c482), $011669ce549234aa$var$getIdSerializer, $011669ce549234aa$var$getIdDeserializer, (0, $5388bad426dc15c3$export$f84bd70098573c5c));






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $298e949ea1e2645e$export$edfb13e85a2c0dc4(idToken) {
    const issuer = (0, $da35d46b99b5d98d$export$9a62e6c0a30e00bc)(idToken).payload.iss;
    const res = {};
    if (!issuer) throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
        name: "InvalidIdTokenException",
        message: "Invalid Idtoken."
    });
    const domainName = issuer.replace(/(^\w+:|^)\/\//, "");
    res[domainName] = idToken;
    return res;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $9d9e81c819338298$var$logger = new (0, $39a0f4f2bf9492b0$export$ba6a9c7ac8291f7f)("CognitoIdentityIdProvider");
/**
 * Provides a Cognito identityId
 *
 * @param tokens - The AuthTokens received after SignIn
 * @returns string
 * @throws configuration exceptions: `InvalidIdentityPoolIdException`
 *  - Auth errors that may arise from misconfiguration.
 * @throws service exceptions: {@link GetIdException }
 */ async function $9d9e81c819338298$export$7c3e576630d5e301({ tokens: tokens , authConfig: authConfig , identityIdStore: identityIdStore  }) {
    identityIdStore.setAuthConfig({
        Cognito: authConfig
    });
    // will return null only if there is no identityId cached or if there is an error retrieving it
    let identityId = await identityIdStore.loadIdentityId();
    // Tokens are available so return primary identityId
    if (tokens) {
        // If there is existing primary identityId in-memory return that
        if (identityId && identityId.type === "primary") return identityId.id;
        else {
            const logins = tokens.idToken ? (0, $298e949ea1e2645e$export$edfb13e85a2c0dc4)(tokens.idToken.toString()) : {};
            const generatedIdentityId = await $9d9e81c819338298$var$generateIdentityId(logins, authConfig);
            if (identityId && identityId.id === generatedIdentityId) $9d9e81c819338298$var$logger.debug(`The guest identity ${identityId.id} has become the primary identity.`);
            identityId = {
                id: generatedIdentityId,
                type: "primary"
            };
        }
    } else {
        // If there is existing guest identityId cached return that
        if (identityId && identityId.type === "guest") return identityId.id;
        else identityId = {
            id: await $9d9e81c819338298$var$generateIdentityId({}, authConfig),
            type: "guest"
        };
    }
    // Store in-memory or local storage depending on guest or primary identityId
    identityIdStore.storeIdentityId(identityId);
    return identityId.id;
}
async function $9d9e81c819338298$var$generateIdentityId(logins, authConfig) {
    const identityPoolId = authConfig?.identityPoolId;
    const region = (0, $f3a37e3ae41d4905$export$8fb32fba519c460)(identityPoolId);
    // IdentityId is absent so get it using IdentityPoolId with Cognito's GetId API
    const idResult = // for a first-time user, this will return a brand new identity
    // for a returning user, this will retrieve the previous identity assocaited with the logins
    (await (0, $011669ce549234aa$export$218c8c3169c024d2)({
        region: region
    }, {
        IdentityPoolId: identityPoolId,
        Logins: logins
    })).IdentityId;
    if (!idResult) throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
        name: "GetIdResponseException",
        message: "Received undefined response from getId operation",
        recoverySuggestion: "Make sure to pass a valid identityPoolId in the configuration."
    });
    return idResult;
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $326c9202938e7517$var$logger = new (0, $39a0f4f2bf9492b0$export$ba6a9c7ac8291f7f)("CognitoCredentialsProvider");
const $326c9202938e7517$var$CREDENTIALS_TTL = 3000000; // 50 min, can be modified on config if required in the future
class $326c9202938e7517$export$be6550e37264dc26 {
    constructor(identityIdStore){
        this._nextCredentialsRefresh = 0;
        this._identityIdStore = identityIdStore;
    }
    async clearCredentialsAndIdentityId() {
        $326c9202938e7517$var$logger.debug("Clearing out credentials and identityId");
        this._credentialsAndIdentityId = undefined;
        await this._identityIdStore.clearIdentityId();
    }
    async clearCredentials() {
        $326c9202938e7517$var$logger.debug("Clearing out in-memory credentials");
        this._credentialsAndIdentityId = undefined;
    }
    async getCredentialsAndIdentityId(getCredentialsOptions) {
        const isAuthenticated = getCredentialsOptions.authenticated;
        const { tokens: tokens  } = getCredentialsOptions;
        const { authConfig: authConfig  } = getCredentialsOptions;
        try {
            (0, $da35d46b99b5d98d$export$8a2f5318ea3215e3)(authConfig?.Cognito);
        } catch  {
            // No identity pool configured, skipping
            return;
        }
        if (!isAuthenticated && !authConfig.Cognito.allowGuestAccess) // TODO(V6): return partial result like Native platforms
        return;
        const { forceRefresh: forceRefresh  } = getCredentialsOptions;
        const tokenHasChanged = this.hasTokenChanged(tokens);
        const identityId = await (0, $9d9e81c819338298$export$7c3e576630d5e301)({
            tokens: tokens,
            authConfig: authConfig.Cognito,
            identityIdStore: this._identityIdStore
        });
        // Clear cached credentials when forceRefresh is true OR the cache token has changed
        if (forceRefresh || tokenHasChanged) this.clearCredentials();
        if (!isAuthenticated) return this.getGuestCredentials(identityId, authConfig.Cognito);
        else {
            (0, $6e9371ee52a401af$export$f4d99632f0717a4b)(tokens);
            return this.credsForOIDCTokens(authConfig.Cognito, tokens, identityId);
        }
    }
    async getGuestCredentials(identityId, authConfig) {
        // Return existing in-memory cached credentials only if it exists, is not past it's lifetime and is unauthenticated credentials
        if (this._credentialsAndIdentityId && !this.isPastTTL() && this._credentialsAndIdentityId.isAuthenticatedCreds === false) {
            $326c9202938e7517$var$logger.info("returning stored credentials as they neither past TTL nor expired.");
            return this._credentialsAndIdentityId;
        }
        // Clear to discard if any authenticated credentials are set and start with a clean slate
        this.clearCredentials();
        const region = (0, $f3a37e3ae41d4905$export$8fb32fba519c460)(authConfig.identityPoolId);
        // use identityId to obtain guest credentials
        // save credentials in-memory
        // No logins params should be passed for guest creds:
        // https://docs.aws.amazon.com/cognitoidentity/latest/APIReference/API_GetCredentialsForIdentity.html
        const clientResult = await (0, $4d75eccb58ec11d3$export$a49c1c173ab96b58)({
            region: region
        }, {
            IdentityId: identityId
        });
        if (clientResult.Credentials && clientResult.Credentials.AccessKeyId && clientResult.Credentials.SecretKey) {
            this._nextCredentialsRefresh = new Date().getTime() + $326c9202938e7517$var$CREDENTIALS_TTL;
            const res = {
                credentials: {
                    accessKeyId: clientResult.Credentials.AccessKeyId,
                    secretAccessKey: clientResult.Credentials.SecretKey,
                    sessionToken: clientResult.Credentials.SessionToken,
                    expiration: clientResult.Credentials.Expiration
                },
                identityId: identityId
            };
            const identityIdRes = clientResult.IdentityId;
            if (identityIdRes) {
                res.identityId = identityIdRes;
                this._identityIdStore.storeIdentityId({
                    id: identityIdRes,
                    type: "guest"
                });
            }
            this._credentialsAndIdentityId = {
                ...res,
                isAuthenticatedCreds: false
            };
            return res;
        } else throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
            name: "CredentialsNotFoundException",
            message: `Cognito did not respond with either Credentials, AccessKeyId or SecretKey.`
        });
    }
    async credsForOIDCTokens(authConfig, authTokens, identityId) {
        if (this._credentialsAndIdentityId && !this.isPastTTL() && this._credentialsAndIdentityId.isAuthenticatedCreds === true) {
            $326c9202938e7517$var$logger.debug("returning stored credentials as they neither past TTL nor expired.");
            return this._credentialsAndIdentityId;
        }
        // Clear to discard if any unauthenticated credentials are set and start with a clean slate
        this.clearCredentials();
        const logins = authTokens.idToken ? (0, $298e949ea1e2645e$export$edfb13e85a2c0dc4)(authTokens.idToken.toString()) : {};
        const region = (0, $f3a37e3ae41d4905$export$8fb32fba519c460)(authConfig.identityPoolId);
        const clientResult = await (0, $4d75eccb58ec11d3$export$a49c1c173ab96b58)({
            region: region
        }, {
            IdentityId: identityId,
            Logins: logins
        });
        if (clientResult.Credentials && clientResult.Credentials.AccessKeyId && clientResult.Credentials.SecretKey) {
            const res = {
                credentials: {
                    accessKeyId: clientResult.Credentials.AccessKeyId,
                    secretAccessKey: clientResult.Credentials.SecretKey,
                    sessionToken: clientResult.Credentials.SessionToken,
                    expiration: clientResult.Credentials.Expiration
                },
                identityId: identityId
            };
            // Store the credentials in-memory along with the expiration
            this._credentialsAndIdentityId = {
                ...res,
                isAuthenticatedCreds: true,
                associatedIdToken: authTokens.idToken?.toString()
            };
            this._nextCredentialsRefresh = new Date().getTime() + $326c9202938e7517$var$CREDENTIALS_TTL;
            const identityIdRes = clientResult.IdentityId;
            if (identityIdRes) {
                res.identityId = identityIdRes;
                this._identityIdStore.storeIdentityId({
                    id: identityIdRes,
                    type: "primary"
                });
            }
            return res;
        } else throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
            name: "CredentialsException",
            message: `Cognito did not respond with either Credentials, AccessKeyId or SecretKey.`
        });
    }
    isPastTTL() {
        return this._nextCredentialsRefresh === undefined ? true : this._nextCredentialsRefresh <= Date.now();
    }
    hasTokenChanged(tokens) {
        return !!tokens && !!this._credentialsAndIdentityId?.associatedIdToken && tokens.idToken?.toString() !== this._credentialsAndIdentityId.associatedIdToken;
    }
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Cognito specific implmentation of the CredentialsProvider interface
 * that manages setting and getting of AWS Credentials.
 *
 * @throws configuration expections: `InvalidIdentityPoolIdException`
 *  - Auth errors that may arise from misconfiguration.
 * @throws service expections: {@link GetCredentialsForIdentityException}, {@link GetIdException}
 *
 */ const $c675585da73d2336$export$be43b753aec531e2 = new (0, $326c9202938e7517$export$be6550e37264dc26)(new (0, $6597ba25b1800063$export$3e97b78667a539a0)((0, $d6350db11aa681cd$export$586b30dcaeecb901)));


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * returns in-flight promise if there is one
 *
 * @param asyncFunction - asyncFunction to be deduped.
 * @returns - the return type of the callback
 */ const $b95044131c7c7bf1$export$cd8d22e3dc00ae5a = (asyncFunction)=>{
    let inflightPromise;
    return async (...args)=>{
        if (inflightPromise) return inflightPromise;
        inflightPromise = new Promise((resolve, reject)=>{
            asyncFunction(...args).then((result)=>{
                resolve(result);
            }).catch((error)=>{
                reject(error);
            }).finally(()=>{
                inflightPromise = undefined;
            });
        });
        return inflightPromise;
    };
};






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $12cd6399d355fb71$export$1113413e6e842bef = (operation)=>(input, endpoint)=>{
        const headers = $12cd6399d355fb71$var$getSharedHeaders(operation);
        const body = JSON.stringify(input);
        return $12cd6399d355fb71$var$buildHttpRpcRequest(endpoint, headers, body);
    };
const $12cd6399d355fb71$var$getSharedHeaders = (operation)=>({
        "content-type": "application/x-amz-json-1.1",
        "x-amz-target": `AWSCognitoIdentityProviderService.${operation}`
    });
const $12cd6399d355fb71$var$buildHttpRpcRequest = ({ url: url  }, headers, body)=>({
        headers: headers,
        url: url,
        body: body,
        method: "POST"
    });





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $30ec7ddce5c02788$export$5b3890f50cd4853f(error) {
    if (!error || error.name === "Error" || error instanceof TypeError) throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
        name: (0, $f5d3b7601afe1953$export$4e712df6b850c8d0).Unknown,
        message: "An unknown error has occurred.",
        underlyingError: error
    });
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $d5338601430a6488$export$8159795418a3e796 = ()=>async (response)=>{
        if (response.statusCode >= 300) {
            const error = await (0, $c9219ddc4f5544cf$export$be467dfcc0538e25)(response);
            (0, $30ec7ddce5c02788$export$5b3890f50cd4853f)(error);
            throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
                name: error.name,
                message: error.message
            });
        }
        return (0, $c9219ddc4f5544cf$export$759bcb35b0d1bf81)(response);
    };






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * A Cognito Identity-specific middleware that disables caching for all requests.
 */ const $566d64d9996fb1fd$var$disableCacheMiddlewareFactory = ()=>(next, _)=>async function disableCacheMiddleware(request) {
            request.headers["cache-control"] = "no-store";
            return next(request);
        };
/**
 * A Cognito Identity-specific transfer handler that does NOT sign requests, and
 * disables caching.
 *
 * @internal
 */ const $566d64d9996fb1fd$export$10f11e95d7a96f7b = (0, $a989f58fee6d43e0$export$f074d76e52925468)((0, $06a5c13f13cb78e5$export$ed7e1ccf00f39c4a), [
    $566d64d9996fb1fd$var$disableCacheMiddlewareFactory
]);




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * The service name used to sign requests if the API requires authentication.
 */ const $83bfda1272b7392e$export$a0efffb4b0c72e04 = "cognito-idp";


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $579ad14e33e08f0c$export$22a3716e7860147a = {
    service: (0, $83bfda1272b7392e$export$a0efffb4b0c72e04),
    retryDecider: (0, $006c1d5500f41923$export$b919d98317a7685f)((0, $c9219ddc4f5544cf$export$be467dfcc0538e25)),
    computeDelay: (0, $46ded7b7e9d65568$export$caea50bde345f648),
    userAgentValue: (0, $0c7e08523dc29e90$export$ede38edb26c0bfdf)(),
    cache: "no-store"
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $73c63bd2bf2643ec$export$91f349d78bea7765 = (config)=>(0, $29600698f92385b7$export$880429a8ae983d4d)((0, $566d64d9996fb1fd$export$10f11e95d7a96f7b), (0, $12cd6399d355fb71$export$1113413e6e842bef)("InitiateAuth"), (0, $d5338601430a6488$export$8159795418a3e796)(), {
        ...(0, $579ad14e33e08f0c$export$22a3716e7860147a),
        ...config
    });













// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $8c7b3f566a393b2a$export$54dd9d9496cb66b9 = ({ region: region  })=>({
        url: new (0, $b0f1ea60776570d9$export$beb82d9d9136c16e)(`https://${(0, $83bfda1272b7392e$export$a0efffb4b0c72e04)}.${region}.${(0, $f91fa1e3d8be306f$export$1c28e37cdcc37f6d)(region)}`)
    });


const $034f40104fa68ca7$export$9fc8f7dceefe00a6 = ({ endpointOverride: endpointOverride  })=>(input)=>{
        if (endpointOverride) return {
            url: new (0, $b0f1ea60776570d9$export$beb82d9d9136c16e)(endpointOverride)
        };
        return (0, $8c7b3f566a393b2a$export$54dd9d9496cb66b9)(input);
    };


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $d1d75befb3456a99$export$b6e6cdd1f90faa62({ username: username , userPoolId: userPoolId , userPoolClientId: userPoolClientId  }) {
    if (typeof window === "undefined") return undefined;
    const amazonCognitoAdvancedSecurityData = window.AmazonCognitoAdvancedSecurityData;
    if (typeof amazonCognitoAdvancedSecurityData === "undefined") return undefined;
    const advancedSecurityData = amazonCognitoAdvancedSecurityData.getData(username, userPoolId, userPoolClientId);
    if (advancedSecurityData) {
        const userContextData = {
            EncodedData: advancedSecurityData
        };
        return userContextData;
    }
    return {};
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $75fc96711695aa91$var$refreshAuthTokensFunction = async ({ tokens: tokens , authConfig: authConfig , username: username  })=>{
    (0, $da35d46b99b5d98d$export$80c92581e59ed502)(authConfig?.Cognito);
    const { userPoolId: userPoolId , userPoolClientId: userPoolClientId , userPoolEndpoint: userPoolEndpoint  } = authConfig.Cognito;
    const region = (0, $f3a37e3ae41d4905$export$5f7eb9761ac2d0d9)(userPoolId);
    (0, $6e9371ee52a401af$export$be38b2d22222d505)(tokens);
    const refreshTokenString = tokens.refreshToken;
    const AuthParameters = {
        REFRESH_TOKEN: refreshTokenString
    };
    if (tokens.deviceMetadata?.deviceKey) AuthParameters.DEVICE_KEY = tokens.deviceMetadata.deviceKey;
    const UserContextData = (0, $d1d75befb3456a99$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const initiateAuth = (0, $73c63bd2bf2643ec$export$91f349d78bea7765)({
        endpointResolver: (0, $034f40104fa68ca7$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const { AuthenticationResult: AuthenticationResult  } = await initiateAuth({
        region: region
    }, {
        ClientId: userPoolClientId,
        AuthFlow: "REFRESH_TOKEN_AUTH",
        AuthParameters: AuthParameters,
        UserContextData: UserContextData
    });
    const accessToken = (0, $da35d46b99b5d98d$export$9a62e6c0a30e00bc)(AuthenticationResult?.AccessToken ?? "");
    const idToken = AuthenticationResult?.IdToken ? (0, $da35d46b99b5d98d$export$9a62e6c0a30e00bc)(AuthenticationResult.IdToken) : undefined;
    const { iat: iat  } = accessToken.payload;
    // This should never happen. If it does, it's a bug from the service.
    if (!iat) throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
        name: "iatNotFoundException",
        message: "iat not found in access token"
    });
    const clockDrift = iat * 1000 - new Date().getTime();
    return {
        accessToken: accessToken,
        idToken: idToken,
        clockDrift: clockDrift,
        refreshToken: refreshTokenString,
        username: username
    };
};
const $75fc96711695aa91$export$ab413c2cb4a135d9 = (0, $b95044131c7c7bf1$export$cd8d22e3dc00ae5a)($75fc96711695aa91$var$refreshAuthTokensFunction);
const $75fc96711695aa91$export$d5c14381105da273 = $75fc96711695aa91$var$refreshAuthTokensFunction;




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $59ed5bbcecfdce0d$export$4e09c449d6c407f7 = ()=>typeof window !== "undefined" && typeof window.document !== "undefined";








// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $388b2d9f599c1030$var$V5_HOSTED_UI_KEY = "amplify-signin-with-hostedUI";
const $388b2d9f599c1030$var$name = "CognitoIdentityServiceProvider";
class $388b2d9f599c1030$export$9b2cef5d94f9b6e8 {
    constructor(keyValueStorage){
        this.keyValueStorage = keyValueStorage;
    }
    async clearOAuthInflightData() {
        (0, $da35d46b99b5d98d$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $388b2d9f599c1030$var$createKeysForAuthStorage($388b2d9f599c1030$var$name, this.cognitoConfig.userPoolClientId);
        await Promise.all([
            this.keyValueStorage.removeItem(authKeys.inflightOAuth),
            this.keyValueStorage.removeItem(authKeys.oauthPKCE),
            this.keyValueStorage.removeItem(authKeys.oauthState)
        ]);
    }
    async clearOAuthData() {
        (0, $da35d46b99b5d98d$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $388b2d9f599c1030$var$createKeysForAuthStorage($388b2d9f599c1030$var$name, this.cognitoConfig.userPoolClientId);
        await this.clearOAuthInflightData();
        await this.keyValueStorage.removeItem($388b2d9f599c1030$var$V5_HOSTED_UI_KEY); // remove in case a customer migrated an App from v5 to v6
        return this.keyValueStorage.removeItem(authKeys.oauthSignIn);
    }
    loadOAuthState() {
        (0, $da35d46b99b5d98d$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $388b2d9f599c1030$var$createKeysForAuthStorage($388b2d9f599c1030$var$name, this.cognitoConfig.userPoolClientId);
        return this.keyValueStorage.getItem(authKeys.oauthState);
    }
    storeOAuthState(state) {
        (0, $da35d46b99b5d98d$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $388b2d9f599c1030$var$createKeysForAuthStorage($388b2d9f599c1030$var$name, this.cognitoConfig.userPoolClientId);
        return this.keyValueStorage.setItem(authKeys.oauthState, state);
    }
    loadPKCE() {
        (0, $da35d46b99b5d98d$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $388b2d9f599c1030$var$createKeysForAuthStorage($388b2d9f599c1030$var$name, this.cognitoConfig.userPoolClientId);
        return this.keyValueStorage.getItem(authKeys.oauthPKCE);
    }
    storePKCE(pkce) {
        (0, $da35d46b99b5d98d$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $388b2d9f599c1030$var$createKeysForAuthStorage($388b2d9f599c1030$var$name, this.cognitoConfig.userPoolClientId);
        return this.keyValueStorage.setItem(authKeys.oauthPKCE, pkce);
    }
    setAuthConfig(authConfigParam) {
        this.cognitoConfig = authConfigParam;
    }
    async loadOAuthInFlight() {
        (0, $da35d46b99b5d98d$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $388b2d9f599c1030$var$createKeysForAuthStorage($388b2d9f599c1030$var$name, this.cognitoConfig.userPoolClientId);
        return await this.keyValueStorage.getItem(authKeys.inflightOAuth) === "true";
    }
    async storeOAuthInFlight(inflight) {
        (0, $da35d46b99b5d98d$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $388b2d9f599c1030$var$createKeysForAuthStorage($388b2d9f599c1030$var$name, this.cognitoConfig.userPoolClientId);
        await this.keyValueStorage.setItem(authKeys.inflightOAuth, `${inflight}`);
    }
    async loadOAuthSignIn() {
        (0, $da35d46b99b5d98d$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $388b2d9f599c1030$var$createKeysForAuthStorage($388b2d9f599c1030$var$name, this.cognitoConfig.userPoolClientId);
        const isLegacyHostedUISignIn = await this.keyValueStorage.getItem($388b2d9f599c1030$var$V5_HOSTED_UI_KEY);
        const [isOAuthSignIn, preferPrivateSession] = (await this.keyValueStorage.getItem(authKeys.oauthSignIn))?.split(",") ?? [];
        return {
            isOAuthSignIn: isOAuthSignIn === "true" || isLegacyHostedUISignIn === "true",
            preferPrivateSession: preferPrivateSession === "true"
        };
    }
    async storeOAuthSignIn(oauthSignIn, preferPrivateSession = false) {
        (0, $da35d46b99b5d98d$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $388b2d9f599c1030$var$createKeysForAuthStorage($388b2d9f599c1030$var$name, this.cognitoConfig.userPoolClientId);
        await this.keyValueStorage.setItem(authKeys.oauthSignIn, `${oauthSignIn},${preferPrivateSession}`);
    }
}
const $388b2d9f599c1030$var$createKeysForAuthStorage = (provider, identifier)=>{
    return (0, $36e2942275e8945a$export$dfb8da757ca62eed)((0, $6e9371ee52a401af$export$3820b4ff343394ea))(provider, identifier);
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $a3425219c0e3d9eb$export$2ed0ec267eb6cb1c = new (0, $388b2d9f599c1030$export$9b2cef5d94f9b6e8)((0, $d6350db11aa681cd$export$586b30dcaeecb901));


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $e96565510dd70381$var$inflightPromises = [];
const $e96565510dd70381$export$c55b09e0e9be0d04 = (resolver)=>{
    $e96565510dd70381$var$inflightPromises.push(resolver);
};
const $e96565510dd70381$export$bcb0b7a105a5df59 = ()=>{
    while($e96565510dd70381$var$inflightPromises.length)$e96565510dd70381$var$inflightPromises.pop()?.();
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $9c8a217614d158ae$export$ba2f3fbc8979d2e6 {
    constructor(){
        this.waitForInflightOAuth = (0, $59ed5bbcecfdce0d$export$4e09c449d6c407f7)() ? async ()=>{
            if (!await (0, $a3425219c0e3d9eb$export$2ed0ec267eb6cb1c).loadOAuthInFlight()) return;
            if (this.inflightPromise) return this.inflightPromise;
            // when there is valid oauth config and there is an inflight oauth flow, try
            // to block async calls that require fetching tokens before the oauth flow completes
            // e.g. getCurrentUser, fetchAuthSession etc.
            this.inflightPromise = new Promise((resolve, _reject)=>{
                (0, $e96565510dd70381$export$c55b09e0e9be0d04)(resolve);
            });
            return this.inflightPromise;
        } : async ()=>{
        // no-op for non-browser environments
        };
    }
    setAuthConfig(authConfig) {
        (0, $a3425219c0e3d9eb$export$2ed0ec267eb6cb1c).setAuthConfig(authConfig.Cognito);
        this.authConfig = authConfig;
    }
    setTokenRefresher(tokenRefresher) {
        this.tokenRefresher = tokenRefresher;
    }
    setAuthTokenStore(tokenStore) {
        this.tokenStore = tokenStore;
    }
    getTokenStore() {
        if (!this.tokenStore) throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
            name: "EmptyTokenStoreException",
            message: "TokenStore not set"
        });
        return this.tokenStore;
    }
    getTokenRefresher() {
        if (!this.tokenRefresher) throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
            name: "EmptyTokenRefresherException",
            message: "TokenRefresher not set"
        });
        return this.tokenRefresher;
    }
    async getTokens(options) {
        let tokens;
        try {
            (0, $da35d46b99b5d98d$export$80c92581e59ed502)(this.authConfig?.Cognito);
        } catch (_err) {
            // Token provider not configured
            return null;
        }
        await this.waitForInflightOAuth();
        this.inflightPromise = undefined;
        tokens = await this.getTokenStore().loadTokens();
        const username = await this.getTokenStore().getLastAuthUser();
        if (tokens === null) return null;
        const idTokenExpired = !!tokens?.idToken && (0, $a494572fc02f1800$export$b007d77a962aa175)({
            expiresAt: (tokens.idToken?.payload?.exp ?? 0) * 1000,
            clockDrift: tokens.clockDrift ?? 0
        });
        const accessTokenExpired = (0, $a494572fc02f1800$export$b007d77a962aa175)({
            expiresAt: (tokens.accessToken?.payload?.exp ?? 0) * 1000,
            clockDrift: tokens.clockDrift ?? 0
        });
        if (options?.forceRefresh || idTokenExpired || accessTokenExpired) {
            tokens = await this.refreshTokens({
                tokens: tokens,
                username: username
            });
            if (tokens === null) return null;
        }
        return {
            accessToken: tokens?.accessToken,
            idToken: tokens?.idToken,
            signInDetails: tokens?.signInDetails
        };
    }
    async refreshTokens({ tokens: tokens , username: username  }) {
        try {
            const { signInDetails: signInDetails  } = tokens;
            const newTokens = await this.getTokenRefresher()({
                tokens: tokens,
                authConfig: this.authConfig,
                username: username
            });
            newTokens.signInDetails = signInDetails;
            await this.setTokens({
                tokens: newTokens
            });
            (0, $9464725044e9d769$export$8c41bb232f1008b1).dispatch("auth", {
                event: "tokenRefresh"
            }, "Auth", (0, $9464725044e9d769$export$aadf71dd9875dd20));
            return newTokens;
        } catch (err) {
            return this.handleErrors(err);
        }
    }
    handleErrors(err) {
        (0, $30ec7ddce5c02788$export$5b3890f50cd4853f)(err);
        if (err.name !== (0, $f5d3b7601afe1953$export$4e712df6b850c8d0).NetworkError) // TODO(v6): Check errors on client
        this.clearTokens();
        (0, $9464725044e9d769$export$8c41bb232f1008b1).dispatch("auth", {
            event: "tokenRefresh_failure",
            data: {
                error: err
            }
        }, "Auth", (0, $9464725044e9d769$export$aadf71dd9875dd20));
        if (err.name.startsWith("NotAuthorizedException")) return null;
        throw err;
    }
    async setTokens({ tokens: tokens  }) {
        return this.getTokenStore().storeTokens(tokens);
    }
    async clearTokens() {
        return this.getTokenStore().clearTokens();
    }
    getDeviceMetadata(username) {
        return this.getTokenStore().getDeviceMetadata(username);
    }
    clearDeviceMetadata(username) {
        return this.getTokenStore().clearDeviceMetadata(username);
    }
    setOAuthMetadata(metadata) {
        return this.getTokenStore().setOAuthMetadata(metadata);
    }
    getOAuthMetadata() {
        return this.getTokenStore().getOAuthMetadata();
    }
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $70c569d3e30fb942$export$85b743bbda58cb6c {
    constructor(){
        this.authTokenStore = new (0, $36e2942275e8945a$export$a36be852d43d512)();
        this.authTokenStore.setKeyValueStorage((0, $d6350db11aa681cd$export$586b30dcaeecb901));
        this.tokenOrchestrator = new (0, $9c8a217614d158ae$export$ba2f3fbc8979d2e6)();
        this.tokenOrchestrator.setAuthTokenStore(this.authTokenStore);
        this.tokenOrchestrator.setTokenRefresher((0, $75fc96711695aa91$export$ab413c2cb4a135d9));
    }
    getTokens({ forceRefresh: forceRefresh  } = {
        forceRefresh: false
    }) {
        return this.tokenOrchestrator.getTokens({
            forceRefresh: forceRefresh
        });
    }
    setKeyValueStorage(keyValueStorage) {
        this.authTokenStore.setKeyValueStorage(keyValueStorage);
    }
    setAuthConfig(authConfig) {
        this.authTokenStore.setAuthConfig(authConfig);
        this.tokenOrchestrator.setAuthConfig(authConfig);
    }
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * The default provider for the JWT access token and ID token issued from the configured Cognito user pool. It manages
 * the refresh and storage of the tokens. It stores the tokens in `window.localStorage` if available, and falls back to
 * in-memory storage if not.
 */ const $14fa9bd317b4b3d6$export$18e158b80aac31a7 = new (0, $70c569d3e30fb942$export$85b743bbda58cb6c)();
const { tokenOrchestrator: $14fa9bd317b4b3d6$export$66561e66d62991d0  } = $14fa9bd317b4b3d6$export$18e158b80aac31a7;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $2fcf3704ebc37489$export$11ac3725994bec7b = {
    /**
     * Configures Amplify with the {@link resourceConfig} and {@link libraryOptions}.
     *
     * @param resourceConfig The {@link ResourcesConfig} object that is typically imported from the
     * `amplifyconfiguration.json` file. It can also be an object literal created inline when calling `Amplify.configure`.
     * @param libraryOptions The {@link LibraryOptions} additional options for the library.
     *
     * @example
     * import config from './amplifyconfiguration.json';
     *
     * Amplify.configure(config);
     */ configure (resourceConfig, libraryOptions) {
        const resolvedResourceConfig = (0, $129dea0cb92517e9$export$f101a69cd6dc6202)(resourceConfig);
        // If no Auth config is provided, no special handling will be required, configure as is.
        // Otherwise, we can assume an Auth config is provided from here on.
        if (!resolvedResourceConfig.Auth) {
            (0, $44174d4eb465d133$export$a3858a9a153cffc7).configure(resolvedResourceConfig, libraryOptions);
            return;
        }
        // If Auth options are provided, always just configure as is.
        // Otherwise, we can assume no Auth libraryOptions were provided from here on.
        if (libraryOptions?.Auth) {
            (0, $44174d4eb465d133$export$a3858a9a153cffc7).configure(resolvedResourceConfig, libraryOptions);
            return;
        }
        // If no Auth libraryOptions were previously configured, then always add default providers.
        if (!(0, $44174d4eb465d133$export$a3858a9a153cffc7).libraryOptions.Auth) {
            (0, $14fa9bd317b4b3d6$export$18e158b80aac31a7).setAuthConfig(resolvedResourceConfig.Auth);
            (0, $14fa9bd317b4b3d6$export$18e158b80aac31a7).setKeyValueStorage(// TODO: allow configure with a public interface
            libraryOptions?.ssr ? new (0, $cd7d6a3de8efc093$export$dae7d845015939d5)({
                sameSite: "lax"
            }) : (0, $d6350db11aa681cd$export$586b30dcaeecb901));
            (0, $44174d4eb465d133$export$a3858a9a153cffc7).configure(resolvedResourceConfig, {
                ...libraryOptions,
                Auth: {
                    tokenProvider: (0, $14fa9bd317b4b3d6$export$18e158b80aac31a7),
                    credentialsProvider: (0, $c675585da73d2336$export$be43b753aec531e2)
                }
            });
            return;
        }
        // At this point, Auth libraryOptions would have been previously configured and no overriding
        // Auth options were given, so we should preserve the currently configured Auth libraryOptions.
        if (libraryOptions) {
            // If ssr is provided through libraryOptions, we should respect the intentional reconfiguration.
            if (libraryOptions.ssr !== undefined) (0, $14fa9bd317b4b3d6$export$18e158b80aac31a7).setKeyValueStorage(// TODO: allow configure with a public interface
            libraryOptions.ssr ? new (0, $cd7d6a3de8efc093$export$dae7d845015939d5)({
                sameSite: "lax"
            }) : (0, $d6350db11aa681cd$export$586b30dcaeecb901));
            (0, $44174d4eb465d133$export$a3858a9a153cffc7).configure(resolvedResourceConfig, {
                Auth: (0, $44174d4eb465d133$export$a3858a9a153cffc7).libraryOptions.Auth,
                ...libraryOptions
            });
            return;
        }
        // Finally, if there were no libraryOptions given at all, we should simply not touch the currently
        // configured libraryOptions.
        (0, $44174d4eb465d133$export$a3858a9a153cffc7).configure(resolvedResourceConfig);
    },
    /**
     * Returns the {@link ResourcesConfig} object passed in as the `resourceConfig` parameter when calling
     * `Amplify.configure`.
     *
     * @returns An {@link ResourcesConfig} object.
     */ getConfig () {
        return (0, $44174d4eb465d133$export$a3858a9a153cffc7).getConfig();
    }
};




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $e5a1b34bea683c02$export$12d5c695b2213c4a;
(function(AuthValidationErrorCode) {
    AuthValidationErrorCode["EmptySignInUsername"] = "EmptySignInUsername";
    AuthValidationErrorCode["EmptySignInPassword"] = "EmptySignInPassword";
    AuthValidationErrorCode["CustomAuthSignInPassword"] = "CustomAuthSignInPassword";
    AuthValidationErrorCode["EmptySignUpUsername"] = "EmptySignUpUsername";
    AuthValidationErrorCode["EmptySignUpPassword"] = "EmptySignUpPassword";
    AuthValidationErrorCode["EmptyConfirmSignUpUsername"] = "EmptyConfirmSignUpUsername";
    AuthValidationErrorCode["EmptyConfirmSignUpCode"] = "EmptyConfirmSignUpCode";
    AuthValidationErrorCode["EmptyResendSignUpCodeUsername"] = "EmptyresendSignUpCodeUsername";
    AuthValidationErrorCode["EmptyChallengeResponse"] = "EmptyChallengeResponse";
    AuthValidationErrorCode["EmptyConfirmResetPasswordUsername"] = "EmptyConfirmResetPasswordUsername";
    AuthValidationErrorCode["EmptyConfirmResetPasswordNewPassword"] = "EmptyConfirmResetPasswordNewPassword";
    AuthValidationErrorCode["EmptyConfirmResetPasswordConfirmationCode"] = "EmptyConfirmResetPasswordConfirmationCode";
    AuthValidationErrorCode["EmptyResetPasswordUsername"] = "EmptyResetPasswordUsername";
    AuthValidationErrorCode["EmptyVerifyTOTPSetupCode"] = "EmptyVerifyTOTPSetupCode";
    AuthValidationErrorCode["EmptyConfirmUserAttributeCode"] = "EmptyConfirmUserAttributeCode";
    AuthValidationErrorCode["IncorrectMFAMethod"] = "IncorrectMFAMethod";
    AuthValidationErrorCode["EmptyUpdatePassword"] = "EmptyUpdatePassword";
})($e5a1b34bea683c02$export$12d5c695b2213c4a || ($e5a1b34bea683c02$export$12d5c695b2213c4a = {}));


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $3277196cec8a3dbe$export$195137955146d376 = {
    [(0, $e5a1b34bea683c02$export$12d5c695b2213c4a).EmptyChallengeResponse]: {
        message: "challengeResponse is required to confirmSignIn"
    },
    [(0, $e5a1b34bea683c02$export$12d5c695b2213c4a).EmptyConfirmResetPasswordUsername]: {
        message: "username is required to confirmResetPassword"
    },
    [(0, $e5a1b34bea683c02$export$12d5c695b2213c4a).EmptyConfirmSignUpCode]: {
        message: "code is required to confirmSignUp"
    },
    [(0, $e5a1b34bea683c02$export$12d5c695b2213c4a).EmptyConfirmSignUpUsername]: {
        message: "username is required to confirmSignUp"
    },
    [(0, $e5a1b34bea683c02$export$12d5c695b2213c4a).EmptyConfirmResetPasswordConfirmationCode]: {
        message: "confirmationCode is required to confirmResetPassword"
    },
    [(0, $e5a1b34bea683c02$export$12d5c695b2213c4a).EmptyConfirmResetPasswordNewPassword]: {
        message: "newPassword is required to confirmResetPassword"
    },
    [(0, $e5a1b34bea683c02$export$12d5c695b2213c4a).EmptyResendSignUpCodeUsername]: {
        message: "username is required to confirmSignUp"
    },
    [(0, $e5a1b34bea683c02$export$12d5c695b2213c4a).EmptyResetPasswordUsername]: {
        message: "username is required to resetPassword"
    },
    [(0, $e5a1b34bea683c02$export$12d5c695b2213c4a).EmptySignInPassword]: {
        message: "password is required to signIn"
    },
    [(0, $e5a1b34bea683c02$export$12d5c695b2213c4a).EmptySignInUsername]: {
        message: "username is required to signIn"
    },
    [(0, $e5a1b34bea683c02$export$12d5c695b2213c4a).EmptySignUpPassword]: {
        message: "password is required to signUp"
    },
    [(0, $e5a1b34bea683c02$export$12d5c695b2213c4a).EmptySignUpUsername]: {
        message: "username is required to signUp"
    },
    [(0, $e5a1b34bea683c02$export$12d5c695b2213c4a).CustomAuthSignInPassword]: {
        message: "A password is not needed when signing in with CUSTOM_WITHOUT_SRP",
        recoverySuggestion: "Do not include a password in your signIn call."
    },
    [(0, $e5a1b34bea683c02$export$12d5c695b2213c4a).IncorrectMFAMethod]: {
        message: "Incorrect MFA method was chosen. It should be either SMS, TOTP, or EMAIL",
        recoverySuggestion: "Try to pass SMS, TOTP, or EMAIL as the challengeResponse"
    },
    [(0, $e5a1b34bea683c02$export$12d5c695b2213c4a).EmptyVerifyTOTPSetupCode]: {
        message: "code is required to verifyTotpSetup"
    },
    [(0, $e5a1b34bea683c02$export$12d5c695b2213c4a).EmptyUpdatePassword]: {
        message: "oldPassword and newPassword are required to changePassword"
    },
    [(0, $e5a1b34bea683c02$export$12d5c695b2213c4a).EmptyConfirmUserAttributeCode]: {
        message: "confirmation code is required to confirmUserAttribute"
    }
};
// TODO: delete this code when the Auth class is removed.
var $3277196cec8a3dbe$export$c3070468b9d65120;
(function(AuthErrorStrings) {
    AuthErrorStrings["DEFAULT_MSG"] = "Authentication Error";
    AuthErrorStrings["EMPTY_EMAIL"] = "Email cannot be empty";
    AuthErrorStrings["EMPTY_PHONE"] = "Phone number cannot be empty";
    AuthErrorStrings["EMPTY_USERNAME"] = "Username cannot be empty";
    AuthErrorStrings["INVALID_USERNAME"] = "The username should either be a string or one of the sign in types";
    AuthErrorStrings["EMPTY_PASSWORD"] = "Password cannot be empty";
    AuthErrorStrings["EMPTY_CODE"] = "Confirmation code cannot be empty";
    AuthErrorStrings["SIGN_UP_ERROR"] = "Error creating account";
    AuthErrorStrings["NO_MFA"] = "No valid MFA method provided";
    AuthErrorStrings["INVALID_MFA"] = "Invalid MFA type";
    AuthErrorStrings["EMPTY_CHALLENGE"] = "Challenge response cannot be empty";
    AuthErrorStrings["NO_USER_SESSION"] = "Failed to get the session because the user is empty";
    AuthErrorStrings["NETWORK_ERROR"] = "Network Error";
    AuthErrorStrings["DEVICE_CONFIG"] = "Device tracking has not been configured in this User Pool";
    AuthErrorStrings["AUTOSIGNIN_ERROR"] = "Please use your credentials to sign in";
    AuthErrorStrings["OAUTH_ERROR"] = "Couldn't finish OAuth flow, check your User Pool HostedUI settings";
})($3277196cec8a3dbe$export$c3070468b9d65120 || ($3277196cec8a3dbe$export$c3070468b9d65120 = {}));
var $3277196cec8a3dbe$export$473ab0b56598aacd;
(function(AuthErrorCodes) {
    AuthErrorCodes["SignInException"] = "SignInException";
    AuthErrorCodes["OAuthSignInError"] = "OAuthSignInException";
})($3277196cec8a3dbe$export$473ab0b56598aacd || ($3277196cec8a3dbe$export$473ab0b56598aacd = {}));



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $fd90eaa8008e7494$export$45936001d12f9b53(assertion, name) {
    const { message: message , recoverySuggestion: recoverySuggestion  } = (0, $3277196cec8a3dbe$export$195137955146d376)[name];
    if (!assertion) throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
        name: name,
        message: message,
        recoverySuggestion: recoverySuggestion
    });
}





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $7032744b11af61d7$export$d6cd780379f37dae = (action, customUserAgentDetails)=>(0, $0c7e08523dc29e90$export$ede38edb26c0bfdf)({
        category: (0, $80240862ea60f1f3$export$3a8840c5b2ecf003).Auth,
        action: action,
        ...customUserAgentDetails
    });
















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $e95566f5c658252a$export$f182f73f82c5c23a = (config)=>(0, $29600698f92385b7$export$880429a8ae983d4d)((0, $566d64d9996fb1fd$export$10f11e95d7a96f7b), (0, $12cd6399d355fb71$export$1113413e6e842bef)("ConfirmSignUp"), (0, $d5338601430a6488$export$8159795418a3e796)(), {
        ...(0, $579ad14e33e08f0c$export$22a3716e7860147a),
        ...config
    });



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $8686208da85e51a8$var$defaultState() {
    return {
        active: false
    };
}
const $8686208da85e51a8$var$autoSignInReducer = (state, action)=>{
    switch(action.type){
        case "SET_USERNAME":
            return {
                ...state,
                username: action.value
            };
        case "SET_SESSION":
            return {
                ...state,
                session: action.value
            };
        case "START":
            return {
                ...state,
                active: true
            };
        case "RESET":
            return $8686208da85e51a8$var$defaultState();
        default:
            return state;
    }
};
const $8686208da85e51a8$var$createAutoSignInStore = (reducer)=>{
    let currentState = reducer($8686208da85e51a8$var$defaultState(), {
        type: "RESET"
    });
    return {
        getState: ()=>currentState,
        dispatch: (action)=>{
            currentState = reducer(currentState, action);
        }
    };
};
const $8686208da85e51a8$export$ef87a9980a3566ca = $8686208da85e51a8$var$createAutoSignInStore($8686208da85e51a8$var$autoSignInReducer);







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $e010ce5326316812$var$initialAutoSignIn = async ()=>{
    throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
        name: (0, $e4cb7b306ced9230$export$fe46a12932d2550a),
        message: "The autoSignIn flow has not started, or has been cancelled/completed.",
        recoverySuggestion: "Please try to use the signIn API or log out before starting a new autoSignIn flow."
    });
};
/**
 * Signs a user in automatically after finishing the sign-up process.
 *
 * This API will automatically sign a user in if the autoSignIn flow has been completed in the following cases:
 * - User confirmed their account with a verification code sent to their phone or email (default option).
 * - User confirmed their account with a verification link sent to their phone or email. In order to
 * enable this option you need to go to the Amazon Cognito [console](https://aws.amazon.com/pm/cognito),
 * look for your userpool, then go to the `Messaging` tab and enable `link` mode inside the `Verification message` option.
 * Finally you need to define the `signUpVerificationMethod` in your `Auth` config.
 *
 * @example
 * ```typescript
 *  Amplify.configure({
 *    Auth: {
 *     Cognito: {
 *    ...cognitoConfig,
 *    signUpVerificationMethod: "link" // the default value is "code"
 *   }
 *	}});
 * ```
 *
 * @throws AutoSignInException - Thrown when the autoSignIn flow has not started, or has been cancelled/completed.
 * @returns The signInOutput.
 *
 * @example
 * ```typescript
 *  // handleSignUp.ts
 * async function handleSignUp(
 *   username:string,
 *   password:string
 * ){
 *   try {
 *     const { nextStep } = await signUp({
 *       username,
 *       password,
 *       options: {
 *         userAttributes:{ email:'email@email.com'},
 *         autoSignIn: true // This enables the auto sign-in flow.
 *       },
 *     });
 *
 *     handleSignUpStep(nextStep);
 *
 *   } catch (error) {
 *     console.log(error);
 *   }
 * }
 *
 * // handleConfirmSignUp.ts
 * async function handleConfirmSignUp(username:string, confirmationCode:string) {
 *   try {
 *     const { nextStep } = await confirmSignUp({
 *       username,
 *       confirmationCode,
 *     });
 *
 *     handleSignUpStep(nextStep);
 *   } catch (error) {
 *     console.log(error);
 *   }
 * }
 *
 * // signUpUtils.ts
 * async function handleSignUpStep( step: SignUpOutput["nextStep"]) {
 * switch (step.signUpStep) {
 *   case "CONFIRM_SIGN_UP":
 *
 *    // Redirect end-user to confirm-sign up screen.
 *
 *   case "COMPLETE_AUTO_SIGN_IN":
 *	   const codeDeliveryDetails = step.codeDeliveryDetails;
 *     if (codeDeliveryDetails) {
 *      // Redirect user to confirm-sign-up with link screen.
 *     }
 *     const signInOutput = await autoSignIn();
 *   // handle sign-in steps
 * }
 *
 * ```
 */ // TODO(Eslint): can this be refactored not using `let` on exported member?
// eslint-disable-next-line import/no-mutable-exports
let $e010ce5326316812$export$c5378dc7d6787fa5 = $e010ce5326316812$var$initialAutoSignIn;
/**
 * Sets the context of autoSignIn at run time.
 * @internal
 */ function $e010ce5326316812$export$7dcbf67a23c27835(callback) {
    $e010ce5326316812$export$c5378dc7d6787fa5 = callback;
}
/**
 * Resets the context
 *
 * @internal
 */ function $e010ce5326316812$export$1ffa2742ce5c589b(resetCallback = true) {
    if (resetCallback) $e010ce5326316812$export$c5378dc7d6787fa5 = $e010ce5326316812$var$initialAutoSignIn;
    (0, $8686208da85e51a8$export$ef87a9980a3566ca).dispatch({
        type: "RESET"
    });
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Confirms a new user account.
 *
 * @param input -  The ConfirmSignUpInput object.
 * @returns ConfirmSignUpOutput
 * @throws -{@link ConfirmSignUpException }
 * Thrown due to an invalid confirmation code.
 * @throws -{@link AuthValidationErrorCode }
 * Thrown due to an empty confirmation code
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $9c3de9596e817bc7$export$2ce39ab6662e8c24(input) {
    const { username: username , confirmationCode: confirmationCode , options: options  } = input;
    const authConfig = (0, $44174d4eb465d133$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    (0, $da35d46b99b5d98d$export$80c92581e59ed502)(authConfig);
    const { userPoolId: userPoolId , userPoolClientId: userPoolClientId , userPoolEndpoint: userPoolEndpoint  } = authConfig;
    const clientMetadata = options?.clientMetadata;
    (0, $fd90eaa8008e7494$export$45936001d12f9b53)(!!username, (0, $e5a1b34bea683c02$export$12d5c695b2213c4a).EmptyConfirmSignUpUsername);
    (0, $fd90eaa8008e7494$export$45936001d12f9b53)(!!confirmationCode, (0, $e5a1b34bea683c02$export$12d5c695b2213c4a).EmptyConfirmSignUpCode);
    const UserContextData = (0, $d1d75befb3456a99$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const confirmSignUpClient = (0, $e95566f5c658252a$export$f182f73f82c5c23a)({
        endpointResolver: (0, $034f40104fa68ca7$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const { Session: session  } = await confirmSignUpClient({
        region: (0, $f3a37e3ae41d4905$export$5f7eb9761ac2d0d9)(authConfig.userPoolId),
        userAgentValue: (0, $7032744b11af61d7$export$d6cd780379f37dae)((0, $80240862ea60f1f3$export$900b1436d7e65f4).ConfirmSignUp)
    }, {
        Username: username,
        ConfirmationCode: confirmationCode,
        ClientMetadata: clientMetadata,
        ForceAliasCreation: options?.forceAliasCreation,
        ClientId: authConfig.userPoolClientId,
        UserContextData: UserContextData
    });
    return new Promise((resolve, reject)=>{
        try {
            const signUpOut = {
                isSignUpComplete: true,
                nextStep: {
                    signUpStep: "DONE"
                }
            };
            const autoSignInStoreState = (0, $8686208da85e51a8$export$ef87a9980a3566ca).getState();
            if (!autoSignInStoreState.active || autoSignInStoreState.username !== username) {
                resolve(signUpOut);
                (0, $e010ce5326316812$export$1ffa2742ce5c589b)();
                return;
            }
            (0, $8686208da85e51a8$export$ef87a9980a3566ca).dispatch({
                type: "SET_SESSION",
                value: session
            });
            const stopListener = (0, $9464725044e9d769$export$45dde0743a4c8d6e).listen("auth-internal", ({ payload: payload  })=>{
                switch(payload.event){
                    case "autoSignIn":
                        resolve({
                            isSignUpComplete: true,
                            nextStep: {
                                signUpStep: "COMPLETE_AUTO_SIGN_IN"
                            }
                        });
                        stopListener();
                }
            });
            (0, $9464725044e9d769$export$45dde0743a4c8d6e).dispatch("auth-internal", {
                event: "confirmSignUp",
                data: signUpOut
            });
        } catch (error) {
            reject(error);
        }
    });
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $99a0826aa0b12fc7$export$39430dfe49142ae = (amplify, options)=>{
    return amplify.Auth.fetchAuthSession(options);
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Fetch the auth session including the tokens and credentials if they are available. By default it
 * does not refresh the auth tokens or credentials if they are loaded in storage already. You can force a refresh
 * with `{ forceRefresh: true }` input.
 *
 * @param options - Options configuring the fetch behavior.
 * @throws {@link AuthError} - Throws error when session information cannot be refreshed.
 * @returns Promise<AuthSession>
 */ const $c68f73318e91dfc9$export$39430dfe49142ae = (options)=>{
    return (0, $99a0826aa0b12fc7$export$39430dfe49142ae)((0, $44174d4eb465d133$export$a3858a9a153cffc7), options);
};





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Transforms a user attributes object into an array of AttributeType objects.
 * @param attributes user attributes to be mapped to AttributeType objects.
 * @returns an array of AttributeType objects.
 */ function $989e07b151f5455b$export$720a7caa078a04b0(attributes) {
    return Object.entries(attributes).map(([key, value])=>({
            Name: key,
            Value: value
        }));
}
/**
 * Transforms an array of AttributeType objects into a user attributes object.
 *
 * @param attributes - an array of AttributeType objects.
 * @returns AuthUserAttributes object.
 */ function $989e07b151f5455b$export$1b975641d03f3b17(attributes) {
    const userAttributes = {};
    attributes?.forEach((attribute)=>{
        if (attribute.Name) userAttributes[attribute.Name] = attribute.Value;
    });
    return userAttributes;
}

















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $fc02c3c5b6ecd822$export$9b3b12a535efe659 = (config)=>(0, $29600698f92385b7$export$880429a8ae983d4d)((0, $566d64d9996fb1fd$export$10f11e95d7a96f7b), (0, $12cd6399d355fb71$export$1113413e6e842bef)("GetUser"), (0, $d5338601430a6488$export$8159795418a3e796)(), {
        ...(0, $579ad14e33e08f0c$export$22a3716e7860147a),
        ...config
    });



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $dd63226066db75fc$export$5dc95ecf3f16c6c9 = async (amplify)=>{
    const authConfig = amplify.getConfig().Auth?.Cognito;
    (0, $da35d46b99b5d98d$export$80c92581e59ed502)(authConfig);
    const { userPoolEndpoint: userPoolEndpoint , userPoolId: userPoolId  } = authConfig;
    const { tokens: tokens  } = await (0, $99a0826aa0b12fc7$export$39430dfe49142ae)(amplify, {
        forceRefresh: false
    });
    (0, $6e9371ee52a401af$export$77712ea5882cac9f)(tokens);
    const getUser = (0, $fc02c3c5b6ecd822$export$9b3b12a535efe659)({
        endpointResolver: (0, $034f40104fa68ca7$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const { UserAttributes: UserAttributes  } = await getUser({
        region: (0, $f3a37e3ae41d4905$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $7032744b11af61d7$export$d6cd780379f37dae)((0, $80240862ea60f1f3$export$900b1436d7e65f4).FetchUserAttributes)
    }, {
        AccessToken: tokens.accessToken.toString()
    });
    return (0, $989e07b151f5455b$export$1b975641d03f3b17)(UserAttributes);
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Fetches the current user attributes while authenticated.
 *
 * @throws - {@link GetUserException} - Cognito service errors thrown when the service is not able to get the user.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ const $b94443d14601a306$export$5dc95ecf3f16c6c9 = ()=>{
    return (0, $dd63226066db75fc$export$5dc95ecf3f16c6c9)((0, $44174d4eb465d133$export$a3858a9a153cffc7));
};




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $92467085a98b3264$export$e5432d4c8eb97ea7 = async (amplify)=>{
    const authConfig = amplify.getConfig().Auth?.Cognito;
    (0, $da35d46b99b5d98d$export$80c92581e59ed502)(authConfig);
    const tokens = await amplify.Auth.getTokens({
        forceRefresh: false
    });
    (0, $6e9371ee52a401af$export$77712ea5882cac9f)(tokens);
    const { "cognito:username": username , sub: sub  } = tokens.idToken?.payload ?? {};
    const authUser = {
        username: username,
        userId: sub
    };
    const signInDetails = $92467085a98b3264$var$getSignInDetailsFromTokens(tokens);
    if (signInDetails) authUser.signInDetails = signInDetails;
    return authUser;
};
function $92467085a98b3264$var$getSignInDetailsFromTokens(tokens) {
    return tokens?.signInDetails;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Gets the current user from the idToken.
 *
 * @param input -  The GetCurrentUserInput object.
 * @returns GetCurrentUserOutput
 * @throws - {@link InitiateAuthException} - Thrown when the service fails to refresh the tokens.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ const $a96a35a57f46b2c7$export$e5432d4c8eb97ea7 = async ()=>{
    return (0, $92467085a98b3264$export$e5432d4c8eb97ea7)((0, $44174d4eb465d133$export$a3858a9a153cffc7));
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $9816897d1d1adde4$export$7c746b75f47c9c7d(input) {
    return Array.from(input, (byte)=>String.fromCodePoint(byte)).join("");
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $2c81515d3d5db49f$export$695b149896bd3e2a = {
    /**
     * Convert input to base64-encoded string
     * @param input - string to convert to base64
     * @param options - encoding options that can optionally produce a base64url string
     * @returns base64-encoded string
     */ convert (input, options = {
        urlSafe: false,
        skipPadding: false
    }) {
        const inputStr = typeof input === "string" ? input : (0, $9816897d1d1adde4$export$7c746b75f47c9c7d)(input);
        let encodedStr = (0, $7b380da28ef680be$export$94f295707b435c6d)()(inputStr);
        // urlSafe char replacement and skipPadding options conform to the base64url spec
        // https://datatracker.ietf.org/doc/html/rfc4648#section-5
        if (options.urlSafe) encodedStr = encodedStr.replace(/\+/g, "-").replace(/\//g, "_");
        if (options.skipPadding) encodedStr = encodedStr.replace(/=/g, "");
        return encodedStr;
    }
};

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Retrieves the device name using the User-Agent Client Hints API if available,
 * falling back to the traditional userAgent string if not.
 *
 * @returns {Promise<string>} A promise that resolves with a string representing the device name.
 *
 * Example Output:
 * navigator.userAgentData:
 *   'macOS 14.2.1 arm macOS Not A(Brand/99.0.0.0;Google Chrome/121.0.6167.160;Chromium/121.0.6167.160'
 * navigator.userAgent:
 *   'Mozilla/5.0 (Macintosh; Intel Mac OS X 10.15; rv:109.0) Gecko/20100101 Firefox/115.0'
 */ const $0975c3300105e1fa$export$98f0aedb14d75123 = async ()=>{
    const { userAgentData: userAgentData  } = navigator;
    if (!userAgentData) return navigator.userAgent;
    const { platform: platform = "" , platformVersion: platformVersion = "" , model: model = "" , architecture: architecture = "" , fullVersionList: fullVersionList = []  } = await userAgentData.getHighEntropyValues([
        "platform",
        "platformVersion",
        "architecture",
        "model",
        "fullVersionList"
    ]);
    const versionList = fullVersionList.map((v)=>`${v.brand}/${v.version}`).join(";");
    const deviceName = [
        platform,
        platformVersion,
        architecture,
        model,
        platform,
        versionList
    ].filter((value)=>value).join(" ");
    return deviceName;
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $9e23bc336cf172f0$export$3cc5c71ef5f25e57;
(function(AssociateSoftwareTokenException) {
    AssociateSoftwareTokenException["ConcurrentModificationException"] = "ConcurrentModificationException";
    AssociateSoftwareTokenException["ForbiddenException"] = "ForbiddenException";
    AssociateSoftwareTokenException["InternalErrorException"] = "InternalErrorException";
    AssociateSoftwareTokenException["InvalidParameterException"] = "InvalidParameterException";
    AssociateSoftwareTokenException["NotAuthorizedException"] = "NotAuthorizedException";
    AssociateSoftwareTokenException["ResourceNotFoundException"] = "ResourceNotFoundException";
    AssociateSoftwareTokenException["SoftwareTokenMFANotFoundException"] = "SoftwareTokenMFANotFoundException";
})($9e23bc336cf172f0$export$3cc5c71ef5f25e57 || ($9e23bc336cf172f0$export$3cc5c71ef5f25e57 = {}));
var $9e23bc336cf172f0$export$4327725e8bb80c51;
(function(ChangePasswordException) {
    ChangePasswordException["ForbiddenException"] = "ForbiddenException";
    ChangePasswordException["InternalErrorException"] = "InternalErrorException";
    ChangePasswordException["InvalidParameterException"] = "InvalidParameterException";
    ChangePasswordException["InvalidPasswordException"] = "InvalidPasswordException";
    ChangePasswordException["LimitExceededException"] = "LimitExceededException";
    ChangePasswordException["NotAuthorizedException"] = "NotAuthorizedException";
    ChangePasswordException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    ChangePasswordException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ChangePasswordException["TooManyRequestsException"] = "TooManyRequestsException";
    ChangePasswordException["UserNotConfirmedException"] = "UserNotConfirmedException";
    ChangePasswordException["UserNotFoundException"] = "UserNotFoundException";
})($9e23bc336cf172f0$export$4327725e8bb80c51 || ($9e23bc336cf172f0$export$4327725e8bb80c51 = {}));
var $9e23bc336cf172f0$export$87a956d0b1b725a1;
(function(ConfirmDeviceException) {
    ConfirmDeviceException["ForbiddenException"] = "ForbiddenException";
    ConfirmDeviceException["InternalErrorException"] = "InternalErrorException";
    ConfirmDeviceException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    ConfirmDeviceException["InvalidParameterException"] = "InvalidParameterException";
    ConfirmDeviceException["InvalidPasswordException"] = "InvalidPasswordException";
    ConfirmDeviceException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    ConfirmDeviceException["NotAuthorizedException"] = "NotAuthorizedException";
    ConfirmDeviceException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    ConfirmDeviceException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ConfirmDeviceException["TooManyRequestsException"] = "TooManyRequestsException";
    ConfirmDeviceException["UsernameExistsException"] = "UsernameExistsException";
    ConfirmDeviceException["UserNotConfirmedException"] = "UserNotConfirmedException";
    ConfirmDeviceException["UserNotFoundException"] = "UserNotFoundException";
})($9e23bc336cf172f0$export$87a956d0b1b725a1 || ($9e23bc336cf172f0$export$87a956d0b1b725a1 = {}));
var $9e23bc336cf172f0$export$b86a388af82085af;
(function(ConfirmForgotPasswordException) {
    ConfirmForgotPasswordException["CodeMismatchException"] = "CodeMismatchException";
    ConfirmForgotPasswordException["ExpiredCodeException"] = "ExpiredCodeException";
    ConfirmForgotPasswordException["ForbiddenException"] = "ForbiddenException";
    ConfirmForgotPasswordException["InternalErrorException"] = "InternalErrorException";
    ConfirmForgotPasswordException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    ConfirmForgotPasswordException["InvalidParameterException"] = "InvalidParameterException";
    ConfirmForgotPasswordException["InvalidPasswordException"] = "InvalidPasswordException";
    ConfirmForgotPasswordException["LimitExceededException"] = "LimitExceededException";
    ConfirmForgotPasswordException["NotAuthorizedException"] = "NotAuthorizedException";
    ConfirmForgotPasswordException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ConfirmForgotPasswordException["TooManyFailedAttemptsException"] = "TooManyFailedAttemptsException";
    ConfirmForgotPasswordException["TooManyRequestsException"] = "TooManyRequestsException";
    ConfirmForgotPasswordException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    ConfirmForgotPasswordException["UserLambdaValidationException"] = "UserLambdaValidationException";
    ConfirmForgotPasswordException["UserNotConfirmedException"] = "UserNotConfirmedException";
    ConfirmForgotPasswordException["UserNotFoundException"] = "UserNotFoundException";
})($9e23bc336cf172f0$export$b86a388af82085af || ($9e23bc336cf172f0$export$b86a388af82085af = {}));
var $9e23bc336cf172f0$export$2ec29642a27fd055;
(function(ConfirmSignUpException) {
    ConfirmSignUpException["AliasExistsException"] = "AliasExistsException";
    ConfirmSignUpException["CodeMismatchException"] = "CodeMismatchException";
    ConfirmSignUpException["ExpiredCodeException"] = "ExpiredCodeException";
    ConfirmSignUpException["ForbiddenException"] = "ForbiddenException";
    ConfirmSignUpException["InternalErrorException"] = "InternalErrorException";
    ConfirmSignUpException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    ConfirmSignUpException["InvalidParameterException"] = "InvalidParameterException";
    ConfirmSignUpException["LimitExceededException"] = "LimitExceededException";
    ConfirmSignUpException["NotAuthorizedException"] = "NotAuthorizedException";
    ConfirmSignUpException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ConfirmSignUpException["TooManyFailedAttemptsException"] = "TooManyFailedAttemptsException";
    ConfirmSignUpException["TooManyRequestsException"] = "TooManyRequestsException";
    ConfirmSignUpException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    ConfirmSignUpException["UserLambdaValidationException"] = "UserLambdaValidationException";
    ConfirmSignUpException["UserNotFoundException"] = "UserNotFoundException";
})($9e23bc336cf172f0$export$2ec29642a27fd055 || ($9e23bc336cf172f0$export$2ec29642a27fd055 = {}));
var $9e23bc336cf172f0$export$c6d546f0ab5ecb26;
(function(DeleteUserAttributesException) {
    DeleteUserAttributesException["ForbiddenException"] = "ForbiddenException";
    DeleteUserAttributesException["InternalErrorException"] = "InternalErrorException";
    DeleteUserAttributesException["InvalidParameterException"] = "InvalidParameterException";
    DeleteUserAttributesException["NotAuthorizedException"] = "NotAuthorizedException";
    DeleteUserAttributesException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    DeleteUserAttributesException["ResourceNotFoundException"] = "ResourceNotFoundException";
    DeleteUserAttributesException["TooManyRequestsException"] = "TooManyRequestsException";
    DeleteUserAttributesException["UserNotConfirmedException"] = "UserNotConfirmedException";
    DeleteUserAttributesException["UserNotFoundException"] = "UserNotFoundException";
})($9e23bc336cf172f0$export$c6d546f0ab5ecb26 || ($9e23bc336cf172f0$export$c6d546f0ab5ecb26 = {}));
var $9e23bc336cf172f0$export$315864c77a135492;
(function(DeleteUserException) {
    DeleteUserException["ForbiddenException"] = "ForbiddenException";
    DeleteUserException["InternalErrorException"] = "InternalErrorException";
    DeleteUserException["InvalidParameterException"] = "InvalidParameterException";
    DeleteUserException["NotAuthorizedException"] = "NotAuthorizedException";
    DeleteUserException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    DeleteUserException["ResourceNotFoundException"] = "ResourceNotFoundException";
    DeleteUserException["TooManyRequestsException"] = "TooManyRequestsException";
    DeleteUserException["UserNotConfirmedException"] = "UserNotConfirmedException";
    DeleteUserException["UserNotFoundException"] = "UserNotFoundException";
})($9e23bc336cf172f0$export$315864c77a135492 || ($9e23bc336cf172f0$export$315864c77a135492 = {}));
var $9e23bc336cf172f0$export$622cff54bc9a0bb0;
(function(ForgetDeviceException) {
    ForgetDeviceException["ForbiddenException"] = "ForbiddenException";
    ForgetDeviceException["InternalErrorException"] = "InternalErrorException";
    ForgetDeviceException["InvalidParameterException"] = "InvalidParameterException";
    ForgetDeviceException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    ForgetDeviceException["NotAuthorizedException"] = "NotAuthorizedException";
    ForgetDeviceException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    ForgetDeviceException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ForgetDeviceException["TooManyRequestsException"] = "TooManyRequestsException";
    ForgetDeviceException["UserNotConfirmedException"] = "UserNotConfirmedException";
    ForgetDeviceException["UserNotFoundException"] = "UserNotFoundException";
})($9e23bc336cf172f0$export$622cff54bc9a0bb0 || ($9e23bc336cf172f0$export$622cff54bc9a0bb0 = {}));
var $9e23bc336cf172f0$export$cedaef1e1242f8be;
(function(ForgotPasswordException) {
    ForgotPasswordException["CodeDeliveryFailureException"] = "CodeDeliveryFailureException";
    ForgotPasswordException["ForbiddenException"] = "ForbiddenException";
    ForgotPasswordException["InternalErrorException"] = "InternalErrorException";
    ForgotPasswordException["InvalidEmailRoleAccessPolicyException"] = "InvalidEmailRoleAccessPolicyException";
    ForgotPasswordException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    ForgotPasswordException["InvalidParameterException"] = "InvalidParameterException";
    ForgotPasswordException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    ForgotPasswordException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    ForgotPasswordException["LimitExceededException"] = "LimitExceededException";
    ForgotPasswordException["NotAuthorizedException"] = "NotAuthorizedException";
    ForgotPasswordException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ForgotPasswordException["TooManyRequestsException"] = "TooManyRequestsException";
    ForgotPasswordException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    ForgotPasswordException["UserLambdaValidationException"] = "UserLambdaValidationException";
    ForgotPasswordException["UserNotFoundException"] = "UserNotFoundException";
})($9e23bc336cf172f0$export$cedaef1e1242f8be || ($9e23bc336cf172f0$export$cedaef1e1242f8be = {}));
var $9e23bc336cf172f0$export$8d5b6b7a140e0c94;
(function(GetUserException) {
    GetUserException["ForbiddenException"] = "ForbiddenException";
    GetUserException["InternalErrorException"] = "InternalErrorException";
    GetUserException["InvalidParameterException"] = "InvalidParameterException";
    GetUserException["NotAuthorizedException"] = "NotAuthorizedException";
    GetUserException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    GetUserException["ResourceNotFoundException"] = "ResourceNotFoundException";
    GetUserException["TooManyRequestsException"] = "TooManyRequestsException";
    GetUserException["UserNotConfirmedException"] = "UserNotConfirmedException";
    GetUserException["UserNotFoundException"] = "UserNotFoundException";
})($9e23bc336cf172f0$export$8d5b6b7a140e0c94 || ($9e23bc336cf172f0$export$8d5b6b7a140e0c94 = {}));
var $9e23bc336cf172f0$export$506f117795ed2bb2;
(function(GetIdException) {
    GetIdException["ExternalServiceException"] = "ExternalServiceException";
    GetIdException["InternalErrorException"] = "InternalErrorException";
    GetIdException["InvalidParameterException"] = "InvalidParameterException";
    GetIdException["LimitExceededException"] = "LimitExceededException";
    GetIdException["NotAuthorizedException"] = "NotAuthorizedException";
    GetIdException["ResourceConflictException"] = "ResourceConflictException";
    GetIdException["ResourceNotFoundException"] = "ResourceNotFoundException";
    GetIdException["TooManyRequestsException"] = "TooManyRequestsException";
})($9e23bc336cf172f0$export$506f117795ed2bb2 || ($9e23bc336cf172f0$export$506f117795ed2bb2 = {}));
var $9e23bc336cf172f0$export$9bff15c85d75f437;
(function(GetCredentialsForIdentityException) {
    GetCredentialsForIdentityException["ExternalServiceException"] = "ExternalServiceException";
    GetCredentialsForIdentityException["InternalErrorException"] = "InternalErrorException";
    GetCredentialsForIdentityException["InvalidIdentityPoolConfigurationException"] = "InvalidIdentityPoolConfigurationException";
    GetCredentialsForIdentityException["InvalidParameterException"] = "InvalidParameterException";
    GetCredentialsForIdentityException["NotAuthorizedException"] = "NotAuthorizedException";
    GetCredentialsForIdentityException["ResourceConflictException"] = "ResourceConflictException";
    GetCredentialsForIdentityException["ResourceNotFoundException"] = "ResourceNotFoundException";
    GetCredentialsForIdentityException["TooManyRequestsException"] = "TooManyRequestsException";
})($9e23bc336cf172f0$export$9bff15c85d75f437 || ($9e23bc336cf172f0$export$9bff15c85d75f437 = {}));
var $9e23bc336cf172f0$export$2a6bba23fbf84d1b;
(function(GetUserAttributeVerificationException) {
    GetUserAttributeVerificationException["CodeDeliveryFailureException"] = "CodeDeliveryFailureException";
    GetUserAttributeVerificationException["ForbiddenException"] = "ForbiddenException";
    GetUserAttributeVerificationException["InternalErrorException"] = "InternalErrorException";
    GetUserAttributeVerificationException["InvalidEmailRoleAccessPolicyException"] = "InvalidEmailRoleAccessPolicyException";
    GetUserAttributeVerificationException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    GetUserAttributeVerificationException["InvalidParameterException"] = "InvalidParameterException";
    GetUserAttributeVerificationException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    GetUserAttributeVerificationException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    GetUserAttributeVerificationException["LimitExceededException"] = "LimitExceededException";
    GetUserAttributeVerificationException["NotAuthorizedException"] = "NotAuthorizedException";
    GetUserAttributeVerificationException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    GetUserAttributeVerificationException["ResourceNotFoundException"] = "ResourceNotFoundException";
    GetUserAttributeVerificationException["TooManyRequestsException"] = "TooManyRequestsException";
    GetUserAttributeVerificationException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    GetUserAttributeVerificationException["UserLambdaValidationException"] = "UserLambdaValidationException";
    GetUserAttributeVerificationException["UserNotConfirmedException"] = "UserNotConfirmedException";
    GetUserAttributeVerificationException["UserNotFoundException"] = "UserNotFoundException";
})($9e23bc336cf172f0$export$2a6bba23fbf84d1b || ($9e23bc336cf172f0$export$2a6bba23fbf84d1b = {}));
var $9e23bc336cf172f0$export$3f7e490ba4e0b71e;
(function(GlobalSignOutException) {
    GlobalSignOutException["ForbiddenException"] = "ForbiddenException";
    GlobalSignOutException["InternalErrorException"] = "InternalErrorException";
    GlobalSignOutException["InvalidParameterException"] = "InvalidParameterException";
    GlobalSignOutException["NotAuthorizedException"] = "NotAuthorizedException";
    GlobalSignOutException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    GlobalSignOutException["ResourceNotFoundException"] = "ResourceNotFoundException";
    GlobalSignOutException["TooManyRequestsException"] = "TooManyRequestsException";
    GlobalSignOutException["UserNotConfirmedException"] = "UserNotConfirmedException";
})($9e23bc336cf172f0$export$3f7e490ba4e0b71e || ($9e23bc336cf172f0$export$3f7e490ba4e0b71e = {}));
var $9e23bc336cf172f0$export$43ac0110dfdad33b;
(function(InitiateAuthException) {
    InitiateAuthException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    InitiateAuthException["ForbiddenException"] = "ForbiddenException";
    InitiateAuthException["InternalErrorException"] = "InternalErrorException";
    InitiateAuthException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    InitiateAuthException["InvalidParameterException"] = "InvalidParameterException";
    InitiateAuthException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    InitiateAuthException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    InitiateAuthException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    InitiateAuthException["NotAuthorizedException"] = "NotAuthorizedException";
    InitiateAuthException["ResourceNotFoundException"] = "ResourceNotFoundException";
    InitiateAuthException["TooManyRequestsException"] = "TooManyRequestsException";
    InitiateAuthException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    InitiateAuthException["UserLambdaValidationException"] = "UserLambdaValidationException";
    InitiateAuthException["UserNotConfirmedException"] = "UserNotConfirmedException";
    InitiateAuthException["UserNotFoundException"] = "UserNotFoundException";
})($9e23bc336cf172f0$export$43ac0110dfdad33b || ($9e23bc336cf172f0$export$43ac0110dfdad33b = {}));
var $9e23bc336cf172f0$export$8807b62ddb0e4d9d;
(function(ResendConfirmationException) {
    ResendConfirmationException["CodeDeliveryFailureException"] = "CodeDeliveryFailureException";
    ResendConfirmationException["ForbiddenException"] = "ForbiddenException";
    ResendConfirmationException["InternalErrorException"] = "InternalErrorException";
    ResendConfirmationException["InvalidEmailRoleAccessPolicyException"] = "InvalidEmailRoleAccessPolicyException";
    ResendConfirmationException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    ResendConfirmationException["InvalidParameterException"] = "InvalidParameterException";
    ResendConfirmationException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    ResendConfirmationException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    ResendConfirmationException["LimitExceededException"] = "LimitExceededException";
    ResendConfirmationException["NotAuthorizedException"] = "NotAuthorizedException";
    ResendConfirmationException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ResendConfirmationException["TooManyRequestsException"] = "TooManyRequestsException";
    ResendConfirmationException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    ResendConfirmationException["UserLambdaValidationException"] = "UserLambdaValidationException";
    ResendConfirmationException["UserNotFoundException"] = "UserNotFoundException";
})($9e23bc336cf172f0$export$8807b62ddb0e4d9d || ($9e23bc336cf172f0$export$8807b62ddb0e4d9d = {}));
var $9e23bc336cf172f0$export$da9908386393628f;
(function(RespondToAuthChallengeException) {
    RespondToAuthChallengeException["AliasExistsException"] = "AliasExistsException";
    RespondToAuthChallengeException["CodeMismatchException"] = "CodeMismatchException";
    RespondToAuthChallengeException["ExpiredCodeException"] = "ExpiredCodeException";
    RespondToAuthChallengeException["ForbiddenException"] = "ForbiddenException";
    RespondToAuthChallengeException["InternalErrorException"] = "InternalErrorException";
    RespondToAuthChallengeException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    RespondToAuthChallengeException["InvalidParameterException"] = "InvalidParameterException";
    RespondToAuthChallengeException["InvalidPasswordException"] = "InvalidPasswordException";
    RespondToAuthChallengeException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    RespondToAuthChallengeException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    RespondToAuthChallengeException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    RespondToAuthChallengeException["MFAMethodNotFoundException"] = "MFAMethodNotFoundException";
    RespondToAuthChallengeException["NotAuthorizedException"] = "NotAuthorizedException";
    RespondToAuthChallengeException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    RespondToAuthChallengeException["ResourceNotFoundException"] = "ResourceNotFoundException";
    RespondToAuthChallengeException["SoftwareTokenMFANotFoundException"] = "SoftwareTokenMFANotFoundException";
    RespondToAuthChallengeException["TooManyRequestsException"] = "TooManyRequestsException";
    RespondToAuthChallengeException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    RespondToAuthChallengeException["UserLambdaValidationException"] = "UserLambdaValidationException";
    RespondToAuthChallengeException["UserNotConfirmedException"] = "UserNotConfirmedException";
    RespondToAuthChallengeException["UserNotFoundException"] = "UserNotFoundException";
})($9e23bc336cf172f0$export$da9908386393628f || ($9e23bc336cf172f0$export$da9908386393628f = {}));
var $9e23bc336cf172f0$export$23ea34859d89459d;
(function(SetUserMFAPreferenceException) {
    SetUserMFAPreferenceException["ForbiddenException"] = "ForbiddenException";
    SetUserMFAPreferenceException["InternalErrorException"] = "InternalErrorException";
    SetUserMFAPreferenceException["InvalidParameterException"] = "InvalidParameterException";
    SetUserMFAPreferenceException["NotAuthorizedException"] = "NotAuthorizedException";
    SetUserMFAPreferenceException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    SetUserMFAPreferenceException["ResourceNotFoundException"] = "ResourceNotFoundException";
    SetUserMFAPreferenceException["UserNotConfirmedException"] = "UserNotConfirmedException";
    SetUserMFAPreferenceException["UserNotFoundException"] = "UserNotFoundException";
})($9e23bc336cf172f0$export$23ea34859d89459d || ($9e23bc336cf172f0$export$23ea34859d89459d = {}));
var $9e23bc336cf172f0$export$d0816902ed99fce6;
(function(SignUpException) {
    SignUpException["CodeDeliveryFailureException"] = "CodeDeliveryFailureException";
    SignUpException["InternalErrorException"] = "InternalErrorException";
    SignUpException["InvalidEmailRoleAccessPolicyException"] = "InvalidEmailRoleAccessPolicyException";
    SignUpException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    SignUpException["InvalidParameterException"] = "InvalidParameterException";
    SignUpException["InvalidPasswordException"] = "InvalidPasswordException";
    SignUpException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    SignUpException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    SignUpException["NotAuthorizedException"] = "NotAuthorizedException";
    SignUpException["ResourceNotFoundException"] = "ResourceNotFoundException";
    SignUpException["TooManyRequestsException"] = "TooManyRequestsException";
    SignUpException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    SignUpException["UserLambdaValidationException"] = "UserLambdaValidationException";
    SignUpException["UsernameExistsException"] = "UsernameExistsException";
})($9e23bc336cf172f0$export$d0816902ed99fce6 || ($9e23bc336cf172f0$export$d0816902ed99fce6 = {}));
var $9e23bc336cf172f0$export$44cb15f260897376;
(function(UpdateUserAttributesException) {
    UpdateUserAttributesException["AliasExistsException"] = "AliasExistsException";
    UpdateUserAttributesException["CodeDeliveryFailureException"] = "CodeDeliveryFailureException";
    UpdateUserAttributesException["CodeMismatchException"] = "CodeMismatchException";
    UpdateUserAttributesException["ExpiredCodeException"] = "ExpiredCodeException";
    UpdateUserAttributesException["ForbiddenException"] = "ForbiddenException";
    UpdateUserAttributesException["InternalErrorException"] = "InternalErrorException";
    UpdateUserAttributesException["InvalidEmailRoleAccessPolicyException"] = "InvalidEmailRoleAccessPolicyException";
    UpdateUserAttributesException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    UpdateUserAttributesException["InvalidParameterException"] = "InvalidParameterException";
    UpdateUserAttributesException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    UpdateUserAttributesException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    UpdateUserAttributesException["NotAuthorizedException"] = "NotAuthorizedException";
    UpdateUserAttributesException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    UpdateUserAttributesException["ResourceNotFoundException"] = "ResourceNotFoundException";
    UpdateUserAttributesException["TooManyRequestsException"] = "TooManyRequestsException";
    UpdateUserAttributesException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    UpdateUserAttributesException["UserLambdaValidationException"] = "UserLambdaValidationException";
    UpdateUserAttributesException["UserNotConfirmedException"] = "UserNotConfirmedException";
    UpdateUserAttributesException["UserNotFoundException"] = "UserNotFoundException";
})($9e23bc336cf172f0$export$44cb15f260897376 || ($9e23bc336cf172f0$export$44cb15f260897376 = {}));
var $9e23bc336cf172f0$export$a974f64d24be573a;
(function(VerifySoftwareTokenException) {
    VerifySoftwareTokenException["CodeMismatchException"] = "CodeMismatchException";
    VerifySoftwareTokenException["EnableSoftwareTokenMFAException"] = "EnableSoftwareTokenMFAException";
    VerifySoftwareTokenException["ForbiddenException"] = "ForbiddenException";
    VerifySoftwareTokenException["InternalErrorException"] = "InternalErrorException";
    VerifySoftwareTokenException["InvalidParameterException"] = "InvalidParameterException";
    VerifySoftwareTokenException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    VerifySoftwareTokenException["NotAuthorizedException"] = "NotAuthorizedException";
    VerifySoftwareTokenException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    VerifySoftwareTokenException["ResourceNotFoundException"] = "ResourceNotFoundException";
    VerifySoftwareTokenException["SoftwareTokenMFANotFoundException"] = "SoftwareTokenMFANotFoundException";
    VerifySoftwareTokenException["TooManyRequestsException"] = "TooManyRequestsException";
    VerifySoftwareTokenException["UserNotConfirmedException"] = "UserNotConfirmedException";
    VerifySoftwareTokenException["UserNotFoundException"] = "UserNotFoundException";
})($9e23bc336cf172f0$export$a974f64d24be573a || ($9e23bc336cf172f0$export$a974f64d24be573a = {}));
var $9e23bc336cf172f0$export$527caabb62d14fe3;
(function(VerifyUserAttributeException) {
    VerifyUserAttributeException["AliasExistsException"] = "AliasExistsException";
    VerifyUserAttributeException["CodeMismatchException"] = "CodeMismatchException";
    VerifyUserAttributeException["ExpiredCodeException"] = "ExpiredCodeException";
    VerifyUserAttributeException["ForbiddenException"] = "ForbiddenException";
    VerifyUserAttributeException["InternalErrorException"] = "InternalErrorException";
    VerifyUserAttributeException["InvalidParameterException"] = "InvalidParameterException";
    VerifyUserAttributeException["LimitExceededException"] = "LimitExceededException";
    VerifyUserAttributeException["NotAuthorizedException"] = "NotAuthorizedException";
    VerifyUserAttributeException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    VerifyUserAttributeException["ResourceNotFoundException"] = "ResourceNotFoundException";
    VerifyUserAttributeException["TooManyRequestsException"] = "TooManyRequestsException";
    VerifyUserAttributeException["UserNotConfirmedException"] = "UserNotConfirmedException";
    VerifyUserAttributeException["UserNotFoundException"] = "UserNotFoundException";
})($9e23bc336cf172f0$export$527caabb62d14fe3 || ($9e23bc336cf172f0$export$527caabb62d14fe3 = {}));
var $9e23bc336cf172f0$export$de57be1863bdb9d6;
(function(UpdateDeviceStatusException) {
    UpdateDeviceStatusException["ForbiddenException"] = "ForbiddenException";
    UpdateDeviceStatusException["InternalErrorException"] = "InternalErrorException";
    UpdateDeviceStatusException["InvalidParameterException"] = "InvalidParameterException";
    UpdateDeviceStatusException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    UpdateDeviceStatusException["NotAuthorizedException"] = "NotAuthorizedException";
    UpdateDeviceStatusException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    UpdateDeviceStatusException["ResourceNotFoundException"] = "ResourceNotFoundException";
    UpdateDeviceStatusException["TooManyRequestsException"] = "TooManyRequestsException";
    UpdateDeviceStatusException["UserNotConfirmedException"] = "UserNotConfirmedException";
    UpdateDeviceStatusException["UserNotFoundException"] = "UserNotFoundException";
})($9e23bc336cf172f0$export$de57be1863bdb9d6 || ($9e23bc336cf172f0$export$de57be1863bdb9d6 = {}));
var $9e23bc336cf172f0$export$eb8cb06bdb07bf0c;
(function(ListDevicesException) {
    ListDevicesException["ForbiddenException"] = "ForbiddenException";
    ListDevicesException["InternalErrorException"] = "InternalErrorException";
    ListDevicesException["InvalidParameterException"] = "InvalidParameterException";
    ListDevicesException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    ListDevicesException["NotAuthorizedException"] = "NotAuthorizedException";
    ListDevicesException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    ListDevicesException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ListDevicesException["TooManyRequestsException"] = "TooManyRequestsException";
    ListDevicesException["UserNotConfirmedException"] = "UserNotConfirmedException";
    ListDevicesException["UserNotFoundException"] = "UserNotFoundException";
})($9e23bc336cf172f0$export$eb8cb06bdb07bf0c || ($9e23bc336cf172f0$export$eb8cb06bdb07bf0c = {}));
const $9e23bc336cf172f0$export$ecd3eb1722b48d26 = "SetUpTOTPException";




















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $33fa144820195cb7$export$11329f5ae466ab5d = (config)=>(0, $29600698f92385b7$export$880429a8ae983d4d)((0, $566d64d9996fb1fd$export$10f11e95d7a96f7b), (0, $12cd6399d355fb71$export$1113413e6e842bef)("RespondToAuthChallenge"), (0, $d5338601430a6488$export$8159795418a3e796)(), {
        ...(0, $579ad14e33e08f0c$export$22a3716e7860147a),
        ...config
    });









// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $3f10064ba4f72f83$export$cf5dd9429415aa98 = (config)=>(0, $29600698f92385b7$export$880429a8ae983d4d)((0, $566d64d9996fb1fd$export$10f11e95d7a96f7b), (0, $12cd6399d355fb71$export$1113413e6e842bef)("VerifySoftwareToken"), (0, $d5338601430a6488$export$8159795418a3e796)(), {
        ...(0, $579ad14e33e08f0c$export$22a3716e7860147a),
        ...config
    });









// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $0eb574771fa3c4bc$export$6bff32634453de2a = (config)=>(0, $29600698f92385b7$export$880429a8ae983d4d)((0, $566d64d9996fb1fd$export$10f11e95d7a96f7b), (0, $12cd6399d355fb71$export$1113413e6e842bef)("AssociateSoftwareToken"), (0, $d5338601430a6488$export$8159795418a3e796)(), {
        ...(0, $579ad14e33e08f0c$export$22a3716e7860147a),
        ...config
    });









// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $98602ad99f5e9d70$export$d88a63af6351a7c3 = (config)=>(0, $29600698f92385b7$export$880429a8ae983d4d)((0, $566d64d9996fb1fd$export$10f11e95d7a96f7b), (0, $12cd6399d355fb71$export$1113413e6e842bef)("ConfirmDevice"), (0, $d5338601430a6488$export$8159795418a3e796)(), {
        ...(0, $579ad14e33e08f0c$export$22a3716e7860147a),
        ...config
    });



















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
async function $f1b09a3c3b2ae67d$export$729df6fdd19b8b0d(AuthenticationResult) {
    if (AuthenticationResult.AccessToken) {
        const accessToken = (0, $da35d46b99b5d98d$export$9a62e6c0a30e00bc)(AuthenticationResult.AccessToken);
        const accessTokenIssuedAtInMillis = (accessToken.payload.iat || 0) * 1000;
        const currentTime = new Date().getTime();
        const clockDrift = accessTokenIssuedAtInMillis > 0 ? accessTokenIssuedAtInMillis - currentTime : 0;
        let idToken;
        let refreshToken;
        let deviceMetadata;
        if (AuthenticationResult.RefreshToken) refreshToken = AuthenticationResult.RefreshToken;
        if (AuthenticationResult.IdToken) idToken = (0, $da35d46b99b5d98d$export$9a62e6c0a30e00bc)(AuthenticationResult.IdToken);
        if (AuthenticationResult?.NewDeviceMetadata) deviceMetadata = AuthenticationResult.NewDeviceMetadata;
        const tokens = {
            accessToken: accessToken,
            idToken: idToken,
            refreshToken: refreshToken,
            clockDrift: clockDrift,
            deviceMetadata: deviceMetadata,
            username: AuthenticationResult.username
        };
        if (AuthenticationResult?.signInDetails) tokens.signInDetails = AuthenticationResult.signInDetails;
        await (0, $14fa9bd317b4b3d6$export$66561e66d62991d0).setTokens({
            tokens: tokens
        });
    } else // This would be a service error
    throw new (0, $d153492e067ac8ab$export$37321a6dace1881c)({
        message: "Invalid tokens",
        name: "InvalidTokens",
        recoverySuggestion: "Check Cognito UserPool settings"
    });
}







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $0386d0d0091ba4c9$export$3f27bc10068ef877 = "Unable to get user session following successful sign-in.";
const $0386d0d0091ba4c9$export$4d78d2ee899572ab = async ()=>{
    try {
        (0, $9464725044e9d769$export$8c41bb232f1008b1).dispatch("auth", {
            event: "signedIn",
            data: await (0, $a96a35a57f46b2c7$export$e5432d4c8eb97ea7)()
        }, "Auth", (0, $9464725044e9d769$export$aadf71dd9875dd20));
    } catch (error) {
        if (error.name === (0, $e4cb7b306ced9230$export$d29d1996d6b6f5e3)) throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
            name: (0, $e4cb7b306ced9230$export$606cffc85964c24b),
            message: $0386d0d0091ba4c9$export$3f27bc10068ef877,
            recoverySuggestion: "This most likely is due to auth tokens not being persisted. If you are using cookie store, please ensure cookies can be correctly set from your server."
        });
        throw error;
    }
};





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Minutes until stored session invalidates
const $18f78a860861bd8b$var$MS_TO_EXPIRY = 180000; // 3 mins
const $18f78a860861bd8b$var$TGT_STATE = "CognitoSignInState";
const $18f78a860861bd8b$var$SIGN_IN_STATE_KEYS = {
    username: `${$18f78a860861bd8b$var$TGT_STATE}.username`,
    challengeName: `${$18f78a860861bd8b$var$TGT_STATE}.challengeName`,
    signInSession: `${$18f78a860861bd8b$var$TGT_STATE}.signInSession`,
    expiry: `${$18f78a860861bd8b$var$TGT_STATE}.expiry`
};
const $18f78a860861bd8b$var$signInReducer = (state, action)=>{
    switch(action.type){
        case "SET_SIGN_IN_SESSION":
            $18f78a860861bd8b$export$f0d4bc0f1640c562({
                signInSession: action.value
            });
            return {
                ...state,
                signInSession: action.value
            };
        case "SET_SIGN_IN_STATE":
            $18f78a860861bd8b$export$f0d4bc0f1640c562(action.value);
            return {
                ...action.value
            };
        case "SET_CHALLENGE_NAME":
            $18f78a860861bd8b$export$f0d4bc0f1640c562({
                challengeName: action.value
            });
            return {
                ...state,
                challengeName: action.value
            };
        case "SET_USERNAME":
            $18f78a860861bd8b$export$f0d4bc0f1640c562({
                username: action.value
            });
            return {
                ...state,
                username: action.value
            };
        case "SET_INITIAL_STATE":
            return $18f78a860861bd8b$var$getInitialState();
        case "RESET_STATE":
            $18f78a860861bd8b$var$clearPersistedSignInState();
            return $18f78a860861bd8b$var$getDefaultState();
        // this state is never reachable
        default:
            return state;
    }
};
const $18f78a860861bd8b$var$isExpired = (expiryDate)=>{
    const expiryTimestamp = Number(expiryDate);
    const currentTimestamp = Date.now();
    return expiryTimestamp <= currentTimestamp;
};
const $18f78a860861bd8b$export$ddfd5a0262ce9df3 = ()=>{
    $18f78a860861bd8b$export$390d5da4c63a4a41.dispatch({
        type: "RESET_STATE"
    });
};
const $18f78a860861bd8b$var$clearPersistedSignInState = ()=>{
    for (const stateKey of Object.values($18f78a860861bd8b$var$SIGN_IN_STATE_KEYS))(0, $d6350db11aa681cd$export$9015f19b74348a18).removeItem(stateKey);
};
const $18f78a860861bd8b$var$getDefaultState = ()=>({
        username: undefined,
        challengeName: undefined,
        signInSession: undefined
    });
// Hydrate signInStore from syncSessionStorage
const $18f78a860861bd8b$var$getInitialState = ()=>{
    const expiry = (0, $d6350db11aa681cd$export$9015f19b74348a18).getItem($18f78a860861bd8b$var$SIGN_IN_STATE_KEYS.expiry);
    if (!expiry || $18f78a860861bd8b$var$isExpired(expiry)) {
        $18f78a860861bd8b$var$clearPersistedSignInState();
        return $18f78a860861bd8b$var$getDefaultState();
    }
    const username = (0, $d6350db11aa681cd$export$9015f19b74348a18).getItem($18f78a860861bd8b$var$SIGN_IN_STATE_KEYS.username) ?? undefined;
    const challengeName = (0, $d6350db11aa681cd$export$9015f19b74348a18).getItem($18f78a860861bd8b$var$SIGN_IN_STATE_KEYS.challengeName) ?? undefined;
    const signInSession = (0, $d6350db11aa681cd$export$9015f19b74348a18).getItem($18f78a860861bd8b$var$SIGN_IN_STATE_KEYS.signInSession) ?? undefined;
    return {
        username: username,
        challengeName: challengeName,
        signInSession: signInSession
    };
};
const $18f78a860861bd8b$var$createStore = (reducer)=>{
    let currentState = reducer($18f78a860861bd8b$var$getDefaultState(), {
        type: "SET_INITIAL_STATE"
    });
    return {
        getState: ()=>currentState,
        dispatch: (action)=>{
            currentState = reducer(currentState, action);
        }
    };
};
const $18f78a860861bd8b$export$390d5da4c63a4a41 = $18f78a860861bd8b$var$createStore($18f78a860861bd8b$var$signInReducer);
function $18f78a860861bd8b$export$bae72361b690e075(state) {
    $18f78a860861bd8b$export$390d5da4c63a4a41.dispatch({
        type: "SET_SIGN_IN_STATE",
        value: state
    });
}
// Save local state into Session Storage
const $18f78a860861bd8b$export$f0d4bc0f1640c562 = ({ challengeName: challengeName , signInSession: signInSession , username: username  })=>{
    username && (0, $d6350db11aa681cd$export$9015f19b74348a18).setItem($18f78a860861bd8b$var$SIGN_IN_STATE_KEYS.username, username);
    challengeName && (0, $d6350db11aa681cd$export$9015f19b74348a18).setItem($18f78a860861bd8b$var$SIGN_IN_STATE_KEYS.challengeName, challengeName);
    if (signInSession) {
        (0, $d6350db11aa681cd$export$9015f19b74348a18).setItem($18f78a860861bd8b$var$SIGN_IN_STATE_KEYS.signInSession, signInSession);
        // Updates expiry when session is passed
        (0, $d6350db11aa681cd$export$9015f19b74348a18).setItem($18f78a860861bd8b$var$SIGN_IN_STATE_KEYS.expiry, String(Date.now() + $18f78a860861bd8b$var$MS_TO_EXPIRY));
    }
};




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $06e8711f4886fb98$export$bf0fd5fd31fb5a90 extends (0, $d153492e067ac8ab$export$37321a6dace1881c) {
    constructor(params){
        super(params);
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        this.constructor = $06e8711f4886fb98$export$bf0fd5fd31fb5a90;
        Object.setPrototypeOf(this, $06e8711f4886fb98$export$bf0fd5fd31fb5a90.prototype);
    }
}
var $06e8711f4886fb98$export$8c9a5e3ce7fcf74e;
(function(PasskeyErrorCode) {
    // not supported
    PasskeyErrorCode["PasskeyNotSupported"] = "PasskeyNotSupported";
    // duplicate passkey
    PasskeyErrorCode["PasskeyAlreadyExists"] = "PasskeyAlreadyExists";
    // misconfigurations
    PasskeyErrorCode["InvalidPasskeyRegistrationOptions"] = "InvalidPasskeyRegistrationOptions";
    PasskeyErrorCode["InvalidPasskeyAuthenticationOptions"] = "InvalidPasskeyAuthenticationOptions";
    PasskeyErrorCode["RelyingPartyMismatch"] = "RelyingPartyMismatch";
    // failed credential creation / retrieval
    PasskeyErrorCode["PasskeyRegistrationFailed"] = "PasskeyRegistrationFailed";
    PasskeyErrorCode["PasskeyRetrievalFailed"] = "PasskeyRetrievalFailed";
    // cancel / aborts
    PasskeyErrorCode["PasskeyRegistrationCanceled"] = "PasskeyRegistrationCanceled";
    PasskeyErrorCode["PasskeyAuthenticationCanceled"] = "PasskeyAuthenticationCanceled";
    PasskeyErrorCode["PasskeyOperationAborted"] = "PasskeyOperationAborted";
})($06e8711f4886fb98$export$8c9a5e3ce7fcf74e || ($06e8711f4886fb98$export$8c9a5e3ce7fcf74e = {}));
const $06e8711f4886fb98$var$notSupportedRecoverySuggestion = "Passkeys may not be supported on this device. Ensure your application is running in a secure context (HTTPS) and Web Authentication API is supported.";
const $06e8711f4886fb98$var$abortOrCancelRecoverySuggestion = "User may have canceled the ceremony or another interruption has occurred. Check underlying error for details.";
const $06e8711f4886fb98$var$misconfigurationRecoverySuggestion = "Ensure your user pool is configured to support the WEB_AUTHN as an authentication factor.";
const $06e8711f4886fb98$var$passkeyErrorMap = {
    [$06e8711f4886fb98$export$8c9a5e3ce7fcf74e.PasskeyNotSupported]: {
        message: "Passkeys may not be supported on this device.",
        recoverySuggestion: $06e8711f4886fb98$var$notSupportedRecoverySuggestion
    },
    [$06e8711f4886fb98$export$8c9a5e3ce7fcf74e.InvalidPasskeyRegistrationOptions]: {
        message: "Invalid passkey registration options.",
        recoverySuggestion: $06e8711f4886fb98$var$misconfigurationRecoverySuggestion
    },
    [$06e8711f4886fb98$export$8c9a5e3ce7fcf74e.InvalidPasskeyAuthenticationOptions]: {
        message: "Invalid passkey authentication options.",
        recoverySuggestion: $06e8711f4886fb98$var$misconfigurationRecoverySuggestion
    },
    [$06e8711f4886fb98$export$8c9a5e3ce7fcf74e.PasskeyRegistrationFailed]: {
        message: "Device failed to create passkey.",
        recoverySuggestion: $06e8711f4886fb98$var$notSupportedRecoverySuggestion
    },
    [$06e8711f4886fb98$export$8c9a5e3ce7fcf74e.PasskeyRetrievalFailed]: {
        message: "Device failed to retrieve passkey.",
        recoverySuggestion: "Passkeys may not be available on this device. Try an alternative authentication factor like PASSWORD, EMAIL_OTP, or SMS_OTP."
    },
    [$06e8711f4886fb98$export$8c9a5e3ce7fcf74e.PasskeyAlreadyExists]: {
        message: "Passkey already exists in authenticator.",
        recoverySuggestion: "Proceed with existing passkey or try again after deleting the credential."
    },
    [$06e8711f4886fb98$export$8c9a5e3ce7fcf74e.PasskeyRegistrationCanceled]: {
        message: "Passkey registration ceremony has been canceled.",
        recoverySuggestion: $06e8711f4886fb98$var$abortOrCancelRecoverySuggestion
    },
    [$06e8711f4886fb98$export$8c9a5e3ce7fcf74e.PasskeyAuthenticationCanceled]: {
        message: "Passkey authentication ceremony has been canceled.",
        recoverySuggestion: $06e8711f4886fb98$var$abortOrCancelRecoverySuggestion
    },
    [$06e8711f4886fb98$export$8c9a5e3ce7fcf74e.PasskeyOperationAborted]: {
        message: "Passkey operation has been aborted.",
        recoverySuggestion: $06e8711f4886fb98$var$abortOrCancelRecoverySuggestion
    },
    [$06e8711f4886fb98$export$8c9a5e3ce7fcf74e.RelyingPartyMismatch]: {
        message: "Relying party does not match current domain.",
        recoverySuggestion: "Ensure relying party identifier matches current domain."
    }
};
const $06e8711f4886fb98$export$3145abf24cf8a54e = (0, $318f49e195f770af$export$5cb8fc27ccbe9d40)($06e8711f4886fb98$var$passkeyErrorMap, $06e8711f4886fb98$export$bf0fd5fd31fb5a90);
/**
 * Handle Passkey Authentication Errors
 * https://w3c.github.io/webauthn/#sctn-get-request-exceptions
 *
 * @param err unknown
 * @returns PasskeyError
 */ const $06e8711f4886fb98$export$6abde9ceb8dfddc0 = (err)=>{
    if (err instanceof $06e8711f4886fb98$export$bf0fd5fd31fb5a90) return err;
    if (err instanceof Error) {
        if (err.name === "NotAllowedError") {
            const { message: message , recoverySuggestion: recoverySuggestion  } = $06e8711f4886fb98$var$passkeyErrorMap[$06e8711f4886fb98$export$8c9a5e3ce7fcf74e.PasskeyAuthenticationCanceled];
            return new $06e8711f4886fb98$export$bf0fd5fd31fb5a90({
                name: $06e8711f4886fb98$export$8c9a5e3ce7fcf74e.PasskeyAuthenticationCanceled,
                message: message,
                recoverySuggestion: recoverySuggestion,
                underlyingError: err
            });
        }
    }
    return $06e8711f4886fb98$var$handlePasskeyError(err);
};
/**
 * Handle Passkey Registration Errors
 * https://w3c.github.io/webauthn/#sctn-create-request-exceptions
 *
 * @param err unknown
 * @returns PasskeyError
 */ const $06e8711f4886fb98$export$7460eb590a766e24 = (err)=>{
    if (err instanceof $06e8711f4886fb98$export$bf0fd5fd31fb5a90) return err;
    if (err instanceof Error) {
        // Duplicate Passkey
        if (err.name === "InvalidStateError") {
            const { message: message , recoverySuggestion: recoverySuggestion  } = $06e8711f4886fb98$var$passkeyErrorMap[$06e8711f4886fb98$export$8c9a5e3ce7fcf74e.PasskeyAlreadyExists];
            return new $06e8711f4886fb98$export$bf0fd5fd31fb5a90({
                name: $06e8711f4886fb98$export$8c9a5e3ce7fcf74e.PasskeyAlreadyExists,
                message: message,
                recoverySuggestion: recoverySuggestion,
                underlyingError: err
            });
        }
        // User Cancels Ceremony / Generic Catch All
        if (err.name === "NotAllowedError") {
            const { message: message , recoverySuggestion: recoverySuggestion  } = $06e8711f4886fb98$var$passkeyErrorMap[$06e8711f4886fb98$export$8c9a5e3ce7fcf74e.PasskeyRegistrationCanceled];
            return new $06e8711f4886fb98$export$bf0fd5fd31fb5a90({
                name: $06e8711f4886fb98$export$8c9a5e3ce7fcf74e.PasskeyRegistrationCanceled,
                message: message,
                recoverySuggestion: recoverySuggestion,
                underlyingError: err
            });
        }
    }
    return $06e8711f4886fb98$var$handlePasskeyError(err);
};
/**
 * Handles Overlapping Passkey Errors Between Registration & Authentication
 * https://w3c.github.io/webauthn/#sctn-create-request-exceptions
 * https://w3c.github.io/webauthn/#sctn-get-request-exceptions
 *
 * @param err unknown
 * @returns PasskeyError
 */ const $06e8711f4886fb98$var$handlePasskeyError = (err)=>{
    if (err instanceof Error) {
        // Passkey Operation Aborted
        if (err.name === "AbortError") {
            const { message: message , recoverySuggestion: recoverySuggestion  } = $06e8711f4886fb98$var$passkeyErrorMap[$06e8711f4886fb98$export$8c9a5e3ce7fcf74e.PasskeyOperationAborted];
            return new $06e8711f4886fb98$export$bf0fd5fd31fb5a90({
                name: $06e8711f4886fb98$export$8c9a5e3ce7fcf74e.PasskeyOperationAborted,
                message: message,
                recoverySuggestion: recoverySuggestion,
                underlyingError: err
            });
        }
        // Relying Party / Domain Mismatch
        if (err.name === "SecurityError") {
            const { message: message , recoverySuggestion: recoverySuggestion  } = $06e8711f4886fb98$var$passkeyErrorMap[$06e8711f4886fb98$export$8c9a5e3ce7fcf74e.RelyingPartyMismatch];
            return new $06e8711f4886fb98$export$bf0fd5fd31fb5a90({
                name: $06e8711f4886fb98$export$8c9a5e3ce7fcf74e.RelyingPartyMismatch,
                message: message,
                recoverySuggestion: recoverySuggestion,
                underlyingError: err
            });
        }
    }
    return new $06e8711f4886fb98$export$bf0fd5fd31fb5a90({
        name: (0, $f5d3b7601afe1953$export$4e712df6b850c8d0).Unknown,
        message: "An unknown error has occurred.",
        underlyingError: err
    });
};




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Determines if passkey is supported in current context
 * Will return false if executed in non-secure context
 * @returns boolean
 */ const $7b7112047e0327cf$export$3b0e0bb0e9c22c1a = ()=>{
    return (0, $59ed5bbcecfdce0d$export$4e09c449d6c407f7)() && window.isSecureContext && "credentials" in navigator && typeof window.PublicKeyCredential === "function";
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// https://datatracker.ietf.org/doc/html/rfc4648#page-7
/**
 * Converts an ArrayBuffer to a base64url encoded string
 * @param buffer - the ArrayBuffer instance of a Uint8Array
 * @returns string - a base64url encoded string
 */ const $0541f0d10421b8f0$export$442d4feb149fcd32 = (buffer)=>{
    return (0, $2c81515d3d5db49f$export$695b149896bd3e2a).convert(new Uint8Array(buffer), {
        urlSafe: true,
        skipPadding: true
    });
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Converts a base64url encoded string to an ArrayBuffer
 * @param base64url - a base64url encoded string
 * @returns ArrayBuffer
 */ const $0270e4bf4c43514e$export$9cebd483a59f0168 = (base64url)=>{
    return Uint8Array.from((0, $01459b747c81c3e7$export$1e303d38dab7b376).convert(base64url, {
        urlSafe: true
    }), (x)=>x.charCodeAt(0)).buffer;
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Deserializes Public Key Credential Creation Options JSON
 * @param input PasskeyCreateOptionsJson
 * @returns PublicKeyCredentialCreationOptions
 */ const $198834e615107964$export$a8f43933ee13e976 = (input)=>{
    const userIdBuffer = (0, $0270e4bf4c43514e$export$9cebd483a59f0168)(input.user.id);
    const challengeBuffer = (0, $0270e4bf4c43514e$export$9cebd483a59f0168)(input.challenge);
    const excludeCredentialsWithBuffer = (input.excludeCredentials || []).map((excludeCred)=>({
            ...excludeCred,
            id: (0, $0270e4bf4c43514e$export$9cebd483a59f0168)(excludeCred.id)
        }));
    return {
        ...input,
        excludeCredentials: excludeCredentialsWithBuffer,
        challenge: challengeBuffer,
        user: {
            ...input.user,
            id: userIdBuffer
        }
    };
};
/**
 * Serializes a Public Key Credential With Attestation to JSON
 * @param input PasskeyCreateResult
 * @returns PasskeyCreateResultJson
 */ const $198834e615107964$export$f686d838e2fa9da3 = (input)=>{
    const response = {
        clientDataJSON: (0, $0541f0d10421b8f0$export$442d4feb149fcd32)(input.response.clientDataJSON),
        attestationObject: (0, $0541f0d10421b8f0$export$442d4feb149fcd32)(input.response.attestationObject),
        transports: input.response.getTransports(),
        publicKeyAlgorithm: input.response.getPublicKeyAlgorithm(),
        authenticatorData: (0, $0541f0d10421b8f0$export$442d4feb149fcd32)(input.response.getAuthenticatorData())
    };
    const publicKey = input.response.getPublicKey();
    if (publicKey) response.publicKey = (0, $0541f0d10421b8f0$export$442d4feb149fcd32)(publicKey);
    const resultJson = {
        type: input.type,
        id: input.id,
        rawId: (0, $0541f0d10421b8f0$export$442d4feb149fcd32)(input.rawId),
        clientExtensionResults: input.getClientExtensionResults(),
        response: response
    };
    if (input.authenticatorAttachment) resultJson.authenticatorAttachment = input.authenticatorAttachment;
    return resultJson;
};
/**
 * Deserializes Public Key Credential Get Options JSON
 * @param input PasskeyGetOptionsJson
 * @returns PublicKeyCredentialRequestOptions
 */ const $198834e615107964$export$d3f47ce866c52e8e = (input)=>{
    const challengeBuffer = (0, $0270e4bf4c43514e$export$9cebd483a59f0168)(input.challenge);
    const allowedCredentialsWithBuffer = (input.allowCredentials || []).map((allowedCred)=>({
            ...allowedCred,
            id: (0, $0270e4bf4c43514e$export$9cebd483a59f0168)(allowedCred.id)
        }));
    return {
        ...input,
        challenge: challengeBuffer,
        allowCredentials: allowedCredentialsWithBuffer
    };
};
/**
 * Serializes a Public Key Credential With Attestation to JSON
 * @param input PasskeyGetResult
 * @returns PasskeyGetResultJson
 */ const $198834e615107964$export$1f22b133ac0d2a5 = (input)=>{
    const response = {
        clientDataJSON: (0, $0541f0d10421b8f0$export$442d4feb149fcd32)(input.response.clientDataJSON),
        authenticatorData: (0, $0541f0d10421b8f0$export$442d4feb149fcd32)(input.response.authenticatorData),
        signature: (0, $0541f0d10421b8f0$export$442d4feb149fcd32)(input.response.signature)
    };
    if (input.response.userHandle) response.userHandle = (0, $0541f0d10421b8f0$export$442d4feb149fcd32)(input.response.userHandle);
    const resultJson = {
        id: input.id,
        rawId: (0, $0541f0d10421b8f0$export$442d4feb149fcd32)(input.rawId),
        type: input.type,
        clientExtensionResults: input.getClientExtensionResults(),
        response: response
    };
    if (input.authenticatorAttachment) resultJson.authenticatorAttachment = input.authenticatorAttachment;
    return resultJson;
};




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $bea5e82637522649$export$c7806094d9c936a2(credential) {
    (0, $06e8711f4886fb98$export$3145abf24cf8a54e)(credential && credential instanceof PublicKeyCredential && credential.response instanceof AuthenticatorAttestationResponse, (0, $06e8711f4886fb98$export$8c9a5e3ce7fcf74e).PasskeyRegistrationFailed);
}
function $bea5e82637522649$export$4f19e511a89efed7(credential) {
    (0, $06e8711f4886fb98$export$3145abf24cf8a54e)(credential && credential instanceof PublicKeyCredential && credential.response instanceof AuthenticatorAssertionResponse, (0, $06e8711f4886fb98$export$8c9a5e3ce7fcf74e).PasskeyRetrievalFailed);
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $02000ead1bb28540$export$d7f92bd7f1e366c1 = async (input)=>{
    try {
        const isPasskeySupported = (0, $7b7112047e0327cf$export$3b0e0bb0e9c22c1a)();
        (0, $06e8711f4886fb98$export$3145abf24cf8a54e)(isPasskeySupported, (0, $06e8711f4886fb98$export$8c9a5e3ce7fcf74e).PasskeyNotSupported);
        const passkeyGetOptions = (0, $198834e615107964$export$d3f47ce866c52e8e)(input);
        const credential = await navigator.credentials.get({
            publicKey: passkeyGetOptions
        });
        (0, $bea5e82637522649$export$4f19e511a89efed7)(credential);
        return (0, $198834e615107964$export$1f22b133ac0d2a5)(credential);
    } catch (err) {
        throw (0, $06e8711f4886fb98$export$6abde9ceb8dfddc0)(err);
    }
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
async function $10c42e9ccd80355d$export$77701654924537aa(challengeParameters) {
    const authConfig = (0, $44174d4eb465d133$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    (0, $da35d46b99b5d98d$export$80c92581e59ed502)(authConfig);
    const { username: username , signInSession: signInSession , signInDetails: signInDetails , challengeName: challengeName  } = (0, $18f78a860861bd8b$export$390d5da4c63a4a41).getState();
    if (challengeName !== "WEB_AUTHN" || !username) throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
        name: (0, $3277196cec8a3dbe$export$473ab0b56598aacd).SignInException,
        message: "Unable to proceed due to invalid sign in state."
    });
    const { CREDENTIAL_REQUEST_OPTIONS: credentialRequestOptions  } = challengeParameters;
    (0, $06e8711f4886fb98$export$3145abf24cf8a54e)(!!credentialRequestOptions, (0, $06e8711f4886fb98$export$8c9a5e3ce7fcf74e).InvalidPasskeyAuthenticationOptions);
    const cred = await (0, $02000ead1bb28540$export$d7f92bd7f1e366c1)(JSON.parse(credentialRequestOptions));
    const respondToAuthChallenge = (0, $33fa144820195cb7$export$11329f5ae466ab5d)({
        endpointResolver: (0, $034f40104fa68ca7$export$9fc8f7dceefe00a6)({
            endpointOverride: authConfig.userPoolEndpoint
        })
    });
    const { ChallengeName: nextChallengeName , ChallengeParameters: nextChallengeParameters , AuthenticationResult: authenticationResult , Session: nextSession  } = await respondToAuthChallenge({
        region: (0, $f3a37e3ae41d4905$export$5f7eb9761ac2d0d9)(authConfig.userPoolId),
        userAgentValue: (0, $7032744b11af61d7$export$d6cd780379f37dae)((0, $80240862ea60f1f3$export$900b1436d7e65f4).ConfirmSignIn)
    }, {
        ChallengeName: "WEB_AUTHN",
        ChallengeResponses: {
            USERNAME: username,
            CREDENTIAL: JSON.stringify(cred)
        },
        ClientId: authConfig.userPoolClientId,
        Session: signInSession
    });
    (0, $18f78a860861bd8b$export$bae72361b690e075)({
        signInSession: nextSession,
        username: username,
        challengeName: nextChallengeName,
        signInDetails: signInDetails
    });
    if (authenticationResult) {
        await (0, $f1b09a3c3b2ae67d$export$729df6fdd19b8b0d)({
            ...authenticationResult,
            username: username,
            NewDeviceMetadata: await (0, $d3c3238cf7b10401$export$548ed8ad974a8b30)({
                userPoolId: authConfig.userPoolId,
                userPoolEndpoint: authConfig.userPoolEndpoint,
                newDeviceMetadata: authenticationResult.NewDeviceMetadata,
                accessToken: authenticationResult.AccessToken
            }),
            signInDetails: signInDetails
        });
        (0, $18f78a860861bd8b$export$390d5da4c63a4a41).dispatch({
            type: "RESET_STATE"
        });
        await (0, $0386d0d0091ba4c9$export$4d78d2ee899572ab)();
        return {
            isSignedIn: true,
            nextStep: {
                signInStep: "DONE"
            }
        };
    }
    if (nextChallengeName === "WEB_AUTHN") throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
        name: (0, $3277196cec8a3dbe$export$473ab0b56598aacd).SignInException,
        message: "Sequential WEB_AUTHN challenges returned from underlying service cannot be handled."
    });
    return (0, $d3c3238cf7b10401$export$cf152400b58b8e65)({
        challengeName: nextChallengeName,
        challengeParameters: nextChallengeParameters
    });
}





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $8f38281af144dd56$export$f5d75491a17f02c = {
    convert (input) {
        return new TextEncoder().encode(input);
    }
};


/* eslint-disable */ // @ts-nocheck -> BigInteger is already a vended utility
// A small implementation of BigInteger based on http://www-cs-students.stanford.edu/~tjw/jsbn/
//
// All public methods have been removed except the following:
//   new BigInteger(a, b) (only radix 2, 4, 8, 16 and 32 supported)
//   toString (only radix 2, 4, 8, 16 and 32 supported)
//   negate
//   abs
//   compareTo
//   bitLength
//   mod
//   equals
//   add
//   subtract
//   multiply
//   divide
//   modPow
/*
 * Copyright (c) 2003-2005  Tom Wu
 * All Rights Reserved.
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS-IS" AND WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS, IMPLIED OR OTHERWISE, INCLUDING WITHOUT LIMITATION, ANY
 * WARRANTY OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE.
 *
 * IN NO EVENT SHALL TOM WU BE LIABLE FOR ANY SPECIAL, INCIDENTAL,
 * INDIRECT OR CONSEQUENTIAL DAMAGES OF ANY KIND, OR ANY DAMAGES WHATSOEVER
 * RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER OR NOT ADVISED OF
 * THE POSSIBILITY OF DAMAGE, AND ON ANY THEORY OF LIABILITY, ARISING OUT
 * OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 *
 * In addition, the following condition applies:
 *
 * All redistributions must retain an intact copy of this copyright notice
 * and disclaimer.
 */ // (public) Constructor
function $e6b0d30d639b7439$export$2e2bcd8739ae039(a, b) {
    if (a != null) this.fromString(a, b);
}
// return new, unset BigInteger
function $e6b0d30d639b7439$var$nbi() {
    return new $e6b0d30d639b7439$export$2e2bcd8739ae039(null, null);
}
// Bits per digit
let $e6b0d30d639b7439$var$dbits;
// JavaScript engine analysis
const $e6b0d30d639b7439$var$canary = 0xdeadbeefcafe;
const $e6b0d30d639b7439$var$j_lm = ($e6b0d30d639b7439$var$canary & 0xffffff) === 0xefcafe;
// am: Compute w_j += (x*this_i), propagate carries,
// c is initial carry, returns final carry.
// c < 3*dvalue, x < 2*dvalue, this_i < dvalue
// We need to select the fastest one that works in this environment.
// am1: use a single mult and divide to get the high bits,
// max digit bits should be 26 because
// max internal value = 2*dvalue^2-2*dvalue (< 2^53)
function $e6b0d30d639b7439$var$am1(i, x, w, j, c, n) {
    while(--n >= 0){
        const v = x * this[i++] + w[j] + c;
        c = Math.floor(v / 0x4000000);
        w[j++] = v & 0x3ffffff;
    }
    return c;
}
// am2 avoids a big mult-and-extract completely.
// Max digit bits should be <= 30 because we do bitwise ops
// on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
function $e6b0d30d639b7439$var$am2(i, x, w, j, c, n) {
    const xl = x & 0x7fff;
    const xh = x >> 15;
    while(--n >= 0){
        let l = this[i] & 0x7fff;
        const h = this[i++] >> 15;
        const m = xh * l + h * xl;
        l = xl * l + ((m & 0x7fff) << 15) + w[j] + (c & 0x3fffffff);
        c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
        w[j++] = l & 0x3fffffff;
    }
    return c;
}
// Alternately, set max digit bits to 28 since some
// browsers slow down when dealing with 32-bit numbers.
function $e6b0d30d639b7439$var$am3(i, x, w, j, c, n) {
    const xl = x & 0x3fff;
    const xh = x >> 14;
    while(--n >= 0){
        let l = this[i] & 0x3fff;
        const h = this[i++] >> 14;
        const m = xh * l + h * xl;
        l = xl * l + ((m & 0x3fff) << 14) + w[j] + c;
        c = (l >> 28) + (m >> 14) + xh * h;
        w[j++] = l & 0xfffffff;
    }
    return c;
}
const $e6b0d30d639b7439$var$inBrowser = typeof navigator !== "undefined";
if ($e6b0d30d639b7439$var$inBrowser && $e6b0d30d639b7439$var$j_lm && navigator.appName === "Microsoft Internet Explorer") {
    $e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.am = $e6b0d30d639b7439$var$am2;
    $e6b0d30d639b7439$var$dbits = 30;
} else if ($e6b0d30d639b7439$var$inBrowser && $e6b0d30d639b7439$var$j_lm && navigator.appName !== "Netscape") {
    $e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.am = $e6b0d30d639b7439$var$am1;
    $e6b0d30d639b7439$var$dbits = 26;
} else {
    // Mozilla/Netscape seems to prefer am3
    $e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.am = $e6b0d30d639b7439$var$am3;
    $e6b0d30d639b7439$var$dbits = 28;
}
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.DB = $e6b0d30d639b7439$var$dbits;
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.DM = (1 << $e6b0d30d639b7439$var$dbits) - 1;
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.DV = 1 << $e6b0d30d639b7439$var$dbits;
const $e6b0d30d639b7439$var$BI_FP = 52;
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.FV = Math.pow(2, $e6b0d30d639b7439$var$BI_FP);
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.F1 = $e6b0d30d639b7439$var$BI_FP - $e6b0d30d639b7439$var$dbits;
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.F2 = 2 * $e6b0d30d639b7439$var$dbits - $e6b0d30d639b7439$var$BI_FP;
// Digit conversions
const $e6b0d30d639b7439$var$BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
const $e6b0d30d639b7439$var$BI_RC = [];
let $e6b0d30d639b7439$var$rr, $e6b0d30d639b7439$var$vv;
$e6b0d30d639b7439$var$rr = "0".charCodeAt(0);
for($e6b0d30d639b7439$var$vv = 0; $e6b0d30d639b7439$var$vv <= 9; ++$e6b0d30d639b7439$var$vv)$e6b0d30d639b7439$var$BI_RC[$e6b0d30d639b7439$var$rr++] = $e6b0d30d639b7439$var$vv;
$e6b0d30d639b7439$var$rr = "a".charCodeAt(0);
for($e6b0d30d639b7439$var$vv = 10; $e6b0d30d639b7439$var$vv < 36; ++$e6b0d30d639b7439$var$vv)$e6b0d30d639b7439$var$BI_RC[$e6b0d30d639b7439$var$rr++] = $e6b0d30d639b7439$var$vv;
$e6b0d30d639b7439$var$rr = "A".charCodeAt(0);
for($e6b0d30d639b7439$var$vv = 10; $e6b0d30d639b7439$var$vv < 36; ++$e6b0d30d639b7439$var$vv)$e6b0d30d639b7439$var$BI_RC[$e6b0d30d639b7439$var$rr++] = $e6b0d30d639b7439$var$vv;
function $e6b0d30d639b7439$var$int2char(n) {
    return $e6b0d30d639b7439$var$BI_RM.charAt(n);
}
function $e6b0d30d639b7439$var$intAt(s, i) {
    const c = $e6b0d30d639b7439$var$BI_RC[s.charCodeAt(i)];
    return c == null ? -1 : c;
}
// (protected) copy this to r
function $e6b0d30d639b7439$var$bnpCopyTo(r) {
    for(let i = this.t - 1; i >= 0; --i)r[i] = this[i];
    r.t = this.t;
    r.s = this.s;
}
// (protected) set from integer value x, -DV <= x < DV
function $e6b0d30d639b7439$var$bnpFromInt(x) {
    this.t = 1;
    this.s = x < 0 ? -1 : 0;
    if (x > 0) this[0] = x;
    else if (x < -1) this[0] = x + this.DV;
    else this.t = 0;
}
// return bigint initialized to value
function $e6b0d30d639b7439$var$nbv(i) {
    const r = $e6b0d30d639b7439$var$nbi();
    r.fromInt(i);
    return r;
}
// (protected) set from string and radix
function $e6b0d30d639b7439$var$bnpFromString(s, b) {
    let k;
    if (b === 16) k = 4;
    else if (b === 8) k = 3;
    else if (b === 2) k = 1;
    else if (b === 32) k = 5;
    else if (b === 4) k = 2;
    else throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
    this.t = 0;
    this.s = 0;
    let i = s.length;
    let mi = false;
    let sh = 0;
    while(--i >= 0){
        const x = $e6b0d30d639b7439$var$intAt(s, i);
        if (x < 0) {
            if (s.charAt(i) === "-") mi = true;
            continue;
        }
        mi = false;
        if (sh === 0) this[this.t++] = x;
        else if (sh + k > this.DB) {
            this[this.t - 1] |= (x & (1 << this.DB - sh) - 1) << sh;
            this[this.t++] = x >> this.DB - sh;
        } else this[this.t - 1] |= x << sh;
        sh += k;
        if (sh >= this.DB) sh -= this.DB;
    }
    this.clamp();
    if (mi) $e6b0d30d639b7439$export$2e2bcd8739ae039.ZERO.subTo(this, this);
}
// (protected) clamp off excess high words
function $e6b0d30d639b7439$var$bnpClamp() {
    const c = this.s & this.DM;
    while(this.t > 0 && this[this.t - 1] == c)--this.t;
}
// (public) return string representation in given radix
function $e6b0d30d639b7439$var$bnToString(b) {
    if (this.s < 0) return "-" + this.negate().toString(b);
    let k;
    if (b == 16) k = 4;
    else if (b === 8) k = 3;
    else if (b === 2) k = 1;
    else if (b === 32) k = 5;
    else if (b === 4) k = 2;
    else throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
    const km = (1 << k) - 1;
    let d;
    let m = false;
    let r = "";
    let i = this.t;
    let p = this.DB - i * this.DB % k;
    if (i-- > 0) {
        if (p < this.DB && (d = this[i] >> p) > 0) {
            m = true;
            r = $e6b0d30d639b7439$var$int2char(d);
        }
        while(i >= 0){
            if (p < k) {
                d = (this[i] & (1 << p) - 1) << k - p;
                d |= this[--i] >> (p += this.DB - k);
            } else {
                d = this[i] >> (p -= k) & km;
                if (p <= 0) {
                    p += this.DB;
                    --i;
                }
            }
            if (d > 0) m = true;
            if (m) r += $e6b0d30d639b7439$var$int2char(d);
        }
    }
    return m ? r : "0";
}
// (public) -this
function $e6b0d30d639b7439$var$bnNegate() {
    const r = $e6b0d30d639b7439$var$nbi();
    $e6b0d30d639b7439$export$2e2bcd8739ae039.ZERO.subTo(this, r);
    return r;
}
// (public) |this|
function $e6b0d30d639b7439$var$bnAbs() {
    return this.s < 0 ? this.negate() : this;
}
// (public) return + if this > a, - if this < a, 0 if equal
function $e6b0d30d639b7439$var$bnCompareTo(a) {
    let r = this.s - a.s;
    if (r != 0) return r;
    let i = this.t;
    r = i - a.t;
    if (r != 0) return this.s < 0 ? -r : r;
    while(--i >= 0)if ((r = this[i] - a[i]) != 0) return r;
    return 0;
}
// returns bit length of the integer x
function $e6b0d30d639b7439$var$nbits(x) {
    let r = 1;
    let t;
    if ((t = x >>> 16) !== 0) {
        x = t;
        r += 16;
    }
    if ((t = x >> 8) !== 0) {
        x = t;
        r += 8;
    }
    if ((t = x >> 4) !== 0) {
        x = t;
        r += 4;
    }
    if ((t = x >> 2) !== 0) {
        x = t;
        r += 2;
    }
    if ((t = x >> 1) !== 0) {
        x = t;
        r += 1;
    }
    return r;
}
// (public) return the number of bits in "this"
function $e6b0d30d639b7439$var$bnBitLength() {
    if (this.t <= 0) return 0;
    return this.DB * (this.t - 1) + $e6b0d30d639b7439$var$nbits(this[this.t - 1] ^ this.s & this.DM);
}
// (protected) r = this << n*DB
function $e6b0d30d639b7439$var$bnpDLShiftTo(n, r) {
    let i;
    for(i = this.t - 1; i >= 0; --i)r[i + n] = this[i];
    for(i = n - 1; i >= 0; --i)r[i] = 0;
    r.t = this.t + n;
    r.s = this.s;
}
// (protected) r = this >> n*DB
function $e6b0d30d639b7439$var$bnpDRShiftTo(n, r) {
    for(let i = n; i < this.t; ++i)r[i - n] = this[i];
    r.t = Math.max(this.t - n, 0);
    r.s = this.s;
}
// (protected) r = this << n
function $e6b0d30d639b7439$var$bnpLShiftTo(n, r) {
    const bs = n % this.DB;
    const cbs = this.DB - bs;
    const bm = (1 << cbs) - 1;
    const ds = Math.floor(n / this.DB);
    let c = this.s << bs & this.DM;
    let i;
    for(i = this.t - 1; i >= 0; --i){
        r[i + ds + 1] = this[i] >> cbs | c;
        c = (this[i] & bm) << bs;
    }
    for(i = ds - 1; i >= 0; --i)r[i] = 0;
    r[ds] = c;
    r.t = this.t + ds + 1;
    r.s = this.s;
    r.clamp();
}
// (protected) r = this >> n
function $e6b0d30d639b7439$var$bnpRShiftTo(n, r) {
    r.s = this.s;
    const ds = Math.floor(n / this.DB);
    if (ds >= this.t) {
        r.t = 0;
        return;
    }
    const bs = n % this.DB;
    const cbs = this.DB - bs;
    const bm = (1 << bs) - 1;
    r[0] = this[ds] >> bs;
    for(let i = ds + 1; i < this.t; ++i){
        r[i - ds - 1] |= (this[i] & bm) << cbs;
        r[i - ds] = this[i] >> bs;
    }
    if (bs > 0) r[this.t - ds - 1] |= (this.s & bm) << cbs;
    r.t = this.t - ds;
    r.clamp();
}
// (protected) r = this - a
function $e6b0d30d639b7439$var$bnpSubTo(a, r) {
    let i = 0;
    let c = 0;
    const m = Math.min(a.t, this.t);
    while(i < m){
        c += this[i] - a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c -= a.s;
        while(i < this.t){
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c -= a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c -= a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c < -1) r[i++] = this.DV + c;
    else if (c > 0) r[i++] = c;
    r.t = i;
    r.clamp();
}
// (protected) r = this * a, r != this,a (HAC 14.12)
// "this" should be the larger one if appropriate.
function $e6b0d30d639b7439$var$bnpMultiplyTo(a, r) {
    const x = this.abs();
    const y = a.abs();
    let i = x.t;
    r.t = i + y.t;
    while(--i >= 0)r[i] = 0;
    for(i = 0; i < y.t; ++i)r[i + x.t] = x.am(0, y[i], r, i, 0, x.t);
    r.s = 0;
    r.clamp();
    if (this.s !== a.s) $e6b0d30d639b7439$export$2e2bcd8739ae039.ZERO.subTo(r, r);
}
// (protected) r = this^2, r != this (HAC 14.16)
function $e6b0d30d639b7439$var$bnpSquareTo(r) {
    const x = this.abs();
    let i = r.t = 2 * x.t;
    while(--i >= 0)r[i] = 0;
    for(i = 0; i < x.t - 1; ++i){
        const c = x.am(i, x[i], r, 2 * i, 0, 1);
        if ((r[i + x.t] += x.am(i + 1, 2 * x[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
            r[i + x.t] -= x.DV;
            r[i + x.t + 1] = 1;
        }
    }
    if (r.t > 0) r[r.t - 1] += x.am(i, x[i], r, 2 * i, 0, 1);
    r.s = 0;
    r.clamp();
}
// (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
// r != q, this != m.  q or r may be null.
function $e6b0d30d639b7439$var$bnpDivRemTo(m, q, r) {
    const pm = m.abs();
    if (pm.t <= 0) return;
    const pt = this.abs();
    if (pt.t < pm.t) {
        if (q != null) q.fromInt(0);
        if (r != null) this.copyTo(r);
        return;
    }
    if (r === null) r = $e6b0d30d639b7439$var$nbi();
    const y = $e6b0d30d639b7439$var$nbi();
    const ts = this.s;
    const ms = m.s;
    const nsh = this.DB - $e6b0d30d639b7439$var$nbits(pm[pm.t - 1]);
    // normalize modulus
    if (nsh > 0) {
        pm.lShiftTo(nsh, y);
        pt.lShiftTo(nsh, r);
    } else {
        pm.copyTo(y);
        pt.copyTo(r);
    }
    const ys = y.t;
    const y0 = y[ys - 1];
    if (y0 === 0) return;
    const yt = y0 * (1 << this.F1) + (ys > 1 ? y[ys - 2] >> this.F2 : 0);
    const d1 = this.FV / yt;
    const d2 = (1 << this.F1) / yt;
    const e = 1 << this.F2;
    let i = r.t;
    let j = i - ys;
    const t = q === null ? $e6b0d30d639b7439$var$nbi() : q;
    y.dlShiftTo(j, t);
    if (r.compareTo(t) >= 0) {
        r[r.t++] = 1;
        r.subTo(t, r);
    }
    $e6b0d30d639b7439$export$2e2bcd8739ae039.ONE.dlShiftTo(ys, t);
    t.subTo(y, y);
    // "negative" y so we can replace sub with am later
    while(y.t < ys)y[y.t++] = 0;
    while(--j >= 0){
        // Estimate quotient digit
        let qd = r[--i] === y0 ? this.DM : Math.floor(r[i] * d1 + (r[i - 1] + e) * d2);
        if ((r[i] += y.am(0, qd, r, j, 0, ys)) < qd) {
            // Try it out
            y.dlShiftTo(j, t);
            r.subTo(t, r);
            while(r[i] < --qd)r.subTo(t, r);
        }
    }
    if (q !== null) {
        r.drShiftTo(ys, q);
        if (ts !== ms) $e6b0d30d639b7439$export$2e2bcd8739ae039.ZERO.subTo(q, q);
    }
    r.t = ys;
    r.clamp();
    if (nsh > 0) r.rShiftTo(nsh, r);
    // Denormalize remainder
    if (ts < 0) $e6b0d30d639b7439$export$2e2bcd8739ae039.ZERO.subTo(r, r);
}
// (public) this mod a
function $e6b0d30d639b7439$var$bnMod(a) {
    const r = $e6b0d30d639b7439$var$nbi();
    this.abs().divRemTo(a, null, r);
    if (this.s < 0 && r.compareTo($e6b0d30d639b7439$export$2e2bcd8739ae039.ZERO) > 0) a.subTo(r, r);
    return r;
}
// (protected) return "-1/this % 2^DB"; useful for Mont. reduction
// justification:
//         xy == 1 (mod m)
//         xy =  1+km
//   xy(2-xy) = (1+km)(1-km)
// x[y(2-xy)] = 1-k^2m^2
// x[y(2-xy)] == 1 (mod m^2)
// if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
// should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
// JS multiply "overflows" differently from C/C++, so care is needed here.
function $e6b0d30d639b7439$var$bnpInvDigit() {
    if (this.t < 1) return 0;
    const x = this[0];
    if ((x & 1) === 0) return 0;
    let y = x & 3;
    // y == 1/x mod 2^2
    y = y * (2 - (x & 0xf) * y) & 0xf;
    // y == 1/x mod 2^4
    y = y * (2 - (x & 0xff) * y) & 0xff;
    // y == 1/x mod 2^8
    y = y * (2 - ((x & 0xffff) * y & 0xffff)) & 0xffff;
    // y == 1/x mod 2^16
    // last step - calculate inverse mod DV directly;
    // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
    y = y * (2 - x * y % this.DV) % this.DV;
    // y == 1/x mod 2^dbits
    // we really want the negative inverse, and -DV < y < DV
    return y > 0 ? this.DV - y : -y;
}
function $e6b0d30d639b7439$var$bnEquals(a) {
    return this.compareTo(a) === 0;
}
// (protected) r = this + a
function $e6b0d30d639b7439$var$bnpAddTo(a, r) {
    let i = 0;
    let c = 0;
    const m = Math.min(a.t, this.t);
    while(i < m){
        c += this[i] + a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c += a.s;
        while(i < this.t){
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c += a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c > 0) r[i++] = c;
    else if (c < -1) r[i++] = this.DV + c;
    r.t = i;
    r.clamp();
}
// (public) this + a
function $e6b0d30d639b7439$var$bnAdd(a) {
    const r = $e6b0d30d639b7439$var$nbi();
    this.addTo(a, r);
    return r;
}
// (public) this - a
function $e6b0d30d639b7439$var$bnSubtract(a) {
    const r = $e6b0d30d639b7439$var$nbi();
    this.subTo(a, r);
    return r;
}
// (public) this * a
function $e6b0d30d639b7439$var$bnMultiply(a) {
    const r = $e6b0d30d639b7439$var$nbi();
    this.multiplyTo(a, r);
    return r;
}
// (public) this / a
function $e6b0d30d639b7439$var$bnDivide(a) {
    const r = $e6b0d30d639b7439$var$nbi();
    this.divRemTo(a, r, null);
    return r;
}
// Montgomery reduction
function $e6b0d30d639b7439$var$Montgomery(m) {
    this.m = m;
    this.mp = m.invDigit();
    this.mpl = this.mp & 0x7fff;
    this.mph = this.mp >> 15;
    this.um = (1 << m.DB - 15) - 1;
    this.mt2 = 2 * m.t;
}
// xR mod m
function $e6b0d30d639b7439$var$montConvert(x) {
    const r = $e6b0d30d639b7439$var$nbi();
    x.abs().dlShiftTo(this.m.t, r);
    r.divRemTo(this.m, null, r);
    if (x.s < 0 && r.compareTo($e6b0d30d639b7439$export$2e2bcd8739ae039.ZERO) > 0) this.m.subTo(r, r);
    return r;
}
// x/R mod m
function $e6b0d30d639b7439$var$montRevert(x) {
    const r = $e6b0d30d639b7439$var$nbi();
    x.copyTo(r);
    this.reduce(r);
    return r;
}
// x = x/R mod m (HAC 14.32)
function $e6b0d30d639b7439$var$montReduce(x) {
    while(x.t <= this.mt2)// pad x so am has enough room later
    x[x.t++] = 0;
    for(let i = 0; i < this.m.t; ++i){
        // faster way of calculating u0 = x[i]*mp mod DV
        let j = x[i] & 0x7fff;
        const u0 = j * this.mpl + ((j * this.mph + (x[i] >> 15) * this.mpl & this.um) << 15) & x.DM;
        // use am to combine the multiply-shift-add into one call
        j = i + this.m.t;
        x[j] += this.m.am(0, u0, x, i, 0, this.m.t);
        // propagate carry
        while(x[j] >= x.DV){
            x[j] -= x.DV;
            x[++j]++;
        }
    }
    x.clamp();
    x.drShiftTo(this.m.t, x);
    if (x.compareTo(this.m) >= 0) x.subTo(this.m, x);
}
// r = "x^2/R mod m"; x != r
function $e6b0d30d639b7439$var$montSqrTo(x, r) {
    x.squareTo(r);
    this.reduce(r);
}
// r = "xy/R mod m"; x,y != r
function $e6b0d30d639b7439$var$montMulTo(x, y, r) {
    x.multiplyTo(y, r);
    this.reduce(r);
}
$e6b0d30d639b7439$var$Montgomery.prototype.convert = $e6b0d30d639b7439$var$montConvert;
$e6b0d30d639b7439$var$Montgomery.prototype.revert = $e6b0d30d639b7439$var$montRevert;
$e6b0d30d639b7439$var$Montgomery.prototype.reduce = $e6b0d30d639b7439$var$montReduce;
$e6b0d30d639b7439$var$Montgomery.prototype.mulTo = $e6b0d30d639b7439$var$montMulTo;
$e6b0d30d639b7439$var$Montgomery.prototype.sqrTo = $e6b0d30d639b7439$var$montSqrTo;
// (public) this^e % m (HAC 14.85)
function $e6b0d30d639b7439$var$bnModPow(e, m, callback) {
    let i = e.bitLength();
    let k;
    let r = $e6b0d30d639b7439$var$nbv(1);
    const z = new $e6b0d30d639b7439$var$Montgomery(m);
    if (i <= 0) return r;
    else if (i < 18) k = 1;
    else if (i < 48) k = 3;
    else if (i < 144) k = 4;
    else if (i < 768) k = 5;
    else k = 6;
    // precomputation
    const g = [];
    let n = 3;
    const k1 = k - 1;
    const km = (1 << k) - 1;
    g[1] = z.convert(this);
    if (k > 1) {
        const g2 = $e6b0d30d639b7439$var$nbi();
        z.sqrTo(g[1], g2);
        while(n <= km){
            g[n] = $e6b0d30d639b7439$var$nbi();
            z.mulTo(g2, g[n - 2], g[n]);
            n += 2;
        }
    }
    let j = e.t - 1;
    let w;
    let is1 = true;
    let r2 = $e6b0d30d639b7439$var$nbi();
    let t;
    i = $e6b0d30d639b7439$var$nbits(e[j]) - 1;
    while(j >= 0){
        if (i >= k1) w = e[j] >> i - k1 & km;
        else {
            w = (e[j] & (1 << i + 1) - 1) << k1 - i;
            if (j > 0) w |= e[j - 1] >> this.DB + i - k1;
        }
        n = k;
        while((w & 1) === 0){
            w >>= 1;
            --n;
        }
        if ((i -= n) < 0) {
            i += this.DB;
            --j;
        }
        if (is1) {
            // ret == 1, don't bother squaring or multiplying it
            g[w].copyTo(r);
            is1 = false;
        } else {
            while(n > 1){
                z.sqrTo(r, r2);
                z.sqrTo(r2, r);
                n -= 2;
            }
            if (n > 0) z.sqrTo(r, r2);
            else {
                t = r;
                r = r2;
                r2 = t;
            }
            z.mulTo(r2, g[w], r);
        }
        while(j >= 0 && (e[j] & 1 << i) === 0){
            z.sqrTo(r, r2);
            t = r;
            r = r2;
            r2 = t;
            if (--i < 0) {
                i = this.DB - 1;
                --j;
            }
        }
    }
    const result = z.revert(r);
    callback(null, result);
    return result;
}
// protected
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.copyTo = $e6b0d30d639b7439$var$bnpCopyTo;
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.fromInt = $e6b0d30d639b7439$var$bnpFromInt;
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.fromString = $e6b0d30d639b7439$var$bnpFromString;
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.clamp = $e6b0d30d639b7439$var$bnpClamp;
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.dlShiftTo = $e6b0d30d639b7439$var$bnpDLShiftTo;
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.drShiftTo = $e6b0d30d639b7439$var$bnpDRShiftTo;
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.lShiftTo = $e6b0d30d639b7439$var$bnpLShiftTo;
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.rShiftTo = $e6b0d30d639b7439$var$bnpRShiftTo;
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.subTo = $e6b0d30d639b7439$var$bnpSubTo;
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.multiplyTo = $e6b0d30d639b7439$var$bnpMultiplyTo;
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.squareTo = $e6b0d30d639b7439$var$bnpSquareTo;
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.divRemTo = $e6b0d30d639b7439$var$bnpDivRemTo;
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.invDigit = $e6b0d30d639b7439$var$bnpInvDigit;
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.addTo = $e6b0d30d639b7439$var$bnpAddTo;
// public
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.toString = $e6b0d30d639b7439$var$bnToString;
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.negate = $e6b0d30d639b7439$var$bnNegate;
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.abs = $e6b0d30d639b7439$var$bnAbs;
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.compareTo = $e6b0d30d639b7439$var$bnCompareTo;
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.bitLength = $e6b0d30d639b7439$var$bnBitLength;
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.mod = $e6b0d30d639b7439$var$bnMod;
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.equals = $e6b0d30d639b7439$var$bnEquals;
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.add = $e6b0d30d639b7439$var$bnAdd;
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.subtract = $e6b0d30d639b7439$var$bnSubtract;
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.multiply = $e6b0d30d639b7439$var$bnMultiply;
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.divide = $e6b0d30d639b7439$var$bnDivide;
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.modPow = $e6b0d30d639b7439$var$bnModPow;
// "constants"
$e6b0d30d639b7439$export$2e2bcd8739ae039.ZERO = $e6b0d30d639b7439$var$nbv(0);
$e6b0d30d639b7439$export$2e2bcd8739ae039.ONE = $e6b0d30d639b7439$var$nbv(1);


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ const $1cef16b1857519e3$export$f7340100dd3acd38 = async ({ a: a , g: g , k: k , x: x , B: B , N: N , U: U  })=>{
    return new Promise((resolve, reject)=>{
        g.modPow(x, N, (outerErr, outerResult)=>{
            if (outerErr) {
                reject(outerErr);
                return;
            }
            B.subtract(k.multiply(outerResult)).modPow(a.add(U.multiply(x)), N, (innerErr, innerResult)=>{
                if (innerErr) {
                    reject(innerErr);
                    return;
                }
                resolve(innerResult.mod(N));
            });
        });
    });
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $97958120efb925b4$export$baab4dd8c7240846 = "FFFFFFFFFFFFFFFFC90FDAA22168C234C4C6628B80DC1CD129024E088A67CC74020BBEA63B139B22514A08798E3404DDEF9519B3CD3A431B302B0A6DF25F14374FE1356D6D51C245E485B576625E7EC6F44C42E9A637ED6B0BFF5CB6F406B7EDEE386BFB5A899FA5AE9F24117C4B1FE649286651ECE45B3DC2007CB8A163BF0598DA48361C55D39A69163FA8FD24CF5F83655D23DCA3AD961C62F356208552BB9ED529077096966D670C354E4ABC9804F1746C08CA18217C32905E462E36CE3BE39E772C180E86039B2783A2EC07A28FB5C55DF06F4C52C9DE2BCBF6955817183995497CEA956AE515D2261898FA051015728E5A8AAAC42DAD33170D04507A33A85521ABDF1CBA64ECFB850458DBEF0A8AEA71575D060C7DB3970F85A6E1E4C7ABF5AE8CDB0933D71E8C94E04A25619DCEE3D2261AD2EE6BF12FFA06D98A0864D87602733EC86A64521F2B18177B200CBBE117577A615D6C770988C0BAD946E208E24FA074E5AB3143DB5BFCE0FD108E4B82D120A93AD2CAFFFFFFFFFFFFFFFF";
const $97958120efb925b4$export$a0f75f7d2f3bd702 = {};
const $97958120efb925b4$export$fcb552daf117d7e3 = {};
for(let i = 0; i < 256; i++){
    let encodedByte = i.toString(16).toLowerCase();
    if (encodedByte.length === 1) encodedByte = `0${encodedByte}`;
    $97958120efb925b4$export$a0f75f7d2f3bd702[i] = encodedByte;
    $97958120efb925b4$export$fcb552daf117d7e3[encodedByte] = i;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Converts a hexadecimal encoded string to a Uint8Array of bytes.
 *
 * @param encoded The hexadecimal encoded string
 */ const $ec5820220853a812$export$b772e43c3daf2e7a = (encoded)=>{
    if (encoded.length % 2 !== 0) throw new Error("Hex encoded strings must have an even number length");
    const out = new Uint8Array(encoded.length / 2);
    for(let i = 0; i < encoded.length; i += 2){
        const encodedByte = encoded.slice(i, i + 2).toLowerCase();
        if (encodedByte in (0, $97958120efb925b4$export$fcb552daf117d7e3)) out[i / 2] = (0, $97958120efb925b4$export$fcb552daf117d7e3)[encodedByte];
        else throw new Error(`Cannot decode unrecognized sequence ${encodedByte} as hexadecimal`);
    }
    return out;
};




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Converts a Uint8Array of binary data to a hexadecimal encoded string.
 *
 * @param bytes The binary data to encode
 */ const $eed88bdc1fb343aa$export$22a20ab34c1d7a2b = (bytes)=>{
    let out = "";
    for(let i = 0; i < bytes.byteLength; i++)out += (0, $97958120efb925b4$export$a0f75f7d2f3bd702)[bytes[i]];
    return out;
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Calculate a hash from a `SourceData`
 * @param {SourceData} data Value to hash.
 * @returns {string} Hex-encoded hash.
 * @private
 */ const $7977b7713864e546$export$629ee8d7d3ebacd1 = (data)=>{
    const sha256 = new (0, $2127c60713693f53$export$3b58ea8124ac5e28)();
    sha256.update(data);
    const hashedData = sha256.digestSync();
    const hashHexFromUint8 = (0, $eed88bdc1fb343aa$export$22a20ab34c1d7a2b)(hashedData);
    return new Array(64 - hashHexFromUint8.length).join("0") + hashHexFromUint8;
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Calculate a hash from a hex string
 * @param {string} hexStr Value to hash.
 * @returns {string} Hex-encoded hash.
 * @private
 */ const $2bae7d4adcab7fc5$export$8b112e065a8843a = (hexStr)=>(0, $7977b7713864e546$export$629ee8d7d3ebacd1)((0, $ec5820220853a812$export$b772e43c3daf2e7a)(hexStr));



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Tests if a hex string has it most significant bit set (case-insensitive regex)
 */ const $2e4ceaf61b2d9c67$var$HEX_MSB_REGEX = /^[89a-f]/i;
/**
 * Returns an unambiguous, even-length hex string of the two's complement encoding of an integer.
 *
 * It is compatible with the hex encoding of Java's BigInteger's toByteArray(), wich returns a
 * byte array containing the two's-complement representation of a BigInteger. The array contains
 * the minimum number of bytes required to represent the BigInteger, including at least one sign bit.
 *
 * Examples showing how ambiguity is avoided by left padding with:
 * 	"00" (for positive values where the most-significant-bit is set)
 *  "FF" (for negative values where the most-significant-bit is set)
 *
 * padHex(bigInteger.fromInt(-236))  === "FF14"
 * padHex(bigInteger.fromInt(20))    === "14"
 *
 * padHex(bigInteger.fromInt(-200))  === "FF38"
 * padHex(bigInteger.fromInt(56))    === "38"
 *
 * padHex(bigInteger.fromInt(-20))   === "EC"
 * padHex(bigInteger.fromInt(236))   === "00EC"
 *
 * padHex(bigInteger.fromInt(-56))   === "C8"
 * padHex(bigInteger.fromInt(200))   === "00C8"
 *
 * @param {AuthBigInteger} bigInt Number to encode.
 * @returns {String} even-length hex string of the two's complement encoding.
 */ const $2e4ceaf61b2d9c67$export$35d4ea07514a0402 = (bigInt)=>{
    if (!(bigInt instanceof (0, $e6b0d30d639b7439$export$2e2bcd8739ae039))) throw new Error("Not a BigInteger");
    const isNegative = bigInt.compareTo((0, $e6b0d30d639b7439$export$2e2bcd8739ae039).ZERO) < 0;
    /* Get a hex string for abs(bigInt) */ let hexStr = bigInt.abs().toString(16);
    /* Pad hex to even length if needed */ hexStr = hexStr.length % 2 !== 0 ? `0${hexStr}` : hexStr;
    /* Prepend "00" if the most significant bit is set */ hexStr = $2e4ceaf61b2d9c67$var$HEX_MSB_REGEX.test(hexStr) ? `00${hexStr}` : hexStr;
    if (isNegative) {
        /* Flip the bits of the representation */ const invertedNibbles = hexStr.split("").map((x)=>{
            const invertedNibble = ~parseInt(x, 16) & 0xf;
            return "0123456789ABCDEF".charAt(invertedNibble);
        }).join("");
        /* After flipping the bits, add one to get the 2's complement representation */ const flippedBitsBI = new (0, $e6b0d30d639b7439$export$2e2bcd8739ae039)(invertedNibbles, 16).add((0, $e6b0d30d639b7439$export$2e2bcd8739ae039).ONE);
        hexStr = flippedBitsBI.toString(16);
        /*
        For hex strings starting with 'FF8', 'FF' can be dropped, e.g. 0xFFFF80=0xFF80=0x80=-128

        Any sequence of '1' bits on the left can always be substituted with a single '1' bit
        without changing the represented value.

        This only happens in the case when the input is 80...00
        */ if (hexStr.toUpperCase().startsWith("FF8")) hexStr = hexStr.substring(2);
    }
    return hexStr;
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ const $8f1acab179b9ebe1$export$e2f40082638513e7 = ({ A: A , B: B  })=>{
    const U = new (0, $e6b0d30d639b7439$export$2e2bcd8739ae039)((0, $2bae7d4adcab7fc5$export$8b112e065a8843a)((0, $2e4ceaf61b2d9c67$export$35d4ea07514a0402)(A) + (0, $2e4ceaf61b2d9c67$export$35d4ea07514a0402)(B)), 16);
    if (U.equals((0, $e6b0d30d639b7439$export$2e2bcd8739ae039).ZERO)) throw new Error("U cannot be zero.");
    return U;
};







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Standard HKDF algorithm.
 *
 * @param {Uint8Array} ikm Input key material.
 * @param {Uint8Array} salt Salt value.
 * @param {Uint8Array} info Context and application specific info.
 *
 * @returns {Uint8Array} Strong key material.
 *
 * @internal
 */ const $1da3d3222e2071df$export$295a0a5429217d03 = (ikm, salt, info)=>{
    const awsCryptoHash = new (0, $2127c60713693f53$export$3b58ea8124ac5e28)(salt);
    awsCryptoHash.update(ikm);
    const resultFromAWSCryptoPrk = awsCryptoHash.digestSync();
    const awsCryptoHashHmac = new (0, $2127c60713693f53$export$3b58ea8124ac5e28)(resultFromAWSCryptoPrk);
    awsCryptoHashHmac.update(info);
    const resultFromAWSCryptoHmac = awsCryptoHashHmac.digestSync();
    const hashHexFromAWSCrypto = resultFromAWSCryptoHmac;
    return hashHexFromAWSCrypto.slice(0, 16);
};




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/*
 * Cryptographically secure pseudorandom number generator
 * As Math.random() is cryptographically not safe to use
 */ function $1dc42b32eec063da$export$d265930babe23ca5() {
    const crypto = (0, $7b380da28ef680be$export$e003cc239f955cb6)();
    const randomResult = crypto.getRandomValues(new Uint32Array(1))[0];
    return randomResult;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Hex encoding strategy.
 * Converts a word array to a hex string.
 * @param {WordArray} wordArray The word array.
 * @return {string} The hex string.
 * @static
 */ function $fbcfeae1e1a35b5c$var$hexStringify(wordArray) {
    // Shortcuts
    const { words: words  } = wordArray;
    const { sigBytes: sigBytes  } = wordArray;
    // Convert
    const hexChars = [];
    for(let i = 0; i < sigBytes; i++){
        const bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
        hexChars.push((bite >>> 4).toString(16));
        hexChars.push((bite & 0x0f).toString(16));
    }
    return hexChars.join("");
}
class $fbcfeae1e1a35b5c$export$4cd4919e303276a6 {
    constructor(words, sigBytes){
        this.words = [];
        let Words = words;
        Words = this.words = Words || [];
        if (sigBytes !== undefined) this.sigBytes = sigBytes;
        else this.sigBytes = Words.length * 4;
    }
    random(nBytes) {
        const words = [];
        for(let i = 0; i < nBytes; i += 4)words.push((0, $1dc42b32eec063da$export$d265930babe23ca5)());
        return new $fbcfeae1e1a35b5c$export$4cd4919e303276a6(words, nBytes);
    }
    toString() {
        return $fbcfeae1e1a35b5c$var$hexStringify(this);
    }
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns a Uint8Array with a sequence of random nBytes
 *
 * @param {number} nBytes
 * @returns {Uint8Array} fixed-length sequence of random bytes
 */ const $9a6cff41abc04edc$export$763d6fc7c4b5dc52 = (nBytes)=>{
    const str = new (0, $fbcfeae1e1a35b5c$export$4cd4919e303276a6)().random(nBytes).toString();
    return (0, $ec5820220853a812$export$b772e43c3daf2e7a)(str);
};




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Helper function to generate a random string
 * @returns {string} a random value.
 *
 * @internal
 */ const $59388e0cd726a085$export$8c487394e1c35fbe = ()=>(0, $2c81515d3d5db49f$export$695b149896bd3e2a).convert((0, $9a6cff41abc04edc$export$763d6fc7c4b5dc52)(40));


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/** @class */ class $62713a0581f3e14f$export$2e2bcd8739ae039 {
    constructor({ userPoolName: userPoolName , a: a , g: g , A: A , N: N  }){
        this.encoder = (0, $8f38281af144dd56$export$f5d75491a17f02c);
        this.userPoolName = userPoolName;
        this.a = a;
        this.g = g;
        this.A = A;
        this.N = N;
        this.k = new (0, $e6b0d30d639b7439$export$2e2bcd8739ae039)((0, $2bae7d4adcab7fc5$export$8b112e065a8843a)(`${(0, $2e4ceaf61b2d9c67$export$35d4ea07514a0402)(N)}${(0, $2e4ceaf61b2d9c67$export$35d4ea07514a0402)(g)}`), 16);
    }
    /**
     * @returns {string} Generated random value included in password hash.
     */ getRandomPassword() {
        if (!this.randomPassword) throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
            name: "EmptyBigIntegerRandomPassword",
            message: "random password is empty"
        });
        return this.randomPassword;
    }
    /**
     * @returns {string} Generated random value included in devices hash.
     */ getSaltToHashDevices() {
        if (!this.saltToHashDevices) throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
            name: "EmptyBigIntegersaltToHashDevices",
            message: "saltToHashDevices is empty"
        });
        return this.saltToHashDevices;
    }
    /**
     * @returns {string} Value used to verify devices.
     */ getVerifierDevices() {
        if (!this.verifierDevices) throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
            name: "EmptyBigIntegerVerifierDevices",
            message: "verifyDevices is empty"
        });
        return this.verifierDevices;
    }
    /**
     * Generate salts and compute verifier.
     *
     * @param {string} deviceGroupKey Devices to generate verifier for.
     * @param {string} username User to generate verifier for.
     *
     * @returns {Promise<void>}
     */ async generateHashDevice(deviceGroupKey, username) {
        this.randomPassword = (0, $59388e0cd726a085$export$8c487394e1c35fbe)();
        const combinedString = `${deviceGroupKey}${username}:${this.randomPassword}`;
        const hashedString = (0, $7977b7713864e546$export$629ee8d7d3ebacd1)(combinedString);
        const hexRandom = (0, $eed88bdc1fb343aa$export$22a20ab34c1d7a2b)((0, $9a6cff41abc04edc$export$763d6fc7c4b5dc52)(16));
        // The random hex will be unambiguously represented as a postive integer
        this.saltToHashDevices = (0, $2e4ceaf61b2d9c67$export$35d4ea07514a0402)(new (0, $e6b0d30d639b7439$export$2e2bcd8739ae039)(hexRandom, 16));
        return new Promise((resolve, reject)=>{
            this.g.modPow(new (0, $e6b0d30d639b7439$export$2e2bcd8739ae039)((0, $2bae7d4adcab7fc5$export$8b112e065a8843a)(this.saltToHashDevices + hashedString), 16), this.N, (err, result)=>{
                if (err) {
                    reject(err);
                    return;
                }
                this.verifierDevices = (0, $2e4ceaf61b2d9c67$export$35d4ea07514a0402)(result);
                resolve();
            });
        });
    }
    /**
     * Calculates the final HKDF key based on computed S value, computed U value and the key
     *
     * @param {String} username Username.
     * @param {String} password Password.
     * @param {AuthBigInteger} B Server B value.
     * @param {AuthBigInteger} salt Generated salt.
     */ async getPasswordAuthenticationKey({ username: username , password: password , serverBValue: serverBValue , salt: salt  }) {
        if (serverBValue.mod(this.N).equals((0, $e6b0d30d639b7439$export$2e2bcd8739ae039).ZERO)) throw new Error("B cannot be zero.");
        const U = (0, $8f1acab179b9ebe1$export$e2f40082638513e7)({
            A: this.A,
            B: serverBValue
        });
        const usernamePassword = `${this.userPoolName}${username}:${password}`;
        const usernamePasswordHash = (0, $7977b7713864e546$export$629ee8d7d3ebacd1)(usernamePassword);
        const x = new (0, $e6b0d30d639b7439$export$2e2bcd8739ae039)((0, $2bae7d4adcab7fc5$export$8b112e065a8843a)((0, $2e4ceaf61b2d9c67$export$35d4ea07514a0402)(salt) + usernamePasswordHash), 16);
        const S = await (0, $1cef16b1857519e3$export$f7340100dd3acd38)({
            a: this.a,
            g: this.g,
            k: this.k,
            x: x,
            B: serverBValue,
            N: this.N,
            U: U
        });
        const context = this.encoder.convert("Caldera Derived Key");
        const spacer = this.encoder.convert(String.fromCharCode(1));
        const info = new Uint8Array(context.byteLength + spacer.byteLength);
        info.set(context, 0);
        info.set(spacer, context.byteLength);
        const hkdfKey = (0, $1da3d3222e2071df$export$295a0a5429217d03)((0, $ec5820220853a812$export$b772e43c3daf2e7a)((0, $2e4ceaf61b2d9c67$export$35d4ea07514a0402)(S)), (0, $ec5820220853a812$export$b772e43c3daf2e7a)((0, $2e4ceaf61b2d9c67$export$35d4ea07514a0402)(U)), info);
        return hkdfKey;
    }
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ const $9a00d3dce34e0c65$export$53a55138f9e96c65 = async ({ a: a , g: g , N: N  })=>{
    return new Promise((resolve, reject)=>{
        g.modPow(a, N, (err, A)=>{
            if (err) {
                reject(err);
                return;
            }
            if (A.mod(N).equals((0, $e6b0d30d639b7439$export$2e2bcd8739ae039).ZERO)) {
                reject(new Error("Illegal parameter. A mod N cannot be 0."));
                return;
            }
            resolve(A);
        });
    });
};






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns a new {@link AuthenticationHelper} instance with randomly generated BigInteger seed
 *
 * @param userPoolName Cognito user pool name.
 * @returns An {@link AuthenticationHelper} instance.
 *
 * @internal
 */ const $4b0015cdb42a07f3$export$47560e2dc89f678c = async (userPoolName)=>{
    const N = new (0, $e6b0d30d639b7439$export$2e2bcd8739ae039)((0, $97958120efb925b4$export$baab4dd8c7240846), 16);
    const g = new (0, $e6b0d30d639b7439$export$2e2bcd8739ae039)("2", 16);
    const a = $4b0015cdb42a07f3$var$generateRandomBigInteger();
    const A = await (0, $9a00d3dce34e0c65$export$53a55138f9e96c65)({
        a: a,
        g: g,
        N: N
    });
    return new (0, $62713a0581f3e14f$export$2e2bcd8739ae039)({
        userPoolName: userPoolName,
        a: a,
        g: g,
        A: A,
        N: N
    });
};
/**
 * Generates a random BigInteger.
 *
 * @returns {BigInteger} a random value.
 */ const $4b0015cdb42a07f3$var$generateRandomBigInteger = ()=>{
    // This will be interpreted as a postive 128-bit integer
    const hexRandom = (0, $eed88bdc1fb343aa$export$22a20ab34c1d7a2b)((0, $9a6cff41abc04edc$export$763d6fc7c4b5dc52)(128));
    // There is no need to do randomBigInt.mod(this.N - 1) as N (3072-bit) is > 128 bytes (1024-bit)
    return new (0, $e6b0d30d639b7439$export$2e2bcd8739ae039)(hexRandom, 16);
};
















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Handles the Password SRP (Secure Remote Password) authentication flow.
 * This function can be used with both USER_SRP_AUTH and USER_AUTH flows.
 *
 * @param {Object} params - The parameters for the Password SRP authentication
 * @param {string} params.username - The username for authentication
 * @param {string} params.password - The user's password
 * @param {ClientMetadata} [params.clientMetadata] - Optional metadata to be sent with auth requests
 * @param {CognitoUserPoolConfig} params.config - Cognito User Pool configuration
 * @param {AuthTokenOrchestrator} params.tokenOrchestrator - Token orchestrator for managing auth tokens
 * @param {AuthFlowType} params.authFlow - The type of authentication flow ('USER_SRP_AUTH' or 'USER_AUTH')
 * @param {AuthFactorType} [params.preferredChallenge] - Optional preferred challenge type when using USER_AUTH flow
 *
 * @returns {Promise<RespondToAuthChallengeCommandOutput>} The authentication response
 */ async function $f77b1ffdbc0c7f64$export$169bd15774e46c56({ username: username , password: password , clientMetadata: clientMetadata , config: config , tokenOrchestrator: tokenOrchestrator , authFlow: authFlow , preferredChallenge: preferredChallenge  }) {
    const { userPoolId: userPoolId , userPoolClientId: userPoolClientId , userPoolEndpoint: userPoolEndpoint  } = config;
    const userPoolName = userPoolId?.split("_")[1] || "";
    const authenticationHelper = await (0, $4b0015cdb42a07f3$export$47560e2dc89f678c)(userPoolName);
    const authParameters = {
        USERNAME: username,
        SRP_A: authenticationHelper.A.toString(16)
    };
    if (authFlow === "USER_AUTH" && preferredChallenge) authParameters.PREFERRED_CHALLENGE = preferredChallenge;
    const UserContextData = (0, $d1d75befb3456a99$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        AuthFlow: authFlow,
        AuthParameters: authParameters,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    const initiateAuth = (0, $73c63bd2bf2643ec$export$91f349d78bea7765)({
        endpointResolver: (0, $034f40104fa68ca7$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const resp = await initiateAuth({
        region: (0, $f3a37e3ae41d4905$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $7032744b11af61d7$export$d6cd780379f37dae)((0, $80240862ea60f1f3$export$900b1436d7e65f4).SignIn)
    }, jsonReq);
    const { ChallengeParameters: challengeParameters , Session: session  } = resp;
    const activeUsername = challengeParameters?.USERNAME ?? username;
    (0, $d3c3238cf7b10401$export$fecfbc200868d412)(activeUsername);
    if (resp.ChallengeName === "PASSWORD_VERIFIER") return (0, $d3c3238cf7b10401$export$30f932fe98713ccc)((0, $d3c3238cf7b10401$export$7f7b64167822fe34), [
        password,
        challengeParameters,
        clientMetadata,
        session,
        authenticationHelper,
        config,
        tokenOrchestrator
    ], activeUsername, tokenOrchestrator);
    return resp;
}














// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Handles the SELECT_CHALLENGE response for authentication.
 * Initiates the selected authentication challenge based on user choice.
 *
 * @param {Object} params - The parameters for handling the selected challenge
 * @param {string} params.username - The username for authentication
 * @param {string} params.session - The current authentication session token
 * @param {string} params.selectedChallenge - The challenge type selected by the user
 * @param {CognitoUserPoolConfig} params.config - Cognito User Pool configuration
 * @param {ClientMetadata} [params.clientMetadata] - Optional metadata to be sent with auth requests
 *
 * @returns {Promise<RespondToAuthChallengeCommandOutput>} The challenge response
 */ async function $f04499bd8022e4e0$export$4eb37109154e77c1({ username: username , session: session , selectedChallenge: selectedChallenge , config: config , clientMetadata: clientMetadata  }) {
    const respondToAuthChallenge = (0, $33fa144820195cb7$export$11329f5ae466ab5d)({
        endpointResolver: (0, $034f40104fa68ca7$export$9fc8f7dceefe00a6)({
            endpointOverride: config.userPoolEndpoint
        })
    });
    return respondToAuthChallenge({
        region: (0, $f3a37e3ae41d4905$export$5f7eb9761ac2d0d9)(config.userPoolId),
        userAgentValue: (0, $7032744b11af61d7$export$d6cd780379f37dae)((0, $80240862ea60f1f3$export$900b1436d7e65f4).ConfirmSignIn)
    }, {
        ChallengeName: "SELECT_CHALLENGE",
        ChallengeResponses: {
            USERNAME: username,
            ANSWER: selectedChallenge
        },
        ClientId: config.userPoolClientId,
        Session: session,
        ClientMetadata: clientMetadata
    });
}
















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Handles the SELECT_CHALLENGE response specifically for Password authentication.
 * This function combines the SELECT_CHALLENGE flow with standard password authentication.
 *
 * @param {string} username - The username for authentication
 * @param {string} password - The user's password
 * @param {ClientMetadata} [clientMetadata] - Optional metadata to be sent with auth requests
 * @param {CognitoUserPoolConfig} config - Cognito User Pool configuration
 * @param {string} session - The current authentication session token
 *
 * @returns {Promise<RespondToAuthChallengeCommandOutput>} The challenge response
 */ async function $ea6ca3f011dd4e16$export$cca550d6560f23b8(username, password, clientMetadata, config, session) {
    const { userPoolId: userPoolId , userPoolClientId: userPoolClientId , userPoolEndpoint: userPoolEndpoint  } = config;
    const authParameters = {
        ANSWER: "PASSWORD",
        USERNAME: username,
        PASSWORD: password
    };
    const userContextData = (0, $d1d75befb3456a99$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const respondToAuthChallenge = (0, $33fa144820195cb7$export$11329f5ae466ab5d)({
        endpointResolver: (0, $034f40104fa68ca7$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const response = await respondToAuthChallenge({
        region: (0, $f3a37e3ae41d4905$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $7032744b11af61d7$export$d6cd780379f37dae)((0, $80240862ea60f1f3$export$900b1436d7e65f4).ConfirmSignIn)
    }, {
        ChallengeName: "SELECT_CHALLENGE",
        ChallengeResponses: authParameters,
        ClientId: userPoolClientId,
        ClientMetadata: clientMetadata,
        Session: session,
        UserContextData: userContextData
    });
    const activeUsername = response.ChallengeParameters?.USERNAME ?? username;
    (0, $d3c3238cf7b10401$export$fecfbc200868d412)(activeUsername);
    return response;
}



















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Handles the SELECT_CHALLENGE response specifically for Password SRP authentication.
 * This function combines the SELECT_CHALLENGE flow with Password SRP protocol.
 *
 * @param {string} username - The username for authentication
 * @param {string} password - The user's password
 * @param {ClientMetadata} [clientMetadata] - Optional metadata to be sent with auth requests
 * @param {CognitoUserPoolConfig} config - Cognito User Pool configuration
 * @param {string} session - The current authentication session token
 * @param {AuthTokenOrchestrator} tokenOrchestrator - Token orchestrator for managing auth tokens
 *
 * @returns {Promise<RespondToAuthChallengeCommandOutput>} The challenge response
 */ async function $1248651d95cfb616$export$e496ff225fdec499(username, password, clientMetadata, config, session, tokenOrchestrator) {
    const { userPoolId: userPoolId , userPoolClientId: userPoolClientId , userPoolEndpoint: userPoolEndpoint  } = config;
    const userPoolName = userPoolId.split("_")[1] || "";
    const authenticationHelper = await (0, $4b0015cdb42a07f3$export$47560e2dc89f678c)(userPoolName);
    const authParameters = {
        ANSWER: "PASSWORD_SRP",
        USERNAME: username,
        SRP_A: authenticationHelper.A.toString(16)
    };
    const userContextData = (0, $d1d75befb3456a99$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const respondToAuthChallenge = (0, $33fa144820195cb7$export$11329f5ae466ab5d)({
        endpointResolver: (0, $034f40104fa68ca7$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const response = await respondToAuthChallenge({
        region: (0, $f3a37e3ae41d4905$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $7032744b11af61d7$export$d6cd780379f37dae)((0, $80240862ea60f1f3$export$900b1436d7e65f4).ConfirmSignIn)
    }, {
        ChallengeName: "SELECT_CHALLENGE",
        ChallengeResponses: authParameters,
        ClientId: userPoolClientId,
        ClientMetadata: clientMetadata,
        Session: session,
        UserContextData: userContextData
    });
    const activeUsername = response.ChallengeParameters?.USERNAME ?? username;
    (0, $d3c3238cf7b10401$export$fecfbc200868d412)(activeUsername);
    if (response.ChallengeName === "PASSWORD_VERIFIER") return (0, $d3c3238cf7b10401$export$30f932fe98713ccc)((0, $d3c3238cf7b10401$export$7f7b64167822fe34), [
        password,
        response.ChallengeParameters,
        clientMetadata,
        response.Session,
        authenticationHelper,
        config,
        tokenOrchestrator
    ], activeUsername, tokenOrchestrator);
    return response;
}







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $327b34006d7a710d$var$MONTH_NAMES = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
const $327b34006d7a710d$var$WEEK_NAMES = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
const $327b34006d7a710d$export$218a6e05f05aec48 = ()=>{
    const now = new Date();
    const weekDay = $327b34006d7a710d$var$WEEK_NAMES[now.getUTCDay()];
    const month = $327b34006d7a710d$var$MONTH_NAMES[now.getUTCMonth()];
    const day = now.getUTCDate();
    let hours = now.getUTCHours();
    if (hours < 10) hours = `0${hours}`;
    let minutes = now.getUTCMinutes();
    if (minutes < 10) minutes = `0${minutes}`;
    let seconds = now.getUTCSeconds();
    if (seconds < 10) seconds = `0${seconds}`;
    const year = now.getUTCFullYear();
    // ddd MMM D HH:mm:ss UTC YYYY
    const dateNow = `${weekDay} ${month} ${day} ${hours}:${minutes}:${seconds} UTC ${year}`;
    return dateNow;
};





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $2a9d2dc2f8ef941d$export$577b7d8a4f1b23fd = ({ userPoolName: userPoolName , username: username , challengeParameters: challengeParameters , dateNow: dateNow , hkdf: hkdf  })=>{
    const bufUPIDaToB = (0, $8f38281af144dd56$export$f5d75491a17f02c).convert(userPoolName);
    const bufUNaToB = (0, $8f38281af144dd56$export$f5d75491a17f02c).convert(username);
    const bufSBaToB = $2a9d2dc2f8ef941d$var$urlB64ToUint8Array(challengeParameters.SECRET_BLOCK);
    const bufDNaToB = (0, $8f38281af144dd56$export$f5d75491a17f02c).convert(dateNow);
    const bufConcat = new Uint8Array(bufUPIDaToB.byteLength + bufUNaToB.byteLength + bufSBaToB.byteLength + bufDNaToB.byteLength);
    bufConcat.set(bufUPIDaToB, 0);
    bufConcat.set(bufUNaToB, bufUPIDaToB.byteLength);
    bufConcat.set(bufSBaToB, bufUPIDaToB.byteLength + bufUNaToB.byteLength);
    bufConcat.set(bufDNaToB, bufUPIDaToB.byteLength + bufUNaToB.byteLength + bufSBaToB.byteLength);
    const awsCryptoHash = new (0, $2127c60713693f53$export$3b58ea8124ac5e28)(hkdf);
    awsCryptoHash.update(bufConcat);
    const resultFromAWSCrypto = awsCryptoHash.digestSync();
    const signatureString = (0, $2c81515d3d5db49f$export$695b149896bd3e2a).convert(resultFromAWSCrypto);
    return signatureString;
};
const $2a9d2dc2f8ef941d$var$urlB64ToUint8Array = (base64String)=>{
    const padding = "=".repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
    const rawData = (0, $01459b747c81c3e7$export$1e303d38dab7b376).convert(base64);
    const outputArray = new Uint8Array(rawData.length);
    for(let i = 0; i < rawData.length; ++i)outputArray[i] = rawData.charCodeAt(i);
    return outputArray;
};




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $d3c3238cf7b10401$var$USER_ATTRIBUTES = "userAttributes.";
async function $d3c3238cf7b10401$export$6fe6331471b54d26({ challengeResponse: challengeResponse , clientMetadata: clientMetadata , session: session , username: username , config: config , tokenOrchestrator: tokenOrchestrator  }) {
    const { userPoolId: userPoolId , userPoolClientId: userPoolClientId , userPoolEndpoint: userPoolEndpoint  } = config;
    const challengeResponses = {
        USERNAME: username,
        ANSWER: challengeResponse
    };
    const deviceMetadata = await tokenOrchestrator?.getDeviceMetadata(username);
    if (deviceMetadata && deviceMetadata.deviceKey) challengeResponses.DEVICE_KEY = deviceMetadata.deviceKey;
    const UserContextData = (0, $d1d75befb3456a99$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        ChallengeName: "CUSTOM_CHALLENGE",
        ChallengeResponses: challengeResponses,
        Session: session,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    const respondToAuthChallenge = (0, $33fa144820195cb7$export$11329f5ae466ab5d)({
        endpointResolver: (0, $034f40104fa68ca7$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const response = await respondToAuthChallenge({
        region: (0, $f3a37e3ae41d4905$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $7032744b11af61d7$export$d6cd780379f37dae)((0, $80240862ea60f1f3$export$900b1436d7e65f4).ConfirmSignIn)
    }, jsonReq);
    if (response.ChallengeName === "DEVICE_SRP_AUTH") return $d3c3238cf7b10401$var$handleDeviceSRPAuth({
        username: username,
        config: config,
        clientMetadata: clientMetadata,
        session: response.Session,
        tokenOrchestrator: tokenOrchestrator
    });
    return response;
}
async function $d3c3238cf7b10401$export$9b78cd405a35bccd({ challengeResponse: challengeResponse , username: username , clientMetadata: clientMetadata , session: session , deviceName: deviceName , config: config  }) {
    const { userPoolId: userPoolId , userPoolClientId: userPoolClientId , userPoolEndpoint: userPoolEndpoint  } = config;
    if (challengeResponse === "EMAIL") return {
        ChallengeName: "MFA_SETUP",
        Session: session,
        ChallengeParameters: {
            MFAS_CAN_SETUP: '["EMAIL_OTP"]'
        },
        $metadata: {}
    };
    if (challengeResponse === "TOTP") return {
        ChallengeName: "MFA_SETUP",
        Session: session,
        ChallengeParameters: {
            MFAS_CAN_SETUP: '["SOFTWARE_TOKEN_MFA"]'
        },
        $metadata: {}
    };
    const challengeResponses = {
        USERNAME: username
    };
    const isTOTPCode = /^\d+$/.test(challengeResponse);
    if (isTOTPCode) {
        const verifySoftwareToken = (0, $3f10064ba4f72f83$export$cf5dd9429415aa98)({
            endpointResolver: (0, $034f40104fa68ca7$export$9fc8f7dceefe00a6)({
                endpointOverride: userPoolEndpoint
            })
        });
        const { Session: Session  } = await verifySoftwareToken({
            region: (0, $f3a37e3ae41d4905$export$5f7eb9761ac2d0d9)(userPoolId),
            userAgentValue: (0, $7032744b11af61d7$export$d6cd780379f37dae)((0, $80240862ea60f1f3$export$900b1436d7e65f4).ConfirmSignIn)
        }, {
            UserCode: challengeResponse,
            Session: session,
            FriendlyDeviceName: deviceName
        });
        (0, $18f78a860861bd8b$export$390d5da4c63a4a41).dispatch({
            type: "SET_SIGN_IN_SESSION",
            value: Session
        });
        const jsonReq = {
            ChallengeName: "MFA_SETUP",
            ChallengeResponses: challengeResponses,
            Session: Session,
            ClientMetadata: clientMetadata,
            ClientId: userPoolClientId
        };
        const respondToAuthChallenge = (0, $33fa144820195cb7$export$11329f5ae466ab5d)({
            endpointResolver: (0, $034f40104fa68ca7$export$9fc8f7dceefe00a6)({
                endpointOverride: userPoolEndpoint
            })
        });
        return respondToAuthChallenge({
            region: (0, $f3a37e3ae41d4905$export$5f7eb9761ac2d0d9)(userPoolId),
            userAgentValue: (0, $7032744b11af61d7$export$d6cd780379f37dae)((0, $80240862ea60f1f3$export$900b1436d7e65f4).ConfirmSignIn)
        }, jsonReq);
    }
    const isEmail = challengeResponse.includes("@");
    if (isEmail) {
        challengeResponses.EMAIL = challengeResponse;
        const jsonReq = {
            ChallengeName: "MFA_SETUP",
            ChallengeResponses: challengeResponses,
            Session: session,
            ClientMetadata: clientMetadata,
            ClientId: userPoolClientId
        };
        const respondToAuthChallenge = (0, $33fa144820195cb7$export$11329f5ae466ab5d)({
            endpointResolver: (0, $034f40104fa68ca7$export$9fc8f7dceefe00a6)({
                endpointOverride: userPoolEndpoint
            })
        });
        return respondToAuthChallenge({
            region: (0, $f3a37e3ae41d4905$export$5f7eb9761ac2d0d9)(userPoolId),
            userAgentValue: (0, $7032744b11af61d7$export$d6cd780379f37dae)((0, $80240862ea60f1f3$export$900b1436d7e65f4).ConfirmSignIn)
        }, jsonReq);
    }
    throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
        name: (0, $3277196cec8a3dbe$export$473ab0b56598aacd).SignInException,
        message: `Cannot proceed with MFA setup using challengeResponse: ${challengeResponse}`,
        recoverySuggestion: 'Try passing "EMAIL", "TOTP", a valid email, or OTP code as the challengeResponse.'
    });
}
async function $d3c3238cf7b10401$export$f0699fc2b71f49c0({ challengeResponse: challengeResponse , username: username , clientMetadata: clientMetadata , session: session , config: config  }) {
    const { userPoolId: userPoolId , userPoolClientId: userPoolClientId , userPoolEndpoint: userPoolEndpoint  } = config;
    (0, $fd90eaa8008e7494$export$45936001d12f9b53)(challengeResponse === "TOTP" || challengeResponse === "SMS" || challengeResponse === "EMAIL", (0, $e5a1b34bea683c02$export$12d5c695b2213c4a).IncorrectMFAMethod);
    const challengeResponses = {
        USERNAME: username,
        ANSWER: $d3c3238cf7b10401$export$7e7902092e38fcff(challengeResponse)
    };
    const UserContextData = (0, $d1d75befb3456a99$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        ChallengeName: "SELECT_MFA_TYPE",
        ChallengeResponses: challengeResponses,
        Session: session,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    const respondToAuthChallenge = (0, $33fa144820195cb7$export$11329f5ae466ab5d)({
        endpointResolver: (0, $034f40104fa68ca7$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    return respondToAuthChallenge({
        region: (0, $f3a37e3ae41d4905$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $7032744b11af61d7$export$d6cd780379f37dae)((0, $80240862ea60f1f3$export$900b1436d7e65f4).ConfirmSignIn)
    }, jsonReq);
}
async function $d3c3238cf7b10401$export$df3f8a8c68da6a2e({ challengeResponse: challengeResponse , clientMetadata: clientMetadata , session: session , username: username , requiredAttributes: requiredAttributes , config: config  }) {
    const { userPoolId: userPoolId , userPoolClientId: userPoolClientId , userPoolEndpoint: userPoolEndpoint  } = config;
    const challengeResponses = {
        ...$d3c3238cf7b10401$export$c7c9603a6b1fd815(requiredAttributes),
        NEW_PASSWORD: challengeResponse,
        USERNAME: username
    };
    const UserContextData = (0, $d1d75befb3456a99$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        ChallengeName: "NEW_PASSWORD_REQUIRED",
        ChallengeResponses: challengeResponses,
        ClientMetadata: clientMetadata,
        Session: session,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    const respondToAuthChallenge = (0, $33fa144820195cb7$export$11329f5ae466ab5d)({
        endpointResolver: (0, $034f40104fa68ca7$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    return respondToAuthChallenge({
        region: (0, $f3a37e3ae41d4905$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $7032744b11af61d7$export$d6cd780379f37dae)((0, $80240862ea60f1f3$export$900b1436d7e65f4).ConfirmSignIn)
    }, jsonReq);
}
async function $d3c3238cf7b10401$export$29fb48d356e16a7(username, password, clientMetadata, config, tokenOrchestrator) {
    const { userPoolClientId: userPoolClientId , userPoolId: userPoolId , userPoolEndpoint: userPoolEndpoint  } = config;
    const authParameters = {
        USERNAME: username,
        PASSWORD: password
    };
    const deviceMetadata = await tokenOrchestrator.getDeviceMetadata(username);
    if (deviceMetadata && deviceMetadata.deviceKey) authParameters.DEVICE_KEY = deviceMetadata.deviceKey;
    const UserContextData = (0, $d1d75befb3456a99$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        AuthFlow: "USER_PASSWORD_AUTH",
        AuthParameters: authParameters,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    const initiateAuth = (0, $73c63bd2bf2643ec$export$91f349d78bea7765)({
        endpointResolver: (0, $034f40104fa68ca7$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const response = await initiateAuth({
        region: (0, $f3a37e3ae41d4905$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $7032744b11af61d7$export$d6cd780379f37dae)((0, $80240862ea60f1f3$export$900b1436d7e65f4).SignIn)
    }, jsonReq);
    const activeUsername = response.ChallengeParameters?.USERNAME ?? response.ChallengeParameters?.USER_ID_FOR_SRP ?? username;
    $d3c3238cf7b10401$export$fecfbc200868d412(activeUsername);
    if (response.ChallengeName === "DEVICE_SRP_AUTH") return $d3c3238cf7b10401$var$handleDeviceSRPAuth({
        username: activeUsername,
        config: config,
        clientMetadata: clientMetadata,
        session: response.Session,
        tokenOrchestrator: tokenOrchestrator
    });
    return response;
}
async function $d3c3238cf7b10401$export$13a3ef5ef8cac338(username, password, clientMetadata, config, tokenOrchestrator) {
    return (0, $f77b1ffdbc0c7f64$export$169bd15774e46c56)({
        username: username,
        password: password,
        clientMetadata: clientMetadata,
        config: config,
        tokenOrchestrator: tokenOrchestrator,
        authFlow: "USER_SRP_AUTH"
    });
}
async function $d3c3238cf7b10401$export$1a654dcab55e0de5(username, clientMetadata, config, tokenOrchestrator) {
    const { userPoolClientId: userPoolClientId , userPoolId: userPoolId , userPoolEndpoint: userPoolEndpoint  } = config;
    const authParameters = {
        USERNAME: username
    };
    const deviceMetadata = await tokenOrchestrator.getDeviceMetadata(username);
    if (deviceMetadata && deviceMetadata.deviceKey) authParameters.DEVICE_KEY = deviceMetadata.deviceKey;
    const UserContextData = (0, $d1d75befb3456a99$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        AuthFlow: "CUSTOM_AUTH",
        AuthParameters: authParameters,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    const initiateAuth = (0, $73c63bd2bf2643ec$export$91f349d78bea7765)({
        endpointResolver: (0, $034f40104fa68ca7$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const response = await initiateAuth({
        region: (0, $f3a37e3ae41d4905$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $7032744b11af61d7$export$d6cd780379f37dae)((0, $80240862ea60f1f3$export$900b1436d7e65f4).SignIn)
    }, jsonReq);
    const activeUsername = response.ChallengeParameters?.USERNAME ?? username;
    $d3c3238cf7b10401$export$fecfbc200868d412(activeUsername);
    if (response.ChallengeName === "DEVICE_SRP_AUTH") return $d3c3238cf7b10401$var$handleDeviceSRPAuth({
        username: activeUsername,
        config: config,
        clientMetadata: clientMetadata,
        session: response.Session,
        tokenOrchestrator: tokenOrchestrator
    });
    return response;
}
async function $d3c3238cf7b10401$export$9ce9dd351616104c(username, password, clientMetadata, config, tokenOrchestrator) {
    (0, $da35d46b99b5d98d$export$80c92581e59ed502)(config);
    const { userPoolId: userPoolId , userPoolClientId: userPoolClientId , userPoolEndpoint: userPoolEndpoint  } = config;
    const userPoolName = userPoolId?.split("_")[1] || "";
    const authenticationHelper = await (0, $4b0015cdb42a07f3$export$47560e2dc89f678c)(userPoolName);
    const authParameters = {
        USERNAME: username,
        SRP_A: authenticationHelper.A.toString(16),
        CHALLENGE_NAME: "SRP_A"
    };
    const UserContextData = (0, $d1d75befb3456a99$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        AuthFlow: "CUSTOM_AUTH",
        AuthParameters: authParameters,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    const initiateAuth = (0, $73c63bd2bf2643ec$export$91f349d78bea7765)({
        endpointResolver: (0, $034f40104fa68ca7$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const { ChallengeParameters: challengeParameters , Session: session  } = await initiateAuth({
        region: (0, $f3a37e3ae41d4905$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $7032744b11af61d7$export$d6cd780379f37dae)((0, $80240862ea60f1f3$export$900b1436d7e65f4).SignIn)
    }, jsonReq);
    const activeUsername = challengeParameters?.USERNAME ?? username;
    $d3c3238cf7b10401$export$fecfbc200868d412(activeUsername);
    return $d3c3238cf7b10401$export$30f932fe98713ccc($d3c3238cf7b10401$export$7f7b64167822fe34, [
        password,
        challengeParameters,
        clientMetadata,
        session,
        authenticationHelper,
        config,
        tokenOrchestrator
    ], activeUsername, tokenOrchestrator);
}
async function $d3c3238cf7b10401$var$handleDeviceSRPAuth({ username: username , config: config , clientMetadata: clientMetadata , session: session , tokenOrchestrator: tokenOrchestrator  }) {
    const { userPoolId: userPoolId , userPoolEndpoint: userPoolEndpoint  } = config;
    const clientId = config.userPoolClientId;
    const deviceMetadata = await tokenOrchestrator?.getDeviceMetadata(username);
    (0, $6e9371ee52a401af$export$b6f03be79626ab0f)(deviceMetadata);
    const authenticationHelper = await (0, $4b0015cdb42a07f3$export$47560e2dc89f678c)(deviceMetadata.deviceGroupKey);
    const challengeResponses = {
        USERNAME: username,
        SRP_A: authenticationHelper.A.toString(16),
        DEVICE_KEY: deviceMetadata.deviceKey
    };
    const jsonReqResponseChallenge = {
        ChallengeName: "DEVICE_SRP_AUTH",
        ClientId: clientId,
        ChallengeResponses: challengeResponses,
        ClientMetadata: clientMetadata,
        Session: session
    };
    const respondToAuthChallenge = (0, $33fa144820195cb7$export$11329f5ae466ab5d)({
        endpointResolver: (0, $034f40104fa68ca7$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const { ChallengeParameters: respondedChallengeParameters , Session: Session  } = await respondToAuthChallenge({
        region: (0, $f3a37e3ae41d4905$export$5f7eb9761ac2d0d9)(userPoolId)
    }, jsonReqResponseChallenge);
    return $d3c3238cf7b10401$var$handleDevicePasswordVerifier(username, respondedChallengeParameters, clientMetadata, Session, authenticationHelper, config, tokenOrchestrator);
}
async function $d3c3238cf7b10401$var$handleDevicePasswordVerifier(username, challengeParameters, clientMetadata, session, authenticationHelper, { userPoolId: userPoolId , userPoolClientId: userPoolClientId , userPoolEndpoint: userPoolEndpoint  }, tokenOrchestrator) {
    const deviceMetadata = await tokenOrchestrator?.getDeviceMetadata(username);
    (0, $6e9371ee52a401af$export$b6f03be79626ab0f)(deviceMetadata);
    const serverBValue = new (0, $e6b0d30d639b7439$export$2e2bcd8739ae039)(challengeParameters?.SRP_B, 16);
    const salt = new (0, $e6b0d30d639b7439$export$2e2bcd8739ae039)(challengeParameters?.SALT, 16);
    const { deviceKey: deviceKey  } = deviceMetadata;
    const { deviceGroupKey: deviceGroupKey  } = deviceMetadata;
    const hkdf = await authenticationHelper.getPasswordAuthenticationKey({
        username: deviceMetadata.deviceKey,
        password: deviceMetadata.randomPassword,
        serverBValue: serverBValue,
        salt: salt
    });
    const dateNow = (0, $327b34006d7a710d$export$218a6e05f05aec48)();
    const challengeResponses = {
        USERNAME: challengeParameters?.USERNAME ?? username,
        PASSWORD_CLAIM_SECRET_BLOCK: challengeParameters?.SECRET_BLOCK,
        TIMESTAMP: dateNow,
        PASSWORD_CLAIM_SIGNATURE: (0, $2a9d2dc2f8ef941d$export$577b7d8a4f1b23fd)({
            username: deviceKey,
            userPoolName: deviceGroupKey,
            challengeParameters: challengeParameters,
            dateNow: dateNow,
            hkdf: hkdf
        }),
        DEVICE_KEY: deviceKey
    };
    const UserContextData = (0, $d1d75befb3456a99$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReqResponseChallenge = {
        ChallengeName: "DEVICE_PASSWORD_VERIFIER",
        ClientId: userPoolClientId,
        ChallengeResponses: challengeResponses,
        Session: session,
        ClientMetadata: clientMetadata,
        UserContextData: UserContextData
    };
    const respondToAuthChallenge = (0, $33fa144820195cb7$export$11329f5ae466ab5d)({
        endpointResolver: (0, $034f40104fa68ca7$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    return respondToAuthChallenge({
        region: (0, $f3a37e3ae41d4905$export$5f7eb9761ac2d0d9)(userPoolId)
    }, jsonReqResponseChallenge);
}
async function $d3c3238cf7b10401$export$7f7b64167822fe34(password, challengeParameters, clientMetadata, session, authenticationHelper, config, tokenOrchestrator) {
    const { userPoolId: userPoolId , userPoolClientId: userPoolClientId , userPoolEndpoint: userPoolEndpoint  } = config;
    const userPoolName = userPoolId?.split("_")[1] || "";
    const serverBValue = new (0, $e6b0d30d639b7439$export$2e2bcd8739ae039)(challengeParameters?.SRP_B, 16);
    const salt = new (0, $e6b0d30d639b7439$export$2e2bcd8739ae039)(challengeParameters?.SALT, 16);
    const username = challengeParameters?.USER_ID_FOR_SRP;
    if (!username) throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
        name: "EmptyUserIdForSRPException",
        message: "USER_ID_FOR_SRP was not found in challengeParameters"
    });
    const hkdf = await authenticationHelper.getPasswordAuthenticationKey({
        username: username,
        password: password,
        serverBValue: serverBValue,
        salt: salt
    });
    const dateNow = (0, $327b34006d7a710d$export$218a6e05f05aec48)();
    const challengeResponses = {
        USERNAME: username,
        PASSWORD_CLAIM_SECRET_BLOCK: challengeParameters?.SECRET_BLOCK,
        TIMESTAMP: dateNow,
        PASSWORD_CLAIM_SIGNATURE: (0, $2a9d2dc2f8ef941d$export$577b7d8a4f1b23fd)({
            username: username,
            userPoolName: userPoolName,
            challengeParameters: challengeParameters,
            dateNow: dateNow,
            hkdf: hkdf
        })
    };
    const deviceMetadata = await tokenOrchestrator.getDeviceMetadata(username);
    if (deviceMetadata && deviceMetadata.deviceKey) challengeResponses.DEVICE_KEY = deviceMetadata.deviceKey;
    const UserContextData = (0, $d1d75befb3456a99$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReqResponseChallenge = {
        ChallengeName: "PASSWORD_VERIFIER",
        ChallengeResponses: challengeResponses,
        ClientMetadata: clientMetadata,
        Session: session,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    const respondToAuthChallenge = (0, $33fa144820195cb7$export$11329f5ae466ab5d)({
        endpointResolver: (0, $034f40104fa68ca7$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const response = await respondToAuthChallenge({
        region: (0, $f3a37e3ae41d4905$export$5f7eb9761ac2d0d9)(userPoolId)
    }, jsonReqResponseChallenge);
    if (response.ChallengeName === "DEVICE_SRP_AUTH") return $d3c3238cf7b10401$var$handleDeviceSRPAuth({
        username: username,
        config: config,
        clientMetadata: clientMetadata,
        session: response.Session,
        tokenOrchestrator: tokenOrchestrator
    });
    return response;
}
async function $d3c3238cf7b10401$export$cf152400b58b8e65(params) {
    const { challengeName: challengeName , challengeParameters: challengeParameters , availableChallenges: availableChallenges  } = params;
    const authConfig = (0, $44174d4eb465d133$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    (0, $da35d46b99b5d98d$export$80c92581e59ed502)(authConfig);
    switch(challengeName){
        case "CUSTOM_CHALLENGE":
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: "CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE",
                    additionalInfo: challengeParameters
                }
            };
        case "MFA_SETUP":
            {
                const { signInSession: signInSession , username: username  } = (0, $18f78a860861bd8b$export$390d5da4c63a4a41).getState();
                const mfaSetupTypes = $d3c3238cf7b10401$export$d70c792e078766ea($d3c3238cf7b10401$export$4055ded9e78438ba(challengeParameters.MFAS_CAN_SETUP)) || [];
                const allowedMfaSetupTypes = $d3c3238cf7b10401$export$343435e7c7c3ff0f(mfaSetupTypes);
                const isTotpMfaSetupAvailable = allowedMfaSetupTypes.includes("TOTP");
                const isEmailMfaSetupAvailable = allowedMfaSetupTypes.includes("EMAIL");
                if (isTotpMfaSetupAvailable && isEmailMfaSetupAvailable) return {
                    isSignedIn: false,
                    nextStep: {
                        signInStep: "CONTINUE_SIGN_IN_WITH_MFA_SETUP_SELECTION",
                        allowedMFATypes: allowedMfaSetupTypes
                    }
                };
                if (isEmailMfaSetupAvailable) return {
                    isSignedIn: false,
                    nextStep: {
                        signInStep: "CONTINUE_SIGN_IN_WITH_EMAIL_SETUP"
                    }
                };
                if (isTotpMfaSetupAvailable) {
                    const associateSoftwareToken = (0, $0eb574771fa3c4bc$export$6bff32634453de2a)({
                        endpointResolver: (0, $034f40104fa68ca7$export$9fc8f7dceefe00a6)({
                            endpointOverride: authConfig.userPoolEndpoint
                        })
                    });
                    const { Session: Session , SecretCode: secretCode  } = await associateSoftwareToken({
                        region: (0, $f3a37e3ae41d4905$export$5f7eb9761ac2d0d9)(authConfig.userPoolId)
                    }, {
                        Session: signInSession
                    });
                    (0, $18f78a860861bd8b$export$390d5da4c63a4a41).dispatch({
                        type: "SET_SIGN_IN_SESSION",
                        value: Session
                    });
                    return {
                        isSignedIn: false,
                        nextStep: {
                            signInStep: "CONTINUE_SIGN_IN_WITH_TOTP_SETUP",
                            totpSetupDetails: $d3c3238cf7b10401$export$b105c3e8e4f5ce91(secretCode, username)
                        }
                    };
                }
                throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
                    name: (0, $3277196cec8a3dbe$export$473ab0b56598aacd).SignInException,
                    message: `Cannot initiate MFA setup from available types: ${mfaSetupTypes}`
                });
            }
        case "NEW_PASSWORD_REQUIRED":
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED",
                    missingAttributes: $d3c3238cf7b10401$export$fbe550151e406473(challengeParameters.requiredAttributes)
                }
            };
        case "SELECT_MFA_TYPE":
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: "CONTINUE_SIGN_IN_WITH_MFA_SELECTION",
                    allowedMFATypes: $d3c3238cf7b10401$export$d70c792e078766ea($d3c3238cf7b10401$export$4055ded9e78438ba(challengeParameters.MFAS_CAN_CHOOSE))
                }
            };
        case "SMS_OTP":
        case "SMS_MFA":
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: "CONFIRM_SIGN_IN_WITH_SMS_CODE",
                    codeDeliveryDetails: {
                        deliveryMedium: challengeParameters.CODE_DELIVERY_DELIVERY_MEDIUM,
                        destination: challengeParameters.CODE_DELIVERY_DESTINATION
                    }
                }
            };
        case "SOFTWARE_TOKEN_MFA":
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: "CONFIRM_SIGN_IN_WITH_TOTP_CODE"
                }
            };
        case "EMAIL_OTP":
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: "CONFIRM_SIGN_IN_WITH_EMAIL_CODE",
                    codeDeliveryDetails: {
                        deliveryMedium: challengeParameters.CODE_DELIVERY_DELIVERY_MEDIUM,
                        destination: challengeParameters.CODE_DELIVERY_DESTINATION
                    }
                }
            };
        case "WEB_AUTHN":
            return (0, $10c42e9ccd80355d$export$77701654924537aa)(challengeParameters);
        case "PASSWORD":
        case "PASSWORD_SRP":
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: "CONFIRM_SIGN_IN_WITH_PASSWORD"
                }
            };
        case "SELECT_CHALLENGE":
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: "CONTINUE_SIGN_IN_WITH_FIRST_FACTOR_SELECTION",
                    availableChallenges: availableChallenges
                }
            };
    }
    // TODO: remove this error message for production apps
    throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
        name: (0, $3277196cec8a3dbe$export$473ab0b56598aacd).SignInException,
        message: "An error occurred during the sign in process. " + `${challengeName} challengeName returned by the underlying service was not addressed.`
    });
}
function $d3c3238cf7b10401$export$b105c3e8e4f5ce91(secretCode, username) {
    return {
        sharedSecret: secretCode,
        getSetupUri: (appName, accountName)=>{
            const totpUri = `otpauth://totp/${appName}:${accountName ?? username}?secret=${secretCode}&issuer=${appName}`;
            return new (0, $b0f1ea60776570d9$export$beb82d9d9136c16e)(totpUri);
        }
    };
}
function $d3c3238cf7b10401$export$cafe99bb44d49edb(errorName) {
    if (errorName === (0, $9e23bc336cf172f0$export$43ac0110dfdad33b).PasswordResetRequiredException) return {
        isSignedIn: false,
        nextStep: {
            signInStep: "RESET_PASSWORD"
        }
    };
    else if (errorName === (0, $9e23bc336cf172f0$export$43ac0110dfdad33b).UserNotConfirmedException) return {
        isSignedIn: false,
        nextStep: {
            signInStep: "CONFIRM_SIGN_UP"
        }
    };
}
function $d3c3238cf7b10401$export$fbe550151e406473(attributes) {
    if (!attributes) return [];
    const parsedAttributes = JSON.parse(attributes).map((att)=>att.includes($d3c3238cf7b10401$var$USER_ATTRIBUTES) ? att.replace($d3c3238cf7b10401$var$USER_ATTRIBUTES, "") : att);
    return parsedAttributes;
}
function $d3c3238cf7b10401$export$c7c9603a6b1fd815(attributes) {
    if (!attributes) return {};
    const newAttributes = {};
    Object.entries(attributes).forEach(([key, value])=>{
        if (value) newAttributes[`${$d3c3238cf7b10401$var$USER_ATTRIBUTES}${key}`] = value;
    });
    return newAttributes;
}
async function $d3c3238cf7b10401$export$cfd8b50d0f78e4fa(username, challengeName, session, challengeResponse, config, tokenOrchestrator, clientMetadata, options) {
    const userAttributes = options?.userAttributes;
    const deviceName = options?.friendlyDeviceName;
    switch(challengeName){
        case "WEB_AUTHN":
        case "SELECT_CHALLENGE":
            if (challengeResponse === "PASSWORD_SRP" || challengeResponse === "PASSWORD") return {
                ChallengeName: challengeResponse,
                Session: session,
                $metadata: {}
            };
            return (0, $f04499bd8022e4e0$export$4eb37109154e77c1)({
                username: username,
                session: session,
                selectedChallenge: challengeResponse,
                config: config,
                clientMetadata: clientMetadata
            });
        case "SELECT_MFA_TYPE":
            return $d3c3238cf7b10401$export$f0699fc2b71f49c0({
                challengeResponse: challengeResponse,
                clientMetadata: clientMetadata,
                session: session,
                username: username,
                config: config
            });
        case "MFA_SETUP":
            return $d3c3238cf7b10401$export$9b78cd405a35bccd({
                challengeResponse: challengeResponse,
                clientMetadata: clientMetadata,
                session: session,
                username: username,
                deviceName: deviceName,
                config: config
            });
        case "NEW_PASSWORD_REQUIRED":
            return $d3c3238cf7b10401$export$df3f8a8c68da6a2e({
                challengeResponse: challengeResponse,
                clientMetadata: clientMetadata,
                session: session,
                username: username,
                requiredAttributes: userAttributes,
                config: config
            });
        case "CUSTOM_CHALLENGE":
            return $d3c3238cf7b10401$export$30f932fe98713ccc($d3c3238cf7b10401$export$6fe6331471b54d26, [
                {
                    challengeResponse: challengeResponse,
                    clientMetadata: clientMetadata,
                    session: session,
                    username: username,
                    config: config,
                    tokenOrchestrator: tokenOrchestrator
                }
            ], username, tokenOrchestrator);
        case "SMS_MFA":
        case "SOFTWARE_TOKEN_MFA":
        case "SMS_OTP":
        case "EMAIL_OTP":
            return $d3c3238cf7b10401$export$1ec196d12cb921db({
                challengeName: challengeName,
                challengeResponse: challengeResponse,
                clientMetadata: clientMetadata,
                session: session,
                username: username,
                config: config
            });
        case "PASSWORD":
            return (0, $ea6ca3f011dd4e16$export$cca550d6560f23b8)(username, challengeResponse, clientMetadata, config, session);
        case "PASSWORD_SRP":
            return (0, $1248651d95cfb616$export$e496ff225fdec499)(username, challengeResponse, clientMetadata, config, session, tokenOrchestrator);
    }
    // TODO: remove this error message for production apps
    throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
        name: (0, $3277196cec8a3dbe$export$473ab0b56598aacd).SignInException,
        message: `An error occurred during the sign in process.
		${challengeName} challengeName returned by the underlying service was not addressed.`
    });
}
function $d3c3238cf7b10401$export$7e7902092e38fcff(mfa) {
    let mfaType = "SMS_MFA";
    if (mfa === "TOTP") mfaType = "SOFTWARE_TOKEN_MFA";
    if (mfa === "EMAIL") mfaType = "EMAIL_OTP";
    return mfaType;
}
function $d3c3238cf7b10401$export$6ce04ce89055b1fe(type) {
    if (type === "SMS_MFA") return "SMS";
    if (type === "SOFTWARE_TOKEN_MFA") return "TOTP";
    if (type === "EMAIL_OTP") return "EMAIL";
// TODO: log warning for unknown MFA type
}
function $d3c3238cf7b10401$export$d70c792e078766ea(types) {
    if (!types) return undefined;
    return types.map($d3c3238cf7b10401$export$6ce04ce89055b1fe).filter(Boolean);
}
function $d3c3238cf7b10401$export$4055ded9e78438ba(mfa) {
    if (!mfa) return [];
    return JSON.parse(mfa);
}
function $d3c3238cf7b10401$export$343435e7c7c3ff0f(availableMfaSetupTypes) {
    return availableMfaSetupTypes.filter((authMfaType)=>authMfaType === "EMAIL" || authMfaType === "TOTP");
}
async function $d3c3238cf7b10401$export$8061cd07f982ef08() {
    let authUser;
    try {
        authUser = await (0, $a96a35a57f46b2c7$export$e5432d4c8eb97ea7)();
    } catch (error) {}
    if (authUser && authUser.userId && authUser.username) throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
        name: (0, $e4cb7b306ced9230$export$bdd0e7e9babcd5c8),
        message: "There is already a signed in user.",
        recoverySuggestion: "Call signOut before calling signIn again."
    });
}
/**
 * This function is used to kick off the device management flow.
 *
 * If an error is thrown while generating a hash device or calling the `ConfirmDevice`
 * client, then this API will ignore the error and return undefined. Otherwise the authentication
 * flow will not complete and the user won't be able to be signed in.
 *
 * @returns DeviceMetadata | undefined
 */ async function $d3c3238cf7b10401$export$548ed8ad974a8b30({ userPoolId: userPoolId , userPoolEndpoint: userPoolEndpoint , newDeviceMetadata: newDeviceMetadata , accessToken: accessToken  }) {
    if (!newDeviceMetadata) return undefined;
    const userPoolName = userPoolId.split("_")[1] || "";
    const authenticationHelper = await (0, $4b0015cdb42a07f3$export$47560e2dc89f678c)(userPoolName);
    const deviceKey = newDeviceMetadata?.DeviceKey;
    const deviceGroupKey = newDeviceMetadata?.DeviceGroupKey;
    try {
        await authenticationHelper.generateHashDevice(deviceGroupKey ?? "", deviceKey ?? "");
    } catch (errGenHash) {
        // TODO: log error here
        return undefined;
    }
    const deviceSecretVerifierConfig = {
        Salt: (0, $2c81515d3d5db49f$export$695b149896bd3e2a).convert((0, $ec5820220853a812$export$b772e43c3daf2e7a)(authenticationHelper.getSaltToHashDevices())),
        PasswordVerifier: (0, $2c81515d3d5db49f$export$695b149896bd3e2a).convert((0, $ec5820220853a812$export$b772e43c3daf2e7a)(authenticationHelper.getVerifierDevices()))
    };
    const randomPassword = authenticationHelper.getRandomPassword();
    try {
        const confirmDevice = (0, $98602ad99f5e9d70$export$d88a63af6351a7c3)({
            endpointResolver: (0, $034f40104fa68ca7$export$9fc8f7dceefe00a6)({
                endpointOverride: userPoolEndpoint
            })
        });
        await confirmDevice({
            region: (0, $f3a37e3ae41d4905$export$5f7eb9761ac2d0d9)(userPoolId)
        }, {
            AccessToken: accessToken,
            DeviceName: await (0, $0975c3300105e1fa$export$98f0aedb14d75123)(),
            DeviceKey: newDeviceMetadata?.DeviceKey,
            DeviceSecretVerifierConfig: deviceSecretVerifierConfig
        });
        return {
            deviceKey: deviceKey,
            deviceGroupKey: deviceGroupKey,
            randomPassword: randomPassword
        };
    } catch (error) {
        // TODO: log error here
        return undefined;
    }
}
/**
 * It will retry the function if the error is a `ResourceNotFoundException` and
 * will clean the device keys stored in the storage mechanism.
 *
 */ async function $d3c3238cf7b10401$export$30f932fe98713ccc(func, args, username, tokenOrchestrator) {
    try {
        return await func(...args);
    } catch (error) {
        if (error instanceof (0, $03e5abb25dfabdd6$export$145273558d58e0ac) && error.name === "ResourceNotFoundException" && error.message.includes("Device does not exist.")) {
            await tokenOrchestrator.clearDeviceMetadata(username);
            return func(...args);
        }
        throw error;
    }
}
function $d3c3238cf7b10401$export$fecfbc200868d412(username) {
    const { dispatch: dispatch  } = (0, $18f78a860861bd8b$export$390d5da4c63a4a41);
    dispatch({
        type: "SET_USERNAME",
        value: username
    });
}
function $d3c3238cf7b10401$export$cc3585de146a51be(username) {
    const state = (0, $18f78a860861bd8b$export$390d5da4c63a4a41).getState();
    return state.username ?? username;
}
async function $d3c3238cf7b10401$export$1ec196d12cb921db({ challengeName: challengeName , challengeResponse: challengeResponse , clientMetadata: clientMetadata , session: session , username: username , config: config  }) {
    const { userPoolId: userPoolId , userPoolClientId: userPoolClientId , userPoolEndpoint: userPoolEndpoint  } = config;
    const challengeResponses = {
        USERNAME: username
    };
    if (challengeName === "EMAIL_OTP") challengeResponses.EMAIL_OTP_CODE = challengeResponse;
    if (challengeName === "SMS_MFA") challengeResponses.SMS_MFA_CODE = challengeResponse;
    if (challengeName === "SMS_OTP") challengeResponses.SMS_OTP_CODE = challengeResponse;
    if (challengeName === "SOFTWARE_TOKEN_MFA") challengeResponses.SOFTWARE_TOKEN_MFA_CODE = challengeResponse;
    const userContextData = (0, $d1d75befb3456a99$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        ChallengeName: challengeName,
        ChallengeResponses: challengeResponses,
        Session: session,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: userContextData
    };
    const respondToAuthChallenge = (0, $33fa144820195cb7$export$11329f5ae466ab5d)({
        endpointResolver: (0, $034f40104fa68ca7$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    return respondToAuthChallenge({
        region: (0, $f3a37e3ae41d4905$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $7032744b11af61d7$export$d6cd780379f37dae)((0, $80240862ea60f1f3$export$900b1436d7e65f4).ConfirmSignIn)
    }, jsonReq);
}















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Signs a user in using a custom authentication flow without password
 *
 * @param input -  The SignInWithCustomAuthInput object
 * @returns AuthSignInResult
 * @throws service: {@link InitiateAuthException } - Cognito service errors thrown during the sign-in process.
 * @throws validation: {@link AuthValidationErrorCode  } - Validation errors thrown when either username or password
 *  are not defined.
 * @throws SignInWithCustomAuthOutput - Thrown when the token provider config is invalid.
 */ async function $1ab8b470a2769d6c$export$7f948971bcf643ff(input) {
    const authConfig = (0, $44174d4eb465d133$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    (0, $da35d46b99b5d98d$export$80c92581e59ed502)(authConfig);
    const { username: username , password: password , options: options  } = input;
    const signInDetails = {
        loginId: username,
        authFlowType: "CUSTOM_WITHOUT_SRP"
    };
    const metadata = options?.clientMetadata;
    (0, $fd90eaa8008e7494$export$45936001d12f9b53)(!!username, (0, $e5a1b34bea683c02$export$12d5c695b2213c4a).EmptySignInUsername);
    (0, $fd90eaa8008e7494$export$45936001d12f9b53)(!password, (0, $e5a1b34bea683c02$export$12d5c695b2213c4a).CustomAuthSignInPassword);
    try {
        const { ChallengeName: retriedChallengeName , ChallengeParameters: retiredChallengeParameters , AuthenticationResult: AuthenticationResult , Session: Session  } = await (0, $d3c3238cf7b10401$export$30f932fe98713ccc)((0, $d3c3238cf7b10401$export$1a654dcab55e0de5), [
            username,
            metadata,
            authConfig,
            (0, $14fa9bd317b4b3d6$export$66561e66d62991d0)
        ], username, (0, $14fa9bd317b4b3d6$export$66561e66d62991d0));
        const activeUsername = (0, $d3c3238cf7b10401$export$cc3585de146a51be)(username);
        // sets up local state used during the sign-in process
        (0, $18f78a860861bd8b$export$bae72361b690e075)({
            signInSession: Session,
            username: activeUsername,
            challengeName: retriedChallengeName,
            signInDetails: signInDetails
        });
        if (AuthenticationResult) {
            await (0, $f1b09a3c3b2ae67d$export$729df6fdd19b8b0d)({
                username: activeUsername,
                ...AuthenticationResult,
                NewDeviceMetadata: await (0, $d3c3238cf7b10401$export$548ed8ad974a8b30)({
                    userPoolId: authConfig.userPoolId,
                    userPoolEndpoint: authConfig.userPoolEndpoint,
                    newDeviceMetadata: AuthenticationResult.NewDeviceMetadata,
                    accessToken: AuthenticationResult.AccessToken
                }),
                signInDetails: signInDetails
            });
            (0, $18f78a860861bd8b$export$ddfd5a0262ce9df3)();
            await (0, $0386d0d0091ba4c9$export$4d78d2ee899572ab)();
            return {
                isSignedIn: true,
                nextStep: {
                    signInStep: "DONE"
                }
            };
        }
        return (0, $d3c3238cf7b10401$export$cf152400b58b8e65)({
            challengeName: retriedChallengeName,
            challengeParameters: retiredChallengeParameters
        });
    } catch (error) {
        (0, $18f78a860861bd8b$export$ddfd5a0262ce9df3)();
        (0, $30ec7ddce5c02788$export$5b3890f50cd4853f)(error);
        const result = (0, $d3c3238cf7b10401$export$cafe99bb44d49edb)(error.name);
        if (result) return result;
        throw error;
    }
}















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Signs a user in using a custom authentication flow with SRP
 *
 * @param input -  The SignInWithCustomSRPAuthInput object
 * @returns SignInWithCustomSRPAuthOutput
 * @throws service: {@link InitiateAuthException }, {@link RespondToAuthChallengeException } - Cognito
 * service errors thrown during the sign-in process.
 * @throws validation: {@link AuthValidationErrorCode  } - Validation errors thrown when either username or password
 *  are not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $37425683072d566a$export$2c0317ed1bbb0787(input) {
    const { username: username , password: password , options: options  } = input;
    const signInDetails = {
        loginId: username,
        authFlowType: "CUSTOM_WITH_SRP"
    };
    const authConfig = (0, $44174d4eb465d133$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    (0, $da35d46b99b5d98d$export$80c92581e59ed502)(authConfig);
    const metadata = options?.clientMetadata;
    (0, $fd90eaa8008e7494$export$45936001d12f9b53)(!!username, (0, $e5a1b34bea683c02$export$12d5c695b2213c4a).EmptySignInUsername);
    (0, $fd90eaa8008e7494$export$45936001d12f9b53)(!!password, (0, $e5a1b34bea683c02$export$12d5c695b2213c4a).EmptySignInPassword);
    try {
        const { ChallengeName: handledChallengeName , ChallengeParameters: handledChallengeParameters , AuthenticationResult: AuthenticationResult , Session: Session  } = await (0, $d3c3238cf7b10401$export$9ce9dd351616104c)(username, password, metadata, authConfig, (0, $14fa9bd317b4b3d6$export$66561e66d62991d0));
        const activeUsername = (0, $d3c3238cf7b10401$export$cc3585de146a51be)(username);
        // sets up local state used during the sign-in process
        (0, $18f78a860861bd8b$export$bae72361b690e075)({
            signInSession: Session,
            username: activeUsername,
            challengeName: handledChallengeName,
            signInDetails: signInDetails
        });
        if (AuthenticationResult) {
            await (0, $f1b09a3c3b2ae67d$export$729df6fdd19b8b0d)({
                username: activeUsername,
                ...AuthenticationResult,
                NewDeviceMetadata: await (0, $d3c3238cf7b10401$export$548ed8ad974a8b30)({
                    userPoolId: authConfig.userPoolId,
                    userPoolEndpoint: authConfig.userPoolEndpoint,
                    newDeviceMetadata: AuthenticationResult.NewDeviceMetadata,
                    accessToken: AuthenticationResult.AccessToken
                }),
                signInDetails: signInDetails
            });
            (0, $18f78a860861bd8b$export$ddfd5a0262ce9df3)();
            await (0, $0386d0d0091ba4c9$export$4d78d2ee899572ab)();
            return {
                isSignedIn: true,
                nextStep: {
                    signInStep: "DONE"
                }
            };
        }
        return (0, $d3c3238cf7b10401$export$cf152400b58b8e65)({
            challengeName: handledChallengeName,
            challengeParameters: handledChallengeParameters
        });
    } catch (error) {
        (0, $18f78a860861bd8b$export$ddfd5a0262ce9df3)();
        (0, $30ec7ddce5c02788$export$5b3890f50cd4853f)(error);
        const result = (0, $d3c3238cf7b10401$export$cafe99bb44d49edb)(error.name);
        if (result) return result;
        throw error;
    }
}
















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Signs a user in
 *
 * @param input - The SignInWithSRPInput object
 * @returns SignInWithSRPOutput
 * @throws service: {@link InitiateAuthException }, {@link RespondToAuthChallengeException } - Cognito service errors
 * thrown during the sign-in process.
 * @throws validation: {@link AuthValidationErrorCode  } - Validation errors thrown when either username or password
 *  are not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $6293e3dd6397aac6$export$728178cf826a5ab9(input) {
    const { username: username , password: password  } = input;
    const authConfig = (0, $44174d4eb465d133$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    const signInDetails = {
        loginId: username,
        authFlowType: "USER_SRP_AUTH"
    };
    (0, $da35d46b99b5d98d$export$80c92581e59ed502)(authConfig);
    const clientMetaData = input.options?.clientMetadata;
    (0, $fd90eaa8008e7494$export$45936001d12f9b53)(!!username, (0, $e5a1b34bea683c02$export$12d5c695b2213c4a).EmptySignInUsername);
    (0, $fd90eaa8008e7494$export$45936001d12f9b53)(!!password, (0, $e5a1b34bea683c02$export$12d5c695b2213c4a).EmptySignInPassword);
    try {
        const { ChallengeName: handledChallengeName , ChallengeParameters: handledChallengeParameters , AuthenticationResult: AuthenticationResult , Session: Session  } = await (0, $d3c3238cf7b10401$export$13a3ef5ef8cac338)(username, password, clientMetaData, authConfig, (0, $14fa9bd317b4b3d6$export$66561e66d62991d0));
        const activeUsername = (0, $d3c3238cf7b10401$export$cc3585de146a51be)(username);
        // sets up local state used during the sign-in process
        (0, $18f78a860861bd8b$export$bae72361b690e075)({
            signInSession: Session,
            username: activeUsername,
            challengeName: handledChallengeName,
            signInDetails: signInDetails
        });
        if (AuthenticationResult) {
            await (0, $f1b09a3c3b2ae67d$export$729df6fdd19b8b0d)({
                username: activeUsername,
                ...AuthenticationResult,
                NewDeviceMetadata: await (0, $d3c3238cf7b10401$export$548ed8ad974a8b30)({
                    userPoolId: authConfig.userPoolId,
                    userPoolEndpoint: authConfig.userPoolEndpoint,
                    newDeviceMetadata: AuthenticationResult.NewDeviceMetadata,
                    accessToken: AuthenticationResult.AccessToken
                }),
                signInDetails: signInDetails
            });
            (0, $18f78a860861bd8b$export$ddfd5a0262ce9df3)();
            await (0, $0386d0d0091ba4c9$export$4d78d2ee899572ab)();
            (0, $e010ce5326316812$export$1ffa2742ce5c589b)();
            return {
                isSignedIn: true,
                nextStep: {
                    signInStep: "DONE"
                }
            };
        }
        return (0, $d3c3238cf7b10401$export$cf152400b58b8e65)({
            challengeName: handledChallengeName,
            challengeParameters: handledChallengeParameters
        });
    } catch (error) {
        (0, $18f78a860861bd8b$export$ddfd5a0262ce9df3)();
        (0, $e010ce5326316812$export$1ffa2742ce5c589b)();
        (0, $30ec7ddce5c02788$export$5b3890f50cd4853f)(error);
        const result = (0, $d3c3238cf7b10401$export$cafe99bb44d49edb)(error.name);
        if (result) return result;
        throw error;
    }
}
















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Signs a user in using USER_PASSWORD_AUTH AuthFlowType
 *
 * @param input - The SignInWithUserPasswordInput object
 * @returns SignInWithUserPasswordOutput
 * @throws service: {@link InitiateAuthException } - Cognito service error thrown during the sign-in process.
 * @throws validation: {@link AuthValidationErrorCode  } - Validation errors thrown when either username or password
 *  are not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $5257e4d42585adf4$export$200af5a623414b2b(input) {
    const { username: username , password: password , options: options  } = input;
    const authConfig = (0, $44174d4eb465d133$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    const signInDetails = {
        loginId: username,
        authFlowType: "USER_PASSWORD_AUTH"
    };
    (0, $da35d46b99b5d98d$export$80c92581e59ed502)(authConfig);
    const metadata = options?.clientMetadata;
    (0, $fd90eaa8008e7494$export$45936001d12f9b53)(!!username, (0, $e5a1b34bea683c02$export$12d5c695b2213c4a).EmptySignInUsername);
    (0, $fd90eaa8008e7494$export$45936001d12f9b53)(!!password, (0, $e5a1b34bea683c02$export$12d5c695b2213c4a).EmptySignInPassword);
    try {
        const { ChallengeName: retiredChallengeName , ChallengeParameters: retriedChallengeParameters , AuthenticationResult: AuthenticationResult , Session: Session  } = await (0, $d3c3238cf7b10401$export$30f932fe98713ccc)((0, $d3c3238cf7b10401$export$29fb48d356e16a7), [
            username,
            password,
            metadata,
            authConfig,
            (0, $14fa9bd317b4b3d6$export$66561e66d62991d0)
        ], username, (0, $14fa9bd317b4b3d6$export$66561e66d62991d0));
        const activeUsername = (0, $d3c3238cf7b10401$export$cc3585de146a51be)(username);
        // sets up local state used during the sign-in process
        (0, $18f78a860861bd8b$export$bae72361b690e075)({
            signInSession: Session,
            username: activeUsername,
            challengeName: retiredChallengeName,
            signInDetails: signInDetails
        });
        if (AuthenticationResult) {
            await (0, $f1b09a3c3b2ae67d$export$729df6fdd19b8b0d)({
                ...AuthenticationResult,
                username: activeUsername,
                NewDeviceMetadata: await (0, $d3c3238cf7b10401$export$548ed8ad974a8b30)({
                    userPoolId: authConfig.userPoolId,
                    userPoolEndpoint: authConfig.userPoolEndpoint,
                    newDeviceMetadata: AuthenticationResult.NewDeviceMetadata,
                    accessToken: AuthenticationResult.AccessToken
                }),
                signInDetails: signInDetails
            });
            (0, $18f78a860861bd8b$export$ddfd5a0262ce9df3)();
            await (0, $0386d0d0091ba4c9$export$4d78d2ee899572ab)();
            (0, $e010ce5326316812$export$1ffa2742ce5c589b)();
            return {
                isSignedIn: true,
                nextStep: {
                    signInStep: "DONE"
                }
            };
        }
        return (0, $d3c3238cf7b10401$export$cf152400b58b8e65)({
            challengeName: retiredChallengeName,
            challengeParameters: retriedChallengeParameters
        });
    } catch (error) {
        (0, $18f78a860861bd8b$export$ddfd5a0262ce9df3)();
        (0, $e010ce5326316812$export$1ffa2742ce5c589b)();
        (0, $30ec7ddce5c02788$export$5b3890f50cd4853f)(error);
        const result = (0, $d3c3238cf7b10401$export$cafe99bb44d49edb)(error.name);
        if (result) return result;
        throw error;
    }
}
































// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Handles user authentication flow with configurable challenge preferences.
 * Supports AuthFactorType challenges through the USER_AUTH flow.
 *
 * @param {HandleUserAuthFlowInput} params - Authentication flow parameters
 * @param {string} params.username - The username for authentication
 * @param {Record<string, string>} [params.clientMetadata] - Optional metadata to pass to authentication service
 * @param {CognitoUserPoolConfig} params.config - Cognito User Pool configuration
 * @param {AuthTokenOrchestrator} params.tokenOrchestrator - Manages authentication tokens and device tracking
 * @param {AuthFactorType} [params.preferredChallenge] - Optional preferred authentication method
 * @param {string} [params.password] - Required when preferredChallenge is 'PASSWORD' or 'PASSWORD_SRP'
 *
 * @returns {Promise<InitiateAuthCommandOutput>} The authentication response from Cognito
 */ async function $8ebf7e6387b2a431$export$f21455679019a68e({ username: username , clientMetadata: clientMetadata , config: config , tokenOrchestrator: tokenOrchestrator , preferredChallenge: preferredChallenge , password: password , session: session  }) {
    const { userPoolId: userPoolId , userPoolClientId: userPoolClientId , userPoolEndpoint: userPoolEndpoint  } = config;
    const UserContextData = (0, $d1d75befb3456a99$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const authParameters = {
        USERNAME: username
    };
    if (preferredChallenge) {
        if (preferredChallenge === "PASSWORD_SRP") {
            (0, $fd90eaa8008e7494$export$45936001d12f9b53)(!!password, (0, $e5a1b34bea683c02$export$12d5c695b2213c4a).EmptySignInPassword);
            return (0, $f77b1ffdbc0c7f64$export$169bd15774e46c56)({
                username: username,
                password: password,
                clientMetadata: clientMetadata,
                config: config,
                tokenOrchestrator: tokenOrchestrator,
                authFlow: "USER_AUTH",
                preferredChallenge: preferredChallenge
            });
        }
        if (preferredChallenge === "PASSWORD") {
            (0, $fd90eaa8008e7494$export$45936001d12f9b53)(!!password, (0, $e5a1b34bea683c02$export$12d5c695b2213c4a).EmptySignInPassword);
            authParameters.PASSWORD = password;
        }
        authParameters.PREFERRED_CHALLENGE = preferredChallenge;
    }
    const jsonReq = {
        AuthFlow: "USER_AUTH",
        AuthParameters: authParameters,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    if (session) jsonReq.Session = session;
    const initiateAuth = (0, $73c63bd2bf2643ec$export$91f349d78bea7765)({
        endpointResolver: (0, $034f40104fa68ca7$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const response = await initiateAuth({
        region: (0, $f3a37e3ae41d4905$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $7032744b11af61d7$export$d6cd780379f37dae)((0, $80240862ea60f1f3$export$900b1436d7e65f4).SignIn)
    }, jsonReq);
    // Set the active username immediately after successful authentication attempt
    // If a user starts a new sign-in while another sign-in is incomplete,
    // this ensures we're tracking the correct user for subsequent auth challenges.
    (0, $d3c3238cf7b10401$export$fecfbc200868d412)(username);
    return response;
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Signs a user in through a registered email or phone number without a password by by receiving and entering an OTP.
 *
 * @param input - The SignInWithUserAuthInput object
 * @returns SignInWithUserAuthOutput
 * @throws service: {@link InitiateAuthException }, {@link RespondToAuthChallengeException } - Cognito service errors
 * thrown during the sign-in process.
 * @throws validation: {@link AuthValidationErrorCode  } - Validation errors thrown when either username or password -- needs to change
 *  are not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $4e265830ec2ec185$export$fcfa00cf0f5ec937(input) {
    const { username: username , password: password , options: options  } = input;
    const authConfig = (0, $44174d4eb465d133$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    const signInDetails = {
        loginId: username,
        authFlowType: "USER_AUTH"
    };
    (0, $da35d46b99b5d98d$export$80c92581e59ed502)(authConfig);
    const clientMetaData = options?.clientMetadata;
    const preferredChallenge = options?.preferredChallenge;
    (0, $fd90eaa8008e7494$export$45936001d12f9b53)(!!username, (0, $e5a1b34bea683c02$export$12d5c695b2213c4a).EmptySignInUsername);
    try {
        const handleUserAuthFlowInput = {
            username: username,
            config: authConfig,
            tokenOrchestrator: $14fa9bd317b4b3d6$export$66561e66d62991d0,
            clientMetadata: clientMetaData,
            preferredChallenge: preferredChallenge,
            password: password
        };
        const autoSignInStoreState = (0, $8686208da85e51a8$export$ef87a9980a3566ca).getState();
        if (autoSignInStoreState.active && autoSignInStoreState.username === username) handleUserAuthFlowInput.session = autoSignInStoreState.session;
        const response = await (0, $8ebf7e6387b2a431$export$f21455679019a68e)(handleUserAuthFlowInput);
        const activeUsername = (0, $d3c3238cf7b10401$export$cc3585de146a51be)(username);
        (0, $18f78a860861bd8b$export$bae72361b690e075)({
            signInSession: response.Session,
            username: activeUsername,
            challengeName: response.ChallengeName,
            signInDetails: signInDetails
        });
        if (response.AuthenticationResult) {
            await (0, $f1b09a3c3b2ae67d$export$729df6fdd19b8b0d)({
                username: activeUsername,
                ...response.AuthenticationResult,
                NewDeviceMetadata: await (0, $d3c3238cf7b10401$export$548ed8ad974a8b30)({
                    userPoolId: authConfig.userPoolId,
                    userPoolEndpoint: authConfig.userPoolEndpoint,
                    newDeviceMetadata: response.AuthenticationResult.NewDeviceMetadata,
                    accessToken: response.AuthenticationResult.AccessToken
                }),
                signInDetails: signInDetails
            });
            (0, $18f78a860861bd8b$export$ddfd5a0262ce9df3)();
            await (0, $0386d0d0091ba4c9$export$4d78d2ee899572ab)();
            (0, $e010ce5326316812$export$1ffa2742ce5c589b)();
            return {
                isSignedIn: true,
                nextStep: {
                    signInStep: "DONE"
                }
            };
        }
        return (0, $d3c3238cf7b10401$export$cf152400b58b8e65)({
            challengeName: response.ChallengeName,
            challengeParameters: response.ChallengeParameters,
            availableChallenges: "AvailableChallenges" in response ? response.AvailableChallenges : undefined
        });
    } catch (error) {
        (0, $18f78a860861bd8b$export$ddfd5a0262ce9df3)();
        (0, $e010ce5326316812$export$1ffa2742ce5c589b)();
        (0, $30ec7ddce5c02788$export$5b3890f50cd4853f)(error);
        const result = (0, $d3c3238cf7b10401$export$cafe99bb44d49edb)(error.name);
        if (result) return result;
        throw error;
    }
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Signs a user in
 *
 * @param input -  The SignInInput object
 * @returns SignInOutput
 * @throws service: {@link InitiateAuthException }, {@link RespondToAuthChallengeException }
 *  - Cognito service errors thrown during the sign-in process.
 * @throws validation: {@link AuthValidationErrorCode  } - Validation errors thrown when either username or password
 *  are not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $8a12ffc5dc959a57$export$9670d83f11d4b64a(input) {
    // Here we want to reset the store but not reassign the callback.
    // The callback is reset when the underlying promise resolves or rejects.
    // With the advent of session based sign in, this guarantees that the signIn API initiates a new auth flow,
    // regardless of whether it is called for a user currently engaged in an active auto sign in session.
    (0, $e010ce5326316812$export$1ffa2742ce5c589b)(false);
    const authFlowType = input.options?.authFlowType;
    await (0, $d3c3238cf7b10401$export$8061cd07f982ef08)();
    switch(authFlowType){
        case "USER_SRP_AUTH":
            return (0, $6293e3dd6397aac6$export$728178cf826a5ab9)(input);
        case "USER_PASSWORD_AUTH":
            return (0, $5257e4d42585adf4$export$200af5a623414b2b)(input);
        case "CUSTOM_WITHOUT_SRP":
            return (0, $1ab8b470a2769d6c$export$7f948971bcf643ff)(input);
        case "CUSTOM_WITH_SRP":
            return (0, $37425683072d566a$export$2c0317ed1bbb0787)(input);
        case "USER_AUTH":
            return (0, $4e265830ec2ec185$export$fcfa00cf0f5ec937)(input);
        default:
            return (0, $6293e3dd6397aac6$export$728178cf826a5ab9)(input);
    }
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $e863fa8082f45809$export$d1b63878dfcc70a6() {
    return (0, $44174d4eb465d133$export$a3858a9a153cffc7).Auth.clearCredentials();
}


















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $872756867fb3a1a7$export$f8a4fedaab76b065 = async (store)=>{
    await store.clearOAuthData();
    (0, $14fa9bd317b4b3d6$export$66561e66d62991d0).clearTokens();
    await (0, $e863fa8082f45809$export$d1b63878dfcc70a6)();
    (0, $9464725044e9d769$export$8c41bb232f1008b1).dispatch("auth", {
        event: "signedOut"
    }, "Auth", (0, $9464725044e9d769$export$aadf71dd9875dd20));
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $ef51fed5140dc4d1$export$a673d54799039714 = async (url)=>{
    if (!window?.location) return;
    // enforce HTTPS
    window.location.href = url.replace("http://", "https://");
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/** @internal */ function $cbadbba8ed1b5a8c$export$93832c3affb240d3(redirects, preferredRedirectUrl) {
    if (preferredRedirectUrl) {
        const redirectUrl = redirects?.find((redirect)=>redirect === preferredRedirectUrl);
        if (!redirectUrl) throw 0, $e4cb7b306ced9230$export$41a56a70fc1a4962;
        return redirectUrl;
    } else {
        const redirectUrlFromTheSameOrigin = redirects?.find($cbadbba8ed1b5a8c$var$isSameOriginAndPathName) ?? redirects?.find($cbadbba8ed1b5a8c$var$isTheSameDomain);
        const redirectUrlFromDifferentOrigin = redirects?.find($cbadbba8ed1b5a8c$var$isHttps) ?? redirects?.find($cbadbba8ed1b5a8c$var$isHttp);
        if (redirectUrlFromTheSameOrigin) return redirectUrlFromTheSameOrigin;
        else if (redirectUrlFromDifferentOrigin) throw 0, $e4cb7b306ced9230$export$c01b4acd6291e035;
        throw 0, $e4cb7b306ced9230$export$60b68b138a52e5ae;
    }
}
// origin + pathname => https://example.com/app
const $cbadbba8ed1b5a8c$var$isSameOriginAndPathName = (redirect)=>redirect.startsWith(// eslint-disable-next-line no-constant-binary-expression
    String((window.location.origin + window.location.pathname) ?? "/"));
// domain => outlook.live.com, github.com
const $cbadbba8ed1b5a8c$var$isTheSameDomain = (redirect)=>redirect.includes(String(window.location.hostname));
const $cbadbba8ed1b5a8c$var$isHttp = (redirect)=>redirect.startsWith("http://");
const $cbadbba8ed1b5a8c$var$isHttps = (redirect)=>redirect.startsWith("https://");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $de1604557ee99f23$export$a20426d3d43ad21f = async (authConfig, preferPrivateSession = false, redirectUrl)=>{
    (0, $da35d46b99b5d98d$export$c13e6dbaf90a8e5f)(authConfig);
    const { loginWith: loginWith , userPoolClientId: userPoolClientId  } = authConfig;
    const { domain: domain , redirectSignOut: redirectSignOut  } = loginWith.oauth;
    const signoutUri = (0, $cbadbba8ed1b5a8c$export$93832c3affb240d3)(redirectSignOut, redirectUrl);
    const oAuthLogoutEndpoint = `https://${domain}/logout?${Object.entries({
        client_id: userPoolClientId,
        logout_uri: encodeURIComponent(signoutUri)
    }).map(([k, v])=>`${k}=${v}`).join("&")}`;
    return (0, $ef51fed5140dc4d1$export$a673d54799039714)(oAuthLogoutEndpoint);
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $0911740e79fabe84$export$74290142c99a2f64 = async (cognitoConfig, store, tokenOrchestrator, redirectUrl)=>{
    const { isOAuthSignIn: isOAuthSignIn  } = await store.loadOAuthSignIn();
    const oauthMetadata = await tokenOrchestrator.getOAuthMetadata();
    // Clear everything before attempting to visted logout endpoint since the current application
    // state could be wiped away on redirect
    await (0, $872756867fb3a1a7$export$f8a4fedaab76b065)(store);
    // The isOAuthSignIn flag is propagated by the oAuthToken store which manages oauth keys in local storage only.
    // These keys are used to determine if a user is in an inflight or signedIn oauth states.
    // However, this behavior represents an issue when 2 apps share the same set of tokens in Cookie storage because the app that didn't
    // start the OAuth will not have access to the oauth keys.
    // A heuristic solution is to add oauth metadata to the tokenOrchestrator which will have access to the underlying
    // storage mechanism that is used by Amplify.
    if (isOAuthSignIn || oauthMetadata?.oauthSignIn) // On web, this will always end up being a void action
    return (0, $de1604557ee99f23$export$a20426d3d43ad21f)(cognitoConfig, false, redirectUrl);
};

















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $0420d9184f5e1e42$export$93ed00c43cc3ad50 = (config)=>(0, $29600698f92385b7$export$880429a8ae983d4d)((0, $566d64d9996fb1fd$export$10f11e95d7a96f7b), (0, $12cd6399d355fb71$export$1113413e6e842bef)("RevokeToken"), (0, $d5338601430a6488$export$8159795418a3e796)(), {
        ...(0, $579ad14e33e08f0c$export$22a3716e7860147a),
        ...config
    });











// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $1c53b569c00b42db$export$9ebd23b04fdf4c3a = (config)=>(0, $29600698f92385b7$export$880429a8ae983d4d)((0, $566d64d9996fb1fd$export$10f11e95d7a96f7b), (0, $12cd6399d355fb71$export$1113413e6e842bef)("GlobalSignOut"), (0, $d5338601430a6488$export$8159795418a3e796)(), {
        ...(0, $579ad14e33e08f0c$export$22a3716e7860147a),
        ...config
    });



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $ce6bf905214da226$var$logger = new (0, $39a0f4f2bf9492b0$export$ba6a9c7ac8291f7f)("Auth");
/**
 * Signs a user out
 *
 * @param input - The SignOutInput object
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $ce6bf905214da226$export$b0ac3a1c242cb1ea(input) {
    const cognitoConfig = (0, $44174d4eb465d133$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    (0, $da35d46b99b5d98d$export$80c92581e59ed502)(cognitoConfig);
    if (input?.global) await $ce6bf905214da226$var$globalSignOut(cognitoConfig);
    else await $ce6bf905214da226$var$clientSignOut(cognitoConfig);
    let hasOAuthConfig;
    try {
        (0, $da35d46b99b5d98d$export$c13e6dbaf90a8e5f)(cognitoConfig);
        hasOAuthConfig = true;
    } catch (err) {
        hasOAuthConfig = false;
    }
    if (hasOAuthConfig) {
        const oAuthStore = new (0, $388b2d9f599c1030$export$9b2cef5d94f9b6e8)((0, $d6350db11aa681cd$export$586b30dcaeecb901));
        oAuthStore.setAuthConfig(cognitoConfig);
        const { type: type  } = await (0, $0911740e79fabe84$export$74290142c99a2f64)(cognitoConfig, oAuthStore, (0, $14fa9bd317b4b3d6$export$66561e66d62991d0), input?.oauth?.redirectUrl) ?? {};
        if (type === "error") throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
            name: (0, $e4cb7b306ced9230$export$625255707e22459c),
            message: `An error occurred when attempting to log out from OAuth provider.`
        });
    } else {
        // complete sign out
        (0, $14fa9bd317b4b3d6$export$66561e66d62991d0).clearTokens();
        await (0, $e863fa8082f45809$export$d1b63878dfcc70a6)();
        (0, $9464725044e9d769$export$8c41bb232f1008b1).dispatch("auth", {
            event: "signedOut"
        }, "Auth", (0, $9464725044e9d769$export$aadf71dd9875dd20));
    }
}
async function $ce6bf905214da226$var$clientSignOut(cognitoConfig) {
    try {
        const { userPoolEndpoint: userPoolEndpoint , userPoolId: userPoolId , userPoolClientId: userPoolClientId  } = cognitoConfig;
        const authTokens = await (0, $14fa9bd317b4b3d6$export$66561e66d62991d0).getTokenStore().loadTokens();
        (0, $6e9371ee52a401af$export$be38b2d22222d505)(authTokens);
        if ($ce6bf905214da226$var$isSessionRevocable(authTokens.accessToken)) {
            const revokeToken = (0, $0420d9184f5e1e42$export$93ed00c43cc3ad50)({
                endpointResolver: (0, $034f40104fa68ca7$export$9fc8f7dceefe00a6)({
                    endpointOverride: userPoolEndpoint
                })
            });
            await revokeToken({
                region: (0, $f3a37e3ae41d4905$export$5f7eb9761ac2d0d9)(userPoolId),
                userAgentValue: (0, $7032744b11af61d7$export$d6cd780379f37dae)((0, $80240862ea60f1f3$export$900b1436d7e65f4).SignOut)
            }, {
                ClientId: userPoolClientId,
                Token: authTokens.refreshToken
            });
        }
    } catch (err) {
        // this shouldn't throw
        $ce6bf905214da226$var$logger.debug("Client signOut error caught but will proceed with token removal");
    }
}
async function $ce6bf905214da226$var$globalSignOut(cognitoConfig) {
    try {
        const { userPoolEndpoint: userPoolEndpoint , userPoolId: userPoolId  } = cognitoConfig;
        const authTokens = await (0, $14fa9bd317b4b3d6$export$66561e66d62991d0).getTokenStore().loadTokens();
        (0, $6e9371ee52a401af$export$77712ea5882cac9f)(authTokens);
        const globalSignOutClient = (0, $1c53b569c00b42db$export$9ebd23b04fdf4c3a)({
            endpointResolver: (0, $034f40104fa68ca7$export$9fc8f7dceefe00a6)({
                endpointOverride: userPoolEndpoint
            })
        });
        await globalSignOutClient({
            region: (0, $f3a37e3ae41d4905$export$5f7eb9761ac2d0d9)(userPoolId),
            userAgentValue: (0, $7032744b11af61d7$export$d6cd780379f37dae)((0, $80240862ea60f1f3$export$900b1436d7e65f4).SignOut)
        }, {
            AccessToken: authTokens.accessToken.toString()
        });
    } catch (err) {
        // it should not throw
        $ce6bf905214da226$var$logger.debug("Global signOut error caught but will proceed with token removal");
    }
}
const $ce6bf905214da226$var$isSessionRevocable = (token)=>!!token?.payload?.origin_jti;













// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $094a6ff85dcbbb8a$var$MAX_AUTOSIGNIN_POLLING_MS = 180000;
function $094a6ff85dcbbb8a$export$385d6b43f72ecccf(signInInput) {
    const stopHubListener = (0, $9464725044e9d769$export$45dde0743a4c8d6e).listen("auth-internal", async ({ payload: payload  })=>{
        switch(payload.event){
            case "confirmSignUp":
                {
                    const response = payload.data;
                    if (response?.isSignUpComplete) {
                        (0, $9464725044e9d769$export$45dde0743a4c8d6e).dispatch("auth-internal", {
                            event: "autoSignIn"
                        });
                        (0, $e010ce5326316812$export$7dcbf67a23c27835)($094a6ff85dcbbb8a$var$autoSignInWithCode(signInInput));
                        stopHubListener();
                    }
                }
        }
    });
    // This will stop the listener if confirmSignUp is not resolved.
    const timeOutId = setTimeout(()=>{
        stopHubListener();
        clearTimeout(timeOutId);
        (0, $e010ce5326316812$export$1ffa2742ce5c589b)();
    }, $094a6ff85dcbbb8a$var$MAX_AUTOSIGNIN_POLLING_MS);
}
function $094a6ff85dcbbb8a$var$debounce(fun, delay) {
    let timer;
    return (args)=>{
        if (!timer) fun(...args);
        clearTimeout(timer);
        timer = setTimeout(()=>{
            timer = undefined;
        }, delay);
    };
}
function $094a6ff85dcbbb8a$var$handleAutoSignInWithLink(signInInput, resolve, reject) {
    const start = Date.now();
    const autoSignInPollingIntervalId = setInterval(async ()=>{
        const elapsedTime = Date.now() - start;
        const maxTime = $094a6ff85dcbbb8a$var$MAX_AUTOSIGNIN_POLLING_MS;
        if (elapsedTime > maxTime) {
            clearInterval(autoSignInPollingIntervalId);
            reject(new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
                name: (0, $e4cb7b306ced9230$export$fe46a12932d2550a),
                message: "The account was not confirmed on time.",
                recoverySuggestion: "Try to verify your account by clicking the link sent your email or phone and then login manually."
            }));
            (0, $e010ce5326316812$export$1ffa2742ce5c589b)();
        } else try {
            const signInOutput = await (0, $8a12ffc5dc959a57$export$9670d83f11d4b64a)(signInInput);
            if (signInOutput.nextStep.signInStep !== "CONFIRM_SIGN_UP") {
                resolve(signInOutput);
                clearInterval(autoSignInPollingIntervalId);
                (0, $e010ce5326316812$export$1ffa2742ce5c589b)();
            }
        } catch (error) {
            clearInterval(autoSignInPollingIntervalId);
            reject(error);
            (0, $e010ce5326316812$export$1ffa2742ce5c589b)();
        }
    }, 5000);
}
const $094a6ff85dcbbb8a$var$debouncedAutoSignInWithLink = $094a6ff85dcbbb8a$var$debounce($094a6ff85dcbbb8a$var$handleAutoSignInWithLink, 300);
const $094a6ff85dcbbb8a$var$debouncedAutoSignWithCodeOrUserConfirmed = $094a6ff85dcbbb8a$var$debounce($094a6ff85dcbbb8a$var$handleAutoSignInWithCodeOrUserConfirmed, 300);
function $094a6ff85dcbbb8a$export$feaed4858b71e8a(signInInput) {
    return async ()=>{
        return new Promise((resolve, reject)=>{
            $094a6ff85dcbbb8a$var$debouncedAutoSignInWithLink([
                signInInput,
                resolve,
                reject
            ]);
        });
    };
}
async function $094a6ff85dcbbb8a$var$handleAutoSignInWithCodeOrUserConfirmed(signInInput, resolve, reject) {
    try {
        const output = signInInput?.options?.authFlowType === "USER_AUTH" ? await (0, $4e265830ec2ec185$export$fcfa00cf0f5ec937)(signInInput) : await (0, $8a12ffc5dc959a57$export$9670d83f11d4b64a)(signInInput);
        resolve(output);
        (0, $e010ce5326316812$export$1ffa2742ce5c589b)();
    } catch (error) {
        reject(error);
        (0, $e010ce5326316812$export$1ffa2742ce5c589b)();
    }
}
function $094a6ff85dcbbb8a$var$autoSignInWithCode(signInInput) {
    return async ()=>{
        return new Promise((resolve, reject)=>{
            $094a6ff85dcbbb8a$var$debouncedAutoSignWithCodeOrUserConfirmed([
                signInInput,
                resolve,
                reject
            ]);
        });
    };
}
const $094a6ff85dcbbb8a$export$9ec2c3d010185172 = $094a6ff85dcbbb8a$var$autoSignInWithCode;


















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $ab0fb32f885dd3e3$export$f9d992c2ce90154a = ()=>async (response)=>{
        if (response.statusCode >= 300) {
            const error = await (0, $c9219ddc4f5544cf$export$be467dfcc0538e25)(response);
            (0, $30ec7ddce5c02788$export$5b3890f50cd4853f)(error);
            if (// Missing Password Error
            // 1 validation error detected: Value at 'password'failed to satisfy constraint: Member must not be null
            error.name === (0, $9e23bc336cf172f0$export$d0816902ed99fce6).InvalidParameterException && /'password'/.test(error.message) && /Member must not be null/.test(error.message)) {
                const name = (0, $e5a1b34bea683c02$export$12d5c695b2213c4a).EmptySignUpPassword;
                const { message: message , recoverySuggestion: recoverySuggestion  } = (0, $3277196cec8a3dbe$export$195137955146d376)[name];
                throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
                    name: name,
                    message: message,
                    recoverySuggestion: recoverySuggestion
                });
            }
            throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
                name: error.name,
                message: error.message
            });
        }
        return (0, $c9219ddc4f5544cf$export$759bcb35b0d1bf81)(response);
    };
const $ab0fb32f885dd3e3$export$99fa98564ba4db04 = (config)=>(0, $29600698f92385b7$export$880429a8ae983d4d)((0, $566d64d9996fb1fd$export$10f11e95d7a96f7b), (0, $12cd6399d355fb71$export$1113413e6e842bef)("SignUp"), $ab0fb32f885dd3e3$export$f9d992c2ce90154a(), {
        ...(0, $579ad14e33e08f0c$export$22a3716e7860147a),
        ...config
    });






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Creates a user
 *
 * @param input - The SignUpInput object
 * @returns SignUpOutput
 * @throws service: {@link SignUpException } - Cognito service errors thrown during the sign-up process.
 * @throws validation: {@link AuthValidationErrorCode } - Validation errors thrown either username or password
 *  are not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $cbf5ba3463998b72$export$cf64224bcd829024(input) {
    const { username: username , password: password , options: options  } = input;
    const authConfig = (0, $44174d4eb465d133$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    const signUpVerificationMethod = authConfig?.signUpVerificationMethod ?? "code";
    const { clientMetadata: clientMetadata , validationData: validationData , autoSignIn: autoSignIn  } = input.options ?? {};
    (0, $da35d46b99b5d98d$export$80c92581e59ed502)(authConfig);
    (0, $fd90eaa8008e7494$export$45936001d12f9b53)(!!username, (0, $e5a1b34bea683c02$export$12d5c695b2213c4a).EmptySignUpUsername);
    const signInServiceOptions = typeof autoSignIn !== "boolean" ? autoSignIn : undefined;
    const signInInput = {
        username: username,
        options: signInServiceOptions
    };
    // if the authFlowType is 'CUSTOM_WITHOUT_SRP' then we don't include the password
    if (signInServiceOptions?.authFlowType !== "CUSTOM_WITHOUT_SRP") signInInput.password = password;
    const { userPoolId: userPoolId , userPoolClientId: userPoolClientId , userPoolEndpoint: userPoolEndpoint  } = authConfig;
    const signUpClient = (0, $ab0fb32f885dd3e3$export$99fa98564ba4db04)({
        endpointResolver: (0, $034f40104fa68ca7$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const signUpClientInput = {
        Username: username,
        Password: undefined,
        UserAttributes: options?.userAttributes && (0, $989e07b151f5455b$export$720a7caa078a04b0)(options?.userAttributes),
        ClientMetadata: clientMetadata,
        ValidationData: validationData && (0, $989e07b151f5455b$export$720a7caa078a04b0)(validationData),
        ClientId: userPoolClientId,
        UserContextData: (0, $d1d75befb3456a99$export$b6e6cdd1f90faa62)({
            username: username,
            userPoolId: userPoolId,
            userPoolClientId: userPoolClientId
        })
    };
    if (password) signUpClientInput.Password = password;
    const { UserSub: userId , CodeDeliveryDetails: cdd , UserConfirmed: userConfirmed , Session: session  } = await signUpClient({
        region: (0, $f3a37e3ae41d4905$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $7032744b11af61d7$export$d6cd780379f37dae)((0, $80240862ea60f1f3$export$900b1436d7e65f4).SignUp)
    }, signUpClientInput);
    if (signInServiceOptions || autoSignIn === true) {
        (0, $8686208da85e51a8$export$ef87a9980a3566ca).dispatch({
            type: "START"
        });
        (0, $8686208da85e51a8$export$ef87a9980a3566ca).dispatch({
            type: "SET_USERNAME",
            value: username
        });
        (0, $8686208da85e51a8$export$ef87a9980a3566ca).dispatch({
            type: "SET_SESSION",
            value: session
        });
    }
    const codeDeliveryDetails = {
        destination: cdd?.Destination,
        deliveryMedium: cdd?.DeliveryMedium,
        attributeName: cdd?.AttributeName
    };
    const isSignUpComplete = !!userConfirmed;
    const isAutoSignInStarted = (0, $8686208da85e51a8$export$ef87a9980a3566ca).getState().active;
    // Sign Up Complete
    // No Confirm Sign In Step Required
    if (isSignUpComplete) {
        if (isAutoSignInStarted) {
            (0, $e010ce5326316812$export$7dcbf67a23c27835)((0, $094a6ff85dcbbb8a$export$9ec2c3d010185172)(signInInput));
            return {
                isSignUpComplete: true,
                nextStep: {
                    signUpStep: "COMPLETE_AUTO_SIGN_IN"
                },
                userId: userId
            };
        }
        return {
            isSignUpComplete: true,
            nextStep: {
                signUpStep: "DONE"
            },
            userId: userId
        };
    }
    // Sign Up Not Complete
    // Confirm Sign Up Step Required
    if (isAutoSignInStarted) {
        // Confirmation Via Link Occurs In Separate Context
        // AutoSignIn Fn Will Initiate Polling Once Executed
        if (signUpVerificationMethod === "link") {
            (0, $e010ce5326316812$export$7dcbf67a23c27835)((0, $094a6ff85dcbbb8a$export$feaed4858b71e8a)(signInInput));
            return {
                isSignUpComplete: false,
                nextStep: {
                    signUpStep: "COMPLETE_AUTO_SIGN_IN",
                    codeDeliveryDetails: codeDeliveryDetails
                },
                userId: userId
            };
        }
        // Confirmation Via Code Occurs In Same Context
        // AutoSignIn Next Step Will Be Returned From Confirm Sign Up
        (0, $094a6ff85dcbbb8a$export$385d6b43f72ecccf)(signInInput);
    }
    return {
        isSignUpComplete: false,
        nextStep: {
            signUpStep: "CONFIRM_SIGN_UP",
            codeDeliveryDetails: codeDeliveryDetails
        },
        userId: userId
    };
}


const $dfc697a5db8ce601$var$awsmobile = {
    aws_project_region: "us-east-1",
    aws_cognito_region: "us-east-1",
    aws_user_pools_id: "us-east-1_[FILL_IN_THE_BLANK]",
    aws_user_pools_web_client_id: "[FILL_IN_THE_BLANK]",
    oauth: {},
    aws_cognito_username_attributes: [
        "EMAIL"
    ],
    aws_cognito_social_providers: [],
    aws_cognito_signup_attributes: [
        "EMAIL"
    ],
    aws_cognito_verification_mechanisms: [
        "EMAIL"
    ]
};
var $dfc697a5db8ce601$export$2e2bcd8739ae039 = $dfc697a5db8ce601$var$awsmobile;


// Context
// Intervals are pretty darn tricky in React; if you're not careful, you'll wind up with a "stale" interval, one which can't access current values of state or props.
// This hook allows us to sidestep that confusion, and it also gives us a superpower: we can modify the delay without having to worry about stopping and starting the interval.
// I learned about this hook from Dan in his blog post (https://overreacted.io/making-setinterval-declarative-with-react-hooks/) on the subject, and he does a fantastic job explaining what all this funkiness is and why you need it. He explains it better than I would be able to, so if you're curious how it works, read his blog post all about it!
// I did make one significant change to his version: My version of the hook returns the interval ID, similar to window.setInterval. This allows you to cancel the interval imperatively, if you need to. Note that this is an escape hatch: the primary declarative way to cancel the interval is to set the delay equal to null.
// Link to this headingUsage
// useInterval looks quite a bit like setInterval in its usage:
// JS
// useInterval(() => {
//   console.log('I fire every second!');
// }, 1000);
// Here's an example of a "Stopwatch" component. useInterval lets us track how much time has elapsed since the user has started the stopwatch.
// JSX
// const Stopwatch = () => {
//   const [status, setStatus] = React.useState('idle');
//   const [timeElapsed, setTimeElapsed] = React.useState(0);
//   useInterval(
//     () => {
//       setTimeElapsed((timeElapsed) => timeElapsed + 1);
//     },
//     status === 'running' ? 1000 : null
//   );
//   const toggle = () => {
//     setTimeElapsed(0);
//     setStatus((status) => (status === 'running' ? 'idle' : 'running'));
//   };
//   return (
//     <>
//       Time Elapsed: {timeElapsed} second(s)
//       <button onClick={toggle}>
//         {status === 'running' ? 'Stop' : 'Start'}
//       </button>
//     </>
//   );
// };

var $bh6RR = parcelRequire("bh6RR");
function $43c5aabb14cdd515$var$useInterval(callback, delay) {
    const intervalRef = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(null);
    const savedCallback = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(callback);
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        const tick = ()=>savedCallback.current();
        if (typeof delay === "number") {
            intervalRef.current = window.setInterval(tick, delay);
            return ()=>window.clearInterval(intervalRef.current);
        }
    }, [
        delay
    ]);
    return intervalRef;
}
var $43c5aabb14cdd515$export$2e2bcd8739ae039 = $43c5aabb14cdd515$var$useInterval;


(0, $2fcf3704ebc37489$export$11ac3725994bec7b).configure((0, $dfc697a5db8ce601$export$2e2bcd8739ae039));
const $5a12233f233e4186$export$38ee920e59704589 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext();
// const ENDPOINT = process.env.REACT_APP_TASKS_API;
// const AUTH_ENDPOINT = process.env.REACT_APP_TASKS_API;
// const API_KEY = process.env.REACT_APP_API_KEY;
function $5a12233f233e4186$var$UserProvider({ children: children  }) {
    const [isAuthenticated, setIsAuthenticated] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const [authUpdated, setAuthUpdated] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(0);
    const [user, setUser] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState("");
    const [token, setToken] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(null);
    const [isAuthModalOpen, setIsAuthModalOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const [infiniteScrollToken, setInfiniteScrollToken] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(null);
    const [stats, setStats] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(null);
    const [name, setName] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState("");
    const fetchToken = async ()=>{
        try {
            const { tokens: tokens  } = await (0, $c68f73318e91dfc9$export$39430dfe49142ae)({
                forceRefresh: true
            });
            const idToken = tokens.idToken.toString();
            setToken(idToken);
        } catch (err) {
            setIsAuthenticated(false);
        }
    };
    (0, $43c5aabb14cdd515$export$2e2bcd8739ae039)(fetchToken, isAuthenticated ? 3600000 : null);
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        const getUserData = async ()=>{
            try {
                const { username: username , userId: userId , signInDetails: signInDetails  } = await (0, $a96a35a57f46b2c7$export$e5432d4c8eb97ea7)();
                const userAttributes = await (0, $b94443d14601a306$export$5dc95ecf3f16c6c9)();
                setIsAuthenticated(true);
                setUser(username);
                setName(userAttributes["given_name"]);
                const { tokens: tokens  } = await (0, $c68f73318e91dfc9$export$39430dfe49142ae)({
                    forceRefresh: true
                });
                const idToken = tokens.idToken.toString();
                setToken(idToken);
            } catch (err) {
                //
                setIsAuthenticated(false);
            }
        };
        getUserData();
    }, [
        authUpdated
    ]);
    // const deleteQuery = async (queryId) => {
    //   const oldQuery = userQueries.filter((query) => {
    //     return query.MATRIX_SHAREID.S === queryId;
    //   })[0];
    //   const oldUlid = oldQuery.MATRIX_ULID.S;
    //   setUserQueries((oldValue) => {
    //     return oldValue.filter((query) => {
    //       return query.MATRIX_SHAREID.S !== queryId;
    //     });
    //   });
    //   const URL = AUTH_ENDPOINT + `query?id=${queryId}&ulid=${oldUlid}`;
    //   const HEADERS = {
    //     'Content-Type': 'application/json',
    //     Authorization: token,
    //   };
    //   const request = new Request(URL, {
    //     method: 'DELETE',
    //     headers: HEADERS,
    //     timeout: 100000,
    //   });
    //   const response = await fetch(request);
    //   const json = await response.json();
    // };
    // const deleteSequence = async (sequenceId) => {
    //   const oldSequence = userSequences.filter((sequence) => {
    //     return sequence.id === sequenceId;
    //   })[0];
    //   const sequenceTitle = oldSequence.name;
    //   const payload = { title: sequenceTitle };
    //   const URL = AUTH_ENDPOINT + `sequence`;
    //   const HEADERS = {
    //     'Content-Type': 'application/json',
    //     Authorization: token,
    //   };
    //   const request = new Request(URL, {
    //     method: 'DELETE',
    //     headers: HEADERS,
    //     body: JSON.stringify(payload),
    //     timeout: 100000,
    //   });
    //   const response = await fetch(request);
    //   const json = await response.json();
    // };
    const handleLogout = async ()=>{
        try {
            await (0, $ce6bf905214da226$export$b0ac3a1c242cb1ea)();
            setIsAuthenticated(false);
            setUser("");
            setName("");
            setAuthUpdated((oldValue)=>oldValue + 1);
        } catch (err) {
        //
        }
    };
    const handleLogin = async (email, password)=>{
        try {
            const input = {
                username: email,
                password: password
            };
            const response = await (0, $8a12ffc5dc959a57$export$9670d83f11d4b64a)(input);
            setAuthUpdated((oldValue)=>oldValue + 1);
        } catch (err) {
        //
        }
    };
    const handleSignUp = async (email, password)=>{
        try {
            const input = {
                username: email,
                password: password,
                options: {
                    userAttributes: {
                        email: email
                    }
                }
            };
            const signUpResponse = await (0, $cbf5ba3463998b72$export$cf64224bcd829024)(input);
        } catch (err) {
        //
        }
    };
    const handleConfirmSignUp = async (email, code)=>{
        try {
            const { isSignUpComplete: isSignUpComplete , nextStep: nextStep  } = await (0, $9c3de9596e817bc7$export$2ce39ab6662e8c24)({
                username: email,
                confirmationCode: code
            });
            setAuthUpdated((oldValue)=>oldValue + 1);
        } catch (error) {
        //
        }
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($5a12233f233e4186$export$38ee920e59704589.Provider, {
        value: {
            isAuthenticated: isAuthenticated,
            setIsAuthenticated: setIsAuthenticated,
            user: user,
            handleLogout: handleLogout,
            handleLogin: handleLogin,
            handleSignUp: handleSignUp,
            handleConfirmSignUp: handleConfirmSignUp,
            isAuthModalOpen: isAuthModalOpen,
            setIsAuthModalOpen: setIsAuthModalOpen,
            token: token,
            stats: stats,
            name: name
        },
        children: children
    });
}
var $5a12233f233e4186$export$2e2bcd8739ae039 = $5a12233f233e4186$var$UserProvider;







var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");
// packages/core/primitive/src/primitive.tsx
function $93dfa6b8fe6a3629$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true  } = {}) {
    return function handleEvent(event) {
        originalEventHandler?.(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler?.(event);
    };
}


// packages/react/compose-refs/src/composeRefs.tsx

var $bh6RR = parcelRequire("bh6RR");
function $e52f713866128e60$var$setRef(ref, value) {
    if (typeof ref === "function") return ref(value);
    else if (ref !== null && ref !== void 0) ref.current = value;
}
function $e52f713866128e60$export$43e446d32b3d21af(...refs) {
    return (node)=>{
        let hasCleanup = false;
        const cleanups = refs.map((ref)=>{
            const cleanup = $e52f713866128e60$var$setRef(ref, node);
            if (!hasCleanup && typeof cleanup == "function") hasCleanup = true;
            return cleanup;
        });
        if (hasCleanup) return ()=>{
            for(let i = 0; i < cleanups.length; i++){
                const cleanup = cleanups[i];
                if (typeof cleanup == "function") cleanup();
                else $e52f713866128e60$var$setRef(refs[i], null);
            }
        };
    };
}
function $e52f713866128e60$export$c7b2cbe3552a0d05(...refs) {
    return $bh6RR.useCallback($e52f713866128e60$export$43e446d32b3d21af(...refs), refs);
}


// packages/react/context/src/createContext.tsx

var $bh6RR = parcelRequire("bh6RR");

function $1cecd1d75f085228$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = $bh6RR.createContext(defaultContext);
    const Provider = (props)=>{
        const { children: children , ...context } = props;
        const value = $bh6RR.useMemo(()=>context, Object.values(context));
        return /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)(Context.Provider, {
            value: value,
            children: children
        });
    };
    Provider.displayName = rootComponentName + "Provider";
    function useContext2(consumerName) {
        const context = $bh6RR.useContext(Context);
        if (context) return context;
        if (defaultContext !== void 0) return defaultContext;
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    return [
        Provider,
        useContext2
    ];
}
function $1cecd1d75f085228$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    function createContext3(rootComponentName, defaultContext) {
        const BaseContext = $bh6RR.createContext(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        const Provider = (props)=>{
            const { scope: scope , children: children , ...context } = props;
            const Context = scope?.[scopeName]?.[index] || BaseContext;
            const value = $bh6RR.useMemo(()=>context, Object.values(context));
            return /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)(Context.Provider, {
                value: value,
                children: children
            });
        };
        Provider.displayName = rootComponentName + "Provider";
        function useContext2(consumerName, scope) {
            const Context = scope?.[scopeName]?.[index] || BaseContext;
            const context = $bh6RR.useContext(Context);
            if (context) return context;
            if (defaultContext !== void 0) return defaultContext;
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        return [
            Provider,
            useContext2
        ];
    }
    const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return $bh6RR.createContext(defaultContext);
        });
        return function useScope(scope) {
            const contexts = scope?.[scopeName] || scopeContexts;
            return $bh6RR.useMemo(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        createContext3,
        $1cecd1d75f085228$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
function $1cecd1d75f085228$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope = ()=>{
        const scopeHooks = scopes.map((createScope2)=>({
                useScope: createScope2(),
                scopeName: createScope2.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes = scopeHooks.reduce((nextScopes2, { useScope: useScope , scopeName: scopeName  })=>{
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes2,
                    ...currentScope
                };
            }, {});
            return $bh6RR.useMemo(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes
                }), [
                nextScopes
            ]);
        };
    };
    createScope.scopeName = baseScope.scopeName;
    return createScope;
}


// packages/react/id/src/id.tsx

var $bh6RR = parcelRequire("bh6RR");
// packages/react/use-layout-effect/src/useLayoutEffect.tsx

var $bh6RR = parcelRequire("bh6RR");
var $8b7ab17803b8e6f8$export$e5c5a5f917a5871c = Boolean(globalThis?.document) ? $bh6RR.useLayoutEffect : ()=>{};


var $d172fcbd2da23bac$var$useReactId = $bh6RR["useId".toString()] || (()=>void 0);
var $d172fcbd2da23bac$var$count = 0;
function $d172fcbd2da23bac$export$f680877a34711e37(deterministicId) {
    const [id, setId] = $bh6RR.useState($d172fcbd2da23bac$var$useReactId());
    (0, $8b7ab17803b8e6f8$export$e5c5a5f917a5871c)(()=>{
        if (!deterministicId) setId((reactId)=>reactId ?? String($d172fcbd2da23bac$var$count++));
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : "");
}


// packages/react/use-controllable-state/src/useControllableState.tsx

var $bh6RR = parcelRequire("bh6RR");
// packages/react/use-callback-ref/src/useCallbackRef.tsx

var $bh6RR = parcelRequire("bh6RR");
function $c901973c35f9b07b$export$25bec8c6f54ee79a(callback) {
    const callbackRef = $bh6RR.useRef(callback);
    $bh6RR.useEffect(()=>{
        callbackRef.current = callback;
    });
    return $bh6RR.useMemo(()=>(...args)=>callbackRef.current?.(...args), []);
}


function $dfcfc7aa8980054c$export$6f32135080cb4c3({ prop: prop , defaultProp: defaultProp , onChange: onChange = ()=>{}  }) {
    const [uncontrolledProp, setUncontrolledProp] = $dfcfc7aa8980054c$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== void 0;
    const value = isControlled ? prop : uncontrolledProp;
    const handleChange = (0, $c901973c35f9b07b$export$25bec8c6f54ee79a)(onChange);
    const setValue = $bh6RR.useCallback((nextValue)=>{
        if (isControlled) {
            const setter = nextValue;
            const value2 = typeof nextValue === "function" ? setter(prop) : nextValue;
            if (value2 !== prop) handleChange(value2);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        handleChange
    ]);
    return [
        value,
        setValue
    ];
}
function $dfcfc7aa8980054c$var$useUncontrolledState({ defaultProp: defaultProp , onChange: onChange  }) {
    const uncontrolledState = $bh6RR.useState(defaultProp);
    const [value] = uncontrolledState;
    const prevValueRef = $bh6RR.useRef(value);
    const handleChange = (0, $c901973c35f9b07b$export$25bec8c6f54ee79a)(onChange);
    $bh6RR.useEffect(()=>{
        if (prevValueRef.current !== value) {
            handleChange(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef,
        handleChange
    ]);
    return uncontrolledState;
}



var $bh6RR = parcelRequire("bh6RR");

// packages/react/primitive/src/Primitive.tsx

var $bh6RR = parcelRequire("bh6RR");

// packages/react/slot/src/Slot.tsx

var $bh6RR = parcelRequire("bh6RR");


var $18fd289ffa468154$export$8c6ed5c666ac1360 = $bh6RR.forwardRef((props, forwardedRef)=>{
    const { children: children , ...slotProps } = props;
    const childrenArray = $bh6RR.Children.toArray(children);
    const slottable = childrenArray.find($18fd289ffa468154$var$isSlottable);
    if (slottable) {
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                if ($bh6RR.Children.count(newElement) > 1) return $bh6RR.Children.only(null);
                return $bh6RR.isValidElement(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)($18fd289ffa468154$var$SlotClone, {
            ...slotProps,
            ref: forwardedRef,
            children: $bh6RR.isValidElement(newElement) ? $bh6RR.cloneElement(newElement, void 0, newChildren) : null
        });
    }
    return /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)($18fd289ffa468154$var$SlotClone, {
        ...slotProps,
        ref: forwardedRef,
        children: children
    });
});
$18fd289ffa468154$export$8c6ed5c666ac1360.displayName = "Slot";
var $18fd289ffa468154$var$SlotClone = $bh6RR.forwardRef((props, forwardedRef)=>{
    const { children: children , ...slotProps } = props;
    if ($bh6RR.isValidElement(children)) {
        const childrenRef = $18fd289ffa468154$var$getElementRef(children);
        return $bh6RR.cloneElement(children, {
            ...$18fd289ffa468154$var$mergeProps(slotProps, children.props),
            // @ts-ignore
            ref: forwardedRef ? (0, $e52f713866128e60$export$43e446d32b3d21af)(forwardedRef, childrenRef) : childrenRef
        });
    }
    return $bh6RR.Children.count(children) > 1 ? $bh6RR.Children.only(null) : null;
});
$18fd289ffa468154$var$SlotClone.displayName = "SlotClone";
var $18fd289ffa468154$export$d9f1ccf0bdb05d45 = ({ children: children  })=>{
    return /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: children
    });
};
function $18fd289ffa468154$var$isSlottable(child) {
    return $bh6RR.isValidElement(child) && child.type === $18fd289ffa468154$export$d9f1ccf0bdb05d45;
}
function $18fd289ffa468154$var$mergeProps(slotProps, childProps) {
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                childPropValue(...args);
                slotPropValue(...args);
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
function $18fd289ffa468154$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}
var $18fd289ffa468154$export$be92b6f5f03c0fe9 = $18fd289ffa468154$export$8c6ed5c666ac1360;



var $793b1a0f4d9647b1$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "span",
    "svg",
    "ul"
];
var $793b1a0f4d9647b1$export$250ffa63cdc0d034 = $793b1a0f4d9647b1$var$NODES.reduce((primitive, node)=>{
    const Node = $bh6RR.forwardRef((props, forwardedRef)=>{
        const { asChild: asChild , ...primitiveProps } = props;
        const Comp = asChild ? (0, $18fd289ffa468154$export$8c6ed5c666ac1360) : node;
        if (typeof window !== "undefined") window[Symbol.for("radix-ui")] = true;
        return /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)(Comp, {
            ...primitiveProps,
            ref: forwardedRef
        });
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
function $793b1a0f4d9647b1$export$6d1a0317bde7de7f(target, event) {
    if (target) $47cfd4084854a574$exports.flushSync(()=>target.dispatchEvent(event));
}
var $793b1a0f4d9647b1$export$be92b6f5f03c0fe9 = $793b1a0f4d9647b1$export$250ffa63cdc0d034;




// packages/react/use-escape-keydown/src/useEscapeKeydown.tsx

var $bh6RR = parcelRequire("bh6RR");

function $879e0a3f7f60ef06$export$3a72a57244d6e765(onEscapeKeyDownProp, ownerDocument = globalThis?.document) {
    const onEscapeKeyDown = (0, $c901973c35f9b07b$export$25bec8c6f54ee79a)(onEscapeKeyDownProp);
    $bh6RR.useEffect(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") onEscapeKeyDown(event);
        };
        ownerDocument.addEventListener("keydown", handleKeyDown, {
            capture: true
        });
        return ()=>ownerDocument.removeEventListener("keydown", handleKeyDown, {
                capture: true
            });
    }, [
        onEscapeKeyDown,
        ownerDocument
    ]);
}



"use client";
var $8473b83e333b07d4$var$DISMISSABLE_LAYER_NAME = "DismissableLayer";
var $8473b83e333b07d4$var$CONTEXT_UPDATE = "dismissableLayer.update";
var $8473b83e333b07d4$var$POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
var $8473b83e333b07d4$var$FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
var $8473b83e333b07d4$var$originalBodyPointerEvents;
var $8473b83e333b07d4$var$DismissableLayerContext = $bh6RR.createContext({
    layers: /* @__PURE__ */ new Set(),
    layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
    branches: /* @__PURE__ */ new Set()
});
var $8473b83e333b07d4$export$177fb62ff3ec1f22 = $bh6RR.forwardRef((props, forwardedRef)=>{
    const { disableOutsidePointerEvents: disableOutsidePointerEvents = false , onEscapeKeyDown: onEscapeKeyDown , onPointerDownOutside: onPointerDownOutside , onFocusOutside: onFocusOutside , onInteractOutside: onInteractOutside , onDismiss: onDismiss , ...layerProps } = props;
    const context = $bh6RR.useContext($8473b83e333b07d4$var$DismissableLayerContext);
    const [node, setNode] = $bh6RR.useState(null);
    const ownerDocument = node?.ownerDocument ?? globalThis?.document;
    const [, force] = $bh6RR.useState({});
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, (node2)=>setNode(node2));
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [
        ...context.layersWithOutsidePointerEventsDisabled
    ].slice(-1);
    const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled);
    const index = node ? layers.indexOf(node) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const pointerDownOutside = $8473b83e333b07d4$var$usePointerDownOutside((event)=>{
        const target = event.target;
        const isPointerDownOnBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
        onPointerDownOutside?.(event);
        onInteractOutside?.(event);
        if (!event.defaultPrevented) onDismiss?.();
    }, ownerDocument);
    const focusOutside = $8473b83e333b07d4$var$useFocusOutside((event)=>{
        const target = event.target;
        const isFocusInBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (isFocusInBranch) return;
        onFocusOutside?.(event);
        onInteractOutside?.(event);
        if (!event.defaultPrevented) onDismiss?.();
    }, ownerDocument);
    (0, $879e0a3f7f60ef06$export$3a72a57244d6e765)((event)=>{
        const isHighestLayer = index === context.layers.size - 1;
        if (!isHighestLayer) return;
        onEscapeKeyDown?.(event);
        if (!event.defaultPrevented && onDismiss) {
            event.preventDefault();
            onDismiss();
        }
    }, ownerDocument);
    $bh6RR.useEffect(()=>{
        if (!node) return;
        if (disableOutsidePointerEvents) {
            if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
                $8473b83e333b07d4$var$originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
                ownerDocument.body.style.pointerEvents = "none";
            }
            context.layersWithOutsidePointerEventsDisabled.add(node);
        }
        context.layers.add(node);
        $8473b83e333b07d4$var$dispatchUpdate();
        return ()=>{
            if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) ownerDocument.body.style.pointerEvents = $8473b83e333b07d4$var$originalBodyPointerEvents;
        };
    }, [
        node,
        ownerDocument,
        disableOutsidePointerEvents,
        context
    ]);
    $bh6RR.useEffect(()=>{
        return ()=>{
            if (!node) return;
            context.layers.delete(node);
            context.layersWithOutsidePointerEventsDisabled.delete(node);
            $8473b83e333b07d4$var$dispatchUpdate();
        };
    }, [
        node,
        context
    ]);
    $bh6RR.useEffect(()=>{
        const handleUpdate = ()=>force({});
        document.addEventListener($8473b83e333b07d4$var$CONTEXT_UPDATE, handleUpdate);
        return ()=>document.removeEventListener($8473b83e333b07d4$var$CONTEXT_UPDATE, handleUpdate);
    }, []);
    return /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, {
        ...layerProps,
        ref: composedRefs,
        style: {
            pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : void 0,
            ...props.style
        },
        onFocusCapture: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
    });
});
$8473b83e333b07d4$export$177fb62ff3ec1f22.displayName = $8473b83e333b07d4$var$DISMISSABLE_LAYER_NAME;
var $8473b83e333b07d4$var$BRANCH_NAME = "DismissableLayerBranch";
var $8473b83e333b07d4$export$4d5eb2109db14228 = $bh6RR.forwardRef((props, forwardedRef)=>{
    const context = $bh6RR.useContext($8473b83e333b07d4$var$DismissableLayerContext);
    const ref = $bh6RR.useRef(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    $bh6RR.useEffect(()=>{
        const node = ref.current;
        if (node) {
            context.branches.add(node);
            return ()=>{
                context.branches.delete(node);
            };
        }
    }, [
        context.branches
    ]);
    return /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, {
        ...props,
        ref: composedRefs
    });
});
$8473b83e333b07d4$export$4d5eb2109db14228.displayName = $8473b83e333b07d4$var$BRANCH_NAME;
function $8473b83e333b07d4$var$usePointerDownOutside(onPointerDownOutside, ownerDocument = globalThis?.document) {
    const handlePointerDownOutside = (0, $c901973c35f9b07b$export$25bec8c6f54ee79a)(onPointerDownOutside);
    const isPointerInsideReactTreeRef = $bh6RR.useRef(false);
    const handleClickRef = $bh6RR.useRef(()=>{});
    $bh6RR.useEffect(()=>{
        const handlePointerDown = (event)=>{
            if (event.target && !isPointerInsideReactTreeRef.current) {
                let handleAndDispatchPointerDownOutsideEvent2 = function() {
                    $8473b83e333b07d4$var$handleAndDispatchCustomEvent($8473b83e333b07d4$var$POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
                        discrete: true
                    });
                };
                var handleAndDispatchPointerDownOutsideEvent = handleAndDispatchPointerDownOutsideEvent2;
                const eventDetail = {
                    originalEvent: event
                };
                if (event.pointerType === "touch") {
                    ownerDocument.removeEventListener("click", handleClickRef.current);
                    handleClickRef.current = handleAndDispatchPointerDownOutsideEvent2;
                    ownerDocument.addEventListener("click", handleClickRef.current, {
                        once: true
                    });
                } else handleAndDispatchPointerDownOutsideEvent2();
            } else ownerDocument.removeEventListener("click", handleClickRef.current);
            isPointerInsideReactTreeRef.current = false;
        };
        const timerId = window.setTimeout(()=>{
            ownerDocument.addEventListener("pointerdown", handlePointerDown);
        }, 0);
        return ()=>{
            window.clearTimeout(timerId);
            ownerDocument.removeEventListener("pointerdown", handlePointerDown);
            ownerDocument.removeEventListener("click", handleClickRef.current);
        };
    }, [
        ownerDocument,
        handlePointerDownOutside
    ]);
    return {
        // ensures we check React component tree (not just DOM tree)
        onPointerDownCapture: ()=>isPointerInsideReactTreeRef.current = true
    };
}
function $8473b83e333b07d4$var$useFocusOutside(onFocusOutside, ownerDocument = globalThis?.document) {
    const handleFocusOutside = (0, $c901973c35f9b07b$export$25bec8c6f54ee79a)(onFocusOutside);
    const isFocusInsideReactTreeRef = $bh6RR.useRef(false);
    $bh6RR.useEffect(()=>{
        const handleFocus = (event)=>{
            if (event.target && !isFocusInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                $8473b83e333b07d4$var$handleAndDispatchCustomEvent($8473b83e333b07d4$var$FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
                    discrete: false
                });
            }
        };
        ownerDocument.addEventListener("focusin", handleFocus);
        return ()=>ownerDocument.removeEventListener("focusin", handleFocus);
    }, [
        ownerDocument,
        handleFocusOutside
    ]);
    return {
        onFocusCapture: ()=>isFocusInsideReactTreeRef.current = true,
        onBlurCapture: ()=>isFocusInsideReactTreeRef.current = false
    };
}
function $8473b83e333b07d4$var$dispatchUpdate() {
    const event = new CustomEvent($8473b83e333b07d4$var$CONTEXT_UPDATE);
    document.dispatchEvent(event);
}
function $8473b83e333b07d4$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete: discrete  }) {
    const target = detail.originalEvent.target;
    const event = new CustomEvent(name, {
        bubbles: false,
        cancelable: true,
        detail: detail
    });
    if (handler) target.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0, $793b1a0f4d9647b1$export$6d1a0317bde7de7f)(target, event);
    else target.dispatchEvent(event);
}
var $8473b83e333b07d4$export$be92b6f5f03c0fe9 = $8473b83e333b07d4$export$177fb62ff3ec1f22;
var $8473b83e333b07d4$export$aecb2ddcb55c95be = $8473b83e333b07d4$export$4d5eb2109db14228;



var $bh6RR = parcelRequire("bh6RR");




"use client";
var $0757534448b5e4bf$var$AUTOFOCUS_ON_MOUNT = "focusScope.autoFocusOnMount";
var $0757534448b5e4bf$var$AUTOFOCUS_ON_UNMOUNT = "focusScope.autoFocusOnUnmount";
var $0757534448b5e4bf$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
var $0757534448b5e4bf$var$FOCUS_SCOPE_NAME = "FocusScope";
var $0757534448b5e4bf$export$20e40289641fbbb6 = $bh6RR.forwardRef((props, forwardedRef)=>{
    const { loop: loop = false , trapped: trapped = false , onMountAutoFocus: onMountAutoFocusProp , onUnmountAutoFocus: onUnmountAutoFocusProp , ...scopeProps } = props;
    const [container, setContainer] = $bh6RR.useState(null);
    const onMountAutoFocus = (0, $c901973c35f9b07b$export$25bec8c6f54ee79a)(onMountAutoFocusProp);
    const onUnmountAutoFocus = (0, $c901973c35f9b07b$export$25bec8c6f54ee79a)(onUnmountAutoFocusProp);
    const lastFocusedElementRef = $bh6RR.useRef(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContainer(node));
    const focusScope = $bh6RR.useRef({
        paused: false,
        pause () {
            this.paused = true;
        },
        resume () {
            this.paused = false;
        }
    }).current;
    $bh6RR.useEffect(()=>{
        if (trapped) {
            let handleFocusIn2 = function(event) {
                if (focusScope.paused || !container) return;
                const target = event.target;
                if (container.contains(target)) lastFocusedElementRef.current = target;
                else $0757534448b5e4bf$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }, handleFocusOut2 = function(event) {
                if (focusScope.paused || !container) return;
                const relatedTarget = event.relatedTarget;
                if (relatedTarget === null) return;
                if (!container.contains(relatedTarget)) $0757534448b5e4bf$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }, handleMutations2 = function(mutations) {
                const focusedElement = document.activeElement;
                if (focusedElement !== document.body) return;
                for (const mutation of mutations)if (mutation.removedNodes.length > 0) $0757534448b5e4bf$var$focus(container);
            };
            var handleFocusIn = handleFocusIn2, handleFocusOut = handleFocusOut2, handleMutations = handleMutations2;
            document.addEventListener("focusin", handleFocusIn2);
            document.addEventListener("focusout", handleFocusOut2);
            const mutationObserver = new MutationObserver(handleMutations2);
            if (container) mutationObserver.observe(container, {
                childList: true,
                subtree: true
            });
            return ()=>{
                document.removeEventListener("focusin", handleFocusIn2);
                document.removeEventListener("focusout", handleFocusOut2);
                mutationObserver.disconnect();
            };
        }
    }, [
        trapped,
        container,
        focusScope.paused
    ]);
    $bh6RR.useEffect(()=>{
        if (container) {
            $0757534448b5e4bf$var$focusScopesStack.add(focusScope);
            const previouslyFocusedElement = document.activeElement;
            const hasFocusedCandidate = container.contains(previouslyFocusedElement);
            if (!hasFocusedCandidate) {
                const mountEvent = new CustomEvent($0757534448b5e4bf$var$AUTOFOCUS_ON_MOUNT, $0757534448b5e4bf$var$EVENT_OPTIONS);
                container.addEventListener($0757534448b5e4bf$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                container.dispatchEvent(mountEvent);
                if (!mountEvent.defaultPrevented) {
                    $0757534448b5e4bf$var$focusFirst($0757534448b5e4bf$var$removeLinks($0757534448b5e4bf$var$getTabbableCandidates(container)), {
                        select: true
                    });
                    if (document.activeElement === previouslyFocusedElement) $0757534448b5e4bf$var$focus(container);
                }
            }
            return ()=>{
                container.removeEventListener($0757534448b5e4bf$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                setTimeout(()=>{
                    const unmountEvent = new CustomEvent($0757534448b5e4bf$var$AUTOFOCUS_ON_UNMOUNT, $0757534448b5e4bf$var$EVENT_OPTIONS);
                    container.addEventListener($0757534448b5e4bf$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    container.dispatchEvent(unmountEvent);
                    if (!unmountEvent.defaultPrevented) $0757534448b5e4bf$var$focus(previouslyFocusedElement ?? document.body, {
                        select: true
                    });
                    container.removeEventListener($0757534448b5e4bf$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    $0757534448b5e4bf$var$focusScopesStack.remove(focusScope);
                }, 0);
            };
        }
    }, [
        container,
        onMountAutoFocus,
        onUnmountAutoFocus,
        focusScope
    ]);
    const handleKeyDown = $bh6RR.useCallback((event)=>{
        if (!loop && !trapped) return;
        if (focusScope.paused) return;
        const isTabKey = event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey;
        const focusedElement = document.activeElement;
        if (isTabKey && focusedElement) {
            const container2 = event.currentTarget;
            const [first, last] = $0757534448b5e4bf$var$getTabbableEdges(container2);
            const hasTabbableElementsInside = first && last;
            if (!hasTabbableElementsInside) {
                if (focusedElement === container2) event.preventDefault();
            } else {
                if (!event.shiftKey && focusedElement === last) {
                    event.preventDefault();
                    if (loop) $0757534448b5e4bf$var$focus(first, {
                        select: true
                    });
                } else if (event.shiftKey && focusedElement === first) {
                    event.preventDefault();
                    if (loop) $0757534448b5e4bf$var$focus(last, {
                        select: true
                    });
                }
            }
        }
    }, [
        loop,
        trapped,
        focusScope.paused
    ]);
    return /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, {
        tabIndex: -1,
        ...scopeProps,
        ref: composedRefs,
        onKeyDown: handleKeyDown
    });
});
$0757534448b5e4bf$export$20e40289641fbbb6.displayName = $0757534448b5e4bf$var$FOCUS_SCOPE_NAME;
function $0757534448b5e4bf$var$focusFirst(candidates, { select: select = false  } = {}) {
    const previouslyFocusedElement = document.activeElement;
    for (const candidate of candidates){
        $0757534448b5e4bf$var$focus(candidate, {
            select: select
        });
        if (document.activeElement !== previouslyFocusedElement) return;
    }
}
function $0757534448b5e4bf$var$getTabbableEdges(container) {
    const candidates = $0757534448b5e4bf$var$getTabbableCandidates(container);
    const first = $0757534448b5e4bf$var$findVisible(candidates, container);
    const last = $0757534448b5e4bf$var$findVisible(candidates.reverse(), container);
    return [
        first,
        last
    ];
}
function $0757534448b5e4bf$var$getTabbableCandidates(container) {
    const nodes = [];
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: (node)=>{
            const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP;
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode);
    return nodes;
}
function $0757534448b5e4bf$var$findVisible(elements, container) {
    for (const element of elements){
        if (!$0757534448b5e4bf$var$isHidden(element, {
            upTo: container
        })) return element;
    }
}
function $0757534448b5e4bf$var$isHidden(node, { upTo: upTo  }) {
    if (getComputedStyle(node).visibility === "hidden") return true;
    while(node){
        if (upTo !== void 0 && node === upTo) return false;
        if (getComputedStyle(node).display === "none") return true;
        node = node.parentElement;
    }
    return false;
}
function $0757534448b5e4bf$var$isSelectableInput(element) {
    return element instanceof HTMLInputElement && "select" in element;
}
function $0757534448b5e4bf$var$focus(element, { select: select = false  } = {}) {
    if (element && element.focus) {
        const previouslyFocusedElement = document.activeElement;
        element.focus({
            preventScroll: true
        });
        if (element !== previouslyFocusedElement && $0757534448b5e4bf$var$isSelectableInput(element) && select) element.select();
    }
}
var $0757534448b5e4bf$var$focusScopesStack = $0757534448b5e4bf$var$createFocusScopesStack();
function $0757534448b5e4bf$var$createFocusScopesStack() {
    let stack = [];
    return {
        add (focusScope) {
            const activeFocusScope = stack[0];
            if (focusScope !== activeFocusScope) activeFocusScope?.pause();
            stack = $0757534448b5e4bf$var$arrayRemove(stack, focusScope);
            stack.unshift(focusScope);
        },
        remove (focusScope) {
            stack = $0757534448b5e4bf$var$arrayRemove(stack, focusScope);
            stack[0]?.resume();
        }
    };
}
function $0757534448b5e4bf$var$arrayRemove(array, item) {
    const updatedArray = [
        ...array
    ];
    const index = updatedArray.indexOf(item);
    if (index !== -1) updatedArray.splice(index, 1);
    return updatedArray;
}
function $0757534448b5e4bf$var$removeLinks(items) {
    return items.filter((item)=>item.tagName !== "A");
}
var $0757534448b5e4bf$export$be92b6f5f03c0fe9 = $0757534448b5e4bf$export$20e40289641fbbb6;



var $bh6RR = parcelRequire("bh6RR");




"use client";
var $252b3d40eb00b07a$var$PORTAL_NAME = "Portal";
var $252b3d40eb00b07a$export$602eac185826482c = $bh6RR.forwardRef((props, forwardedRef)=>{
    const { container: containerProp , ...portalProps } = props;
    const [mounted, setMounted] = $bh6RR.useState(false);
    (0, $8b7ab17803b8e6f8$export$e5c5a5f917a5871c)(()=>setMounted(true), []);
    const container = containerProp || mounted && globalThis?.document?.body;
    return container ? (0, (/*@__PURE__*/$parcel$interopDefault($47cfd4084854a574$exports))).createPortal(/* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, {
        ...portalProps,
        ref: forwardedRef
    }), container) : null;
});
$252b3d40eb00b07a$export$602eac185826482c.displayName = $252b3d40eb00b07a$var$PORTAL_NAME;
var $252b3d40eb00b07a$export$be92b6f5f03c0fe9 = $252b3d40eb00b07a$export$602eac185826482c;



var $bh6RR = parcelRequire("bh6RR");


"use client";
function $e651d1dc516f7371$var$useStateMachine(initialState, machine) {
    return $bh6RR.useReducer((state, event)=>{
        const nextState = machine[state][event];
        return nextState ?? state;
    }, initialState);
}
// packages/react/presence/src/Presence.tsx
var $e651d1dc516f7371$export$99c2b779aa4e8b8b = (props)=>{
    const { present: present , children: children  } = props;
    const presence = $e651d1dc516f7371$var$usePresence(present);
    const child = typeof children === "function" ? children({
        present: presence.isPresent
    }) : $bh6RR.Children.only(children);
    const ref = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(presence.ref, $e651d1dc516f7371$var$getElementRef(child));
    const forceMount = typeof children === "function";
    return forceMount || presence.isPresent ? $bh6RR.cloneElement(child, {
        ref: ref
    }) : null;
};
$e651d1dc516f7371$export$99c2b779aa4e8b8b.displayName = "Presence";
function $e651d1dc516f7371$var$usePresence(present) {
    const [node, setNode] = $bh6RR.useState();
    const stylesRef = $bh6RR.useRef({});
    const prevPresentRef = $bh6RR.useRef(present);
    const prevAnimationNameRef = $bh6RR.useRef("none");
    const initialState = present ? "mounted" : "unmounted";
    const [state, send] = $e651d1dc516f7371$var$useStateMachine(initialState, {
        mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
        },
        unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
        },
        unmounted: {
            MOUNT: "mounted"
        }
    });
    $bh6RR.useEffect(()=>{
        const currentAnimationName = $e651d1dc516f7371$var$getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === "mounted" ? currentAnimationName : "none";
    }, [
        state
    ]);
    (0, $8b7ab17803b8e6f8$export$e5c5a5f917a5871c)(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = $e651d1dc516f7371$var$getAnimationName(styles);
            if (present) send("MOUNT");
            else if (currentAnimationName === "none" || styles?.display === "none") send("UNMOUNT");
            else {
                const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send("ANIMATION_OUT");
                else send("UNMOUNT");
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    (0, $8b7ab17803b8e6f8$export$e5c5a5f917a5871c)(()=>{
        if (node) {
            let timeoutId;
            const ownerWindow = node.ownerDocument.defaultView ?? window;
            const handleAnimationEnd = (event)=>{
                const currentAnimationName = $e651d1dc516f7371$var$getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(event.animationName);
                if (event.target === node && isCurrentAnimation) {
                    send("ANIMATION_END");
                    if (!prevPresentRef.current) {
                        const currentFillMode = node.style.animationFillMode;
                        node.style.animationFillMode = "forwards";
                        timeoutId = ownerWindow.setTimeout(()=>{
                            if (node.style.animationFillMode === "forwards") node.style.animationFillMode = currentFillMode;
                        });
                    }
                }
            };
            const handleAnimationStart = (event)=>{
                if (event.target === node) prevAnimationNameRef.current = $e651d1dc516f7371$var$getAnimationName(stylesRef.current);
            };
            node.addEventListener("animationstart", handleAnimationStart);
            node.addEventListener("animationcancel", handleAnimationEnd);
            node.addEventListener("animationend", handleAnimationEnd);
            return ()=>{
                ownerWindow.clearTimeout(timeoutId);
                node.removeEventListener("animationstart", handleAnimationStart);
                node.removeEventListener("animationcancel", handleAnimationEnd);
                node.removeEventListener("animationend", handleAnimationEnd);
            };
        } else send("ANIMATION_END");
    }, [
        node,
        send
    ]);
    return {
        isPresent: [
            "mounted",
            "unmountSuspended"
        ].includes(state),
        ref: $bh6RR.useCallback((node2)=>{
            if (node2) stylesRef.current = getComputedStyle(node2);
            setNode(node2);
        }, [])
    };
}
function $e651d1dc516f7371$var$getAnimationName(styles) {
    return styles?.animationName || "none";
}
function $e651d1dc516f7371$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}




var $bh6RR = parcelRequire("bh6RR");
"use client";
var $39ae7ab2790868b6$var$count = 0;
function $39ae7ab2790868b6$export$ac5b58043b79449b(props) {
    $39ae7ab2790868b6$export$b7ece24a22aeda8c();
    return props.children;
}
function $39ae7ab2790868b6$export$b7ece24a22aeda8c() {
    $bh6RR.useEffect(()=>{
        const edgeGuards = document.querySelectorAll("[data-radix-focus-guard]");
        document.body.insertAdjacentElement("afterbegin", edgeGuards[0] ?? $39ae7ab2790868b6$var$createFocusGuard());
        document.body.insertAdjacentElement("beforeend", edgeGuards[1] ?? $39ae7ab2790868b6$var$createFocusGuard());
        $39ae7ab2790868b6$var$count++;
        return ()=>{
            if ($39ae7ab2790868b6$var$count === 1) document.querySelectorAll("[data-radix-focus-guard]").forEach((node)=>node.remove());
            $39ae7ab2790868b6$var$count--;
        };
    }, []);
}
function $39ae7ab2790868b6$var$createFocusGuard() {
    const element = document.createElement("span");
    element.setAttribute("data-radix-focus-guard", "");
    element.tabIndex = 0;
    element.style.outline = "none";
    element.style.opacity = "0";
    element.style.position = "fixed";
    element.style.pointerEvents = "none";
    return element;
}
var $39ae7ab2790868b6$export$be92b6f5f03c0fe9 = $39ae7ab2790868b6$export$ac5b58043b79449b;




var $bh6RR = parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");
var $dbb3c33b31cdcfb1$export$1da7500147d4bc3 = "right-scroll-bar-position";
var $dbb3c33b31cdcfb1$export$898e37bbd2a0ae4e = "width-before-scroll-bar";
var $dbb3c33b31cdcfb1$export$bb813dfbbc432abc = "with-scroll-bars-hidden";
var $dbb3c33b31cdcfb1$export$63d0edf80fea83b1 = "--removed-body-scroll-bar-size";



var $bh6RR = parcelRequire("bh6RR");
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $83a050b8f7e61fc1$export$d734136a7b018efe(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
    return ref;
}



var $bh6RR = parcelRequire("bh6RR");
function $bcea459d6fe13dac$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $bh6RR.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}


var $59e9bf7262dc1a6d$var$useIsomorphicLayoutEffect = typeof window !== "undefined" ? $bh6RR.useLayoutEffect : $bh6RR.useEffect;
var $59e9bf7262dc1a6d$var$currentValues = new WeakMap();
function $59e9bf7262dc1a6d$export$74665b213cb5c4cf(refs, defaultValue) {
    var callbackRef = (0, $bcea459d6fe13dac$export$25bec8c6f54ee79a)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $83a050b8f7e61fc1$export$d734136a7b018efe)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    $59e9bf7262dc1a6d$var$useIsomorphicLayoutEffect(function() {
        var oldValue = $59e9bf7262dc1a6d$var$currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, $83a050b8f7e61fc1$export$d734136a7b018efe)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, $83a050b8f7e61fc1$export$d734136a7b018efe)(ref, current_1);
            });
        }
        $59e9bf7262dc1a6d$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}



function $0647093a1b1c5afc$var$ItoI(a) {
    return a;
}
function $0647093a1b1c5afc$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $0647093a1b1c5afc$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $0647093a1b1c5afc$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $0647093a1b1c5afc$var$ItoI;
    return $0647093a1b1c5afc$var$innerCreateMedium(defaults, middleware);
}
function $0647093a1b1c5afc$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $0647093a1b1c5afc$var$innerCreateMedium(null);
    medium.options = (0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)({
        async: true,
        ssr: false
    }, options);
    return medium;
}


var $1e32631777ba14da$export$e27363444bedfeac = (0, $0647093a1b1c5afc$export$e13ec7dd7a14088d)();


var $1c1f9cd94bee4822$var$nothing = function() {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */ var $1c1f9cd94bee4822$export$22940b497e769dee = $bh6RR.forwardRef(function(props, parentRef) {
    var ref = $bh6RR.useRef(null);
    var _a = $bh6RR.useState({
        onScrollCapture: $1c1f9cd94bee4822$var$nothing,
        onWheelCapture: $1c1f9cd94bee4822$var$nothing,
        onTouchMoveCapture: $1c1f9cd94bee4822$var$nothing
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? "div" : _b, gapMode = props.gapMode, rest = (0, $f5ed4ab2a4d1861b$export$3c9a16f847548506)(props, [
        "forwardProps",
        "children",
        "className",
        "removeScrollBar",
        "enabled",
        "shards",
        "sideCar",
        "noIsolation",
        "inert",
        "allowPinchZoom",
        "as",
        "gapMode"
    ]);
    var SideCar = sideCar;
    var containerRef = (0, $59e9bf7262dc1a6d$export$74665b213cb5c4cf)([
        ref,
        parentRef
    ]);
    var containerProps = (0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)((0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)({}, rest), callbacks);
    return $bh6RR.createElement($bh6RR.Fragment, null, enabled && $bh6RR.createElement(SideCar, {
        sideCar: (0, $1e32631777ba14da$export$e27363444bedfeac),
        removeScrollBar: removeScrollBar,
        shards: shards,
        noIsolation: noIsolation,
        inert: inert,
        setCallbacks: setCallbacks,
        allowPinchZoom: !!allowPinchZoom,
        lockRef: ref,
        gapMode: gapMode
    }), forwardProps ? $bh6RR.cloneElement($bh6RR.Children.only(children), (0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)((0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)({}, containerProps), {
        ref: containerRef
    })) : $bh6RR.createElement(Container, (0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)({}, containerProps, {
        className: className,
        ref: containerRef
    }), children));
});
$1c1f9cd94bee4822$export$22940b497e769dee.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false
};
$1c1f9cd94bee4822$export$22940b497e769dee.classNames = {
    fullWidth: (0, $dbb3c33b31cdcfb1$export$898e37bbd2a0ae4e),
    zeroRight: (0, $dbb3c33b31cdcfb1$export$1da7500147d4bc3)
};




var $bh6RR = parcelRequire("bh6RR");
var $db1654befbc8d676$var$SideCar = function(_a) {
    var sideCar = _a.sideCar, rest = (0, $f5ed4ab2a4d1861b$export$3c9a16f847548506)(_a, [
        "sideCar"
    ]);
    if (!sideCar) throw new Error("Sidecar: please provide `sideCar` property to import the right car");
    var Target = sideCar.read();
    if (!Target) throw new Error("Sidecar medium not found");
    return $bh6RR.createElement(Target, (0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)({}, rest));
};
$db1654befbc8d676$var$SideCar.isSideCarExport = true;
function $db1654befbc8d676$export$6cacc8fb0a9b94ce(medium, exported) {
    medium.useMedium(exported);
    return $db1654befbc8d676$var$SideCar;
}




var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");
var $c1a97cf4bee7a747$var$currentNonce;
var $c1a97cf4bee7a747$export$c5f670b24c0ae95a = function(nonce) {
    $c1a97cf4bee7a747$var$currentNonce = nonce;
};
var $c1a97cf4bee7a747$export$2b85b721e524d74b = function() {
    if ($c1a97cf4bee7a747$var$currentNonce) return $c1a97cf4bee7a747$var$currentNonce;
    if (typeof __webpack_nonce__ !== "undefined") return __webpack_nonce__;
    return undefined;
};


function $ec0bd1fbc8093bb3$var$makeStyleTag() {
    if (!document) return null;
    var tag = document.createElement("style");
    tag.type = "text/css";
    var nonce = (0, $c1a97cf4bee7a747$export$2b85b721e524d74b)();
    if (nonce) tag.setAttribute("nonce", nonce);
    return tag;
}
function $ec0bd1fbc8093bb3$var$injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) // @ts-ignore
    tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $ec0bd1fbc8093bb3$var$insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName("head")[0];
    head.appendChild(tag);
}
var $ec0bd1fbc8093bb3$export$7c74eec858d5d226 = function() {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function(style) {
            if (counter == 0) {
                if (stylesheet = $ec0bd1fbc8093bb3$var$makeStyleTag()) {
                    $ec0bd1fbc8093bb3$var$injectStyles(stylesheet, style);
                    $ec0bd1fbc8093bb3$var$insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function() {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        }
    };
};


var $388d9750a20580a4$export$7d7b35c2d250e94c = function() {
    var sheet = (0, $ec0bd1fbc8093bb3$export$7c74eec858d5d226)();
    return function(styles, isDynamic) {
        $bh6RR.useEffect(function() {
            sheet.add(styles);
            return function() {
                sheet.remove();
            };
        }, [
            styles && isDynamic
        ]);
    };
};


var $8f0cc34b8d78d287$export$c1248ee86ba532c8 = function() {
    var useStyle = (0, $388d9750a20580a4$export$7d7b35c2d250e94c)();
    var Sheet = function(_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};







var $c24b64e0e48f5c2b$export$efed13b5d0ca3386 = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
};
var $c24b64e0e48f5c2b$var$parse = function(x) {
    return parseInt(x || "", 10) || 0;
};
var $c24b64e0e48f5c2b$var$getOffset = function(gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === "padding" ? "paddingLeft" : "marginLeft"];
    var top = cs[gapMode === "padding" ? "paddingTop" : "marginTop"];
    var right = cs[gapMode === "padding" ? "paddingRight" : "marginRight"];
    return [
        $c24b64e0e48f5c2b$var$parse(left),
        $c24b64e0e48f5c2b$var$parse(top),
        $c24b64e0e48f5c2b$var$parse(right)
    ];
};
var $c24b64e0e48f5c2b$export$75f2ca8f029c77f4 = function(gapMode) {
    if (gapMode === void 0) gapMode = "margin";
    if (typeof window === "undefined") return $c24b64e0e48f5c2b$export$efed13b5d0ca3386;
    var offsets = $c24b64e0e48f5c2b$var$getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
    };
};


var $a1bca04d3c994e31$var$Style = (0, $8f0cc34b8d78d287$export$c1248ee86ba532c8)();
var $a1bca04d3c994e31$export$65254d5f26cb9564 = "data-scroll-locked";
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var $a1bca04d3c994e31$var$getStyles = function(_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) gapMode = "margin";
    return "\n  .".concat((0, $dbb3c33b31cdcfb1$export$bb813dfbbc432abc), " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body[").concat($a1bca04d3c994e31$export$65254d5f26cb9564, "] {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === "margin" && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === "padding" && "padding-right: ".concat(gap, "px ").concat(important, ";")
    ].filter(Boolean).join(""), "\n  }\n  \n  .").concat((0, $dbb3c33b31cdcfb1$export$1da7500147d4bc3), " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $dbb3c33b31cdcfb1$export$898e37bbd2a0ae4e), " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $dbb3c33b31cdcfb1$export$1da7500147d4bc3), " .").concat((0, $dbb3c33b31cdcfb1$export$1da7500147d4bc3), " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat((0, $dbb3c33b31cdcfb1$export$898e37bbd2a0ae4e), " .").concat((0, $dbb3c33b31cdcfb1$export$898e37bbd2a0ae4e), " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body[").concat($a1bca04d3c994e31$export$65254d5f26cb9564, "] {\n    ").concat((0, $dbb3c33b31cdcfb1$export$63d0edf80fea83b1), ": ").concat(gap, "px;\n  }\n");
};
var $a1bca04d3c994e31$var$getCurrentUseCounter = function() {
    var counter = parseInt(document.body.getAttribute($a1bca04d3c994e31$export$65254d5f26cb9564) || "0", 10);
    return isFinite(counter) ? counter : 0;
};
var $a1bca04d3c994e31$export$a1939b1f9f9b02dc = function() {
    $bh6RR.useEffect(function() {
        document.body.setAttribute($a1bca04d3c994e31$export$65254d5f26cb9564, ($a1bca04d3c994e31$var$getCurrentUseCounter() + 1).toString());
        return function() {
            var newCounter = $a1bca04d3c994e31$var$getCurrentUseCounter() - 1;
            if (newCounter <= 0) document.body.removeAttribute($a1bca04d3c994e31$export$65254d5f26cb9564);
            else document.body.setAttribute($a1bca04d3c994e31$export$65254d5f26cb9564, newCounter.toString());
        };
    }, []);
};
var $a1bca04d3c994e31$export$9aa43b459c5ae9b9 = function(_a) {
    var noRelative = _a.noRelative, noImportant = _a.noImportant, _b = _a.gapMode, gapMode = _b === void 0 ? "margin" : _b;
    $a1bca04d3c994e31$export$a1939b1f9f9b02dc();
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */ var gap = $bh6RR.useMemo(function() {
        return (0, $c24b64e0e48f5c2b$export$75f2ca8f029c77f4)(gapMode);
    }, [
        gapMode
    ]);
    return $bh6RR.createElement($a1bca04d3c994e31$var$Style, {
        styles: $a1bca04d3c994e31$var$getStyles(gap, !noRelative, gapMode, !noImportant ? "!important" : "")
    });
};







var $c3d5eca92c5827bc$var$passiveSupported = false;
if (typeof window !== "undefined") try {
    var $c3d5eca92c5827bc$var$options = Object.defineProperty({}, "passive", {
        get: function() {
            $c3d5eca92c5827bc$var$passiveSupported = true;
            return true;
        }
    });
    // @ts-ignore
    window.addEventListener("test", $c3d5eca92c5827bc$var$options, $c3d5eca92c5827bc$var$options);
    // @ts-ignore
    window.removeEventListener("test", $c3d5eca92c5827bc$var$options, $c3d5eca92c5827bc$var$options);
} catch (err) {
    $c3d5eca92c5827bc$var$passiveSupported = false;
}
var $c3d5eca92c5827bc$export$10a6e88623fa9454 = $c3d5eca92c5827bc$var$passiveSupported ? {
    passive: false
} : false;


var $b2f037382e9b8811$var$alwaysContainsScroll = function(node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === "TEXTAREA";
};
var $b2f037382e9b8811$var$elementCanBeScrolled = function(node, overflow) {
    if (!(node instanceof Element)) return false;
    var styles = window.getComputedStyle(node);
    return(// not-not-scrollable
    styles[overflow] !== "hidden" && // contains scroll inside self
    !(styles.overflowY === styles.overflowX && !$b2f037382e9b8811$var$alwaysContainsScroll(node) && styles[overflow] === "visible"));
};
var $b2f037382e9b8811$var$elementCouldBeVScrolled = function(node) {
    return $b2f037382e9b8811$var$elementCanBeScrolled(node, "overflowY");
};
var $b2f037382e9b8811$var$elementCouldBeHScrolled = function(node) {
    return $b2f037382e9b8811$var$elementCanBeScrolled(node, "overflowX");
};
var $b2f037382e9b8811$export$9ec64480cae49817 = function(axis, node) {
    var ownerDocument = node.ownerDocument;
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== "undefined" && current instanceof ShadowRoot) current = current.host;
        var isScrollable = $b2f037382e9b8811$var$elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = $b2f037382e9b8811$var$getScrollVariables(axis, current), scrollHeight = _a[1], clientHeight = _a[2];
            if (scrollHeight > clientHeight) return true;
        }
        current = current.parentNode;
    }while (current && current !== ownerDocument.body);
    return false;
};
var $b2f037382e9b8811$var$getVScrollVariables = function(_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight
    ];
};
var $b2f037382e9b8811$var$getHScrollVariables = function(_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth
    ];
};
var $b2f037382e9b8811$var$elementCouldBeScrolled = function(axis, node) {
    return axis === "v" ? $b2f037382e9b8811$var$elementCouldBeVScrolled(node) : $b2f037382e9b8811$var$elementCouldBeHScrolled(node);
};
var $b2f037382e9b8811$var$getScrollVariables = function(axis, node) {
    return axis === "v" ? $b2f037382e9b8811$var$getVScrollVariables(node) : $b2f037382e9b8811$var$getHScrollVariables(node);
};
var $b2f037382e9b8811$var$getDirectionFactor = function(axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */ return axis === "h" && direction === "rtl" ? -1 : 1;
};
var $b2f037382e9b8811$export$dde0441bd4a6ded8 = function(axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = $b2f037382e9b8811$var$getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        var _a = $b2f037382e9b8811$var$getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if ($b2f037382e9b8811$var$elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        if (target instanceof ShadowRoot) target = target.host;
        else target = target.parentNode;
    }while (// portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target));
    // handle epsilon around 0 (non standard zoom levels)
    if (isDeltaPositive && (noOverscroll && Math.abs(availableScroll) < 1 || !noOverscroll && delta > availableScroll)) shouldCancelScroll = true;
    else if (!isDeltaPositive && (noOverscroll && Math.abs(availableScrollTop) < 1 || !noOverscroll && -delta > availableScrollTop)) shouldCancelScroll = true;
    return shouldCancelScroll;
};


var $0012650a668228df$export$6e085704a79f4f56 = function(event) {
    return "changedTouches" in event ? [
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
    ] : [
        0,
        0
    ];
};
var $0012650a668228df$export$39efaa2ca254a28d = function(event) {
    return [
        event.deltaX,
        event.deltaY
    ];
};
var $0012650a668228df$var$extractRef = function(ref) {
    return ref && "current" in ref ? ref.current : ref;
};
var $0012650a668228df$var$deltaCompare = function(x, y) {
    return x[0] === y[0] && x[1] === y[1];
};
var $0012650a668228df$var$generateStyle = function(id) {
    return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var $0012650a668228df$var$idCounter = 0;
var $0012650a668228df$var$lockStack = [];
function $0012650a668228df$export$a09dbff87b5da2d(props) {
    var shouldPreventQueue = $bh6RR.useRef([]);
    var touchStartRef = $bh6RR.useRef([
        0,
        0
    ]);
    var activeAxis = $bh6RR.useRef();
    var id = $bh6RR.useState($0012650a668228df$var$idCounter++)[0];
    var Style = $bh6RR.useState((0, $8f0cc34b8d78d287$export$c1248ee86ba532c8))[0];
    var lastProps = $bh6RR.useRef(props);
    $bh6RR.useEffect(function() {
        lastProps.current = props;
    }, [
        props
    ]);
    $bh6RR.useEffect(function() {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0, $f5ed4ab2a4d1861b$export$1216008129fb82ed)([
                props.lockRef.current
            ], (props.shards || []).map($0012650a668228df$var$extractRef), true).filter(Boolean);
            allow_1.forEach(function(el) {
                return el.classList.add("allow-interactivity-".concat(id));
            });
            return function() {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function(el) {
                    return el.classList.remove("allow-interactivity-".concat(id));
                });
            };
        }
        return;
    }, [
        props.inert,
        props.lockRef.current,
        props.shards
    ]);
    var shouldCancelEvent = $bh6RR.useCallback(function(event, parent) {
        if ("touches" in event && event.touches.length === 2 || event.type === "wheel" && event.ctrlKey) return !lastProps.current.allowPinchZoom;
        var touch = $0012650a668228df$export$6e085704a79f4f56(event);
        var touchStart = touchStartRef.current;
        var deltaX = "deltaX" in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = "deltaY" in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? "h" : "v";
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ("touches" in event && moveDirection === "h" && target.type === "range") return false;
        var canBeScrolledInMainDirection = (0, $b2f037382e9b8811$export$9ec64480cae49817)(moveDirection, target);
        if (!canBeScrolledInMainDirection) return true;
        if (canBeScrolledInMainDirection) currentAxis = moveDirection;
        else {
            currentAxis = moveDirection === "v" ? "h" : "v";
            canBeScrolledInMainDirection = (0, $b2f037382e9b8811$export$9ec64480cae49817)(moveDirection, target);
        // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) return false;
        if (!activeAxis.current && "changedTouches" in event && (deltaX || deltaY)) activeAxis.current = currentAxis;
        if (!currentAxis) return true;
        var cancelingAxis = activeAxis.current || currentAxis;
        return (0, $b2f037382e9b8811$export$dde0441bd4a6ded8)(cancelingAxis, parent, event, cancelingAxis === "h" ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = $bh6RR.useCallback(function(_event) {
        var event = _event;
        if (!$0012650a668228df$var$lockStack.length || $0012650a668228df$var$lockStack[$0012650a668228df$var$lockStack.length - 1] !== Style) // not the last active
        return;
        var delta = "deltaY" in event ? $0012650a668228df$export$39efaa2ca254a28d(event) : $0012650a668228df$export$6e085704a79f4f56(event);
        var sourceEvent = shouldPreventQueue.current.filter(function(e) {
            return e.name === event.type && (e.target === event.target || event.target === e.shadowParent) && $0012650a668228df$var$deltaCompare(e.delta, delta);
        })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) event.preventDefault();
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || []).map($0012650a668228df$var$extractRef).filter(Boolean).filter(function(node) {
                return node.contains(event.target);
            });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) event.preventDefault();
            }
        }
    }, []);
    var shouldCancel = $bh6RR.useCallback(function(name, delta, target, should) {
        var event = {
            name: name,
            delta: delta,
            target: target,
            should: should,
            shadowParent: $0012650a668228df$var$getOutermostShadowParent(target)
        };
        shouldPreventQueue.current.push(event);
        setTimeout(function() {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
                return e !== event;
            });
        }, 1);
    }, []);
    var scrollTouchStart = $bh6RR.useCallback(function(event) {
        touchStartRef.current = $0012650a668228df$export$6e085704a79f4f56(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = $bh6RR.useCallback(function(event) {
        shouldCancel(event.type, $0012650a668228df$export$39efaa2ca254a28d(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = $bh6RR.useCallback(function(event) {
        shouldCancel(event.type, $0012650a668228df$export$6e085704a79f4f56(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    $bh6RR.useEffect(function() {
        $0012650a668228df$var$lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove
        });
        document.addEventListener("wheel", shouldPrevent, (0, $c3d5eca92c5827bc$export$10a6e88623fa9454));
        document.addEventListener("touchmove", shouldPrevent, (0, $c3d5eca92c5827bc$export$10a6e88623fa9454));
        document.addEventListener("touchstart", scrollTouchStart, (0, $c3d5eca92c5827bc$export$10a6e88623fa9454));
        return function() {
            $0012650a668228df$var$lockStack = $0012650a668228df$var$lockStack.filter(function(inst) {
                return inst !== Style;
            });
            document.removeEventListener("wheel", shouldPrevent, (0, $c3d5eca92c5827bc$export$10a6e88623fa9454));
            document.removeEventListener("touchmove", shouldPrevent, (0, $c3d5eca92c5827bc$export$10a6e88623fa9454));
            document.removeEventListener("touchstart", scrollTouchStart, (0, $c3d5eca92c5827bc$export$10a6e88623fa9454));
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return $bh6RR.createElement($bh6RR.Fragment, null, inert ? $bh6RR.createElement(Style, {
        styles: $0012650a668228df$var$generateStyle(id)
    }) : null, removeScrollBar ? $bh6RR.createElement((0, $a1bca04d3c994e31$export$9aa43b459c5ae9b9), {
        gapMode: props.gapMode
    }) : null);
}
function $0012650a668228df$var$getOutermostShadowParent(node) {
    var shadowParent = null;
    while(node !== null){
        if (node instanceof ShadowRoot) {
            shadowParent = node.host;
            node = node.host;
        }
        node = node.parentNode;
    }
    return shadowParent;
}



var $32fbe4a10a756a07$export$2e2bcd8739ae039 = (0, $db1654befbc8d676$export$6cacc8fb0a9b94ce)((0, $1e32631777ba14da$export$e27363444bedfeac), (0, $0012650a668228df$export$a09dbff87b5da2d));


var $2a904e957609af53$var$ReactRemoveScroll = $bh6RR.forwardRef(function(props, ref) {
    return $bh6RR.createElement((0, $1c1f9cd94bee4822$export$22940b497e769dee), (0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)({}, props, {
        ref: ref,
        sideCar: (0, $32fbe4a10a756a07$export$2e2bcd8739ae039)
    }));
});
$2a904e957609af53$var$ReactRemoveScroll.classNames = (0, $1c1f9cd94bee4822$export$22940b497e769dee).classNames;
var $2a904e957609af53$export$2e2bcd8739ae039 = $2a904e957609af53$var$ReactRemoveScroll;


var $43e375177e5001c1$var$getDefaultParent = function(originalTarget) {
    if (typeof document === "undefined") return null;
    var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
    return sampleTarget.ownerDocument.body;
};
var $43e375177e5001c1$var$counterMap = new WeakMap();
var $43e375177e5001c1$var$uncontrolledNodes = new WeakMap();
var $43e375177e5001c1$var$markerMap = {};
var $43e375177e5001c1$var$lockCount = 0;
var $43e375177e5001c1$var$unwrapHost = function(node) {
    return node && (node.host || $43e375177e5001c1$var$unwrapHost(node.parentNode));
};
var $43e375177e5001c1$var$correctTargets = function(parent, targets) {
    return targets.map(function(target) {
        if (parent.contains(target)) return target;
        var correctedTarget = $43e375177e5001c1$var$unwrapHost(target);
        if (correctedTarget && parent.contains(correctedTarget)) return correctedTarget;
        console.error("aria-hidden", target, "in not contained inside", parent, ". Doing nothing");
        return null;
    }).filter(function(x) {
        return Boolean(x);
    });
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @param {String} [controlAttribute] - html Attribute to control
 * @return {Undo} undo command
 */ var $43e375177e5001c1$var$applyAttributeToOthers = function(originalTarget, parentNode, markerName, controlAttribute) {
    var targets = $43e375177e5001c1$var$correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    if (!$43e375177e5001c1$var$markerMap[markerName]) $43e375177e5001c1$var$markerMap[markerName] = new WeakMap();
    var markerCounter = $43e375177e5001c1$var$markerMap[markerName];
    var hiddenNodes = [];
    var elementsToKeep = new Set();
    var elementsToStop = new Set(targets);
    var keep = function(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        keep(el.parentNode);
    };
    targets.forEach(keep);
    var deep = function(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        Array.prototype.forEach.call(parent.children, function(node) {
            if (elementsToKeep.has(node)) deep(node);
            else try {
                var attr = node.getAttribute(controlAttribute);
                var alreadyHidden = attr !== null && attr !== "false";
                var counterValue = ($43e375177e5001c1$var$counterMap.get(node) || 0) + 1;
                var markerValue = (markerCounter.get(node) || 0) + 1;
                $43e375177e5001c1$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenNodes.push(node);
                if (counterValue === 1 && alreadyHidden) $43e375177e5001c1$var$uncontrolledNodes.set(node, true);
                if (markerValue === 1) node.setAttribute(markerName, "true");
                if (!alreadyHidden) node.setAttribute(controlAttribute, "true");
            } catch (e) {
                console.error("aria-hidden: cannot operate on ", node, e);
            }
        });
    };
    deep(parentNode);
    elementsToKeep.clear();
    $43e375177e5001c1$var$lockCount++;
    return function() {
        hiddenNodes.forEach(function(node) {
            var counterValue = $43e375177e5001c1$var$counterMap.get(node) - 1;
            var markerValue = markerCounter.get(node) - 1;
            $43e375177e5001c1$var$counterMap.set(node, counterValue);
            markerCounter.set(node, markerValue);
            if (!counterValue) {
                if (!$43e375177e5001c1$var$uncontrolledNodes.has(node)) node.removeAttribute(controlAttribute);
                $43e375177e5001c1$var$uncontrolledNodes.delete(node);
            }
            if (!markerValue) node.removeAttribute(markerName);
        });
        $43e375177e5001c1$var$lockCount--;
        if (!$43e375177e5001c1$var$lockCount) {
            // clear
            $43e375177e5001c1$var$counterMap = new WeakMap();
            $43e375177e5001c1$var$counterMap = new WeakMap();
            $43e375177e5001c1$var$uncontrolledNodes = new WeakMap();
            $43e375177e5001c1$var$markerMap = {};
        }
    };
};
var $43e375177e5001c1$export$6e33d16126ed003c = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-aria-hidden";
    var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    var activeParentNode = parentNode || $43e375177e5001c1$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    // we should not hide ariaLive elements - https://github.com/theKashey/aria-hidden/issues/10
    targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll("[aria-live]")));
    return $43e375177e5001c1$var$applyAttributeToOthers(targets, activeParentNode, markerName, "aria-hidden");
};
var $43e375177e5001c1$export$59151cc8db999a24 = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-inert-ed";
    var activeParentNode = parentNode || $43e375177e5001c1$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    return $43e375177e5001c1$var$applyAttributeToOthers(originalTarget, activeParentNode, markerName, "inert");
};
var $43e375177e5001c1$export$cc95fea82d705fca = function() {
    return typeof HTMLElement !== "undefined" && HTMLElement.prototype.hasOwnProperty("inert");
};
var $43e375177e5001c1$export$9845d4b6bdad192b = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-suppressed";
    return ($43e375177e5001c1$export$cc95fea82d705fca() ? $43e375177e5001c1$export$59151cc8db999a24 : $43e375177e5001c1$export$6e33d16126ed003c)(originalTarget, parentNode, markerName);
};




"use client";
var $919b3aedf69a16e5$var$DIALOG_NAME = "Dialog";
var [$919b3aedf69a16e5$var$createDialogContext, $919b3aedf69a16e5$export$cc702773b8ea3e41] = (0, $1cecd1d75f085228$export$50c7b4e9d9f19c1)($919b3aedf69a16e5$var$DIALOG_NAME);
var [$919b3aedf69a16e5$var$DialogProvider, $919b3aedf69a16e5$var$useDialogContext] = $919b3aedf69a16e5$var$createDialogContext($919b3aedf69a16e5$var$DIALOG_NAME);
var $919b3aedf69a16e5$export$3ddf2d174ce01153 = (props)=>{
    const { __scopeDialog: __scopeDialog , children: children , open: openProp , defaultOpen: defaultOpen , onOpenChange: onOpenChange , modal: modal = true  } = props;
    const triggerRef = $bh6RR.useRef(null);
    const contentRef = $bh6RR.useRef(null);
    const [open = false, setOpen] = (0, $dfcfc7aa8980054c$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)($919b3aedf69a16e5$var$DialogProvider, {
        scope: __scopeDialog,
        triggerRef: triggerRef,
        contentRef: contentRef,
        contentId: (0, $d172fcbd2da23bac$export$f680877a34711e37)(),
        titleId: (0, $d172fcbd2da23bac$export$f680877a34711e37)(),
        descriptionId: (0, $d172fcbd2da23bac$export$f680877a34711e37)(),
        open: open,
        onOpenChange: setOpen,
        onOpenToggle: $bh6RR.useCallback(()=>setOpen((prevOpen)=>!prevOpen), [
            setOpen
        ]),
        modal: modal,
        children: children
    });
};
$919b3aedf69a16e5$export$3ddf2d174ce01153.displayName = $919b3aedf69a16e5$var$DIALOG_NAME;
var $919b3aedf69a16e5$var$TRIGGER_NAME = "DialogTrigger";
var $919b3aedf69a16e5$export$2e1e1122cf0cba88 = $bh6RR.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , ...triggerProps } = props;
    const context = $919b3aedf69a16e5$var$useDialogContext($919b3aedf69a16e5$var$TRIGGER_NAME, __scopeDialog);
    const composedTriggerRef = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, context.triggerRef);
    return /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).button, {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.contentId,
        "data-state": $919b3aedf69a16e5$var$getState(context.open),
        ...triggerProps,
        ref: composedTriggerRef,
        onClick: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onClick, context.onOpenToggle)
    });
});
$919b3aedf69a16e5$export$2e1e1122cf0cba88.displayName = $919b3aedf69a16e5$var$TRIGGER_NAME;
var $919b3aedf69a16e5$var$PORTAL_NAME = "DialogPortal";
var [$919b3aedf69a16e5$var$PortalProvider, $919b3aedf69a16e5$var$usePortalContext] = $919b3aedf69a16e5$var$createDialogContext($919b3aedf69a16e5$var$PORTAL_NAME, {
    forceMount: void 0
});
var $919b3aedf69a16e5$export$dad7c95542bacce0 = (props)=>{
    const { __scopeDialog: __scopeDialog , forceMount: forceMount , children: children , container: container  } = props;
    const context = $919b3aedf69a16e5$var$useDialogContext($919b3aedf69a16e5$var$PORTAL_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)($919b3aedf69a16e5$var$PortalProvider, {
        scope: __scopeDialog,
        forceMount: forceMount,
        children: $bh6RR.Children.map(children, (child)=>/* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)((0, $e651d1dc516f7371$export$99c2b779aa4e8b8b), {
                present: forceMount || context.open,
                children: /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)((0, $252b3d40eb00b07a$export$602eac185826482c), {
                    asChild: true,
                    container: container,
                    children: child
                })
            }))
    });
};
$919b3aedf69a16e5$export$dad7c95542bacce0.displayName = $919b3aedf69a16e5$var$PORTAL_NAME;
var $919b3aedf69a16e5$var$OVERLAY_NAME = "DialogOverlay";
var $919b3aedf69a16e5$export$bd1d06c79be19e17 = $bh6RR.forwardRef((props, forwardedRef)=>{
    const portalContext = $919b3aedf69a16e5$var$usePortalContext($919b3aedf69a16e5$var$OVERLAY_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount , ...overlayProps } = props;
    const context = $919b3aedf69a16e5$var$useDialogContext($919b3aedf69a16e5$var$OVERLAY_NAME, props.__scopeDialog);
    return context.modal ? /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)((0, $e651d1dc516f7371$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open,
        children: /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)($919b3aedf69a16e5$var$DialogOverlayImpl, {
            ...overlayProps,
            ref: forwardedRef
        })
    }) : null;
});
$919b3aedf69a16e5$export$bd1d06c79be19e17.displayName = $919b3aedf69a16e5$var$OVERLAY_NAME;
var $919b3aedf69a16e5$var$DialogOverlayImpl = $bh6RR.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , ...overlayProps } = props;
    const context = $919b3aedf69a16e5$var$useDialogContext($919b3aedf69a16e5$var$OVERLAY_NAME, __scopeDialog);
    return(// Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
    // ie. when `Overlay` and `Content` are siblings
    /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)((0, $2a904e957609af53$export$2e2bcd8739ae039), {
        as: (0, $18fd289ffa468154$export$8c6ed5c666ac1360),
        allowPinchZoom: true,
        shards: [
            context.contentRef
        ],
        children: /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, {
            "data-state": $919b3aedf69a16e5$var$getState(context.open),
            ...overlayProps,
            ref: forwardedRef,
            style: {
                pointerEvents: "auto",
                ...overlayProps.style
            }
        })
    }));
});
var $919b3aedf69a16e5$var$CONTENT_NAME = "DialogContent";
var $919b3aedf69a16e5$export$b6d9565de1e068cf = $bh6RR.forwardRef((props, forwardedRef)=>{
    const portalContext = $919b3aedf69a16e5$var$usePortalContext($919b3aedf69a16e5$var$CONTENT_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount , ...contentProps } = props;
    const context = $919b3aedf69a16e5$var$useDialogContext($919b3aedf69a16e5$var$CONTENT_NAME, props.__scopeDialog);
    return /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)((0, $e651d1dc516f7371$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open,
        children: context.modal ? /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)($919b3aedf69a16e5$var$DialogContentModal, {
            ...contentProps,
            ref: forwardedRef
        }) : /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)($919b3aedf69a16e5$var$DialogContentNonModal, {
            ...contentProps,
            ref: forwardedRef
        })
    });
});
$919b3aedf69a16e5$export$b6d9565de1e068cf.displayName = $919b3aedf69a16e5$var$CONTENT_NAME;
var $919b3aedf69a16e5$var$DialogContentModal = $bh6RR.forwardRef((props, forwardedRef)=>{
    const context = $919b3aedf69a16e5$var$useDialogContext($919b3aedf69a16e5$var$CONTENT_NAME, props.__scopeDialog);
    const contentRef = $bh6RR.useRef(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, context.contentRef, contentRef);
    $bh6RR.useEffect(()=>{
        const content = contentRef.current;
        if (content) return (0, $43e375177e5001c1$export$6e33d16126ed003c)(content);
    }, []);
    return /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)($919b3aedf69a16e5$var$DialogContentImpl, {
        ...props,
        ref: composedRefs,
        trapFocus: context.open,
        disableOutsidePointerEvents: true,
        onCloseAutoFocus: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onCloseAutoFocus, (event)=>{
            event.preventDefault();
            context.triggerRef.current?.focus();
        }),
        onPointerDownOutside: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onPointerDownOutside, (event)=>{
            const originalEvent = event.detail.originalEvent;
            const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
            if (isRightClick) event.preventDefault();
        }),
        onFocusOutside: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onFocusOutside, (event)=>event.preventDefault())
    });
});
var $919b3aedf69a16e5$var$DialogContentNonModal = $bh6RR.forwardRef((props, forwardedRef)=>{
    const context = $919b3aedf69a16e5$var$useDialogContext($919b3aedf69a16e5$var$CONTENT_NAME, props.__scopeDialog);
    const hasInteractedOutsideRef = $bh6RR.useRef(false);
    const hasPointerDownOutsideRef = $bh6RR.useRef(false);
    return /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)($919b3aedf69a16e5$var$DialogContentImpl, {
        ...props,
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: (event)=>{
            props.onCloseAutoFocus?.(event);
            if (!event.defaultPrevented) {
                if (!hasInteractedOutsideRef.current) context.triggerRef.current?.focus();
                event.preventDefault();
            }
            hasInteractedOutsideRef.current = false;
            hasPointerDownOutsideRef.current = false;
        },
        onInteractOutside: (event)=>{
            props.onInteractOutside?.(event);
            if (!event.defaultPrevented) {
                hasInteractedOutsideRef.current = true;
                if (event.detail.originalEvent.type === "pointerdown") hasPointerDownOutsideRef.current = true;
            }
            const target = event.target;
            const targetIsTrigger = context.triggerRef.current?.contains(target);
            if (targetIsTrigger) event.preventDefault();
            if (event.detail.originalEvent.type === "focusin" && hasPointerDownOutsideRef.current) event.preventDefault();
        }
    });
});
var $919b3aedf69a16e5$var$DialogContentImpl = $bh6RR.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , trapFocus: trapFocus , onOpenAutoFocus: onOpenAutoFocus , onCloseAutoFocus: onCloseAutoFocus , ...contentProps } = props;
    const context = $919b3aedf69a16e5$var$useDialogContext($919b3aedf69a16e5$var$CONTENT_NAME, __scopeDialog);
    const contentRef = $bh6RR.useRef(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, contentRef);
    (0, $39ae7ab2790868b6$export$b7ece24a22aeda8c)();
    return /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)((0, $0757534448b5e4bf$export$20e40289641fbbb6), {
                asChild: true,
                loop: true,
                trapped: trapFocus,
                onMountAutoFocus: onOpenAutoFocus,
                onUnmountAutoFocus: onCloseAutoFocus,
                children: /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)((0, $8473b83e333b07d4$export$177fb62ff3ec1f22), {
                    role: "dialog",
                    id: context.contentId,
                    "aria-describedby": context.descriptionId,
                    "aria-labelledby": context.titleId,
                    "data-state": $919b3aedf69a16e5$var$getState(context.open),
                    ...contentProps,
                    ref: composedRefs,
                    onDismiss: ()=>context.onOpenChange(false)
                })
            }),
            /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                children: [
                    /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)($919b3aedf69a16e5$var$TitleWarning, {
                        titleId: context.titleId
                    }),
                    /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)($919b3aedf69a16e5$var$DescriptionWarning, {
                        contentRef: contentRef,
                        descriptionId: context.descriptionId
                    })
                ]
            })
        ]
    });
});
var $919b3aedf69a16e5$var$TITLE_NAME = "DialogTitle";
var $919b3aedf69a16e5$export$16f7638e4a34b909 = $bh6RR.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , ...titleProps } = props;
    const context = $919b3aedf69a16e5$var$useDialogContext($919b3aedf69a16e5$var$TITLE_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).h2, {
        id: context.titleId,
        ...titleProps,
        ref: forwardedRef
    });
});
$919b3aedf69a16e5$export$16f7638e4a34b909.displayName = $919b3aedf69a16e5$var$TITLE_NAME;
var $919b3aedf69a16e5$var$DESCRIPTION_NAME = "DialogDescription";
var $919b3aedf69a16e5$export$94e94c2ec2c954d5 = $bh6RR.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , ...descriptionProps } = props;
    const context = $919b3aedf69a16e5$var$useDialogContext($919b3aedf69a16e5$var$DESCRIPTION_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).p, {
        id: context.descriptionId,
        ...descriptionProps,
        ref: forwardedRef
    });
});
$919b3aedf69a16e5$export$94e94c2ec2c954d5.displayName = $919b3aedf69a16e5$var$DESCRIPTION_NAME;
var $919b3aedf69a16e5$var$CLOSE_NAME = "DialogClose";
var $919b3aedf69a16e5$export$fba2fb7cd781b7ac = $bh6RR.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , ...closeProps } = props;
    const context = $919b3aedf69a16e5$var$useDialogContext($919b3aedf69a16e5$var$CLOSE_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).button, {
        type: "button",
        ...closeProps,
        ref: forwardedRef,
        onClick: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onClick, ()=>context.onOpenChange(false))
    });
});
$919b3aedf69a16e5$export$fba2fb7cd781b7ac.displayName = $919b3aedf69a16e5$var$CLOSE_NAME;
function $919b3aedf69a16e5$var$getState(open) {
    return open ? "open" : "closed";
}
var $919b3aedf69a16e5$var$TITLE_WARNING_NAME = "DialogTitleWarning";
var [$919b3aedf69a16e5$export$69b62a49393917d6, $919b3aedf69a16e5$var$useWarningContext] = (0, $1cecd1d75f085228$export$fd42f52fd3ae1109)($919b3aedf69a16e5$var$TITLE_WARNING_NAME, {
    contentName: $919b3aedf69a16e5$var$CONTENT_NAME,
    titleName: $919b3aedf69a16e5$var$TITLE_NAME,
    docsSlug: "dialog"
});
var $919b3aedf69a16e5$var$TitleWarning = ({ titleId: titleId  })=>{
    const titleWarningContext = $919b3aedf69a16e5$var$useWarningContext($919b3aedf69a16e5$var$TITLE_WARNING_NAME);
    const MESSAGE = `\`${titleWarningContext.contentName}\` requires a \`${titleWarningContext.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${titleWarningContext.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${titleWarningContext.docsSlug}`;
    $bh6RR.useEffect(()=>{
        if (titleId) {
            const hasTitle = document.getElementById(titleId);
            if (!hasTitle) console.error(MESSAGE);
        }
    }, [
        MESSAGE,
        titleId
    ]);
    return null;
};
var $919b3aedf69a16e5$var$DESCRIPTION_WARNING_NAME = "DialogDescriptionWarning";
var $919b3aedf69a16e5$var$DescriptionWarning = ({ contentRef: contentRef , descriptionId: descriptionId  })=>{
    const descriptionWarningContext = $919b3aedf69a16e5$var$useWarningContext($919b3aedf69a16e5$var$DESCRIPTION_WARNING_NAME);
    const MESSAGE = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${descriptionWarningContext.contentName}}.`;
    $bh6RR.useEffect(()=>{
        const describedById = contentRef.current?.getAttribute("aria-describedby");
        if (descriptionId && describedById) {
            const hasDescription = document.getElementById(descriptionId);
            if (!hasDescription) console.warn(MESSAGE);
        }
    }, [
        MESSAGE,
        contentRef,
        descriptionId
    ]);
    return null;
};
var $919b3aedf69a16e5$export$be92b6f5f03c0fe9 = $919b3aedf69a16e5$export$3ddf2d174ce01153;
var $919b3aedf69a16e5$export$41fb9f06171c75f4 = $919b3aedf69a16e5$export$2e1e1122cf0cba88;
var $919b3aedf69a16e5$export$602eac185826482c = $919b3aedf69a16e5$export$dad7c95542bacce0;
var $919b3aedf69a16e5$export$c6fdb837b070b4ff = $919b3aedf69a16e5$export$bd1d06c79be19e17;
var $919b3aedf69a16e5$export$7c6e2c02157bb7d2 = $919b3aedf69a16e5$export$b6d9565de1e068cf;
var $919b3aedf69a16e5$export$f99233281efd08a0 = $919b3aedf69a16e5$export$16f7638e4a34b909;
var $919b3aedf69a16e5$export$393edc798c47379d = $919b3aedf69a16e5$export$94e94c2ec2c954d5;
var $919b3aedf69a16e5$export$f39c2d165cd861fe = $919b3aedf69a16e5$export$fba2fb7cd781b7ac;






var $bh6RR = parcelRequire("bh6RR");



var $bh6RR = parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");




"use client";
function $c43a6ccc42422c95$export$c74125a8e3af6bb2(name) {
    const PROVIDER_NAME = name + "CollectionProvider";
    const [createCollectionContext, createCollectionScope] = (0, $1cecd1d75f085228$export$50c7b4e9d9f19c1)(PROVIDER_NAME);
    const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
        collectionRef: {
            current: null
        },
        itemMap: /* @__PURE__ */ new Map()
    });
    const CollectionProvider = (props)=>{
        const { scope: scope , children: children  } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(null);
        const itemMap = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(/* @__PURE__ */ new Map()).current;
        return /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)(CollectionProviderImpl, {
            scope: scope,
            itemMap: itemMap,
            collectionRef: ref,
            children: children
        });
    };
    CollectionProvider.displayName = PROVIDER_NAME;
    const COLLECTION_SLOT_NAME = name + "CollectionSlot";
    const CollectionSlot = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef((props, forwardedRef)=>{
        const { scope: scope , children: children  } = props;
        const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
        const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, context.collectionRef);
        return /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)((0, $18fd289ffa468154$export$8c6ed5c666ac1360), {
            ref: composedRefs,
            children: children
        });
    });
    CollectionSlot.displayName = COLLECTION_SLOT_NAME;
    const ITEM_SLOT_NAME = name + "CollectionItemSlot";
    const ITEM_DATA_ATTR = "data-radix-collection-item";
    const CollectionItemSlot = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef((props, forwardedRef)=>{
        const { scope: scope , children: children , ...itemData } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(null);
        const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, ref);
        const context = useCollectionContext(ITEM_SLOT_NAME, scope);
        (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
            context.itemMap.set(ref, {
                ref: ref,
                ...itemData
            });
            return ()=>void context.itemMap.delete(ref);
        });
        return /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)((0, $18fd289ffa468154$export$8c6ed5c666ac1360), {
            [ITEM_DATA_ATTR]: "",
            ref: composedRefs,
            children: children
        });
    });
    CollectionItemSlot.displayName = ITEM_SLOT_NAME;
    function useCollection(scope) {
        const context = useCollectionContext(name + "CollectionConsumer", scope);
        const getItems = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useCallback(()=>{
            const collectionNode = context.collectionRef.current;
            if (!collectionNode) return [];
            const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
            const items = Array.from(context.itemMap.values());
            const orderedItems = items.sort((a, b)=>orderedNodes.indexOf(a.ref.current) - orderedNodes.indexOf(b.ref.current));
            return orderedItems;
        }, [
            context.collectionRef,
            context.itemMap
        ]);
        return getItems;
    }
    return [
        {
            Provider: CollectionProvider,
            Slot: CollectionSlot,
            ItemSlot: CollectionItemSlot
        },
        useCollection,
        createCollectionScope
    ];
}








// packages/react/direction/src/Direction.tsx

var $bh6RR = parcelRequire("bh6RR");

var $4ac4e2f5e0780c9a$var$DirectionContext = $bh6RR.createContext(void 0);
var $4ac4e2f5e0780c9a$export$c760c09fdd558351 = (props)=>{
    const { dir: dir , children: children  } = props;
    return /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)($4ac4e2f5e0780c9a$var$DirectionContext.Provider, {
        value: dir,
        children: children
    });
};
function $4ac4e2f5e0780c9a$export$b39126d51d94e6f3(localDir) {
    const globalDir = $bh6RR.useContext($4ac4e2f5e0780c9a$var$DirectionContext);
    return localDir || globalDir || "ltr";
}
var $4ac4e2f5e0780c9a$export$2881499e37b75b9a = $4ac4e2f5e0780c9a$export$c760c09fdd558351;



"use client";
var $1a384a7578ffd5f3$var$ENTRY_FOCUS = "rovingFocusGroup.onEntryFocus";
var $1a384a7578ffd5f3$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
var $1a384a7578ffd5f3$var$GROUP_NAME = "RovingFocusGroup";
var [$1a384a7578ffd5f3$var$Collection, $1a384a7578ffd5f3$var$useCollection, $1a384a7578ffd5f3$var$createCollectionScope] = (0, $c43a6ccc42422c95$export$c74125a8e3af6bb2)($1a384a7578ffd5f3$var$GROUP_NAME);
var [$1a384a7578ffd5f3$var$createRovingFocusGroupContext, $1a384a7578ffd5f3$export$c7109489551a4f4] = (0, $1cecd1d75f085228$export$50c7b4e9d9f19c1)($1a384a7578ffd5f3$var$GROUP_NAME, [
    $1a384a7578ffd5f3$var$createCollectionScope
]);
var [$1a384a7578ffd5f3$var$RovingFocusProvider, $1a384a7578ffd5f3$var$useRovingFocusContext] = $1a384a7578ffd5f3$var$createRovingFocusGroupContext($1a384a7578ffd5f3$var$GROUP_NAME);
var $1a384a7578ffd5f3$export$8699f7c8af148338 = $bh6RR.forwardRef((props, forwardedRef)=>{
    return /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)($1a384a7578ffd5f3$var$Collection.Provider, {
        scope: props.__scopeRovingFocusGroup,
        children: /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)($1a384a7578ffd5f3$var$Collection.Slot, {
            scope: props.__scopeRovingFocusGroup,
            children: /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)($1a384a7578ffd5f3$var$RovingFocusGroupImpl, {
                ...props,
                ref: forwardedRef
            })
        })
    });
});
$1a384a7578ffd5f3$export$8699f7c8af148338.displayName = $1a384a7578ffd5f3$var$GROUP_NAME;
var $1a384a7578ffd5f3$var$RovingFocusGroupImpl = $bh6RR.forwardRef((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup , orientation: orientation , loop: loop = false , dir: dir , currentTabStopId: currentTabStopIdProp , defaultCurrentTabStopId: defaultCurrentTabStopId , onCurrentTabStopIdChange: onCurrentTabStopIdChange , onEntryFocus: onEntryFocus , preventScrollOnEntryFocus: preventScrollOnEntryFocus = false , ...groupProps } = props;
    const ref = $bh6RR.useRef(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const direction = (0, $4ac4e2f5e0780c9a$export$b39126d51d94e6f3)(dir);
    const [currentTabStopId = null, setCurrentTabStopId] = (0, $dfcfc7aa8980054c$export$6f32135080cb4c3)({
        prop: currentTabStopIdProp,
        defaultProp: defaultCurrentTabStopId,
        onChange: onCurrentTabStopIdChange
    });
    const [isTabbingBackOut, setIsTabbingBackOut] = $bh6RR.useState(false);
    const handleEntryFocus = (0, $c901973c35f9b07b$export$25bec8c6f54ee79a)(onEntryFocus);
    const getItems = $1a384a7578ffd5f3$var$useCollection(__scopeRovingFocusGroup);
    const isClickFocusRef = $bh6RR.useRef(false);
    const [focusableItemsCount, setFocusableItemsCount] = $bh6RR.useState(0);
    $bh6RR.useEffect(()=>{
        const node = ref.current;
        if (node) {
            node.addEventListener($1a384a7578ffd5f3$var$ENTRY_FOCUS, handleEntryFocus);
            return ()=>node.removeEventListener($1a384a7578ffd5f3$var$ENTRY_FOCUS, handleEntryFocus);
        }
    }, [
        handleEntryFocus
    ]);
    return /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)($1a384a7578ffd5f3$var$RovingFocusProvider, {
        scope: __scopeRovingFocusGroup,
        orientation: orientation,
        dir: direction,
        loop: loop,
        currentTabStopId: currentTabStopId,
        onItemFocus: $bh6RR.useCallback((tabStopId)=>setCurrentTabStopId(tabStopId), [
            setCurrentTabStopId
        ]),
        onItemShiftTab: $bh6RR.useCallback(()=>setIsTabbingBackOut(true), []),
        onFocusableItemAdd: $bh6RR.useCallback(()=>setFocusableItemsCount((prevCount)=>prevCount + 1), []),
        onFocusableItemRemove: $bh6RR.useCallback(()=>setFocusableItemsCount((prevCount)=>prevCount - 1), []),
        children: /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, {
            tabIndex: isTabbingBackOut || focusableItemsCount === 0 ? -1 : 0,
            "data-orientation": orientation,
            ...groupProps,
            ref: composedRefs,
            style: {
                outline: "none",
                ...props.style
            },
            onMouseDown: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onMouseDown, ()=>{
                isClickFocusRef.current = true;
            }),
            onFocus: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onFocus, (event)=>{
                const isKeyboardFocus = !isClickFocusRef.current;
                if (event.target === event.currentTarget && isKeyboardFocus && !isTabbingBackOut) {
                    const entryFocusEvent = new CustomEvent($1a384a7578ffd5f3$var$ENTRY_FOCUS, $1a384a7578ffd5f3$var$EVENT_OPTIONS);
                    event.currentTarget.dispatchEvent(entryFocusEvent);
                    if (!entryFocusEvent.defaultPrevented) {
                        const items = getItems().filter((item)=>item.focusable);
                        const activeItem = items.find((item)=>item.active);
                        const currentItem = items.find((item)=>item.id === currentTabStopId);
                        const candidateItems = [
                            activeItem,
                            currentItem,
                            ...items
                        ].filter(Boolean);
                        const candidateNodes = candidateItems.map((item)=>item.ref.current);
                        $1a384a7578ffd5f3$var$focusFirst(candidateNodes, preventScrollOnEntryFocus);
                    }
                }
                isClickFocusRef.current = false;
            }),
            onBlur: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onBlur, ()=>setIsTabbingBackOut(false))
        })
    });
});
var $1a384a7578ffd5f3$var$ITEM_NAME = "RovingFocusGroupItem";
var $1a384a7578ffd5f3$export$ab9df7c53fe8454 = $bh6RR.forwardRef((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup , focusable: focusable = true , active: active = false , tabStopId: tabStopId , ...itemProps } = props;
    const autoId = (0, $d172fcbd2da23bac$export$f680877a34711e37)();
    const id = tabStopId || autoId;
    const context = $1a384a7578ffd5f3$var$useRovingFocusContext($1a384a7578ffd5f3$var$ITEM_NAME, __scopeRovingFocusGroup);
    const isCurrentTabStop = context.currentTabStopId === id;
    const getItems = $1a384a7578ffd5f3$var$useCollection(__scopeRovingFocusGroup);
    const { onFocusableItemAdd: onFocusableItemAdd , onFocusableItemRemove: onFocusableItemRemove  } = context;
    $bh6RR.useEffect(()=>{
        if (focusable) {
            onFocusableItemAdd();
            return ()=>onFocusableItemRemove();
        }
    }, [
        focusable,
        onFocusableItemAdd,
        onFocusableItemRemove
    ]);
    return /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)($1a384a7578ffd5f3$var$Collection.ItemSlot, {
        scope: __scopeRovingFocusGroup,
        id: id,
        focusable: focusable,
        active: active,
        children: /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).span, {
            tabIndex: isCurrentTabStop ? 0 : -1,
            "data-orientation": context.orientation,
            ...itemProps,
            ref: forwardedRef,
            onMouseDown: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onMouseDown, (event)=>{
                if (!focusable) event.preventDefault();
                else context.onItemFocus(id);
            }),
            onFocus: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onFocus, ()=>context.onItemFocus(id)),
            onKeyDown: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
                if (event.key === "Tab" && event.shiftKey) {
                    context.onItemShiftTab();
                    return;
                }
                if (event.target !== event.currentTarget) return;
                const focusIntent = $1a384a7578ffd5f3$var$getFocusIntent(event, context.orientation, context.dir);
                if (focusIntent !== void 0) {
                    if (event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
                    event.preventDefault();
                    const items = getItems().filter((item)=>item.focusable);
                    let candidateNodes = items.map((item)=>item.ref.current);
                    if (focusIntent === "last") candidateNodes.reverse();
                    else if (focusIntent === "prev" || focusIntent === "next") {
                        if (focusIntent === "prev") candidateNodes.reverse();
                        const currentIndex = candidateNodes.indexOf(event.currentTarget);
                        candidateNodes = context.loop ? $1a384a7578ffd5f3$var$wrapArray(candidateNodes, currentIndex + 1) : candidateNodes.slice(currentIndex + 1);
                    }
                    setTimeout(()=>$1a384a7578ffd5f3$var$focusFirst(candidateNodes));
                }
            })
        })
    });
});
$1a384a7578ffd5f3$export$ab9df7c53fe8454.displayName = $1a384a7578ffd5f3$var$ITEM_NAME;
var $1a384a7578ffd5f3$var$MAP_KEY_TO_FOCUS_INTENT = {
    ArrowLeft: "prev",
    ArrowUp: "prev",
    ArrowRight: "next",
    ArrowDown: "next",
    PageUp: "first",
    Home: "first",
    PageDown: "last",
    End: "last"
};
function $1a384a7578ffd5f3$var$getDirectionAwareKey(key, dir) {
    if (dir !== "rtl") return key;
    return key === "ArrowLeft" ? "ArrowRight" : key === "ArrowRight" ? "ArrowLeft" : key;
}
function $1a384a7578ffd5f3$var$getFocusIntent(event, orientation, dir) {
    const key = $1a384a7578ffd5f3$var$getDirectionAwareKey(event.key, dir);
    if (orientation === "vertical" && [
        "ArrowLeft",
        "ArrowRight"
    ].includes(key)) return void 0;
    if (orientation === "horizontal" && [
        "ArrowUp",
        "ArrowDown"
    ].includes(key)) return void 0;
    return $1a384a7578ffd5f3$var$MAP_KEY_TO_FOCUS_INTENT[key];
}
function $1a384a7578ffd5f3$var$focusFirst(candidates, preventScroll = false) {
    const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
    for (const candidate of candidates){
        if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
        candidate.focus({
            preventScroll: preventScroll
        });
        if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
    }
}
function $1a384a7578ffd5f3$var$wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]);
}
var $1a384a7578ffd5f3$export$be92b6f5f03c0fe9 = $1a384a7578ffd5f3$export$8699f7c8af148338;
var $1a384a7578ffd5f3$export$6d08773d2e66f8f2 = $1a384a7578ffd5f3$export$ab9df7c53fe8454;








"use client";
var $cddb0ca76cb01c25$var$TABS_NAME = "Tabs";
var [$cddb0ca76cb01c25$var$createTabsContext, $cddb0ca76cb01c25$export$355f5bd209d7b13a] = (0, $1cecd1d75f085228$export$50c7b4e9d9f19c1)($cddb0ca76cb01c25$var$TABS_NAME, [
    (0, $1a384a7578ffd5f3$export$c7109489551a4f4)
]);
var $cddb0ca76cb01c25$var$useRovingFocusGroupScope = (0, $1a384a7578ffd5f3$export$c7109489551a4f4)();
var [$cddb0ca76cb01c25$var$TabsProvider, $cddb0ca76cb01c25$var$useTabsContext] = $cddb0ca76cb01c25$var$createTabsContext($cddb0ca76cb01c25$var$TABS_NAME);
var $cddb0ca76cb01c25$export$b2539bed5023c21c = $bh6RR.forwardRef((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs , value: valueProp , onValueChange: onValueChange , defaultValue: defaultValue , orientation: orientation = "horizontal" , dir: dir , activationMode: activationMode = "automatic" , ...tabsProps } = props;
    const direction = (0, $4ac4e2f5e0780c9a$export$b39126d51d94e6f3)(dir);
    const [value, setValue] = (0, $dfcfc7aa8980054c$export$6f32135080cb4c3)({
        prop: valueProp,
        onChange: onValueChange,
        defaultProp: defaultValue
    });
    return /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)($cddb0ca76cb01c25$var$TabsProvider, {
        scope: __scopeTabs,
        baseId: (0, $d172fcbd2da23bac$export$f680877a34711e37)(),
        value: value,
        onValueChange: setValue,
        orientation: orientation,
        dir: direction,
        activationMode: activationMode,
        children: /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, {
            dir: direction,
            "data-orientation": orientation,
            ...tabsProps,
            ref: forwardedRef
        })
    });
});
$cddb0ca76cb01c25$export$b2539bed5023c21c.displayName = $cddb0ca76cb01c25$var$TABS_NAME;
var $cddb0ca76cb01c25$var$TAB_LIST_NAME = "TabsList";
var $cddb0ca76cb01c25$export$9712d22edc0d78c1 = $bh6RR.forwardRef((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs , loop: loop = true , ...listProps } = props;
    const context = $cddb0ca76cb01c25$var$useTabsContext($cddb0ca76cb01c25$var$TAB_LIST_NAME, __scopeTabs);
    const rovingFocusGroupScope = $cddb0ca76cb01c25$var$useRovingFocusGroupScope(__scopeTabs);
    return /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)($1a384a7578ffd5f3$export$be92b6f5f03c0fe9, {
        asChild: true,
        ...rovingFocusGroupScope,
        orientation: context.orientation,
        dir: context.dir,
        loop: loop,
        children: /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, {
            role: "tablist",
            "aria-orientation": context.orientation,
            ...listProps,
            ref: forwardedRef
        })
    });
});
$cddb0ca76cb01c25$export$9712d22edc0d78c1.displayName = $cddb0ca76cb01c25$var$TAB_LIST_NAME;
var $cddb0ca76cb01c25$var$TRIGGER_NAME = "TabsTrigger";
var $cddb0ca76cb01c25$export$8114b9fdfdf9f3ba = $bh6RR.forwardRef((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs , value: value , disabled: disabled = false , ...triggerProps } = props;
    const context = $cddb0ca76cb01c25$var$useTabsContext($cddb0ca76cb01c25$var$TRIGGER_NAME, __scopeTabs);
    const rovingFocusGroupScope = $cddb0ca76cb01c25$var$useRovingFocusGroupScope(__scopeTabs);
    const triggerId = $cddb0ca76cb01c25$var$makeTriggerId(context.baseId, value);
    const contentId = $cddb0ca76cb01c25$var$makeContentId(context.baseId, value);
    const isSelected = value === context.value;
    return /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)($1a384a7578ffd5f3$export$6d08773d2e66f8f2, {
        asChild: true,
        ...rovingFocusGroupScope,
        focusable: !disabled,
        active: isSelected,
        children: /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).button, {
            type: "button",
            role: "tab",
            "aria-selected": isSelected,
            "aria-controls": contentId,
            "data-state": isSelected ? "active" : "inactive",
            "data-disabled": disabled ? "" : void 0,
            disabled: disabled,
            id: triggerId,
            ...triggerProps,
            ref: forwardedRef,
            onMouseDown: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onMouseDown, (event)=>{
                if (!disabled && event.button === 0 && event.ctrlKey === false) context.onValueChange(value);
                else event.preventDefault();
            }),
            onKeyDown: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
                if ([
                    " ",
                    "Enter"
                ].includes(event.key)) context.onValueChange(value);
            }),
            onFocus: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onFocus, ()=>{
                const isAutomaticActivation = context.activationMode !== "manual";
                if (!isSelected && !disabled && isAutomaticActivation) context.onValueChange(value);
            })
        })
    });
});
$cddb0ca76cb01c25$export$8114b9fdfdf9f3ba.displayName = $cddb0ca76cb01c25$var$TRIGGER_NAME;
var $cddb0ca76cb01c25$var$CONTENT_NAME = "TabsContent";
var $cddb0ca76cb01c25$export$bd905d70e8fd2ebb = $bh6RR.forwardRef((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs , value: value , forceMount: forceMount , children: children , ...contentProps } = props;
    const context = $cddb0ca76cb01c25$var$useTabsContext($cddb0ca76cb01c25$var$CONTENT_NAME, __scopeTabs);
    const triggerId = $cddb0ca76cb01c25$var$makeTriggerId(context.baseId, value);
    const contentId = $cddb0ca76cb01c25$var$makeContentId(context.baseId, value);
    const isSelected = value === context.value;
    const isMountAnimationPreventedRef = $bh6RR.useRef(isSelected);
    $bh6RR.useEffect(()=>{
        const rAF = requestAnimationFrame(()=>isMountAnimationPreventedRef.current = false);
        return ()=>cancelAnimationFrame(rAF);
    }, []);
    return /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)((0, $e651d1dc516f7371$export$99c2b779aa4e8b8b), {
        present: forceMount || isSelected,
        children: ({ present: present  })=>/* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, {
                "data-state": isSelected ? "active" : "inactive",
                "data-orientation": context.orientation,
                role: "tabpanel",
                "aria-labelledby": triggerId,
                hidden: !present,
                id: contentId,
                tabIndex: 0,
                ...contentProps,
                ref: forwardedRef,
                style: {
                    ...props.style,
                    animationDuration: isMountAnimationPreventedRef.current ? "0s" : void 0
                },
                children: present && children
            })
    });
});
$cddb0ca76cb01c25$export$bd905d70e8fd2ebb.displayName = $cddb0ca76cb01c25$var$CONTENT_NAME;
function $cddb0ca76cb01c25$var$makeTriggerId(baseId, value) {
    return `${baseId}-trigger-${value}`;
}
function $cddb0ca76cb01c25$var$makeContentId(baseId, value) {
    return `${baseId}-content-${value}`;
}
var $cddb0ca76cb01c25$export$be92b6f5f03c0fe9 = $cddb0ca76cb01c25$export$b2539bed5023c21c;
var $cddb0ca76cb01c25$export$54c2e3dc7acea9f5 = $cddb0ca76cb01c25$export$9712d22edc0d78c1;
var $cddb0ca76cb01c25$export$41fb9f06171c75f4 = $cddb0ca76cb01c25$export$8114b9fdfdf9f3ba;
var $cddb0ca76cb01c25$export$7c6e2c02157bb7d2 = $cddb0ca76cb01c25$export$bd905d70e8fd2ebb;


const $bfafc62980e59835$var$AuthDialog = ()=>{
    const [email, setEmail] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState("");
    const [password, setPassword] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState("");
    const [confirmPassword, setConfirmPassword] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState("");
    const { handleLogin: handleLogin , handleSignUp: handleSignUp , handleConfirmSignUp: handleConfirmSignUp , setIsAuthModalOpen: setIsAuthModalOpen  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $5a12233f233e4186$export$38ee920e59704589));
    const [dialogOpen, setDialogOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const [code, setCode] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState("");
    const [awaitingConfirmation, setAwaitingConfirmation] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const passwordIsLongEnough = password.length >= 8;
    const passwordContainsNumber = /\d/.test(password);
    const passwordContainsSpecialCharacter = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(password);
    const passwordContainsUppercase = /[A-Z]/.test(password);
    const passwordContainsLowercase = /[a-z]/.test(password);
    const passwordMatchesConfirm = password === confirmPassword && password.length > 0;
    const passwordIsValid = passwordIsLongEnough && passwordContainsNumber && passwordContainsSpecialCharacter && passwordContainsUppercase && passwordContainsLowercase && passwordMatchesConfirm;
    function handleLoginAttempt() {
        handleLogin(email, password);
        setDialogOpen(false);
        setIsAuthModalOpen(false);
    }
    function handleSignUpAttempt() {
        if (!passwordIsValid) {
            window.alert("Password is not valid! Review the requirements!");
            return;
        }
        if (email === "") {
            window.alert("Email not valid!");
            return;
        }
        handleSignUp(email, password);
        setAwaitingConfirmation(true);
    }
    function handleConfirmSignUpAttempt() {
        handleConfirmSignUp(email, code);
        setAwaitingConfirmation(false);
        setTimeout(()=>{
            handleLogin(email, password);
        }, 1000);
        setDialogOpen(false);
        setIsAuthModalOpen(false);
    }
    const signUpForm = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                className: "Text",
                children: "Create an account!"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($919b3aedf69a16e5$export$393edc798c47379d, {
                className: "AuthDialogDescription"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("fieldset", {
                className: "Fieldset",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                        className: "Label",
                        htmlFor: "email",
                        children: "Email"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                        value: email,
                        onChange: (e)=>setEmail(e.target.value),
                        className: "Input",
                        id: "email",
                        type: "email"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("fieldset", {
                className: "Fieldset",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                        className: "Label",
                        htmlFor: "password",
                        children: "Password"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                        value: password,
                        onChange: (e)=>setPassword(e.target.value),
                        className: "Input",
                        id: "password",
                        type: "password"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("fieldset", {
                className: "Fieldset",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                        className: "Label",
                        htmlFor: "confirmpassword",
                        children: "Confirm Password"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                        value: confirmPassword,
                        onChange: (e)=>setConfirmPassword(e.target.value),
                        className: "Input",
                        id: "password",
                        type: "password"
                    })
                ]
            }),
            passwordIsLongEnough ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                style: {
                    color: "green"
                },
                children: ">= 8 characters long"
            }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                style: {
                    color: "red"
                },
                children: "< 8 characters long!"
            }),
            passwordContainsNumber ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                style: {
                    color: "green"
                },
                children: ">=1 number"
            }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                style: {
                    color: "red"
                },
                children: "<1 number!"
            }),
            passwordContainsSpecialCharacter ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                style: {
                    color: "green"
                },
                children: ">=1 special character"
            }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                style: {
                    color: "red"
                },
                children: "<1 special character"
            }),
            passwordContainsUppercase ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                style: {
                    color: "green"
                },
                children: ">=1 uppercase letter"
            }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                style: {
                    color: "red"
                },
                children: "<1 uppercase letter"
            }),
            passwordContainsLowercase ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                style: {
                    color: "green"
                },
                children: ">=1 lowercase letter"
            }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                style: {
                    color: "red"
                },
                children: "<1 lowercase letter"
            }),
            passwordMatchesConfirm ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                style: {
                    color: "green"
                },
                children: "Password matches confirm"
            }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                style: {
                    color: "red"
                },
                children: "Password & confirm don't match"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                style: {
                    display: "flex",
                    marginTop: 20,
                    justifyContent: "flex-end"
                },
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                    onClick: handleSignUpAttempt,
                    className: "Button green",
                    children: "Sign Up"
                })
            })
        ]
    });
    const confirmForm = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                className: "Text",
                children: `Enter Confirmation Code Sent to ${email}`
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($919b3aedf69a16e5$export$393edc798c47379d, {
                className: "AuthDialogDescription"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("fieldset", {
                className: "Fieldset",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                        className: "Label",
                        htmlFor: "code",
                        children: "Confirmation Code"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                        value: code,
                        onChange: (e)=>setCode(e.target.value),
                        className: "Input",
                        id: "code",
                        type: "text"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                style: {
                    display: "flex",
                    marginTop: 20,
                    justifyContent: "flex-end"
                },
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                    onClick: handleConfirmSignUpAttempt,
                    className: "Button green",
                    children: "Confirm"
                })
            })
        ]
    });
    const signUpTabContent = awaitingConfirmation ? confirmForm : signUpForm;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($919b3aedf69a16e5$export$be92b6f5f03c0fe9, {
        open: dialogOpen,
        onOpenChange: ()=>{
            setDialogOpen((oldValue)=>{
                setIsAuthModalOpen(!oldValue);
                return !oldValue;
            });
        },
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($919b3aedf69a16e5$export$41fb9f06171c75f4, {
                asChild: true,
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "Button violet",
                    children: "Login"
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($919b3aedf69a16e5$export$602eac185826482c, {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($919b3aedf69a16e5$export$c6fdb837b070b4ff, {
                        className: "AuthDialogOverlay"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($919b3aedf69a16e5$export$7c6e2c02157bb7d2, {
                        className: "AuthDialogContent",
                        asChild: true,
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($cddb0ca76cb01c25$export$be92b6f5f03c0fe9, {
                            className: "TabsRoot",
                            defaultValue: "tab1",
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($cddb0ca76cb01c25$export$54c2e3dc7acea9f5, {
                                    className: "TabsList",
                                    "aria-label": "Manage your account",
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($cddb0ca76cb01c25$export$41fb9f06171c75f4, {
                                            className: "TabsTrigger",
                                            value: "tab1",
                                            children: "Log In"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($cddb0ca76cb01c25$export$41fb9f06171c75f4, {
                                            className: "TabsTrigger",
                                            value: "tab2",
                                            children: "Sign Up"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($cddb0ca76cb01c25$export$7c6e2c02157bb7d2, {
                                    className: "TabsContent",
                                    value: "tab1",
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                                            className: "Text",
                                            children: "Your username is your email."
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("fieldset", {
                                            className: "Fieldset",
                                            children: [
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                                                    className: "Label",
                                                    htmlFor: "email",
                                                    children: "Email"
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                                    value: email,
                                                    onChange: (e)=>setEmail(e.target.value),
                                                    className: "Input",
                                                    id: "email",
                                                    type: "email"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("fieldset", {
                                            className: "Fieldset",
                                            children: [
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                                                    className: "Label",
                                                    htmlFor: "password",
                                                    children: "Password"
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                                    value: password,
                                                    onChange: (e)=>setPassword(e.target.value),
                                                    className: "Input",
                                                    id: "password",
                                                    type: "password"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                            style: {
                                                display: "flex",
                                                marginTop: 20,
                                                justifyContent: "flex-end"
                                            },
                                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                                onClick: handleLoginAttempt,
                                                className: "Button green",
                                                children: "Log In"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($cddb0ca76cb01c25$export$7c6e2c02157bb7d2, {
                                    className: "TabsContent",
                                    value: "tab2",
                                    children: signUpTabContent
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $bfafc62980e59835$export$2e2bcd8739ae039 = $bfafc62980e59835$var$AuthDialog;




// import ProjectDialog from '../ProjectDialog';
// import ProjectDropdown from '../ProjectDropdown';
function $ddb89bb066eb98c1$var$NavBar() {
    //const { isAuthenticated, handleLogout } = React.useContext(UserContext);
    const { setProjects: setProjects , setProjectTasksWereRequested: setProjectTasksWereRequested , setProjectTasksWereFetched: setProjectTasksWereFetched  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $7ead3b1a9a673b0a$export$58d75f9829cbe158));
    function handleSelectValue(selection) {
        setProjects((oldValue)=>oldValue.includes(selection) ? oldValue : [
                ...oldValue,
                selection
            ]);
        setProjectTasksWereRequested(true);
        setProjectTasksWereFetched(false);
    }
    // const LoginLogout = isAuthenticated ? (
    //   <NavItem onClick={handleLogout}>Logout</NavItem>
    // ) : (
    //   <NavItem>
    //     <AuthDialog />
    //   </NavItem>
    // );
    // const AddProject = (
    //   <NavItem>
    //     <ProjectDialog />
    //   </NavItem>
    // );
    const settingsSVG = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "lucide lucide-settings",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "3"
            })
        ]
    });
    const volumeMutedSVG = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "lucide lucide-volume",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("polygon", {
            points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5"
        })
    });
    const volumeOnSVG = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "lucide lucide-volume-2",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("polygon", {
                points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M15.54 8.46a5 5 0 0 1 0 7.07"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M19.07 4.93a10 10 0 0 1 0 14.14"
            })
        ]
    });
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($ddb89bb066eb98c1$var$FlexWrapper, {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($ddb89bb066eb98c1$var$NavItem, {
                children: volumeOnSVG
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($ddb89bb066eb98c1$var$NavItem, {
                children: "About"
            })
        ]
    });
}
var $ddb89bb066eb98c1$export$2e2bcd8739ae039 = $ddb89bb066eb98c1$var$NavBar;
const $ddb89bb066eb98c1$var$FlexWrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: row;
  align-self: flex-end;
  gap: 10px;
`;
const $ddb89bb066eb98c1$var$NavItem = (0, $e484c752f3f06549$export$2e2bcd8739ae039).button`
  background-color: var(--number-box-background-color);
  color: var(--number-box-font-color);
  border-left: 1px solid var(--number-box-border-color);
  border-bottom: 1px solid var(--number-box-border-color);
  border-right: 1px solid var(--number-box-border-color);
  &:hover {
    background-color: var(--number-box-border-color);
    color: red;
  }
  /* width: 100px; */
  display: flex;
  padding: 2px 6px;
  /* height: 50px; */
  align-items: center;
  justify-content: center;
  text-decoration: none;
  color: inherit;

  a {
    text-decoration: none;
    color: inherit;
  }
`; // --number-box-hover-background-color: hsl(240, 10%, 85%);
 // --matrix-cell-background-color: hsl(240, 50%, 93%);
 // --action-box-background-color: hsl(240 10% 95% / 50%);
 // --action-box-hover-background-color: hsl(240 10% 85% / 50%);
 // --action-box-hover-font-color: hsl(240 90% 50% / 50%);
 // --action-box-font-color: hsl(240 65% 40% / 50%);
 // --action-box-border-color: hsl(240 65% 65% / 50%);
 // --bubble-hover-background-color: hsl(240, 100%, 50%);
 // --number-box-hover-font-color: hsl(240, 100%, 50%);
 // --bubble-hover-border-color: hsl(240, 100%, 90%);
 // --number-box-border-radius: 8px;
 // --header-color: hsl(240, 85%, 35%);
 // --active-button-color: hsl(240, 85%, 35%);
 // --hover-button-color: hsl(240, 60%, 55%);
 // --mode-button-selected: hsl(240, 85%, 35%);





function $02ce57c81a0104d3$var$Header() {
    const { randomItem: randomItem , setApiWasRequested: setApiWasRequested , setRequestWasHandled: setRequestWasHandled  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $7ead3b1a9a673b0a$export$58d75f9829cbe158));
    function handleClick() {
        console.log("handling click");
        setApiWasRequested(true);
        setRequestWasHandled(false);
    }
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ddb89bb066eb98c1$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("header", {
                className: `${$7f3c0863fade5429$export$38e42c68cf43b5d4} ${(0, $7f3c0863fade5429$export$385906a4ef528034)}`,
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h1", {
                    children: "James Shapiro"
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                children: [
                    "Invisible",
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                        className: $7f3c0863fade5429$export$69d0d1846105bbd3,
                        children: "PLACEHOLDER"
                    }),
                    "placeholder",
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                        className: $7f3c0863fade5429$export$69d0d1846105bbd3,
                        children: "DEMO"
                    }),
                    "Demo"
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($02ce57c81a0104d3$var$Button, {
                onClick: handleClick,
                children: "Invoke API (see console)"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                children: [
                    "Random Data Context Item: ",
                    randomItem
                ]
            })
        ]
    });
}
var $02ce57c81a0104d3$export$2e2bcd8739ae039 = $02ce57c81a0104d3$var$Header;
const $02ce57c81a0104d3$var$Button = (0, $e484c752f3f06549$export$2e2bcd8739ae039).button`
  padding: 20px;
  background-color: hsl(217, 100%, 61%);
  color: white;
  width: fit-content;
  border-radius: 8px;
  margin: 100px auto;
  border: 2px solid black;
`;




parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");
function $2d9d74cd18324bdd$var$WakeLocker() {
    const wakeLockRef = (0, $bh6RR.useRef)(null);
    // Function to request the wake lock
    const requestWakeLock = async ()=>{
        try {
            const wakeLock = await navigator.wakeLock.request("screen");
            wakeLockRef.current = wakeLock;
            // Listen for release events
            wakeLock.addEventListener("release", ()=>{
                console.log("Wake Lock was released");
            });
            console.log("Wake Lock acquired");
        } catch (err) {
            console.error(`${err.name}, ${err.message}`);
        }
    };
    // Function to release the wake lock
    const releaseWakeLock = async ()=>{
        if (wakeLockRef.current !== null) {
            await wakeLockRef.current.release();
            wakeLockRef.current = null;
            console.log("Wake Lock released manually");
        }
    };
    // Handle visibility change
    const handleVisibilityChange = ()=>{
        if (document.visibilityState === "visible") requestWakeLock();
        else releaseWakeLock();
    };
    (0, $bh6RR.useEffect)(()=>{
        // Initial wake lock request
        requestWakeLock();
        // Listen for visibility change
        document.addEventListener("visibilitychange", handleVisibilityChange);
        // Cleanup function to release the lock and remove listeners
        return ()=>{
            releaseWakeLock();
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);
    return null;
}
var $2d9d74cd18324bdd$export$2e2bcd8739ae039 = $2d9d74cd18324bdd$var$WakeLocker;






var $bh6RR = parcelRequire("bh6RR");




var $bh6RR = parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $700bf53ed0e34a6e$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
const $700bf53ed0e34a6e$var$COLUMNS = "abcdefgh".split("");
const $700bf53ed0e34a6e$var$START_POSITION_OBJECT = {
    a8: "bR",
    b8: "bN",
    c8: "bB",
    d8: "bQ",
    e8: "bK",
    f8: "bB",
    g8: "bN",
    h8: "bR",
    a7: "bP",
    b7: "bP",
    c7: "bP",
    d7: "bP",
    e7: "bP",
    f7: "bP",
    g7: "bP",
    h7: "bP",
    a2: "wP",
    b2: "wP",
    c2: "wP",
    d2: "wP",
    e2: "wP",
    f2: "wP",
    g2: "wP",
    h2: "wP",
    a1: "wR",
    b1: "wN",
    c1: "wB",
    d1: "wQ",
    e1: "wK",
    f1: "wB",
    g1: "wN",
    h1: "wR"
};
const $700bf53ed0e34a6e$var$WHITE_COLUMN_VALUES = {
    a: 0,
    b: 1,
    c: 2,
    d: 3,
    e: 4,
    f: 5,
    g: 6,
    h: 7
};
const $700bf53ed0e34a6e$var$BLACK_COLUMN_VALUES = {
    a: 7,
    b: 6,
    c: 5,
    d: 4,
    e: 3,
    f: 2,
    g: 1,
    h: 0
};
const $700bf53ed0e34a6e$var$WHITE_ROWS = [
    7,
    6,
    5,
    4,
    3,
    2,
    1,
    0
];
const $700bf53ed0e34a6e$var$BLACK_ROWS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7
];
// https://commons.wikimedia.org/wiki/Category:SVG_chess_pieces
// By en:User:Cburnett - Own work
// This W3C - unspecified vector image was created with Inkscape., CC BY - SA 3.0, https://commons.wikimedia.org/w/index.php?curid=1499810
const $700bf53ed0e34a6e$var$defaultPieces = {
    wP: (0, $d4dab640dcbe486c$exports.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        width: "45",
        height: "45"
    }, {
        children: (0, $d4dab640dcbe486c$exports.jsx)("path", {
            d: "m 22.5,9 c -2.21,0 -4,1.79 -4,4 0,0.89 0.29,1.71 0.78,2.38 C 17.33,16.5 16,18.59 16,21 c 0,2.03 0.94,3.84 2.41,5.03 C 15.41,27.09 11,31.58 11,39.5 H 34 C 34,31.58 29.59,27.09 26.59,26.03 28.06,24.84 29,23.03 29,21 29,18.59 27.67,16.5 25.72,15.38 26.21,14.71 26.5,13.89 26.5,13 c 0,-2.21 -1.79,-4 -4,-4 z",
            style: {
                opacity: "1",
                fill: "#ffffff",
                fillOpacity: "1",
                fillRule: "nonzero",
                stroke: "#000000",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "miter",
                strokeMiterlimit: "4",
                strokeDasharray: "none",
                strokeOpacity: "1"
            }
        })
    })),
    wR: (0, $d4dab640dcbe486c$exports.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        width: "45",
        height: "45"
    }, {
        children: (0, $d4dab640dcbe486c$exports.jsxs)("g", Object.assign({
            style: {
                opacity: "1",
                fill: "#ffffff",
                fillOpacity: "1",
                fillRule: "evenodd",
                stroke: "#000000",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: "4",
                strokeDasharray: "none",
                strokeOpacity: "1"
            }
        }, {
            children: [
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 9,39 L 36,39 L 36,36 L 9,36 L 9,39 z ",
                    style: {
                        strokeLinecap: "butt"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 12,36 L 12,32 L 33,32 L 33,36 L 12,36 z ",
                    style: {
                        strokeLinecap: "butt"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 11,14 L 11,9 L 15,9 L 15,11 L 20,11 L 20,9 L 25,9 L 25,11 L 30,11 L 30,9 L 34,9 L 34,14",
                    style: {
                        strokeLinecap: "butt"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 34,14 L 31,17 L 14,17 L 11,14"
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 31,17 L 31,29.5 L 14,29.5 L 14,17",
                    style: {
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 31,29.5 L 32.5,32 L 12.5,32 L 14,29.5"
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 11,14 L 34,14",
                    style: {
                        fill: "none",
                        stroke: "#000000",
                        strokeLinejoin: "miter"
                    }
                })
            ]
        }))
    })),
    wN: (0, $d4dab640dcbe486c$exports.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        width: "45",
        height: "45"
    }, {
        children: (0, $d4dab640dcbe486c$exports.jsxs)("g", Object.assign({
            style: {
                opacity: "1",
                fill: "none",
                fillOpacity: "1",
                fillRule: "evenodd",
                stroke: "#000000",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: "4",
                strokeDasharray: "none",
                strokeOpacity: "1"
            }
        }, {
            children: [
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 22,10 C 32.5,11 38.5,18 38,39 L 15,39 C 15,30 25,32.5 23,18",
                    style: {
                        fill: "#ffffff",
                        stroke: "#000000"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 24,18 C 24.38,20.91 18.45,25.37 16,27 C 13,29 13.18,31.34 11,31 C 9.958,30.06 12.41,27.96 11,28 C 10,28 11.19,29.23 10,30 C 9,30 5.997,31 6,26 C 6,24 12,14 12,14 C 12,14 13.89,12.1 14,10.5 C 13.27,9.506 13.5,8.5 13.5,7.5 C 14.5,6.5 16.5,10 16.5,10 L 18.5,10 C 18.5,10 19.28,8.008 21,7 C 22,7 22,10 22,10",
                    style: {
                        fill: "#ffffff",
                        stroke: "#000000"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 9.5 25.5 A 0.5 0.5 0 1 1 8.5,25.5 A 0.5 0.5 0 1 1 9.5 25.5 z",
                    style: {
                        fill: "#000000",
                        stroke: "#000000"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 15 15.5 A 0.5 1.5 0 1 1  14,15.5 A 0.5 1.5 0 1 1  15 15.5 z",
                    transform: "matrix(0.866,0.5,-0.5,0.866,9.693,-5.173)",
                    style: {
                        fill: "#000000",
                        stroke: "#000000"
                    }
                })
            ]
        }))
    })),
    wB: (0, $d4dab640dcbe486c$exports.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        width: "45",
        height: "45"
    }, {
        children: (0, $d4dab640dcbe486c$exports.jsxs)("g", Object.assign({
            style: {
                opacity: "1",
                fill: "none",
                fillRule: "evenodd",
                fillOpacity: "1",
                stroke: "#000000",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: "4",
                strokeDasharray: "none",
                strokeOpacity: "1"
            }
        }, {
            children: [
                (0, $d4dab640dcbe486c$exports.jsxs)("g", Object.assign({
                    style: {
                        fill: "#ffffff",
                        stroke: "#000000",
                        strokeLinecap: "butt"
                    }
                }, {
                    children: [
                        (0, $d4dab640dcbe486c$exports.jsx)("path", {
                            d: "M 9,36 C 12.39,35.03 19.11,36.43 22.5,34 C 25.89,36.43 32.61,35.03 36,36 C 36,36 37.65,36.54 39,38 C 38.32,38.97 37.35,38.99 36,38.5 C 32.61,37.53 25.89,38.96 22.5,37.5 C 19.11,38.96 12.39,37.53 9,38.5 C 7.65,38.99 6.68,38.97 6,38 C 7.35,36.54 9,36 9,36 z"
                        }),
                        (0, $d4dab640dcbe486c$exports.jsx)("path", {
                            d: "M 15,32 C 17.5,34.5 27.5,34.5 30,32 C 30.5,30.5 30,30 30,30 C 30,27.5 27.5,26 27.5,26 C 33,24.5 33.5,14.5 22.5,10.5 C 11.5,14.5 12,24.5 17.5,26 C 17.5,26 15,27.5 15,30 C 15,30 14.5,30.5 15,32 z"
                        }),
                        (0, $d4dab640dcbe486c$exports.jsx)("path", {
                            d: "M 25 8 A 2.5 2.5 0 1 1  20,8 A 2.5 2.5 0 1 1  25 8 z"
                        })
                    ]
                })),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 17.5,26 L 27.5,26 M 15,30 L 30,30 M 22.5,15.5 L 22.5,20.5 M 20,18 L 25,18",
                    style: {
                        fill: "none",
                        stroke: "#000000",
                        strokeLinejoin: "miter"
                    }
                })
            ]
        }))
    })),
    wQ: (0, $d4dab640dcbe486c$exports.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        width: "45",
        height: "45"
    }, {
        children: (0, $d4dab640dcbe486c$exports.jsxs)("g", Object.assign({
            style: {
                fill: "#ffffff",
                stroke: "#000000",
                strokeWidth: "1.5",
                strokeLinejoin: "round"
            }
        }, {
            children: [
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 9,26 C 17.5,24.5 30,24.5 36,26 L 38.5,13.5 L 31,25 L 30.7,10.9 L 25.5,24.5 L 22.5,10 L 19.5,24.5 L 14.3,10.9 L 14,25 L 6.5,13.5 L 9,26 z"
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 9,26 C 9,28 10.5,28 11.5,30 C 12.5,31.5 12.5,31 12,33.5 C 10.5,34.5 11,36 11,36 C 9.5,37.5 11,38.5 11,38.5 C 17.5,39.5 27.5,39.5 34,38.5 C 34,38.5 35.5,37.5 34,36 C 34,36 34.5,34.5 33,33.5 C 32.5,31 32.5,31.5 33.5,30 C 34.5,28 36,28 36,26 C 27.5,24.5 17.5,24.5 9,26 z"
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 11.5,30 C 15,29 30,29 33.5,30",
                    style: {
                        fill: "none"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 12,33.5 C 18,32.5 27,32.5 33,33.5",
                    style: {
                        fill: "none"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                    cx: "6",
                    cy: "12",
                    r: "2"
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                    cx: "14",
                    cy: "9",
                    r: "2"
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                    cx: "22.5",
                    cy: "8",
                    r: "2"
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                    cx: "31",
                    cy: "9",
                    r: "2"
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                    cx: "39",
                    cy: "12",
                    r: "2"
                })
            ]
        }))
    })),
    wK: (0, $d4dab640dcbe486c$exports.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        width: "45",
        height: "45"
    }, {
        children: (0, $d4dab640dcbe486c$exports.jsxs)("g", Object.assign({
            style: {
                fill: "none",
                fillOpacity: "1",
                fillRule: "evenodd",
                stroke: "#000000",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: "4",
                strokeDasharray: "none",
                strokeOpacity: "1"
            }
        }, {
            children: [
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 22.5,11.63 L 22.5,6",
                    style: {
                        fill: "none",
                        stroke: "#000000",
                        strokeLinejoin: "miter"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 20,8 L 25,8",
                    style: {
                        fill: "none",
                        stroke: "#000000",
                        strokeLinejoin: "miter"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 22.5,25 C 22.5,25 27,17.5 25.5,14.5 C 25.5,14.5 24.5,12 22.5,12 C 20.5,12 19.5,14.5 19.5,14.5 C 18,17.5 22.5,25 22.5,25",
                    style: {
                        fill: "#ffffff",
                        stroke: "#000000",
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 12.5,37 C 18,40.5 27,40.5 32.5,37 L 32.5,30 C 32.5,30 41.5,25.5 38.5,19.5 C 34.5,13 25,16 22.5,23.5 L 22.5,27 L 22.5,23.5 C 20,16 10.5,13 6.5,19.5 C 3.5,25.5 12.5,30 12.5,30 L 12.5,37",
                    style: {
                        fill: "#ffffff",
                        stroke: "#000000"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 12.5,30 C 18,27 27,27 32.5,30",
                    style: {
                        fill: "none",
                        stroke: "#000000"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 12.5,33.5 C 18,30.5 27,30.5 32.5,33.5",
                    style: {
                        fill: "none",
                        stroke: "#000000"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 12.5,37 C 18,34 27,34 32.5,37",
                    style: {
                        fill: "none",
                        stroke: "#000000"
                    }
                })
            ]
        }))
    })),
    bP: (0, $d4dab640dcbe486c$exports.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        width: "45",
        height: "45"
    }, {
        children: (0, $d4dab640dcbe486c$exports.jsx)("path", {
            d: "m 22.5,9 c -2.21,0 -4,1.79 -4,4 0,0.89 0.29,1.71 0.78,2.38 C 17.33,16.5 16,18.59 16,21 c 0,2.03 0.94,3.84 2.41,5.03 C 15.41,27.09 11,31.58 11,39.5 H 34 C 34,31.58 29.59,27.09 26.59,26.03 28.06,24.84 29,23.03 29,21 29,18.59 27.67,16.5 25.72,15.38 26.21,14.71 26.5,13.89 26.5,13 c 0,-2.21 -1.79,-4 -4,-4 z",
            style: {
                opacity: "1",
                fill: "#000000",
                fillOpacity: "1",
                fillRule: "nonzero",
                stroke: "#000000",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "miter",
                strokeMiterlimit: "4",
                strokeDasharray: "none",
                strokeOpacity: "1"
            }
        })
    })),
    bR: (0, $d4dab640dcbe486c$exports.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        width: "45",
        height: "45"
    }, {
        children: (0, $d4dab640dcbe486c$exports.jsxs)("g", Object.assign({
            style: {
                opacity: "1",
                fill: "#000000",
                fillOpacity: "1",
                fillRule: "evenodd",
                stroke: "#000000",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: "4",
                strokeDasharray: "none",
                strokeOpacity: "1"
            }
        }, {
            children: [
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 9,39 L 36,39 L 36,36 L 9,36 L 9,39 z ",
                    style: {
                        strokeLinecap: "butt"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 12.5,32 L 14,29.5 L 31,29.5 L 32.5,32 L 12.5,32 z ",
                    style: {
                        strokeLinecap: "butt"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 12,36 L 12,32 L 33,32 L 33,36 L 12,36 z ",
                    style: {
                        strokeLinecap: "butt"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 14,29.5 L 14,16.5 L 31,16.5 L 31,29.5 L 14,29.5 z ",
                    style: {
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 14,16.5 L 11,14 L 34,14 L 31,16.5 L 14,16.5 z ",
                    style: {
                        strokeLinecap: "butt"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 11,14 L 11,9 L 15,9 L 15,11 L 20,11 L 20,9 L 25,9 L 25,11 L 30,11 L 30,9 L 34,9 L 34,14 L 11,14 z ",
                    style: {
                        strokeLinecap: "butt"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 12,35.5 L 33,35.5 L 33,35.5",
                    style: {
                        fill: "none",
                        stroke: "#ffffff",
                        strokeWidth: "1",
                        strokeLinejoin: "miter"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 13,31.5 L 32,31.5",
                    style: {
                        fill: "none",
                        stroke: "#ffffff",
                        strokeWidth: "1",
                        strokeLinejoin: "miter"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 14,29.5 L 31,29.5",
                    style: {
                        fill: "none",
                        stroke: "#ffffff",
                        strokeWidth: "1",
                        strokeLinejoin: "miter"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 14,16.5 L 31,16.5",
                    style: {
                        fill: "none",
                        stroke: "#ffffff",
                        strokeWidth: "1",
                        strokeLinejoin: "miter"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 11,14 L 34,14",
                    style: {
                        fill: "none",
                        stroke: "#ffffff",
                        strokeWidth: "1",
                        strokeLinejoin: "miter"
                    }
                })
            ]
        }))
    })),
    bN: (0, $d4dab640dcbe486c$exports.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        width: "45",
        height: "45"
    }, {
        children: (0, $d4dab640dcbe486c$exports.jsxs)("g", Object.assign({
            style: {
                opacity: "1",
                fill: "none",
                fillOpacity: "1",
                fillRule: "evenodd",
                stroke: "#000000",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: "4",
                strokeDasharray: "none",
                strokeOpacity: "1"
            }
        }, {
            children: [
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 22,10 C 32.5,11 38.5,18 38,39 L 15,39 C 15,30 25,32.5 23,18",
                    style: {
                        fill: "#000000",
                        stroke: "#000000"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 24,18 C 24.38,20.91 18.45,25.37 16,27 C 13,29 13.18,31.34 11,31 C 9.958,30.06 12.41,27.96 11,28 C 10,28 11.19,29.23 10,30 C 9,30 5.997,31 6,26 C 6,24 12,14 12,14 C 12,14 13.89,12.1 14,10.5 C 13.27,9.506 13.5,8.5 13.5,7.5 C 14.5,6.5 16.5,10 16.5,10 L 18.5,10 C 18.5,10 19.28,8.008 21,7 C 22,7 22,10 22,10",
                    style: {
                        fill: "#000000",
                        stroke: "#000000"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 9.5 25.5 A 0.5 0.5 0 1 1 8.5,25.5 A 0.5 0.5 0 1 1 9.5 25.5 z",
                    style: {
                        fill: "#ffffff",
                        stroke: "#ffffff"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 15 15.5 A 0.5 1.5 0 1 1  14,15.5 A 0.5 1.5 0 1 1  15 15.5 z",
                    transform: "matrix(0.866,0.5,-0.5,0.866,9.693,-5.173)",
                    style: {
                        fill: "#ffffff",
                        stroke: "#ffffff"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 24.55,10.4 L 24.1,11.85 L 24.6,12 C 27.75,13 30.25,14.49 32.5,18.75 C 34.75,23.01 35.75,29.06 35.25,39 L 35.2,39.5 L 37.45,39.5 L 37.5,39 C 38,28.94 36.62,22.15 34.25,17.66 C 31.88,13.17 28.46,11.02 25.06,10.5 L 24.55,10.4 z ",
                    style: {
                        fill: "#ffffff",
                        stroke: "none"
                    }
                })
            ]
        }))
    })),
    bB: (0, $d4dab640dcbe486c$exports.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        width: "45",
        height: "45"
    }, {
        children: (0, $d4dab640dcbe486c$exports.jsxs)("g", Object.assign({
            style: {
                opacity: "1",
                fill: "none",
                fillRule: "evenodd",
                fillOpacity: "1",
                stroke: "#000000",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: "4",
                strokeDasharray: "none",
                strokeOpacity: "1"
            }
        }, {
            children: [
                (0, $d4dab640dcbe486c$exports.jsxs)("g", Object.assign({
                    style: {
                        fill: "#000000",
                        stroke: "#000000",
                        strokeLinecap: "butt"
                    }
                }, {
                    children: [
                        (0, $d4dab640dcbe486c$exports.jsx)("path", {
                            d: "M 9,36 C 12.39,35.03 19.11,36.43 22.5,34 C 25.89,36.43 32.61,35.03 36,36 C 36,36 37.65,36.54 39,38 C 38.32,38.97 37.35,38.99 36,38.5 C 32.61,37.53 25.89,38.96 22.5,37.5 C 19.11,38.96 12.39,37.53 9,38.5 C 7.65,38.99 6.68,38.97 6,38 C 7.35,36.54 9,36 9,36 z"
                        }),
                        (0, $d4dab640dcbe486c$exports.jsx)("path", {
                            d: "M 15,32 C 17.5,34.5 27.5,34.5 30,32 C 30.5,30.5 30,30 30,30 C 30,27.5 27.5,26 27.5,26 C 33,24.5 33.5,14.5 22.5,10.5 C 11.5,14.5 12,24.5 17.5,26 C 17.5,26 15,27.5 15,30 C 15,30 14.5,30.5 15,32 z"
                        }),
                        (0, $d4dab640dcbe486c$exports.jsx)("path", {
                            d: "M 25 8 A 2.5 2.5 0 1 1  20,8 A 2.5 2.5 0 1 1  25 8 z"
                        })
                    ]
                })),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 17.5,26 L 27.5,26 M 15,30 L 30,30 M 22.5,15.5 L 22.5,20.5 M 20,18 L 25,18",
                    style: {
                        fill: "none",
                        stroke: "#ffffff",
                        strokeLinejoin: "miter"
                    }
                })
            ]
        }))
    })),
    bQ: (0, $d4dab640dcbe486c$exports.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        width: "45",
        height: "45"
    }, {
        children: (0, $d4dab640dcbe486c$exports.jsxs)("g", Object.assign({
            style: {
                fill: "#000000",
                stroke: "#000000",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }
        }, {
            children: [
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 9,26 C 17.5,24.5 30,24.5 36,26 L 38.5,13.5 L 31,25 L 30.7,10.9 L 25.5,24.5 L 22.5,10 L 19.5,24.5 L 14.3,10.9 L 14,25 L 6.5,13.5 L 9,26 z",
                    style: {
                        strokeLinecap: "butt",
                        fill: "#000000"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "m 9,26 c 0,2 1.5,2 2.5,4 1,1.5 1,1 0.5,3.5 -1.5,1 -1,2.5 -1,2.5 -1.5,1.5 0,2.5 0,2.5 6.5,1 16.5,1 23,0 0,0 1.5,-1 0,-2.5 0,0 0.5,-1.5 -1,-2.5 -0.5,-2.5 -0.5,-2 0.5,-3.5 1,-2 2.5,-2 2.5,-4 -8.5,-1.5 -18.5,-1.5 -27,0 z"
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 11.5,30 C 15,29 30,29 33.5,30"
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "m 12,33.5 c 6,-1 15,-1 21,0"
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                    cx: "6",
                    cy: "12",
                    r: "2"
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                    cx: "14",
                    cy: "9",
                    r: "2"
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                    cx: "22.5",
                    cy: "8",
                    r: "2"
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                    cx: "31",
                    cy: "9",
                    r: "2"
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                    cx: "39",
                    cy: "12",
                    r: "2"
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 11,38.5 A 35,35 1 0 0 34,38.5",
                    style: {
                        fill: "none",
                        stroke: "#000000",
                        strokeLinecap: "butt"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsxs)("g", Object.assign({
                    style: {
                        fill: "none",
                        stroke: "#ffffff"
                    }
                }, {
                    children: [
                        (0, $d4dab640dcbe486c$exports.jsx)("path", {
                            d: "M 11,29 A 35,35 1 0 1 34,29"
                        }),
                        (0, $d4dab640dcbe486c$exports.jsx)("path", {
                            d: "M 12.5,31.5 L 32.5,31.5"
                        }),
                        (0, $d4dab640dcbe486c$exports.jsx)("path", {
                            d: "M 11.5,34.5 A 35,35 1 0 0 33.5,34.5"
                        }),
                        (0, $d4dab640dcbe486c$exports.jsx)("path", {
                            d: "M 10.5,37.5 A 35,35 1 0 0 34.5,37.5"
                        })
                    ]
                }))
            ]
        }))
    })),
    bK: (0, $d4dab640dcbe486c$exports.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        width: "45",
        height: "45"
    }, {
        children: (0, $d4dab640dcbe486c$exports.jsxs)("g", Object.assign({
            style: {
                fill: "none",
                fillOpacity: "1",
                fillRule: "evenodd",
                stroke: "#000000",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: "4",
                strokeDasharray: "none",
                strokeOpacity: "1"
            }
        }, {
            children: [
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 22.5,11.63 L 22.5,6",
                    style: {
                        fill: "none",
                        stroke: "#000000",
                        strokeLinejoin: "miter"
                    },
                    id: "path6570"
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 22.5,25 C 22.5,25 27,17.5 25.5,14.5 C 25.5,14.5 24.5,12 22.5,12 C 20.5,12 19.5,14.5 19.5,14.5 C 18,17.5 22.5,25 22.5,25",
                    style: {
                        fill: "#000000",
                        fillOpacity: "1",
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 12.5,37 C 18,40.5 27,40.5 32.5,37 L 32.5,30 C 32.5,30 41.5,25.5 38.5,19.5 C 34.5,13 25,16 22.5,23.5 L 22.5,27 L 22.5,23.5 C 20,16 10.5,13 6.5,19.5 C 3.5,25.5 12.5,30 12.5,30 L 12.5,37",
                    style: {
                        fill: "#000000",
                        stroke: "#000000"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 20,8 L 25,8",
                    style: {
                        fill: "none",
                        stroke: "#000000",
                        strokeLinejoin: "miter"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 32,29.5 C 32,29.5 40.5,25.5 38.03,19.85 C 34.15,14 25,18 22.5,24.5 L 22.5,26.6 L 22.5,24.5 C 20,18 10.85,14 6.97,19.85 C 4.5,25.5 13,29.5 13,29.5",
                    style: {
                        fill: "none",
                        stroke: "#ffffff"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 12.5,30 C 18,27 27,27 32.5,30 M 12.5,33.5 C 18,30.5 27,30.5 32.5,33.5 M 12.5,37 C 18,34 27,34 32.5,37",
                    style: {
                        fill: "none",
                        stroke: "#ffffff"
                    }
                })
            ]
        }))
    }))
};
/**
 * Retrieves the coordinates at the centre of the requested square, relative to the top left of the board (0, 0).
 */ function $700bf53ed0e34a6e$var$getRelativeCoords(boardOrientation, boardWidth, square) {
    const squareWidth = boardWidth / 8;
    const columns = boardOrientation === "white" ? $700bf53ed0e34a6e$var$WHITE_COLUMN_VALUES : $700bf53ed0e34a6e$var$BLACK_COLUMN_VALUES;
    const rows = boardOrientation === "white" ? $700bf53ed0e34a6e$var$WHITE_ROWS : $700bf53ed0e34a6e$var$BLACK_ROWS;
    const x = columns[square[0]] * squareWidth + squareWidth / 2;
    const y = rows[parseInt(square[1], 10) - 1] * squareWidth + squareWidth / 2;
    return {
        x: x,
        y: y
    };
}
/**
 * Returns whether the passed position is different from the start position.
 */ function $700bf53ed0e34a6e$var$isDifferentFromStart(newPosition) {
    let isDifferent = false;
    Object.keys($700bf53ed0e34a6e$var$START_POSITION_OBJECT).forEach((square)=>{
        if (newPosition[square] !== $700bf53ed0e34a6e$var$START_POSITION_OBJECT[square]) isDifferent = true;
    });
    Object.keys(newPosition).forEach((square)=>{
        if ($700bf53ed0e34a6e$var$START_POSITION_OBJECT[square] !== newPosition[square]) isDifferent = true;
    });
    return isDifferent;
}
/**
 * Returns what pieces have been added and what pieces have been removed between board positions.
 */ function $700bf53ed0e34a6e$var$getPositionDifferences(currentPosition, newPosition) {
    const difference = {
        removed: {},
        added: {}
    };
    // removed from current
    Object.keys(currentPosition).forEach((square)=>{
        if (newPosition[square] !== currentPosition[square]) difference.removed[square] = currentPosition[square];
    });
    // added from new
    Object.keys(newPosition).forEach((square)=>{
        if (currentPosition[square] !== newPosition[square]) difference.added[square] = newPosition[square];
    });
    return difference;
}
/**
 * Converts a fen string or existing position object to a position object.
 */ function $700bf53ed0e34a6e$var$convertPositionToObject(position) {
    if (position === "start") return $700bf53ed0e34a6e$var$START_POSITION_OBJECT;
    if (typeof position === "string") // attempt to convert fen to position object
    return $700bf53ed0e34a6e$var$fenToObj(position);
    return position;
}
/**
 * Converts a fen string to a position object.
 */ function $700bf53ed0e34a6e$var$fenToObj(fen) {
    if (!$700bf53ed0e34a6e$var$isValidFen(fen)) return {};
    // cut off any move, castling, etc info from the end. we're only interested in position information
    fen = fen.replace(/ .+$/, "");
    const rows = fen.split("/");
    const position = {};
    let currentRow = 8;
    for(let i = 0; i < 8; i++){
        const row = rows[i].split("");
        let colIdx = 0;
        // loop through each character in the FEN section
        for(let j = 0; j < row.length; j++)// number / empty squares
        if (row[j].search(/[1-8]/) !== -1) {
            const numEmptySquares = parseInt(row[j], 10);
            colIdx = colIdx + numEmptySquares;
        } else {
            // piece
            const square = $700bf53ed0e34a6e$var$COLUMNS[colIdx] + currentRow;
            position[square] = $700bf53ed0e34a6e$var$fenToPieceCode(row[j]);
            colIdx = colIdx + 1;
        }
        currentRow = currentRow - 1;
    }
    return position;
}
/**
 * Returns whether string is valid fen notation.
 */ function $700bf53ed0e34a6e$var$isValidFen(fen) {
    // cut off any move, castling, etc info from the end. we're only interested in position information
    fen = fen.replace(/ .+$/, "");
    // expand the empty square numbers to just 1s
    fen = $700bf53ed0e34a6e$var$expandFenEmptySquares(fen);
    // fen should be 8 sections separated by slashes
    const chunks = fen.split("/");
    if (chunks.length !== 8) return false;
    // check each section
    for(let i = 0; i < 8; i++){
        if (chunks[i].length !== 8 || chunks[i].search(/[^kqrnbpKQRNBP1]/) !== -1) return false;
    }
    return true;
}
/**
 * Expand out fen notation to countable characters for validation
 */ function $700bf53ed0e34a6e$var$expandFenEmptySquares(fen) {
    return fen.replace(/8/g, "11111111").replace(/7/g, "1111111").replace(/6/g, "111111").replace(/5/g, "11111").replace(/4/g, "1111").replace(/3/g, "111").replace(/2/g, "11");
}
/**
 * Convert fen piece code to camel case notation. e.g. bP, wK.
 */ function $700bf53ed0e34a6e$var$fenToPieceCode(piece) {
    // black piece
    if (piece.toLowerCase() === piece) return "b" + piece.toUpperCase();
    // white piece
    return "w" + piece.toUpperCase();
}
const $700bf53ed0e34a6e$var$useArrows = (customArrows, areArrowsAllowed = true, onArrowsChange, customArrowColor)=>{
    // arrows passed programatically to `ChessBoard` as a react prop
    const [customArrowsSet, setCustomArrows] = (0, $bh6RR.useState)([]);
    // arrows drawn with mouse by user on the board
    const [arrows, setArrows] = (0, $bh6RR.useState)([]);
    // active arrow which user draws while dragging mouse
    const [newArrow, setNewArrow] = (0, $bh6RR.useState)();
    // handle external `customArrows` props changes
    (0, $bh6RR.useEffect)(()=>{
        if (Array.isArray(customArrows)) {
            // so that custom arrows overwrite temporary arrows
            clearArrows();
            setCustomArrows(//filter out arrows which starts and ends in the same square
            customArrows === null || customArrows === void 0 ? void 0 : customArrows.filter((arrow)=>arrow[0] !== arrow[1]));
        }
    }, [
        customArrows
    ]);
    // callback when arrows changed after user interaction
    (0, $bh6RR.useEffect)(()=>{
        onArrowsChange === null || onArrowsChange === void 0 || onArrowsChange(arrows);
    }, [
        arrows
    ]);
    // function clears all arrows drawed by user
    function clearArrows() {
        setArrows([]);
        setNewArrow(undefined);
    }
    const drawNewArrow = (fromSquare, toSquare)=>{
        if (!areArrowsAllowed) return;
        setNewArrow([
            fromSquare,
            toSquare,
            customArrowColor
        ]);
    };
    const allBoardArrows = [
        ...arrows,
        ...customArrowsSet
    ];
    const onArrowDrawEnd = (fromSquare, toSquare)=>{
        if (fromSquare === toSquare || !areArrowsAllowed) return;
        let arrowsCopy;
        const newArrow = [
            fromSquare,
            toSquare,
            customArrowColor
        ];
        const isNewArrowUnique = allBoardArrows.every(([arrowFrom, arrowTo])=>{
            return !(arrowFrom === fromSquare && arrowTo === toSquare);
        });
        // add the newArrow to arrows array if it is unique
        if (isNewArrowUnique) arrowsCopy = [
            ...arrows,
            newArrow
        ];
        else arrowsCopy = arrows.filter(([arrowFrom, arrowTo])=>{
            return !(arrowFrom === fromSquare && arrowTo === toSquare);
        });
        setNewArrow(undefined);
        setArrows(arrowsCopy);
    };
    return {
        arrows: allBoardArrows,
        newArrow: newArrow,
        clearArrows: clearArrows,
        drawNewArrow: drawNewArrow,
        setArrows: setArrows,
        onArrowDrawEnd: onArrowDrawEnd
    };
};
const $700bf53ed0e34a6e$var$ChessboardContext = (0, $bh6RR.createContext)({});
const $700bf53ed0e34a6e$var$useChessboard = ()=>(0, $bh6RR.useContext)($700bf53ed0e34a6e$var$ChessboardContext);
const $700bf53ed0e34a6e$var$ChessboardProvider = (0, $bh6RR.forwardRef)(({ allowDragOutsideBoard: allowDragOutsideBoard = true , animationDuration: animationDuration = 300 , areArrowsAllowed: areArrowsAllowed = true , arePiecesDraggable: arePiecesDraggable = true , arePremovesAllowed: arePremovesAllowed = false , autoPromoteToQueen: autoPromoteToQueen = false , boardOrientation: boardOrientation = "white" , boardWidth: boardWidth , children: children , clearPremovesOnRightClick: clearPremovesOnRightClick = true , customArrows: customArrows , customArrowColor: customArrowColor = "rgb(255,170,0)" , customBoardStyle: customBoardStyle , customNotationStyle: customNotationStyle , customDarkSquareStyle: customDarkSquareStyle = {
    backgroundColor: "#B58863"
} , customDropSquareStyle: customDropSquareStyle = {
    boxShadow: "inset 0 0 1px 6px rgba(255,255,255,0.75)"
} , customLightSquareStyle: customLightSquareStyle = {
    backgroundColor: "#F0D9B5"
} , customPieces: customPieces , customPremoveDarkSquareStyle: customPremoveDarkSquareStyle = {
    backgroundColor: "#A42323"
} , customPremoveLightSquareStyle: customPremoveLightSquareStyle = {
    backgroundColor: "#BD2828"
} , customSquare: customSquare = "div" , customSquareStyles: customSquareStyles , dropOffBoardAction: dropOffBoardAction = "snapback" , id: id = 0 , isDraggablePiece: isDraggablePiece = ()=>true , getPositionObject: getPositionObject = ()=>{} , onArrowsChange: onArrowsChange = ()=>{} , onDragOverSquare: onDragOverSquare = ()=>{} , onMouseOutSquare: onMouseOutSquare = ()=>{} , onMouseOverSquare: onMouseOverSquare = ()=>{} , onPieceClick: onPieceClick = ()=>{} , onPieceDragBegin: onPieceDragBegin = ()=>{} , onPieceDragEnd: onPieceDragEnd = ()=>{} , onPieceDrop: onPieceDrop = ()=>true , onPieceDropOffBoard: onPieceDropOffBoard = ()=>{} , onPromotionCheck: onPromotionCheck = (sourceSquare, targetSquare, piece)=>{
    return (piece === "wP" && sourceSquare[1] === "7" && targetSquare[1] === "8" || piece === "bP" && sourceSquare[1] === "2" && targetSquare[1] === "1") && Math.abs(sourceSquare.charCodeAt(0) - targetSquare.charCodeAt(0)) <= 1;
} , onPromotionPieceSelect: onPromotionPieceSelect = ()=>true , onSparePieceDrop: onSparePieceDrop = ()=>true , onSquareClick: onSquareClick = ()=>{} , onSquareRightClick: onSquareRightClick = ()=>{} , position: position = "start" , promotionDialogVariant: promotionDialogVariant = "default" , promotionToSquare: promotionToSquare = null , showBoardNotation: showBoardNotation = true , showPromotionDialog: showPromotionDialog = false , snapToCursor: snapToCursor = true  }, ref)=>{
    // position stored and displayed on board
    const [currentPosition, setCurrentPosition] = (0, $bh6RR.useState)($700bf53ed0e34a6e$var$convertPositionToObject(position));
    // calculated differences between current and incoming positions
    const [positionDifferences, setPositionDifferences] = (0, $bh6RR.useState)({
        removed: {},
        added: {}
    });
    // colour of last piece moved to determine if premoving
    const [lastPieceColour, setLastPieceColour] = (0, $bh6RR.useState)(undefined);
    // show / hide promotion dialog
    const [showPromoteDialog, setShowPromoteDialog] = (0, $bh6RR.useState)(showPromotionDialog && !autoPromoteToQueen);
    // which square a pawn is being promoted to
    const [promoteFromSquare, setPromoteFromSquare] = (0, $bh6RR.useState)(null);
    const [promoteToSquare, setPromoteToSquare] = (0, $bh6RR.useState)(promotionToSquare);
    // current premoves
    const [premoves, setPremoves] = (0, $bh6RR.useState)([]);
    // ref used to access current value during timeouts (closures)
    const premovesRef = (0, $bh6RR.useRef)(premoves);
    // current right mouse down square
    const [currentRightClickDown, setCurrentRightClickDown] = (0, $bh6RR.useState)();
    // chess pieces/styling
    const [chessPieces, setChessPieces] = (0, $bh6RR.useState)(Object.assign(Object.assign({}, $700bf53ed0e34a6e$var$defaultPieces), customPieces));
    // whether the last move was a manual drop or not
    const [wasManualDrop, setWasManualDrop] = (0, $bh6RR.useState)(false);
    // the most recent timeout whilst waiting for animation to complete
    const [previousTimeout, setPreviousTimeout] = (0, $bh6RR.useState)();
    // if currently waiting for an animation to finish
    const [isWaitingForAnimation, setIsWaitingForAnimation] = (0, $bh6RR.useState)(false);
    // last square dragged over for checking in touch events
    const [lastSquareDraggedOver, setLastSquareDraggedOver] = (0, $bh6RR.useState)(null);
    // open clearPremoves() to allow user to call on undo/reset/whenever
    (0, $bh6RR.useImperativeHandle)(ref, ()=>({
            clearPremoves (clearLastPieceColour = true) {
                clearPremoves(clearLastPieceColour);
            }
        }));
    // handle custom pieces change
    (0, $bh6RR.useEffect)(()=>{
        setChessPieces(Object.assign(Object.assign({}, $700bf53ed0e34a6e$var$defaultPieces), customPieces));
    }, [
        customPieces
    ]);
    // handle promote changes
    (0, $bh6RR.useEffect)(()=>{
        setShowPromoteDialog(showPromotionDialog);
        setPromoteToSquare(promotionToSquare);
    }, [
        promotionToSquare,
        showPromotionDialog
    ]);
    // handle external position change
    (0, $bh6RR.useEffect)(()=>{
        var _a, _b, _c;
        // clear any open promotion dialogs
        clearPromotion();
        const newPosition = $700bf53ed0e34a6e$var$convertPositionToObject(position);
        const differences = $700bf53ed0e34a6e$var$getPositionDifferences(currentPosition, newPosition);
        const newPieceColour = ((_a = Object.keys(differences.added)) === null || _a === void 0 ? void 0 : _a.length) <= 2 ? (_c = (_b = Object.entries(differences.added)) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c[1][0] : undefined;
        // external move has come in before animation is over
        // cancel animation and immediately update position
        if (isWaitingForAnimation) {
            setCurrentPosition(newPosition);
            setIsWaitingForAnimation(false);
            arePremovesAllowed && attemptPremove(newPieceColour);
            if (previousTimeout) clearTimeout(previousTimeout);
        } else // move was made using drag and drop
        if (wasManualDrop) {
            setCurrentPosition(newPosition);
            setIsWaitingForAnimation(false);
            arePremovesAllowed && attemptPremove(newPieceColour);
        } else {
            // move was made by external position change
            // if position === start then don't override newPieceColour
            // needs isDifferentFromStart in scenario where premoves have been cleared upon board reset but first move is made by computer, the last move colour would need to be updated
            if ($700bf53ed0e34a6e$var$isDifferentFromStart(newPosition) && lastPieceColour !== undefined) setLastPieceColour(newPieceColour);
            else if (!$700bf53ed0e34a6e$var$isDifferentFromStart(newPosition)) // position === start, likely a board reset. set to black to allow black to make premoves on first move
            setLastPieceColour("b");
            else setLastPieceColour(undefined);
            setPositionDifferences(differences);
            // animate external move
            setIsWaitingForAnimation(true);
            const newTimeout = setTimeout(()=>{
                setCurrentPosition(newPosition);
                setIsWaitingForAnimation(false);
                arePremovesAllowed && attemptPremove(newPieceColour);
            }, animationDuration);
            setPreviousTimeout(newTimeout);
        }
        // reset manual drop, ready for next move to be made by user or external
        setWasManualDrop(false);
        // inform latest position information
        getPositionObject(newPosition);
        // clear arrows
        clearArrows();
        // clear timeout on unmount
        return ()=>{
            clearTimeout(previousTimeout);
        };
    }, [
        position
    ]);
    const { arrows: arrows , newArrow: newArrow , clearArrows: clearArrows , drawNewArrow: drawNewArrow , onArrowDrawEnd: onArrowDrawEnd  } = $700bf53ed0e34a6e$var$useArrows(customArrows, areArrowsAllowed, onArrowsChange, customArrowColor);
    // handle drop position change
    function handleSetPosition(sourceSq, targetSq, piece, wasManualDropOverride) {
        // if dropped back down, don't do anything
        if (sourceSq === targetSq) return;
        clearArrows();
        // if second move is made for same colour, or there are still premoves queued, then this move needs to be added to premove queue instead of played
        // premoves length check for colour is added in because white could make 3 premoves, and then black responds to the first move (changing the last piece colour) and then white pre-moves again
        if (arePremovesAllowed && isWaitingForAnimation || arePremovesAllowed && (lastPieceColour === piece[0] || premovesRef.current.filter((p)=>p.piece[0] === piece[0]).length > 0)) {
            const oldPremoves = [
                ...premovesRef.current
            ];
            oldPremoves.push({
                sourceSq: sourceSq,
                targetSq: targetSq,
                piece: piece
            });
            premovesRef.current = oldPremoves;
            setPremoves([
                ...oldPremoves
            ]);
            clearPromotion();
            return;
        }
        // if transitioning, don't allow new drop
        if (!arePremovesAllowed && isWaitingForAnimation) return;
        const newOnDropPosition = Object.assign({}, currentPosition);
        setWasManualDrop(!!wasManualDropOverride);
        setLastPieceColour(piece[0]);
        // if onPieceDrop function provided, execute it, position must be updated externally and captured by useEffect above for this move to show on board
        if (onPieceDrop.length) {
            const isValidMove = onPieceDrop(sourceSq, targetSq, piece);
            if (!isValidMove) {
                clearPremoves();
                setWasManualDrop(false);
            }
        } else {
            // delete source piece
            delete newOnDropPosition[sourceSq];
            // add piece in new position
            newOnDropPosition[targetSq] = piece;
            setCurrentPosition(newOnDropPosition);
        }
        clearPromotion();
        // inform latest position information
        getPositionObject(newOnDropPosition);
    }
    function deletePieceFromSquare(square) {
        const positionCopy = Object.assign({}, currentPosition);
        delete positionCopy[square];
        setCurrentPosition(positionCopy);
        // inform latest position information
        getPositionObject(positionCopy);
    }
    function attemptPremove(newPieceColour) {
        if (premovesRef.current.length === 0) return;
        // get current value of premove as this is called in a timeout so value may have changed since timeout was set
        const premove = premovesRef.current[0];
        // if premove is a differing colour to last move made, then this move can be made
        if (premove.piece[0] !== undefined && premove.piece[0] !== newPieceColour && onPieceDrop.length) {
            setLastPieceColour(premove.piece[0]);
            setWasManualDrop(true); // pre-move doesn't need animation
            const isValidMove = onPieceDrop(premove.sourceSq, premove.targetSq, premove.piece);
            // premove was successful and can be removed from queue
            if (isValidMove) {
                const oldPremoves = [
                    ...premovesRef.current
                ];
                oldPremoves.shift();
                premovesRef.current = oldPremoves;
                setPremoves([
                    ...oldPremoves
                ]);
            } else // premove wasn't successful, clear premove queue
            clearPremoves();
        }
    }
    function handleSparePieceDrop(piece, targetSq) {
        const isValidDrop = onSparePieceDrop(piece, targetSq);
        if (!isValidDrop) return;
        const newOnDropPosition = Object.assign({}, currentPosition);
        // add piece in new position
        newOnDropPosition[targetSq] = piece;
        setCurrentPosition(newOnDropPosition);
        // inform latest position information
        getPositionObject(newOnDropPosition);
    }
    function clearPremoves(clearLastPieceColour = true) {
        // don't clear when right clicking to clear, otherwise you won't be able to premove again before next go
        if (clearLastPieceColour) setLastPieceColour(undefined);
        premovesRef.current = [];
        setPremoves([]);
    }
    function clearPromotion() {
        setPromoteFromSquare(null);
        setPromoteToSquare(null);
        setShowPromoteDialog(false);
    }
    function onRightClickDown(square) {
        setCurrentRightClickDown(square);
    }
    function onRightClickUp(square) {
        if (currentRightClickDown) // same square, don't draw an arrow, but do clear premoves and run onSquareRightClick
        {
            if (currentRightClickDown === square) {
                setCurrentRightClickDown(undefined);
                clearPremovesOnRightClick && clearPremoves(false);
                onSquareRightClick(square);
                return;
            }
        } else setCurrentRightClickDown(undefined);
    }
    function clearCurrentRightClickDown() {
        setCurrentRightClickDown(undefined);
    }
    const ChessboardProviderContextValue = {
        allowDragOutsideBoard: allowDragOutsideBoard,
        animationDuration: animationDuration,
        arePiecesDraggable: arePiecesDraggable,
        arePremovesAllowed: arePremovesAllowed,
        arrows: arrows,
        autoPromoteToQueen: autoPromoteToQueen,
        boardOrientation: boardOrientation,
        boardWidth: boardWidth,
        chessPieces: chessPieces,
        clearArrows: clearArrows,
        clearCurrentRightClickDown: clearCurrentRightClickDown,
        currentPosition: currentPosition,
        currentRightClickDown: currentRightClickDown,
        customArrowColor: customArrowColor,
        customBoardStyle: customBoardStyle,
        customDarkSquareStyle: customDarkSquareStyle,
        customDropSquareStyle: customDropSquareStyle,
        customLightSquareStyle: customLightSquareStyle,
        customNotationStyle: customNotationStyle,
        customPremoveDarkSquareStyle: customPremoveDarkSquareStyle,
        customPremoveLightSquareStyle: customPremoveLightSquareStyle,
        customSquare: customSquare,
        customSquareStyles: customSquareStyles,
        deletePieceFromSquare: deletePieceFromSquare,
        drawNewArrow: drawNewArrow,
        dropOffBoardAction: dropOffBoardAction,
        handleSetPosition: handleSetPosition,
        handleSparePieceDrop: handleSparePieceDrop,
        id: id,
        isDraggablePiece: isDraggablePiece,
        isWaitingForAnimation: isWaitingForAnimation,
        lastPieceColour: lastPieceColour,
        lastSquareDraggedOver: lastSquareDraggedOver,
        newArrow: newArrow,
        onArrowDrawEnd: onArrowDrawEnd,
        onDragOverSquare: onDragOverSquare,
        onMouseOutSquare: onMouseOutSquare,
        onMouseOverSquare: onMouseOverSquare,
        onPieceClick: onPieceClick,
        onPieceDragBegin: onPieceDragBegin,
        onPieceDragEnd: onPieceDragEnd,
        onPieceDrop: onPieceDrop,
        onPieceDropOffBoard: onPieceDropOffBoard,
        onPromotionCheck: onPromotionCheck,
        onPromotionPieceSelect: onPromotionPieceSelect,
        onRightClickDown: onRightClickDown,
        onRightClickUp: onRightClickUp,
        onSparePieceDrop: onSparePieceDrop,
        onSquareClick: onSquareClick,
        positionDifferences: positionDifferences,
        premoves: premoves,
        promoteFromSquare: promoteFromSquare,
        promoteToSquare: promoteToSquare,
        promotionDialogVariant: promotionDialogVariant,
        setLastSquareDraggedOver: setLastSquareDraggedOver,
        setPromoteFromSquare: setPromoteFromSquare,
        setPromoteToSquare: setPromoteToSquare,
        setShowPromoteDialog: setShowPromoteDialog,
        showBoardNotation: showBoardNotation,
        showPromoteDialog: showPromoteDialog,
        snapToCursor: snapToCursor
    };
    return (0, $d4dab640dcbe486c$exports.jsx)($700bf53ed0e34a6e$var$ChessboardContext.Provider, Object.assign({
        value: ChessboardProviderContextValue
    }, {
        children: children
    }));
});
function $700bf53ed0e34a6e$var$Notation({ row: row , col: col  }) {
    const { boardOrientation: boardOrientation , boardWidth: boardWidth , customDarkSquareStyle: customDarkSquareStyle , customLightSquareStyle: customLightSquareStyle , customNotationStyle: customNotationStyle  } = $700bf53ed0e34a6e$var$useChessboard();
    const whiteColor = customLightSquareStyle.backgroundColor;
    const blackColor = customDarkSquareStyle.backgroundColor;
    const isRow = col === 0;
    const isColumn = row === 7;
    const isBottomLeftSquare = isRow && isColumn;
    function getRow() {
        return boardOrientation === "white" ? 8 - row : row + 1;
    }
    function getColumn() {
        return boardOrientation === "black" ? $700bf53ed0e34a6e$var$COLUMNS[7 - col] : $700bf53ed0e34a6e$var$COLUMNS[col];
    }
    function renderBottomLeft() {
        return (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
            children: [
                (0, $d4dab640dcbe486c$exports.jsx)("div", Object.assign({
                    style: Object.assign(Object.assign({
                        zIndex: 3,
                        position: "absolute"
                    }, {
                        color: whiteColor
                    }), $700bf53ed0e34a6e$var$numericStyle(boardWidth, customNotationStyle))
                }, {
                    children: getRow()
                })),
                (0, $d4dab640dcbe486c$exports.jsx)("div", Object.assign({
                    style: Object.assign(Object.assign({
                        zIndex: 3,
                        position: "absolute"
                    }, {
                        color: whiteColor
                    }), $700bf53ed0e34a6e$var$alphaStyle(boardWidth, customNotationStyle))
                }, {
                    children: getColumn()
                }))
            ]
        });
    }
    function renderLetters() {
        return (0, $d4dab640dcbe486c$exports.jsx)("div", Object.assign({
            style: Object.assign(Object.assign({
                userSelect: "none",
                zIndex: 3,
                position: "absolute"
            }, {
                color: col % 2 !== 0 ? blackColor : whiteColor
            }), $700bf53ed0e34a6e$var$alphaStyle(boardWidth, customNotationStyle))
        }, {
            children: getColumn()
        }));
    }
    function renderNumbers() {
        return (0, $d4dab640dcbe486c$exports.jsx)("div", Object.assign({
            style: Object.assign(Object.assign({
                userSelect: "none",
                zIndex: 3,
                position: "absolute"
            }, boardOrientation === "black" ? {
                color: row % 2 === 0 ? blackColor : whiteColor
            } : {
                color: row % 2 === 0 ? blackColor : whiteColor
            }), $700bf53ed0e34a6e$var$numericStyle(boardWidth, customNotationStyle))
        }, {
            children: getRow()
        }));
    }
    if (isBottomLeftSquare) return renderBottomLeft();
    if (isColumn) return renderLetters();
    if (isRow) return renderNumbers();
    return null;
}
const $700bf53ed0e34a6e$var$alphaStyle = (width, customNotationStyle)=>Object.assign({
        alignSelf: "flex-end",
        paddingLeft: width / 8 - width / 48,
        fontSize: width / 48
    }, customNotationStyle);
const $700bf53ed0e34a6e$var$numericStyle = (width, customNotationStyle)=>Object.assign({
        alignSelf: "flex-start",
        paddingRight: width / 8 - width / 48,
        fontSize: width / 48
    }, customNotationStyle);
/**
 * Create the React Context
 */ const $700bf53ed0e34a6e$var$DndContext = (0, $bh6RR.createContext)({
    dragDropManager: undefined
});
/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $700bf53ed0e34a6e$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + "use the non-minified dev environment for full errors. ";
}
// Inlined version of the `symbol-observable` polyfill
var $700bf53ed0e34a6e$var$$$observable = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $700bf53ed0e34a6e$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var $700bf53ed0e34a6e$var$ActionTypes = {
    INIT: "@@redux/INIT" + $700bf53ed0e34a6e$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $700bf53ed0e34a6e$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $700bf53ed0e34a6e$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $700bf53ed0e34a6e$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $700bf53ed0e34a6e$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($700bf53ed0e34a6e$var$isDate(val)) return "date";
    if ($700bf53ed0e34a6e$var$isError(val)) return "error";
    var constructorName = $700bf53ed0e34a6e$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $700bf53ed0e34a6e$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $700bf53ed0e34a6e$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $700bf53ed0e34a6e$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $700bf53ed0e34a6e$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $700bf53ed0e34a6e$var$createStore(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($700bf53ed0e34a6e$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($700bf53ed0e34a6e$var$formatProdErrorMessage(1));
        return enhancer($700bf53ed0e34a6e$var$createStore)(reducer, preloadedState);
    }
    if (typeof reducer !== "function") throw new Error($700bf53ed0e34a6e$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($700bf53ed0e34a6e$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($700bf53ed0e34a6e$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($700bf53ed0e34a6e$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($700bf53ed0e34a6e$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$700bf53ed0e34a6e$var$isPlainObject(action)) throw new Error($700bf53ed0e34a6e$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($700bf53ed0e34a6e$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($700bf53ed0e34a6e$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($700bf53ed0e34a6e$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $700bf53ed0e34a6e$var$ActionTypes.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($700bf53ed0e34a6e$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$700bf53ed0e34a6e$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $700bf53ed0e34a6e$var$ActionTypes.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$700bf53ed0e34a6e$var$$$observable] = observable, _ref2;
}
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $700bf53ed0e34a6e$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */ function $700bf53ed0e34a6e$var$isCrushed() {}
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ function $700bf53ed0e34a6e$var$invariant(condition, format, ...args) {
    if ($700bf53ed0e34a6e$var$isProduction()) {
        if (format === undefined) throw new Error("invariant requires an error message argument");
    }
    if (!condition) {
        let error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            let argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = "Invariant Violation";
        }
        error.framesToPop = 1 // we don't care about invariant's own frame
        ;
        throw error;
    }
}
function $700bf53ed0e34a6e$var$isProduction() {
    return typeof $391299e0893a3dfa$exports !== "undefined" && true;
}
// cheap lodash replacements
/**
 * drop-in replacement for _.get
 * @param obj
 * @param path
 * @param defaultValue
 */ function $700bf53ed0e34a6e$var$get(obj, path, defaultValue) {
    return path.split(".").reduce((a, c)=>a && a[c] ? a[c] : defaultValue || null, obj);
}
/**
 * drop-in replacement for _.without
 */ function $700bf53ed0e34a6e$var$without$1(items, item) {
    return items.filter((i)=>i !== item);
}
/**
 * drop-in replacement for _.isString
 * @param input
 */ function $700bf53ed0e34a6e$var$isObject(input) {
    return typeof input === "object";
}
/**
 * replacement for _.xor
 * @param itemsA
 * @param itemsB
 */ function $700bf53ed0e34a6e$var$xor(itemsA, itemsB) {
    const map = new Map();
    const insertItem = (item)=>{
        map.set(item, map.has(item) ? map.get(item) + 1 : 1);
    };
    itemsA.forEach(insertItem);
    itemsB.forEach(insertItem);
    const result = [];
    map.forEach((count, key)=>{
        if (count === 1) result.push(key);
    });
    return result;
}
/**
 * replacement for _.intersection
 * @param itemsA
 * @param itemsB
 */ function $700bf53ed0e34a6e$var$intersection(itemsA, itemsB) {
    return itemsA.filter((t)=>itemsB.indexOf(t) > -1);
}
const $700bf53ed0e34a6e$var$INIT_COORDS = "dnd-core/INIT_COORDS";
const $700bf53ed0e34a6e$var$BEGIN_DRAG = "dnd-core/BEGIN_DRAG";
const $700bf53ed0e34a6e$var$PUBLISH_DRAG_SOURCE = "dnd-core/PUBLISH_DRAG_SOURCE";
const $700bf53ed0e34a6e$var$HOVER = "dnd-core/HOVER";
const $700bf53ed0e34a6e$var$DROP = "dnd-core/DROP";
const $700bf53ed0e34a6e$var$END_DRAG = "dnd-core/END_DRAG";
function $700bf53ed0e34a6e$var$setClientOffset(clientOffset, sourceClientOffset) {
    return {
        type: $700bf53ed0e34a6e$var$INIT_COORDS,
        payload: {
            sourceClientOffset: sourceClientOffset || null,
            clientOffset: clientOffset || null
        }
    };
}
const $700bf53ed0e34a6e$var$ResetCoordinatesAction = {
    type: $700bf53ed0e34a6e$var$INIT_COORDS,
    payload: {
        clientOffset: null,
        sourceClientOffset: null
    }
};
function $700bf53ed0e34a6e$var$createBeginDrag(manager) {
    return function beginDrag(sourceIds = [], options = {
        publishSource: true
    }) {
        const { publishSource: publishSource = true , clientOffset: clientOffset , getSourceClientOffset: getSourceClientOffset  } = options;
        const monitor = manager.getMonitor();
        const registry = manager.getRegistry();
        // Initialize the coordinates using the client offset
        manager.dispatch($700bf53ed0e34a6e$var$setClientOffset(clientOffset));
        $700bf53ed0e34a6e$var$verifyInvariants$1(sourceIds, monitor, registry);
        // Get the draggable source
        const sourceId = $700bf53ed0e34a6e$var$getDraggableSource(sourceIds, monitor);
        if (sourceId == null) {
            manager.dispatch($700bf53ed0e34a6e$var$ResetCoordinatesAction);
            return;
        }
        // Get the source client offset
        let sourceClientOffset = null;
        if (clientOffset) {
            if (!getSourceClientOffset) throw new Error("getSourceClientOffset must be defined");
            $700bf53ed0e34a6e$var$verifyGetSourceClientOffsetIsFunction(getSourceClientOffset);
            sourceClientOffset = getSourceClientOffset(sourceId);
        }
        // Initialize the full coordinates
        manager.dispatch($700bf53ed0e34a6e$var$setClientOffset(clientOffset, sourceClientOffset));
        const source = registry.getSource(sourceId);
        const item = source.beginDrag(monitor, sourceId);
        // If source.beginDrag returns null, this is an indicator to cancel the drag
        if (item == null) return undefined;
        $700bf53ed0e34a6e$var$verifyItemIsObject(item);
        registry.pinSource(sourceId);
        const itemType = registry.getSourceType(sourceId);
        return {
            type: $700bf53ed0e34a6e$var$BEGIN_DRAG,
            payload: {
                itemType: itemType,
                item: item,
                sourceId: sourceId,
                clientOffset: clientOffset || null,
                sourceClientOffset: sourceClientOffset || null,
                isSourcePublic: !!publishSource
            }
        };
    };
}
function $700bf53ed0e34a6e$var$verifyInvariants$1(sourceIds, monitor, registry) {
    $700bf53ed0e34a6e$var$invariant(!monitor.isDragging(), "Cannot call beginDrag while dragging.");
    sourceIds.forEach(function(sourceId) {
        $700bf53ed0e34a6e$var$invariant(registry.getSource(sourceId), "Expected sourceIds to be registered.");
    });
}
function $700bf53ed0e34a6e$var$verifyGetSourceClientOffsetIsFunction(getSourceClientOffset) {
    $700bf53ed0e34a6e$var$invariant(typeof getSourceClientOffset === "function", "When clientOffset is provided, getSourceClientOffset must be a function.");
}
function $700bf53ed0e34a6e$var$verifyItemIsObject(item) {
    $700bf53ed0e34a6e$var$invariant($700bf53ed0e34a6e$var$isObject(item), "Item must be an object.");
}
function $700bf53ed0e34a6e$var$getDraggableSource(sourceIds, monitor) {
    let sourceId = null;
    for(let i = sourceIds.length - 1; i >= 0; i--)if (monitor.canDragSource(sourceIds[i])) {
        sourceId = sourceIds[i];
        break;
    }
    return sourceId;
}
function $700bf53ed0e34a6e$var$_defineProperty$4(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $700bf53ed0e34a6e$var$_objectSpread$4(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $700bf53ed0e34a6e$var$_defineProperty$4(target, key, source[key]);
        });
    }
    return target;
}
function $700bf53ed0e34a6e$var$createDrop(manager) {
    return function drop(options = {}) {
        const monitor = manager.getMonitor();
        const registry = manager.getRegistry();
        $700bf53ed0e34a6e$var$verifyInvariants(monitor);
        const targetIds = $700bf53ed0e34a6e$var$getDroppableTargets(monitor);
        // Multiple actions are dispatched here, which is why this doesn't return an action
        targetIds.forEach((targetId, index)=>{
            const dropResult = $700bf53ed0e34a6e$var$determineDropResult(targetId, index, registry, monitor);
            const action = {
                type: $700bf53ed0e34a6e$var$DROP,
                payload: {
                    dropResult: $700bf53ed0e34a6e$var$_objectSpread$4({}, options, dropResult)
                }
            };
            manager.dispatch(action);
        });
    };
}
function $700bf53ed0e34a6e$var$verifyInvariants(monitor) {
    $700bf53ed0e34a6e$var$invariant(monitor.isDragging(), "Cannot call drop while not dragging.");
    $700bf53ed0e34a6e$var$invariant(!monitor.didDrop(), "Cannot call drop twice during one drag operation.");
}
function $700bf53ed0e34a6e$var$determineDropResult(targetId, index, registry, monitor) {
    const target = registry.getTarget(targetId);
    let dropResult = target ? target.drop(monitor, targetId) : undefined;
    $700bf53ed0e34a6e$var$verifyDropResultType(dropResult);
    if (typeof dropResult === "undefined") dropResult = index === 0 ? {} : monitor.getDropResult();
    return dropResult;
}
function $700bf53ed0e34a6e$var$verifyDropResultType(dropResult) {
    $700bf53ed0e34a6e$var$invariant(typeof dropResult === "undefined" || $700bf53ed0e34a6e$var$isObject(dropResult), "Drop result must either be an object or undefined.");
}
function $700bf53ed0e34a6e$var$getDroppableTargets(monitor) {
    const targetIds = monitor.getTargetIds().filter(monitor.canDropOnTarget, monitor);
    targetIds.reverse();
    return targetIds;
}
function $700bf53ed0e34a6e$var$createEndDrag(manager) {
    return function endDrag() {
        const monitor = manager.getMonitor();
        const registry = manager.getRegistry();
        $700bf53ed0e34a6e$var$verifyIsDragging(monitor);
        const sourceId = monitor.getSourceId();
        if (sourceId != null) {
            const source = registry.getSource(sourceId, true);
            source.endDrag(monitor, sourceId);
            registry.unpinSource();
        }
        return {
            type: $700bf53ed0e34a6e$var$END_DRAG
        };
    };
}
function $700bf53ed0e34a6e$var$verifyIsDragging(monitor) {
    $700bf53ed0e34a6e$var$invariant(monitor.isDragging(), "Cannot call endDrag while not dragging.");
}
function $700bf53ed0e34a6e$var$matchesType(targetType, draggedItemType) {
    if (draggedItemType === null) return targetType === null;
    return Array.isArray(targetType) ? targetType.some((t)=>t === draggedItemType) : targetType === draggedItemType;
}
function $700bf53ed0e34a6e$var$createHover(manager) {
    return function hover(targetIdsArg, { clientOffset: clientOffset  } = {}) {
        $700bf53ed0e34a6e$var$verifyTargetIdsIsArray(targetIdsArg);
        const targetIds = targetIdsArg.slice(0);
        const monitor = manager.getMonitor();
        const registry = manager.getRegistry();
        const draggedItemType = monitor.getItemType();
        $700bf53ed0e34a6e$var$removeNonMatchingTargetIds(targetIds, registry, draggedItemType);
        $700bf53ed0e34a6e$var$checkInvariants(targetIds, monitor, registry);
        $700bf53ed0e34a6e$var$hoverAllTargets(targetIds, monitor, registry);
        return {
            type: $700bf53ed0e34a6e$var$HOVER,
            payload: {
                targetIds: targetIds,
                clientOffset: clientOffset || null
            }
        };
    };
}
function $700bf53ed0e34a6e$var$verifyTargetIdsIsArray(targetIdsArg) {
    $700bf53ed0e34a6e$var$invariant(Array.isArray(targetIdsArg), "Expected targetIds to be an array.");
}
function $700bf53ed0e34a6e$var$checkInvariants(targetIds, monitor, registry) {
    $700bf53ed0e34a6e$var$invariant(monitor.isDragging(), "Cannot call hover while not dragging.");
    $700bf53ed0e34a6e$var$invariant(!monitor.didDrop(), "Cannot call hover after drop.");
    for(let i = 0; i < targetIds.length; i++){
        const targetId = targetIds[i];
        $700bf53ed0e34a6e$var$invariant(targetIds.lastIndexOf(targetId) === i, "Expected targetIds to be unique in the passed array.");
        const target = registry.getTarget(targetId);
        $700bf53ed0e34a6e$var$invariant(target, "Expected targetIds to be registered.");
    }
}
function $700bf53ed0e34a6e$var$removeNonMatchingTargetIds(targetIds, registry, draggedItemType) {
    // Remove those targetIds that don't match the targetType.  This
    // fixes shallow isOver which would only be non-shallow because of
    // non-matching targets.
    for(let i = targetIds.length - 1; i >= 0; i--){
        const targetId = targetIds[i];
        const targetType = registry.getTargetType(targetId);
        if (!$700bf53ed0e34a6e$var$matchesType(targetType, draggedItemType)) targetIds.splice(i, 1);
    }
}
function $700bf53ed0e34a6e$var$hoverAllTargets(targetIds, monitor, registry) {
    // Finally call hover on all matching targets.
    targetIds.forEach(function(targetId) {
        const target = registry.getTarget(targetId);
        target.hover(monitor, targetId);
    });
}
function $700bf53ed0e34a6e$var$createPublishDragSource(manager) {
    return function publishDragSource() {
        const monitor = manager.getMonitor();
        if (monitor.isDragging()) return {
            type: $700bf53ed0e34a6e$var$PUBLISH_DRAG_SOURCE
        };
        return;
    };
}
function $700bf53ed0e34a6e$var$createDragDropActions(manager) {
    return {
        beginDrag: $700bf53ed0e34a6e$var$createBeginDrag(manager),
        publishDragSource: $700bf53ed0e34a6e$var$createPublishDragSource(manager),
        hover: $700bf53ed0e34a6e$var$createHover(manager),
        drop: $700bf53ed0e34a6e$var$createDrop(manager),
        endDrag: $700bf53ed0e34a6e$var$createEndDrag(manager)
    };
}
class $700bf53ed0e34a6e$var$DragDropManagerImpl {
    receiveBackend(backend) {
        this.backend = backend;
    }
    getMonitor() {
        return this.monitor;
    }
    getBackend() {
        return this.backend;
    }
    getRegistry() {
        return this.monitor.registry;
    }
    getActions() {
        /* eslint-disable-next-line @typescript-eslint/no-this-alias */ const manager = this;
        const { dispatch: dispatch  } = this.store;
        function bindActionCreator(actionCreator) {
            return (...args)=>{
                const action = actionCreator.apply(manager, args);
                if (typeof action !== "undefined") dispatch(action);
            };
        }
        const actions = $700bf53ed0e34a6e$var$createDragDropActions(this);
        return Object.keys(actions).reduce((boundActions, key)=>{
            const action = actions[key];
            boundActions[key] = bindActionCreator(action);
            return boundActions;
        }, {});
    }
    dispatch(action) {
        this.store.dispatch(action);
    }
    constructor(store, monitor){
        this.isSetUp = false;
        this.handleRefCountChange = ()=>{
            const shouldSetUp = this.store.getState().refCount > 0;
            if (this.backend) {
                if (shouldSetUp && !this.isSetUp) {
                    this.backend.setup();
                    this.isSetUp = true;
                } else if (!shouldSetUp && this.isSetUp) {
                    this.backend.teardown();
                    this.isSetUp = false;
                }
            }
        };
        this.store = store;
        this.monitor = monitor;
        store.subscribe(this.handleRefCountChange);
    }
}
/**
 * Coordinate addition
 * @param a The first coordinate
 * @param b The second coordinate
 */ function $700bf53ed0e34a6e$var$add(a, b) {
    return {
        x: a.x + b.x,
        y: a.y + b.y
    };
}
/**
 * Coordinate subtraction
 * @param a The first coordinate
 * @param b The second coordinate
 */ function $700bf53ed0e34a6e$var$subtract(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
/**
 * Returns the cartesian distance of the drag source component's position, based on its position
 * at the time when the current drag operation has started, and the movement difference.
 *
 * Returns null if no item is being dragged.
 *
 * @param state The offset state to compute from
 */ function $700bf53ed0e34a6e$var$getSourceClientOffset(state) {
    const { clientOffset: clientOffset , initialClientOffset: initialClientOffset , initialSourceClientOffset: initialSourceClientOffset  } = state;
    if (!clientOffset || !initialClientOffset || !initialSourceClientOffset) return null;
    return $700bf53ed0e34a6e$var$subtract($700bf53ed0e34a6e$var$add(clientOffset, initialSourceClientOffset), initialClientOffset);
}
/**
 * Determines the x,y offset between the client offset and the initial client offset
 *
 * @param state The offset state to compute from
 */ function $700bf53ed0e34a6e$var$getDifferenceFromInitialOffset(state) {
    const { clientOffset: clientOffset , initialClientOffset: initialClientOffset  } = state;
    if (!clientOffset || !initialClientOffset) return null;
    return $700bf53ed0e34a6e$var$subtract(clientOffset, initialClientOffset);
}
const $700bf53ed0e34a6e$var$NONE = [];
const $700bf53ed0e34a6e$var$ALL = [];
$700bf53ed0e34a6e$var$NONE.__IS_NONE__ = true;
$700bf53ed0e34a6e$var$ALL.__IS_ALL__ = true;
/**
 * Determines if the given handler IDs are dirty or not.
 *
 * @param dirtyIds The set of dirty handler ids
 * @param handlerIds The set of handler ids to check
 */ function $700bf53ed0e34a6e$var$areDirty(dirtyIds, handlerIds) {
    if (dirtyIds === $700bf53ed0e34a6e$var$NONE) return false;
    if (dirtyIds === $700bf53ed0e34a6e$var$ALL || typeof handlerIds === "undefined") return true;
    const commonIds = $700bf53ed0e34a6e$var$intersection(handlerIds, dirtyIds);
    return commonIds.length > 0;
}
class $700bf53ed0e34a6e$var$DragDropMonitorImpl {
    subscribeToStateChange(listener, options = {}) {
        const { handlerIds: handlerIds  } = options;
        $700bf53ed0e34a6e$var$invariant(typeof listener === "function", "listener must be a function.");
        $700bf53ed0e34a6e$var$invariant(typeof handlerIds === "undefined" || Array.isArray(handlerIds), "handlerIds, when specified, must be an array of strings.");
        let prevStateId = this.store.getState().stateId;
        const handleChange = ()=>{
            const state = this.store.getState();
            const currentStateId = state.stateId;
            try {
                const canSkipListener = currentStateId === prevStateId || currentStateId === prevStateId + 1 && !$700bf53ed0e34a6e$var$areDirty(state.dirtyHandlerIds, handlerIds);
                if (!canSkipListener) listener();
            } finally{
                prevStateId = currentStateId;
            }
        };
        return this.store.subscribe(handleChange);
    }
    subscribeToOffsetChange(listener) {
        $700bf53ed0e34a6e$var$invariant(typeof listener === "function", "listener must be a function.");
        let previousState = this.store.getState().dragOffset;
        const handleChange = ()=>{
            const nextState = this.store.getState().dragOffset;
            if (nextState === previousState) return;
            previousState = nextState;
            listener();
        };
        return this.store.subscribe(handleChange);
    }
    canDragSource(sourceId) {
        if (!sourceId) return false;
        const source = this.registry.getSource(sourceId);
        $700bf53ed0e34a6e$var$invariant(source, `Expected to find a valid source. sourceId=${sourceId}`);
        if (this.isDragging()) return false;
        return source.canDrag(this, sourceId);
    }
    canDropOnTarget(targetId) {
        // undefined on initial render
        if (!targetId) return false;
        const target = this.registry.getTarget(targetId);
        $700bf53ed0e34a6e$var$invariant(target, `Expected to find a valid target. targetId=${targetId}`);
        if (!this.isDragging() || this.didDrop()) return false;
        const targetType = this.registry.getTargetType(targetId);
        const draggedItemType = this.getItemType();
        return $700bf53ed0e34a6e$var$matchesType(targetType, draggedItemType) && target.canDrop(this, targetId);
    }
    isDragging() {
        return Boolean(this.getItemType());
    }
    isDraggingSource(sourceId) {
        // undefined on initial render
        if (!sourceId) return false;
        const source = this.registry.getSource(sourceId, true);
        $700bf53ed0e34a6e$var$invariant(source, `Expected to find a valid source. sourceId=${sourceId}`);
        if (!this.isDragging() || !this.isSourcePublic()) return false;
        const sourceType = this.registry.getSourceType(sourceId);
        const draggedItemType = this.getItemType();
        if (sourceType !== draggedItemType) return false;
        return source.isDragging(this, sourceId);
    }
    isOverTarget(targetId, options = {
        shallow: false
    }) {
        // undefined on initial render
        if (!targetId) return false;
        const { shallow: shallow  } = options;
        if (!this.isDragging()) return false;
        const targetType = this.registry.getTargetType(targetId);
        const draggedItemType = this.getItemType();
        if (draggedItemType && !$700bf53ed0e34a6e$var$matchesType(targetType, draggedItemType)) return false;
        const targetIds = this.getTargetIds();
        if (!targetIds.length) return false;
        const index = targetIds.indexOf(targetId);
        if (shallow) return index === targetIds.length - 1;
        else return index > -1;
    }
    getItemType() {
        return this.store.getState().dragOperation.itemType;
    }
    getItem() {
        return this.store.getState().dragOperation.item;
    }
    getSourceId() {
        return this.store.getState().dragOperation.sourceId;
    }
    getTargetIds() {
        return this.store.getState().dragOperation.targetIds;
    }
    getDropResult() {
        return this.store.getState().dragOperation.dropResult;
    }
    didDrop() {
        return this.store.getState().dragOperation.didDrop;
    }
    isSourcePublic() {
        return Boolean(this.store.getState().dragOperation.isSourcePublic);
    }
    getInitialClientOffset() {
        return this.store.getState().dragOffset.initialClientOffset;
    }
    getInitialSourceClientOffset() {
        return this.store.getState().dragOffset.initialSourceClientOffset;
    }
    getClientOffset() {
        return this.store.getState().dragOffset.clientOffset;
    }
    getSourceClientOffset() {
        return $700bf53ed0e34a6e$var$getSourceClientOffset(this.store.getState().dragOffset);
    }
    getDifferenceFromInitialOffset() {
        return $700bf53ed0e34a6e$var$getDifferenceFromInitialOffset(this.store.getState().dragOffset);
    }
    constructor(store, registry){
        this.store = store;
        this.registry = registry;
    }
}
// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
/* globals self */ const $700bf53ed0e34a6e$var$scope = typeof $parcel$global !== "undefined" ? $parcel$global : self;
const $700bf53ed0e34a6e$var$BrowserMutationObserver = $700bf53ed0e34a6e$var$scope.MutationObserver || $700bf53ed0e34a6e$var$scope.WebKitMutationObserver;
function $700bf53ed0e34a6e$var$makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        const timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        const intervalHandle = setInterval(handleTimer, 50);
        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}
// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function $700bf53ed0e34a6e$var$makeRequestCallFromMutationObserver(callback) {
    let toggle = 1;
    const observer = new $700bf53ed0e34a6e$var$BrowserMutationObserver(callback);
    const node = document.createTextNode("");
    observer.observe(node, {
        characterData: true
    });
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}
const $700bf53ed0e34a6e$var$makeRequestCall = typeof $700bf53ed0e34a6e$var$BrowserMutationObserver === "function" ? // They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
$700bf53ed0e34a6e$var$makeRequestCallFromMutationObserver : // 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.
// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396
// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
$700bf53ed0e34a6e$var$makeRequestCallFromTimer;
class $700bf53ed0e34a6e$var$AsapQueue {
    // Use the fastest means possible to execute a task in its own turn, with
    // priority over other events including IO, animation, reflow, and redraw
    // events in browsers.
    //
    // An exception thrown by a task will permanently interrupt the processing of
    // subsequent tasks. The higher level `asap` function ensures that if an
    // exception is thrown by a task, that the task queue will continue flushing as
    // soon as possible, but if you use `rawAsap` directly, you are responsible to
    // either ensure that no exceptions are thrown from your task, or to manually
    // call `rawAsap.requestFlush` if an exception is thrown.
    enqueueTask(task) {
        const { queue: q , requestFlush: requestFlush  } = this;
        if (!q.length) {
            requestFlush();
            this.flushing = true;
        }
        // Equivalent to push, but avoids a function call.
        q[q.length] = task;
    }
    constructor(){
        this.queue = [];
        // We queue errors to ensure they are thrown in right order (FIFO).
        // Array-as-queue is good enough here, since we are just dealing with exceptions.
        this.pendingErrors = [];
        // Once a flush has been requested, no further calls to `requestFlush` are
        // necessary until the next `flush` completes.
        // @ts-ignore
        this.flushing = false;
        // The position of the next task to execute in the task queue. This is
        // preserved between calls to `flush` so that it can be resumed if
        // a task throws an exception.
        this.index = 0;
        // If a task schedules additional tasks recursively, the task queue can grow
        // unbounded. To prevent memory exhaustion, the task queue will periodically
        // truncate already-completed tasks.
        this.capacity = 1024;
        // The flush function processes all tasks that have been scheduled with
        // `rawAsap` unless and until one of those tasks throws an exception.
        // If a task throws an exception, `flush` ensures that its state will remain
        // consistent and will resume where it left off when called again.
        // However, `flush` does not make any arrangements to be called again if an
        // exception is thrown.
        this.flush = ()=>{
            const { queue: q  } = this;
            while(this.index < q.length){
                const currentIndex = this.index;
                // Advance the index before calling the task. This ensures that we will
                // begin flushing on the next task the task throws an error.
                this.index++;
                q[currentIndex].call();
                // Prevent leaking memory for long chains of recursive calls to `asap`.
                // If we call `asap` within tasks scheduled by `asap`, the queue will
                // grow, but to avoid an O(n) walk for every task we execute, we don't
                // shift tasks off the queue after they have been executed.
                // Instead, we periodically shift 1024 tasks off the queue.
                if (this.index > this.capacity) {
                    // Manually shift all values starting at the index back to the
                    // beginning of the queue.
                    for(let scan = 0, newLength = q.length - this.index; scan < newLength; scan++)q[scan] = q[scan + this.index];
                    q.length -= this.index;
                    this.index = 0;
                }
            }
            q.length = 0;
            this.index = 0;
            this.flushing = false;
        };
        // In a web browser, exceptions are not fatal. However, to avoid
        // slowing down the queue of pending tasks, we rethrow the error in a
        // lower priority turn.
        this.registerPendingError = (err)=>{
            this.pendingErrors.push(err);
            this.requestErrorThrow();
        };
        // `requestFlush` requests that the high priority event queue be flushed as
        // soon as possible.
        // This is useful to prevent an error thrown in a task from stalling the event
        // queue if the exception handled by Node.js’s
        // `process.on("uncaughtException")` or by a domain.
        // `requestFlush` is implemented using a strategy based on data collected from
        // every available SauceLabs Selenium web driver worker at time of writing.
        // https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
        this.requestFlush = $700bf53ed0e34a6e$var$makeRequestCall(this.flush);
        this.requestErrorThrow = $700bf53ed0e34a6e$var$makeRequestCallFromTimer(()=>{
            // Throw first error
            if (this.pendingErrors.length) throw this.pendingErrors.shift();
        });
    }
} // The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html
// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.
// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }
// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.
// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }
// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.
// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.
// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// // its existence.
// rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer
// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
// `call`, just like a function.
class $700bf53ed0e34a6e$var$RawTask {
    call() {
        try {
            this.task && this.task();
        } catch (error) {
            this.onError(error);
        } finally{
            this.task = null;
            this.release(this);
        }
    }
    constructor(onError, release){
        this.onError = onError;
        this.release = release;
        this.task = null;
    }
}
class $700bf53ed0e34a6e$var$TaskFactory {
    create(task) {
        const tasks = this.freeTasks;
        const t1 = tasks.length ? tasks.pop() : new $700bf53ed0e34a6e$var$RawTask(this.onError, (t)=>tasks[tasks.length] = t);
        t1.task = task;
        return t1;
    }
    constructor(onError){
        this.onError = onError;
        this.freeTasks = [];
    }
}
const $700bf53ed0e34a6e$var$asapQueue = new $700bf53ed0e34a6e$var$AsapQueue();
const $700bf53ed0e34a6e$var$taskFactory = new $700bf53ed0e34a6e$var$TaskFactory($700bf53ed0e34a6e$var$asapQueue.registerPendingError);
/**
 * Calls a task as soon as possible after returning, in its own event, with priority
 * over other events like animation, reflow, and repaint. An error thrown from an
 * event will not interrupt, nor even substantially slow down the processing of
 * other events, but will be rather postponed to a lower priority event.
 * @param {{call}} task A callable object, typically a function that takes no
 * arguments.
 */ function $700bf53ed0e34a6e$var$asap(task) {
    $700bf53ed0e34a6e$var$asapQueue.enqueueTask($700bf53ed0e34a6e$var$taskFactory.create(task));
}
const $700bf53ed0e34a6e$var$ADD_SOURCE = "dnd-core/ADD_SOURCE";
const $700bf53ed0e34a6e$var$ADD_TARGET = "dnd-core/ADD_TARGET";
const $700bf53ed0e34a6e$var$REMOVE_SOURCE = "dnd-core/REMOVE_SOURCE";
const $700bf53ed0e34a6e$var$REMOVE_TARGET = "dnd-core/REMOVE_TARGET";
function $700bf53ed0e34a6e$var$addSource(sourceId) {
    return {
        type: $700bf53ed0e34a6e$var$ADD_SOURCE,
        payload: {
            sourceId: sourceId
        }
    };
}
function $700bf53ed0e34a6e$var$addTarget(targetId) {
    return {
        type: $700bf53ed0e34a6e$var$ADD_TARGET,
        payload: {
            targetId: targetId
        }
    };
}
function $700bf53ed0e34a6e$var$removeSource(sourceId) {
    return {
        type: $700bf53ed0e34a6e$var$REMOVE_SOURCE,
        payload: {
            sourceId: sourceId
        }
    };
}
function $700bf53ed0e34a6e$var$removeTarget(targetId) {
    return {
        type: $700bf53ed0e34a6e$var$REMOVE_TARGET,
        payload: {
            targetId: targetId
        }
    };
}
function $700bf53ed0e34a6e$var$validateSourceContract(source) {
    $700bf53ed0e34a6e$var$invariant(typeof source.canDrag === "function", "Expected canDrag to be a function.");
    $700bf53ed0e34a6e$var$invariant(typeof source.beginDrag === "function", "Expected beginDrag to be a function.");
    $700bf53ed0e34a6e$var$invariant(typeof source.endDrag === "function", "Expected endDrag to be a function.");
}
function $700bf53ed0e34a6e$var$validateTargetContract(target) {
    $700bf53ed0e34a6e$var$invariant(typeof target.canDrop === "function", "Expected canDrop to be a function.");
    $700bf53ed0e34a6e$var$invariant(typeof target.hover === "function", "Expected hover to be a function.");
    $700bf53ed0e34a6e$var$invariant(typeof target.drop === "function", "Expected beginDrag to be a function.");
}
function $700bf53ed0e34a6e$var$validateType(type, allowArray) {
    if (allowArray && Array.isArray(type)) {
        type.forEach((t)=>$700bf53ed0e34a6e$var$validateType(t, false));
        return;
    }
    $700bf53ed0e34a6e$var$invariant(typeof type === "string" || typeof type === "symbol", allowArray ? "Type can only be a string, a symbol, or an array of either." : "Type can only be a string or a symbol.");
}
var $700bf53ed0e34a6e$var$HandlerRole;
(function(HandlerRole) {
    HandlerRole["SOURCE"] = "SOURCE";
    HandlerRole["TARGET"] = "TARGET";
})($700bf53ed0e34a6e$var$HandlerRole || ($700bf53ed0e34a6e$var$HandlerRole = {}));
let $700bf53ed0e34a6e$var$nextUniqueId = 0;
function $700bf53ed0e34a6e$var$getNextUniqueId() {
    return $700bf53ed0e34a6e$var$nextUniqueId++;
}
function $700bf53ed0e34a6e$var$getNextHandlerId(role) {
    const id = $700bf53ed0e34a6e$var$getNextUniqueId().toString();
    switch(role){
        case $700bf53ed0e34a6e$var$HandlerRole.SOURCE:
            return `S${id}`;
        case $700bf53ed0e34a6e$var$HandlerRole.TARGET:
            return `T${id}`;
        default:
            throw new Error(`Unknown Handler Role: ${role}`);
    }
}
function $700bf53ed0e34a6e$var$parseRoleFromHandlerId(handlerId) {
    switch(handlerId[0]){
        case "S":
            return $700bf53ed0e34a6e$var$HandlerRole.SOURCE;
        case "T":
            return $700bf53ed0e34a6e$var$HandlerRole.TARGET;
        default:
            throw new Error(`Cannot parse handler ID: ${handlerId}`);
    }
}
function $700bf53ed0e34a6e$var$mapContainsValue(map, searchValue) {
    const entries = map.entries();
    let isDone = false;
    do {
        const { done: done , value: [, value]  } = entries.next();
        if (value === searchValue) return true;
        isDone = !!done;
    }while (!isDone);
    return false;
}
class $700bf53ed0e34a6e$var$HandlerRegistryImpl {
    addSource(type, source) {
        $700bf53ed0e34a6e$var$validateType(type);
        $700bf53ed0e34a6e$var$validateSourceContract(source);
        const sourceId = this.addHandler($700bf53ed0e34a6e$var$HandlerRole.SOURCE, type, source);
        this.store.dispatch($700bf53ed0e34a6e$var$addSource(sourceId));
        return sourceId;
    }
    addTarget(type, target) {
        $700bf53ed0e34a6e$var$validateType(type, true);
        $700bf53ed0e34a6e$var$validateTargetContract(target);
        const targetId = this.addHandler($700bf53ed0e34a6e$var$HandlerRole.TARGET, type, target);
        this.store.dispatch($700bf53ed0e34a6e$var$addTarget(targetId));
        return targetId;
    }
    containsHandler(handler) {
        return $700bf53ed0e34a6e$var$mapContainsValue(this.dragSources, handler) || $700bf53ed0e34a6e$var$mapContainsValue(this.dropTargets, handler);
    }
    getSource(sourceId, includePinned = false) {
        $700bf53ed0e34a6e$var$invariant(this.isSourceId(sourceId), "Expected a valid source ID.");
        const isPinned = includePinned && sourceId === this.pinnedSourceId;
        const source = isPinned ? this.pinnedSource : this.dragSources.get(sourceId);
        return source;
    }
    getTarget(targetId) {
        $700bf53ed0e34a6e$var$invariant(this.isTargetId(targetId), "Expected a valid target ID.");
        return this.dropTargets.get(targetId);
    }
    getSourceType(sourceId) {
        $700bf53ed0e34a6e$var$invariant(this.isSourceId(sourceId), "Expected a valid source ID.");
        return this.types.get(sourceId);
    }
    getTargetType(targetId) {
        $700bf53ed0e34a6e$var$invariant(this.isTargetId(targetId), "Expected a valid target ID.");
        return this.types.get(targetId);
    }
    isSourceId(handlerId) {
        const role = $700bf53ed0e34a6e$var$parseRoleFromHandlerId(handlerId);
        return role === $700bf53ed0e34a6e$var$HandlerRole.SOURCE;
    }
    isTargetId(handlerId) {
        const role = $700bf53ed0e34a6e$var$parseRoleFromHandlerId(handlerId);
        return role === $700bf53ed0e34a6e$var$HandlerRole.TARGET;
    }
    removeSource(sourceId) {
        $700bf53ed0e34a6e$var$invariant(this.getSource(sourceId), "Expected an existing source.");
        this.store.dispatch($700bf53ed0e34a6e$var$removeSource(sourceId));
        $700bf53ed0e34a6e$var$asap(()=>{
            this.dragSources.delete(sourceId);
            this.types.delete(sourceId);
        });
    }
    removeTarget(targetId) {
        $700bf53ed0e34a6e$var$invariant(this.getTarget(targetId), "Expected an existing target.");
        this.store.dispatch($700bf53ed0e34a6e$var$removeTarget(targetId));
        this.dropTargets.delete(targetId);
        this.types.delete(targetId);
    }
    pinSource(sourceId) {
        const source = this.getSource(sourceId);
        $700bf53ed0e34a6e$var$invariant(source, "Expected an existing source.");
        this.pinnedSourceId = sourceId;
        this.pinnedSource = source;
    }
    unpinSource() {
        $700bf53ed0e34a6e$var$invariant(this.pinnedSource, "No source is pinned at the time.");
        this.pinnedSourceId = null;
        this.pinnedSource = null;
    }
    addHandler(role, type, handler) {
        const id = $700bf53ed0e34a6e$var$getNextHandlerId(role);
        this.types.set(id, type);
        if (role === $700bf53ed0e34a6e$var$HandlerRole.SOURCE) this.dragSources.set(id, handler);
        else if (role === $700bf53ed0e34a6e$var$HandlerRole.TARGET) this.dropTargets.set(id, handler);
        return id;
    }
    constructor(store){
        this.types = new Map();
        this.dragSources = new Map();
        this.dropTargets = new Map();
        this.pinnedSourceId = null;
        this.pinnedSource = null;
        this.store = store;
    }
}
const $700bf53ed0e34a6e$var$strictEquality = (a, b)=>a === b;
/**
 * Determine if two cartesian coordinate offsets are equal
 * @param offsetA
 * @param offsetB
 */ function $700bf53ed0e34a6e$var$areCoordsEqual(offsetA, offsetB) {
    if (!offsetA && !offsetB) return true;
    else if (!offsetA || !offsetB) return false;
    else return offsetA.x === offsetB.x && offsetA.y === offsetB.y;
}
/**
 * Determines if two arrays of items are equal
 * @param a The first array of items
 * @param b The second array of items
 */ function $700bf53ed0e34a6e$var$areArraysEqual(a, b, isEqual = $700bf53ed0e34a6e$var$strictEquality) {
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; ++i){
        if (!isEqual(a[i], b[i])) return false;
    }
    return true;
}
function $700bf53ed0e34a6e$var$reduce$5(_state = $700bf53ed0e34a6e$var$NONE, action) {
    switch(action.type){
        case $700bf53ed0e34a6e$var$HOVER:
            break;
        case $700bf53ed0e34a6e$var$ADD_SOURCE:
        case $700bf53ed0e34a6e$var$ADD_TARGET:
        case $700bf53ed0e34a6e$var$REMOVE_TARGET:
        case $700bf53ed0e34a6e$var$REMOVE_SOURCE:
            return $700bf53ed0e34a6e$var$NONE;
        case $700bf53ed0e34a6e$var$BEGIN_DRAG:
        case $700bf53ed0e34a6e$var$PUBLISH_DRAG_SOURCE:
        case $700bf53ed0e34a6e$var$END_DRAG:
        case $700bf53ed0e34a6e$var$DROP:
        default:
            return $700bf53ed0e34a6e$var$ALL;
    }
    const { targetIds: targetIds = [] , prevTargetIds: prevTargetIds = []  } = action.payload;
    const result = $700bf53ed0e34a6e$var$xor(targetIds, prevTargetIds);
    const didChange = result.length > 0 || !$700bf53ed0e34a6e$var$areArraysEqual(targetIds, prevTargetIds);
    if (!didChange) return $700bf53ed0e34a6e$var$NONE;
    // Check the target ids at the innermost position. If they are valid, add them
    // to the result
    const prevInnermostTargetId = prevTargetIds[prevTargetIds.length - 1];
    const innermostTargetId = targetIds[targetIds.length - 1];
    if (prevInnermostTargetId !== innermostTargetId) {
        if (prevInnermostTargetId) result.push(prevInnermostTargetId);
        if (innermostTargetId) result.push(innermostTargetId);
    }
    return result;
}
function $700bf53ed0e34a6e$var$_defineProperty$3(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $700bf53ed0e34a6e$var$_objectSpread$3(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $700bf53ed0e34a6e$var$_defineProperty$3(target, key, source[key]);
        });
    }
    return target;
}
const $700bf53ed0e34a6e$var$initialState$1 = {
    initialSourceClientOffset: null,
    initialClientOffset: null,
    clientOffset: null
};
function $700bf53ed0e34a6e$var$reduce$4(state = $700bf53ed0e34a6e$var$initialState$1, action) {
    const { payload: payload  } = action;
    switch(action.type){
        case $700bf53ed0e34a6e$var$INIT_COORDS:
        case $700bf53ed0e34a6e$var$BEGIN_DRAG:
            return {
                initialSourceClientOffset: payload.sourceClientOffset,
                initialClientOffset: payload.clientOffset,
                clientOffset: payload.clientOffset
            };
        case $700bf53ed0e34a6e$var$HOVER:
            if ($700bf53ed0e34a6e$var$areCoordsEqual(state.clientOffset, payload.clientOffset)) return state;
            return $700bf53ed0e34a6e$var$_objectSpread$3({}, state, {
                clientOffset: payload.clientOffset
            });
        case $700bf53ed0e34a6e$var$END_DRAG:
        case $700bf53ed0e34a6e$var$DROP:
            return $700bf53ed0e34a6e$var$initialState$1;
        default:
            return state;
    }
}
function $700bf53ed0e34a6e$var$_defineProperty$2(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $700bf53ed0e34a6e$var$_objectSpread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $700bf53ed0e34a6e$var$_defineProperty$2(target, key, source[key]);
        });
    }
    return target;
}
const $700bf53ed0e34a6e$var$initialState = {
    itemType: null,
    item: null,
    sourceId: null,
    targetIds: [],
    dropResult: null,
    didDrop: false,
    isSourcePublic: null
};
function $700bf53ed0e34a6e$var$reduce$3(state = $700bf53ed0e34a6e$var$initialState, action) {
    const { payload: payload  } = action;
    switch(action.type){
        case $700bf53ed0e34a6e$var$BEGIN_DRAG:
            return $700bf53ed0e34a6e$var$_objectSpread$2({}, state, {
                itemType: payload.itemType,
                item: payload.item,
                sourceId: payload.sourceId,
                isSourcePublic: payload.isSourcePublic,
                dropResult: null,
                didDrop: false
            });
        case $700bf53ed0e34a6e$var$PUBLISH_DRAG_SOURCE:
            return $700bf53ed0e34a6e$var$_objectSpread$2({}, state, {
                isSourcePublic: true
            });
        case $700bf53ed0e34a6e$var$HOVER:
            return $700bf53ed0e34a6e$var$_objectSpread$2({}, state, {
                targetIds: payload.targetIds
            });
        case $700bf53ed0e34a6e$var$REMOVE_TARGET:
            if (state.targetIds.indexOf(payload.targetId) === -1) return state;
            return $700bf53ed0e34a6e$var$_objectSpread$2({}, state, {
                targetIds: $700bf53ed0e34a6e$var$without$1(state.targetIds, payload.targetId)
            });
        case $700bf53ed0e34a6e$var$DROP:
            return $700bf53ed0e34a6e$var$_objectSpread$2({}, state, {
                dropResult: payload.dropResult,
                didDrop: true,
                targetIds: []
            });
        case $700bf53ed0e34a6e$var$END_DRAG:
            return $700bf53ed0e34a6e$var$_objectSpread$2({}, state, {
                itemType: null,
                item: null,
                sourceId: null,
                dropResult: null,
                didDrop: false,
                isSourcePublic: null,
                targetIds: []
            });
        default:
            return state;
    }
}
function $700bf53ed0e34a6e$var$reduce$2(state = 0, action) {
    switch(action.type){
        case $700bf53ed0e34a6e$var$ADD_SOURCE:
        case $700bf53ed0e34a6e$var$ADD_TARGET:
            return state + 1;
        case $700bf53ed0e34a6e$var$REMOVE_SOURCE:
        case $700bf53ed0e34a6e$var$REMOVE_TARGET:
            return state - 1;
        default:
            return state;
    }
}
function $700bf53ed0e34a6e$var$reduce$1(state = 0) {
    return state + 1;
}
function $700bf53ed0e34a6e$var$_defineProperty$1(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $700bf53ed0e34a6e$var$_objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $700bf53ed0e34a6e$var$_defineProperty$1(target, key, source[key]);
        });
    }
    return target;
}
function $700bf53ed0e34a6e$var$reduce(state = {}, action) {
    return {
        dirtyHandlerIds: $700bf53ed0e34a6e$var$reduce$5(state.dirtyHandlerIds, {
            type: action.type,
            payload: $700bf53ed0e34a6e$var$_objectSpread$1({}, action.payload, {
                prevTargetIds: $700bf53ed0e34a6e$var$get(state, "dragOperation.targetIds", [])
            })
        }),
        dragOffset: $700bf53ed0e34a6e$var$reduce$4(state.dragOffset, action),
        refCount: $700bf53ed0e34a6e$var$reduce$2(state.refCount, action),
        dragOperation: $700bf53ed0e34a6e$var$reduce$3(state.dragOperation, action),
        stateId: $700bf53ed0e34a6e$var$reduce$1(state.stateId)
    };
}
function $700bf53ed0e34a6e$var$createDragDropManager(backendFactory, globalContext, backendOptions = {}, debugMode = false) {
    const store = $700bf53ed0e34a6e$var$makeStoreInstance(debugMode);
    const monitor = new $700bf53ed0e34a6e$var$DragDropMonitorImpl(store, new $700bf53ed0e34a6e$var$HandlerRegistryImpl(store));
    const manager = new $700bf53ed0e34a6e$var$DragDropManagerImpl(store, monitor);
    const backend = backendFactory(manager, globalContext, backendOptions);
    manager.receiveBackend(backend);
    return manager;
}
function $700bf53ed0e34a6e$var$makeStoreInstance(debugMode) {
    // TODO: if we ever make a react-native version of this,
    // we'll need to consider how to pull off dev-tooling
    const reduxDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__;
    return $700bf53ed0e34a6e$var$createStore($700bf53ed0e34a6e$var$reduce, debugMode && reduxDevTools && reduxDevTools({
        name: "dnd-core",
        instanceId: "dnd-core"
    }));
}
function $700bf53ed0e34a6e$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $700bf53ed0e34a6e$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $700bf53ed0e34a6e$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
let $700bf53ed0e34a6e$var$refCount = 0;
const $700bf53ed0e34a6e$var$INSTANCE_SYM = Symbol.for("__REACT_DND_CONTEXT_INSTANCE__");
var $700bf53ed0e34a6e$var$DndProvider = /*#__PURE__*/ (0, $bh6RR.memo)(function DndProvider(_param) {
    var { children: children  } = _param, props = $700bf53ed0e34a6e$var$_objectWithoutProperties(_param, [
        "children"
    ]);
    const [manager, isGlobalInstance] = $700bf53ed0e34a6e$var$getDndContextValue(props) // memoized from props
    ;
    /**
		 * If the global context was used to store the DND context
		 * then where theres no more references to it we should
		 * clean it up to avoid memory leaks
		 */ (0, $bh6RR.useEffect)(()=>{
        if (isGlobalInstance) {
            const context = $700bf53ed0e34a6e$var$getGlobalContext();
            ++$700bf53ed0e34a6e$var$refCount;
            return ()=>{
                if (--$700bf53ed0e34a6e$var$refCount === 0) context[$700bf53ed0e34a6e$var$INSTANCE_SYM] = null;
            };
        }
        return;
    }, []);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($700bf53ed0e34a6e$var$DndContext.Provider, {
        value: manager,
        children: children
    });
});
function $700bf53ed0e34a6e$var$getDndContextValue(props) {
    if ("manager" in props) {
        const manager = {
            dragDropManager: props.manager
        };
        return [
            manager,
            false
        ];
    }
    const manager = $700bf53ed0e34a6e$var$createSingletonDndContext(props.backend, props.context, props.options, props.debugMode);
    const isGlobalInstance = !props.context;
    return [
        manager,
        isGlobalInstance
    ];
}
function $700bf53ed0e34a6e$var$createSingletonDndContext(backend, context = $700bf53ed0e34a6e$var$getGlobalContext(), options, debugMode) {
    const ctx = context;
    if (!ctx[$700bf53ed0e34a6e$var$INSTANCE_SYM]) ctx[$700bf53ed0e34a6e$var$INSTANCE_SYM] = {
        dragDropManager: $700bf53ed0e34a6e$var$createDragDropManager(backend, context, options, debugMode)
    };
    return ctx[$700bf53ed0e34a6e$var$INSTANCE_SYM];
}
function $700bf53ed0e34a6e$var$getGlobalContext() {
    return typeof $parcel$global !== "undefined" ? $parcel$global : window;
}
// do not edit .js files directly - edit src/index.jst
var $700bf53ed0e34a6e$var$fastDeepEqual = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};
// suppress the useLayoutEffect warning on server side.
const $700bf53ed0e34a6e$var$useIsomorphicLayoutEffect = typeof window !== "undefined" ? (0, $bh6RR.useLayoutEffect) : (0, $bh6RR.useEffect);
/**
 *
 * @param monitor The monitor to collect state from
 * @param collect The collecting function
 * @param onUpdate A method to invoke when updates occur
 */ function $700bf53ed0e34a6e$var$useCollector(monitor, collect, onUpdate) {
    const [collected, setCollected] = (0, $bh6RR.useState)(()=>collect(monitor));
    const updateCollected = (0, $bh6RR.useCallback)(()=>{
        const nextValue = collect(monitor);
        // This needs to be a deep-equality check because some monitor-collected values
        // include XYCoord objects that may be equivalent, but do not have instance equality.
        if (!$700bf53ed0e34a6e$var$fastDeepEqual(collected, nextValue)) {
            setCollected(nextValue);
            if (onUpdate) onUpdate();
        }
    }, [
        collected,
        monitor,
        onUpdate
    ]);
    // update the collected properties after react renders.
    // Note that the "Dustbin Stress Test" fails if this is not
    // done when the component updates
    $700bf53ed0e34a6e$var$useIsomorphicLayoutEffect(updateCollected);
    return [
        collected,
        updateCollected
    ];
}
function $700bf53ed0e34a6e$var$useMonitorOutput(monitor, collect, onCollect) {
    const [collected, updateCollected] = $700bf53ed0e34a6e$var$useCollector(monitor, collect, onCollect);
    $700bf53ed0e34a6e$var$useIsomorphicLayoutEffect(function subscribeToMonitorStateChange() {
        const handlerId = monitor.getHandlerId();
        if (handlerId == null) return;
        return monitor.subscribeToStateChange(updateCollected, {
            handlerIds: [
                handlerId
            ]
        });
    }, [
        monitor,
        updateCollected
    ]);
    return collected;
}
function $700bf53ed0e34a6e$var$useCollectedProps(collector, monitor, connector) {
    return $700bf53ed0e34a6e$var$useMonitorOutput(monitor, collector || (()=>({})), ()=>connector.reconnect());
}
function $700bf53ed0e34a6e$var$useOptionalFactory(arg, deps) {
    const memoDeps = [
        ...deps || []
    ];
    if (deps == null && typeof arg !== "function") memoDeps.push(arg);
    return (0, $bh6RR.useMemo)(()=>{
        return typeof arg === "function" ? arg() : arg;
    }, memoDeps);
}
function $700bf53ed0e34a6e$var$useConnectDragSource(connector) {
    return (0, $bh6RR.useMemo)(()=>connector.hooks.dragSource(), [
        connector
    ]);
}
function $700bf53ed0e34a6e$var$useConnectDragPreview(connector) {
    return (0, $bh6RR.useMemo)(()=>connector.hooks.dragPreview(), [
        connector
    ]);
}
let $700bf53ed0e34a6e$var$isCallingCanDrag = false;
let $700bf53ed0e34a6e$var$isCallingIsDragging = false;
class $700bf53ed0e34a6e$var$DragSourceMonitorImpl {
    receiveHandlerId(sourceId) {
        this.sourceId = sourceId;
    }
    getHandlerId() {
        return this.sourceId;
    }
    canDrag() {
        $700bf53ed0e34a6e$var$invariant(!$700bf53ed0e34a6e$var$isCallingCanDrag, "You may not call monitor.canDrag() inside your canDrag() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor");
        try {
            $700bf53ed0e34a6e$var$isCallingCanDrag = true;
            return this.internalMonitor.canDragSource(this.sourceId);
        } finally{
            $700bf53ed0e34a6e$var$isCallingCanDrag = false;
        }
    }
    isDragging() {
        if (!this.sourceId) return false;
        $700bf53ed0e34a6e$var$invariant(!$700bf53ed0e34a6e$var$isCallingIsDragging, "You may not call monitor.isDragging() inside your isDragging() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor");
        try {
            $700bf53ed0e34a6e$var$isCallingIsDragging = true;
            return this.internalMonitor.isDraggingSource(this.sourceId);
        } finally{
            $700bf53ed0e34a6e$var$isCallingIsDragging = false;
        }
    }
    subscribeToStateChange(listener, options) {
        return this.internalMonitor.subscribeToStateChange(listener, options);
    }
    isDraggingSource(sourceId) {
        return this.internalMonitor.isDraggingSource(sourceId);
    }
    isOverTarget(targetId, options) {
        return this.internalMonitor.isOverTarget(targetId, options);
    }
    getTargetIds() {
        return this.internalMonitor.getTargetIds();
    }
    isSourcePublic() {
        return this.internalMonitor.isSourcePublic();
    }
    getSourceId() {
        return this.internalMonitor.getSourceId();
    }
    subscribeToOffsetChange(listener) {
        return this.internalMonitor.subscribeToOffsetChange(listener);
    }
    canDragSource(sourceId) {
        return this.internalMonitor.canDragSource(sourceId);
    }
    canDropOnTarget(targetId) {
        return this.internalMonitor.canDropOnTarget(targetId);
    }
    getItemType() {
        return this.internalMonitor.getItemType();
    }
    getItem() {
        return this.internalMonitor.getItem();
    }
    getDropResult() {
        return this.internalMonitor.getDropResult();
    }
    didDrop() {
        return this.internalMonitor.didDrop();
    }
    getInitialClientOffset() {
        return this.internalMonitor.getInitialClientOffset();
    }
    getInitialSourceClientOffset() {
        return this.internalMonitor.getInitialSourceClientOffset();
    }
    getSourceClientOffset() {
        return this.internalMonitor.getSourceClientOffset();
    }
    getClientOffset() {
        return this.internalMonitor.getClientOffset();
    }
    getDifferenceFromInitialOffset() {
        return this.internalMonitor.getDifferenceFromInitialOffset();
    }
    constructor(manager){
        this.sourceId = null;
        this.internalMonitor = manager.getMonitor();
    }
}
let $700bf53ed0e34a6e$var$isCallingCanDrop = false;
class $700bf53ed0e34a6e$var$DropTargetMonitorImpl {
    receiveHandlerId(targetId) {
        this.targetId = targetId;
    }
    getHandlerId() {
        return this.targetId;
    }
    subscribeToStateChange(listener, options) {
        return this.internalMonitor.subscribeToStateChange(listener, options);
    }
    canDrop() {
        // Cut out early if the target id has not been set. This should prevent errors
        // where the user has an older version of dnd-core like in
        // https://github.com/react-dnd/react-dnd/issues/1310
        if (!this.targetId) return false;
        $700bf53ed0e34a6e$var$invariant(!$700bf53ed0e34a6e$var$isCallingCanDrop, "You may not call monitor.canDrop() inside your canDrop() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target-monitor");
        try {
            $700bf53ed0e34a6e$var$isCallingCanDrop = true;
            return this.internalMonitor.canDropOnTarget(this.targetId);
        } finally{
            $700bf53ed0e34a6e$var$isCallingCanDrop = false;
        }
    }
    isOver(options) {
        if (!this.targetId) return false;
        return this.internalMonitor.isOverTarget(this.targetId, options);
    }
    getItemType() {
        return this.internalMonitor.getItemType();
    }
    getItem() {
        return this.internalMonitor.getItem();
    }
    getDropResult() {
        return this.internalMonitor.getDropResult();
    }
    didDrop() {
        return this.internalMonitor.didDrop();
    }
    getInitialClientOffset() {
        return this.internalMonitor.getInitialClientOffset();
    }
    getInitialSourceClientOffset() {
        return this.internalMonitor.getInitialSourceClientOffset();
    }
    getSourceClientOffset() {
        return this.internalMonitor.getSourceClientOffset();
    }
    getClientOffset() {
        return this.internalMonitor.getClientOffset();
    }
    getDifferenceFromInitialOffset() {
        return this.internalMonitor.getDifferenceFromInitialOffset();
    }
    constructor(manager){
        this.targetId = null;
        this.internalMonitor = manager.getMonitor();
    }
}
function $700bf53ed0e34a6e$var$registerTarget(type, target, manager) {
    const registry = manager.getRegistry();
    const targetId = registry.addTarget(type, target);
    return [
        targetId,
        ()=>registry.removeTarget(targetId)
    ];
}
function $700bf53ed0e34a6e$var$registerSource(type, source, manager) {
    const registry = manager.getRegistry();
    const sourceId = registry.addSource(type, source);
    return [
        sourceId,
        ()=>registry.removeSource(sourceId)
    ];
}
function $700bf53ed0e34a6e$var$shallowEqual(objA, objB, compare, compareContext) {
    let compareResult = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (compareResult !== void 0) return !!compareResult;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    const bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(let idx = 0; idx < keysA.length; idx++){
        const key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        const valueA = objA[key];
        const valueB = objB[key];
        compareResult = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (compareResult === false || compareResult === void 0 && valueA !== valueB) return false;
    }
    return true;
}
function $700bf53ed0e34a6e$var$isRef(obj) {
    return obj !== null && typeof obj === "object" && Object.prototype.hasOwnProperty.call(obj, "current");
}
function $700bf53ed0e34a6e$var$throwIfCompositeComponentElement(element) {
    // Custom components can no longer be wrapped directly in React DnD 2.0
    // so that we don't need to depend on findDOMNode() from react-dom.
    if (typeof element.type === "string") return;
    const displayName = element.type.displayName || element.type.name || "the component";
    throw new Error("Only native element nodes can now be passed to React DnD connectors." + `You can either wrap ${displayName} into a <div>, or turn it into a ` + "drag source or a drop target itself.");
}
function $700bf53ed0e34a6e$var$wrapHookToRecognizeElement(hook) {
    return (elementOrNode = null, options = null)=>{
        // When passed a node, call the hook straight away.
        if (!(0, $bh6RR.isValidElement)(elementOrNode)) {
            const node = elementOrNode;
            hook(node, options);
            // return the node so it can be chained (e.g. when within callback refs
            // <div ref={node => connectDragSource(connectDropTarget(node))}/>
            return node;
        }
        // If passed a ReactElement, clone it and attach this function as a ref.
        // This helps us achieve a neat API where user doesn't even know that refs
        // are being used under the hood.
        const element = elementOrNode;
        $700bf53ed0e34a6e$var$throwIfCompositeComponentElement(element);
        // When no options are passed, use the hook directly
        const ref = options ? (node)=>hook(node, options) : hook;
        return $700bf53ed0e34a6e$var$cloneWithRef(element, ref);
    };
}
function $700bf53ed0e34a6e$var$wrapConnectorHooks(hooks) {
    const wrappedHooks = {};
    Object.keys(hooks).forEach((key)=>{
        const hook = hooks[key];
        // ref objects should be passed straight through without wrapping
        if (key.endsWith("Ref")) wrappedHooks[key] = hooks[key];
        else {
            const wrappedHook = $700bf53ed0e34a6e$var$wrapHookToRecognizeElement(hook);
            wrappedHooks[key] = ()=>wrappedHook;
        }
    });
    return wrappedHooks;
}
function $700bf53ed0e34a6e$var$setRef(ref, node) {
    if (typeof ref === "function") ref(node);
    else ref.current = node;
}
function $700bf53ed0e34a6e$var$cloneWithRef(element, newRef) {
    const previousRef = element.ref;
    $700bf53ed0e34a6e$var$invariant(typeof previousRef !== "string", "Cannot connect React DnD to an element with an existing string ref. Please convert it to use a callback ref instead, or wrap it into a <span> or <div>. Read more: https://reactjs.org/docs/refs-and-the-dom.html#callback-refs");
    if (!previousRef) // When there is no ref on the element, use the new ref directly
    return (0, $bh6RR.cloneElement)(element, {
        ref: newRef
    });
    else return (0, $bh6RR.cloneElement)(element, {
        ref: (node)=>{
            $700bf53ed0e34a6e$var$setRef(previousRef, node);
            $700bf53ed0e34a6e$var$setRef(newRef, node);
        }
    });
}
class $700bf53ed0e34a6e$var$SourceConnector {
    receiveHandlerId(newHandlerId) {
        if (this.handlerId === newHandlerId) return;
        this.handlerId = newHandlerId;
        this.reconnect();
    }
    get connectTarget() {
        return this.dragSource;
    }
    get dragSourceOptions() {
        return this.dragSourceOptionsInternal;
    }
    set dragSourceOptions(options) {
        this.dragSourceOptionsInternal = options;
    }
    get dragPreviewOptions() {
        return this.dragPreviewOptionsInternal;
    }
    set dragPreviewOptions(options) {
        this.dragPreviewOptionsInternal = options;
    }
    reconnect() {
        const didChange = this.reconnectDragSource();
        this.reconnectDragPreview(didChange);
    }
    reconnectDragSource() {
        const dragSource = this.dragSource;
        // if nothing has changed then don't resubscribe
        const didChange = this.didHandlerIdChange() || this.didConnectedDragSourceChange() || this.didDragSourceOptionsChange();
        if (didChange) this.disconnectDragSource();
        if (!this.handlerId) return didChange;
        if (!dragSource) {
            this.lastConnectedDragSource = dragSource;
            return didChange;
        }
        if (didChange) {
            this.lastConnectedHandlerId = this.handlerId;
            this.lastConnectedDragSource = dragSource;
            this.lastConnectedDragSourceOptions = this.dragSourceOptions;
            this.dragSourceUnsubscribe = this.backend.connectDragSource(this.handlerId, dragSource, this.dragSourceOptions);
        }
        return didChange;
    }
    reconnectDragPreview(forceDidChange = false) {
        const dragPreview = this.dragPreview;
        // if nothing has changed then don't resubscribe
        const didChange = forceDidChange || this.didHandlerIdChange() || this.didConnectedDragPreviewChange() || this.didDragPreviewOptionsChange();
        if (didChange) this.disconnectDragPreview();
        if (!this.handlerId) return;
        if (!dragPreview) {
            this.lastConnectedDragPreview = dragPreview;
            return;
        }
        if (didChange) {
            this.lastConnectedHandlerId = this.handlerId;
            this.lastConnectedDragPreview = dragPreview;
            this.lastConnectedDragPreviewOptions = this.dragPreviewOptions;
            this.dragPreviewUnsubscribe = this.backend.connectDragPreview(this.handlerId, dragPreview, this.dragPreviewOptions);
        }
    }
    didHandlerIdChange() {
        return this.lastConnectedHandlerId !== this.handlerId;
    }
    didConnectedDragSourceChange() {
        return this.lastConnectedDragSource !== this.dragSource;
    }
    didConnectedDragPreviewChange() {
        return this.lastConnectedDragPreview !== this.dragPreview;
    }
    didDragSourceOptionsChange() {
        return !$700bf53ed0e34a6e$var$shallowEqual(this.lastConnectedDragSourceOptions, this.dragSourceOptions);
    }
    didDragPreviewOptionsChange() {
        return !$700bf53ed0e34a6e$var$shallowEqual(this.lastConnectedDragPreviewOptions, this.dragPreviewOptions);
    }
    disconnectDragSource() {
        if (this.dragSourceUnsubscribe) {
            this.dragSourceUnsubscribe();
            this.dragSourceUnsubscribe = undefined;
        }
    }
    disconnectDragPreview() {
        if (this.dragPreviewUnsubscribe) {
            this.dragPreviewUnsubscribe();
            this.dragPreviewUnsubscribe = undefined;
            this.dragPreviewNode = null;
            this.dragPreviewRef = null;
        }
    }
    get dragSource() {
        return this.dragSourceNode || this.dragSourceRef && this.dragSourceRef.current;
    }
    get dragPreview() {
        return this.dragPreviewNode || this.dragPreviewRef && this.dragPreviewRef.current;
    }
    clearDragSource() {
        this.dragSourceNode = null;
        this.dragSourceRef = null;
    }
    clearDragPreview() {
        this.dragPreviewNode = null;
        this.dragPreviewRef = null;
    }
    constructor(backend){
        this.hooks = $700bf53ed0e34a6e$var$wrapConnectorHooks({
            dragSource: (node, options)=>{
                this.clearDragSource();
                this.dragSourceOptions = options || null;
                if ($700bf53ed0e34a6e$var$isRef(node)) this.dragSourceRef = node;
                else this.dragSourceNode = node;
                this.reconnectDragSource();
            },
            dragPreview: (node, options)=>{
                this.clearDragPreview();
                this.dragPreviewOptions = options || null;
                if ($700bf53ed0e34a6e$var$isRef(node)) this.dragPreviewRef = node;
                else this.dragPreviewNode = node;
                this.reconnectDragPreview();
            }
        });
        this.handlerId = null;
        // The drop target may either be attached via ref or connect function
        this.dragSourceRef = null;
        this.dragSourceOptionsInternal = null;
        // The drag preview may either be attached via ref or connect function
        this.dragPreviewRef = null;
        this.dragPreviewOptionsInternal = null;
        this.lastConnectedHandlerId = null;
        this.lastConnectedDragSource = null;
        this.lastConnectedDragSourceOptions = null;
        this.lastConnectedDragPreview = null;
        this.lastConnectedDragPreviewOptions = null;
        this.backend = backend;
    }
}
class $700bf53ed0e34a6e$var$TargetConnector {
    get connectTarget() {
        return this.dropTarget;
    }
    reconnect() {
        // if nothing has changed then don't resubscribe
        const didChange = this.didHandlerIdChange() || this.didDropTargetChange() || this.didOptionsChange();
        if (didChange) this.disconnectDropTarget();
        const dropTarget = this.dropTarget;
        if (!this.handlerId) return;
        if (!dropTarget) {
            this.lastConnectedDropTarget = dropTarget;
            return;
        }
        if (didChange) {
            this.lastConnectedHandlerId = this.handlerId;
            this.lastConnectedDropTarget = dropTarget;
            this.lastConnectedDropTargetOptions = this.dropTargetOptions;
            this.unsubscribeDropTarget = this.backend.connectDropTarget(this.handlerId, dropTarget, this.dropTargetOptions);
        }
    }
    receiveHandlerId(newHandlerId) {
        if (newHandlerId === this.handlerId) return;
        this.handlerId = newHandlerId;
        this.reconnect();
    }
    get dropTargetOptions() {
        return this.dropTargetOptionsInternal;
    }
    set dropTargetOptions(options) {
        this.dropTargetOptionsInternal = options;
    }
    didHandlerIdChange() {
        return this.lastConnectedHandlerId !== this.handlerId;
    }
    didDropTargetChange() {
        return this.lastConnectedDropTarget !== this.dropTarget;
    }
    didOptionsChange() {
        return !$700bf53ed0e34a6e$var$shallowEqual(this.lastConnectedDropTargetOptions, this.dropTargetOptions);
    }
    disconnectDropTarget() {
        if (this.unsubscribeDropTarget) {
            this.unsubscribeDropTarget();
            this.unsubscribeDropTarget = undefined;
        }
    }
    get dropTarget() {
        return this.dropTargetNode || this.dropTargetRef && this.dropTargetRef.current;
    }
    clearDropTarget() {
        this.dropTargetRef = null;
        this.dropTargetNode = null;
    }
    constructor(backend){
        this.hooks = $700bf53ed0e34a6e$var$wrapConnectorHooks({
            dropTarget: (node, options)=>{
                this.clearDropTarget();
                this.dropTargetOptions = options;
                if ($700bf53ed0e34a6e$var$isRef(node)) this.dropTargetRef = node;
                else this.dropTargetNode = node;
                this.reconnect();
            }
        });
        this.handlerId = null;
        // The drop target may either be attached via ref or connect function
        this.dropTargetRef = null;
        this.dropTargetOptionsInternal = null;
        this.lastConnectedHandlerId = null;
        this.lastConnectedDropTarget = null;
        this.lastConnectedDropTargetOptions = null;
        this.backend = backend;
    }
}
/**
 * A hook to retrieve the DragDropManager from Context
 */ function $700bf53ed0e34a6e$var$useDragDropManager() {
    const { dragDropManager: dragDropManager  } = (0, $bh6RR.useContext)($700bf53ed0e34a6e$var$DndContext);
    $700bf53ed0e34a6e$var$invariant(dragDropManager != null, "Expected drag drop context");
    return dragDropManager;
}
function $700bf53ed0e34a6e$var$useDragSourceConnector(dragSourceOptions, dragPreviewOptions) {
    const manager = $700bf53ed0e34a6e$var$useDragDropManager();
    const connector = (0, $bh6RR.useMemo)(()=>new $700bf53ed0e34a6e$var$SourceConnector(manager.getBackend()), [
        manager
    ]);
    $700bf53ed0e34a6e$var$useIsomorphicLayoutEffect(()=>{
        connector.dragSourceOptions = dragSourceOptions || null;
        connector.reconnect();
        return ()=>connector.disconnectDragSource();
    }, [
        connector,
        dragSourceOptions
    ]);
    $700bf53ed0e34a6e$var$useIsomorphicLayoutEffect(()=>{
        connector.dragPreviewOptions = dragPreviewOptions || null;
        connector.reconnect();
        return ()=>connector.disconnectDragPreview();
    }, [
        connector,
        dragPreviewOptions
    ]);
    return connector;
}
function $700bf53ed0e34a6e$var$useDragSourceMonitor() {
    const manager = $700bf53ed0e34a6e$var$useDragDropManager();
    return (0, $bh6RR.useMemo)(()=>new $700bf53ed0e34a6e$var$DragSourceMonitorImpl(manager), [
        manager
    ]);
}
class $700bf53ed0e34a6e$var$DragSourceImpl {
    beginDrag() {
        const spec = this.spec;
        const monitor = this.monitor;
        let result = null;
        if (typeof spec.item === "object") result = spec.item;
        else if (typeof spec.item === "function") result = spec.item(monitor);
        else result = {};
        return result !== null && result !== void 0 ? result : null;
    }
    canDrag() {
        const spec = this.spec;
        const monitor = this.monitor;
        if (typeof spec.canDrag === "boolean") return spec.canDrag;
        else if (typeof spec.canDrag === "function") return spec.canDrag(monitor);
        else return true;
    }
    isDragging(globalMonitor, target) {
        const spec = this.spec;
        const monitor = this.monitor;
        const { isDragging: isDragging  } = spec;
        return isDragging ? isDragging(monitor) : target === globalMonitor.getSourceId();
    }
    endDrag() {
        const spec = this.spec;
        const monitor = this.monitor;
        const connector = this.connector;
        const { end: end  } = spec;
        if (end) end(monitor.getItem(), monitor);
        connector.reconnect();
    }
    constructor(spec, monitor, connector){
        this.spec = spec;
        this.monitor = monitor;
        this.connector = connector;
    }
}
function $700bf53ed0e34a6e$var$useDragSource(spec, monitor, connector) {
    const handler = (0, $bh6RR.useMemo)(()=>new $700bf53ed0e34a6e$var$DragSourceImpl(spec, monitor, connector), [
        monitor,
        connector
    ]);
    (0, $bh6RR.useEffect)(()=>{
        handler.spec = spec;
    }, [
        spec
    ]);
    return handler;
}
function $700bf53ed0e34a6e$var$useDragType(spec) {
    return (0, $bh6RR.useMemo)(()=>{
        const result = spec.type;
        $700bf53ed0e34a6e$var$invariant(result != null, "spec.type must be defined");
        return result;
    }, [
        spec
    ]);
}
function $700bf53ed0e34a6e$var$useRegisteredDragSource(spec, monitor, connector) {
    const manager = $700bf53ed0e34a6e$var$useDragDropManager();
    const handler = $700bf53ed0e34a6e$var$useDragSource(spec, monitor, connector);
    const itemType = $700bf53ed0e34a6e$var$useDragType(spec);
    $700bf53ed0e34a6e$var$useIsomorphicLayoutEffect(function registerDragSource() {
        if (itemType != null) {
            const [handlerId, unregister] = $700bf53ed0e34a6e$var$registerSource(itemType, handler, manager);
            monitor.receiveHandlerId(handlerId);
            connector.receiveHandlerId(handlerId);
            return unregister;
        }
        return;
    }, [
        manager,
        monitor,
        connector,
        handler,
        itemType
    ]);
}
/**
 * useDragSource hook
 * @param sourceSpec The drag source specification (object or function, function preferred)
 * @param deps The memoization deps array to use when evaluating spec changes
 */ function $700bf53ed0e34a6e$var$useDrag(specArg, deps) {
    const spec = $700bf53ed0e34a6e$var$useOptionalFactory(specArg, deps);
    $700bf53ed0e34a6e$var$invariant(!spec.begin, `useDrag::spec.begin was deprecated in v14. Replace spec.begin() with spec.item(). (see more here - https://react-dnd.github.io/react-dnd/docs/api/use-drag)`);
    const monitor = $700bf53ed0e34a6e$var$useDragSourceMonitor();
    const connector = $700bf53ed0e34a6e$var$useDragSourceConnector(spec.options, spec.previewOptions);
    $700bf53ed0e34a6e$var$useRegisteredDragSource(spec, monitor, connector);
    return [
        $700bf53ed0e34a6e$var$useCollectedProps(spec.collect, monitor, connector),
        $700bf53ed0e34a6e$var$useConnectDragSource(connector),
        $700bf53ed0e34a6e$var$useConnectDragPreview(connector)
    ];
}
/**
 * useDragLayer Hook
 * @param collector The property collector
 */ function $700bf53ed0e34a6e$var$useDragLayer(collect) {
    const dragDropManager = $700bf53ed0e34a6e$var$useDragDropManager();
    const monitor = dragDropManager.getMonitor();
    const [collected, updateCollected] = $700bf53ed0e34a6e$var$useCollector(monitor, collect);
    (0, $bh6RR.useEffect)(()=>monitor.subscribeToOffsetChange(updateCollected));
    (0, $bh6RR.useEffect)(()=>monitor.subscribeToStateChange(updateCollected));
    return collected;
}
function $700bf53ed0e34a6e$var$useConnectDropTarget(connector) {
    return (0, $bh6RR.useMemo)(()=>connector.hooks.dropTarget(), [
        connector
    ]);
}
function $700bf53ed0e34a6e$var$useDropTargetConnector(options) {
    const manager = $700bf53ed0e34a6e$var$useDragDropManager();
    const connector = (0, $bh6RR.useMemo)(()=>new $700bf53ed0e34a6e$var$TargetConnector(manager.getBackend()), [
        manager
    ]);
    $700bf53ed0e34a6e$var$useIsomorphicLayoutEffect(()=>{
        connector.dropTargetOptions = options || null;
        connector.reconnect();
        return ()=>connector.disconnectDropTarget();
    }, [
        options
    ]);
    return connector;
}
function $700bf53ed0e34a6e$var$useDropTargetMonitor() {
    const manager = $700bf53ed0e34a6e$var$useDragDropManager();
    return (0, $bh6RR.useMemo)(()=>new $700bf53ed0e34a6e$var$DropTargetMonitorImpl(manager), [
        manager
    ]);
}
/**
 * Internal utility hook to get an array-version of spec.accept.
 * The main utility here is that we aren't creating a new array on every render if a non-array spec.accept is passed in.
 * @param spec
 */ function $700bf53ed0e34a6e$var$useAccept(spec) {
    const { accept: accept  } = spec;
    return (0, $bh6RR.useMemo)(()=>{
        $700bf53ed0e34a6e$var$invariant(spec.accept != null, "accept must be defined");
        return Array.isArray(accept) ? accept : [
            accept
        ];
    }, [
        accept
    ]);
}
class $700bf53ed0e34a6e$var$DropTargetImpl {
    canDrop() {
        const spec = this.spec;
        const monitor = this.monitor;
        return spec.canDrop ? spec.canDrop(monitor.getItem(), monitor) : true;
    }
    hover() {
        const spec = this.spec;
        const monitor = this.monitor;
        if (spec.hover) spec.hover(monitor.getItem(), monitor);
    }
    drop() {
        const spec = this.spec;
        const monitor = this.monitor;
        if (spec.drop) return spec.drop(monitor.getItem(), monitor);
        return;
    }
    constructor(spec, monitor){
        this.spec = spec;
        this.monitor = monitor;
    }
}
function $700bf53ed0e34a6e$var$useDropTarget(spec, monitor) {
    const dropTarget = (0, $bh6RR.useMemo)(()=>new $700bf53ed0e34a6e$var$DropTargetImpl(spec, monitor), [
        monitor
    ]);
    (0, $bh6RR.useEffect)(()=>{
        dropTarget.spec = spec;
    }, [
        spec
    ]);
    return dropTarget;
}
function $700bf53ed0e34a6e$var$useRegisteredDropTarget(spec, monitor, connector) {
    const manager = $700bf53ed0e34a6e$var$useDragDropManager();
    const dropTarget = $700bf53ed0e34a6e$var$useDropTarget(spec, monitor);
    const accept = $700bf53ed0e34a6e$var$useAccept(spec);
    $700bf53ed0e34a6e$var$useIsomorphicLayoutEffect(function registerDropTarget() {
        const [handlerId, unregister] = $700bf53ed0e34a6e$var$registerTarget(accept, dropTarget, manager);
        monitor.receiveHandlerId(handlerId);
        connector.receiveHandlerId(handlerId);
        return unregister;
    }, [
        manager,
        monitor,
        dropTarget,
        connector,
        accept.map((a)=>a.toString()).join("|")
    ]);
}
/**
 * useDropTarget Hook
 * @param spec The drop target specification (object or function, function preferred)
 * @param deps The memoization deps array to use when evaluating spec changes
 */ function $700bf53ed0e34a6e$var$useDrop(specArg, deps) {
    const spec = $700bf53ed0e34a6e$var$useOptionalFactory(specArg, deps);
    const monitor = $700bf53ed0e34a6e$var$useDropTargetMonitor();
    const connector = $700bf53ed0e34a6e$var$useDropTargetConnector(spec.options);
    $700bf53ed0e34a6e$var$useRegisteredDropTarget(spec, monitor, connector);
    return [
        $700bf53ed0e34a6e$var$useCollectedProps(spec.collect, monitor, connector),
        $700bf53ed0e34a6e$var$useConnectDropTarget(connector)
    ];
}
// cheap lodash replacements
function $700bf53ed0e34a6e$var$memoize(fn) {
    let result = null;
    const memoized = ()=>{
        if (result == null) result = fn();
        return result;
    };
    return memoized;
}
/**
 * drop-in replacement for _.without
 */ function $700bf53ed0e34a6e$var$without(items, item) {
    return items.filter((i)=>i !== item);
}
function $700bf53ed0e34a6e$var$union(itemsA, itemsB) {
    const set = new Set();
    const insertItem = (item)=>set.add(item);
    itemsA.forEach(insertItem);
    itemsB.forEach(insertItem);
    const result = [];
    set.forEach((key)=>result.push(key));
    return result;
}
class $700bf53ed0e34a6e$var$EnterLeaveCounter {
    enter(enteringNode) {
        const previousLength = this.entered.length;
        const isNodeEntered = (node)=>this.isNodeInDocument(node) && (!node.contains || node.contains(enteringNode));
        this.entered = $700bf53ed0e34a6e$var$union(this.entered.filter(isNodeEntered), [
            enteringNode
        ]);
        return previousLength === 0 && this.entered.length > 0;
    }
    leave(leavingNode) {
        const previousLength = this.entered.length;
        this.entered = $700bf53ed0e34a6e$var$without(this.entered.filter(this.isNodeInDocument), leavingNode);
        return previousLength > 0 && this.entered.length === 0;
    }
    reset() {
        this.entered = [];
    }
    constructor(isNodeInDocument){
        this.entered = [];
        this.isNodeInDocument = isNodeInDocument;
    }
}
class $700bf53ed0e34a6e$var$NativeDragSource {
    initializeExposedProperties() {
        Object.keys(this.config.exposeProperties).forEach((property)=>{
            Object.defineProperty(this.item, property, {
                configurable: true,
                enumerable: true,
                get () {
                    // eslint-disable-next-line no-console
                    console.warn(`Browser doesn't allow reading "${property}" until the drop event.`);
                    return null;
                }
            });
        });
    }
    loadDataTransfer(dataTransfer) {
        if (dataTransfer) {
            const newProperties = {};
            Object.keys(this.config.exposeProperties).forEach((property)=>{
                const propertyFn = this.config.exposeProperties[property];
                if (propertyFn != null) newProperties[property] = {
                    value: propertyFn(dataTransfer, this.config.matchesTypes),
                    configurable: true,
                    enumerable: true
                };
            });
            Object.defineProperties(this.item, newProperties);
        }
    }
    canDrag() {
        return true;
    }
    beginDrag() {
        return this.item;
    }
    isDragging(monitor, handle) {
        return handle === monitor.getSourceId();
    }
    endDrag() {
    // empty
    }
    constructor(config){
        this.config = config;
        this.item = {};
        this.initializeExposedProperties();
    }
}
const $700bf53ed0e34a6e$var$FILE = "__NATIVE_FILE__";
const $700bf53ed0e34a6e$var$URL = "__NATIVE_URL__";
const $700bf53ed0e34a6e$var$TEXT = "__NATIVE_TEXT__";
const $700bf53ed0e34a6e$var$HTML = "__NATIVE_HTML__";
var $700bf53ed0e34a6e$var$NativeTypes = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    FILE: $700bf53ed0e34a6e$var$FILE,
    HTML: $700bf53ed0e34a6e$var$HTML,
    TEXT: $700bf53ed0e34a6e$var$TEXT,
    URL: $700bf53ed0e34a6e$var$URL
});
function $700bf53ed0e34a6e$var$getDataFromDataTransfer(dataTransfer, typesToTry, defaultValue) {
    const result = typesToTry.reduce((resultSoFar, typeToTry)=>resultSoFar || dataTransfer.getData(typeToTry), "");
    return result != null ? result : defaultValue;
}
const $700bf53ed0e34a6e$var$nativeTypesConfig = {
    [$700bf53ed0e34a6e$var$FILE]: {
        exposeProperties: {
            files: (dataTransfer)=>Array.prototype.slice.call(dataTransfer.files),
            items: (dataTransfer)=>dataTransfer.items,
            dataTransfer: (dataTransfer)=>dataTransfer
        },
        matchesTypes: [
            "Files"
        ]
    },
    [$700bf53ed0e34a6e$var$HTML]: {
        exposeProperties: {
            html: (dataTransfer, matchesTypes)=>$700bf53ed0e34a6e$var$getDataFromDataTransfer(dataTransfer, matchesTypes, ""),
            dataTransfer: (dataTransfer)=>dataTransfer
        },
        matchesTypes: [
            "Html",
            "text/html"
        ]
    },
    [$700bf53ed0e34a6e$var$URL]: {
        exposeProperties: {
            urls: (dataTransfer, matchesTypes)=>$700bf53ed0e34a6e$var$getDataFromDataTransfer(dataTransfer, matchesTypes, "").split("\n"),
            dataTransfer: (dataTransfer)=>dataTransfer
        },
        matchesTypes: [
            "Url",
            "text/uri-list"
        ]
    },
    [$700bf53ed0e34a6e$var$TEXT]: {
        exposeProperties: {
            text: (dataTransfer, matchesTypes)=>$700bf53ed0e34a6e$var$getDataFromDataTransfer(dataTransfer, matchesTypes, ""),
            dataTransfer: (dataTransfer)=>dataTransfer
        },
        matchesTypes: [
            "Text",
            "text/plain"
        ]
    }
};
function $700bf53ed0e34a6e$var$createNativeDragSource(type, dataTransfer) {
    const config = $700bf53ed0e34a6e$var$nativeTypesConfig[type];
    if (!config) throw new Error(`native type ${type} has no configuration`);
    const result = new $700bf53ed0e34a6e$var$NativeDragSource(config);
    result.loadDataTransfer(dataTransfer);
    return result;
}
function $700bf53ed0e34a6e$var$matchNativeItemType(dataTransfer) {
    if (!dataTransfer) return null;
    const dataTransferTypes = Array.prototype.slice.call(dataTransfer.types || []);
    return Object.keys($700bf53ed0e34a6e$var$nativeTypesConfig).filter((nativeItemType)=>{
        const typeConfig = $700bf53ed0e34a6e$var$nativeTypesConfig[nativeItemType];
        if (!(typeConfig === null || typeConfig === void 0 ? void 0 : typeConfig.matchesTypes)) return false;
        return typeConfig.matchesTypes.some((t)=>dataTransferTypes.indexOf(t) > -1);
    })[0] || null;
}
const $700bf53ed0e34a6e$var$isFirefox = $700bf53ed0e34a6e$var$memoize(()=>/firefox/i.test(navigator.userAgent));
const $700bf53ed0e34a6e$var$isSafari = $700bf53ed0e34a6e$var$memoize(()=>Boolean(window.safari));
class $700bf53ed0e34a6e$var$MonotonicInterpolant {
    interpolate(x) {
        const { xs: xs , ys: ys , c1s: c1s , c2s: c2s , c3s: c3s  } = this;
        // The rightmost point in the dataset should give an exact result
        let i = xs.length - 1;
        if (x === xs[i]) return ys[i];
        // Search for the interval x is in, returning the corresponding y if x is one of the original xs
        let low = 0;
        let high = c3s.length - 1;
        let mid;
        while(low <= high){
            mid = Math.floor(0.5 * (low + high));
            const xHere = xs[mid];
            if (xHere < x) low = mid + 1;
            else if (xHere > x) high = mid - 1;
            else return ys[mid];
        }
        i = Math.max(0, high);
        // Interpolate
        const diff = x - xs[i];
        const diffSq = diff * diff;
        return ys[i] + c1s[i] * diff + c2s[i] * diffSq + c3s[i] * diff * diffSq;
    }
    constructor(xs, ys){
        const { length: length  } = xs;
        // Rearrange xs and ys so that xs is sorted
        const indexes = [];
        for(let i = 0; i < length; i++)indexes.push(i);
        indexes.sort((a, b)=>xs[a] < xs[b] ? -1 : 1);
        const dxs = [];
        const ms = [];
        let dx;
        let dy;
        for(let i1 = 0; i1 < length - 1; i1++){
            dx = xs[i1 + 1] - xs[i1];
            dy = ys[i1 + 1] - ys[i1];
            dxs.push(dx);
            ms.push(dy / dx);
        }
        // Get degree-1 coefficients
        const c1s = [
            ms[0]
        ];
        for(let i2 = 0; i2 < dxs.length - 1; i2++){
            const m2 = ms[i2];
            const mNext = ms[i2 + 1];
            if (m2 * mNext <= 0) c1s.push(0);
            else {
                dx = dxs[i2];
                const dxNext = dxs[i2 + 1];
                const common = dx + dxNext;
                c1s.push(3 * common / ((common + dxNext) / m2 + (common + dx) / mNext));
            }
        }
        c1s.push(ms[ms.length - 1]);
        // Get degree-2 and degree-3 coefficients
        const c2s = [];
        const c3s = [];
        let m;
        for(let i3 = 0; i3 < c1s.length - 1; i3++){
            m = ms[i3];
            const c1 = c1s[i3];
            const invDx = 1 / dxs[i3];
            const common = c1 + c1s[i3 + 1] - m - m;
            c2s.push((m - c1 - common) * invDx);
            c3s.push(common * invDx * invDx);
        }
        this.xs = xs;
        this.ys = ys;
        this.c1s = c1s;
        this.c2s = c2s;
        this.c3s = c3s;
    }
}
const $700bf53ed0e34a6e$var$ELEMENT_NODE$1 = 1;
function $700bf53ed0e34a6e$var$getNodeClientOffset$1(node) {
    const el = node.nodeType === $700bf53ed0e34a6e$var$ELEMENT_NODE$1 ? node : node.parentElement;
    if (!el) return null;
    const { top: top , left: left  } = el.getBoundingClientRect();
    return {
        x: left,
        y: top
    };
}
function $700bf53ed0e34a6e$var$getEventClientOffset$1(e) {
    return {
        x: e.clientX,
        y: e.clientY
    };
}
function $700bf53ed0e34a6e$var$isImageNode(node) {
    var ref;
    return node.nodeName === "IMG" && ($700bf53ed0e34a6e$var$isFirefox() || !((ref = document.documentElement) === null || ref === void 0 ? void 0 : ref.contains(node)));
}
function $700bf53ed0e34a6e$var$getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight) {
    let dragPreviewWidth = isImage ? dragPreview.width : sourceWidth;
    let dragPreviewHeight = isImage ? dragPreview.height : sourceHeight;
    // Work around @2x coordinate discrepancies in browsers
    if ($700bf53ed0e34a6e$var$isSafari() && isImage) {
        dragPreviewHeight /= window.devicePixelRatio;
        dragPreviewWidth /= window.devicePixelRatio;
    }
    return {
        dragPreviewWidth: dragPreviewWidth,
        dragPreviewHeight: dragPreviewHeight
    };
}
function $700bf53ed0e34a6e$var$getDragPreviewOffset(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint) {
    // The browsers will use the image intrinsic size under different conditions.
    // Firefox only cares if it's an image, but WebKit also wants it to be detached.
    const isImage = $700bf53ed0e34a6e$var$isImageNode(dragPreview);
    const dragPreviewNode = isImage ? sourceNode : dragPreview;
    const dragPreviewNodeOffsetFromClient = $700bf53ed0e34a6e$var$getNodeClientOffset$1(dragPreviewNode);
    const offsetFromDragPreview = {
        x: clientOffset.x - dragPreviewNodeOffsetFromClient.x,
        y: clientOffset.y - dragPreviewNodeOffsetFromClient.y
    };
    const { offsetWidth: sourceWidth , offsetHeight: sourceHeight  } = sourceNode;
    const { anchorX: anchorX , anchorY: anchorY  } = anchorPoint;
    const { dragPreviewWidth: dragPreviewWidth , dragPreviewHeight: dragPreviewHeight  } = $700bf53ed0e34a6e$var$getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight);
    const calculateYOffset = ()=>{
        const interpolantY = new $700bf53ed0e34a6e$var$MonotonicInterpolant([
            0,
            0.5,
            1
        ], [
            // Dock to the top
            offsetFromDragPreview.y,
            // Align at the center
            offsetFromDragPreview.y / sourceHeight * dragPreviewHeight,
            // Dock to the bottom
            offsetFromDragPreview.y + dragPreviewHeight - sourceHeight
        ]);
        let y = interpolantY.interpolate(anchorY);
        // Work around Safari 8 positioning bug
        if ($700bf53ed0e34a6e$var$isSafari() && isImage) // We'll have to wait for @3x to see if this is entirely correct
        y += (window.devicePixelRatio - 1) * dragPreviewHeight;
        return y;
    };
    const calculateXOffset = ()=>{
        // Interpolate coordinates depending on anchor point
        // If you know a simpler way to do this, let me know
        const interpolantX = new $700bf53ed0e34a6e$var$MonotonicInterpolant([
            0,
            0.5,
            1
        ], [
            // Dock to the left
            offsetFromDragPreview.x,
            // Align at the center
            offsetFromDragPreview.x / sourceWidth * dragPreviewWidth,
            // Dock to the right
            offsetFromDragPreview.x + dragPreviewWidth - sourceWidth
        ]);
        return interpolantX.interpolate(anchorX);
    };
    // Force offsets if specified in the options.
    const { offsetX: offsetX , offsetY: offsetY  } = offsetPoint;
    const isManualOffsetX = offsetX === 0 || offsetX;
    const isManualOffsetY = offsetY === 0 || offsetY;
    return {
        x: isManualOffsetX ? offsetX : calculateXOffset(),
        y: isManualOffsetY ? offsetY : calculateYOffset()
    };
}
let $700bf53ed0e34a6e$var$OptionsReader$1 = class OptionsReader {
    get window() {
        if (this.globalContext) return this.globalContext;
        else if (typeof window !== "undefined") return window;
        return undefined;
    }
    get document() {
        var ref;
        if ((ref = this.globalContext) === null || ref === void 0 ? void 0 : ref.document) return this.globalContext.document;
        else if (this.window) return this.window.document;
        else return undefined;
    }
    get rootElement() {
        var ref;
        return ((ref = this.optionsArgs) === null || ref === void 0 ? void 0 : ref.rootElement) || this.window;
    }
    constructor(globalContext, options){
        this.ownerDocument = null;
        this.globalContext = globalContext;
        this.optionsArgs = options;
    }
};
function $700bf53ed0e34a6e$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $700bf53ed0e34a6e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $700bf53ed0e34a6e$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
class $700bf53ed0e34a6e$var$HTML5BackendImpl {
    /**
	 * Generate profiling statistics for the HTML5Backend.
	 */ profile() {
        var ref, ref1;
        return {
            sourcePreviewNodes: this.sourcePreviewNodes.size,
            sourcePreviewNodeOptions: this.sourcePreviewNodeOptions.size,
            sourceNodeOptions: this.sourceNodeOptions.size,
            sourceNodes: this.sourceNodes.size,
            dragStartSourceIds: ((ref = this.dragStartSourceIds) === null || ref === void 0 ? void 0 : ref.length) || 0,
            dropTargetIds: this.dropTargetIds.length,
            dragEnterTargetIds: this.dragEnterTargetIds.length,
            dragOverTargetIds: ((ref1 = this.dragOverTargetIds) === null || ref1 === void 0 ? void 0 : ref1.length) || 0
        };
    }
    // public for test
    get window() {
        return this.options.window;
    }
    get document() {
        return this.options.document;
    }
    /**
	 * Get the root element to use for event subscriptions
	 */ get rootElement() {
        return this.options.rootElement;
    }
    setup() {
        const root = this.rootElement;
        if (root === undefined) return;
        if (root.__isReactDndBackendSetUp) throw new Error("Cannot have two HTML5 backends at the same time.");
        root.__isReactDndBackendSetUp = true;
        this.addEventListeners(root);
    }
    teardown() {
        const root = this.rootElement;
        if (root === undefined) return;
        root.__isReactDndBackendSetUp = false;
        this.removeEventListeners(this.rootElement);
        this.clearCurrentDragSourceNode();
        if (this.asyncEndDragFrameId) {
            var ref;
            (ref = this.window) === null || ref === void 0 || ref.cancelAnimationFrame(this.asyncEndDragFrameId);
        }
    }
    connectDragPreview(sourceId, node, options) {
        this.sourcePreviewNodeOptions.set(sourceId, options);
        this.sourcePreviewNodes.set(sourceId, node);
        return ()=>{
            this.sourcePreviewNodes.delete(sourceId);
            this.sourcePreviewNodeOptions.delete(sourceId);
        };
    }
    connectDragSource(sourceId, node, options) {
        this.sourceNodes.set(sourceId, node);
        this.sourceNodeOptions.set(sourceId, options);
        const handleDragStart = (e)=>this.handleDragStart(e, sourceId);
        const handleSelectStart = (e)=>this.handleSelectStart(e);
        node.setAttribute("draggable", "true");
        node.addEventListener("dragstart", handleDragStart);
        node.addEventListener("selectstart", handleSelectStart);
        return ()=>{
            this.sourceNodes.delete(sourceId);
            this.sourceNodeOptions.delete(sourceId);
            node.removeEventListener("dragstart", handleDragStart);
            node.removeEventListener("selectstart", handleSelectStart);
            node.setAttribute("draggable", "false");
        };
    }
    connectDropTarget(targetId, node) {
        const handleDragEnter = (e)=>this.handleDragEnter(e, targetId);
        const handleDragOver = (e)=>this.handleDragOver(e, targetId);
        const handleDrop = (e)=>this.handleDrop(e, targetId);
        node.addEventListener("dragenter", handleDragEnter);
        node.addEventListener("dragover", handleDragOver);
        node.addEventListener("drop", handleDrop);
        return ()=>{
            node.removeEventListener("dragenter", handleDragEnter);
            node.removeEventListener("dragover", handleDragOver);
            node.removeEventListener("drop", handleDrop);
        };
    }
    addEventListeners(target) {
        // SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
        if (!target.addEventListener) return;
        target.addEventListener("dragstart", this.handleTopDragStart);
        target.addEventListener("dragstart", this.handleTopDragStartCapture, true);
        target.addEventListener("dragend", this.handleTopDragEndCapture, true);
        target.addEventListener("dragenter", this.handleTopDragEnter);
        target.addEventListener("dragenter", this.handleTopDragEnterCapture, true);
        target.addEventListener("dragleave", this.handleTopDragLeaveCapture, true);
        target.addEventListener("dragover", this.handleTopDragOver);
        target.addEventListener("dragover", this.handleTopDragOverCapture, true);
        target.addEventListener("drop", this.handleTopDrop);
        target.addEventListener("drop", this.handleTopDropCapture, true);
    }
    removeEventListeners(target) {
        // SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
        if (!target.removeEventListener) return;
        target.removeEventListener("dragstart", this.handleTopDragStart);
        target.removeEventListener("dragstart", this.handleTopDragStartCapture, true);
        target.removeEventListener("dragend", this.handleTopDragEndCapture, true);
        target.removeEventListener("dragenter", this.handleTopDragEnter);
        target.removeEventListener("dragenter", this.handleTopDragEnterCapture, true);
        target.removeEventListener("dragleave", this.handleTopDragLeaveCapture, true);
        target.removeEventListener("dragover", this.handleTopDragOver);
        target.removeEventListener("dragover", this.handleTopDragOverCapture, true);
        target.removeEventListener("drop", this.handleTopDrop);
        target.removeEventListener("drop", this.handleTopDropCapture, true);
    }
    getCurrentSourceNodeOptions() {
        const sourceId = this.monitor.getSourceId();
        const sourceNodeOptions = this.sourceNodeOptions.get(sourceId);
        return $700bf53ed0e34a6e$var$_objectSpread({
            dropEffect: this.altKeyPressed ? "copy" : "move"
        }, sourceNodeOptions || {});
    }
    getCurrentDropEffect() {
        if (this.isDraggingNativeItem()) // It makes more sense to default to 'copy' for native resources
        return "copy";
        return this.getCurrentSourceNodeOptions().dropEffect;
    }
    getCurrentSourcePreviewNodeOptions() {
        const sourceId = this.monitor.getSourceId();
        const sourcePreviewNodeOptions = this.sourcePreviewNodeOptions.get(sourceId);
        return $700bf53ed0e34a6e$var$_objectSpread({
            anchorX: 0.5,
            anchorY: 0.5,
            captureDraggingState: false
        }, sourcePreviewNodeOptions || {});
    }
    isDraggingNativeItem() {
        const itemType = this.monitor.getItemType();
        return Object.keys($700bf53ed0e34a6e$var$NativeTypes).some((key)=>$700bf53ed0e34a6e$var$NativeTypes[key] === itemType);
    }
    beginDragNativeItem(type, dataTransfer) {
        this.clearCurrentDragSourceNode();
        this.currentNativeSource = $700bf53ed0e34a6e$var$createNativeDragSource(type, dataTransfer);
        this.currentNativeHandle = this.registry.addSource(type, this.currentNativeSource);
        this.actions.beginDrag([
            this.currentNativeHandle
        ]);
    }
    setCurrentDragSourceNode(node) {
        this.clearCurrentDragSourceNode();
        this.currentDragSourceNode = node;
        // A timeout of > 0 is necessary to resolve Firefox issue referenced
        // See:
        //   * https://github.com/react-dnd/react-dnd/pull/928
        //   * https://github.com/react-dnd/react-dnd/issues/869
        const MOUSE_MOVE_TIMEOUT = 1000;
        // Receiving a mouse event in the middle of a dragging operation
        // means it has ended and the drag source node disappeared from DOM,
        // so the browser didn't dispatch the dragend event.
        //
        // We need to wait before we start listening for mousemove events.
        // This is needed because the drag preview needs to be drawn or else it fires an 'mousemove' event
        // immediately in some browsers.
        //
        // See:
        //   * https://github.com/react-dnd/react-dnd/pull/928
        //   * https://github.com/react-dnd/react-dnd/issues/869
        //
        this.mouseMoveTimeoutTimer = setTimeout(()=>{
            var ref;
            return (ref = this.rootElement) === null || ref === void 0 ? void 0 : ref.addEventListener("mousemove", this.endDragIfSourceWasRemovedFromDOM, true);
        }, MOUSE_MOVE_TIMEOUT);
    }
    clearCurrentDragSourceNode() {
        if (this.currentDragSourceNode) {
            this.currentDragSourceNode = null;
            if (this.rootElement) {
                var ref;
                (ref = this.window) === null || ref === void 0 || ref.clearTimeout(this.mouseMoveTimeoutTimer || undefined);
                this.rootElement.removeEventListener("mousemove", this.endDragIfSourceWasRemovedFromDOM, true);
            }
            this.mouseMoveTimeoutTimer = null;
            return true;
        }
        return false;
    }
    handleDragStart(e, sourceId) {
        if (e.defaultPrevented) return;
        if (!this.dragStartSourceIds) this.dragStartSourceIds = [];
        this.dragStartSourceIds.unshift(sourceId);
    }
    handleDragEnter(_e, targetId) {
        this.dragEnterTargetIds.unshift(targetId);
    }
    handleDragOver(_e, targetId) {
        if (this.dragOverTargetIds === null) this.dragOverTargetIds = [];
        this.dragOverTargetIds.unshift(targetId);
    }
    handleDrop(_e, targetId) {
        this.dropTargetIds.unshift(targetId);
    }
    constructor(manager, globalContext, options){
        this.sourcePreviewNodes = new Map();
        this.sourcePreviewNodeOptions = new Map();
        this.sourceNodes = new Map();
        this.sourceNodeOptions = new Map();
        this.dragStartSourceIds = null;
        this.dropTargetIds = [];
        this.dragEnterTargetIds = [];
        this.currentNativeSource = null;
        this.currentNativeHandle = null;
        this.currentDragSourceNode = null;
        this.altKeyPressed = false;
        this.mouseMoveTimeoutTimer = null;
        this.asyncEndDragFrameId = null;
        this.dragOverTargetIds = null;
        this.lastClientOffset = null;
        this.hoverRafId = null;
        this.getSourceClientOffset = (sourceId)=>{
            const source = this.sourceNodes.get(sourceId);
            return source && $700bf53ed0e34a6e$var$getNodeClientOffset$1(source) || null;
        };
        this.endDragNativeItem = ()=>{
            if (!this.isDraggingNativeItem()) return;
            this.actions.endDrag();
            if (this.currentNativeHandle) this.registry.removeSource(this.currentNativeHandle);
            this.currentNativeHandle = null;
            this.currentNativeSource = null;
        };
        this.isNodeInDocument = (node)=>{
            // Check the node either in the main document or in the current context
            return Boolean(node && this.document && this.document.body && this.document.body.contains(node));
        };
        this.endDragIfSourceWasRemovedFromDOM = ()=>{
            const node = this.currentDragSourceNode;
            if (node == null || this.isNodeInDocument(node)) return;
            if (this.clearCurrentDragSourceNode() && this.monitor.isDragging()) this.actions.endDrag();
            this.cancelHover();
        };
        this.scheduleHover = (dragOverTargetIds)=>{
            if (this.hoverRafId === null && typeof requestAnimationFrame !== "undefined") this.hoverRafId = requestAnimationFrame(()=>{
                if (this.monitor.isDragging()) this.actions.hover(dragOverTargetIds || [], {
                    clientOffset: this.lastClientOffset
                });
                this.hoverRafId = null;
            });
        };
        this.cancelHover = ()=>{
            if (this.hoverRafId !== null && typeof cancelAnimationFrame !== "undefined") {
                cancelAnimationFrame(this.hoverRafId);
                this.hoverRafId = null;
            }
        };
        this.handleTopDragStartCapture = ()=>{
            this.clearCurrentDragSourceNode();
            this.dragStartSourceIds = [];
        };
        this.handleTopDragStart = (e)=>{
            if (e.defaultPrevented) return;
            const { dragStartSourceIds: dragStartSourceIds  } = this;
            this.dragStartSourceIds = null;
            const clientOffset = $700bf53ed0e34a6e$var$getEventClientOffset$1(e);
            // Avoid crashing if we missed a drop event or our previous drag died
            if (this.monitor.isDragging()) {
                this.actions.endDrag();
                this.cancelHover();
            }
            // Don't publish the source just yet (see why below)
            this.actions.beginDrag(dragStartSourceIds || [], {
                publishSource: false,
                getSourceClientOffset: this.getSourceClientOffset,
                clientOffset: clientOffset
            });
            const { dataTransfer: dataTransfer  } = e;
            const nativeType = $700bf53ed0e34a6e$var$matchNativeItemType(dataTransfer);
            if (this.monitor.isDragging()) {
                if (dataTransfer && typeof dataTransfer.setDragImage === "function") {
                    // Use custom drag image if user specifies it.
                    // If child drag source refuses drag but parent agrees,
                    // use parent's node as drag image. Neither works in IE though.
                    const sourceId = this.monitor.getSourceId();
                    const sourceNode = this.sourceNodes.get(sourceId);
                    const dragPreview = this.sourcePreviewNodes.get(sourceId) || sourceNode;
                    if (dragPreview) {
                        const { anchorX: anchorX , anchorY: anchorY , offsetX: offsetX , offsetY: offsetY  } = this.getCurrentSourcePreviewNodeOptions();
                        const anchorPoint = {
                            anchorX: anchorX,
                            anchorY: anchorY
                        };
                        const offsetPoint = {
                            offsetX: offsetX,
                            offsetY: offsetY
                        };
                        const dragPreviewOffset = $700bf53ed0e34a6e$var$getDragPreviewOffset(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint);
                        dataTransfer.setDragImage(dragPreview, dragPreviewOffset.x, dragPreviewOffset.y);
                    }
                }
                try {
                    // Firefox won't drag without setting data
                    dataTransfer === null || dataTransfer === void 0 || dataTransfer.setData("application/json", {});
                } catch (err) {
                // IE doesn't support MIME types in setData
                }
                // Store drag source node so we can check whether
                // it is removed from DOM and trigger endDrag manually.
                this.setCurrentDragSourceNode(e.target);
                // Now we are ready to publish the drag source.. or are we not?
                const { captureDraggingState: captureDraggingState  } = this.getCurrentSourcePreviewNodeOptions();
                if (!captureDraggingState) // Usually we want to publish it in the next tick so that browser
                // is able to screenshot the current (not yet dragging) state.
                //
                // It also neatly avoids a situation where render() returns null
                // in the same tick for the source element, and browser freaks out.
                setTimeout(()=>this.actions.publishDragSource(), 0);
                else // In some cases the user may want to override this behavior, e.g.
                // to work around IE not supporting custom drag previews.
                //
                // When using a custom drag layer, the only way to prevent
                // the default drag preview from drawing in IE is to screenshot
                // the dragging state in which the node itself has zero opacity
                // and height. In this case, though, returning null from render()
                // will abruptly end the dragging, which is not obvious.
                //
                // This is the reason such behavior is strictly opt-in.
                this.actions.publishDragSource();
            } else if (nativeType) // A native item (such as URL) dragged from inside the document
            this.beginDragNativeItem(nativeType);
            else if (dataTransfer && !dataTransfer.types && (e.target && !e.target.hasAttribute || !e.target.hasAttribute("draggable"))) // Looks like a Safari bug: dataTransfer.types is null, but there was no draggable.
            // Just let it drag. It's a native type (URL or text) and will be picked up in
            // dragenter handler.
            return;
            else // If by this time no drag source reacted, tell browser not to drag.
            e.preventDefault();
        };
        this.handleTopDragEndCapture = ()=>{
            if (this.clearCurrentDragSourceNode() && this.monitor.isDragging()) // Firefox can dispatch this event in an infinite loop
            // if dragend handler does something like showing an alert.
            // Only proceed if we have not handled it already.
            this.actions.endDrag();
            this.cancelHover();
        };
        this.handleTopDragEnterCapture = (e)=>{
            this.dragEnterTargetIds = [];
            if (this.isDraggingNativeItem()) {
                var ref;
                (ref = this.currentNativeSource) === null || ref === void 0 || ref.loadDataTransfer(e.dataTransfer);
            }
            const isFirstEnter = this.enterLeaveCounter.enter(e.target);
            if (!isFirstEnter || this.monitor.isDragging()) return;
            const { dataTransfer: dataTransfer  } = e;
            const nativeType = $700bf53ed0e34a6e$var$matchNativeItemType(dataTransfer);
            if (nativeType) // A native item (such as file or URL) dragged from outside the document
            this.beginDragNativeItem(nativeType, dataTransfer);
        };
        this.handleTopDragEnter = (e)=>{
            const { dragEnterTargetIds: dragEnterTargetIds  } = this;
            this.dragEnterTargetIds = [];
            if (!this.monitor.isDragging()) // This is probably a native item type we don't understand.
            return;
            this.altKeyPressed = e.altKey;
            // If the target changes position as the result of `dragenter`, `dragover` might still
            // get dispatched despite target being no longer there. The easy solution is to check
            // whether there actually is a target before firing `hover`.
            if (dragEnterTargetIds.length > 0) this.actions.hover(dragEnterTargetIds, {
                clientOffset: $700bf53ed0e34a6e$var$getEventClientOffset$1(e)
            });
            const canDrop = dragEnterTargetIds.some((targetId)=>this.monitor.canDropOnTarget(targetId));
            if (canDrop) {
                // IE requires this to fire dragover events
                e.preventDefault();
                if (e.dataTransfer) e.dataTransfer.dropEffect = this.getCurrentDropEffect();
            }
        };
        this.handleTopDragOverCapture = (e)=>{
            this.dragOverTargetIds = [];
            if (this.isDraggingNativeItem()) {
                var ref;
                (ref = this.currentNativeSource) === null || ref === void 0 || ref.loadDataTransfer(e.dataTransfer);
            }
        };
        this.handleTopDragOver = (e)=>{
            const { dragOverTargetIds: dragOverTargetIds  } = this;
            this.dragOverTargetIds = [];
            if (!this.monitor.isDragging()) {
                // This is probably a native item type we don't understand.
                // Prevent default "drop and blow away the whole document" action.
                e.preventDefault();
                if (e.dataTransfer) e.dataTransfer.dropEffect = "none";
                return;
            }
            this.altKeyPressed = e.altKey;
            this.lastClientOffset = $700bf53ed0e34a6e$var$getEventClientOffset$1(e);
            this.scheduleHover(dragOverTargetIds);
            const canDrop = (dragOverTargetIds || []).some((targetId)=>this.monitor.canDropOnTarget(targetId));
            if (canDrop) {
                // Show user-specified drop effect.
                e.preventDefault();
                if (e.dataTransfer) e.dataTransfer.dropEffect = this.getCurrentDropEffect();
            } else if (this.isDraggingNativeItem()) // Don't show a nice cursor but still prevent default
            // "drop and blow away the whole document" action.
            e.preventDefault();
            else {
                e.preventDefault();
                if (e.dataTransfer) e.dataTransfer.dropEffect = "none";
            }
        };
        this.handleTopDragLeaveCapture = (e)=>{
            if (this.isDraggingNativeItem()) e.preventDefault();
            const isLastLeave = this.enterLeaveCounter.leave(e.target);
            if (!isLastLeave) return;
            if (this.isDraggingNativeItem()) setTimeout(()=>this.endDragNativeItem(), 0);
            this.cancelHover();
        };
        this.handleTopDropCapture = (e)=>{
            this.dropTargetIds = [];
            if (this.isDraggingNativeItem()) {
                var ref;
                e.preventDefault();
                (ref = this.currentNativeSource) === null || ref === void 0 || ref.loadDataTransfer(e.dataTransfer);
            } else if ($700bf53ed0e34a6e$var$matchNativeItemType(e.dataTransfer)) // Dragging some elements, like <a> and <img> may still behave like a native drag event,
            // even if the current drag event matches a user-defined type.
            // Stop the default behavior when we're not expecting a native item to be dropped.
            e.preventDefault();
            this.enterLeaveCounter.reset();
        };
        this.handleTopDrop = (e)=>{
            const { dropTargetIds: dropTargetIds  } = this;
            this.dropTargetIds = [];
            this.actions.hover(dropTargetIds, {
                clientOffset: $700bf53ed0e34a6e$var$getEventClientOffset$1(e)
            });
            this.actions.drop({
                dropEffect: this.getCurrentDropEffect()
            });
            if (this.isDraggingNativeItem()) this.endDragNativeItem();
            else if (this.monitor.isDragging()) this.actions.endDrag();
            this.cancelHover();
        };
        this.handleSelectStart = (e)=>{
            const target = e.target;
            // Only IE requires us to explicitly say
            // we want drag drop operation to start
            if (typeof target.dragDrop !== "function") return;
            // Inputs and textareas should be selectable
            if (target.tagName === "INPUT" || target.tagName === "SELECT" || target.tagName === "TEXTAREA" || target.isContentEditable) return;
            // For other targets, ask IE
            // to enable drag and drop
            e.preventDefault();
            target.dragDrop();
        };
        this.options = new $700bf53ed0e34a6e$var$OptionsReader$1(globalContext, options);
        this.actions = manager.getActions();
        this.monitor = manager.getMonitor();
        this.registry = manager.getRegistry();
        this.enterLeaveCounter = new $700bf53ed0e34a6e$var$EnterLeaveCounter(this.isNodeInDocument);
    }
}
let $700bf53ed0e34a6e$var$emptyImage;
function $700bf53ed0e34a6e$var$getEmptyImage() {
    if (!$700bf53ed0e34a6e$var$emptyImage) {
        $700bf53ed0e34a6e$var$emptyImage = new Image();
        $700bf53ed0e34a6e$var$emptyImage.src = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
    }
    return $700bf53ed0e34a6e$var$emptyImage;
}
const $700bf53ed0e34a6e$var$HTML5Backend = function createBackend(manager, context, options) {
    return new $700bf53ed0e34a6e$var$HTML5BackendImpl(manager, context, options);
};
function $700bf53ed0e34a6e$var$Piece({ isPremovedPiece: isPremovedPiece = false , piece: piece , square: square , squares: squares  }) {
    const { animationDuration: animationDuration , arePiecesDraggable: arePiecesDraggable , boardWidth: boardWidth , boardOrientation: boardOrientation , chessPieces: chessPieces , currentPosition: currentPosition , deletePieceFromSquare: deletePieceFromSquare , dropOffBoardAction: dropOffBoardAction , id: id , isDraggablePiece: isDraggablePiece , isWaitingForAnimation: isWaitingForAnimation , onPieceClick: onPieceClick , onPieceDragBegin: onPieceDragBegin , onPieceDragEnd: onPieceDragEnd , onPieceDropOffBoard: onPieceDropOffBoard , onPromotionCheck: onPromotionCheck , positionDifferences: positionDifferences  } = $700bf53ed0e34a6e$var$useChessboard();
    const [pieceStyle, setPieceStyle] = (0, $bh6RR.useState)({
        opacity: 1,
        zIndex: 5,
        touchAction: "none",
        cursor: arePiecesDraggable && isDraggablePiece({
            piece: piece,
            sourceSquare: square
        }) ? "-webkit-grab" : "default"
    });
    const [{ canDrag: canDrag , isDragging: isDragging  }, drag, dragPreview] = $700bf53ed0e34a6e$var$useDrag(()=>({
            type: "piece",
            item: ()=>{
                onPieceDragBegin(piece, square);
                return {
                    piece: piece,
                    square: square,
                    id: id
                };
            },
            end: (item, monitor)=>{
                onPieceDragEnd(piece, square);
                const wasDropOutsideTheBoard = !monitor.didDrop();
                if (wasDropOutsideTheBoard) {
                    if (dropOffBoardAction === "trash") deletePieceFromSquare(square);
                    onPieceDropOffBoard === null || onPieceDropOffBoard === void 0 || onPieceDropOffBoard(square, piece);
                }
            },
            collect: (monitor)=>({
                    canDrag: isDraggablePiece({
                        piece: piece,
                        sourceSquare: square
                    }),
                    isDragging: !!monitor.isDragging()
                })
        }), [
        piece,
        square,
        currentPosition,
        id
    ]);
    // hide the default preview
    dragPreview($700bf53ed0e34a6e$var$getEmptyImage(), {
        captureDraggingState: true
    });
    // hide piece on drag
    (0, $bh6RR.useEffect)(()=>{
        setPieceStyle((oldPieceStyle)=>Object.assign(Object.assign({}, oldPieceStyle), {
                opacity: isDragging ? 0 : 1
            }));
    }, [
        isDragging
    ]);
    // new move has come in
    // if waiting for animation, then animation has started and we can perform animation
    // we need to head towards where we need to go, we are the source, we are heading towards the target
    (0, $bh6RR.useEffect)(()=>{
        var _a;
        const removedPiece = (_a = positionDifferences.removed) === null || _a === void 0 ? void 0 : _a[square];
        // return as null and not loaded yet
        if (!positionDifferences.added || !removedPiece) return;
        // check if piece matches or if removed piece was a pawn and new square is on 1st or 8th rank (promotion)
        const newSquare = Object.entries(positionDifferences.added).find(([s, p])=>p === removedPiece || onPromotionCheck(square, s, removedPiece));
        // we can perform animation if our square was in removed, AND the matching piece is in added AND this isn't a premoved piece
        if (isWaitingForAnimation && removedPiece && newSquare && !isPremovedPiece) {
            const sourceSq = square;
            const targetSq = newSquare[0];
            if (sourceSq && targetSq) {
                const squareWidth = boardWidth / 8;
                setPieceStyle((oldPieceStyle)=>Object.assign(Object.assign({}, oldPieceStyle), {
                        transform: `translate(${(boardOrientation === "black" ? -1 : 1) * (targetSq.charCodeAt(0) - sourceSq.charCodeAt(0)) * squareWidth}px, ${(boardOrientation === "black" ? -1 : 1) * (Number(sourceSq[1]) - Number(targetSq[1])) * squareWidth}px)`,
                        transition: `transform ${animationDuration}ms`,
                        zIndex: 6
                    }));
            }
        }
    }, [
        positionDifferences
    ]);
    // translate to their own positions (repaint on undo)
    (0, $bh6RR.useEffect)(()=>{
        const { sourceSq: sourceSq  } = getSingleSquareCoordinates();
        if (sourceSq) setPieceStyle((oldPieceStyle)=>Object.assign(Object.assign({}, oldPieceStyle), {
                transform: `translate(${0}px, ${0}px)`,
                transition: `transform ${0}ms`
            }));
    }, [
        currentPosition
    ]);
    // update is piece draggable
    (0, $bh6RR.useEffect)(()=>{
        setPieceStyle((oldPieceStyle)=>Object.assign(Object.assign({}, oldPieceStyle), {
                cursor: arePiecesDraggable && isDraggablePiece({
                    piece: piece,
                    sourceSquare: square
                }) ? "-webkit-grab" : "default"
            }));
    }, [
        square,
        currentPosition,
        arePiecesDraggable
    ]);
    function getSingleSquareCoordinates() {
        return {
            sourceSq: squares[square]
        };
    }
    return (0, $d4dab640dcbe486c$exports.jsx)("div", Object.assign({
        ref: arePiecesDraggable && canDrag ? drag : null,
        onClick: ()=>onPieceClick(piece, square),
        "data-piece": piece,
        style: pieceStyle
    }, {
        children: typeof chessPieces[piece] === "function" ? chessPieces[piece]({
            squareWidth: boardWidth / 8,
            isDragging: isDragging,
            square: square
        }) : (0, $d4dab640dcbe486c$exports.jsx)("svg", Object.assign({
            viewBox: "1 1 43 43",
            width: boardWidth / 8,
            height: boardWidth / 8,
            style: {
                display: "block"
            }
        }, {
            children: (0, $d4dab640dcbe486c$exports.jsx)("g", {
                children: chessPieces[piece]
            })
        }))
    }));
}
function $700bf53ed0e34a6e$var$Square({ square: square , squareColor: squareColor , setSquares: setSquares , squareHasPremove: squareHasPremove , children: children  }) {
    const squareRef = (0, $bh6RR.useRef)(null);
    const { autoPromoteToQueen: autoPromoteToQueen , boardWidth: boardWidth , boardOrientation: boardOrientation , clearArrows: clearArrows , currentPosition: currentPosition , currentRightClickDown: currentRightClickDown , customBoardStyle: customBoardStyle , customDarkSquareStyle: customDarkSquareStyle , customDropSquareStyle: customDropSquareStyle , customLightSquareStyle: customLightSquareStyle , customPremoveDarkSquareStyle: customPremoveDarkSquareStyle , customPremoveLightSquareStyle: customPremoveLightSquareStyle , customSquare: CustomSquare , customSquareStyles: customSquareStyles , drawNewArrow: drawNewArrow , handleSetPosition: handleSetPosition , handleSparePieceDrop: handleSparePieceDrop , isWaitingForAnimation: isWaitingForAnimation , lastPieceColour: lastPieceColour , lastSquareDraggedOver: lastSquareDraggedOver , onArrowDrawEnd: onArrowDrawEnd , onDragOverSquare: onDragOverSquare , onMouseOutSquare: onMouseOutSquare , onMouseOverSquare: onMouseOverSquare , onPieceDrop: onPieceDrop , onPromotionCheck: onPromotionCheck , onRightClickDown: onRightClickDown , onRightClickUp: onRightClickUp , onSquareClick: onSquareClick , setLastSquareDraggedOver: setLastSquareDraggedOver , setPromoteFromSquare: setPromoteFromSquare , setPromoteToSquare: setPromoteToSquare , setShowPromoteDialog: setShowPromoteDialog  } = $700bf53ed0e34a6e$var$useChessboard();
    const [{ isOver: isOver  }, drop] = $700bf53ed0e34a6e$var$useDrop(()=>({
            accept: "piece",
            drop: handleDrop,
            collect: (monitor)=>({
                    isOver: !!monitor.isOver()
                })
        }), [
        square,
        currentPosition,
        onPieceDrop,
        isWaitingForAnimation,
        lastPieceColour
    ]);
    function handleDrop(item) {
        if (item.isSpare) {
            handleSparePieceDrop(item.piece, square);
            return;
        }
        if (onPromotionCheck(item.square, square, item.piece)) {
            if (autoPromoteToQueen) handleSetPosition(item.square, square, item.piece[0] === "w" ? "wQ" : "bQ");
            else {
                setPromoteFromSquare(item.square);
                setPromoteToSquare(square);
                setShowPromoteDialog(true);
            }
        } else handleSetPosition(item.square, square, item.piece, true);
    }
    (0, $bh6RR.useEffect)(()=>{
        if (squareRef.current) {
            const { x: x , y: y  } = squareRef.current.getBoundingClientRect();
            setSquares((oldSquares)=>Object.assign(Object.assign({}, oldSquares), {
                    [square]: {
                        x: x,
                        y: y
                    }
                }));
        }
    }, [
        boardWidth,
        boardOrientation
    ]);
    const defaultSquareStyle = Object.assign(Object.assign(Object.assign(Object.assign({}, $700bf53ed0e34a6e$var$borderRadius(square, boardOrientation, customBoardStyle)), squareColor === "black" ? customDarkSquareStyle : customLightSquareStyle), squareHasPremove && (squareColor === "black" ? customPremoveDarkSquareStyle : customPremoveLightSquareStyle)), isOver && customDropSquareStyle);
    return (0, $d4dab640dcbe486c$exports.jsx)("div", Object.assign({
        ref: drop,
        style: defaultSquareStyle,
        "data-square-color": squareColor,
        "data-square": square,
        onTouchMove: (e)=>{
            var _a;
            // Handle touch events on tablet and mobile not covered by onMouseOver/onDragEnter
            const touchLocation = e.touches[0];
            const touchElement = document.elementsFromPoint(touchLocation.clientX, touchLocation.clientY);
            const draggedOverSquare = (_a = touchElement === null || touchElement === void 0 ? void 0 : touchElement.find((el)=>el.getAttribute("data-square"))) === null || _a === void 0 ? void 0 : _a.getAttribute("data-square");
            if (draggedOverSquare && draggedOverSquare !== lastSquareDraggedOver) {
                setLastSquareDraggedOver(draggedOverSquare);
                onDragOverSquare(draggedOverSquare);
            }
        },
        onMouseOver: (e)=>{
            // noop if moving from child of square into square.
            if (e.buttons === 2 && currentRightClickDown) drawNewArrow(currentRightClickDown, square);
            if (e.relatedTarget && e.currentTarget.contains(e.relatedTarget)) return;
            onMouseOverSquare(square);
        },
        onMouseOut: (e)=>{
            // noop if moving from square into a child of square.
            if (e.relatedTarget && e.currentTarget.contains(e.relatedTarget)) return;
            onMouseOutSquare(square);
        },
        onMouseDown: (e)=>{
            if (e.button === 2) onRightClickDown(square);
        },
        onMouseUp: (e)=>{
            if (e.button === 2) {
                if (currentRightClickDown) onArrowDrawEnd(currentRightClickDown, square);
                onRightClickUp(square);
            }
        },
        onDragEnter: ()=>onDragOverSquare(square),
        onClick: ()=>{
            const piece = currentPosition[square];
            onSquareClick(square, piece);
            clearArrows();
        },
        onContextMenu: (e)=>{
            e.preventDefault();
        }
    }, {
        children: typeof CustomSquare === "string" ? (0, $d4dab640dcbe486c$exports.jsx)(CustomSquare, Object.assign({
            // Type is too complex to properly evaluate, so ignore this line.
            // @ts-ignore
            ref: squareRef,
            style: Object.assign(Object.assign(Object.assign({}, $700bf53ed0e34a6e$var$size(boardWidth)), $700bf53ed0e34a6e$var$center), !squareHasPremove && (customSquareStyles === null || customSquareStyles === void 0 ? void 0 : customSquareStyles[square]))
        }, {
            children: children
        })) : (0, $d4dab640dcbe486c$exports.jsx)(CustomSquare, Object.assign({
            ref: squareRef,
            square: square,
            squareColor: squareColor,
            style: Object.assign(Object.assign(Object.assign({}, $700bf53ed0e34a6e$var$size(boardWidth)), $700bf53ed0e34a6e$var$center), !squareHasPremove && (customSquareStyles === null || customSquareStyles === void 0 ? void 0 : customSquareStyles[square]))
        }, {
            children: children
        }))
    }));
}
const $700bf53ed0e34a6e$var$center = {
    display: "flex",
    justifyContent: "center"
};
const $700bf53ed0e34a6e$var$size = (width)=>({
        width: width / 8,
        height: width / 8
    });
const $700bf53ed0e34a6e$var$borderRadius = (square, boardOrientation, customBoardStyle)=>{
    if (!(customBoardStyle === null || customBoardStyle === void 0 ? void 0 : customBoardStyle.borderRadius)) return {};
    if (square === "a1") return boardOrientation === "white" ? {
        borderBottomLeftRadius: customBoardStyle.borderRadius
    } : {
        borderTopRightRadius: customBoardStyle.borderRadius
    };
    if (square === "a8") return boardOrientation === "white" ? {
        borderTopLeftRadius: customBoardStyle.borderRadius
    } : {
        borderBottomRightRadius: customBoardStyle.borderRadius
    };
    if (square === "h1") return boardOrientation === "white" ? {
        borderBottomRightRadius: customBoardStyle.borderRadius
    } : {
        borderTopLeftRadius: customBoardStyle.borderRadius
    };
    if (square === "h8") return boardOrientation === "white" ? {
        borderTopRightRadius: customBoardStyle.borderRadius
    } : {
        borderBottomLeftRadius: customBoardStyle.borderRadius
    };
    return {};
};
function $700bf53ed0e34a6e$var$Squares() {
    const [squares, setSquares] = (0, $bh6RR.useState)({});
    const { arePremovesAllowed: arePremovesAllowed , boardOrientation: boardOrientation , boardWidth: boardWidth , currentPosition: currentPosition , id: id , premoves: premoves , showBoardNotation: showBoardNotation  } = $700bf53ed0e34a6e$var$useChessboard();
    const premovesHistory = (0, $bh6RR.useMemo)(()=>{
        const result = [];
        // if premoves aren't allowed, don't waste time on calculations
        if (!arePremovesAllowed) return [];
        premoves.forEach((premove, index)=>{
            const { sourceSq: sourceSq , targetSq: targetSq , piece: piece  } = premove;
            // determine if the premove is made by an already premoved piece
            const relatedPremovedPiece = result.find((p)=>{
                var _a;
                return p.piece === piece && ((_a = p.premovesRoute.at(-1)) === null || _a === void 0 ? void 0 : _a.targetSq) === sourceSq;
            });
            // if premove has been made by already premoved piece then write the move to its `premovesRoute` field to be able find its final destination later
            if (relatedPremovedPiece) relatedPremovedPiece.premovesRoute.push({
                sourceSq: sourceSq,
                targetSq: targetSq,
                index: index
            });
            else result.push({
                piece: piece,
                // index is useful for scenarios where two or more pieces are targeting the same square
                premovesRoute: [
                    {
                        sourceSq: sourceSq,
                        targetSq: targetSq,
                        index: index
                    }
                ]
            });
        });
        return result;
    }, [
        premoves
    ]);
    return (0, $d4dab640dcbe486c$exports.jsx)("div", Object.assign({
        "data-boardid": id
    }, {
        children: [
            ...Array(8)
        ].map((_, r)=>{
            return (0, $d4dab640dcbe486c$exports.jsx)("div", Object.assign({
                style: {
                    display: "flex",
                    flexWrap: "nowrap",
                    width: boardWidth
                }
            }, {
                children: [
                    ...Array(8)
                ].map((_, c)=>{
                    const square = boardOrientation === "black" ? $700bf53ed0e34a6e$var$COLUMNS[7 - c] + (r + 1) : $700bf53ed0e34a6e$var$COLUMNS[c] + (8 - r);
                    const squareColor = c % 2 === r % 2 ? "white" : "black";
                    const squareHasPremove = premoves.find((p)=>p.sourceSq === square || p.targetSq === square);
                    const squareHasPremoveTarget = premovesHistory.filter(({ premovesRoute: premovesRoute  })=>{
                        var _a;
                        return ((_a = premovesRoute.at(-1)) === null || _a === void 0 ? void 0 : _a.targetSq) === square;
                    })//the premoved piece with the higher index will be shown, as it is the latest one
                    .sort((a, b)=>{
                        var _a, _b;
                        return ((_a = b.premovesRoute.at(-1)) === null || _a === void 0 ? void 0 : _a.index) - ((_b = a.premovesRoute.at(-1)) === null || _b === void 0 ? void 0 : _b.index);
                    }).at(0);
                    return (0, $d4dab640dcbe486c$exports.jsxs)($700bf53ed0e34a6e$var$Square, Object.assign({
                        square: square,
                        squareColor: squareColor,
                        setSquares: setSquares,
                        squareHasPremove: !!squareHasPremove
                    }, {
                        children: [
                            !squareHasPremove && currentPosition[square] && (0, $d4dab640dcbe486c$exports.jsx)($700bf53ed0e34a6e$var$Piece, {
                                piece: currentPosition[square],
                                square: square,
                                squares: squares
                            }),
                            squareHasPremoveTarget && (0, $d4dab640dcbe486c$exports.jsx)($700bf53ed0e34a6e$var$Piece, {
                                isPremovedPiece: true,
                                piece: squareHasPremoveTarget.piece,
                                square: square,
                                squares: squares
                            }),
                            showBoardNotation && (0, $d4dab640dcbe486c$exports.jsx)($700bf53ed0e34a6e$var$Notation, {
                                row: r,
                                col: c
                            })
                        ]
                    }), `${c}${r}`);
                })
            }), r.toString());
        })
    }));
}
const $700bf53ed0e34a6e$var$Arrows = ()=>{
    const { arrows: arrows , newArrow: newArrow , boardOrientation: boardOrientation , boardWidth: boardWidth , customArrowColor: primaryArrowCollor  } = $700bf53ed0e34a6e$var$useChessboard();
    const arrowsList = [
        ...arrows,
        newArrow
    ].filter(Boolean);
    return (0, $d4dab640dcbe486c$exports.jsx)("svg", Object.assign({
        width: boardWidth,
        height: boardWidth,
        style: {
            position: "absolute",
            top: "0",
            left: "0",
            pointerEvents: "none",
            zIndex: "10"
        }
    }, {
        children: arrowsList.map((arrow, i)=>{
            const [arrowStartField, arrowEndField, arrowColor] = arrow;
            if (arrowStartField === arrowEndField) return null;
            const from = $700bf53ed0e34a6e$var$getRelativeCoords(boardOrientation, boardWidth, arrowStartField);
            const to = $700bf53ed0e34a6e$var$getRelativeCoords(boardOrientation, boardWidth, arrowEndField);
            let ARROW_LENGTH_REDUCER = boardWidth / 32;
            const isArrowActive = i === arrows.length;
            // if there are different arrows targeting the same square make their length a bit shorter
            if (arrows.some((restArrow)=>restArrow[0] !== arrowStartField && restArrow[1] === arrowEndField) && !isArrowActive) ARROW_LENGTH_REDUCER = boardWidth / 16;
            const dx = to.x - from.x;
            const dy = to.y - from.y;
            const r = Math.hypot(dy, dx);
            const end = {
                x: from.x + dx * (r - ARROW_LENGTH_REDUCER) / r,
                y: from.y + dy * (r - ARROW_LENGTH_REDUCER) / r
            };
            return (0, $d4dab640dcbe486c$exports.jsxs)((0, $bh6RR.Fragment), {
                children: [
                    (0, $d4dab640dcbe486c$exports.jsx)("marker", Object.assign({
                        id: `arrowhead-${i}`,
                        markerWidth: "2",
                        markerHeight: "2.5",
                        refX: "1.25",
                        refY: "1.25",
                        orient: "auto"
                    }, {
                        children: (0, $d4dab640dcbe486c$exports.jsx)("polygon", {
                            points: "0.3 0, 2 1.25, 0.3 2.5",
                            fill: arrowColor !== null && arrowColor !== void 0 ? arrowColor : primaryArrowCollor
                        })
                    })),
                    (0, $d4dab640dcbe486c$exports.jsx)("line", {
                        x1: from.x,
                        y1: from.y,
                        x2: end.x,
                        y2: end.y,
                        opacity: isArrowActive ? "0.5" : "0.65",
                        stroke: arrowColor !== null && arrowColor !== void 0 ? arrowColor : primaryArrowCollor,
                        strokeWidth: isArrowActive ? 0.9 * boardWidth / 40 : boardWidth / 40,
                        markerEnd: `url(#arrowhead-${i})`
                    })
                ]
            }, `${arrowStartField}-${arrowEndField}${isArrowActive ? "-active" : ""}`);
        })
    }));
};
function $700bf53ed0e34a6e$var$PromotionOption({ option: option  }) {
    const [isHover, setIsHover] = (0, $bh6RR.useState)(false);
    const { boardWidth: boardWidth , chessPieces: chessPieces , customDarkSquareStyle: customDarkSquareStyle , customLightSquareStyle: customLightSquareStyle , handleSetPosition: handleSetPosition , onPromotionPieceSelect: onPromotionPieceSelect , promoteFromSquare: promoteFromSquare , promoteToSquare: promoteToSquare , promotionDialogVariant: promotionDialogVariant  } = $700bf53ed0e34a6e$var$useChessboard();
    const backgroundColor = ()=>{
        switch(option[1]){
            case "Q":
                return customDarkSquareStyle.backgroundColor;
            case "R":
                return customLightSquareStyle.backgroundColor;
            case "N":
                return promotionDialogVariant === "default" ? customLightSquareStyle.backgroundColor : customDarkSquareStyle.backgroundColor;
            case "B":
                return promotionDialogVariant === "default" ? customDarkSquareStyle.backgroundColor : customLightSquareStyle.backgroundColor;
        }
    };
    return (0, $d4dab640dcbe486c$exports.jsx)("div", Object.assign({
        onClick: ()=>{
            if (onPromotionPieceSelect(option, promoteFromSquare !== null && promoteFromSquare !== void 0 ? promoteFromSquare : undefined, promoteToSquare !== null && promoteToSquare !== void 0 ? promoteToSquare : undefined)) handleSetPosition(promoteFromSquare, promoteToSquare, option, true);
        },
        onMouseOver: ()=>setIsHover(true),
        onMouseOut: ()=>setIsHover(false),
        "data-piece": option,
        style: {
            cursor: "pointer",
            backgroundColor: isHover ? backgroundColor() : `${backgroundColor()}aa`,
            borderRadius: "4px",
            transition: "all 0.1s ease-out"
        }
    }, {
        children: typeof chessPieces[option] === "function" ? (0, $d4dab640dcbe486c$exports.jsx)("div", Object.assign({
            style: {
                transition: "all 0.1s ease-out",
                transform: isHover ? "scale(1)" : "scale(0.85)"
            }
        }, {
            children: chessPieces[option]({
                squareWidth: boardWidth / 8,
                isDragging: false
            })
        })) : (0, $d4dab640dcbe486c$exports.jsx)("svg", Object.assign({
            viewBox: "1 1 43 43",
            width: boardWidth / 8,
            height: boardWidth / 8,
            style: {
                transition: "all 0.1s ease-out",
                transform: isHover ? "scale(1)" : "scale(0.85)"
            }
        }, {
            children: (0, $d4dab640dcbe486c$exports.jsx)("g", {
                children: chessPieces[option]
            })
        }))
    }));
}
function $700bf53ed0e34a6e$var$PromotionDialog() {
    const { boardOrientation: boardOrientation , boardWidth: boardWidth , promotionDialogVariant: promotionDialogVariant , promoteToSquare: promoteToSquare  } = $700bf53ed0e34a6e$var$useChessboard();
    const promotePieceColor = (promoteToSquare === null || promoteToSquare === void 0 ? void 0 : promoteToSquare[1]) === "1" ? "b" : "w";
    const promotionOptions = [
        `${promotePieceColor !== null && promotePieceColor !== void 0 ? promotePieceColor : "w"}Q`,
        `${promotePieceColor !== null && promotePieceColor !== void 0 ? promotePieceColor : "w"}R`,
        `${promotePieceColor !== null && promotePieceColor !== void 0 ? promotePieceColor : "w"}N`,
        `${promotePieceColor !== null && promotePieceColor !== void 0 ? promotePieceColor : "w"}B`
    ];
    const dialogStyles = {
        default: {
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            transform: `translate(${-boardWidth / 8}px, ${-boardWidth / 8}px)`
        },
        vertical: {
            transform: `translate(${-boardWidth / 16}px, ${-boardWidth / 16}px)`
        },
        modal: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            transform: `translate(0px, ${3 * boardWidth / 8}px)`,
            width: "100%",
            height: `${boardWidth / 4}px`,
            top: 0,
            backgroundColor: "white",
            left: 0
        }
    };
    const dialogCoords = $700bf53ed0e34a6e$var$getRelativeCoords(boardOrientation, boardWidth, promoteToSquare || "a8");
    return (0, $d4dab640dcbe486c$exports.jsx)("div", Object.assign({
        style: Object.assign({
            position: "absolute",
            top: `${dialogCoords === null || dialogCoords === void 0 ? void 0 : dialogCoords.y}px`,
            left: `${dialogCoords === null || dialogCoords === void 0 ? void 0 : dialogCoords.x}px`,
            zIndex: 1000
        }, dialogStyles[promotionDialogVariant]),
        title: "Choose promotion piece"
    }, {
        children: promotionOptions.map((option)=>(0, $d4dab640dcbe486c$exports.jsx)($700bf53ed0e34a6e$var$PromotionOption, {
                option: option
            }, option))
    }));
}
const $700bf53ed0e34a6e$var$errorImage = {
    whiteKing: (0, $d4dab640dcbe486c$exports.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        style: {
            shapeRendering: "geometricPrecision",
            textRendering: "geometricPrecision",
            imageRendering: "crisp-edges"
        },
        viewBox: "0 0 4210 12970",
        x: "0px",
        y: "0px",
        fillRule: "evenodd",
        clipRule: "evenodd",
        width: "250",
        height: "250"
    }, {
        children: (0, $d4dab640dcbe486c$exports.jsx)("g", {
            children: (0, $d4dab640dcbe486c$exports.jsx)("path", {
                style: {
                    fill: "black",
                    fillRule: "nonzero"
                },
                d: "M2105 0c169,0 286,160 249,315l200 0c-172,266 -231,479 -256,792 315,-24 530,-86 792,-255l0 897c-265,-171 -479,-231 -792,-256 18,234 75,495 185,682l339 0c233,0 369,269 225,456l545 0 -595 1916c130,94 158,275 59,402 465,0 416,568 51,568l-334 0 465 2867 332 0c250,0 381,306 199,485 162,63 273,220 273,399l0 633 168 0 0 475c-1403,0 -2807,0 -4210,0l0 -475 167 0 0 -633c0,-179 112,-336 274,-399 -181,-178 -52,-485 199,-485l332 0 465 -2867 -335 0c-353,0 -418,-568 51,-568 -98,-127 -70,-308 59,-402l-594 -1916c181,0 363,0 545,0 -144,-187 -9,-456 225,-456l339 0c110,-187 167,-448 185,-682 -315,25 -530,87 -793,256l0 -897c266,171 480,231 793,255 -25,-315 -87,-529 -256,-792l199 0c-36,-155 81,-315 250,-315zm-1994 10012l0 253 3988 0 0 -253c-1330,0 -2659,0 -3988,0zm484 -1060c-174,0 -316,142 -316,316l0 633 3652 0 0 -633c0,-174 -142,-316 -316,-316 -1007,0 -2013,0 -3020,0zm45 -457c-230,0 -225,345 0,345l2930 0c230,0 225,-345 0,-345 -977,0 -1953,0 -2930,0zm2020 -2978l-1111 0 -465 2867 2041 0 -465 -2867zm-1558 -456c-229,0 -224,345 0,345 669,0 1337,0 2005,0 230,0 225,-345 0,-345 -668,0 -1336,0 -2005,0zm1730 -457l-1454 0c-229,0 -224,345 0,345l1454 0c229,0 224,-345 0,-345zm-2064 -1862l544 1751c529,0 1057,0 1586,0l544 -1751c-892,0 -1783,0 -2674,0zm1085 -567l504 0c-126,-247 -163,-526 -177,-800 273,15 553,52 800,177l0 -504c-247,126 -527,163 -800,177 14,-273 51,-552 177,-799 -168,0 -336,0 -504,0 125,247 162,526 177,799 -274,-14 -553,-51 -800,-177l0 504c247,-125 527,-162 800,-177 -15,274 -52,553 -177,800zm969 111l-1434 0c-230,0 -225,345 0,345l1434 0c230,0 225,-345 0,-345zm-717 -2175c-105,0 -175,109 -133,204l266 0c42,-96 -30,-205 -133,-204z"
            })
        })
    }))
};
function $700bf53ed0e34a6e$var$ErrorBoundary({ children: children  }) {
    try {
        return (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {
            children: children
        });
    } catch (error) {
        console.log(error);
        return (0, $d4dab640dcbe486c$exports.jsx)($700bf53ed0e34a6e$var$WhiteKing, {
            showError: true
        });
    }
}
function $700bf53ed0e34a6e$var$WhiteKing({ showError: showError = false  }) {
    return (0, $d4dab640dcbe486c$exports.jsxs)("div", Object.assign({
        style: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column"
        }
    }, {
        children: [
            (0, $d4dab640dcbe486c$exports.jsx)("div", Object.assign({
                style: {
                    width: 250,
                    height: 250,
                    transform: "rotate(90deg)"
                }
            }, {
                children: $700bf53ed0e34a6e$var$errorImage.whiteKing
            })),
            showError && (0, $d4dab640dcbe486c$exports.jsx)("h1", {
                children: "Something went wrong"
            })
        ]
    }));
}
function $700bf53ed0e34a6e$var$Board() {
    const boardRef = (0, $bh6RR.useRef)(null);
    const { boardWidth: boardWidth , clearCurrentRightClickDown: clearCurrentRightClickDown , onPromotionPieceSelect: onPromotionPieceSelect , setShowPromoteDialog: setShowPromoteDialog , showPromoteDialog: showPromoteDialog , customBoardStyle: customBoardStyle  } = $700bf53ed0e34a6e$var$useChessboard();
    (0, $bh6RR.useEffect)(()=>{
        function handleClickOutside(event) {
            if (boardRef.current && !boardRef.current.contains(event.target)) clearCurrentRightClickDown();
        }
        document.addEventListener("mouseup", handleClickOutside);
        return ()=>{
            document.removeEventListener("mouseup", handleClickOutside);
        };
    }, []);
    return boardWidth ? (0, $d4dab640dcbe486c$exports.jsx)("div", Object.assign({
        style: {
            perspective: "1000px"
        }
    }, {
        children: (0, $d4dab640dcbe486c$exports.jsxs)("div", Object.assign({
            ref: boardRef,
            style: Object.assign(Object.assign({
                position: "relative"
            }, $700bf53ed0e34a6e$var$boardStyles(boardWidth)), customBoardStyle)
        }, {
            children: [
                (0, $d4dab640dcbe486c$exports.jsx)($700bf53ed0e34a6e$var$Squares, {}),
                (0, $d4dab640dcbe486c$exports.jsx)($700bf53ed0e34a6e$var$Arrows, {}),
                showPromoteDialog && (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                    children: [
                        (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            onClick: ()=>{
                                setShowPromoteDialog(false);
                                onPromotionPieceSelect === null || onPromotionPieceSelect === void 0 || onPromotionPieceSelect();
                            },
                            style: {
                                position: "absolute",
                                top: "0",
                                left: "0",
                                zIndex: "100",
                                backgroundColor: "rgba(22,21,18,.7)",
                                width: boardWidth,
                                height: boardWidth
                            }
                        }),
                        (0, $d4dab640dcbe486c$exports.jsx)($700bf53ed0e34a6e$var$PromotionDialog, {})
                    ]
                })
            ]
        }))
    })) : (0, $d4dab640dcbe486c$exports.jsx)($700bf53ed0e34a6e$var$WhiteKing, {});
}
const $700bf53ed0e34a6e$var$boardStyles = (width)=>({
        cursor: "default",
        height: width,
        width: width
    });
var $700bf53ed0e34a6e$var$ListenerType;
(function(ListenerType) {
    ListenerType["mouse"] = "mouse";
    ListenerType["touch"] = "touch";
    ListenerType["keyboard"] = "keyboard";
})($700bf53ed0e34a6e$var$ListenerType || ($700bf53ed0e34a6e$var$ListenerType = {}));
class $700bf53ed0e34a6e$var$OptionsReader {
    get delay() {
        var _delay;
        return (_delay = this.args.delay) !== null && _delay !== void 0 ? _delay : 0;
    }
    get scrollAngleRanges() {
        return this.args.scrollAngleRanges;
    }
    get getDropTargetElementsAtPoint() {
        return this.args.getDropTargetElementsAtPoint;
    }
    get ignoreContextMenu() {
        var _ignoreContextMenu;
        return (_ignoreContextMenu = this.args.ignoreContextMenu) !== null && _ignoreContextMenu !== void 0 ? _ignoreContextMenu : false;
    }
    get enableHoverOutsideTarget() {
        var _enableHoverOutsideTarget;
        return (_enableHoverOutsideTarget = this.args.enableHoverOutsideTarget) !== null && _enableHoverOutsideTarget !== void 0 ? _enableHoverOutsideTarget : false;
    }
    get enableKeyboardEvents() {
        var _enableKeyboardEvents;
        return (_enableKeyboardEvents = this.args.enableKeyboardEvents) !== null && _enableKeyboardEvents !== void 0 ? _enableKeyboardEvents : false;
    }
    get enableMouseEvents() {
        var _enableMouseEvents;
        return (_enableMouseEvents = this.args.enableMouseEvents) !== null && _enableMouseEvents !== void 0 ? _enableMouseEvents : false;
    }
    get enableTouchEvents() {
        var _enableTouchEvents;
        return (_enableTouchEvents = this.args.enableTouchEvents) !== null && _enableTouchEvents !== void 0 ? _enableTouchEvents : true;
    }
    get touchSlop() {
        return this.args.touchSlop || 0;
    }
    get delayTouchStart() {
        var ref, ref1;
        var ref2, ref3;
        return (ref3 = (ref2 = (ref = this.args) === null || ref === void 0 ? void 0 : ref.delayTouchStart) !== null && ref2 !== void 0 ? ref2 : (ref1 = this.args) === null || ref1 === void 0 ? void 0 : ref1.delay) !== null && ref3 !== void 0 ? ref3 : 0;
    }
    get delayMouseStart() {
        var ref, ref4;
        var ref5, ref6;
        return (ref6 = (ref5 = (ref = this.args) === null || ref === void 0 ? void 0 : ref.delayMouseStart) !== null && ref5 !== void 0 ? ref5 : (ref4 = this.args) === null || ref4 === void 0 ? void 0 : ref4.delay) !== null && ref6 !== void 0 ? ref6 : 0;
    }
    get window() {
        if (this.context && this.context.window) return this.context.window;
        else if (typeof window !== "undefined") return window;
        return undefined;
    }
    get document() {
        var ref;
        if ((ref = this.context) === null || ref === void 0 ? void 0 : ref.document) return this.context.document;
        if (this.window) return this.window.document;
        return undefined;
    }
    get rootElement() {
        var ref;
        return ((ref = this.args) === null || ref === void 0 ? void 0 : ref.rootElement) || this.document;
    }
    constructor(args, context){
        this.args = args;
        this.context = context;
    }
}
function $700bf53ed0e34a6e$var$distance(x1, y1, x2, y2) {
    return Math.sqrt(Math.pow(Math.abs(x2 - x1), 2) + Math.pow(Math.abs(y2 - y1), 2));
}
function $700bf53ed0e34a6e$var$inAngleRanges(x1, y1, x2, y2, angleRanges) {
    if (!angleRanges) return false;
    const angle = Math.atan2(y2 - y1, x2 - x1) * 180 / Math.PI + 180;
    for(let i = 0; i < angleRanges.length; ++i){
        const ar = angleRanges[i];
        if (ar && (ar.start == null || angle >= ar.start) && (ar.end == null || angle <= ar.end)) return true;
    }
    return false;
}
// Used for MouseEvent.buttons (note the s on the end).
const $700bf53ed0e34a6e$var$MouseButtons = {
    Left: 1,
    Right: 2,
    Center: 4
};
// Used for e.button (note the lack of an s on the end).
const $700bf53ed0e34a6e$var$MouseButton = {
    Left: 0,
    Center: 1,
    Right: 2
};
/**
 * Only touch events and mouse events where the left button is pressed should initiate a drag.
 * @param {MouseEvent | TouchEvent} e The event
 */ function $700bf53ed0e34a6e$var$eventShouldStartDrag(e) {
    // For touch events, button will be undefined. If e.button is defined,
    // then it should be MouseButton.Left.
    return e.button === undefined || e.button === $700bf53ed0e34a6e$var$MouseButton.Left;
}
/**
 * Only touch events and mouse events where the left mouse button is no longer held should end a drag.
 * It's possible the user mouse downs with the left mouse button, then mouse down and ups with the right mouse button.
 * We don't want releasing the right mouse button to end the drag.
 * @param {MouseEvent | TouchEvent} e The event
 */ function $700bf53ed0e34a6e$var$eventShouldEndDrag(e) {
    // Touch events will have buttons be undefined, while mouse events will have e.buttons's left button
    // bit field unset if the left mouse button has been released
    return e.buttons === undefined || (e.buttons & $700bf53ed0e34a6e$var$MouseButtons.Left) === 0;
}
function $700bf53ed0e34a6e$var$isTouchEvent(e) {
    return !!e.targetTouches;
}
const $700bf53ed0e34a6e$var$ELEMENT_NODE = 1;
function $700bf53ed0e34a6e$var$getNodeClientOffset(node) {
    const el = node.nodeType === $700bf53ed0e34a6e$var$ELEMENT_NODE ? node : node.parentElement;
    if (!el) return undefined;
    const { top: top , left: left  } = el.getBoundingClientRect();
    return {
        x: left,
        y: top
    };
}
function $700bf53ed0e34a6e$var$getEventClientTouchOffset(e, lastTargetTouchFallback) {
    if (e.targetTouches.length === 1) return $700bf53ed0e34a6e$var$getEventClientOffset(e.targetTouches[0]);
    else if (lastTargetTouchFallback && e.touches.length === 1) {
        if (e.touches[0].target === lastTargetTouchFallback.target) return $700bf53ed0e34a6e$var$getEventClientOffset(e.touches[0]);
    }
    return;
}
function $700bf53ed0e34a6e$var$getEventClientOffset(e, lastTargetTouchFallback) {
    if ($700bf53ed0e34a6e$var$isTouchEvent(e)) return $700bf53ed0e34a6e$var$getEventClientTouchOffset(e, lastTargetTouchFallback);
    else return {
        x: e.clientX,
        y: e.clientY
    };
}
const $700bf53ed0e34a6e$var$supportsPassive = (()=>{
    // simular to jQuery's test
    let supported = false;
    try {
        addEventListener("test", ()=>{
        // do nothing
        }, Object.defineProperty({}, "passive", {
            get () {
                supported = true;
                return true;
            }
        }));
    } catch (e) {
    // do nothing
    }
    return supported;
})();
const $700bf53ed0e34a6e$var$eventNames = {
    [$700bf53ed0e34a6e$var$ListenerType.mouse]: {
        start: "mousedown",
        move: "mousemove",
        end: "mouseup",
        contextmenu: "contextmenu"
    },
    [$700bf53ed0e34a6e$var$ListenerType.touch]: {
        start: "touchstart",
        move: "touchmove",
        end: "touchend"
    },
    [$700bf53ed0e34a6e$var$ListenerType.keyboard]: {
        keydown: "keydown"
    }
};
class $700bf53ed0e34a6e$var$TouchBackendImpl {
    /**
	 * Generate profiling statistics for the HTML5Backend.
	 */ profile() {
        var ref;
        return {
            sourceNodes: this.sourceNodes.size,
            sourcePreviewNodes: this.sourcePreviewNodes.size,
            sourcePreviewNodeOptions: this.sourcePreviewNodeOptions.size,
            targetNodes: this.targetNodes.size,
            dragOverTargetIds: ((ref = this.dragOverTargetIds) === null || ref === void 0 ? void 0 : ref.length) || 0
        };
    }
    // public for test
    get document() {
        return this.options.document;
    }
    setup() {
        const root = this.options.rootElement;
        if (!root) return;
        $700bf53ed0e34a6e$var$invariant(!$700bf53ed0e34a6e$var$TouchBackendImpl.isSetUp, "Cannot have two Touch backends at the same time.");
        $700bf53ed0e34a6e$var$TouchBackendImpl.isSetUp = true;
        this.addEventListener(root, "start", this.getTopMoveStartHandler());
        this.addEventListener(root, "start", this.handleTopMoveStartCapture, true);
        this.addEventListener(root, "move", this.handleTopMove);
        this.addEventListener(root, "move", this.handleTopMoveCapture, true);
        this.addEventListener(root, "end", this.handleTopMoveEndCapture, true);
        if (this.options.enableMouseEvents && !this.options.ignoreContextMenu) this.addEventListener(root, "contextmenu", this.handleTopMoveEndCapture);
        if (this.options.enableKeyboardEvents) this.addEventListener(root, "keydown", this.handleCancelOnEscape, true);
    }
    teardown() {
        const root = this.options.rootElement;
        if (!root) return;
        $700bf53ed0e34a6e$var$TouchBackendImpl.isSetUp = false;
        this._mouseClientOffset = {};
        this.removeEventListener(root, "start", this.handleTopMoveStartCapture, true);
        this.removeEventListener(root, "start", this.handleTopMoveStart);
        this.removeEventListener(root, "move", this.handleTopMoveCapture, true);
        this.removeEventListener(root, "move", this.handleTopMove);
        this.removeEventListener(root, "end", this.handleTopMoveEndCapture, true);
        if (this.options.enableMouseEvents && !this.options.ignoreContextMenu) this.removeEventListener(root, "contextmenu", this.handleTopMoveEndCapture);
        if (this.options.enableKeyboardEvents) this.removeEventListener(root, "keydown", this.handleCancelOnEscape, true);
        this.uninstallSourceNodeRemovalObserver();
    }
    addEventListener(subject, event, handler, capture = false) {
        const options = $700bf53ed0e34a6e$var$supportsPassive ? {
            capture: capture,
            passive: false
        } : capture;
        this.listenerTypes.forEach(function(listenerType) {
            const evt = $700bf53ed0e34a6e$var$eventNames[listenerType][event];
            if (evt) subject.addEventListener(evt, handler, options);
        });
    }
    removeEventListener(subject, event, handler, capture = false) {
        const options = $700bf53ed0e34a6e$var$supportsPassive ? {
            capture: capture,
            passive: false
        } : capture;
        this.listenerTypes.forEach(function(listenerType) {
            const evt = $700bf53ed0e34a6e$var$eventNames[listenerType][event];
            if (evt) subject.removeEventListener(evt, handler, options);
        });
    }
    connectDragSource(sourceId, node) {
        const handleMoveStart = this.handleMoveStart.bind(this, sourceId);
        this.sourceNodes.set(sourceId, node);
        this.addEventListener(node, "start", handleMoveStart);
        return ()=>{
            this.sourceNodes.delete(sourceId);
            this.removeEventListener(node, "start", handleMoveStart);
        };
    }
    connectDragPreview(sourceId, node, options) {
        this.sourcePreviewNodeOptions.set(sourceId, options);
        this.sourcePreviewNodes.set(sourceId, node);
        return ()=>{
            this.sourcePreviewNodes.delete(sourceId);
            this.sourcePreviewNodeOptions.delete(sourceId);
        };
    }
    connectDropTarget(targetId, node) {
        const root = this.options.rootElement;
        if (!this.document || !root) return ()=>{
        /* noop */ };
        const handleMove = (e)=>{
            if (!this.document || !root || !this.monitor.isDragging()) return;
            let coords;
            /**
			 * Grab the coordinates for the current mouse/touch position
			 */ switch(e.type){
                case $700bf53ed0e34a6e$var$eventNames.mouse.move:
                    coords = {
                        x: e.clientX,
                        y: e.clientY
                    };
                    break;
                case $700bf53ed0e34a6e$var$eventNames.touch.move:
                    var ref, ref1;
                    coords = {
                        x: ((ref = e.touches[0]) === null || ref === void 0 ? void 0 : ref.clientX) || 0,
                        y: ((ref1 = e.touches[0]) === null || ref1 === void 0 ? void 0 : ref1.clientY) || 0
                    };
                    break;
            }
            /**
			 * Use the coordinates to grab the element the drag ended on.
			 * If the element is the same as the target node (or any of it's children) then we have hit a drop target and can handle the move.
			 */ const droppedOn = coords != null ? this.document.elementFromPoint(coords.x, coords.y) : undefined;
            const childMatch = droppedOn && node.contains(droppedOn);
            if (droppedOn === node || childMatch) return this.handleMove(e, targetId);
        };
        /**
		 * Attaching the event listener to the body so that touchmove will work while dragging over multiple target elements.
		 */ this.addEventListener(this.document.body, "move", handleMove);
        this.targetNodes.set(targetId, node);
        return ()=>{
            if (this.document) {
                this.targetNodes.delete(targetId);
                this.removeEventListener(this.document.body, "move", handleMove);
            }
        };
    }
    getTopMoveStartHandler() {
        if (!this.options.delayTouchStart && !this.options.delayMouseStart) return this.handleTopMoveStart;
        return this.handleTopMoveStartDelay;
    }
    installSourceNodeRemovalObserver(node) {
        this.uninstallSourceNodeRemovalObserver();
        this.draggedSourceNode = node;
        this.draggedSourceNodeRemovalObserver = new MutationObserver(()=>{
            if (node && !node.parentElement) {
                this.resurrectSourceNode();
                this.uninstallSourceNodeRemovalObserver();
            }
        });
        if (!node || !node.parentElement) return;
        this.draggedSourceNodeRemovalObserver.observe(node.parentElement, {
            childList: true
        });
    }
    resurrectSourceNode() {
        if (this.document && this.draggedSourceNode) {
            this.draggedSourceNode.style.display = "none";
            this.draggedSourceNode.removeAttribute("data-reactid");
            this.document.body.appendChild(this.draggedSourceNode);
        }
    }
    uninstallSourceNodeRemovalObserver() {
        if (this.draggedSourceNodeRemovalObserver) this.draggedSourceNodeRemovalObserver.disconnect();
        this.draggedSourceNodeRemovalObserver = undefined;
        this.draggedSourceNode = undefined;
    }
    constructor(manager, context, options){
        this.getSourceClientOffset = (sourceId)=>{
            const element = this.sourceNodes.get(sourceId);
            return element && $700bf53ed0e34a6e$var$getNodeClientOffset(element);
        };
        this.handleTopMoveStartCapture = (e)=>{
            if (!$700bf53ed0e34a6e$var$eventShouldStartDrag(e)) return;
            this.moveStartSourceIds = [];
        };
        this.handleMoveStart = (sourceId)=>{
            // Just because we received an event doesn't necessarily mean we need to collect drag sources.
            // We only collect start collecting drag sources on touch and left mouse events.
            if (Array.isArray(this.moveStartSourceIds)) this.moveStartSourceIds.unshift(sourceId);
        };
        this.handleTopMoveStart = (e)=>{
            if (!$700bf53ed0e34a6e$var$eventShouldStartDrag(e)) return;
            // Don't prematurely preventDefault() here since it might:
            // 1. Mess up scrolling
            // 2. Mess up long tap (which brings up context menu)
            // 3. If there's an anchor link as a child, tap won't be triggered on link
            const clientOffset = $700bf53ed0e34a6e$var$getEventClientOffset(e);
            if (clientOffset) {
                if ($700bf53ed0e34a6e$var$isTouchEvent(e)) this.lastTargetTouchFallback = e.targetTouches[0];
                this._mouseClientOffset = clientOffset;
            }
            this.waitingForDelay = false;
        };
        this.handleTopMoveStartDelay = (e)=>{
            if (!$700bf53ed0e34a6e$var$eventShouldStartDrag(e)) return;
            const delay = e.type === $700bf53ed0e34a6e$var$eventNames.touch.start ? this.options.delayTouchStart : this.options.delayMouseStart;
            this.timeout = setTimeout(this.handleTopMoveStart.bind(this, e), delay);
            this.waitingForDelay = true;
        };
        this.handleTopMoveCapture = ()=>{
            this.dragOverTargetIds = [];
        };
        this.handleMove = (_evt, targetId)=>{
            if (this.dragOverTargetIds) this.dragOverTargetIds.unshift(targetId);
        };
        this.handleTopMove = (e1)=>{
            if (this.timeout) clearTimeout(this.timeout);
            if (!this.document || this.waitingForDelay) return;
            const { moveStartSourceIds: moveStartSourceIds , dragOverTargetIds: dragOverTargetIds  } = this;
            const enableHoverOutsideTarget = this.options.enableHoverOutsideTarget;
            const clientOffset = $700bf53ed0e34a6e$var$getEventClientOffset(e1, this.lastTargetTouchFallback);
            if (!clientOffset) return;
            // If the touch move started as a scroll, or is is between the scroll angles
            if (this._isScrolling || !this.monitor.isDragging() && $700bf53ed0e34a6e$var$inAngleRanges(this._mouseClientOffset.x || 0, this._mouseClientOffset.y || 0, clientOffset.x, clientOffset.y, this.options.scrollAngleRanges)) {
                this._isScrolling = true;
                return;
            }
            // If we're not dragging and we've moved a little, that counts as a drag start
            if (!this.monitor.isDragging() && // eslint-disable-next-line no-prototype-builtins
            this._mouseClientOffset.hasOwnProperty("x") && moveStartSourceIds && $700bf53ed0e34a6e$var$distance(this._mouseClientOffset.x || 0, this._mouseClientOffset.y || 0, clientOffset.x, clientOffset.y) > (this.options.touchSlop ? this.options.touchSlop : 0)) {
                this.moveStartSourceIds = undefined;
                this.actions.beginDrag(moveStartSourceIds, {
                    clientOffset: this._mouseClientOffset,
                    getSourceClientOffset: this.getSourceClientOffset,
                    publishSource: false
                });
            }
            if (!this.monitor.isDragging()) return;
            const sourceNode = this.sourceNodes.get(this.monitor.getSourceId());
            this.installSourceNodeRemovalObserver(sourceNode);
            this.actions.publishDragSource();
            if (e1.cancelable) e1.preventDefault();
            // Get the node elements of the hovered DropTargets
            const dragOverTargetNodes = (dragOverTargetIds || []).map((key)=>this.targetNodes.get(key)).filter((e)=>!!e);
            // Get the a ordered list of nodes that are touched by
            const elementsAtPoint = this.options.getDropTargetElementsAtPoint ? this.options.getDropTargetElementsAtPoint(clientOffset.x, clientOffset.y, dragOverTargetNodes) : this.document.elementsFromPoint(clientOffset.x, clientOffset.y);
            // Extend list with parents that are not receiving elementsFromPoint events (size 0 elements and svg groups)
            const elementsAtPointExtended = [];
            for(const nodeId in elementsAtPoint){
                // eslint-disable-next-line no-prototype-builtins
                if (!elementsAtPoint.hasOwnProperty(nodeId)) continue;
                let currentNode = elementsAtPoint[nodeId];
                if (currentNode != null) elementsAtPointExtended.push(currentNode);
                while(currentNode){
                    currentNode = currentNode.parentElement;
                    if (currentNode && elementsAtPointExtended.indexOf(currentNode) === -1) elementsAtPointExtended.push(currentNode);
                }
            }
            const orderedDragOverTargetIds = elementsAtPointExtended // Filter off nodes that arent a hovered DropTargets nodes
            .filter((node)=>dragOverTargetNodes.indexOf(node) > -1) // Map back the nodes elements to targetIds
            .map((node)=>this._getDropTargetId(node)) // Filter off possible null rows
            .filter((node)=>!!node).filter((id, index, ids)=>ids.indexOf(id) === index);
            // Invoke hover for drop targets when source node is still over and pointer is outside
            if (enableHoverOutsideTarget) for(const targetId in this.targetNodes){
                const targetNode = this.targetNodes.get(targetId);
                if (sourceNode && targetNode && targetNode.contains(sourceNode) && orderedDragOverTargetIds.indexOf(targetId) === -1) {
                    orderedDragOverTargetIds.unshift(targetId);
                    break;
                }
            }
            // Reverse order because dnd-core reverse it before calling the DropTarget drop methods
            orderedDragOverTargetIds.reverse();
            this.actions.hover(orderedDragOverTargetIds, {
                clientOffset: clientOffset
            });
        };
        /**
	 *
	 * visible for testing
	 */ this._getDropTargetId = (node)=>{
            const keys = this.targetNodes.keys();
            let next = keys.next();
            while(next.done === false){
                const targetId = next.value;
                if (node === this.targetNodes.get(targetId)) return targetId;
                else next = keys.next();
            }
            return undefined;
        };
        this.handleTopMoveEndCapture = (e)=>{
            this._isScrolling = false;
            this.lastTargetTouchFallback = undefined;
            if (!$700bf53ed0e34a6e$var$eventShouldEndDrag(e)) return;
            if (!this.monitor.isDragging() || this.monitor.didDrop()) {
                this.moveStartSourceIds = undefined;
                return;
            }
            if (e.cancelable) e.preventDefault();
            this._mouseClientOffset = {};
            this.uninstallSourceNodeRemovalObserver();
            this.actions.drop();
            this.actions.endDrag();
        };
        this.handleCancelOnEscape = (e)=>{
            if (e.key === "Escape" && this.monitor.isDragging()) {
                this._mouseClientOffset = {};
                this.uninstallSourceNodeRemovalObserver();
                this.actions.endDrag();
            }
        };
        this.options = new $700bf53ed0e34a6e$var$OptionsReader(options, context);
        this.actions = manager.getActions();
        this.monitor = manager.getMonitor();
        this.sourceNodes = new Map();
        this.sourcePreviewNodes = new Map();
        this.sourcePreviewNodeOptions = new Map();
        this.targetNodes = new Map();
        this.listenerTypes = [];
        this._mouseClientOffset = {};
        this._isScrolling = false;
        if (this.options.enableMouseEvents) this.listenerTypes.push($700bf53ed0e34a6e$var$ListenerType.mouse);
        if (this.options.enableTouchEvents) this.listenerTypes.push($700bf53ed0e34a6e$var$ListenerType.touch);
        if (this.options.enableKeyboardEvents) this.listenerTypes.push($700bf53ed0e34a6e$var$ListenerType.keyboard);
    }
}
const $700bf53ed0e34a6e$var$TouchBackend = function createBackend(manager, context = {}, options = {}) {
    return new $700bf53ed0e34a6e$var$TouchBackendImpl(manager, context, options);
};
const $700bf53ed0e34a6e$var$ChessboardDnDContext = (0, $bh6RR.createContext)({
    isCustomDndProviderSet: false
});
const $700bf53ed0e34a6e$var$EmptyProvider = ({ children: children  })=>{
    return (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: children
    });
};
const $700bf53ed0e34a6e$export$5058efb00df7de8c = ({ children: children , backend: backend , context: context , options: options , debugMode: debugMode  })=>{
    return (0, $d4dab640dcbe486c$exports.jsx)($700bf53ed0e34a6e$var$ChessboardDnDContext.Provider, Object.assign({
        value: {
            isCustomDndProviderSet: true
        }
    }, {
        children: (0, $d4dab640dcbe486c$exports.jsx)($700bf53ed0e34a6e$var$DndProvider, Object.assign({
            backend: backend || ("ontouchstart" in window ? $700bf53ed0e34a6e$var$TouchBackend : $700bf53ed0e34a6e$var$HTML5Backend),
            context: context,
            options: options,
            debugMode: debugMode !== null && debugMode !== void 0 ? debugMode : false
        }, {
            children: children
        }))
    }));
};
const $700bf53ed0e34a6e$var$ChessboardDnDRoot = ({ customDndBackend: customDndBackend , customDndBackendOptions: customDndBackendOptions , children: children  })=>{
    const [clientWindow, setClientWindow] = (0, $bh6RR.useState)();
    const [backendSet, setBackendSet] = (0, $bh6RR.useState)(false);
    const [isMobile, setIsMobile] = (0, $bh6RR.useState)(false);
    const { isCustomDndProviderSet: isCustomDndProviderSet  } = (0, $bh6RR.useContext)($700bf53ed0e34a6e$var$ChessboardDnDContext);
    (0, $bh6RR.useEffect)(()=>{
        setIsMobile("ontouchstart" in window);
        setBackendSet(true);
        setClientWindow(window);
    }, []);
    // in case we already wrapped `<Chessboard/>`  with `<DnDProvider/>` we don't need to create a new one
    const DnDWrapper = isCustomDndProviderSet ? $700bf53ed0e34a6e$var$EmptyProvider : $700bf53ed0e34a6e$var$DndProvider;
    if (!backendSet) return null;
    return clientWindow ? (0, $d4dab640dcbe486c$exports.jsx)(DnDWrapper, Object.assign({
        backend: customDndBackend || (isMobile ? $700bf53ed0e34a6e$var$TouchBackend : $700bf53ed0e34a6e$var$HTML5Backend),
        context: clientWindow,
        options: customDndBackend ? customDndBackendOptions : undefined
    }, {
        children: children
    })) : (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: children
    });
};
function $700bf53ed0e34a6e$var$CustomDragLayer({ boardContainer: boardContainer  }) {
    const { boardWidth: boardWidth , chessPieces: chessPieces , id: id , snapToCursor: snapToCursor , allowDragOutsideBoard: allowDragOutsideBoard  } = $700bf53ed0e34a6e$var$useChessboard();
    const collectedProps = $700bf53ed0e34a6e$var$useDragLayer((monitor)=>({
            item: monitor.getItem(),
            clientOffset: monitor.getClientOffset(),
            sourceClientOffset: monitor.getSourceClientOffset(),
            isDragging: monitor.isDragging()
        }));
    const { isDragging: isDragging , item: item , clientOffset: clientOffset , sourceClientOffset: sourceClientOffset  } = collectedProps;
    const getItemStyle = (0, $bh6RR.useCallback)((clientOffset, sourceClientOffset)=>{
        if (!clientOffset || !sourceClientOffset) return {
            display: "none"
        };
        let { x: x , y: y  } = snapToCursor ? clientOffset : sourceClientOffset;
        const halfSquareWidth = boardWidth / 8 / 2;
        if (snapToCursor) {
            x -= halfSquareWidth;
            y -= halfSquareWidth;
        }
        if (!allowDragOutsideBoard) {
            const { left: left , top: top  } = boardContainer;
            // half square so the piece reaches the board
            const maxLeft = left - halfSquareWidth;
            const maxTop = top - halfSquareWidth;
            const maxRight = left + boardWidth - halfSquareWidth;
            const maxBottom = top + boardWidth - halfSquareWidth;
            x = Math.max(maxLeft, Math.min(x, maxRight));
            y = Math.max(maxTop, Math.min(y, maxBottom));
        }
        const transform = `translate(${x}px, ${y}px)`;
        return {
            transform: transform,
            WebkitTransform: transform,
            touchAction: "none"
        };
    }, [
        boardWidth,
        allowDragOutsideBoard,
        snapToCursor,
        boardContainer
    ]);
    return isDragging && item.id === id ? (0, $d4dab640dcbe486c$exports.jsx)("div", Object.assign({
        style: {
            position: "fixed",
            pointerEvents: "none",
            zIndex: 10,
            left: 0,
            top: 0
        }
    }, {
        children: (0, $d4dab640dcbe486c$exports.jsx)("div", Object.assign({
            style: getItemStyle(clientOffset, sourceClientOffset)
        }, {
            children: typeof chessPieces[item.piece] === "function" ? chessPieces[item.piece]({
                squareWidth: boardWidth / 8,
                isDragging: true
            }) : (0, $d4dab640dcbe486c$exports.jsx)("svg", Object.assign({
                viewBox: "1 1 43 43",
                width: boardWidth / 8,
                height: boardWidth / 8
            }, {
                children: (0, $d4dab640dcbe486c$exports.jsx)("g", {
                    children: chessPieces[item.piece]
                })
            }))
        }))
    })) : null;
}
const $700bf53ed0e34a6e$export$10d0f5ecf473d343 = ({ piece: piece , width: width , customPieceJSX: customPieceJSX , dndId: dndId  })=>{
    const renderPiece = customPieceJSX !== null && customPieceJSX !== void 0 ? customPieceJSX : $700bf53ed0e34a6e$var$defaultPieces[piece];
    const [{ canDrag: canDrag , isDragging: isDragging  }, drag, dragPreview] = $700bf53ed0e34a6e$var$useDrag(()=>({
            type: "piece",
            item: ()=>{
                return {
                    piece: piece,
                    isSpare: true,
                    id: dndId
                };
            },
            collect: (monitor)=>({
                    canDrag: true,
                    isDragging: !!monitor.isDragging()
                })
        }), [
        piece,
        dndId
    ]);
    // hide the default preview
    dragPreview($700bf53ed0e34a6e$var$getEmptyImage(), {
        captureDraggingState: true
    });
    return (0, $d4dab640dcbe486c$exports.jsx)("div", Object.assign({
        ref: canDrag ? drag : null,
        "data-piece": piece,
        style: {
            cursor: "move"
        }
    }, {
        children: typeof renderPiece === "function" ? renderPiece({
            squareWidth: width,
            isDragging: isDragging
        }) : (0, $d4dab640dcbe486c$exports.jsx)("svg", Object.assign({
            viewBox: "1 1 43 43",
            width: width,
            height: width
        }, {
            children: (0, $d4dab640dcbe486c$exports.jsx)("g", {
                children: renderPiece
            })
        }))
    }));
};
const $700bf53ed0e34a6e$export$2b996ae5040ad8f1 = (0, $bh6RR.forwardRef)((props, ref)=>{
    const { customDndBackend: customDndBackend , customDndBackendOptions: customDndBackendOptions , onBoardWidthChange: onBoardWidthChange  } = props, otherProps = $700bf53ed0e34a6e$var$__rest(props, [
        "customDndBackend",
        "customDndBackendOptions",
        "onBoardWidthChange"
    ]);
    const [boardWidth, setBoardWidth] = (0, $bh6RR.useState)(props.boardWidth);
    const boardRef = (0, $bh6RR.useRef)(null);
    const boardContainerRef = (0, $bh6RR.useRef)(null);
    const [boardContainerPos, setBoardContainerPos] = (0, $bh6RR.useState)({
        left: 0,
        top: 0
    });
    const metrics = (0, $bh6RR.useMemo)(()=>{
        var _a;
        return (_a = boardRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
    }, [
        boardRef.current
    ]);
    (0, $bh6RR.useEffect)(()=>{
        boardWidth && (onBoardWidthChange === null || onBoardWidthChange === void 0 || onBoardWidthChange(boardWidth));
    }, [
        boardWidth
    ]);
    (0, $bh6RR.useEffect)(()=>{
        setBoardContainerPos({
            left: (metrics === null || metrics === void 0 ? void 0 : metrics.left) ? metrics === null || metrics === void 0 ? void 0 : metrics.left : 0,
            top: (metrics === null || metrics === void 0 ? void 0 : metrics.top) ? metrics === null || metrics === void 0 ? void 0 : metrics.top : 0
        });
    }, [
        metrics
    ]);
    (0, $bh6RR.useEffect)(()=>{
        var _a;
        if (props.boardWidth === undefined && ((_a = boardRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth)) {
            const resizeObserver = new ResizeObserver(()=>{
                var _a;
                setBoardWidth((_a = boardRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth);
            });
            resizeObserver.observe(boardRef.current);
            return ()=>{
                resizeObserver.disconnect();
            };
        }
    }, [
        boardRef.current
    ]);
    return (0, $d4dab640dcbe486c$exports.jsx)($700bf53ed0e34a6e$var$ErrorBoundary, {
        children: (0, $d4dab640dcbe486c$exports.jsxs)("div", Object.assign({
            ref: boardContainerRef,
            style: {
                display: "flex",
                flexDirection: "column",
                width: "100%"
            }
        }, {
            children: [
                (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    ref: boardRef,
                    style: {
                        width: "100%"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)($700bf53ed0e34a6e$var$ChessboardDnDRoot, Object.assign({
                    customDndBackend: customDndBackend,
                    customDndBackendOptions: customDndBackendOptions
                }, {
                    children: boardWidth && (0, $d4dab640dcbe486c$exports.jsxs)($700bf53ed0e34a6e$var$ChessboardProvider, Object.assign({
                        boardWidth: boardWidth
                    }, otherProps, {
                        ref: ref
                    }, {
                        children: [
                            (0, $d4dab640dcbe486c$exports.jsx)($700bf53ed0e34a6e$var$CustomDragLayer, {
                                boardContainer: boardContainerPos
                            }),
                            (0, $d4dab640dcbe486c$exports.jsx)($700bf53ed0e34a6e$var$Board, {})
                        ]
                    }))
                }))
            ]
        }))
    });
});




var $bh6RR = parcelRequire("bh6RR");
function $57084659f555c894$var$_extends() {
    return $57084659f555c894$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $57084659f555c894$var$_extends.apply(null, arguments);
}
function $57084659f555c894$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $57084659f555c894$var$useOnMount(callback) {
    (0, $bh6RR.useEffect)(callback, []);
}
var $57084659f555c894$var$_excluded = [
    "id",
    "volume",
    "playbackRate",
    "soundEnabled",
    "interrupt",
    "onload"
];

function $57084659f555c894$export$a34349420ba3cec8(src, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$volume = _ref.volume, volume = _ref$volume === void 0 ? 1 : _ref$volume, _ref$playbackRate = _ref.playbackRate, playbackRate = _ref$playbackRate === void 0 ? 1 : _ref$playbackRate, _ref$soundEnabled = _ref.soundEnabled, soundEnabled = _ref$soundEnabled === void 0 ? true : _ref$soundEnabled, _ref$interrupt = _ref.interrupt, interrupt = _ref$interrupt === void 0 ? false : _ref$interrupt, onload = _ref.onload, delegated = $57084659f555c894$var$_objectWithoutPropertiesLoose(_ref, $57084659f555c894$var$_excluded);
    var HowlConstructor = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(null);
    var isMounted = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(false);
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(null), duration = _React$useState[0], setDuration = _React$useState[1];
    var _React$useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(null), sound = _React$useState2[0], setSound = _React$useState2[1];
    var handleLoad = function handleLoad() {
        if (typeof onload === "function") // @ts-ignore
        onload.call(this);
        if (isMounted.current) // @ts-ignore
        setDuration(this.duration() * 1000);
        // @ts-ignore
        setSound(this);
    };
    // We want to lazy-load Howler, since sounds can't play on load anyway.
    $57084659f555c894$var$useOnMount(function() {
        (parcelRequire("3vQgY")).then(function(mod) {
            if (!isMounted.current) {
                var _mod$Howl;
                // Depending on the module system used, `mod` might hold
                // the export directly, or it might be under `default`.
                HowlConstructor.current = (_mod$Howl = mod.Howl) !== null && _mod$Howl !== void 0 ? _mod$Howl : mod["default"].Howl;
                isMounted.current = true;
                new HowlConstructor.current($57084659f555c894$var$_extends({
                    src: Array.isArray(src) ? src : [
                        src
                    ],
                    volume: volume,
                    rate: playbackRate,
                    onload: handleLoad
                }, delegated));
            }
        });
        return function() {
            isMounted.current = false;
        };
    });
    // When the `src` changes, we have to do a whole thing where we recreate
    // the Howl instance. This is because Howler doesn't expose a way to
    // tweak the sound
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(function() {
        if (HowlConstructor.current && sound) setSound(new HowlConstructor.current($57084659f555c894$var$_extends({
            src: Array.isArray(src) ? src : [
                src
            ],
            volume: volume,
            onload: handleLoad
        }, delegated)));
    // The linter wants to run this effect whenever ANYTHING changes,
    // but very specifically I only want to recreate the Howl instance
    // when the `src` changes. Other changes should have no effect.
    // Passing array to the useEffect dependencies list will result in
    // ifinite loop so we need to stringify it, for more details check
    // https://github.com/facebook/react/issues/14476#issuecomment-471199055
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        JSON.stringify(src)
    ]);
    // Whenever volume/playbackRate are changed, change those properties
    // on the sound instance.
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(function() {
        if (sound) {
            sound.volume(volume);
            sound.rate(playbackRate);
        }
    // A weird bug means that including the `sound` here can trigger an
    // error on unmount, where the state loses track of the sprites??
    // No idea, but anyway I don't need to re-run this if only the `sound`
    // changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        volume,
        playbackRate
    ]);
    var play = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useCallback(function(options) {
        if (typeof options === "undefined") options = {};
        if (!sound || !soundEnabled && !options.forceSoundEnabled) return;
        if (interrupt) sound.stop();
        if (options.playbackRate) sound.rate(options.playbackRate);
        sound.play(options.id);
    }, [
        sound,
        soundEnabled,
        interrupt
    ]);
    var stop = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useCallback(function(id) {
        if (!sound) return;
        sound.stop(id);
    }, [
        sound
    ]);
    var pause = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useCallback(function(id) {
        if (!sound) return;
        sound.pause(id);
    }, [
        sound
    ]);
    var returnedValue = [
        play,
        {
            sound: sound,
            stop: stop,
            pause: pause,
            duration: duration
        }
    ];
    return returnedValue;
}
var $57084659f555c894$export$2e2bcd8739ae039 = $57084659f555c894$export$a34349420ba3cec8;


var $82ccdc90324af0e7$exports = {};

$82ccdc90324af0e7$exports = new URL((parcelRequire("kyEFX")).resolve("1hqhz"), import.meta.url).toString();


var $b707c1ec3f10a507$exports = {};

$b707c1ec3f10a507$exports = new URL((parcelRequire("kyEFX")).resolve("g4QIV"), import.meta.url).toString();





const $82bed5901a6d171c$var$ENDPOINT = "https://[TODO_ADD_API_HERE].execute-api.us-east-1.amazonaws.com/dev/";
function $82bed5901a6d171c$var$Board({ initialOrientation: initialOrientation , boardId: boardId  }) {
    const [validateMove, setValidateMove] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(true);
    const [playMoveSound] = (0, $57084659f555c894$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($82ccdc90324af0e7$exports))));
    const [playCaptureSound] = (0, $57084659f555c894$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($b707c1ec3f10a507$exports))));
    const [orientation, setOrientation] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(initialOrientation);
    const [triggerFirstMove, setTriggerFirstMove] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(0);
    const [plans, setPlans] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState([]);
    console.log("reloading");
    const { resetAll: resetAll , notes: notes , toggle: toggle , tags: tags , isPlanningMode: isPlanningMode , isMistake: isMistake , setIsPlanningMode: setIsPlanningMode , setIsMistake: setIsMistake , setPlayerSolvedExercise: setPlayerSolvedExercise , setPlayerFailedExercise: setPlayerFailedExercise , setNumCorrectExercisePlan: setNumCorrectExercisePlan , exercisePlans: exercisePlans , setExercisePlans: setExercisePlans , moveHistory: moveHistory , setMoveHistory: setMoveHistory , selectedMove: selectedMove , setSelectedMove: setSelectedMove , chess: chess , positionFen: positionFen , setPositionFen: setPositionFen  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $7ead3b1a9a673b0a$export$58d75f9829cbe158));
    const [lastStateBeforePlanning, setLastStateBeforePlanning] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState({
        lastFenBeforePlanning: chess.fen(),
        lastMoveBeforePlanning: null
    });
    const [nextCorrectMove, setNextCorrectMove] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(null);
    // const { token } = React.useContext(UserContext);
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        const initialFen = "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1";
    }, [
        orientation,
        tags,
        triggerFirstMove
    ]);
    const resetBoard = ()=>{
        const newGame = new (0, $e1e1f1f3cd154daa$export$a4d6ea685c300d39)();
        setPositionFen(newGame.fen());
        chess.reset();
        setTriggerFirstMove((prev)=>(prev + 1) % 100);
        setPlans([]);
        setIsPlanningMode(false);
        setIsMistake(false);
        resetAll();
    };
    const flipBoard = ()=>{
        setOrientation((prevOrientation)=>{
            return prevOrientation === "white" ? "black" : "white";
        });
    };
    const handlePieceDrop = (sourceSquare, targetSquare)=>{
        try {
            if (validateMove && !isPlanningMode) {
                const moveData = {
                    from: sourceSquare,
                    to: targetSquare,
                    promotion: "q"
                };
                setLastStateBeforePlanning({
                    lastFenBeforePlanning: chess.fen(),
                    lastMoveBeforePlanning: moveData
                });
                let move = chess.move(moveData);
                if (move) {
                    console.log(`move=${JSON.stringify(move)}`);
                    setMoveHistory((previous)=>{
                        return [
                            ...previous,
                            move.san
                        ];
                    });
                    if (move.flags.includes("c")) playCaptureSound();
                    else playMoveSound();
                    setPositionFen(chess.fen());
                    return true;
                } else return false;
            }
        } catch (error) {
            console.log("Error making move:", error);
            return false;
        }
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($82bed5901a6d171c$var$Div, {
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $700bf53ed0e34a6e$export$2b996ae5040ad8f1), {
                id: boardId,
                onPieceDrop: handlePieceDrop,
                position: positionFen,
                dropOffBoardAction: "snapback",
                boardOrientation: orientation,
                allowDragOutsideBoard: !validateMove
            })
        })
    });
}
var $82bed5901a6d171c$export$2e2bcd8739ae039 = $82bed5901a6d171c$var$Board;
const $82bed5901a6d171c$var$Button = (0, $e484c752f3f06549$export$2e2bcd8739ae039).button`
  padding: 5px;
  background-color: lightgrey;
  margin: 2px;
  margin-top: 10px;
  margin-right: 3px;
  border-radius: 5px;
  font-weight: bold;
  border: 2px solid black;
`;
const $82bed5901a6d171c$var$Div = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  width: 99%;
`;






var $bh6RR = parcelRequire("bh6RR");



function $92686b3f28b72d7a$var$MoveTable() {
    const { moveHistory: moveHistory , selectedMove: selectedMove , setSelectedMove: setSelectedMove  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $7ead3b1a9a673b0a$export$58d75f9829cbe158));
    const formatMove = (move)=>{
        return move.replace(/N/g, "♞") // Knight
        .replace(/B/g, "♝") // Bishop
        .replace(/R/g, "♜") // Rook
        .replace(/Q/g, "♛") // Queen
        .replace(/K/g, "♚"); // King
    };
    // Process moves into pairs
    const movePairs = [];
    for(let i = 0; i < moveHistory.length; i += 2)movePairs.push({
        whiteDisplay: moveHistory[i] ? formatMove(moveHistory[i]) : "",
        whiteSan: moveHistory[i],
        blackDisplay: moveHistory[i + 1] ? formatMove(moveHistory[i + 1]) : "",
        blackSan: moveHistory[i + 1]
    });
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($92686b3f28b72d7a$var$StyledTable, {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("tbody", {
            children: movePairs.map((pair, index)=>{
                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($92686b3f28b72d7a$var$StyledRow, {
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($92686b3f28b72d7a$var$StyledMoveIndexCell, {
                            children: index + 1
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($92686b3f28b72d7a$var$StyledCell, {
                            isiconmove: /^[NBRQK]/.test(pair.whiteSan),
                            children: pair.whiteDisplay
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($92686b3f28b72d7a$var$StyledCell, {
                            isiconmove: /^[NBRQK]/.test(pair.blackSan),
                            children: pair.blackDisplay
                        })
                    ]
                }, index);
            })
        })
    });
}
var $92686b3f28b72d7a$export$2e2bcd8739ae039 = $92686b3f28b72d7a$var$MoveTable;
const $92686b3f28b72d7a$var$StyledTable = (0, $e484c752f3f06549$export$2e2bcd8739ae039).table`
  width: 100%;
  padding-top: 60px;
`;
const $92686b3f28b72d7a$var$StyledRow = (0, $e484c752f3f06549$export$2e2bcd8739ae039).tr`
  display: flex;
`;
const $92686b3f28b72d7a$var$StyledMoveIndexCell = (0, $e484c752f3f06549$export$2e2bcd8739ae039).td`
  flex: 1;
  background-color: #302e2c;
  color: #6b6b6b;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 20px;
  padding-right: 20px;
`;
const $92686b3f28b72d7a$var$StyledCell = (0, $e484c752f3f06549$export$2e2bcd8739ae039).td`
  flex: 10;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: ${(p)=>p.isiconmove ? "15px" : "20px"};
  background-color: #262421;
  color: #bababa;
  cursor: pointer;
  &:hover {
    background-color: #3692e7;
    color: #ffffff;
  }
  &:last-child:empty {
    cursor: default;
    background-color: #262421;
  }
`;





function $118ccf88bcfc51b9$export$3af29c0efb268f04(componentFactory) {
    if (typeof Proxy === "undefined") return componentFactory;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ const componentCache = new Map();
    const deprecatedFactoryFunction = (...args)=>{
        return componentFactory(...args);
    };
    return new Proxy(deprecatedFactoryFunction, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: (_target, key)=>{
            if (key === "create") return componentFactory;
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, componentFactory(key));
            return componentCache.get(key);
        }
    });
}


function $6c424f3bd35daf15$export$aa71198ceeaf53ce(v) {
    return v !== null && typeof v === "object" && typeof v.start === "function";
}



const $96ae1bfc697c0155$export$9153ad4c4999f4a0 = (v)=>{
    return Array.isArray(v);
};


function $b3131a4296a9915c$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    const prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(let i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}


/**
 * Decides if the supplied variable is variant label
 */ function $e4ec7857057a08b6$export$720b90e312cea233(v) {
    return typeof v === "string" || Array.isArray(v);
}


function $960c679efe64d12b$var$getValueState(visualElement) {
    const state = [
        {},
        {}
    ];
    visualElement === null || visualElement === void 0 || visualElement.values.forEach((value, key)=>{
        state[0][key] = value.get();
        state[1][key] = value.getVelocity();
    });
    return state;
}
function $960c679efe64d12b$export$d68f140c4d9b48bc(props, definition, custom, visualElement) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") {
        const [current, velocity] = $960c679efe64d12b$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") {
        const [current, velocity] = $960c679efe64d12b$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    return definition;
}


function $dfe6a10b7b91d234$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return (0, $960c679efe64d12b$export$d68f140c4d9b48bc)(props, definition, custom !== undefined ? custom : props.custom, visualElement);
}


const $eb6a0a2a824114cd$export$16e45afcc206d3a8 = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
const $eb6a0a2a824114cd$export$1405a65085f40b9 = [
    "initial",
    ...$eb6a0a2a824114cd$export$16e45afcc206d3a8
];



/**
 * Generate a list of every possible transform key.
 */ const $05d385f303970557$export$280dc01950909d86 = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 */ const $05d385f303970557$export$7b42a0094fb00b6e = new Set($05d385f303970557$export$280dc01950909d86);


/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ const $631bdbca8ed9a472$export$fc3e7e8557f8c8c7 = (seconds)=>seconds * 1000;
const $631bdbca8ed9a472$export$f64c3bfbc58eec0f = (milliseconds)=>milliseconds / 1000;



const $943a3f0a32f59f42$var$underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
const $943a3f0a32f59f42$var$criticallyDampedSpring = (target)=>({
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    });
const $943a3f0a32f59f42$var$keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ const $943a3f0a32f59f42$var$ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
const $943a3f0a32f59f42$export$262124b154b9f1c0 = (valueKey, { keyframes: keyframes  })=>{
    if (keyframes.length > 2) return $943a3f0a32f59f42$var$keyframesTransition;
    else if ((0, $05d385f303970557$export$7b42a0094fb00b6e).has(valueKey)) return valueKey.startsWith("scale") ? $943a3f0a32f59f42$var$criticallyDampedSpring(keyframes[1]) : $943a3f0a32f59f42$var$underDampedSpring;
    return $943a3f0a32f59f42$var$ease;
};


function $7530df41f7472851$export$7c1391340308742e(transition, key) {
    return transition ? transition[key] || transition["default"] || transition : undefined;
}


const $6c4fc775126b27b6$export$dd826089e3c5e502 = {
    skipAnimations: false,
    useManualTiming: false
};


const $636ef95c23a1ebef$export$888a3d84909f9e3d = {
    current: false
};


const $cb21c6c57eea1e02$var$isNotNull = (value)=>value !== null;
function $cb21c6c57eea1e02$export$14de59408fad90b(keyframes, { repeat: repeat , repeatType: repeatType = "loop"  }, finalKeyframe) {
    const resolvedKeyframes = keyframes.filter($cb21c6c57eea1e02$var$isNotNull);
    const index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : resolvedKeyframes.length - 1;
    return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}


const $c13dd6518645747b$export$8793edee2d425525 = (any)=>any;


let $af7e1b70fef19820$export$491112666e282270 = (0, $c13dd6518645747b$export$8793edee2d425525);
let $af7e1b70fef19820$export$f5708dca728d7177 = (0, $c13dd6518645747b$export$8793edee2d425525);
var $af7e1b70fef19820$var$check, $af7e1b70fef19820$var$message, $af7e1b70fef19820$var$check1, $af7e1b70fef19820$var$message1;






function $1b7b86ec18a0a90a$export$b995e5e85f5c8289(runNextFrame) {
    /**
     * We create and reuse two queues, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ let thisFrame = new Set();
    let nextFrame = new Set();
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ const toKeepAlive = new WeakSet();
    let latestFrameData = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    function triggerCallback(callback) {
        if (toKeepAlive.has(callback)) {
            step.schedule(callback);
            runNextFrame();
        }
        callback(latestFrameData);
    }
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (!queue.has(callback)) queue.add(callback);
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: (callback)=>{
            nextFrame.delete(callback);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: (frameData)=>{
            latestFrameData = frameData;
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [thisFrame, nextFrame] = [
                nextFrame,
                thisFrame
            ];
            // Execute this frame
            thisFrame.forEach(triggerCallback);
            // Clear the frame so no callbacks remain. This is to avoid
            // memory leaks should this render step not run for a while.
            thisFrame.clear();
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}


const $3c9d516863748892$export$71ecace0a033b35a = [
    "read",
    "resolveKeyframes",
    "update",
    "preRender",
    "render",
    "postRender"
];
const $3c9d516863748892$var$maxElapsed = 40;
function $3c9d516863748892$export$510b0596a933801a(scheduleNextBatch, allowKeepAlive) {
    let runNextFrame = false;
    let useDefaultElapsed = true;
    const state = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    const flagRunNextFrame = ()=>runNextFrame = true;
    const steps = $3c9d516863748892$export$71ecace0a033b35a.reduce((acc, key)=>{
        acc[key] = (0, $1b7b86ec18a0a90a$export$b995e5e85f5c8289)(flagRunNextFrame);
        return acc;
    }, {});
    const { read: read , resolveKeyframes: resolveKeyframes , update: update , preRender: preRender , render: render , postRender: postRender  } = steps;
    const processBatch = ()=>{
        const timestamp = (0, $6c4fc775126b27b6$export$dd826089e3c5e502).useManualTiming ? state.timestamp : performance.now();
        runNextFrame = false;
        state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, $3c9d516863748892$var$maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        // Unrolled render loop for better per-frame performance
        read.process(state);
        resolveKeyframes.process(state);
        update.process(state);
        preRender.process(state);
        render.process(state);
        postRender.process(state);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    const wake = ()=>{
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) scheduleNextBatch(processBatch);
    };
    const schedule = $3c9d516863748892$export$71ecace0a033b35a.reduce((acc, key)=>{
        const step = steps[key];
        acc[key] = (process, keepAlive = false, immediate = false)=>{
            if (!runNextFrame) wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    const cancel = (process)=>{
        for(let i = 0; i < $3c9d516863748892$export$71ecace0a033b35a.length; i++)steps[$3c9d516863748892$export$71ecace0a033b35a[i]].cancel(process);
    };
    return {
        schedule: schedule,
        cancel: cancel,
        state: state,
        steps: steps
    };
}


const { schedule: $6491bdd13544fdda$export$2cef06c20297c17d , cancel: $6491bdd13544fdda$export$ec99c0ef4978dccb , state: $6491bdd13544fdda$export$fff89137e9e818ce , steps: $6491bdd13544fdda$export$1811c3a7e3af92f0  } = (0, $3c9d516863748892$export$510b0596a933801a)(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : (0, $c13dd6518645747b$export$8793edee2d425525), true);



/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $704adaa4b6058bb3$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $704adaa4b6058bb3$var$subdivisionPrecision = 0.0000001;
const $704adaa4b6058bb3$var$subdivisionMaxIterations = 12;
function $704adaa4b6058bb3$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $704adaa4b6058bb3$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $704adaa4b6058bb3$var$subdivisionPrecision && ++i < $704adaa4b6058bb3$var$subdivisionMaxIterations);
    return currentT;
}
function $704adaa4b6058bb3$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $c13dd6518645747b$export$8793edee2d425525;
    const getTForX = (aX)=>$704adaa4b6058bb3$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $704adaa4b6058bb3$var$calcBezier(getTForX(t), mY1, mY2);
}


// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
const $89b4bec8fd3fdad1$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;


// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
const $0437738b097fa26f$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);


const $d3c4eaabf34a945a$export$77edfce482316a60 = /*@__PURE__*/ (0, $704adaa4b6058bb3$export$2c575fa1d20488bd)(0.33, 1.53, 0.69, 0.99);
const $d3c4eaabf34a945a$export$b01116c84cdfe1a2 = /*@__PURE__*/ (0, $0437738b097fa26f$export$2c07eeff45156d4d)($d3c4eaabf34a945a$export$77edfce482316a60);
const $d3c4eaabf34a945a$export$ddc5fd596f6c71b2 = /*@__PURE__*/ (0, $89b4bec8fd3fdad1$export$f946554fb8aeaf0d)($d3c4eaabf34a945a$export$b01116c84cdfe1a2);


const $1a7a42634de0d0af$export$6b0af63b873d419e = (p)=>(p *= 2) < 1 ? 0.5 * (0, $d3c4eaabf34a945a$export$b01116c84cdfe1a2)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));





const $f0e499eff44e3cea$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $f0e499eff44e3cea$export$c8d67a19199d1a50 = (0, $0437738b097fa26f$export$2c07eeff45156d4d)($f0e499eff44e3cea$export$e444123e42d03385);
const $f0e499eff44e3cea$export$30d3455eee55bed5 = (0, $89b4bec8fd3fdad1$export$f946554fb8aeaf0d)($f0e499eff44e3cea$export$e444123e42d03385);


/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ const $e46637106d3b5fd8$export$ade84c85e44a6cb1 = (v)=>/^0[^.\s]+$/u.test(v);


function $cfbb3fdee2e93a54$export$e56af863d5645d5f(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, $e46637106d3b5fd8$export$ade84c85e44a6cb1)(value);
    else return true;
}



/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ const $307e1e0a636b2ddb$export$65583ed5a868f2d9 = (v)=>/^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(v);


const $9223341d00255d67$var$checkStringStartsWith = (token)=>(key)=>typeof key === "string" && key.startsWith(token);
const $9223341d00255d67$export$9de1236619d9e756 = /*@__PURE__*/ $9223341d00255d67$var$checkStringStartsWith("--");
const $9223341d00255d67$var$startsAsVariableToken = /*@__PURE__*/ $9223341d00255d67$var$checkStringStartsWith("var(--");
const $9223341d00255d67$export$31f9caa2600b5723 = (value)=>{
    const startsWithToken = $9223341d00255d67$var$startsAsVariableToken(value);
    if (!startsWithToken) return false;
    // Ensure any comments are stripped from the value as this can harm performance of the regex.
    return $9223341d00255d67$var$singleCssVariableRegex.test(value.split("/*")[0].trim());
};
const $9223341d00255d67$var$singleCssVariableRegex = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;


/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ const $ff42741a21ccb940$var$splitCSSVariableRegex = // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
/^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u;
function $ff42741a21ccb940$export$b9f0c1f373aee2b0(current) {
    const match = $ff42741a21ccb940$var$splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token1, token2, fallback] = match;
    return [
        `--${token1 !== null && token1 !== void 0 ? token1 : token2}`,
        fallback
    ];
}
const $ff42741a21ccb940$var$maxDepth = 4;
function $ff42741a21ccb940$export$289398774300c991(current, element, depth = 1) {
    (0, $af7e1b70fef19820$export$f5708dca728d7177)(depth <= $ff42741a21ccb940$var$maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`);
    const [token, fallback] = $ff42741a21ccb940$export$b9f0c1f373aee2b0(current);
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        const trimmed = resolved.trim();
        return (0, $307e1e0a636b2ddb$export$65583ed5a868f2d9)(trimmed) ? parseFloat(trimmed) : trimmed;
    }
    return (0, $9223341d00255d67$export$31f9caa2600b5723)(fallback) ? $ff42741a21ccb940$export$289398774300c991(fallback, element, depth + 1) : fallback;
}




const $bb2cd2f4425aee0a$export$7d15b64cf5a3a4c4 = (min, max, v)=>{
    if (v > max) return max;
    if (v < min) return min;
    return v;
};


const $84044ef4463ca44e$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $84044ef4463ca44e$export$58f0f39f63f3cf42 = {
    ...$84044ef4463ca44e$export$98e628dec113755e,
    transform: (v)=>(0, $bb2cd2f4425aee0a$export$7d15b64cf5a3a4c4)(0, 1, v)
};
const $84044ef4463ca44e$export$dcdf75081b88279d = {
    ...$84044ef4463ca44e$export$98e628dec113755e,
    default: 1
};


const $ee89500f7aaa2f56$var$createUnitType = (unit)=>({
        test: (v)=>typeof v === "string" && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $ee89500f7aaa2f56$export$41fc368e1a942b97 = /*@__PURE__*/ $ee89500f7aaa2f56$var$createUnitType("deg");
const $ee89500f7aaa2f56$export$626336c2cd4b14de = /*@__PURE__*/ $ee89500f7aaa2f56$var$createUnitType("%");
const $ee89500f7aaa2f56$export$91c0eda1d06bf008 = /*@__PURE__*/ $ee89500f7aaa2f56$var$createUnitType("px");
const $ee89500f7aaa2f56$export$f91e8c45a95a32f2 = /*@__PURE__*/ $ee89500f7aaa2f56$var$createUnitType("vh");
const $ee89500f7aaa2f56$export$aed3d7b7d206c196 = /*@__PURE__*/ $ee89500f7aaa2f56$var$createUnitType("vw");
const $ee89500f7aaa2f56$export$44e2e1705876d7ed = {
    ...$ee89500f7aaa2f56$export$626336c2cd4b14de,
    parse: (v)=>$ee89500f7aaa2f56$export$626336c2cd4b14de.parse(v) / 100,
    transform: (v)=>$ee89500f7aaa2f56$export$626336c2cd4b14de.transform(v * 100)
};


const $2b1f30070063653f$export$c66c0d5db2a205d = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    "x",
    "y",
    "translateX",
    "translateY"
]);
const $2b1f30070063653f$export$8e5250d1aa9bf370 = (v)=>v === (0, $84044ef4463ca44e$export$98e628dec113755e) || v === (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008);
const $2b1f30070063653f$var$getPosFromMatrix = (matrix, pos)=>parseFloat(matrix.split(", ")[pos]);
const $2b1f30070063653f$var$getTranslateFromMatrix = (pos2, pos3)=>(_bbox, { transform: transform  })=>{
        if (transform === "none" || !transform) return 0;
        const matrix3d = transform.match(/^matrix3d\((.+)\)$/u);
        if (matrix3d) return $2b1f30070063653f$var$getPosFromMatrix(matrix3d[1], pos3);
        else {
            const matrix = transform.match(/^matrix\((.+)\)$/u);
            if (matrix) return $2b1f30070063653f$var$getPosFromMatrix(matrix[1], pos2);
            else return 0;
        }
    };
const $2b1f30070063653f$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
const $2b1f30070063653f$var$nonTranslationalTransformKeys = (0, $05d385f303970557$export$280dc01950909d86).filter((key)=>!$2b1f30070063653f$var$transformKeys.has(key));
function $2b1f30070063653f$export$39d4bc9655f3f632(visualElement) {
    const removedTransforms = [];
    $2b1f30070063653f$var$nonTranslationalTransformKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    return removedTransforms;
}
const $2b1f30070063653f$export$781d46a8aa670d52 = {
    // Dimensions
    width: ({ x: x  }, { paddingLeft: paddingLeft = "0" , paddingRight: paddingRight = "0"  })=>x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
    height: ({ y: y  }, { paddingTop: paddingTop = "0" , paddingBottom: paddingBottom = "0"  })=>y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
    top: (_bbox, { top: top  })=>parseFloat(top),
    left: (_bbox, { left: left  })=>parseFloat(left),
    bottom: ({ y: y  }, { top: top  })=>parseFloat(top) + (y.max - y.min),
    right: ({ x: x  }, { left: left  })=>parseFloat(left) + (x.max - x.min),
    // Transform
    x: $2b1f30070063653f$var$getTranslateFromMatrix(4, 13),
    y: $2b1f30070063653f$var$getTranslateFromMatrix(5, 14)
};
// Alias translate longform names
$2b1f30070063653f$export$781d46a8aa670d52.translateX = $2b1f30070063653f$export$781d46a8aa670d52.x;
$2b1f30070063653f$export$781d46a8aa670d52.translateY = $2b1f30070063653f$export$781d46a8aa670d52.y;




/**
 * Tests a provided value against a ValueType
 */ const $bce78752b9f7f913$export$6eae4d0a6a7ca7cd = (v)=>(type)=>type.test(v);


/**
 * ValueType for "auto"
 */ const $6e9d07411e0549ee$export$dfb5619354ba860 = {
    test: (v)=>v === "auto",
    parse: (v)=>v
};


/**
 * A list of value types commonly used for dimensions
 */ const $d03d4f627f09ffbd$export$d176691c1998a1f5 = [
    (0, $84044ef4463ca44e$export$98e628dec113755e),
    (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    (0, $ee89500f7aaa2f56$export$626336c2cd4b14de),
    (0, $ee89500f7aaa2f56$export$41fc368e1a942b97),
    (0, $ee89500f7aaa2f56$export$aed3d7b7d206c196),
    (0, $ee89500f7aaa2f56$export$f91e8c45a95a32f2),
    (0, $6e9d07411e0549ee$export$dfb5619354ba860)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ const $d03d4f627f09ffbd$export$eefdd52e3ccae428 = (v)=>$d03d4f627f09ffbd$export$d176691c1998a1f5.find((0, $bce78752b9f7f913$export$6eae4d0a6a7ca7cd)(v));




const $8a643b2da1c7bc40$var$toResolve = new Set();
let $8a643b2da1c7bc40$var$isScheduled = false;
let $8a643b2da1c7bc40$var$anyNeedsMeasurement = false;
function $8a643b2da1c7bc40$var$measureAllKeyframes() {
    if ($8a643b2da1c7bc40$var$anyNeedsMeasurement) {
        const resolversToMeasure = Array.from($8a643b2da1c7bc40$var$toResolve).filter((resolver)=>resolver.needsMeasurement);
        const elementsToMeasure = new Set(resolversToMeasure.map((resolver)=>resolver.element));
        const transformsToRestore = new Map();
        /**
         * Write pass
         * If we're measuring elements we want to remove bounding box-changing transforms.
         */ elementsToMeasure.forEach((element)=>{
            const removedTransforms = (0, $2b1f30070063653f$export$39d4bc9655f3f632)(element);
            if (!removedTransforms.length) return;
            transformsToRestore.set(element, removedTransforms);
            element.render();
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureInitialState());
        // Write
        elementsToMeasure.forEach((element)=>{
            element.render();
            const restore = transformsToRestore.get(element);
            if (restore) restore.forEach(([key, value])=>{
                var _a;
                (_a = element.getValue(key)) === null || _a === void 0 || _a.set(value);
            });
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureEndState());
        // Write
        resolversToMeasure.forEach((resolver)=>{
            if (resolver.suspendedScrollY !== undefined) window.scrollTo(0, resolver.suspendedScrollY);
        });
    }
    $8a643b2da1c7bc40$var$anyNeedsMeasurement = false;
    $8a643b2da1c7bc40$var$isScheduled = false;
    $8a643b2da1c7bc40$var$toResolve.forEach((resolver)=>resolver.complete());
    $8a643b2da1c7bc40$var$toResolve.clear();
}
function $8a643b2da1c7bc40$var$readAllKeyframes() {
    $8a643b2da1c7bc40$var$toResolve.forEach((resolver)=>{
        resolver.readKeyframes();
        if (resolver.needsMeasurement) $8a643b2da1c7bc40$var$anyNeedsMeasurement = true;
    });
}
function $8a643b2da1c7bc40$export$78b96d2a12593b05() {
    $8a643b2da1c7bc40$var$readAllKeyframes();
    $8a643b2da1c7bc40$var$measureAllKeyframes();
}
class $8a643b2da1c7bc40$export$74d34ca3182f1750 {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element, isAsync = false){
        /**
         * Track whether this resolver has completed. Once complete, it never
         * needs to attempt keyframe resolution again.
         */ this.isComplete = false;
        /**
         * Track whether this resolver is async. If it is, it'll be added to the
         * resolver queue and flushed in the next frame. Resolvers that aren't going
         * to trigger read/write thrashing don't need to be async.
         */ this.isAsync = false;
        /**
         * Track whether this resolver needs to perform a measurement
         * to resolve its keyframes.
         */ this.needsMeasurement = false;
        /**
         * Track whether this resolver is currently scheduled to resolve
         * to allow it to be cancelled and resumed externally.
         */ this.isScheduled = false;
        this.unresolvedKeyframes = [
            ...unresolvedKeyframes
        ];
        this.onComplete = onComplete;
        this.name = name;
        this.motionValue = motionValue;
        this.element = element;
        this.isAsync = isAsync;
    }
    scheduleResolve() {
        this.isScheduled = true;
        if (this.isAsync) {
            $8a643b2da1c7bc40$var$toResolve.add(this);
            if (!$8a643b2da1c7bc40$var$isScheduled) {
                $8a643b2da1c7bc40$var$isScheduled = true;
                (0, $6491bdd13544fdda$export$2cef06c20297c17d).read($8a643b2da1c7bc40$var$readAllKeyframes);
                (0, $6491bdd13544fdda$export$2cef06c20297c17d).resolveKeyframes($8a643b2da1c7bc40$var$measureAllKeyframes);
            }
        } else {
            this.readKeyframes();
            this.complete();
        }
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes , name: name , element: element , motionValue: motionValue  } = this;
        /**
         * If a keyframe is null, we hydrate it either by reading it from
         * the instance, or propagating from previous keyframes.
         */ for(let i = 0; i < unresolvedKeyframes.length; i++)if (unresolvedKeyframes[i] === null) {
            /**
                 * If the first keyframe is null, we need to find its value by sampling the element
                 */ if (i === 0) {
                const currentValue = motionValue === null || motionValue === void 0 ? void 0 : motionValue.get();
                const finalKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
                if (currentValue !== undefined) unresolvedKeyframes[0] = currentValue;
                else if (element && name) {
                    const valueAsRead = element.readValue(name, finalKeyframe);
                    if (valueAsRead !== undefined && valueAsRead !== null) unresolvedKeyframes[0] = valueAsRead;
                }
                if (unresolvedKeyframes[0] === undefined) unresolvedKeyframes[0] = finalKeyframe;
                if (motionValue && currentValue === undefined) motionValue.set(unresolvedKeyframes[0]);
            } else unresolvedKeyframes[i] = unresolvedKeyframes[i - 1];
        }
    }
    setFinalKeyframe() {}
    measureInitialState() {}
    renderEndStyles() {}
    measureEndState() {}
    complete() {
        this.isComplete = true;
        this.onComplete(this.unresolvedKeyframes, this.finalKeyframe);
        $8a643b2da1c7bc40$var$toResolve.delete(this);
    }
    cancel() {
        if (!this.isComplete) {
            this.isScheduled = false;
            $8a643b2da1c7bc40$var$toResolve.delete(this);
        }
    }
    resume() {
        if (!this.isComplete) this.scheduleResolve();
    }
}




// If this number is a decimal, make it just five decimal places
// to avoid exponents
const $08533e7dcf2265d2$export$83d2e9e3e4ee39ed = (v)=>Math.round(v * 100000) / 100000;


const $0cfc69005916d580$export$2444ca58c08448e4 = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;


function $ea92e7c60948441e$export$b931b78cbb3caf86(v) {
    return v == null;
}


const $c20d4ae2b38f8df9$export$ed808ff6ecd39e8d = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu;


/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ const $5722faa01ec1ec2e$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean(typeof v === "string" && (0, $c20d4ae2b38f8df9$export$ed808ff6ecd39e8d).test(v) && v.startsWith(type) || testProp && !(0, $ea92e7c60948441e$export$b931b78cbb3caf86)(v) && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $5722faa01ec1ec2e$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (typeof v !== "string") return v;
        const [a, b, c, alpha] = v.match((0, $0cfc69005916d580$export$2444ca58c08448e4));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };


const $73de4a1e9f0dd80c$var$clampRgbUnit = (v)=>(0, $bb2cd2f4425aee0a$export$7d15b64cf5a3a4c4)(0, 255, v);
const $73de4a1e9f0dd80c$export$7a99c86b5b1f4c9e = {
    ...(0, $84044ef4463ca44e$export$98e628dec113755e),
    transform: (v)=>Math.round($73de4a1e9f0dd80c$var$clampRgbUnit(v))
};
const $73de4a1e9f0dd80c$export$4e46ac54fc82cf3b = {
    test: /*@__PURE__*/ (0, $5722faa01ec1ec2e$export$2c8400d58aca05e)("rgb", "red"),
    parse: /*@__PURE__*/ (0, $5722faa01ec1ec2e$export$73d6f35be992df24)("red", "green", "blue"),
    transform: ({ red: red , green: green , blue: blue , alpha: alpha$1 = 1  })=>"rgba(" + $73de4a1e9f0dd80c$export$7a99c86b5b1f4c9e.transform(red) + ", " + $73de4a1e9f0dd80c$export$7a99c86b5b1f4c9e.transform(green) + ", " + $73de4a1e9f0dd80c$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $08533e7dcf2265d2$export$83d2e9e3e4ee39ed)((0, $84044ef4463ca44e$export$58f0f39f63f3cf42).transform(alpha$1)) + ")"
};



function $30a5a0b739818b6d$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $30a5a0b739818b6d$export$834dfc94dde4b3d8 = {
    test: /*@__PURE__*/ (0, $5722faa01ec1ec2e$export$2c8400d58aca05e)("#"),
    parse: $30a5a0b739818b6d$var$parseHex,
    transform: (0, $73de4a1e9f0dd80c$export$4e46ac54fc82cf3b).transform
};






const $0843b7e1fb4696f0$export$810b04175080204c = {
    test: /*@__PURE__*/ (0, $5722faa01ec1ec2e$export$2c8400d58aca05e)("hsl", "hue"),
    parse: /*@__PURE__*/ (0, $5722faa01ec1ec2e$export$73d6f35be992df24)("hue", "saturation", "lightness"),
    transform: ({ hue: hue , saturation: saturation , lightness: lightness , alpha: alpha$1 = 1  })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $ee89500f7aaa2f56$export$626336c2cd4b14de).transform((0, $08533e7dcf2265d2$export$83d2e9e3e4ee39ed)(saturation)) + ", " + (0, $ee89500f7aaa2f56$export$626336c2cd4b14de).transform((0, $08533e7dcf2265d2$export$83d2e9e3e4ee39ed)(lightness)) + ", " + (0, $08533e7dcf2265d2$export$83d2e9e3e4ee39ed)((0, $84044ef4463ca44e$export$58f0f39f63f3cf42).transform(alpha$1)) + ")";
    }
};



const $7a26ed3125820d32$export$35e9368ef982300f = {
    test: (v)=>(0, $73de4a1e9f0dd80c$export$4e46ac54fc82cf3b).test(v) || (0, $30a5a0b739818b6d$export$834dfc94dde4b3d8).test(v) || (0, $0843b7e1fb4696f0$export$810b04175080204c).test(v),
    parse: (v)=>{
        if ((0, $73de4a1e9f0dd80c$export$4e46ac54fc82cf3b).test(v)) return (0, $73de4a1e9f0dd80c$export$4e46ac54fc82cf3b).parse(v);
        else if ((0, $0843b7e1fb4696f0$export$810b04175080204c).test(v)) return (0, $0843b7e1fb4696f0$export$810b04175080204c).parse(v);
        else return (0, $30a5a0b739818b6d$export$834dfc94dde4b3d8).parse(v);
    },
    transform: (v)=>{
        return typeof v === "string" ? v : v.hasOwnProperty("red") ? (0, $73de4a1e9f0dd80c$export$4e46ac54fc82cf3b).transform(v) : (0, $0843b7e1fb4696f0$export$810b04175080204c).transform(v);
    }
};


const $f8337b1228d779df$export$740b69c5fad25dba = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;




function $a554c66132092e1c$var$test(v) {
    var _a, _b;
    return isNaN(v) && typeof v === "string" && (((_a = v.match((0, $0cfc69005916d580$export$2444ca58c08448e4))) === null || _a === void 0 ? void 0 : _a.length) || 0) + (((_b = v.match((0, $f8337b1228d779df$export$740b69c5fad25dba))) === null || _b === void 0 ? void 0 : _b.length) || 0) > 0;
}
const $a554c66132092e1c$var$NUMBER_TOKEN = "number";
const $a554c66132092e1c$var$COLOR_TOKEN = "color";
const $a554c66132092e1c$var$VAR_TOKEN = "var";
const $a554c66132092e1c$var$VAR_FUNCTION_TOKEN = "var(";
const $a554c66132092e1c$var$SPLIT_TOKEN = "${}";
// this regex consists of the `singleCssVariableRegex|rgbHSLValueRegex|digitRegex`
const $a554c66132092e1c$var$complexRegex = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function $a554c66132092e1c$export$b61fc7c44bf646d5(value) {
    const originalValue = value.toString();
    const values = [];
    const indexes = {
        color: [],
        number: [],
        var: []
    };
    const types = [];
    let i = 0;
    const tokenised = originalValue.replace($a554c66132092e1c$var$complexRegex, (parsedValue)=>{
        if ((0, $7a26ed3125820d32$export$35e9368ef982300f).test(parsedValue)) {
            indexes.color.push(i);
            types.push($a554c66132092e1c$var$COLOR_TOKEN);
            values.push((0, $7a26ed3125820d32$export$35e9368ef982300f).parse(parsedValue));
        } else if (parsedValue.startsWith($a554c66132092e1c$var$VAR_FUNCTION_TOKEN)) {
            indexes.var.push(i);
            types.push($a554c66132092e1c$var$VAR_TOKEN);
            values.push(parsedValue);
        } else {
            indexes.number.push(i);
            types.push($a554c66132092e1c$var$NUMBER_TOKEN);
            values.push(parseFloat(parsedValue));
        }
        ++i;
        return $a554c66132092e1c$var$SPLIT_TOKEN;
    });
    const split = tokenised.split($a554c66132092e1c$var$SPLIT_TOKEN);
    return {
        values: values,
        split: split,
        indexes: indexes,
        types: types
    };
}
function $a554c66132092e1c$var$parseComplexValue(v) {
    return $a554c66132092e1c$export$b61fc7c44bf646d5(v).values;
}
function $a554c66132092e1c$var$createTransformer(source) {
    const { split: split , types: types  } = $a554c66132092e1c$export$b61fc7c44bf646d5(source);
    const numSections = split.length;
    return (v)=>{
        let output = "";
        for(let i = 0; i < numSections; i++){
            output += split[i];
            if (v[i] !== undefined) {
                const type = types[i];
                if (type === $a554c66132092e1c$var$NUMBER_TOKEN) output += (0, $08533e7dcf2265d2$export$83d2e9e3e4ee39ed)(v[i]);
                else if (type === $a554c66132092e1c$var$COLOR_TOKEN) output += (0, $7a26ed3125820d32$export$35e9368ef982300f).transform(v[i]);
                else output += v[i];
            }
        }
        return output;
    };
}
const $a554c66132092e1c$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : v;
function $a554c66132092e1c$var$getAnimatableNone(v) {
    const parsed = $a554c66132092e1c$var$parseComplexValue(v);
    const transformer = $a554c66132092e1c$var$createTransformer(v);
    return transformer(parsed.map($a554c66132092e1c$var$convertNumbersToZero));
}
const $a554c66132092e1c$export$83a0e34f1302825b = {
    test: $a554c66132092e1c$var$test,
    parse: $a554c66132092e1c$var$parseComplexValue,
    createTransformer: $a554c66132092e1c$var$createTransformer,
    getAnimatableNone: $a554c66132092e1c$var$getAnimatableNone
};





/**
 * Properties that should default to 1 or 100%
 */ const $9326f348bb1b920e$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $9326f348bb1b920e$var$applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $0cfc69005916d580$export$2444ca58c08448e4)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $9326f348bb1b920e$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $9326f348bb1b920e$var$functionRegex = /\b([a-z-]*)\(.*?\)/gu;
const $9326f348bb1b920e$export$3dea766d36a8935f = {
    ...(0, $a554c66132092e1c$export$83a0e34f1302825b),
    getAnimatableNone: (v)=>{
        const functions = v.match($9326f348bb1b920e$var$functionRegex);
        return functions ? functions.map($9326f348bb1b920e$var$applyDefaultFilter).join(" ") : v;
    }
};







const $61e57eb6323393a7$export$2fb74b0a4e7d7c4a = {
    // Border props
    borderWidth: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    borderTopWidth: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    borderRightWidth: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    borderBottomWidth: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    borderLeftWidth: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    borderRadius: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    radius: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    borderTopLeftRadius: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    borderTopRightRadius: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    borderBottomRightRadius: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    borderBottomLeftRadius: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    // Positioning props
    width: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    maxWidth: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    height: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    maxHeight: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    top: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    right: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    bottom: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    left: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    // Spacing props
    padding: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    paddingTop: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    paddingRight: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    paddingBottom: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    paddingLeft: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    margin: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    marginTop: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    marginRight: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    marginBottom: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    marginLeft: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    // Misc
    backgroundPositionX: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    backgroundPositionY: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008)
};




const $a68f72253e3f5800$export$f2e4285fee37e26 = {
    rotate: (0, $ee89500f7aaa2f56$export$41fc368e1a942b97),
    rotateX: (0, $ee89500f7aaa2f56$export$41fc368e1a942b97),
    rotateY: (0, $ee89500f7aaa2f56$export$41fc368e1a942b97),
    rotateZ: (0, $ee89500f7aaa2f56$export$41fc368e1a942b97),
    scale: $84044ef4463ca44e$export$dcdf75081b88279d,
    scaleX: (0, $84044ef4463ca44e$export$dcdf75081b88279d),
    scaleY: (0, $84044ef4463ca44e$export$dcdf75081b88279d),
    scaleZ: (0, $84044ef4463ca44e$export$dcdf75081b88279d),
    skew: (0, $ee89500f7aaa2f56$export$41fc368e1a942b97),
    skewX: (0, $ee89500f7aaa2f56$export$41fc368e1a942b97),
    skewY: (0, $ee89500f7aaa2f56$export$41fc368e1a942b97),
    distance: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    translateX: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    translateY: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    translateZ: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    x: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    y: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    z: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    perspective: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    transformPerspective: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    opacity: (0, $84044ef4463ca44e$export$58f0f39f63f3cf42),
    originX: (0, $ee89500f7aaa2f56$export$44e2e1705876d7ed),
    originY: (0, $ee89500f7aaa2f56$export$44e2e1705876d7ed),
    originZ: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008)
};



const $1500fa361742b746$export$7d260a2a5f8bc19e = {
    ...(0, $84044ef4463ca44e$export$98e628dec113755e),
    transform: Math.round
};


const $e26e0ac69c88d1e3$export$eec14432cd1cb67b = {
    ...(0, $61e57eb6323393a7$export$2fb74b0a4e7d7c4a),
    ...(0, $a68f72253e3f5800$export$f2e4285fee37e26),
    zIndex: (0, $1500fa361742b746$export$7d260a2a5f8bc19e),
    size: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    // SVG
    fillOpacity: (0, $84044ef4463ca44e$export$58f0f39f63f3cf42),
    strokeOpacity: (0, $84044ef4463ca44e$export$58f0f39f63f3cf42),
    numOctaves: (0, $1500fa361742b746$export$7d260a2a5f8bc19e)
};


/**
 * A map of default value types for common values
 */ const $5244b39289cc5c6d$export$98cd7c72c5a731fb = {
    ...(0, $e26e0ac69c88d1e3$export$eec14432cd1cb67b),
    color: // Color props
    $7a26ed3125820d32$export$35e9368ef982300f,
    backgroundColor: (0, $7a26ed3125820d32$export$35e9368ef982300f),
    outlineColor: (0, $7a26ed3125820d32$export$35e9368ef982300f),
    fill: (0, $7a26ed3125820d32$export$35e9368ef982300f),
    stroke: (0, $7a26ed3125820d32$export$35e9368ef982300f),
    // Border props
    borderColor: (0, $7a26ed3125820d32$export$35e9368ef982300f),
    borderTopColor: (0, $7a26ed3125820d32$export$35e9368ef982300f),
    borderRightColor: (0, $7a26ed3125820d32$export$35e9368ef982300f),
    borderBottomColor: (0, $7a26ed3125820d32$export$35e9368ef982300f),
    borderLeftColor: (0, $7a26ed3125820d32$export$35e9368ef982300f),
    filter: $9326f348bb1b920e$export$3dea766d36a8935f,
    WebkitFilter: (0, $9326f348bb1b920e$export$3dea766d36a8935f)
};
/**
 * Gets the default ValueType for the provided value key
 */ const $5244b39289cc5c6d$export$67d1babe0338d23b = (key)=>$5244b39289cc5c6d$export$98cd7c72c5a731fb[key];


function $1838583c06c42261$export$cea0cedcb94873b5(key, value) {
    let defaultValueType = (0, $5244b39289cc5c6d$export$67d1babe0338d23b)(key);
    if (defaultValueType !== (0, $9326f348bb1b920e$export$3dea766d36a8935f)) defaultValueType = (0, $a554c66132092e1c$export$83a0e34f1302825b);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}


/**
 * If we encounter keyframes like "none" or "0" and we also have keyframes like
 * "#fff" or "200px 200px" we want to find a keyframe to serve as a template for
 * the "none" keyframes. In this case "#fff" or "200px 200px" - then these get turned into
 * zero equivalents, i.e. "#fff0" or "0px 0px".
 */ const $7a2127a321ebfc42$var$invalidTemplates = new Set([
    "auto",
    "none",
    "0"
]);
function $7a2127a321ebfc42$export$8cc4958f8e540f37(unresolvedKeyframes, noneKeyframeIndexes, name) {
    let i = 0;
    let animatableTemplate = undefined;
    while(i < unresolvedKeyframes.length && !animatableTemplate){
        const keyframe = unresolvedKeyframes[i];
        if (typeof keyframe === "string" && !$7a2127a321ebfc42$var$invalidTemplates.has(keyframe) && (0, $a554c66132092e1c$export$b61fc7c44bf646d5)(keyframe).values.length) animatableTemplate = unresolvedKeyframes[i];
        i++;
    }
    if (animatableTemplate && name) for (const noneIndex of noneKeyframeIndexes)unresolvedKeyframes[noneIndex] = (0, $1838583c06c42261$export$cea0cedcb94873b5)(name, animatableTemplate);
}


class $c8b2f05e40a653fe$export$4983792d11b61017 extends (0, $8a643b2da1c7bc40$export$74d34ca3182f1750) {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element){
        super(unresolvedKeyframes, onComplete, name, motionValue, element, true);
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes , element: element , name: name  } = this;
        if (!element || !element.current) return;
        super.readKeyframes();
        /**
         * If any keyframe is a CSS variable, we need to find its value by sampling the element
         */ for(let i = 0; i < unresolvedKeyframes.length; i++){
            let keyframe = unresolvedKeyframes[i];
            if (typeof keyframe === "string") {
                keyframe = keyframe.trim();
                if ((0, $9223341d00255d67$export$31f9caa2600b5723)(keyframe)) {
                    const resolved = (0, $ff42741a21ccb940$export$289398774300c991)(keyframe, element.current);
                    if (resolved !== undefined) unresolvedKeyframes[i] = resolved;
                    if (i === unresolvedKeyframes.length - 1) this.finalKeyframe = keyframe;
                }
            }
        }
        /**
         * Resolve "none" values. We do this potentially twice - once before and once after measuring keyframes.
         * This could be seen as inefficient but it's a trade-off to avoid measurements in more situations, which
         * have a far bigger performance impact.
         */ this.resolveNoneKeyframes();
        /**
         * Check to see if unit type has changed. If so schedule jobs that will
         * temporarily set styles to the destination keyframes.
         * Skip if we have more than two keyframes or this isn't a positional value.
         * TODO: We can throw if there are multiple keyframes and the value type changes.
         */ if (!(0, $2b1f30070063653f$export$c66c0d5db2a205d).has(name) || unresolvedKeyframes.length !== 2) return;
        const [origin, target] = unresolvedKeyframes;
        const originType = (0, $d03d4f627f09ffbd$export$eefdd52e3ccae428)(origin);
        const targetType = (0, $d03d4f627f09ffbd$export$eefdd52e3ccae428)(target);
        /**
         * Either we don't recognise these value types or we can animate between them.
         */ if (originType === targetType) return;
        /**
         * If both values are numbers or pixels, we can animate between them by
         * converting them to numbers.
         */ if ((0, $2b1f30070063653f$export$8e5250d1aa9bf370)(originType) && (0, $2b1f30070063653f$export$8e5250d1aa9bf370)(targetType)) for(let i = 0; i < unresolvedKeyframes.length; i++){
            const value = unresolvedKeyframes[i];
            if (typeof value === "string") unresolvedKeyframes[i] = parseFloat(value);
        }
        else /**
             * Else, the only way to resolve this is by measuring the element.
             */ this.needsMeasurement = true;
    }
    resolveNoneKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes , name: name  } = this;
        const noneKeyframeIndexes = [];
        for(let i = 0; i < unresolvedKeyframes.length; i++)if ((0, $cfbb3fdee2e93a54$export$e56af863d5645d5f)(unresolvedKeyframes[i])) noneKeyframeIndexes.push(i);
        if (noneKeyframeIndexes.length) (0, $7a2127a321ebfc42$export$8cc4958f8e540f37)(unresolvedKeyframes, noneKeyframeIndexes, name);
    }
    measureInitialState() {
        const { element: element , unresolvedKeyframes: unresolvedKeyframes , name: name  } = this;
        if (!element || !element.current) return;
        if (name === "height") this.suspendedScrollY = window.pageYOffset;
        this.measuredOrigin = (0, $2b1f30070063653f$export$781d46a8aa670d52)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        unresolvedKeyframes[0] = this.measuredOrigin;
        // Set final key frame to measure after next render
        const measureKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
        if (measureKeyframe !== undefined) element.getValue(name, measureKeyframe).jump(measureKeyframe, false);
    }
    measureEndState() {
        var _a;
        const { element: element , name: name , unresolvedKeyframes: unresolvedKeyframes  } = this;
        if (!element || !element.current) return;
        const value = element.getValue(name);
        value && value.jump(this.measuredOrigin, false);
        const finalKeyframeIndex = unresolvedKeyframes.length - 1;
        const finalKeyframe = unresolvedKeyframes[finalKeyframeIndex];
        unresolvedKeyframes[finalKeyframeIndex] = (0, $2b1f30070063653f$export$781d46a8aa670d52)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        if (finalKeyframe !== null && this.finalKeyframe === undefined) this.finalKeyframe = finalKeyframe;
        // If we removed transform values, reapply them before the next render
        if ((_a = this.removedTransforms) === null || _a === void 0 ? void 0 : _a.length) this.removedTransforms.forEach(([unsetTransformName, unsetTransformValue])=>{
            element.getValue(unsetTransformName).set(unsetTransformValue);
        });
        this.resolveNoneKeyframes();
    }
}




function $9f244d5cf04606a0$export$6ab7812f1bac68be(type) {
    return typeof type === "function";
}




let $05b982fb85a2786e$var$now;
function $05b982fb85a2786e$var$clearTime() {
    $05b982fb85a2786e$var$now = undefined;
}
/**
 * An eventloop-synchronous alternative to performance.now().
 *
 * Ensures that time measurements remain consistent within a synchronous context.
 * Usually calling performance.now() twice within the same synchronous context
 * will return different values which isn't useful for animations when we're usually
 * trying to sync animations to the same frame.
 */ const $05b982fb85a2786e$export$2da9be4cfdb689b1 = {
    now: ()=>{
        if ($05b982fb85a2786e$var$now === undefined) $05b982fb85a2786e$export$2da9be4cfdb689b1.set((0, $6491bdd13544fdda$export$fff89137e9e818ce).isProcessing || (0, $6c4fc775126b27b6$export$dd826089e3c5e502).useManualTiming ? (0, $6491bdd13544fdda$export$fff89137e9e818ce).timestamp : performance.now());
        return $05b982fb85a2786e$var$now;
    },
    set: (newTime)=>{
        $05b982fb85a2786e$var$now = newTime;
        queueMicrotask($05b982fb85a2786e$var$clearTime);
    }
};







/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ const $9af063a91152801b$export$65676b58b122bc38 = (value, name)=>{
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (name === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, $a554c66132092e1c$export$83a0e34f1302825b).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};


function $dd719f2577620065$var$hasKeyframesChanged(keyframes) {
    const current = keyframes[0];
    if (keyframes.length === 1) return true;
    for(let i = 0; i < keyframes.length; i++){
        if (keyframes[i] !== current) return true;
    }
}
function $dd719f2577620065$export$1b109e6c9968df4f(keyframes, name, type, velocity) {
    /**
     * Check if we're able to animate between the start and end keyframes,
     * and throw a warning if we're attempting to animate between one that's
     * animatable and another that isn't.
     */ const originKeyframe = keyframes[0];
    if (originKeyframe === null) return false;
    /**
     * These aren't traditionally animatable but we do support them.
     * In future we could look into making this more generic or replacing
     * this function with mix() === mixImmediate
     */ if (name === "display" || name === "visibility") return true;
    const targetKeyframe = keyframes[keyframes.length - 1];
    const isOriginAnimatable = (0, $9af063a91152801b$export$65676b58b122bc38)(originKeyframe, name);
    const isTargetAnimatable = (0, $9af063a91152801b$export$65676b58b122bc38)(targetKeyframe, name);
    (0, $af7e1b70fef19820$export$491112666e282270)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${name} from "${originKeyframe}" to "${targetKeyframe}". ${originKeyframe} is not an animatable value - to enable this animation set ${originKeyframe} to a value animatable to ${targetKeyframe} via the \`style\` property.`);
    // Always skip if any of these are true
    if (!isOriginAnimatable || !isTargetAnimatable) return false;
    return $dd719f2577620065$var$hasKeyframesChanged(keyframes) || (type === "spring" || (0, $9f244d5cf04606a0$export$6ab7812f1bac68be)(type)) && velocity;
}



/**
 * Maximum time allowed between an animation being created and it being
 * resolved for us to use the latter as the start time.
 *
 * This is to ensure that while we prefer to "start" an animation as soon
 * as it's triggered, we also want to avoid a visual jump if there's a big delay
 * between these two moments.
 */ const $9e9bbf9cd1b9c15e$var$MAX_RESOLVE_DELAY = 40;
class $9e9bbf9cd1b9c15e$export$d1e4f34b9c2550c1 {
    constructor({ autoplay: autoplay = true , delay: delay = 0 , type: type = "keyframes" , repeat: repeat = 0 , repeatDelay: repeatDelay = 0 , repeatType: repeatType = "loop" , ...options }){
        // Track whether the animation has been stopped. Stopped animations won't restart.
        this.isStopped = false;
        this.hasAttemptedResolve = false;
        this.createdAt = (0, $05b982fb85a2786e$export$2da9be4cfdb689b1).now();
        this.options = {
            autoplay: autoplay,
            delay: delay,
            type: type,
            repeat: repeat,
            repeatDelay: repeatDelay,
            repeatType: repeatType,
            ...options
        };
        this.updateFinishedPromise();
    }
    /**
     * This method uses the createdAt and resolvedAt to calculate the
     * animation startTime. *Ideally*, we would use the createdAt time as t=0
     * as the following frame would then be the first frame of the animation in
     * progress, which would feel snappier.
     *
     * However, if there's a delay (main thread work) between the creation of
     * the animation and the first commited frame, we prefer to use resolvedAt
     * to avoid a sudden jump into the animation.
     */ calcStartTime() {
        if (!this.resolvedAt) return this.createdAt;
        return this.resolvedAt - this.createdAt > $9e9bbf9cd1b9c15e$var$MAX_RESOLVE_DELAY ? this.resolvedAt : this.createdAt;
    }
    /**
     * A getter for resolved data. If keyframes are not yet resolved, accessing
     * this.resolved will synchronously flush all pending keyframe resolvers.
     * This is a deoptimisation, but at its worst still batches read/writes.
     */ get resolved() {
        if (!this._resolved && !this.hasAttemptedResolve) (0, $8a643b2da1c7bc40$export$78b96d2a12593b05)();
        return this._resolved;
    }
    /**
     * A method to be called when the keyframes resolver completes. This method
     * will check if its possible to run the animation and, if not, skip it.
     * Otherwise, it will call initPlayback on the implementing class.
     */ onKeyframesResolved(keyframes, finalKeyframe) {
        this.resolvedAt = (0, $05b982fb85a2786e$export$2da9be4cfdb689b1).now();
        this.hasAttemptedResolve = true;
        const { name: name , type: type , velocity: velocity , delay: delay , onComplete: onComplete , onUpdate: onUpdate , isGenerator: isGenerator  } = this.options;
        /**
         * If we can't animate this value with the resolved keyframes
         * then we should complete it immediately.
         */ if (!isGenerator && !(0, $dd719f2577620065$export$1b109e6c9968df4f)(keyframes, name, type, velocity)) {
            // Finish immediately
            if ((0, $636ef95c23a1ebef$export$888a3d84909f9e3d).current || !delay) {
                onUpdate === null || onUpdate === void 0 || onUpdate((0, $cb21c6c57eea1e02$export$14de59408fad90b)(keyframes, this.options, finalKeyframe));
                onComplete === null || onComplete === void 0 || onComplete();
                this.resolveFinishedPromise();
                return;
            } else this.options.duration = 0;
        }
        const resolvedAnimation = this.initPlayback(keyframes, finalKeyframe);
        if (resolvedAnimation === false) return;
        this._resolved = {
            keyframes: keyframes,
            finalKeyframe: finalKeyframe,
            ...resolvedAnimation
        };
        this.onPostResolved();
    }
    onPostResolved() {}
    /**
     * Allows the returned animation to be awaited or promise-chained. Currently
     * resolves when the animation finishes at all but in a future update could/should
     * reject if its cancels.
     */ then(resolve, reject) {
        return this.currentFinishedPromise.then(resolve, reject);
    }
    flatten() {
        this.options.type = "keyframes";
        this.options.ease = "linear";
    }
    updateFinishedPromise() {
        this.currentFinishedPromise = new Promise((resolve)=>{
            this.resolveFinishedPromise = resolve;
        });
    }
}



/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/ const $e6e94e48128648b0$export$504d7abb21fa8c9 = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};


const $6f00502c1d650426$export$66d3851e2b1ec912 = (easing, duration, resolution = 10 // as milliseconds
)=>{
    let points = "";
    const numPoints = Math.max(Math.round(duration / resolution), 2);
    for(let i = 0; i < numPoints; i++)points += easing((0, $e6e94e48128648b0$export$504d7abb21fa8c9)(0, numPoints - 1, i)) + ", ";
    return `linear(${points.substring(0, points.length - 2)})`;
};



/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ function $8d9716de34c4d522$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}


const $53c11e9376dd0d8e$var$velocitySampleDuration = 5; // ms
function $53c11e9376dd0d8e$export$854187271d233eb5(resolveValue, t, current) {
    const prevT = Math.max(t - $53c11e9376dd0d8e$var$velocitySampleDuration, 0);
    return (0, $8d9716de34c4d522$export$eab0632f7ad4f9d7)(current - resolveValue(prevT), t - prevT);
}





const $3c52e59ffa955590$export$86436497e7b05d16 = {
    // Default spring physics
    stiffness: 100,
    damping: 10,
    mass: 1.0,
    velocity: 0.0,
    // Default duration/bounce-based options
    duration: 800,
    bounce: 0.3,
    visualDuration: 0.3,
    // Rest thresholds
    restSpeed: {
        granular: 0.01,
        default: 2
    },
    restDelta: {
        granular: 0.005,
        default: 0.5
    },
    // Limits
    minDuration: 0.01,
    maxDuration: 10.0,
    minDamping: 0.05,
    maxDamping: 1
};


const $e053e23acb72da0f$var$safeMin = 0.001;
function $e053e23acb72da0f$export$b15f158dc6d6f458({ duration: duration = (0, $3c52e59ffa955590$export$86436497e7b05d16).duration , bounce: bounce = (0, $3c52e59ffa955590$export$86436497e7b05d16).bounce , velocity: velocity = (0, $3c52e59ffa955590$export$86436497e7b05d16).velocity , mass: mass = (0, $3c52e59ffa955590$export$86436497e7b05d16).mass  }) {
    let envelope;
    let derivative;
    (0, $af7e1b70fef19820$export$491112666e282270)(duration <= (0, $631bdbca8ed9a472$export$fc3e7e8557f8c8c7)((0, $3c52e59ffa955590$export$86436497e7b05d16).maxDuration), "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, $bb2cd2f4425aee0a$export$7d15b64cf5a3a4c4)((0, $3c52e59ffa955590$export$86436497e7b05d16).minDamping, (0, $3c52e59ffa955590$export$86436497e7b05d16).maxDamping, dampingRatio);
    duration = (0, $bb2cd2f4425aee0a$export$7d15b64cf5a3a4c4)((0, $3c52e59ffa955590$export$86436497e7b05d16).minDuration, (0, $3c52e59ffa955590$export$86436497e7b05d16).maxDuration, (0, $631bdbca8ed9a472$export$f64c3bfbc58eec0f)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $e053e23acb72da0f$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $e053e23acb72da0f$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $e053e23acb72da0f$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $e053e23acb72da0f$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$e053e23acb72da0f$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $e053e23acb72da0f$var$approximateRoot(envelope, derivative, initialGuess);
    duration = (0, $631bdbca8ed9a472$export$fc3e7e8557f8c8c7)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: (0, $3c52e59ffa955590$export$86436497e7b05d16).stiffness,
        damping: (0, $3c52e59ffa955590$export$86436497e7b05d16).damping,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $e053e23acb72da0f$var$rootIterations = 12;
function $e053e23acb72da0f$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $e053e23acb72da0f$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $e053e23acb72da0f$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}


/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $9e09771207b3385c$export$f4ff70a5b4808fd8 = 20000;
function $9e09771207b3385c$export$cbdd6b3d40ea54e2(generator) {
    let duration = 0;
    const timeStep = 50;
    let state = generator.next(duration);
    while(!state.done && duration < $9e09771207b3385c$export$f4ff70a5b4808fd8){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= $9e09771207b3385c$export$f4ff70a5b4808fd8 ? Infinity : duration;
}




const $883a7f57df047776$var$durationKeys = [
    "duration",
    "bounce"
];
const $883a7f57df047776$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $883a7f57df047776$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $883a7f57df047776$var$getSpringOptions(options) {
    let springOptions = {
        velocity: (0, $3c52e59ffa955590$export$86436497e7b05d16).velocity,
        stiffness: (0, $3c52e59ffa955590$export$86436497e7b05d16).stiffness,
        damping: (0, $3c52e59ffa955590$export$86436497e7b05d16).damping,
        mass: (0, $3c52e59ffa955590$export$86436497e7b05d16).mass,
        isResolvedFromDuration: false,
        ...options
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!$883a7f57df047776$var$isSpringType(options, $883a7f57df047776$var$physicsKeys) && $883a7f57df047776$var$isSpringType(options, $883a7f57df047776$var$durationKeys)) {
        if (options.visualDuration) {
            const visualDuration = options.visualDuration;
            const root = 2 * Math.PI / (visualDuration * 1.2);
            const stiffness = root * root;
            const damping = 2 * (0, $bb2cd2f4425aee0a$export$7d15b64cf5a3a4c4)(0.05, 1, 1 - options.bounce) * Math.sqrt(stiffness);
            springOptions = {
                ...springOptions,
                mass: (0, $3c52e59ffa955590$export$86436497e7b05d16).mass,
                stiffness: stiffness,
                damping: damping
            };
        } else {
            const derived = (0, $e053e23acb72da0f$export$b15f158dc6d6f458)(options);
            springOptions = {
                ...springOptions,
                ...derived,
                mass: (0, $3c52e59ffa955590$export$86436497e7b05d16).mass
            };
            springOptions.isResolvedFromDuration = true;
        }
    }
    return springOptions;
}
function $883a7f57df047776$export$b36281d89752ae66(optionsOrVisualDuration = (0, $3c52e59ffa955590$export$86436497e7b05d16).visualDuration, bounce = (0, $3c52e59ffa955590$export$86436497e7b05d16).bounce) {
    const options = typeof optionsOrVisualDuration !== "object" ? {
        visualDuration: optionsOrVisualDuration,
        keyframes: [
            0,
            1
        ],
        bounce: bounce
    } : optionsOrVisualDuration;
    let { restSpeed: restSpeed , restDelta: restDelta  } = options;
    const origin = options.keyframes[0];
    const target = options.keyframes[options.keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    const { stiffness: stiffness , damping: damping , mass: mass , duration: duration , velocity: velocity , isResolvedFromDuration: isResolvedFromDuration  } = $883a7f57df047776$var$getSpringOptions({
        ...options,
        velocity: -(0, $631bdbca8ed9a472$export$f64c3bfbc58eec0f)(options.velocity || 0)
    });
    const initialVelocity = velocity || 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const initialDelta = target - origin;
    const undampedAngularFreq = (0, $631bdbca8ed9a472$export$f64c3bfbc58eec0f)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? (0, $3c52e59ffa955590$export$86436497e7b05d16).restSpeed.granular : (0, $3c52e59ffa955590$export$86436497e7b05d16).restSpeed.default);
    restDelta || (restDelta = isGranularScale ? (0, $3c52e59ffa955590$export$86436497e7b05d16).restDelta.granular : (0, $3c52e59ffa955590$export$86436497e7b05d16).restDelta.default);
    let resolveSpring;
    if (dampingRatio < 1) {
        const angularFreq = (0, $e053e23acb72da0f$export$5f679887c3a78b15)(undampedAngularFreq, dampingRatio);
        // Underdamped spring
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) // Critically damped spring
    resolveSpring = (t)=>target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
    else {
        // Overdamped spring
        const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
    }
    const generator = {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        next: (t)=>{
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                let currentVelocity = 0.0;
                /**
                 * We only need to calculate velocity for under-damped springs
                 * as over- and critically-damped springs can't overshoot, so
                 * checking only for displacement is enough.
                 */ if (dampingRatio < 1) currentVelocity = t === 0 ? (0, $631bdbca8ed9a472$export$fc3e7e8557f8c8c7)(initialVelocity) : (0, $53c11e9376dd0d8e$export$854187271d233eb5)(resolveSpring, t, current);
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        },
        toString: ()=>{
            const calculatedDuration = Math.min((0, $9e09771207b3385c$export$cbdd6b3d40ea54e2)(generator), (0, $9e09771207b3385c$export$f4ff70a5b4808fd8));
            const easing = (0, $6f00502c1d650426$export$66d3851e2b1ec912)((progress)=>generator.next(calculatedDuration * progress).value, calculatedDuration, 30);
            return calculatedDuration + "ms " + easing;
        }
    };
    return generator;
}




function $45d5055f4c56892a$export$ee3ff3a17106998({ keyframes: keyframes , velocity: velocity = 0.0 , power: power = 0.8 , timeConstant: timeConstant = 325 , bounceDamping: bounceDamping = 10 , bounceStiffness: bounceStiffness = 500 , modifyTarget: modifyTarget , min: min , max: max , restDelta: restDelta = 0.5 , restSpeed: restSpeed  }) {
    const origin = keyframes[0];
    const state = {
        done: false,
        value: origin
    };
    const isOutOfBounds = (v)=>min !== undefined && v < min || max !== undefined && v > max;
    const nearestBoundary = (v)=>{
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    const calcDelta = (t)=>-amplitude * Math.exp(-t / timeConstant);
    const calcLatest = (t)=>target + calcDelta(t);
    const applyFriction = (t)=>{
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t)=>{
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, $883a7f57df047776$export$b36281d89752ae66)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, $53c11e9376dd0d8e$export$854187271d233eb5)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta: restDelta,
            restSpeed: restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: (t)=>{
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ let hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t >= timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}



const $d8968a9bf4ef9569$export$929e5a82286172a6 = /*@__PURE__*/ (0, $704adaa4b6058bb3$export$2c575fa1d20488bd)(0.42, 0, 1, 1);
const $d8968a9bf4ef9569$export$57636bb43b1ccbb0 = /*@__PURE__*/ (0, $704adaa4b6058bb3$export$2c575fa1d20488bd)(0, 0, 0.58, 1);
const $d8968a9bf4ef9569$export$c07234257a03d5e9 = /*@__PURE__*/ (0, $704adaa4b6058bb3$export$2c575fa1d20488bd)(0.42, 0, 0.58, 1);


const $77de1aec9c0d8bc3$export$216948827bbdc797 = (ease)=>{
    return Array.isArray(ease) && typeof ease[0] !== "number";
};








const $3a622b680f893ceb$export$ff43f99925d7366b = (easing)=>Array.isArray(easing) && typeof easing[0] === "number";


const $d606f3c6c8f4d23c$var$easingLookup = {
    linear: (0, $c13dd6518645747b$export$8793edee2d425525),
    easeIn: $d8968a9bf4ef9569$export$929e5a82286172a6,
    easeInOut: $d8968a9bf4ef9569$export$c07234257a03d5e9,
    easeOut: $d8968a9bf4ef9569$export$57636bb43b1ccbb0,
    circIn: $f0e499eff44e3cea$export$e444123e42d03385,
    circInOut: $f0e499eff44e3cea$export$30d3455eee55bed5,
    circOut: $f0e499eff44e3cea$export$c8d67a19199d1a50,
    backIn: $d3c4eaabf34a945a$export$b01116c84cdfe1a2,
    backInOut: $d3c4eaabf34a945a$export$ddc5fd596f6c71b2,
    backOut: $d3c4eaabf34a945a$export$77edfce482316a60,
    anticipate: $1a7a42634de0d0af$export$6b0af63b873d419e
};
const $d606f3c6c8f4d23c$export$ef97fe084f156ca4 = (definition)=>{
    if ((0, $3a622b680f893ceb$export$ff43f99925d7366b)(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $af7e1b70fef19820$export$f5708dca728d7177)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`);
        const [x1, y1, x2, y2] = definition;
        return (0, $704adaa4b6058bb3$export$2c575fa1d20488bd)(x1, y1, x2, y2);
    } else if (typeof definition === "string") {
        // Else lookup from table
        (0, $af7e1b70fef19820$export$f5708dca728d7177)($d606f3c6c8f4d23c$var$easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`);
        return $d606f3c6c8f4d23c$var$easingLookup[definition];
    }
    return definition;
};



/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ const $6cc9e4dbba39be5c$var$combineFunctions = (a, b)=>(v)=>b(a(v));
const $6cc9e4dbba39be5c$export$a4627e546088548d = (...transformers)=>transformers.reduce($6cc9e4dbba39be5c$var$combineFunctions);




/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ const $87248eb8ba080f28$export$3bb0b4ff1037b8dd = (from, to, progress)=>{
    return from + (to - from) * progress;
};




// Adapted from https://gist.github.com/mjackson/5311256
function $5429745468e3b812$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $5429745468e3b812$export$6ae64dbcd6bfc33e({ hue: hue , saturation: saturation , lightness: lightness , alpha: alpha  }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $5429745468e3b812$var$hueToRgb(p, q, hue + 1 / 3);
        green = $5429745468e3b812$var$hueToRgb(p, q, hue);
        blue = $5429745468e3b812$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}





function $a4bfef1e47c99c15$export$a6f92d4bae65c0f1(a, b) {
    return (p)=>p > 0 ? b : a;
}


// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const $3587923dc2cfe4e2$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    const expo = v * (to * to - fromExpo) + fromExpo;
    return expo < 0 ? 0 : Math.sqrt(expo);
};
const $3587923dc2cfe4e2$var$colorTypes = [
    (0, $30a5a0b739818b6d$export$834dfc94dde4b3d8),
    (0, $73de4a1e9f0dd80c$export$4e46ac54fc82cf3b),
    (0, $0843b7e1fb4696f0$export$810b04175080204c)
];
const $3587923dc2cfe4e2$var$getColorType = (v)=>$3587923dc2cfe4e2$var$colorTypes.find((type)=>type.test(v));
function $3587923dc2cfe4e2$var$asRGBA(color) {
    const type = $3587923dc2cfe4e2$var$getColorType(color);
    (0, $af7e1b70fef19820$export$491112666e282270)(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`);
    if (!Boolean(type)) return false;
    let model = type.parse(color);
    if (type === (0, $0843b7e1fb4696f0$export$810b04175080204c)) // TODO Remove this cast - needed since Motion's stricter typing
    model = (0, $5429745468e3b812$export$6ae64dbcd6bfc33e)(model);
    return model;
}
const $3587923dc2cfe4e2$export$51e568cf5c039bac = (from, to)=>{
    const fromRGBA = $3587923dc2cfe4e2$var$asRGBA(from);
    const toRGBA = $3587923dc2cfe4e2$var$asRGBA(to);
    if (!fromRGBA || !toRGBA) return (0, $a4bfef1e47c99c15$export$a6f92d4bae65c0f1)(from, to);
    const blended = {
        ...fromRGBA
    };
    return (v)=>{
        blended.red = $3587923dc2cfe4e2$export$d4ecea248cce73c(fromRGBA.red, toRGBA.red, v);
        blended.green = $3587923dc2cfe4e2$export$d4ecea248cce73c(fromRGBA.green, toRGBA.green, v);
        blended.blue = $3587923dc2cfe4e2$export$d4ecea248cce73c(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, $73de4a1e9f0dd80c$export$4e46ac54fc82cf3b).transform(blended);
    };
};







const $d051ba1e71c72dc9$export$e5a55ae567dd4ac7 = new Set([
    "none",
    "hidden"
]);
/**
 * Returns a function that, when provided a progress value between 0 and 1,
 * will return the "none" or "hidden" string only when the progress is that of
 * the origin or target.
 */ function $d051ba1e71c72dc9$export$fed62ccc3fb1a568(origin, target) {
    if ($d051ba1e71c72dc9$export$e5a55ae567dd4ac7.has(origin)) return (p)=>p <= 0 ? origin : target;
    else return (p)=>p >= 1 ? target : origin;
}



function $bbad6d399b1675c4$var$mixNumber(a, b) {
    return (p)=>(0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(a, b, p);
}
function $bbad6d399b1675c4$export$36ec24672cd098e0(a) {
    if (typeof a === "number") return $bbad6d399b1675c4$var$mixNumber;
    else if (typeof a === "string") return (0, $9223341d00255d67$export$31f9caa2600b5723)(a) ? (0, $a4bfef1e47c99c15$export$a6f92d4bae65c0f1) : (0, $7a26ed3125820d32$export$35e9368ef982300f).test(a) ? (0, $3587923dc2cfe4e2$export$51e568cf5c039bac) : $bbad6d399b1675c4$export$65516310a87d8205;
    else if (Array.isArray(a)) return $bbad6d399b1675c4$export$3bbefa2f402845c4;
    else if (typeof a === "object") return (0, $7a26ed3125820d32$export$35e9368ef982300f).test(a) ? (0, $3587923dc2cfe4e2$export$51e568cf5c039bac) : $bbad6d399b1675c4$export$ebc23b6840c51ba1;
    return 0, $a4bfef1e47c99c15$export$a6f92d4bae65c0f1;
}
function $bbad6d399b1675c4$export$3bbefa2f402845c4(a, b) {
    const output = [
        ...a
    ];
    const numValues = output.length;
    const blendValue = a.map((v, i)=>$bbad6d399b1675c4$export$36ec24672cd098e0(v)(v, b[i]));
    return (p)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](p);
        return output;
    };
}
function $bbad6d399b1675c4$export$ebc23b6840c51ba1(a, b) {
    const output = {
        ...a,
        ...b
    };
    const blendValue = {};
    for(const key in output)if (a[key] !== undefined && b[key] !== undefined) blendValue[key] = $bbad6d399b1675c4$export$36ec24672cd098e0(a[key])(a[key], b[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
}
function $bbad6d399b1675c4$var$matchOrder(origin, target) {
    var _a;
    const orderedOrigin = [];
    const pointers = {
        color: 0,
        var: 0,
        number: 0
    };
    for(let i = 0; i < target.values.length; i++){
        const type = target.types[i];
        const originIndex = origin.indexes[type][pointers[type]];
        const originValue = (_a = origin.values[originIndex]) !== null && _a !== void 0 ? _a : 0;
        orderedOrigin[i] = originValue;
        pointers[type]++;
    }
    return orderedOrigin;
}
const $bbad6d399b1675c4$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $a554c66132092e1c$export$83a0e34f1302825b).createTransformer(target);
    const originStats = (0, $a554c66132092e1c$export$b61fc7c44bf646d5)(origin);
    const targetStats = (0, $a554c66132092e1c$export$b61fc7c44bf646d5)(target);
    const canInterpolate = originStats.indexes.var.length === targetStats.indexes.var.length && originStats.indexes.color.length === targetStats.indexes.color.length && originStats.indexes.number.length >= targetStats.indexes.number.length;
    if (canInterpolate) {
        if ((0, $d051ba1e71c72dc9$export$e5a55ae567dd4ac7).has(origin) && !targetStats.values.length || (0, $d051ba1e71c72dc9$export$e5a55ae567dd4ac7).has(target) && !originStats.values.length) return (0, $d051ba1e71c72dc9$export$fed62ccc3fb1a568)(origin, target);
        return (0, $6cc9e4dbba39be5c$export$a4627e546088548d)($bbad6d399b1675c4$export$3bbefa2f402845c4($bbad6d399b1675c4$var$matchOrder(originStats, targetStats), targetStats.values), template);
    } else {
        (0, $af7e1b70fef19820$export$491112666e282270)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return (0, $a4bfef1e47c99c15$export$a6f92d4bae65c0f1)(origin, target);
    }
};



function $ffbcc7e5194b07fa$export$2c9e8a9632a706b2(from, to, p) {
    if (typeof from === "number" && typeof to === "number" && typeof p === "number") return (0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(from, to, p);
    const mixer = (0, $bbad6d399b1675c4$export$36ec24672cd098e0)(from);
    return mixer(from, to);
}


function $db1b2cb99cb3914e$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || (0, $ffbcc7e5194b07fa$export$2c9e8a9632a706b2);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] || (0, $c13dd6518645747b$export$8793edee2d425525) : ease;
            mixer = (0, $6cc9e4dbba39be5c$export$a4627e546088548d)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revist this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function $db1b2cb99cb3914e$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true , ease: ease , mixer: mixer  } = {}) {
    const inputLength = input.length;
    (0, $af7e1b70fef19820$export$f5708dca728d7177)(inputLength === output.length, "Both input and output ranges must be the same length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return ()=>output[0];
    if (inputLength === 2 && input[0] === input[1]) return ()=>output[1];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [
            ...input
        ].reverse();
        output = [
            ...output
        ].reverse();
    }
    const mixers = $db1b2cb99cb3914e$var$createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v)=>{
        let i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        const progressInRange = (0, $e6e94e48128648b0$export$504d7abb21fa8c9)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? (v)=>interpolator((0, $bb2cd2f4425aee0a$export$7d15b64cf5a3a4c4)(input[0], input[inputLength - 1], v)) : interpolator;
}




function $3d0a1060fe6b890b$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $e6e94e48128648b0$export$504d7abb21fa8c9)(0, remaining, i);
        offset.push((0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(min, 1, offsetProgress));
    }
}


function $b4d6c80c1f693ab4$export$24dbcec0b26e6d9d(arr) {
    const offset = [
        0
    ];
    (0, $3d0a1060fe6b890b$export$dafee61230cf05c6)(offset, arr.length - 1);
    return offset;
}


function $56a5cdb9e012c5ee$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}


function $a441228218aac9d3$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $d8968a9bf4ef9569$export$c07234257a03d5e9)).splice(0, values.length - 1);
}
function $a441228218aac9d3$export$d25ddfdf17c3ad3e({ duration: duration = 300 , keyframes: keyframeValues , times: times , ease: ease = "easeInOut"  }) {
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ const easingFunctions = (0, $77de1aec9c0d8bc3$export$216948827bbdc797)(ease) ? ease.map((0, $d606f3c6c8f4d23c$export$ef97fe084f156ca4)) : (0, $d606f3c6c8f4d23c$export$ef97fe084f156ca4)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ const absoluteTimes = (0, $56a5cdb9e012c5ee$export$2a91b4e3a4539316)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, $b4d6c80c1f693ab4$export$24dbcec0b26e6d9d)(keyframeValues), duration);
    const mapTimeToKeyframe = (0, $db1b2cb99cb3914e$export$89e29e4ab65e70a9)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : $a441228218aac9d3$export$6b60b58e4ea7d715(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: (t)=>{
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}











const $eb7f9ad0d187e388$export$c1033964b5ad7fef = (update)=>{
    const passTimestamp = ({ timestamp: timestamp  })=>update(timestamp);
    return {
        start: ()=>(0, $6491bdd13544fdda$export$2cef06c20297c17d).update(passTimestamp, true),
        stop: ()=>(0, $6491bdd13544fdda$export$ec99c0ef4978dccb)(passTimestamp),
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: ()=>(0, $6491bdd13544fdda$export$fff89137e9e818ce).isProcessing ? (0, $6491bdd13544fdda$export$fff89137e9e818ce).timestamp : (0, $05b982fb85a2786e$export$2da9be4cfdb689b1).now()
    };
};




const $38d8d0fc14215eff$var$generators = {
    decay: (0, $45d5055f4c56892a$export$ee3ff3a17106998),
    inertia: $45d5055f4c56892a$export$ee3ff3a17106998,
    tween: (0, $a441228218aac9d3$export$d25ddfdf17c3ad3e),
    keyframes: (0, $a441228218aac9d3$export$d25ddfdf17c3ad3e),
    spring: $883a7f57df047776$export$b36281d89752ae66
};
const $38d8d0fc14215eff$var$percentToProgress = (percent)=>percent / 100;
/**
 * Animation that runs on the main thread. Designed to be WAAPI-spec in the subset of
 * features we expose publically. Mostly the compatibility is to ensure visual identity
 * between both WAAPI and main thread animations.
 */ class $38d8d0fc14215eff$export$fd98d9cca67a58bc extends (0, $9e9bbf9cd1b9c15e$export$d1e4f34b9c2550c1) {
    constructor(options){
        super(options);
        /**
         * The time at which the animation was paused.
         */ this.holdTime = null;
        /**
         * The time at which the animation was cancelled.
         */ this.cancelTime = null;
        /**
         * The current time of the animation.
         */ this.currentTime = 0;
        /**
         * Playback speed as a factor. 0 would be stopped, -1 reverse and 2 double speed.
         */ this.playbackSpeed = 1;
        /**
         * The state of the animation to apply when the animation is resolved. This
         * allows calls to the public API to control the animation before it is resolved,
         * without us having to resolve it first.
         */ this.pendingPlayState = "running";
        /**
         * The time at which the animation was started.
         */ this.startTime = null;
        this.state = "idle";
        /**
         * This method is bound to the instance to fix a pattern where
         * animation.stop is returned as a reference from a useEffect.
         */ this.stop = ()=>{
            this.resolver.cancel();
            this.isStopped = true;
            if (this.state === "idle") return;
            this.teardown();
            const { onStop: onStop  } = this.options;
            onStop && onStop();
        };
        const { name: name , motionValue: motionValue , element: element , keyframes: keyframes  } = this.options;
        const KeyframeResolver$1 = (element === null || element === void 0 ? void 0 : element.KeyframeResolver) || (0, $8a643b2da1c7bc40$export$74d34ca3182f1750);
        const onResolved = (resolvedKeyframes, finalKeyframe)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe);
        this.resolver = new KeyframeResolver$1(keyframes, onResolved, name, motionValue, element);
        this.resolver.scheduleResolve();
    }
    flatten() {
        super.flatten();
        // If we've already resolved the animation, re-initialise it
        if (this._resolved) Object.assign(this._resolved, this.initPlayback(this._resolved.keyframes));
    }
    initPlayback(keyframes$1) {
        const { type: type = "keyframes" , repeat: repeat = 0 , repeatDelay: repeatDelay = 0 , repeatType: repeatType , velocity: velocity = 0  } = this.options;
        const generatorFactory = (0, $9f244d5cf04606a0$export$6ab7812f1bac68be)(type) ? type : $38d8d0fc14215eff$var$generators[type] || (0, $a441228218aac9d3$export$d25ddfdf17c3ad3e);
        /**
         * If our generator doesn't support mixing numbers, we need to replace keyframes with
         * [0, 100] and then make a function that maps that to the actual keyframes.
         *
         * 100 is chosen instead of 1 as it works nicer with spring animations.
         */ let mapPercentToKeyframes;
        let mirroredGenerator;
        if (generatorFactory !== (0, $a441228218aac9d3$export$d25ddfdf17c3ad3e) && typeof keyframes$1[0] !== "number") {
            mapPercentToKeyframes = (0, $6cc9e4dbba39be5c$export$a4627e546088548d)($38d8d0fc14215eff$var$percentToProgress, (0, $ffbcc7e5194b07fa$export$2c9e8a9632a706b2)(keyframes$1[0], keyframes$1[1]));
            keyframes$1 = [
                0,
                100
            ];
        }
        const generator = generatorFactory({
            ...this.options,
            keyframes: keyframes$1
        });
        /**
         * If we have a mirror repeat type we need to create a second generator that outputs the
         * mirrored (not reversed) animation and later ping pong between the two generators.
         */ if (repeatType === "mirror") mirroredGenerator = generatorFactory({
            ...this.options,
            keyframes: [
                ...keyframes$1
            ].reverse(),
            velocity: -velocity
        });
        /**
         * If duration is undefined and we have repeat options,
         * we need to calculate a duration from the generator.
         *
         * We set it to the generator itself to cache the duration.
         * Any timeline resolver will need to have already precalculated
         * the duration by this step.
         */ if (generator.calculatedDuration === null) generator.calculatedDuration = (0, $9e09771207b3385c$export$cbdd6b3d40ea54e2)(generator);
        const { calculatedDuration: calculatedDuration  } = generator;
        const resolvedDuration = calculatedDuration + repeatDelay;
        const totalDuration = resolvedDuration * (repeat + 1) - repeatDelay;
        return {
            generator: generator,
            mirroredGenerator: mirroredGenerator,
            mapPercentToKeyframes: mapPercentToKeyframes,
            calculatedDuration: calculatedDuration,
            resolvedDuration: resolvedDuration,
            totalDuration: totalDuration
        };
    }
    onPostResolved() {
        const { autoplay: autoplay = true  } = this.options;
        this.play();
        if (this.pendingPlayState === "paused" || !autoplay) this.pause();
        else this.state = this.pendingPlayState;
    }
    tick(timestamp, sample = false) {
        const { resolved: resolved  } = this;
        // If the animations has failed to resolve, return the final keyframe.
        if (!resolved) {
            const { keyframes: keyframes  } = this.options;
            return {
                done: true,
                value: keyframes[keyframes.length - 1]
            };
        }
        const { finalKeyframe: finalKeyframe , generator: generator , mirroredGenerator: mirroredGenerator , mapPercentToKeyframes: mapPercentToKeyframes , keyframes: keyframes , calculatedDuration: calculatedDuration , totalDuration: totalDuration , resolvedDuration: resolvedDuration  } = resolved;
        if (this.startTime === null) return generator.next(0);
        const { delay: delay , repeat: repeat , repeatType: repeatType , repeatDelay: repeatDelay , onUpdate: onUpdate  } = this.options;
        /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (this.speed > 0) this.startTime = Math.min(this.startTime, timestamp);
        else if (this.speed < 0) this.startTime = Math.min(timestamp - totalDuration / this.speed, this.startTime);
        // Update currentTime
        if (sample) this.currentTime = timestamp;
        else if (this.holdTime !== null) this.currentTime = this.holdTime;
        else // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
        // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
        // example.
        this.currentTime = Math.round(timestamp - this.startTime) * this.speed;
        // Rebase on delay
        const timeWithoutDelay = this.currentTime - delay * (this.speed >= 0 ? 1 : -1);
        const isInDelayPhase = this.speed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
        this.currentTime = Math.max(timeWithoutDelay, 0);
        // If this animation has finished, set the current time  to the total duration.
        if (this.state === "finished" && this.holdTime === null) this.currentTime = totalDuration;
        let elapsed = this.currentTime;
        let frameGenerator = generator;
        if (repeat) {
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = Math.min(this.currentTime, totalDuration) / resolvedDuration;
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
            iterationProgress === 1 && currentIteration--;
            currentIteration = Math.min(currentIteration, repeat + 1);
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const isOddIteration = Boolean(currentIteration % 2);
            if (isOddIteration) {
                if (repeatType === "reverse") {
                    iterationProgress = 1 - iterationProgress;
                    if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
            }
            elapsed = (0, $bb2cd2f4425aee0a$export$7d15b64cf5a3a4c4)(0, 1, iterationProgress) * resolvedDuration;
        }
        /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ const state = isInDelayPhase ? {
            done: false,
            value: keyframes[0]
        } : frameGenerator.next(elapsed);
        if (mapPercentToKeyframes) state.value = mapPercentToKeyframes(state.value);
        let { done: done  } = state;
        if (!isInDelayPhase && calculatedDuration !== null) done = this.speed >= 0 ? this.currentTime >= totalDuration : this.currentTime <= 0;
        const isAnimationFinished = this.holdTime === null && (this.state === "finished" || this.state === "running" && done);
        if (isAnimationFinished && finalKeyframe !== undefined) state.value = (0, $cb21c6c57eea1e02$export$14de59408fad90b)(keyframes, this.options, finalKeyframe);
        if (onUpdate) onUpdate(state.value);
        if (isAnimationFinished) this.finish();
        return state;
    }
    get duration() {
        const { resolved: resolved  } = this;
        return resolved ? (0, $631bdbca8ed9a472$export$f64c3bfbc58eec0f)(resolved.calculatedDuration) : 0;
    }
    get time() {
        return (0, $631bdbca8ed9a472$export$f64c3bfbc58eec0f)(this.currentTime);
    }
    set time(newTime) {
        newTime = (0, $631bdbca8ed9a472$export$fc3e7e8557f8c8c7)(newTime);
        this.currentTime = newTime;
        if (this.holdTime !== null || this.speed === 0) this.holdTime = newTime;
        else if (this.driver) this.startTime = this.driver.now() - newTime / this.speed;
    }
    get speed() {
        return this.playbackSpeed;
    }
    set speed(newSpeed) {
        const hasChanged = this.playbackSpeed !== newSpeed;
        this.playbackSpeed = newSpeed;
        if (hasChanged) this.time = (0, $631bdbca8ed9a472$export$f64c3bfbc58eec0f)(this.currentTime);
    }
    play() {
        if (!this.resolver.isScheduled) this.resolver.resume();
        if (!this._resolved) {
            this.pendingPlayState = "running";
            return;
        }
        if (this.isStopped) return;
        const { driver: driver = (0, $eb7f9ad0d187e388$export$c1033964b5ad7fef) , onPlay: onPlay , startTime: startTime  } = this.options;
        if (!this.driver) this.driver = driver((timestamp)=>this.tick(timestamp));
        onPlay && onPlay();
        const now = this.driver.now();
        if (this.holdTime !== null) this.startTime = now - this.holdTime;
        else if (!this.startTime) this.startTime = startTime !== null && startTime !== void 0 ? startTime : this.calcStartTime();
        else if (this.state === "finished") this.startTime = now;
        if (this.state === "finished") this.updateFinishedPromise();
        this.cancelTime = this.startTime;
        this.holdTime = null;
        /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ this.state = "running";
        this.driver.start();
    }
    pause() {
        var _a;
        if (!this._resolved) {
            this.pendingPlayState = "paused";
            return;
        }
        this.state = "paused";
        this.holdTime = (_a = this.currentTime) !== null && _a !== void 0 ? _a : 0;
    }
    complete() {
        if (this.state !== "running") this.play();
        this.pendingPlayState = this.state = "finished";
        this.holdTime = null;
    }
    finish() {
        this.teardown();
        this.state = "finished";
        const { onComplete: onComplete  } = this.options;
        onComplete && onComplete();
    }
    cancel() {
        if (this.cancelTime !== null) this.tick(this.cancelTime);
        this.teardown();
        this.updateFinishedPromise();
    }
    teardown() {
        this.state = "idle";
        this.stopDriver();
        this.resolveFinishedPromise();
        this.updateFinishedPromise();
        this.startTime = this.cancelTime = null;
        this.resolver.cancel();
    }
    stopDriver() {
        if (!this.driver) return;
        this.driver.stop();
        this.driver = undefined;
    }
    sample(time) {
        this.startTime = 0;
        return this.tick(time, true);
    }
}
// Legacy interface
function $38d8d0fc14215eff$export$ee9b76de7353d815(options) {
    return new $38d8d0fc14215eff$export$fd98d9cca67a58bc(options);
}


/**
 * A list of values that can be hardware-accelerated.
 */ const $a48a2668cc2264ec$export$a27eefbd8fb5e404 = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform"
]);




function $b4f9da87da1ca830$export$7c73462e0d25e514(callback) {
    let result;
    return ()=>{
        if (result === undefined) result = callback();
        return result;
    };
}


/**
 * Add the ability for test suites to manually set support flags
 * to better test more environments.
 */ const $92dd689f947242e8$export$e3ad02c335474dee = {
    linearEasing: undefined
};


function $661af794b6fe6527$export$1964673d5ec13c3a(callback, supportsFlag) {
    const memoized = (0, $b4f9da87da1ca830$export$7c73462e0d25e514)(callback);
    return ()=>{
        var _a;
        return (_a = (0, $92dd689f947242e8$export$e3ad02c335474dee)[supportsFlag]) !== null && _a !== void 0 ? _a : memoized();
    };
}


const $5e240f5c11f168de$export$866c1d07a1ac2ab = /*@__PURE__*/ (0, $661af794b6fe6527$export$1964673d5ec13c3a)(()=>{
    try {
        document.createElement("div").animate({
            opacity: 0
        }, {
            easing: "linear(0, 1)"
        });
    } catch (e) {
        return false;
    }
    return true;
}, "linearEasing");


function $9b4b0944f487b7c3$export$fcdd8f3f2160beda(easing) {
    return Boolean(typeof easing === "function" && (0, $5e240f5c11f168de$export$866c1d07a1ac2ab)() || !easing || typeof easing === "string" && (easing in $9b4b0944f487b7c3$export$2cf569f5e2221176 || (0, $5e240f5c11f168de$export$866c1d07a1ac2ab)()) || (0, $3a622b680f893ceb$export$ff43f99925d7366b)(easing) || Array.isArray(easing) && easing.every($9b4b0944f487b7c3$export$fcdd8f3f2160beda));
}
const $9b4b0944f487b7c3$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;
const $9b4b0944f487b7c3$export$2cf569f5e2221176 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: /*@__PURE__*/ $9b4b0944f487b7c3$export$2523b8f0bd8f44cb([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: /*@__PURE__*/ $9b4b0944f487b7c3$export$2523b8f0bd8f44cb([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: /*@__PURE__*/ $9b4b0944f487b7c3$export$2523b8f0bd8f44cb([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: /*@__PURE__*/ $9b4b0944f487b7c3$export$2523b8f0bd8f44cb([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};
function $9b4b0944f487b7c3$export$916ea73bcd3a6030(easing, duration) {
    if (!easing) return undefined;
    else if (typeof easing === "function" && (0, $5e240f5c11f168de$export$866c1d07a1ac2ab)()) return (0, $6f00502c1d650426$export$66d3851e2b1ec912)(easing, duration);
    else if ((0, $3a622b680f893ceb$export$ff43f99925d7366b)(easing)) return $9b4b0944f487b7c3$export$2523b8f0bd8f44cb(easing);
    else if (Array.isArray(easing)) return easing.map((segmentEasing)=>$9b4b0944f487b7c3$export$916ea73bcd3a6030(segmentEasing, duration) || $9b4b0944f487b7c3$export$2cf569f5e2221176.easeOut);
    else return $9b4b0944f487b7c3$export$2cf569f5e2221176[easing];
}


function $2b04773fa5493e28$export$d896de52f97cb615(element, valueName, keyframes, { delay: delay = 0 , duration: duration = 300 , repeat: repeat = 0 , repeatType: repeatType = "loop" , ease: ease = "easeInOut" , times: times  } = {}) {
    const keyframeOptions = {
        [valueName]: keyframes
    };
    if (times) keyframeOptions.offset = times;
    const easing = (0, $9b4b0944f487b7c3$export$916ea73bcd3a6030)(ease, duration);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    return element.animate(keyframeOptions, {
        delay: delay,
        duration: duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    });
}



function $441fea3c9d5f5c15$export$5bd0fcbc73622e13(animation, timeline) {
    animation.timeline = timeline;
    animation.onfinish = null;
}





const $5e339d6188e4f0f2$export$51ea9b46fb7a8c5d = /*@__PURE__*/ (0, $b4f9da87da1ca830$export$7c73462e0d25e514)(()=>Object.hasOwnProperty.call(Element.prototype, "animate"));


/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ const $264f965dbb30cd85$var$sampleDelta = 10; //ms
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $264f965dbb30cd85$var$maxDuration = 20000;
/**
 * Check if an animation can run natively via WAAPI or requires pregenerated keyframes.
 * WAAPI doesn't support spring or function easings so we run these as JS animation before
 * handing off.
 */ function $264f965dbb30cd85$var$requiresPregeneratedKeyframes(options) {
    return (0, $9f244d5cf04606a0$export$6ab7812f1bac68be)(options.type) || options.type === "spring" || !(0, $9b4b0944f487b7c3$export$fcdd8f3f2160beda)(options.ease);
}
function $264f965dbb30cd85$var$pregenerateKeyframes(keyframes, options) {
    /**
     * Create a main-thread animation to pregenerate keyframes.
     * We sample this at regular intervals to generate keyframes that we then
     * linearly interpolate between.
     */ const sampleAnimation = new (0, $38d8d0fc14215eff$export$fd98d9cca67a58bc)({
        ...options,
        keyframes: keyframes,
        repeat: 0,
        delay: 0,
        isGenerator: true
    });
    let state = {
        done: false,
        value: keyframes[0]
    };
    const pregeneratedKeyframes = [];
    /**
     * Bail after 20 seconds of pre-generated keyframes as it's likely
     * we're heading for an infinite loop.
     */ let t = 0;
    while(!state.done && t < $264f965dbb30cd85$var$maxDuration){
        state = sampleAnimation.sample(t);
        pregeneratedKeyframes.push(state.value);
        t += $264f965dbb30cd85$var$sampleDelta;
    }
    return {
        times: undefined,
        keyframes: pregeneratedKeyframes,
        duration: t - $264f965dbb30cd85$var$sampleDelta,
        ease: "linear"
    };
}
const $264f965dbb30cd85$var$unsupportedEasingFunctions = {
    anticipate: $1a7a42634de0d0af$export$6b0af63b873d419e,
    backInOut: $d3c4eaabf34a945a$export$ddc5fd596f6c71b2,
    circInOut: $f0e499eff44e3cea$export$30d3455eee55bed5
};
function $264f965dbb30cd85$var$isUnsupportedEase(key) {
    return key in $264f965dbb30cd85$var$unsupportedEasingFunctions;
}
class $264f965dbb30cd85$export$2a45abb4e6513325 extends (0, $9e9bbf9cd1b9c15e$export$d1e4f34b9c2550c1) {
    constructor(options){
        super(options);
        const { name: name , motionValue: motionValue , element: element , keyframes: keyframes  } = this.options;
        this.resolver = new (0, $c8b2f05e40a653fe$export$4983792d11b61017)(keyframes, (resolvedKeyframes, finalKeyframe)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe), name, motionValue, element);
        this.resolver.scheduleResolve();
    }
    initPlayback(keyframes, finalKeyframe) {
        var _a;
        let { duration: duration = 300 , times: times , ease: ease , type: type , motionValue: motionValue , name: name , startTime: startTime  } = this.options;
        /**
         * If element has since been unmounted, return false to indicate
         * the animation failed to initialised.
         */ if (!((_a = motionValue.owner) === null || _a === void 0 ? void 0 : _a.current)) return false;
        /**
         * If the user has provided an easing function name that isn't supported
         * by WAAPI (like "anticipate"), we need to provide the corressponding
         * function. This will later get converted to a linear() easing function.
         */ if (typeof ease === "string" && (0, $5e240f5c11f168de$export$866c1d07a1ac2ab)() && $264f965dbb30cd85$var$isUnsupportedEase(ease)) ease = $264f965dbb30cd85$var$unsupportedEasingFunctions[ease];
        /**
         * If this animation needs pre-generated keyframes then generate.
         */ if ($264f965dbb30cd85$var$requiresPregeneratedKeyframes(this.options)) {
            const { onComplete: onComplete , onUpdate: onUpdate , motionValue: motionValue , element: element , ...options } = this.options;
            const pregeneratedAnimation = $264f965dbb30cd85$var$pregenerateKeyframes(keyframes, options);
            keyframes = pregeneratedAnimation.keyframes;
            // If this is a very short animation, ensure we have
            // at least two keyframes to animate between as older browsers
            // can't animate between a single keyframe.
            if (keyframes.length === 1) keyframes[1] = keyframes[0];
            duration = pregeneratedAnimation.duration;
            times = pregeneratedAnimation.times;
            ease = pregeneratedAnimation.ease;
            type = "keyframes";
        }
        const animation = (0, $2b04773fa5493e28$export$d896de52f97cb615)(motionValue.owner.current, name, keyframes, {
            ...this.options,
            duration: duration,
            times: times,
            ease: ease
        });
        // Override the browser calculated startTime with one synchronised to other JS
        // and WAAPI animations starting this event loop.
        animation.startTime = startTime !== null && startTime !== void 0 ? startTime : this.calcStartTime();
        if (this.pendingTimeline) {
            (0, $441fea3c9d5f5c15$export$5bd0fcbc73622e13)(animation, this.pendingTimeline);
            this.pendingTimeline = undefined;
        } else /**
             * Prefer the `onfinish` prop as it's more widely supported than
             * the `finished` promise.
             *
             * Here, we synchronously set the provided MotionValue to the end
             * keyframe. If we didn't, when the WAAPI animation is finished it would
             * be removed from the element which would then revert to its old styles.
             */ animation.onfinish = ()=>{
            const { onComplete: onComplete  } = this.options;
            motionValue.set((0, $cb21c6c57eea1e02$export$14de59408fad90b)(keyframes, this.options, finalKeyframe));
            onComplete && onComplete();
            this.cancel();
            this.resolveFinishedPromise();
        };
        return {
            animation: animation,
            duration: duration,
            times: times,
            type: type,
            ease: ease,
            keyframes: keyframes
        };
    }
    get duration() {
        const { resolved: resolved  } = this;
        if (!resolved) return 0;
        const { duration: duration  } = resolved;
        return (0, $631bdbca8ed9a472$export$f64c3bfbc58eec0f)(duration);
    }
    get time() {
        const { resolved: resolved  } = this;
        if (!resolved) return 0;
        const { animation: animation  } = resolved;
        return (0, $631bdbca8ed9a472$export$f64c3bfbc58eec0f)(animation.currentTime || 0);
    }
    set time(newTime) {
        const { resolved: resolved  } = this;
        if (!resolved) return;
        const { animation: animation  } = resolved;
        animation.currentTime = (0, $631bdbca8ed9a472$export$fc3e7e8557f8c8c7)(newTime);
    }
    get speed() {
        const { resolved: resolved  } = this;
        if (!resolved) return 1;
        const { animation: animation  } = resolved;
        return animation.playbackRate;
    }
    set speed(newSpeed) {
        const { resolved: resolved  } = this;
        if (!resolved) return;
        const { animation: animation  } = resolved;
        animation.playbackRate = newSpeed;
    }
    get state() {
        const { resolved: resolved  } = this;
        if (!resolved) return "idle";
        const { animation: animation  } = resolved;
        return animation.playState;
    }
    get startTime() {
        const { resolved: resolved  } = this;
        if (!resolved) return null;
        const { animation: animation  } = resolved;
        // Coerce to number as TypeScript incorrectly types this
        // as CSSNumberish
        return animation.startTime;
    }
    /**
     * Replace the default DocumentTimeline with another AnimationTimeline.
     * Currently used for scroll animations.
     */ attachTimeline(timeline) {
        if (!this._resolved) this.pendingTimeline = timeline;
        else {
            const { resolved: resolved  } = this;
            if (!resolved) return 0, $c13dd6518645747b$export$8793edee2d425525;
            const { animation: animation  } = resolved;
            (0, $441fea3c9d5f5c15$export$5bd0fcbc73622e13)(animation, timeline);
        }
        return 0, $c13dd6518645747b$export$8793edee2d425525;
    }
    play() {
        if (this.isStopped) return;
        const { resolved: resolved  } = this;
        if (!resolved) return;
        const { animation: animation  } = resolved;
        if (animation.playState === "finished") this.updateFinishedPromise();
        animation.play();
    }
    pause() {
        const { resolved: resolved  } = this;
        if (!resolved) return;
        const { animation: animation  } = resolved;
        animation.pause();
    }
    stop() {
        this.resolver.cancel();
        this.isStopped = true;
        if (this.state === "idle") return;
        this.resolveFinishedPromise();
        this.updateFinishedPromise();
        const { resolved: resolved  } = this;
        if (!resolved) return;
        const { animation: animation , keyframes: keyframes , duration: duration , type: type , ease: ease , times: times  } = resolved;
        if (animation.playState === "idle" || animation.playState === "finished") return;
        /**
         * WAAPI doesn't natively have any interruption capabilities.
         *
         * Rather than read commited styles back out of the DOM, we can
         * create a renderless JS animation and sample it twice to calculate
         * its current value, "previous" value, and therefore allow
         * Motion to calculate velocity for any subsequent animation.
         */ if (this.time) {
            const { motionValue: motionValue , onUpdate: onUpdate , onComplete: onComplete , element: element , ...options } = this.options;
            const sampleAnimation = new (0, $38d8d0fc14215eff$export$fd98d9cca67a58bc)({
                ...options,
                keyframes: keyframes,
                duration: duration,
                type: type,
                ease: ease,
                times: times,
                isGenerator: true
            });
            const sampleTime = (0, $631bdbca8ed9a472$export$fc3e7e8557f8c8c7)(this.time);
            motionValue.setWithVelocity(sampleAnimation.sample(sampleTime - $264f965dbb30cd85$var$sampleDelta).value, sampleAnimation.sample(sampleTime).value, $264f965dbb30cd85$var$sampleDelta);
        }
        const { onStop: onStop  } = this.options;
        onStop && onStop();
        this.cancel();
    }
    complete() {
        const { resolved: resolved  } = this;
        if (!resolved) return;
        resolved.animation.finish();
    }
    cancel() {
        const { resolved: resolved  } = this;
        if (!resolved) return;
        resolved.animation.cancel();
    }
    static supports(options) {
        const { motionValue: motionValue , name: name , repeatDelay: repeatDelay , repeatType: repeatType , damping: damping , type: type  } = options;
        return (0, $5e339d6188e4f0f2$export$51ea9b46fb7a8c5d)() && name && (0, $a48a2668cc2264ec$export$a27eefbd8fb5e404).has(name) && motionValue && motionValue.owner && motionValue.owner.current instanceof HTMLElement && /**
             * If we're outputting values to onUpdate then we can't use WAAPI as there's
             * no way to read the value from WAAPI every frame.
             */ !motionValue.owner.getProps().onUpdate && !repeatDelay && repeatType !== "mirror" && damping !== 0 && type !== "inertia";
    }
}




const $e728714da8c8a772$export$20d68f04f30763a5 = (0, $b4f9da87da1ca830$export$7c73462e0d25e514)(()=>window.ScrollTimeline !== undefined);


class $dc9a88cb44e235dd$export$c1e41718f71efe41 {
    constructor(animations){
        // Bound to accomodate common `return animation.stop` pattern
        this.stop = ()=>this.runAll("stop");
        this.animations = animations.filter(Boolean);
    }
    then(onResolve, onReject) {
        return Promise.all(this.animations).then(onResolve).catch(onReject);
    }
    /**
     * TODO: Filter out cancelled or stopped animations before returning
     */ getAll(propName) {
        return this.animations[0][propName];
    }
    setAll(propName, newValue) {
        for(let i = 0; i < this.animations.length; i++)this.animations[i][propName] = newValue;
    }
    attachTimeline(timeline, fallback) {
        const subscriptions = this.animations.map((animation)=>{
            if ((0, $e728714da8c8a772$export$20d68f04f30763a5)() && animation.attachTimeline) return animation.attachTimeline(timeline);
            else return fallback(animation);
        });
        return ()=>{
            subscriptions.forEach((cancel, i)=>{
                cancel && cancel();
                this.animations[i].stop();
            });
        };
    }
    get time() {
        return this.getAll("time");
    }
    set time(time) {
        this.setAll("time", time);
    }
    get speed() {
        return this.getAll("speed");
    }
    set speed(speed) {
        this.setAll("speed", speed);
    }
    get startTime() {
        return this.getAll("startTime");
    }
    get duration() {
        let max = 0;
        for(let i = 0; i < this.animations.length; i++)max = Math.max(max, this.animations[i].duration);
        return max;
    }
    runAll(methodName) {
        this.animations.forEach((controls)=>controls[methodName]());
    }
    flatten() {
        this.runAll("flatten");
    }
    play() {
        this.runAll("play");
    }
    pause() {
        this.runAll("pause");
    }
    cancel() {
        this.runAll("cancel");
    }
    complete() {
        this.runAll("complete");
    }
}


/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $21fa6358c07b6e55$export$ca8e47dc8ed5a9d7({ when: when , delay: _delay , delayChildren: delayChildren , staggerChildren: staggerChildren , staggerDirection: staggerDirection , repeat: repeat , repeatType: repeatType , repeatDelay: repeatDelay , from: from , elapsed: elapsed , ...transition }) {
    return !!Object.keys(transition).length;
}


const $3431270835958863$export$90b3dfc33ff3548 = (name, value, target, transition = {}, element, isHandoff)=>(onComplete)=>{
        const valueTransition = (0, $7530df41f7472851$export$7c1391340308742e)(transition, name) || {};
        /**
     * Most transition values are currently completely overwritten by value-specific
     * transitions. In the future it'd be nicer to blend these transitions. But for now
     * delay actually does inherit from the root transition if not value-specific.
     */ const delay = valueTransition.delay || transition.delay || 0;
        /**
     * Elapsed isn't a public transition option but can be passed through from
     * optimized appear effects in milliseconds.
     */ let { elapsed: elapsed = 0  } = transition;
        elapsed = elapsed - (0, $631bdbca8ed9a472$export$fc3e7e8557f8c8c7)(delay);
        let options = {
            keyframes: Array.isArray(target) ? target : [
                null,
                target
            ],
            ease: "easeOut",
            velocity: value.getVelocity(),
            ...valueTransition,
            delay: -elapsed,
            onUpdate: (v)=>{
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: ()=>{
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            },
            name: name,
            motionValue: value,
            element: isHandoff ? undefined : element
        };
        /**
     * If there's no transition defined for this value, we can generate
     * unqiue transition settings for this value.
     */ if (!(0, $21fa6358c07b6e55$export$ca8e47dc8ed5a9d7)(valueTransition)) options = {
            ...options,
            ...(0, $943a3f0a32f59f42$export$262124b154b9f1c0)(name, options)
        };
        /**
     * Both WAAPI and our internal animation functions use durations
     * as defined by milliseconds, while our external API defines them
     * as seconds.
     */ if (options.duration) options.duration = (0, $631bdbca8ed9a472$export$fc3e7e8557f8c8c7)(options.duration);
        if (options.repeatDelay) options.repeatDelay = (0, $631bdbca8ed9a472$export$fc3e7e8557f8c8c7)(options.repeatDelay);
        if (options.from !== undefined) options.keyframes[0] = options.from;
        let shouldSkip = false;
        if (options.type === false || options.duration === 0 && !options.repeatDelay) {
            options.duration = 0;
            if (options.delay === 0) shouldSkip = true;
        }
        if ((0, $636ef95c23a1ebef$export$888a3d84909f9e3d).current || (0, $6c4fc775126b27b6$export$dd826089e3c5e502).skipAnimations) {
            shouldSkip = true;
            options.duration = 0;
            options.delay = 0;
        }
        /**
     * If we can or must skip creating the animation, and apply only
     * the final keyframe, do so. We also check once keyframes are resolved but
     * this early check prevents the need to create an animation at all.
     */ if (shouldSkip && !isHandoff && value.get() !== undefined) {
            const finalKeyframe = (0, $cb21c6c57eea1e02$export$14de59408fad90b)(options.keyframes, valueTransition);
            if (finalKeyframe !== undefined) {
                (0, $6491bdd13544fdda$export$2cef06c20297c17d).update(()=>{
                    options.onUpdate(finalKeyframe);
                    options.onComplete();
                });
                // We still want to return some animation controls here rather
                // than returning undefined
                return new (0, $dc9a88cb44e235dd$export$c1e41718f71efe41)([]);
            }
        }
        /**
     * Animate via WAAPI if possible. If this is a handoff animation, the optimised animation will be running via
     * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
     * optimised animation.
     */ if (!isHandoff && (0, $264f965dbb30cd85$export$2a45abb4e6513325).supports(options)) return new (0, $264f965dbb30cd85$export$2a45abb4e6513325)(options);
        else return new (0, $38d8d0fc14215eff$export$fd98d9cca67a58bc)(options);
    };



const $b9d94c0c185391a2$export$2f308ad9864b3ac9 = (v)=>{
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
const $b9d94c0c185391a2$export$5485128c47bd48bb = (v)=>{
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $96ae1bfc697c0155$export$9153ad4c4999f4a0)(v) ? v[v.length - 1] || 0 : v;
};


function $13ad1cfa8b4681b0$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $13ad1cfa8b4681b0$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $13ad1cfa8b4681b0$export$ec937e64de6c1257([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}


class $fe92d8ac7a8c9e00$export$e7dff9482a5fd23c {
    constructor(){
        this.subscriptions = [];
    }
    add(handler) {
        (0, $13ad1cfa8b4681b0$export$20e507e47fae79fd)(this.subscriptions, handler);
        return ()=>(0, $13ad1cfa8b4681b0$export$fe2d9b4e03920b4c)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(let i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ const handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
}






/**
 * Maximum time between the value of two frames, beyond which we
 * assume the velocity has since been 0.
 */ const $925342fde4532b85$var$MAX_VELOCITY_DELTA = 30;
const $925342fde4532b85$var$isFloat = (value)=>{
    return !isNaN(parseFloat(value));
};
const $925342fde4532b85$export$67fcd818a264039d = {
    current: undefined
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ class $925342fde4532b85$export$8cea36d14ee64562 {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */ constructor(init, options = {}){
        /**
         * This will be replaced by the build step with the latest version number.
         * When MotionValues are provided to motion components, warn if versions are mixed.
         */ this.version = "11.15.0";
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = null;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = (v, render = true)=>{
            const currentTime = (0, $05b982fb85a2786e$export$2da9be4cfdb689b1).now();
            /**
             * If we're updating the value during another frame or eventloop
             * than the previous frame, then the we set the previous frame value
             * to current.
             */ if (this.updatedAt !== currentTime) this.setPrevFrameValue();
            this.prev = this.current;
            this.setCurrent(v);
            // Update update subscribers
            if (this.current !== this.prev && this.events.change) this.events.change.notify(this.current);
            // Update render subscribers
            if (render && this.events.renderRequest) this.events.renderRequest.notify(this.current);
        };
        this.hasAnimated = false;
        this.setCurrent(init);
        this.owner = options.owner;
    }
    setCurrent(current) {
        this.current = current;
        this.updatedAt = (0, $05b982fb85a2786e$export$2da9be4cfdb689b1).now();
        if (this.canTrackVelocity === null && current !== undefined) this.canTrackVelocity = $925342fde4532b85$var$isFloat(this.current);
    }
    setPrevFrameValue(prevFrameValue = this.current) {
        this.prevFrameValue = prevFrameValue;
        this.prevUpdatedAt = this.updatedAt;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ onChange(subscription) {
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $fe92d8ac7a8c9e00$export$e7dff9482a5fd23c)();
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") return ()=>{
            unsubscribe();
            /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, $6491bdd13544fdda$export$2cef06c20297c17d).read(()=>{
                if (!this.events.change.getSize()) this.stop();
            });
        };
        return unsubscribe;
    }
    clearListeners() {
        for(const eventManagers in this.events)this.events[eventManagers].clear();
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */ attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ set(v, render = true) {
        if (!render || !this.passiveEffect) this.updateAndNotify(v, render);
        else this.passiveEffect(v, this.updateAndNotify);
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = undefined;
        this.prevFrameValue = prev;
        this.prevUpdatedAt = this.updatedAt - delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ jump(v, endAnimation = true) {
        this.updateAndNotify(v);
        this.prev = v;
        this.prevUpdatedAt = this.prevFrameValue = undefined;
        endAnimation && this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ get() {
        if ($925342fde4532b85$export$67fcd818a264039d.current) $925342fde4532b85$export$67fcd818a264039d.current.push(this);
        return this.current;
    }
    /**
     * @public
     */ getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ getVelocity() {
        const currentTime = (0, $05b982fb85a2786e$export$2da9be4cfdb689b1).now();
        if (!this.canTrackVelocity || this.prevFrameValue === undefined || currentTime - this.updatedAt > $925342fde4532b85$var$MAX_VELOCITY_DELTA) return 0;
        const delta = Math.min(this.updatedAt - this.prevUpdatedAt, $925342fde4532b85$var$MAX_VELOCITY_DELTA);
        // Casts because of parseFloat's poor typing
        return (0, $8d9716de34c4d522$export$eab0632f7ad4f9d7)(parseFloat(this.current) - parseFloat(this.prevFrameValue), delta);
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */ start(startAnimation) {
        this.stop();
        return new Promise((resolve)=>{
            this.hasAnimated = true;
            this.animation = startAnimation(resolve);
            if (this.events.animationStart) this.events.animationStart.notify();
        }).then(()=>{
            if (this.events.animationComplete) this.events.animationComplete.notify();
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */ stop() {
        if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) this.events.animationCancel.notify();
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ isAnimating() {
        return !!this.animation;
    }
    clearAnimation() {
        delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ destroy() {
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
}
function $925342fde4532b85$export$ce8bdc721e76545f(init, options) {
    return new $925342fde4532b85$export$8cea36d14ee64562(init, options);
}



/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $4ddbbe2518feafa3$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $925342fde4532b85$export$ce8bdc721e76545f)(value));
}
function $4ddbbe2518feafa3$export$1f61c53461aff4a5(visualElement, definition) {
    const resolved = (0, $dfe6a10b7b91d234$export$7b1b1c981f4f0558)(visualElement, definition);
    let { transitionEnd: transitionEnd = {} , transition: transition = {} , ...target } = resolved || {};
    target = {
        ...target,
        ...transitionEnd
    };
    for(const key in target){
        const value = (0, $b9d94c0c185391a2$export$5485128c47bd48bb)(target[key]);
        $4ddbbe2518feafa3$var$setMotionValue(visualElement, key, value);
    }
}



/**
 * Convert camelCase to dash-case properties.
 */ const $002b84d235cc9e7f$export$9fd24a634729c672 = (str)=>str.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase();


const $6b140fcbcf20767d$export$ed7b8fa9dbf0105d = "framerAppearId";
const $6b140fcbcf20767d$export$8592e1c077c890a6 = "data-" + (0, $002b84d235cc9e7f$export$9fd24a634729c672)($6b140fcbcf20767d$export$ed7b8fa9dbf0105d);


function $e2f74713dde14d85$export$5f8d21e84d1d84fc(visualElement) {
    return visualElement.props[0, $6b140fcbcf20767d$export$8592e1c077c890a6];
}


const $d449570363f09a53$export$605d60a2578142d3 = (value)=>Boolean(value && value.getVelocity);


function $7b21dab475728d1e$export$98397f3adbf6259f(value) {
    return Boolean((0, $d449570363f09a53$export$605d60a2578142d3)(value) && value.add);
}


function $bd95401810c788ae$export$3ac5aed310be0bee(visualElement, key) {
    const willChange = visualElement.getValue("willChange");
    /**
     * It could be that a user has set willChange to a regular MotionValue,
     * in which case we can't add the value to it.
     */ if ((0, $7b21dab475728d1e$export$98397f3adbf6259f)(willChange)) return willChange.add(key);
}



/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $cbfc21822c188a13$var$shouldBlockAnimation({ protectedKeys: protectedKeys , needsAnimating: needsAnimating  }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function $cbfc21822c188a13$export$68cacfeee78d98d2(visualElement, targetAndTransition, { delay: delay = 0 , transitionOverride: transitionOverride , type: type  } = {}) {
    var _a;
    let { transition: transition = visualElement.getDefaultTransition() , transitionEnd: transitionEnd , ...target } = targetAndTransition;
    if (transitionOverride) transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    for(const key in target){
        const value = visualElement.getValue(key, (_a = visualElement.latestValues[key]) !== null && _a !== void 0 ? _a : null);
        const valueTarget = target[key];
        if (valueTarget === undefined || animationTypeState && $cbfc21822c188a13$var$shouldBlockAnimation(animationTypeState, key)) continue;
        const valueTransition = {
            delay: delay,
            ...(0, $7530df41f7472851$export$7c1391340308742e)(transition || {}, key)
        };
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ let isHandoff = false;
        if (window.MotionHandoffAnimation) {
            const appearId = (0, $e2f74713dde14d85$export$5f8d21e84d1d84fc)(visualElement);
            if (appearId) {
                const startTime = window.MotionHandoffAnimation(appearId, key, (0, $6491bdd13544fdda$export$2cef06c20297c17d));
                if (startTime !== null) {
                    valueTransition.startTime = startTime;
                    isHandoff = true;
                }
            }
        }
        (0, $bd95401810c788ae$export$3ac5aed310be0bee)(visualElement, key);
        value.start((0, $3431270835958863$export$90b3dfc33ff3548)(key, value, valueTarget, visualElement.shouldReduceMotion && (0, $05d385f303970557$export$7b42a0094fb00b6e).has(key) ? {
            type: false
        } : valueTransition, visualElement, isHandoff));
        const animation = value.animation;
        if (animation) animations.push(animation);
    }
    if (transitionEnd) Promise.all(animations).then(()=>{
        (0, $6491bdd13544fdda$export$2cef06c20297c17d).update(()=>{
            transitionEnd && (0, $4ddbbe2518feafa3$export$1f61c53461aff4a5)(visualElement, transitionEnd);
        });
    });
    return animations;
}




function $8c445c76717d72c0$export$4709dc300705b2af(visualElement, variant, options = {}) {
    var _a;
    const resolved = (0, $dfe6a10b7b91d234$export$7b1b1c981f4f0558)(visualElement, variant, options.type === "exit" ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom : undefined);
    let { transition: transition = visualElement.getDefaultTransition() || {}  } = resolved || {};
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getAnimation = resolved ? ()=>Promise.all((0, $cbfc21822c188a13$export$68cacfeee78d98d2)(visualElement, resolved, options)) : ()=>Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? (forwardDelay = 0)=>{
        const { delayChildren: delayChildren = 0 , staggerChildren: staggerChildren , staggerDirection: staggerDirection  } = transition;
        return $8c445c76717d72c0$var$animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
    } : ()=>Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ const { when: when  } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ];
        return first().then(()=>last());
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
function $8c445c76717d72c0$var$animateChildren(visualElement, variant, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    const maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    const generateStaggerDuration = staggerDirection === 1 ? (i = 0)=>i * staggerChildren : (i = 0)=>maxStaggerDuration - i * staggerChildren;
    Array.from(visualElement.variantChildren).sort($8c445c76717d72c0$export$523a0bedf33ad781).forEach((child, i)=>{
        child.notify("AnimationStart", variant);
        animations.push($8c445c76717d72c0$export$4709dc300705b2af(child, variant, {
            ...options,
            delay: delayChildren + generateStaggerDuration(i)
        }).then(()=>child.notify("AnimationComplete", variant)));
    });
    return Promise.all(animations);
}
function $8c445c76717d72c0$export$523a0bedf33ad781(a, b) {
    return a.sortNodePosition(b);
}


function $ca7433f5e9b78911$export$ff62cf473653f109(visualElement, definition, options = {}) {
    visualElement.notify("AnimationStart", definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant)=>(0, $8c445c76717d72c0$export$4709dc300705b2af)(visualElement, variant, options));
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = (0, $8c445c76717d72c0$export$4709dc300705b2af)(visualElement, definition, options);
    else {
        const resolvedDefinition = typeof definition === "function" ? (0, $dfe6a10b7b91d234$export$7b1b1c981f4f0558)(visualElement, definition, options.custom) : definition;
        animation = Promise.all((0, $cbfc21822c188a13$export$68cacfeee78d98d2)(visualElement, resolvedDefinition, options));
    }
    return animation.then(()=>{
        visualElement.notify("AnimationComplete", definition);
    });
}




const $51a01f65a0f496d4$var$numVariantProps = (0, $eb6a0a2a824114cd$export$1405a65085f40b9).length;
function $51a01f65a0f496d4$export$6669f52f7ffa343b(visualElement) {
    if (!visualElement) return undefined;
    if (!visualElement.isControllingVariants) {
        const context = visualElement.parent ? $51a01f65a0f496d4$export$6669f52f7ffa343b(visualElement.parent) || {} : {};
        if (visualElement.props.initial !== undefined) context.initial = visualElement.props.initial;
        return context;
    }
    const context = {};
    for(let i = 0; i < $51a01f65a0f496d4$var$numVariantProps; i++){
        const name = (0, $eb6a0a2a824114cd$export$1405a65085f40b9)[i];
        const prop = visualElement.props[name];
        if ((0, $e4ec7857057a08b6$export$720b90e312cea233)(prop) || prop === false) context[name] = prop;
    }
    return context;
}


const $e4063d3013cf053c$var$reversePriorityOrder = [
    ...(0, $eb6a0a2a824114cd$export$16e45afcc206d3a8)
].reverse();
const $e4063d3013cf053c$var$numAnimationTypes = (0, $eb6a0a2a824114cd$export$16e45afcc206d3a8).length;
function $e4063d3013cf053c$var$animateList(visualElement) {
    return (animations)=>Promise.all(animations.map(({ animation: animation , options: options  })=>(0, $ca7433f5e9b78911$export$ff62cf473653f109)(visualElement, animation, options)));
}
function $e4063d3013cf053c$export$bb53502b7a672aa8(visualElement) {
    let animate = $e4063d3013cf053c$var$animateList(visualElement);
    let state = $e4063d3013cf053c$var$createState();
    let isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ const buildResolvedTypeValues = (type)=>(acc, definition)=>{
            var _a;
            const resolved = (0, $dfe6a10b7b91d234$export$7b1b1c981f4f0558)(visualElement, definition, type === "exit" ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom : undefined);
            if (resolved) {
                const { transition: transition , transitionEnd: transitionEnd , ...target } = resolved;
                acc = {
                    ...acc,
                    ...target,
                    ...transitionEnd
                };
            }
            return acc;
        };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(changedActiveType) {
        const { props: props  } = visualElement;
        const context = (0, $51a01f65a0f496d4$export$6669f52f7ffa343b)(visualElement.parent) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(let i = 0; i < $e4063d3013cf053c$var$numAnimationTypes; i++){
            const type = $e4063d3013cf053c$var$reversePriorityOrder[i];
            const typeState = state[type];
            const prop = props[type] !== undefined ? props[type] : context[type];
            const propIsVariant = (0, $e4ec7857057a08b6$export$720b90e312cea233)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */ if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = {
                ...encounteredKeys
            };
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $6c424f3bd35daf15$export$aa71198ceeaf53ce)(prop) || typeof prop === "boolean") continue;
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ const variantDidChange = $e4063d3013cf053c$export$68651800594fd43c(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            let handledRemovedValues = false;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ const definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ let resolvedValues = definitionList.reduce(buildResolvedTypeValues(type), {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ const { prevResolvedValues: prevResolvedValues = {}  } = typeState;
            const allKeys = {
                ...prevResolvedValues,
                ...resolvedValues
            };
            const markToAnimate = (key)=>{
                shouldAnimateType = true;
                if (removedKeys.has(key)) {
                    handledRemovedValues = true;
                    removedKeys.delete(key);
                }
                typeState.needsAnimating[key] = true;
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = false;
            };
            for(const key in allKeys){
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ let valueHasChanged = false;
                if ((0, $96ae1bfc697c0155$export$9153ad4c4999f4a0)(next) && (0, $96ae1bfc697c0155$export$9153ad4c4999f4a0)(prev)) valueHasChanged = !(0, $b3131a4296a9915c$export$90e866afbd6b9f1a)(next, prev);
                else valueHasChanged = next !== prev;
                if (valueHasChanged) {
                    if (next !== undefined && next !== null) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */ if (typeState.isActive) encounteredKeys = {
                ...encounteredKeys,
                ...resolvedValues
            };
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to skip this animation
             * unless the inherited variants haven't changed on this render.
             */ const willAnimateViaParent = isInherited && variantDidChange;
            const needsAnimating = !willAnimateViaParent || handledRemovedValues;
            if (shouldAnimateType && needsAnimating) animations.push(...definitionList.map((animation)=>({
                    animation: animation,
                    options: {
                        type: type
                    }
                })));
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            const fallbackAnimation = {};
            removedKeys.forEach((key)=>{
                const fallbackTarget = visualElement.getBaseTarget(key);
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = true;
                // @ts-expect-error - @mattgperry to figure if we should do something here
                fallbackAnimation[key] = fallbackTarget !== null && fallbackTarget !== void 0 ? fallbackTarget : null;
            });
            animations.push({
                animation: fallbackAnimation
            });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender && (props.initial === false || props.initial === props.animate) && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach((child)=>{
            var _a;
            return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive);
        });
        state[type].isActive = isActive;
        const animations = animateChanges(type);
        for(const key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: ()=>state,
        reset: ()=>{
            state = $e4063d3013cf053c$var$createState();
            isInitialRender = true;
        }
    };
}
function $e4063d3013cf053c$export$68651800594fd43c(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if (Array.isArray(next)) return !(0, $b3131a4296a9915c$export$90e866afbd6b9f1a)(next, prev);
    return false;
}
function $e4063d3013cf053c$var$createTypeState(isActive = false) {
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $e4063d3013cf053c$var$createState() {
    return {
        animate: $e4063d3013cf053c$var$createTypeState(true),
        whileInView: $e4063d3013cf053c$var$createTypeState(),
        whileHover: $e4063d3013cf053c$var$createTypeState(),
        whileTap: $e4063d3013cf053c$var$createTypeState(),
        whileDrag: $e4063d3013cf053c$var$createTypeState(),
        whileFocus: $e4063d3013cf053c$var$createTypeState(),
        exit: $e4063d3013cf053c$var$createTypeState()
    };
}


class $8c269db61902fb68$export$6e91cf7616333d5 {
    constructor(node){
        this.isMounted = false;
        this.node = node;
    }
    update() {}
}


class $f32e32aeb432bca6$export$b45b3fe5caabdca extends (0, $8c269db61902fb68$export$6e91cf7616333d5) {
    /**
     * We dynamically generate the AnimationState manager as it contains a reference
     * to the underlying animation library. We only want to load that if we load this,
     * so people can optionally code split it out using the `m` component.
     */ constructor(node){
        super(node);
        node.animationState || (node.animationState = (0, $e4063d3013cf053c$export$bb53502b7a672aa8)(node));
    }
    updateAnimationControlsSubscription() {
        const { animate: animate  } = this.node.getProps();
        if ((0, $6c424f3bd35daf15$export$aa71198ceeaf53ce)(animate)) this.unmountControls = animate.subscribe(this.node);
    }
    /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */ mount() {
        this.updateAnimationControlsSubscription();
    }
    update() {
        const { animate: animate  } = this.node.getProps();
        const { animate: prevAnimate  } = this.node.prevProps || {};
        if (animate !== prevAnimate) this.updateAnimationControlsSubscription();
    }
    unmount() {
        var _a;
        this.node.animationState.reset();
        (_a = this.unmountControls) === null || _a === void 0 || _a.call(this);
    }
}



let $a4f717d2e1520e94$var$id = 0;
class $a4f717d2e1520e94$export$4989d1eb6104cc6c extends (0, $8c269db61902fb68$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.id = $a4f717d2e1520e94$var$id++;
    }
    update() {
        if (!this.node.presenceContext) return;
        const { isPresent: isPresent , onExitComplete: onExitComplete  } = this.node.presenceContext;
        const { isPresent: prevIsPresent  } = this.node.prevPresenceContext || {};
        if (!this.node.animationState || isPresent === prevIsPresent) return;
        const exitAnimation = this.node.animationState.setActive("exit", !isPresent);
        if (onExitComplete && !isPresent) exitAnimation.then(()=>onExitComplete(this.id));
    }
    mount() {
        const { register: register  } = this.node.presenceContext || {};
        if (register) this.unmount = register(this.id);
    }
    unmount() {}
}


const $61912b83da9ce72c$export$7f9953c70dacfd7f = {
    animation: {
        Feature: (0, $f32e32aeb432bca6$export$b45b3fe5caabdca)
    },
    exit: {
        Feature: (0, $a4f717d2e1520e94$export$4989d1eb6104cc6c)
    }
};





const $11aaa3516eb4fe3b$export$9e9bc3c487fccc00 = {
    x: false,
    y: false
};
function $11aaa3516eb4fe3b$export$1b3dd616664938e4() {
    return $11aaa3516eb4fe3b$export$9e9bc3c487fccc00.x || $11aaa3516eb4fe3b$export$9e9bc3c487fccc00.y;
}


function $5c6341e39395a445$export$90ceba2564a894f8(elementOrSelector, scope, selectorCache) {
    var _a;
    if (elementOrSelector instanceof Element) return [
        elementOrSelector
    ];
    else if (typeof elementOrSelector === "string") {
        let root = document;
        if (scope) // TODO: Refactor to utils package
        // invariant(
        //     Boolean(scope.current),
        //     "Scope provided, but no element detected."
        // )
        root = scope.current;
        const elements = (_a = selectorCache === null || selectorCache === void 0 ? void 0 : selectorCache[elementOrSelector]) !== null && _a !== void 0 ? _a : root.querySelectorAll(elementOrSelector);
        return elements ? Array.from(elements) : [];
    }
    return Array.from(elementOrSelector);
}


function $c98cdcb0020672a8$export$edc0ace9d5e7e842(elementOrSelector, options) {
    const elements = (0, $5c6341e39395a445$export$90ceba2564a894f8)(elementOrSelector);
    const gestureAbortController = new AbortController();
    const eventOptions = {
        passive: true,
        ...options,
        signal: gestureAbortController.signal
    };
    const cancel = ()=>gestureAbortController.abort();
    return [
        elements,
        eventOptions,
        cancel
    ];
}


/**
 * Filter out events that are not pointer events, or are triggering
 * while a Motion gesture is active.
 */ function $62aebe68f5a3cc52$var$filterEvents(callback) {
    return (event)=>{
        if (event.pointerType === "touch" || (0, $11aaa3516eb4fe3b$export$1b3dd616664938e4)()) return;
        callback(event);
    };
}
/**
 * Create a hover gesture. hover() is different to .addEventListener("pointerenter")
 * in that it has an easier syntax, filters out polyfilled touch events, interoperates
 * with drag gestures, and automatically removes the "pointerennd" event listener when the hover ends.
 *
 * @public
 */ function $62aebe68f5a3cc52$export$3f60957f5dbf3876(elementOrSelector, onHoverStart, options = {}) {
    const [elements, eventOptions, cancel] = (0, $c98cdcb0020672a8$export$edc0ace9d5e7e842)(elementOrSelector, options);
    const onPointerEnter = $62aebe68f5a3cc52$var$filterEvents((enterEvent)=>{
        const { target: target  } = enterEvent;
        const onHoverEnd = onHoverStart(enterEvent);
        if (!onHoverEnd || !target) return;
        const onPointerLeave = $62aebe68f5a3cc52$var$filterEvents((leaveEvent)=>{
            onHoverEnd(leaveEvent);
            target.removeEventListener("pointerleave", onPointerLeave);
        });
        target.addEventListener("pointerleave", onPointerLeave, eventOptions);
    });
    elements.forEach((element)=>{
        element.addEventListener("pointerenter", onPointerEnter, eventOptions);
    });
    return cancel;
}



const $c46cbf3dcf8631f9$export$a4cf9c8a4b063a6e = (event)=>{
    if (event.pointerType === "mouse") return typeof event.button !== "number" || event.button <= 0;
    else /**
         * isPrimary is true for all mice buttons, whereas every touch point
         * is regarded as its own input. So subsequent concurrent touch points
         * will be false.
         *
         * Specifically match against false here as incomplete versions of
         * PointerEvents in very old browser might have it set as undefined.
         */ return event.isPrimary !== false;
};



const $38fc35b2f99bbeec$export$7987404a4e35b84b = new WeakSet();


/**
 * Filter out events that are not "Enter" keys.
 */ function $ec2e5a2e73f36afc$var$filterEvents(callback) {
    return (event)=>{
        if (event.key !== "Enter") return;
        callback(event);
    };
}
function $ec2e5a2e73f36afc$var$firePointerEvent(target, type) {
    target.dispatchEvent(new PointerEvent("pointer" + type, {
        isPrimary: true,
        bubbles: true
    }));
}
const $ec2e5a2e73f36afc$export$4b5790288fe12a79 = (focusEvent, eventOptions)=>{
    const element = focusEvent.currentTarget;
    if (!element) return;
    const handleKeydown = $ec2e5a2e73f36afc$var$filterEvents(()=>{
        if ((0, $38fc35b2f99bbeec$export$7987404a4e35b84b).has(element)) return;
        $ec2e5a2e73f36afc$var$firePointerEvent(element, "down");
        const handleKeyup = $ec2e5a2e73f36afc$var$filterEvents(()=>{
            $ec2e5a2e73f36afc$var$firePointerEvent(element, "up");
        });
        const handleBlur = ()=>$ec2e5a2e73f36afc$var$firePointerEvent(element, "cancel");
        element.addEventListener("keyup", handleKeyup, eventOptions);
        element.addEventListener("blur", handleBlur, eventOptions);
    });
    element.addEventListener("keydown", handleKeydown, eventOptions);
    /**
     * Add an event listener that fires on blur to remove the keydown events.
     */ element.addEventListener("blur", ()=>element.removeEventListener("keydown", handleKeydown), eventOptions);
};


const $9e66ba36736ca475$var$focusableElements = new Set([
    "BUTTON",
    "INPUT",
    "SELECT",
    "TEXTAREA",
    "A"
]);
function $9e66ba36736ca475$export$5f6976e2f961e8b7(element) {
    return $9e66ba36736ca475$var$focusableElements.has(element.tagName) || element.tabIndex !== -1;
}


/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ const $e3dc885e9b4ce990$export$e841ada32ff745b = (parent, child)=>{
    if (!child) return false;
    else if (parent === child) return true;
    else return $e3dc885e9b4ce990$export$e841ada32ff745b(parent, child.parentElement);
};



/**
 * Filter out events that are not primary pointer events, or are triggering
 * while a Motion gesture is active.
 */ function $1fb501146082d657$var$isValidPressEvent(event) {
    return (0, $c46cbf3dcf8631f9$export$a4cf9c8a4b063a6e)(event) && !(0, $11aaa3516eb4fe3b$export$1b3dd616664938e4)();
}
/**
 * Create a press gesture.
 *
 * Press is different to `"pointerdown"`, `"pointerup"` in that it
 * automatically filters out secondary pointer events like right
 * click and multitouch.
 *
 * It also adds accessibility support for keyboards, where
 * an element with a press gesture will receive focus and
 *  trigger on Enter `"keydown"` and `"keyup"` events.
 *
 * This is different to a browser's `"click"` event, which does
 * respond to keyboards but only for the `"click"` itself, rather
 * than the press start and end/cancel. The element also needs
 * to be focusable for this to work, whereas a press gesture will
 * make an element focusable by default.
 *
 * @public
 */ function $1fb501146082d657$export$dbe9198142dace0c(elementOrSelector, onPressStart, options = {}) {
    const [elements, eventOptions, cancelEvents] = (0, $c98cdcb0020672a8$export$edc0ace9d5e7e842)(elementOrSelector, options);
    const startPress = (startEvent)=>{
        const element = startEvent.currentTarget;
        if (!$1fb501146082d657$var$isValidPressEvent(startEvent) || (0, $38fc35b2f99bbeec$export$7987404a4e35b84b).has(element)) return;
        (0, $38fc35b2f99bbeec$export$7987404a4e35b84b).add(element);
        const onPressEnd = onPressStart(startEvent);
        const onPointerEnd = (endEvent, success)=>{
            window.removeEventListener("pointerup", onPointerUp);
            window.removeEventListener("pointercancel", onPointerCancel);
            if (!$1fb501146082d657$var$isValidPressEvent(endEvent) || !(0, $38fc35b2f99bbeec$export$7987404a4e35b84b).has(element)) return;
            (0, $38fc35b2f99bbeec$export$7987404a4e35b84b).delete(element);
            if (onPressEnd) onPressEnd(endEvent, {
                success: success
            });
        };
        const onPointerUp = (upEvent)=>{
            onPointerEnd(upEvent, options.useGlobalTarget || (0, $e3dc885e9b4ce990$export$e841ada32ff745b)(element, upEvent.target));
        };
        const onPointerCancel = (cancelEvent)=>{
            onPointerEnd(cancelEvent, false);
        };
        window.addEventListener("pointerup", onPointerUp, eventOptions);
        window.addEventListener("pointercancel", onPointerCancel, eventOptions);
    };
    elements.forEach((element)=>{
        if (!(0, $9e66ba36736ca475$export$5f6976e2f961e8b7)(element)) element.tabIndex = 0;
        const target = options.useGlobalTarget ? window : element;
        target.addEventListener("pointerdown", startPress, eventOptions);
        element.addEventListener("focus", (event)=>(0, $ec2e5a2e73f36afc$export$4b5790288fe12a79)(event, eventOptions), eventOptions);
    });
    return cancelEvents;
}





function $7a2dafd130edc18a$export$64d8a3fd7eb621d5(axis) {
    if (axis === "x" || axis === "y") {
        if ((0, $11aaa3516eb4fe3b$export$9e9bc3c487fccc00)[axis]) return null;
        else {
            (0, $11aaa3516eb4fe3b$export$9e9bc3c487fccc00)[axis] = true;
            return ()=>{
                (0, $11aaa3516eb4fe3b$export$9e9bc3c487fccc00)[axis] = false;
            };
        }
    } else {
        if ((0, $11aaa3516eb4fe3b$export$9e9bc3c487fccc00).x || (0, $11aaa3516eb4fe3b$export$9e9bc3c487fccc00).y) return null;
        else {
            (0, $11aaa3516eb4fe3b$export$9e9bc3c487fccc00).x = (0, $11aaa3516eb4fe3b$export$9e9bc3c487fccc00).y = true;
            return ()=>{
                (0, $11aaa3516eb4fe3b$export$9e9bc3c487fccc00).x = (0, $11aaa3516eb4fe3b$export$9e9bc3c487fccc00).y = false;
            };
        }
    }
}







function $c20245f8d567b28b$export$12f84bb882d06e1a(event) {
    return {
        point: {
            x: event.pageX,
            y: event.pageY
        }
    };
}
const $c20245f8d567b28b$export$c404e80f92c98d29 = (handler)=>{
    return (event)=>(0, $c46cbf3dcf8631f9$export$a4cf9c8a4b063a6e)(event) && handler(event, $c20245f8d567b28b$export$12f84bb882d06e1a(event));
};



function $5727f053dc302d4d$export$b1d829ddf82884aa(target, eventName, handler, options = {
    passive: true
}) {
    target.addEventListener(eventName, handler, options);
    return ()=>target.removeEventListener(eventName, handler);
}



function $149813d40ccb6fe7$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $5727f053dc302d4d$export$b1d829ddf82884aa)(target, eventName, (0, $c20245f8d567b28b$export$c404e80f92c98d29)(handler), options);
}



const $d4f8ff7f023adf4a$export$9f17032d917177de = (a, b)=>Math.abs(a - b);
function $d4f8ff7f023adf4a$export$503a1d513f12e38b(a, b) {
    // Multi-dimensional
    const xDelta = $d4f8ff7f023adf4a$export$9f17032d917177de(a.x, b.x);
    const yDelta = $d4f8ff7f023adf4a$export$9f17032d917177de(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}




/**
 * @internal
 */ class $f05cb07b67532e20$export$d9c66232c9c4689c {
    constructor(event, handlers, { transformPagePoint: transformPagePoint , contextWindow: contextWindow , dragSnapToOrigin: dragSnapToOrigin = false  } = {}){
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        /**
         * @internal
         */ this.contextWindow = window;
        this.updatePoint = ()=>{
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const info = $f05cb07b67532e20$var$getPanInfo(this.lastMoveEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            const isDistancePastThreshold = (0, $d4f8ff7f023adf4a$export$503a1d513f12e38b)(info.offset, {
                x: 0,
                y: 0
            }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold) return;
            const { point: point  } = info;
            const { timestamp: timestamp  } = (0, $6491bdd13544fdda$export$fff89137e9e818ce);
            this.history.push({
                ...point,
                timestamp: timestamp
            });
            const { onStart: onStart , onMove: onMove  } = this.handlers;
            if (!isPanStarted) {
                onStart && onStart(this.lastMoveEvent, info);
                this.startEvent = this.lastMoveEvent;
            }
            onMove && onMove(this.lastMoveEvent, info);
        };
        this.handlePointerMove = (event, info)=>{
            this.lastMoveEvent = event;
            this.lastMoveEventInfo = $f05cb07b67532e20$var$transformPoint(info, this.transformPagePoint);
            // Throttle mouse move event to once per frame
            (0, $6491bdd13544fdda$export$2cef06c20297c17d).update(this.updatePoint, true);
        };
        this.handlePointerUp = (event, info)=>{
            this.end();
            const { onEnd: onEnd , onSessionEnd: onSessionEnd , resumeAnimation: resumeAnimation  } = this.handlers;
            if (this.dragSnapToOrigin) resumeAnimation && resumeAnimation();
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const panInfo = $f05cb07b67532e20$var$getPanInfo(event.type === "pointercancel" ? this.lastMoveEventInfo : $f05cb07b67532e20$var$transformPoint(info, this.transformPagePoint), this.history);
            if (this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (!(0, $c46cbf3dcf8631f9$export$a4cf9c8a4b063a6e)(event)) return;
        this.dragSnapToOrigin = dragSnapToOrigin;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        this.contextWindow = contextWindow || window;
        const info = (0, $c20245f8d567b28b$export$12f84bb882d06e1a)(event);
        const initialInfo = $f05cb07b67532e20$var$transformPoint(info, this.transformPagePoint);
        const { point: point  } = initialInfo;
        const { timestamp: timestamp  } = (0, $6491bdd13544fdda$export$fff89137e9e818ce);
        this.history = [
            {
                ...point,
                timestamp: timestamp
            }
        ];
        const { onSessionStart: onSessionStart  } = handlers;
        onSessionStart && onSessionStart(event, $f05cb07b67532e20$var$getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, $6cc9e4dbba39be5c$export$a4627e546088548d)((0, $149813d40ccb6fe7$export$fcff2e64e6676b81)(this.contextWindow, "pointermove", this.handlePointerMove), (0, $149813d40ccb6fe7$export$fcff2e64e6676b81)(this.contextWindow, "pointerup", this.handlePointerUp), (0, $149813d40ccb6fe7$export$fcff2e64e6676b81)(this.contextWindow, "pointercancel", this.handlePointerUp));
    }
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        this.removeListeners && this.removeListeners();
        (0, $6491bdd13544fdda$export$ec99c0ef4978dccb)(this.updatePoint);
    }
}
function $f05cb07b67532e20$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $f05cb07b67532e20$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $f05cb07b67532e20$var$getPanInfo({ point: point  }, history) {
    return {
        point: point,
        delta: $f05cb07b67532e20$var$subtractPoint(point, $f05cb07b67532e20$var$lastDevicePoint(history)),
        offset: $f05cb07b67532e20$var$subtractPoint(point, $f05cb07b67532e20$var$startDevicePoint(history)),
        velocity: $f05cb07b67532e20$var$getVelocity(history, 0.1)
    };
}
function $f05cb07b67532e20$var$startDevicePoint(history) {
    return history[0];
}
function $f05cb07b67532e20$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $f05cb07b67532e20$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = $f05cb07b67532e20$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $631bdbca8ed9a472$export$fc3e7e8557f8c8c7)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    const time = (0, $631bdbca8ed9a472$export$f64c3bfbc58eec0f)(lastPoint.timestamp - timestampedPoint.timestamp);
    if (time === 0) return {
        x: 0,
        y: 0
    };
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}


function $0dc8dc297bc3aa83$export$dedd81df7bc1307(ref) {
    return ref && typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}





const $d9901b0e7f584a90$var$SCALE_PRECISION = 0.0001;
const $d9901b0e7f584a90$var$SCALE_MIN = 1 - $d9901b0e7f584a90$var$SCALE_PRECISION;
const $d9901b0e7f584a90$var$SCALE_MAX = 1 + $d9901b0e7f584a90$var$SCALE_PRECISION;
const $d9901b0e7f584a90$var$TRANSLATE_PRECISION = 0.01;
const $d9901b0e7f584a90$var$TRANSLATE_MIN = 0 - $d9901b0e7f584a90$var$TRANSLATE_PRECISION;
const $d9901b0e7f584a90$var$TRANSLATE_MAX = 0 + $d9901b0e7f584a90$var$TRANSLATE_PRECISION;
function $d9901b0e7f584a90$export$c1c127004b72a37(axis) {
    return axis.max - axis.min;
}
function $d9901b0e7f584a90$export$28d0384c4b79bde2(value, target, maxDistance) {
    return Math.abs(value - target) <= maxDistance;
}
function $d9901b0e7f584a90$export$e90fc1ae5e3e48ed(delta, source, target, origin = 0.5) {
    delta.origin = origin;
    delta.originPoint = (0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(source.min, source.max, delta.origin);
    delta.scale = $d9901b0e7f584a90$export$c1c127004b72a37(target) / $d9901b0e7f584a90$export$c1c127004b72a37(source);
    delta.translate = (0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(target.min, target.max, delta.origin) - delta.originPoint;
    if (delta.scale >= $d9901b0e7f584a90$var$SCALE_MIN && delta.scale <= $d9901b0e7f584a90$var$SCALE_MAX || isNaN(delta.scale)) delta.scale = 1.0;
    if (delta.translate >= $d9901b0e7f584a90$var$TRANSLATE_MIN && delta.translate <= $d9901b0e7f584a90$var$TRANSLATE_MAX || isNaN(delta.translate)) delta.translate = 0.0;
}
function $d9901b0e7f584a90$export$c0d25e96fc67d310(delta, source, target, origin) {
    $d9901b0e7f584a90$export$e90fc1ae5e3e48ed(delta.x, source.x, target.x, origin ? origin.originX : undefined);
    $d9901b0e7f584a90$export$e90fc1ae5e3e48ed(delta.y, source.y, target.y, origin ? origin.originY : undefined);
}
function $d9901b0e7f584a90$export$cabef5b392704b41(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + $d9901b0e7f584a90$export$c1c127004b72a37(relative);
}
function $d9901b0e7f584a90$export$426154f9d100f99(target, relative, parent) {
    $d9901b0e7f584a90$export$cabef5b392704b41(target.x, relative.x, parent.x);
    $d9901b0e7f584a90$export$cabef5b392704b41(target.y, relative.y, parent.y);
}
function $d9901b0e7f584a90$export$ecd3d3bef81102c3(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + $d9901b0e7f584a90$export$c1c127004b72a37(layout);
}
function $d9901b0e7f584a90$export$2785bfcc929c5650(target, layout, parent) {
    $d9901b0e7f584a90$export$ecd3d3bef81102c3(target.x, layout.x, parent.x);
    $d9901b0e7f584a90$export$ecd3d3bef81102c3(target.y, layout.y, parent.y);
}




/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $e4bc4f9b398dfeb3$export$b3c764d3fca3ffe3(point, { min: min , max: max  }, elastic) {
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $e4bc4f9b398dfeb3$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $e4bc4f9b398dfeb3$export$4e9195bf7793bc78(layoutBox, { top: top , left: left , bottom: bottom , right: right  }) {
    return {
        x: $e4bc4f9b398dfeb3$export$690c180aa5775042(layoutBox.x, left, right),
        y: $e4bc4f9b398dfeb3$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $e4bc4f9b398dfeb3$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    let min = constraintsAxis.min - layoutAxis.min;
    let max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) [min, max] = [
        max,
        min
    ];
    return {
        min: min,
        max: max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $e4bc4f9b398dfeb3$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $e4bc4f9b398dfeb3$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $e4bc4f9b398dfeb3$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function $e4bc4f9b398dfeb3$export$13abbfca044ca46d(source, target) {
    let origin = 0.5;
    const sourceLength = (0, $d9901b0e7f584a90$export$c1c127004b72a37)(source);
    const targetLength = (0, $d9901b0e7f584a90$export$c1c127004b72a37)(target);
    if (targetLength > sourceLength) origin = (0, $e6e94e48128648b0$export$504d7abb21fa8c9)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, $e6e94e48128648b0$export$504d7abb21fa8c9)(source.min, source.max - targetLength, target.min);
    return (0, $bb2cd2f4425aee0a$export$7d15b64cf5a3a4c4)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $e4bc4f9b398dfeb3$export$e9672cc4c36a8b87(layout, constraints) {
    const relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
const $e4bc4f9b398dfeb3$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $e4bc4f9b398dfeb3$export$7c5eaef8f4723d22(dragElastic = $e4bc4f9b398dfeb3$export$a3366d3bac43a742) {
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $e4bc4f9b398dfeb3$export$a3366d3bac43a742;
    return {
        x: $e4bc4f9b398dfeb3$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $e4bc4f9b398dfeb3$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $e4bc4f9b398dfeb3$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $e4bc4f9b398dfeb3$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $e4bc4f9b398dfeb3$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $e4bc4f9b398dfeb3$export$bbbc10b82e6c0afb(dragElastic, label) {
    return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}


const $93b39ae61dedc877$export$ff25708b37f72782 = ()=>({
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    });
const $93b39ae61dedc877$export$3d227df54007d73a = ()=>({
        x: $93b39ae61dedc877$export$ff25708b37f72782(),
        y: $93b39ae61dedc877$export$ff25708b37f72782()
    });
const $93b39ae61dedc877$export$6db76765312617ac = ()=>({
        min: 0,
        max: 0
    });
const $93b39ae61dedc877$export$6459fc9e86be362e = ()=>({
        x: $93b39ae61dedc877$export$6db76765312617ac(),
        y: $93b39ae61dedc877$export$6db76765312617ac()
    });


function $c68037220032f1d8$export$b789de563eb43b1(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}


/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $040c3e7ac51c9eb3$export$d3955c6a8f65a36b({ top: top , left: left , right: right , bottom: bottom  }) {
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $040c3e7ac51c9eb3$export$b6b9cd4198191a47({ x: x , y: y  }) {
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $040c3e7ac51c9eb3$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    const topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    const bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}



function $fed21f2a9fad1fb9$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $fed21f2a9fad1fb9$export$bdf30dca883ea463({ scale: scale , scaleX: scaleX , scaleY: scaleY  }) {
    return !$fed21f2a9fad1fb9$var$isIdentityScale(scale) || !$fed21f2a9fad1fb9$var$isIdentityScale(scaleX) || !$fed21f2a9fad1fb9$var$isIdentityScale(scaleY);
}
function $fed21f2a9fad1fb9$export$a545127cf1fbb600(values) {
    return $fed21f2a9fad1fb9$export$bdf30dca883ea463(values) || $fed21f2a9fad1fb9$export$bf80f5f8f4dc327f(values) || values.z || values.rotate || values.rotateX || values.rotateY || values.skewX || values.skewY;
}
function $fed21f2a9fad1fb9$export$bf80f5f8f4dc327f(values) {
    return $fed21f2a9fad1fb9$var$is2DTranslate(values.x) || $fed21f2a9fad1fb9$var$is2DTranslate(values.y);
}
function $fed21f2a9fad1fb9$var$is2DTranslate(value) {
    return value && value !== "0%";
}


/**
 * Scales a point based on a factor and an originPoint
 */ function $4c951bbfa32a6f81$export$2290ec7febe36dd6(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $4c951bbfa32a6f81$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $4c951bbfa32a6f81$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $4c951bbfa32a6f81$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $4c951bbfa32a6f81$export$e8e3a712e9ebf422(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = $4c951bbfa32a6f81$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $4c951bbfa32a6f81$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $4c951bbfa32a6f81$export$d80074982803af5c(box, { x: x , y: y  }) {
    $4c951bbfa32a6f81$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $4c951bbfa32a6f81$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
const $4c951bbfa32a6f81$var$TREE_SCALE_SNAP_MIN = 0.999999999999;
const $4c951bbfa32a6f81$var$TREE_SCALE_SNAP_MAX = 1.0000000000001;
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $4c951bbfa32a6f81$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition = false) {
    const treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for(let i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ const { visualElement: visualElement  } = node.options;
        if (visualElement && visualElement.props.style && visualElement.props.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) $4c951bbfa32a6f81$export$58b16271041fbfb(box, {
            x: -node.scroll.offset.x,
            y: -node.scroll.offset.y
        });
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $4c951bbfa32a6f81$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $fed21f2a9fad1fb9$export$a545127cf1fbb600)(node.latestValues)) $4c951bbfa32a6f81$export$58b16271041fbfb(box, node.latestValues);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ if (treeScale.x < $4c951bbfa32a6f81$var$TREE_SCALE_SNAP_MAX && treeScale.x > $4c951bbfa32a6f81$var$TREE_SCALE_SNAP_MIN) treeScale.x = 1.0;
    if (treeScale.y < $4c951bbfa32a6f81$var$TREE_SCALE_SNAP_MAX && treeScale.y > $4c951bbfa32a6f81$var$TREE_SCALE_SNAP_MIN) treeScale.y = 1.0;
}
function $4c951bbfa32a6f81$export$a807a5ce5ebb3895(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $4c951bbfa32a6f81$export$625f1dd140a2f5e7(axis, axisTranslate, axisScale, boxScale, axisOrigin = 0.5) {
    const originPoint = (0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $4c951bbfa32a6f81$export$e8e3a712e9ebf422(axis, axisTranslate, axisScale, originPoint, boxScale);
}
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $4c951bbfa32a6f81$export$58b16271041fbfb(box, transform) {
    $4c951bbfa32a6f81$export$625f1dd140a2f5e7(box.x, transform.x, transform.scaleX, transform.scale, transform.originX);
    $4c951bbfa32a6f81$export$625f1dd140a2f5e7(box.y, transform.y, transform.scaleY, transform.scale, transform.originY);
}


function $0b2600dd2e3d7275$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $040c3e7ac51c9eb3$export$d3955c6a8f65a36b)((0, $040c3e7ac51c9eb3$export$21543fb75483a50)(instance.getBoundingClientRect(), transformPoint));
}
function $0b2600dd2e3d7275$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = $0b2600dd2e3d7275$export$d8718b6a7e5c624e(element, transformPagePoint);
    const { scroll: scroll  } = rootProjectionNode;
    if (scroll) {
        (0, $4c951bbfa32a6f81$export$a807a5ce5ebb3895)(viewportBox.x, scroll.offset.x);
        (0, $4c951bbfa32a6f81$export$a807a5ce5ebb3895)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}









// Fixes https://github.com/motiondivision/motion/issues/2270
const $1a5cc9ddc6d87d3a$export$d533d84f9871c879 = ({ current: current  })=>{
    return current ? current.ownerDocument.defaultView : null;
};




const $0ba13f75c89670e3$export$f0a15892c27dc07c = new WeakMap();
/**
 *
 */ // let latestPointerEvent: PointerEvent
class $0ba13f75c89670e3$export$86bff71f18910307 {
    constructor(visualElement){
        this.openDragLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
        this.visualElement = visualElement;
    }
    start(originEvent, { snapToCursor: snapToCursor = false  } = {}) {
        /**
         * Don't start dragging if this component is exiting
         */ const { presenceContext: presenceContext  } = this.visualElement;
        if (presenceContext && presenceContext.isPresent === false) return;
        const onSessionStart = (event)=>{
            const { dragSnapToOrigin: dragSnapToOrigin  } = this.getProps();
            // Stop or pause any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            dragSnapToOrigin ? this.pauseAnimation() : this.stopAnimation();
            if (snapToCursor) this.snapToCursor((0, $c20245f8d567b28b$export$12f84bb882d06e1a)(event).point);
        };
        const onStart = (event, info)=>{
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            const { drag: drag , dragPropagation: dragPropagation , onDragStart: onDragStart  } = this.getProps();
            if (drag && !dragPropagation) {
                if (this.openDragLock) this.openDragLock();
                this.openDragLock = (0, $7a2dafd130edc18a$export$64d8a3fd7eb621d5)(drag);
                // If we don 't have the lock, don't start dragging
                if (!this.openDragLock) return;
            }
            this.isDragging = true;
            this.currentDirection = null;
            this.resolveConstraints();
            if (this.visualElement.projection) {
                this.visualElement.projection.isAnimationBlocked = true;
                this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin
             */ (0, $c68037220032f1d8$export$b789de563eb43b1)((axis)=>{
                let current = this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */ if ((0, $ee89500f7aaa2f56$export$626336c2cd4b14de).test(current)) {
                    const { projection: projection  } = this.visualElement;
                    if (projection && projection.layout) {
                        const measuredAxis = projection.layout.layoutBox[axis];
                        if (measuredAxis) {
                            const length = (0, $d9901b0e7f584a90$export$c1c127004b72a37)(measuredAxis);
                            current = length * (parseFloat(current) / 100);
                        }
                    }
                }
                this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            if (onDragStart) (0, $6491bdd13544fdda$export$2cef06c20297c17d).postRender(()=>onDragStart(event, info));
            (0, $bd95401810c788ae$export$3ac5aed310be0bee)(this.visualElement, "transform");
            const { animationState: animationState  } = this.visualElement;
            animationState && animationState.setActive("whileDrag", true);
        };
        const onMove = (event, info)=>{
            // latestPointerEvent = event
            const { dragPropagation: dragPropagation , dragDirectionLock: dragDirectionLock , onDirectionLock: onDirectionLock , onDrag: onDrag  } = this.getProps();
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !this.openDragLock) return;
            const { offset: offset  } = info;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && this.currentDirection === null) {
                this.currentDirection = $0ba13f75c89670e3$var$getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (this.currentDirection !== null) onDirectionLock && onDirectionLock(this.currentDirection);
                return;
            }
            // Update each point with the latest position
            this.updateAxis("x", info.point, offset);
            this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ this.visualElement.render();
            /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */ onDrag && onDrag(event, info);
        };
        const onSessionEnd = (event, info)=>this.stop(event, info);
        const resumeAnimation = ()=>(0, $c68037220032f1d8$export$b789de563eb43b1)((axis)=>{
                var _a;
                return this.getAnimationState(axis) === "paused" && ((_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.play());
            });
        const { dragSnapToOrigin: dragSnapToOrigin  } = this.getProps();
        this.panSession = new (0, $f05cb07b67532e20$export$d9c66232c9c4689c)(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd,
            resumeAnimation: resumeAnimation
        }, {
            transformPagePoint: this.visualElement.getTransformPagePoint(),
            dragSnapToOrigin: dragSnapToOrigin,
            contextWindow: (0, $1a5cc9ddc6d87d3a$export$d533d84f9871c879)(this.visualElement)
        });
    }
    stop(event, info) {
        const isDragging = this.isDragging;
        this.cancel();
        if (!isDragging) return;
        const { velocity: velocity  } = info;
        this.startAnimation(velocity);
        const { onDragEnd: onDragEnd  } = this.getProps();
        if (onDragEnd) (0, $6491bdd13544fdda$export$2cef06c20297c17d).postRender(()=>onDragEnd(event, info));
    }
    cancel() {
        this.isDragging = false;
        const { projection: projection , animationState: animationState  } = this.visualElement;
        if (projection) projection.isAnimationBlocked = false;
        this.panSession && this.panSession.end();
        this.panSession = undefined;
        const { dragPropagation: dragPropagation  } = this.getProps();
        if (!dragPropagation && this.openDragLock) {
            this.openDragLock();
            this.openDragLock = null;
        }
        animationState && animationState.setActive("whileDrag", false);
    }
    updateAxis(axis, _point, offset) {
        const { drag: drag  } = this.getProps();
        // If we're not dragging this axis, do an early return.
        if (!offset || !$0ba13f75c89670e3$var$shouldDrag(axis, drag, this.currentDirection)) return;
        const axisValue = this.getAxisMotionValue(axis);
        let next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) next = (0, $e4bc4f9b398dfeb3$export$b3c764d3fca3ffe3)(next, this.constraints[axis], this.elastic[axis]);
        axisValue.set(next);
    }
    resolveConstraints() {
        var _a;
        const { dragConstraints: dragConstraints , dragElastic: dragElastic  } = this.getProps();
        const layout = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(false) : (_a = this.visualElement.projection) === null || _a === void 0 ? void 0 : _a.layout;
        const prevConstraints = this.constraints;
        if (dragConstraints && (0, $0dc8dc297bc3aa83$export$dedd81df7bc1307)(dragConstraints)) {
            if (!this.constraints) this.constraints = this.resolveRefConstraints();
        } else if (dragConstraints && layout) this.constraints = (0, $e4bc4f9b398dfeb3$export$4e9195bf7793bc78)(layout.layoutBox, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, $e4bc4f9b398dfeb3$export$7c5eaef8f4723d22)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */ if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) (0, $c68037220032f1d8$export$b789de563eb43b1)((axis)=>{
            if (this.constraints !== false && this.getAxisMotionValue(axis)) this.constraints[axis] = (0, $e4bc4f9b398dfeb3$export$e9672cc4c36a8b87)(layout.layoutBox[axis], this.constraints[axis]);
        });
    }
    resolveRefConstraints() {
        const { dragConstraints: constraints , onMeasureDragConstraints: onMeasureDragConstraints  } = this.getProps();
        if (!constraints || !(0, $0dc8dc297bc3aa83$export$dedd81df7bc1307)(constraints)) return false;
        const constraintsElement = constraints.current;
        (0, $af7e1b70fef19820$export$f5708dca728d7177)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        const { projection: projection  } = this.visualElement;
        // TODO
        if (!projection || !projection.layout) return false;
        const constraintsBox = (0, $0b2600dd2e3d7275$export$6a597be7a7940a96)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        let measuredConstraints = (0, $e4bc4f9b398dfeb3$export$4228500f19d4cdf7)(projection.layout.layoutBox, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            const userConstraints = onMeasureDragConstraints((0, $040c3e7ac51c9eb3$export$b6b9cd4198191a47)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, $040c3e7ac51c9eb3$export$d3955c6a8f65a36b)(userConstraints);
        }
        return measuredConstraints;
    }
    startAnimation(velocity) {
        const { drag: drag , dragMomentum: dragMomentum , dragElastic: dragElastic , dragTransition: dragTransition , dragSnapToOrigin: dragSnapToOrigin , onDragTransitionEnd: onDragTransitionEnd  } = this.getProps();
        const constraints = this.constraints || {};
        const momentumAnimations = (0, $c68037220032f1d8$export$b789de563eb43b1)((axis)=>{
            if (!$0ba13f75c89670e3$var$shouldDrag(axis, drag, this.currentDirection)) return;
            let transition = constraints && constraints[axis] || {};
            if (dragSnapToOrigin) transition = {
                min: 0,
                max: 0
            };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ const bounceStiffness = dragElastic ? 200 : 1000000;
            const bounceDamping = dragElastic ? 40 : 10000000;
            const inertia = {
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10,
                ...dragTransition,
                ...transition
            };
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
    startAxisValueAnimation(axis, transition) {
        const axisValue = this.getAxisMotionValue(axis);
        (0, $bd95401810c788ae$export$3ac5aed310be0bee)(this.visualElement, axis);
        return axisValue.start((0, $3431270835958863$export$90b3dfc33ff3548)(axis, axisValue, 0, transition, this.visualElement, false));
    }
    stopAnimation() {
        (0, $c68037220032f1d8$export$b789de563eb43b1)((axis)=>this.getAxisMotionValue(axis).stop());
    }
    pauseAnimation() {
        (0, $c68037220032f1d8$export$b789de563eb43b1)((axis)=>{
            var _a;
            return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.pause();
        });
    }
    getAnimationState(axis) {
        var _a;
        return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.state;
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ getAxisMotionValue(axis) {
        const dragKey = `_drag${axis.toUpperCase()}`;
        const props = this.visualElement.getProps();
        const externalMotionValue = props[dragKey];
        return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (props.initial ? props.initial[axis] : undefined) || 0);
    }
    snapToCursor(point) {
        (0, $c68037220032f1d8$export$b789de563eb43b1)((axis)=>{
            const { drag: drag  } = this.getProps();
            // If we're not dragging this axis, do an early return.
            if (!$0ba13f75c89670e3$var$shouldDrag(axis, drag, this.currentDirection)) return;
            const { projection: projection  } = this.visualElement;
            const axisValue = this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                const { min: min , max: max  } = projection.layout.layoutBox[axis];
                axisValue.set(point[axis] - (0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(min, max, 0.5));
            }
        });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ scalePositionWithinConstraints() {
        if (!this.visualElement.current) return;
        const { drag: drag , dragConstraints: dragConstraints  } = this.getProps();
        const { projection: projection  } = this.visualElement;
        if (!(0, $0dc8dc297bc3aa83$export$dedd81df7bc1307)(dragConstraints) || !projection || !this.constraints) return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ const boxProgress = {
            x: 0,
            y: 0
        };
        (0, $c68037220032f1d8$export$b789de563eb43b1)((axis)=>{
            const axisValue = this.getAxisMotionValue(axis);
            if (axisValue && this.constraints !== false) {
                const latest = axisValue.get();
                boxProgress[axis] = (0, $e4bc4f9b398dfeb3$export$13abbfca044ca46d)({
                    min: latest,
                    max: latest
                }, this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */ const { transformTemplate: transformTemplate  } = this.visualElement.getProps();
        this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        projection.root && projection.root.updateScroll();
        projection.updateLayout();
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ (0, $c68037220032f1d8$export$b789de563eb43b1)((axis)=>{
            if (!$0ba13f75c89670e3$var$shouldDrag(axis, drag, null)) return;
            /**
             * Calculate a new transform based on the previous box progress
             */ const axisValue = this.getAxisMotionValue(axis);
            const { min: min , max: max  } = this.constraints[axis];
            axisValue.set((0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(min, max, boxProgress[axis]));
        });
    }
    addListeners() {
        if (!this.visualElement.current) return;
        $0ba13f75c89670e3$export$f0a15892c27dc07c.set(this.visualElement, this);
        const element = this.visualElement.current;
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ const stopPointerListener = (0, $149813d40ccb6fe7$export$fcff2e64e6676b81)(element, "pointerdown", (event)=>{
            const { drag: drag , dragListener: dragListener = true  } = this.getProps();
            drag && dragListener && this.start(event);
        });
        const measureDragConstraints = ()=>{
            const { dragConstraints: dragConstraints  } = this.getProps();
            if ((0, $0dc8dc297bc3aa83$export$dedd81df7bc1307)(dragConstraints) && dragConstraints.current) this.constraints = this.resolveRefConstraints();
        };
        const { projection: projection  } = this.visualElement;
        const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            projection.root && projection.root.updateScroll();
            projection.updateLayout();
        }
        (0, $6491bdd13544fdda$export$2cef06c20297c17d).read(measureDragConstraints);
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ const stopResizeListener = (0, $5727f053dc302d4d$export$b1d829ddf82884aa)(window, "resize", ()=>this.scalePositionWithinConstraints());
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ const stopLayoutUpdateListener = projection.addEventListener("didUpdate", ({ delta: delta , hasLayoutChanged: hasLayoutChanged  })=>{
            if (this.isDragging && hasLayoutChanged) {
                (0, $c68037220032f1d8$export$b789de563eb43b1)((axis)=>{
                    const motionValue = this.getAxisMotionValue(axis);
                    if (!motionValue) return;
                    this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                this.visualElement.render();
            }
        });
        return ()=>{
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
            stopLayoutUpdateListener && stopLayoutUpdateListener();
        };
    }
    getProps() {
        const props = this.visualElement.getProps();
        const { drag: drag = false , dragDirectionLock: dragDirectionLock = false , dragPropagation: dragPropagation = false , dragConstraints: dragConstraints = false , dragElastic: dragElastic = (0, $e4bc4f9b398dfeb3$export$a3366d3bac43a742) , dragMomentum: dragMomentum = true  } = props;
        return {
            ...props,
            drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum
        };
    }
}
function $0ba13f75c89670e3$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $0ba13f75c89670e3$var$getCurrentDirection(offset, lockThreshold = 10) {
    let direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}


class $012c82f716440bf2$export$5d97dc2872682820 extends (0, $8c269db61902fb68$export$6e91cf7616333d5) {
    constructor(node){
        super(node);
        this.removeGroupControls = (0, $c13dd6518645747b$export$8793edee2d425525);
        this.removeListeners = (0, $c13dd6518645747b$export$8793edee2d425525);
        this.controls = new (0, $0ba13f75c89670e3$export$86bff71f18910307)(node);
    }
    mount() {
        // If we've been provided a DragControls for manual control over the drag gesture,
        // subscribe this component to it on mount.
        const { dragControls: dragControls  } = this.node.getProps();
        if (dragControls) this.removeGroupControls = dragControls.subscribe(this.controls);
        this.removeListeners = this.controls.addListeners() || (0, $c13dd6518645747b$export$8793edee2d425525);
    }
    unmount() {
        this.removeGroupControls();
        this.removeListeners();
    }
}








const $a23e02b288283422$var$asyncHandler = (handler)=>(event, info)=>{
        if (handler) (0, $6491bdd13544fdda$export$2cef06c20297c17d).postRender(()=>handler(event, info));
    };
class $a23e02b288283422$export$b4f8f1ee75ce5859 extends (0, $8c269db61902fb68$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.removePointerDownListener = (0, $c13dd6518645747b$export$8793edee2d425525);
    }
    onPointerDown(pointerDownEvent) {
        this.session = new (0, $f05cb07b67532e20$export$d9c66232c9c4689c)(pointerDownEvent, this.createPanHandlers(), {
            transformPagePoint: this.node.getTransformPagePoint(),
            contextWindow: (0, $1a5cc9ddc6d87d3a$export$d533d84f9871c879)(this.node)
        });
    }
    createPanHandlers() {
        const { onPanSessionStart: onPanSessionStart , onPanStart: onPanStart , onPan: onPan , onPanEnd: onPanEnd  } = this.node.getProps();
        return {
            onSessionStart: $a23e02b288283422$var$asyncHandler(onPanSessionStart),
            onStart: $a23e02b288283422$var$asyncHandler(onPanStart),
            onMove: onPan,
            onEnd: (event, info)=>{
                delete this.session;
                if (onPanEnd) (0, $6491bdd13544fdda$export$2cef06c20297c17d).postRender(()=>onPanEnd(event, info));
            }
        };
    }
    mount() {
        this.removePointerDownListener = (0, $149813d40ccb6fe7$export$fcff2e64e6676b81)(this.node.current, "pointerdown", (event)=>this.onPointerDown(event));
    }
    update() {
        this.session && this.session.updateHandlers(this.createPanHandlers());
    }
    unmount() {
        this.removePointerDownListener();
        this.session && this.session.end();
    }
}




var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");
"use client";
/**
 * @public
 */ const $12e60920c2394b39$export$f224e4635b6f8ce2 = (0, $bh6RR.createContext)(null);


/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $11db8f3094dfc6f1$export$2a8c16d82a0a0e26() {
    const context = (0, $bh6RR.useContext)((0, $12e60920c2394b39$export$f224e4635b6f8ce2));
    if (context === null) return [
        true,
        null
    ];
    const { isPresent: isPresent , onExitComplete: onExitComplete , register: register  } = context;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    const id = (0, $bh6RR.useId)();
    (0, $bh6RR.useEffect)(()=>register(id), []);
    const safeToRemove = (0, $bh6RR.useCallback)(()=>onExitComplete && onExitComplete(id), [
        id,
        onExitComplete
    ]);
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $11db8f3094dfc6f1$export$8249053f690ea39a() {
    return $11db8f3094dfc6f1$export$ee27c052bca048fb((0, $bh6RR.useContext)((0, $12e60920c2394b39$export$f224e4635b6f8ce2)));
}
function $11db8f3094dfc6f1$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}



var $bh6RR = parcelRequire("bh6RR");
"use client";
const $364741b44296b530$export$a3579ca508007a95 = (0, $bh6RR.createContext)({});



var $bh6RR = parcelRequire("bh6RR");
"use client";
/**
 * Internal, exported only for usage in Framer
 */ const $b8a0e6b50203ba18$export$da5f7b802957459a = (0, $bh6RR.createContext)({});


/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ const $fb51e1392d812b31$export$97db156a3ed1593b = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};



function $e543877808356f59$export$fafff692be55225d(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ const $e543877808356f59$export$5eafb6257a5844c = {
    correct: (latest, node)=>{
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, $ee89500f7aaa2f56$export$91c0eda1d06bf008).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ const x = $e543877808356f59$export$fafff692be55225d(latest, node.target.x);
        const y = $e543877808356f59$export$fafff692be55225d(latest, node.target.y);
        return `${x}% ${y}%`;
    }
};




const $2e837016dedbf14e$export$eb0bc629e74dcf8 = {
    correct: (latest, { treeScale: treeScale , projectionDelta: projectionDelta  })=>{
        const original = latest;
        const shadow = (0, $a554c66132092e1c$export$83a0e34f1302825b).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        const template = (0, $a554c66132092e1c$export$83a0e34f1302825b).createTransformer(latest);
        const offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        const xScale = projectionDelta.x.scale * treeScale.x;
        const yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ const averageScale = (0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        return template(shadow);
    }
};


const $93233d74f0d10a65$export$91ddd985b97788d1 = {};
function $93233d74f0d10a65$export$de9e7791c71225fd(correctors) {
    Object.assign($93233d74f0d10a65$export$91ddd985b97788d1, correctors);
}



const { schedule: $3858c82cd1ca695a$export$bb76eed83315504c , cancel: $3858c82cd1ca695a$export$3252729004b8456e  } = (0, $3c9d516863748892$export$510b0596a933801a)(queueMicrotask, false);



"use client";
class $b6e93d5d187b3d6c$var$MeasureLayoutWithContext extends (0, $bh6RR.Component) {
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ componentDidMount() {
        const { visualElement: visualElement , layoutGroup: layoutGroup , switchLayoutGroup: switchLayoutGroup , layoutId: layoutId  } = this.props;
        const { projection: projection  } = visualElement;
        (0, $93233d74f0d10a65$export$de9e7791c71225fd)($b6e93d5d187b3d6c$var$defaultScaleCorrectors);
        if (projection) {
            if (layoutGroup.group) layoutGroup.group.add(projection);
            if (switchLayoutGroup && switchLayoutGroup.register && layoutId) switchLayoutGroup.register(projection);
            projection.root.didUpdate();
            projection.addEventListener("animationComplete", ()=>{
                this.safeToRemove();
            });
            projection.setOptions({
                ...projection.options,
                onExitComplete: ()=>this.safeToRemove()
            });
        }
        (0, $fb51e1392d812b31$export$97db156a3ed1593b).hasEverUpdated = true;
    }
    getSnapshotBeforeUpdate(prevProps) {
        const { layoutDependency: layoutDependency , visualElement: visualElement , drag: drag , isPresent: isPresent  } = this.props;
        const projection = visualElement.projection;
        if (!projection) return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
        if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined) projection.willUpdate();
        else this.safeToRemove();
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) projection.promote();
            else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ (0, $6491bdd13544fdda$export$2cef06c20297c17d).postRender(()=>{
                const stack = projection.getStack();
                if (!stack || !stack.members.length) this.safeToRemove();
            });
        }
        return null;
    }
    componentDidUpdate() {
        const { projection: projection  } = this.props.visualElement;
        if (projection) {
            projection.root.didUpdate();
            (0, $3858c82cd1ca695a$export$bb76eed83315504c).postRender(()=>{
                if (!projection.currentAnimation && projection.isLead()) this.safeToRemove();
            });
        }
    }
    componentWillUnmount() {
        const { visualElement: visualElement , layoutGroup: layoutGroup , switchLayoutGroup: promoteContext  } = this.props;
        const { projection: projection  } = visualElement;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup && layoutGroup.group) layoutGroup.group.remove(projection);
            if (promoteContext && promoteContext.deregister) promoteContext.deregister(projection);
        }
    }
    safeToRemove() {
        const { safeToRemove: safeToRemove  } = this.props;
        safeToRemove && safeToRemove();
    }
    render() {
        return null;
    }
}
function $b6e93d5d187b3d6c$export$779f5fb01ad751cd(props) {
    const [isPresent, safeToRemove] = (0, $11db8f3094dfc6f1$export$2a8c16d82a0a0e26)();
    const layoutGroup = (0, $bh6RR.useContext)((0, $364741b44296b530$export$a3579ca508007a95));
    return (0, $d4dab640dcbe486c$exports.jsx)($b6e93d5d187b3d6c$var$MeasureLayoutWithContext, {
        ...props,
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, $bh6RR.useContext)((0, $b8a0e6b50203ba18$export$da5f7b802957459a)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    });
}
const $b6e93d5d187b3d6c$var$defaultScaleCorrectors = {
    borderRadius: {
        ...(0, $e543877808356f59$export$5eafb6257a5844c),
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    },
    borderTopLeftRadius: (0, $e543877808356f59$export$5eafb6257a5844c),
    borderTopRightRadius: (0, $e543877808356f59$export$5eafb6257a5844c),
    borderBottomLeftRadius: (0, $e543877808356f59$export$5eafb6257a5844c),
    borderBottomRightRadius: (0, $e543877808356f59$export$5eafb6257a5844c),
    boxShadow: (0, $2e837016dedbf14e$export$eb0bc629e74dcf8)
};








const $210c6abc2ab907de$var$borders = [
    "TopLeft",
    "TopRight",
    "BottomLeft",
    "BottomRight"
];
const $210c6abc2ab907de$var$numBorders = $210c6abc2ab907de$var$borders.length;
const $210c6abc2ab907de$var$asNumber = (value)=>typeof value === "string" ? parseFloat(value) : value;
const $210c6abc2ab907de$var$isPx = (value)=>typeof value === "number" || (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008).test(value);
function $210c6abc2ab907de$export$739e279c17d51c3d(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    if (shouldCrossfadeOpacity) {
        target.opacity = (0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(0, // TODO Reinstate this if only child
        lead.opacity !== undefined ? lead.opacity : 1, $210c6abc2ab907de$var$easeCrossfadeIn(progress));
        target.opacityExit = (0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(follow.opacity !== undefined ? follow.opacity : 1, 0, $210c6abc2ab907de$var$easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(follow.opacity !== undefined ? follow.opacity : 1, lead.opacity !== undefined ? lead.opacity : 1, progress);
    /**
     * Mix border radius
     */ for(let i = 0; i < $210c6abc2ab907de$var$numBorders; i++){
        const borderLabel = `border${$210c6abc2ab907de$var$borders[i]}Radius`;
        let followRadius = $210c6abc2ab907de$var$getRadius(follow, borderLabel);
        let leadRadius = $210c6abc2ab907de$var$getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        const canMix = followRadius === 0 || leadRadius === 0 || $210c6abc2ab907de$var$isPx(followRadius) === $210c6abc2ab907de$var$isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)($210c6abc2ab907de$var$asNumber(followRadius), $210c6abc2ab907de$var$asNumber(leadRadius), progress), 0);
            if ((0, $ee89500f7aaa2f56$export$626336c2cd4b14de).test(leadRadius) || (0, $ee89500f7aaa2f56$export$626336c2cd4b14de).test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(follow.rotate || 0, lead.rotate || 0, progress);
}
function $210c6abc2ab907de$var$getRadius(values, radiusName) {
    return values[radiusName] !== undefined ? values[radiusName] : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
const $210c6abc2ab907de$var$easeCrossfadeIn = /*@__PURE__*/ $210c6abc2ab907de$var$compress(0, 0.5, (0, $f0e499eff44e3cea$export$c8d67a19199d1a50));
const $210c6abc2ab907de$var$easeCrossfadeOut = /*@__PURE__*/ $210c6abc2ab907de$var$compress(0.5, 0.95, (0, $c13dd6518645747b$export$8793edee2d425525));
function $210c6abc2ab907de$var$compress(min, max, easing) {
    return (p)=>{
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, $e6e94e48128648b0$export$504d7abb21fa8c9)(min, max, p));
    };
}


/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $44cebc6c5c69ba9d$export$a0230ae482601ae8(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $44cebc6c5c69ba9d$export$c53fd88f45d77e4b(box, originBox) {
    $44cebc6c5c69ba9d$export$a0230ae482601ae8(box.x, originBox.x);
    $44cebc6c5c69ba9d$export$a0230ae482601ae8(box.y, originBox.y);
}
/**
 * Reset a delta to the provided origin box.
 *
 * This is a mutative operation.
 */ function $44cebc6c5c69ba9d$export$8ead6a7d6b225ef(delta, originDelta) {
    delta.translate = originDelta.translate;
    delta.scale = originDelta.scale;
    delta.originPoint = originDelta.originPoint;
    delta.origin = originDelta.origin;
}







/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $749794150c53d8b2$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, $4c951bbfa32a6f81$export$2290ec7febe36dd6)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, $4c951bbfa32a6f81$export$2290ec7febe36dd6)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $749794150c53d8b2$export$cc12a0672fae5b4a(axis, translate = 0, scale = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
    if ((0, $ee89500f7aaa2f56$export$626336c2cd4b14de).test(translate)) {
        translate = parseFloat(translate);
        const relativeProgress = (0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    let originPoint = (0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = $749794150c53d8b2$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $749794150c53d8b2$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $749794150c53d8b2$export$42b76f1d0d16d5b(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
    $749794150c53d8b2$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $749794150c53d8b2$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $749794150c53d8b2$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $749794150c53d8b2$export$73e1ad0a9694e25c(box, transforms, originBox, sourceBox) {
    $749794150c53d8b2$export$42b76f1d0d16d5b(box.x, transforms, $749794150c53d8b2$var$xKeys, originBox ? originBox.x : undefined, sourceBox ? sourceBox.x : undefined);
    $749794150c53d8b2$export$42b76f1d0d16d5b(box.y, transforms, $749794150c53d8b2$var$yKeys, originBox ? originBox.y : undefined, sourceBox ? sourceBox.y : undefined);
}




function $360ce5c67f749464$var$isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function $360ce5c67f749464$export$a7ec7642fe550fb6(delta) {
    return $360ce5c67f749464$var$isAxisDeltaZero(delta.x) && $360ce5c67f749464$var$isAxisDeltaZero(delta.y);
}
function $360ce5c67f749464$export$7a9a6f114ddd0fdb(a, b) {
    return a.min === b.min && a.max === b.max;
}
function $360ce5c67f749464$export$8d5cf76bb7daff09(a, b) {
    return $360ce5c67f749464$export$7a9a6f114ddd0fdb(a.x, b.x) && $360ce5c67f749464$export$7a9a6f114ddd0fdb(a.y, b.y);
}
function $360ce5c67f749464$export$22adf28bfca1c186(a, b) {
    return Math.round(a.min) === Math.round(b.min) && Math.round(a.max) === Math.round(b.max);
}
function $360ce5c67f749464$export$ef641b782d85522(a, b) {
    return $360ce5c67f749464$export$22adf28bfca1c186(a.x, b.x) && $360ce5c67f749464$export$22adf28bfca1c186(a.y, b.y);
}
function $360ce5c67f749464$export$c5706146bc63213(box) {
    return (0, $d9901b0e7f584a90$export$c1c127004b72a37)(box.x) / (0, $d9901b0e7f584a90$export$c1c127004b72a37)(box.y);
}
function $360ce5c67f749464$export$444620505e28fe92(a, b) {
    return a.translate === b.translate && a.scale === b.scale && a.originPoint === b.originPoint;
}



class $183043a6fc74a7d6$export$39be5b2d82fc9dc7 {
    constructor(){
        this.members = [];
    }
    add(node) {
        (0, $13ad1cfa8b4681b0$export$20e507e47fae79fd)(this.members, node);
        node.scheduleRender();
    }
    remove(node) {
        (0, $13ad1cfa8b4681b0$export$fe2d9b4e03920b4c)(this.members, node);
        if (node === this.prevLead) this.prevLead = undefined;
        if (node === this.lead) {
            const prevLead = this.members[this.members.length - 1];
            if (prevLead) this.promote(prevLead);
        }
    }
    relegate(node) {
        const indexOfNode = this.members.findIndex((member)=>node === member);
        if (indexOfNode === 0) return false;
        /**
         * Find the next projection node that is present
         */ let prevLead;
        for(let i = indexOfNode; i >= 0; i--){
            const member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        } else return false;
    }
    promote(node, preserveFollowOpacity) {
        const prevLead = this.lead;
        if (node === prevLead) return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) node.resumeFrom.preserveOpacity = true;
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
            }
            if (node.root && node.root.isUpdating) node.isLayoutDirty = true;
            const { crossfade: crossfade  } = node.options;
            if (crossfade === false) prevLead.hide();
        /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */ }
    }
    exitAnimationComplete() {
        this.members.forEach((node)=>{
            const { options: options , resumingFrom: resumingFrom  } = node;
            options.onExitComplete && options.onExitComplete();
            if (resumingFrom) resumingFrom.options.onExitComplete && resumingFrom.options.onExitComplete();
        });
    }
    scheduleRender() {
        this.members.forEach((node)=>{
            node.instance && node.scheduleRender(false);
        });
    }
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */ removeLeadSnapshot() {
        if (this.lead && this.lead.snapshot) this.lead.snapshot = undefined;
    }
}



function $bec23b122ca5d293$export$d33653b270fe725c(delta, treeScale, latestTransform) {
    let transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ const xTranslate = delta.x.translate / treeScale.x;
    const yTranslate = delta.y.translate / treeScale.y;
    const zTranslate = (latestTransform === null || latestTransform === void 0 ? void 0 : latestTransform.z) || 0;
    if (xTranslate || yTranslate || zTranslate) transform = `translate3d(${xTranslate}px, ${yTranslate}px, ${zTranslate}px) `;
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ if (treeScale.x !== 1 || treeScale.y !== 1) transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
    if (latestTransform) {
        const { transformPerspective: transformPerspective , rotate: rotate , rotateX: rotateX , rotateY: rotateY , skewX: skewX , skewY: skewY  } = latestTransform;
        if (transformPerspective) transform = `perspective(${transformPerspective}px) ${transform}`;
        if (rotate) transform += `rotate(${rotate}deg) `;
        if (rotateX) transform += `rotateX(${rotateX}deg) `;
        if (rotateY) transform += `rotateY(${rotateY}deg) `;
        if (skewX) transform += `skewX(${skewX}deg) `;
        if (skewY) transform += `skewY(${skewY}deg) `;
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ const elementScaleX = delta.x.scale * treeScale.x;
    const elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) transform += `scale(${elementScaleX}, ${elementScaleY})`;
    return transform || "none";
}





const $b2b47619cf5d2c84$export$d689d9dec5ad338 = (a, b)=>a.depth - b.depth;


class $1f12cfa00e0c731b$export$1465d17e3de78a96 {
    constructor(){
        this.children = [];
        this.isDirty = false;
    }
    add(child) {
        (0, $13ad1cfa8b4681b0$export$20e507e47fae79fd)(this.children, child);
        this.isDirty = true;
    }
    remove(child) {
        (0, $13ad1cfa8b4681b0$export$fe2d9b4e03920b4c)(this.children, child);
        this.isDirty = true;
    }
    forEach(callback) {
        this.isDirty && this.children.sort((0, $b2b47619cf5d2c84$export$d689d9dec5ad338));
        this.isDirty = false;
        this.children.forEach(callback);
    }
}




/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */ function $9e7923b7600c25b9$export$fcc2206ecb6d74b(value) {
    const unwrappedValue = (0, $d449570363f09a53$export$605d60a2578142d3)(value) ? value.get() : value;
    return (0, $b9d94c0c185391a2$export$2f308ad9864b3ac9)(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}






/**
 * Timeout defined in ms
 */ function $d62baf960e3e1cd2$export$1391212d75b2ee65(callback, timeout) {
    const start = (0, $05b982fb85a2786e$export$2da9be4cfdb689b1).now();
    const checkElapsed = ({ timestamp: timestamp  })=>{
        const elapsed = timestamp - start;
        if (elapsed >= timeout) {
            (0, $6491bdd13544fdda$export$ec99c0ef4978dccb)(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    (0, $6491bdd13544fdda$export$2cef06c20297c17d).read(checkElapsed, true);
    return ()=>(0, $6491bdd13544fdda$export$ec99c0ef4978dccb)(checkElapsed);
}
function $d62baf960e3e1cd2$export$fcd451ca460f8a2a(callback, timeout) {
    return $d62baf960e3e1cd2$export$1391212d75b2ee65(callback, (0, $631bdbca8ed9a472$export$fc3e7e8557f8c8c7)(timeout));
}



function $7982a746f864c4a2$export$17eda790a720ec57(element) {
    return element instanceof SVGElement && element.tagName !== "svg";
}





function $a676325df12b3ad9$export$335a17c977067b99(value, keyframes, options) {
    const motionValue$1 = (0, $d449570363f09a53$export$605d60a2578142d3)(value) ? value : (0, $925342fde4532b85$export$ce8bdc721e76545f)(value);
    motionValue$1.start((0, $3431270835958863$export$90b3dfc33ff3548)("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}









const $281d58aebf127403$var$metrics = {
    type: "projectionFrame",
    totalNodes: 0,
    resolvedTargetDeltas: 0,
    recalculatedProjection: 0
};
const $281d58aebf127403$var$isDebug = typeof window !== "undefined" && window.MotionDebug !== undefined;
const $281d58aebf127403$var$transformAxes = [
    "",
    "X",
    "Y",
    "Z"
];
const $281d58aebf127403$var$hiddenVisibility = {
    visibility: "hidden"
};
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ const $281d58aebf127403$var$animationTarget = 1000;
let $281d58aebf127403$var$id = 0;
function $281d58aebf127403$var$resetDistortingTransform(key, visualElement, values, sharedAnimationValues) {
    const { latestValues: latestValues  } = visualElement;
    // Record the distorting transform and then temporarily set it to 0
    if (latestValues[key]) {
        values[key] = latestValues[key];
        visualElement.setStaticValue(key, 0);
        if (sharedAnimationValues) sharedAnimationValues[key] = 0;
    }
}
function $281d58aebf127403$var$cancelTreeOptimisedTransformAnimations(projectionNode) {
    projectionNode.hasCheckedOptimisedAppear = true;
    if (projectionNode.root === projectionNode) return;
    const { visualElement: visualElement  } = projectionNode.options;
    if (!visualElement) return;
    const appearId = (0, $e2f74713dde14d85$export$5f8d21e84d1d84fc)(visualElement);
    if (window.MotionHasOptimisedAnimation(appearId, "transform")) {
        const { layout: layout , layoutId: layoutId  } = projectionNode.options;
        window.MotionCancelOptimisedAnimation(appearId, "transform", (0, $6491bdd13544fdda$export$2cef06c20297c17d), !(layout || layoutId));
    }
    const { parent: parent  } = projectionNode;
    if (parent && !parent.hasCheckedOptimisedAppear) $281d58aebf127403$var$cancelTreeOptimisedTransformAnimations(parent);
}
function $281d58aebf127403$export$a84b61f69daa9da0({ attachResizeListener: attachResizeListener , defaultParent: defaultParent , measureScroll: measureScroll , checkIsScrollRoot: checkIsScrollRoot , resetTransform: resetTransform  }) {
    return class ProjectionNode {
        constructor(latestValues = {}, parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent()){
            /**
             * A unique ID generated for every projection node.
             */ this.id = $281d58aebf127403$var$id++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */ this.animationId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            /**
             * Flag to true if we think the projection calculations for this node needs
             * recalculating as a result of an updated transform or layout animation.
             */ this.isProjectionDirty = false;
            /**
             * Flag to true if the layout *or* transform has changed. This then gets propagated
             * throughout the projection tree, forcing any element below to recalculate on the next frame.
             */ this.isSharedProjectionDirty = false;
            /**
             * Flag transform dirty. This gets propagated throughout the whole tree but is only
             * respected by shared nodes.
             */ this.isTransformDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * Store whether this node has been checked for optimised appear animations. As
             * effects fire bottom-up, and we want to look up the tree for appear animations,
             * this makes sure we only check each path once, stopping at nodes that
             * have already been checked.
             */ this.hasCheckedOptimisedAppear = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            this.hasTreeAnimated = false;
            // Note: Currently only running on root node
            this.updateScheduled = false;
            this.scheduleUpdate = ()=>this.update();
            this.projectionUpdateScheduled = false;
            this.checkUpdateFailed = ()=>{
                if (this.isUpdating) {
                    this.isUpdating = false;
                    this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */ this.updateProjection = ()=>{
                this.projectionUpdateScheduled = false;
                /**
                 * Reset debug counts. Manually resetting rather than creating a new
                 * object each frame.
                 */ if ($281d58aebf127403$var$isDebug) $281d58aebf127403$var$metrics.totalNodes = $281d58aebf127403$var$metrics.resolvedTargetDeltas = $281d58aebf127403$var$metrics.recalculatedProjection = 0;
                this.nodes.forEach($281d58aebf127403$export$131f2f0cc5fe9609);
                this.nodes.forEach($281d58aebf127403$var$resolveTargetDelta);
                this.nodes.forEach($281d58aebf127403$var$calcProjection);
                this.nodes.forEach($281d58aebf127403$export$c2664f37bc951031);
                if ($281d58aebf127403$var$isDebug) window.MotionDebug.record($281d58aebf127403$var$metrics);
            };
            /**
             * Frame calculations
             */ this.resolvedRelativeTargetAt = 0.0;
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? [
                ...parent.path,
                parent
            ] : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            for(let i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, $1f12cfa00e0c731b$export$1465d17e3de78a96)();
        }
        addEventListener(name, handler) {
            if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, $fe92d8ac7a8c9e00$export$e7dff9482a5fd23c)());
            return this.eventHandlers.get(name).add(handler);
        }
        notifyListeners(name, ...args) {
            const subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager && subscriptionManager.notify(...args);
        }
        hasListeners(name) {
            return this.eventHandlers.has(name);
        }
        /**
         * Lifecycles
         */ mount(instance, isLayoutDirty = this.root.hasTreeAnimated) {
            if (this.instance) return;
            this.isSVG = (0, $7982a746f864c4a2$export$17eda790a720ec57)(instance);
            this.instance = instance;
            const { layoutId: layoutId , layout: layout , visualElement: visualElement  } = this.options;
            if (visualElement && !visualElement.current) visualElement.mount(instance);
            this.root.nodes.add(this);
            this.parent && this.parent.children.add(this);
            if (isLayoutDirty && (layout || layoutId)) this.isLayoutDirty = true;
            if (attachResizeListener) {
                let cancelDelay;
                const resizeUnblockUpdate = ()=>this.root.updateBlockedByResize = false;
                attachResizeListener(instance, ()=>{
                    this.root.updateBlockedByResize = true;
                    cancelDelay && cancelDelay();
                    cancelDelay = (0, $d62baf960e3e1cd2$export$1391212d75b2ee65)(resizeUnblockUpdate, 250);
                    if ((0, $fb51e1392d812b31$export$97db156a3ed1593b).hasAnimatedSinceResize) {
                        (0, $fb51e1392d812b31$export$97db156a3ed1593b).hasAnimatedSinceResize = false;
                        this.nodes.forEach($281d58aebf127403$var$finishAnimation);
                    }
                });
            }
            if (layoutId) this.root.registerSharedNode(layoutId, this);
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", ({ delta: delta , hasLayoutChanged: hasLayoutChanged , hasRelativeTargetChanged: hasRelativeTargetChanged , layout: newLayout  })=>{
                if (this.isTreeAnimationBlocked()) {
                    this.target = undefined;
                    this.relativeTarget = undefined;
                    return;
                }
                // TODO: Check here if an animation exists
                const layoutTransition = this.options.transition || visualElement.getDefaultTransition() || $281d58aebf127403$var$defaultLayoutTransition;
                const { onLayoutAnimationStart: onLayoutAnimationStart , onLayoutAnimationComplete: onLayoutAnimationComplete  } = visualElement.getProps();
                /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ const targetChanged = !this.targetLayout || !(0, $360ce5c67f749464$export$ef641b782d85522)(this.targetLayout, newLayout) || hasRelativeTargetChanged;
                /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
                if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || hasOnlyRelativeTargetChanged || hasLayoutChanged && (targetChanged || !this.currentAnimation)) {
                    if (this.resumeFrom) {
                        this.resumingFrom = this.resumeFrom;
                        this.resumingFrom.resumingFrom = undefined;
                    }
                    this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                    const animationOptions = {
                        ...(0, $7530df41f7472851$export$7c1391340308742e)(layoutTransition, "layout"),
                        onPlay: onLayoutAnimationStart,
                        onComplete: onLayoutAnimationComplete
                    };
                    if (visualElement.shouldReduceMotion || this.options.layoutRoot) {
                        animationOptions.delay = 0;
                        animationOptions.type = false;
                    }
                    this.startAnimation(animationOptions);
                } else {
                    /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never commited to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged) $281d58aebf127403$var$finishAnimation(this);
                    if (this.isLead() && this.options.onExitComplete) this.options.onExitComplete();
                }
                this.targetLayout = newLayout;
            });
        }
        unmount() {
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            const stack = this.getStack();
            stack && stack.remove(this);
            this.parent && this.parent.children.delete(this);
            this.instance = undefined;
            (0, $6491bdd13544fdda$export$ec99c0ef4978dccb)(this.updateProjection);
        }
        // only on the root
        blockUpdate() {
            this.updateManuallyBlocked = true;
        }
        unblockUpdate() {
            this.updateManuallyBlocked = false;
        }
        isUpdateBlocked() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        }
        isTreeAnimationBlocked() {
            return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
        }
        // Note: currently only running on root node
        startUpdate() {
            if (this.isUpdateBlocked()) return;
            this.isUpdating = true;
            this.nodes && this.nodes.forEach($281d58aebf127403$var$resetSkewAndRotation);
            this.animationId++;
        }
        getTransformTemplate() {
            const { visualElement: visualElement  } = this.options;
            return visualElement && visualElement.getProps().transformTemplate;
        }
        willUpdate(shouldNotifyListeners = true) {
            this.root.hasTreeAnimated = true;
            if (this.root.isUpdateBlocked()) {
                this.options.onExitComplete && this.options.onExitComplete();
                return;
            }
            /**
             * If we're running optimised appear animations then these must be
             * cancelled before measuring the DOM. This is so we can measure
             * the true layout of the element rather than the WAAPI animation
             * which will be unaffected by the resetSkewAndRotate step.
             *
             * Note: This is a DOM write. Worst case scenario is this is sandwiched
             * between other snapshot reads which will cause unnecessary style recalculations.
             * This has to happen here though, as we don't yet know which nodes will need
             * snapshots in startUpdate(), but we only want to cancel optimised animations
             * if a layout animation measurement is actually going to be affected by them.
             */ if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear) $281d58aebf127403$var$cancelTreeOptimisedTransformAnimations(this);
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty) return;
            this.isLayoutDirty = true;
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.shouldResetTransform = true;
                node.updateScroll("snapshot");
                if (node.options.layoutRoot) node.willUpdate(false);
            }
            const { layoutId: layoutId , layout: layout  } = this.options;
            if (layoutId === undefined && !layout) return;
            const transformTemplate = this.getTransformTemplate();
            this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        }
        update() {
            this.updateScheduled = false;
            const updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach($281d58aebf127403$var$clearMeasurements);
                return;
            }
            if (!this.isUpdating) this.nodes.forEach($281d58aebf127403$var$clearIsLayoutDirty);
            this.isUpdating = false;
            /**
             * Write
             */ this.nodes.forEach($281d58aebf127403$var$resetTransformStyle);
            /**
             * Read ==================
             */ // Update layout measurements of updated children
            this.nodes.forEach($281d58aebf127403$var$updateLayout);
            /**
             * Write
             */ // Notify listeners that the layout is updated
            this.nodes.forEach($281d58aebf127403$var$notifyLayoutUpdate);
            this.clearAllSnapshots();
            /**
             * Manually flush any pending updates. Ideally
             * we could leave this to the following requestAnimationFrame but this seems
             * to leave a flash of incorrectly styled content.
             */ const now = (0, $05b982fb85a2786e$export$2da9be4cfdb689b1).now();
            (0, $6491bdd13544fdda$export$fff89137e9e818ce).delta = (0, $bb2cd2f4425aee0a$export$7d15b64cf5a3a4c4)(0, 1000 / 60, now - (0, $6491bdd13544fdda$export$fff89137e9e818ce).timestamp);
            (0, $6491bdd13544fdda$export$fff89137e9e818ce).timestamp = now;
            (0, $6491bdd13544fdda$export$fff89137e9e818ce).isProcessing = true;
            (0, $6491bdd13544fdda$export$1811c3a7e3af92f0).update.process((0, $6491bdd13544fdda$export$fff89137e9e818ce));
            (0, $6491bdd13544fdda$export$1811c3a7e3af92f0).preRender.process((0, $6491bdd13544fdda$export$fff89137e9e818ce));
            (0, $6491bdd13544fdda$export$1811c3a7e3af92f0).render.process((0, $6491bdd13544fdda$export$fff89137e9e818ce));
            (0, $6491bdd13544fdda$export$fff89137e9e818ce).isProcessing = false;
        }
        didUpdate() {
            if (!this.updateScheduled) {
                this.updateScheduled = true;
                (0, $3858c82cd1ca695a$export$bb76eed83315504c).read(this.scheduleUpdate);
            }
        }
        clearAllSnapshots() {
            this.nodes.forEach($281d58aebf127403$var$clearSnapshot);
            this.sharedNodes.forEach($281d58aebf127403$var$removeLeadSnapshots);
        }
        scheduleUpdateProjection() {
            if (!this.projectionUpdateScheduled) {
                this.projectionUpdateScheduled = true;
                (0, $6491bdd13544fdda$export$2cef06c20297c17d).preRender(this.updateProjection, false, true);
            }
        }
        scheduleCheckAfterUnmount() {
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, $6491bdd13544fdda$export$2cef06c20297c17d).postRender(()=>{
                if (this.isLayoutDirty) this.root.didUpdate();
                else this.root.checkUpdateFailed();
            });
        }
        /**
         * Update measurements
         */ updateSnapshot() {
            if (this.snapshot || !this.instance) return;
            this.snapshot = this.measure();
        }
        updateLayout() {
            if (!this.instance) return;
            // TODO: Incorporate into a forwarded scroll offset
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.updateScroll();
            }
            const prevLayout = this.layout;
            this.layout = this.measure(false);
            this.layoutCorrected = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.layoutBox);
            const { visualElement: visualElement  } = this.options;
            visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : undefined);
        }
        updateScroll(phase = "measure") {
            let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
            if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) needsMeasurement = false;
            if (needsMeasurement) {
                const isRoot = checkIsScrollRoot(this.instance);
                this.scroll = {
                    animationId: this.root.animationId,
                    phase: phase,
                    isRoot: isRoot,
                    offset: measureScroll(this.instance),
                    wasRoot: this.scroll ? this.scroll.isRoot : isRoot
                };
            }
        }
        resetTransform() {
            if (!resetTransform) return;
            const isResetRequested = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout;
            const hasProjection = this.projectionDelta && !(0, $360ce5c67f749464$export$a7ec7642fe550fb6)(this.projectionDelta);
            const transformTemplate = this.getTransformTemplate();
            const transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested && (hasProjection || (0, $fed21f2a9fad1fb9$export$a545127cf1fbb600)(this.latestValues) || transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        }
        measure(removeTransform = true) {
            const pageBox = this.measurePageBox();
            let layoutBox = this.removeElementScroll(pageBox);
            /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */ if (removeTransform) layoutBox = this.removeTransform(layoutBox);
            $281d58aebf127403$var$roundBox(layoutBox);
            return {
                animationId: this.root.animationId,
                measuredBox: pageBox,
                layoutBox: layoutBox,
                latestValues: {},
                source: this.id
            };
        }
        measurePageBox() {
            var _a;
            const { visualElement: visualElement  } = this.options;
            if (!visualElement) return (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
            const box = visualElement.measureViewportBox();
            const wasInScrollRoot = ((_a = this.scroll) === null || _a === void 0 ? void 0 : _a.wasRoot) || this.path.some($281d58aebf127403$var$checkNodeWasScrollRoot);
            if (!wasInScrollRoot) {
                // Remove viewport scroll to give page-relative coordinates
                const { scroll: scroll  } = this.root;
                if (scroll) {
                    (0, $4c951bbfa32a6f81$export$a807a5ce5ebb3895)(box.x, scroll.offset.x);
                    (0, $4c951bbfa32a6f81$export$a807a5ce5ebb3895)(box.y, scroll.offset.y);
                }
            }
            return box;
        }
        removeElementScroll(box) {
            var _a;
            const boxWithoutScroll = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
            (0, $44cebc6c5c69ba9d$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
            if ((_a = this.scroll) === null || _a === void 0 ? void 0 : _a.wasRoot) return boxWithoutScroll;
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                const { scroll: scroll , options: options  } = node;
                if (node !== this.root && scroll && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (scroll.wasRoot) (0, $44cebc6c5c69ba9d$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
                    (0, $4c951bbfa32a6f81$export$a807a5ce5ebb3895)(boxWithoutScroll.x, scroll.offset.x);
                    (0, $4c951bbfa32a6f81$export$a807a5ce5ebb3895)(boxWithoutScroll.y, scroll.offset.y);
                }
            }
            return boxWithoutScroll;
        }
        applyTransform(box, transformOnly = false) {
            const withTransforms = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
            (0, $44cebc6c5c69ba9d$export$c53fd88f45d77e4b)(withTransforms, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) (0, $4c951bbfa32a6f81$export$58b16271041fbfb)(withTransforms, {
                    x: -node.scroll.offset.x,
                    y: -node.scroll.offset.y
                });
                if (!(0, $fed21f2a9fad1fb9$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $4c951bbfa32a6f81$export$58b16271041fbfb)(withTransforms, node.latestValues);
            }
            if ((0, $fed21f2a9fad1fb9$export$a545127cf1fbb600)(this.latestValues)) (0, $4c951bbfa32a6f81$export$58b16271041fbfb)(withTransforms, this.latestValues);
            return withTransforms;
        }
        removeTransform(box) {
            const boxWithoutTransform = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
            (0, $44cebc6c5c69ba9d$export$c53fd88f45d77e4b)(boxWithoutTransform, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!node.instance) continue;
                if (!(0, $fed21f2a9fad1fb9$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $fed21f2a9fad1fb9$export$bdf30dca883ea463)(node.latestValues) && node.updateSnapshot();
                const sourceBox = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
                const nodeBox = node.measurePageBox();
                (0, $44cebc6c5c69ba9d$export$c53fd88f45d77e4b)(sourceBox, nodeBox);
                (0, $749794150c53d8b2$export$73e1ad0a9694e25c)(boxWithoutTransform, node.latestValues, node.snapshot ? node.snapshot.layoutBox : undefined, sourceBox);
            }
            if ((0, $fed21f2a9fad1fb9$export$a545127cf1fbb600)(this.latestValues)) (0, $749794150c53d8b2$export$73e1ad0a9694e25c)(boxWithoutTransform, this.latestValues);
            return boxWithoutTransform;
        }
        setTargetDelta(delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
            this.isProjectionDirty = true;
        }
        setOptions(options) {
            this.options = {
                ...this.options,
                ...options,
                crossfade: options.crossfade !== undefined ? options.crossfade : true
            };
        }
        clearMeasurements() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        }
        forceRelativeParentToResolveTarget() {
            if (!this.relativeParent) return;
            /**
             * If the parent target isn't up-to-date, force it to update.
             * This is an unfortunate de-optimisation as it means any updating relative
             * projection will cause all the relative parents to recalculate back
             * up the tree.
             */ if (this.relativeParent.resolvedRelativeTargetAt !== (0, $6491bdd13544fdda$export$fff89137e9e818ce).timestamp) this.relativeParent.resolveTargetDelta(true);
        }
        resolveTargetDelta(forceRecalculation = false) {
            var _a;
            /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */ const lead = this.getLead();
            this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
            this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
            this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */ const canSkip = !(forceRecalculation || isShared && this.isSharedProjectionDirty || this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty) || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize);
            if (canSkip) return;
            const { layout: layout , layoutId: layoutId  } = this.options;
            /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
            this.resolvedRelativeTargetAt = (0, $6491bdd13544fdda$export$fff89137e9e818ce).timestamp;
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ if (!this.targetDelta && !this.relativeTarget) {
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && relativeParent.layout && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
                    (0, $d9901b0e7f584a90$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.layout.layoutBox, relativeParent.layout.layoutBox);
                    (0, $44cebc6c5c69ba9d$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
            /**
             * Lazy-init target data structure
             */ if (!this.target) {
                this.target = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
                this.targetWithTransforms = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target) {
                this.forceRelativeParentToResolveTarget();
                (0, $d9901b0e7f584a90$export$426154f9d100f99)(this.target, this.relativeTarget, this.relativeParent.target);
            /**
                 * If we've only got a targetDelta, resolve it into a target
                 */ } else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) // TODO: This is creating a new object every frame
                this.target = this.applyTransform(this.layout.layoutBox);
                else (0, $44cebc6c5c69ba9d$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
                (0, $4c951bbfa32a6f81$export$d80074982803af5c)(this.target, this.targetDelta);
            } else /**
                 * If no target, use own layout as target
                 */ (0, $44cebc6c5c69ba9d$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && Boolean(relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent.options.layoutScroll && relativeParent.target && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
                    (0, $d9901b0e7f584a90$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.target, relativeParent.target);
                    (0, $44cebc6c5c69ba9d$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * Increase debug counter for resolved target deltas
             */ if ($281d58aebf127403$var$isDebug) $281d58aebf127403$var$metrics.resolvedTargetDeltas++;
        }
        getClosestProjectingParent() {
            if (!this.parent || (0, $fed21f2a9fad1fb9$export$bdf30dca883ea463)(this.parent.latestValues) || (0, $fed21f2a9fad1fb9$export$bf80f5f8f4dc327f)(this.parent.latestValues)) return undefined;
            if (this.parent.isProjecting()) return this.parent;
            else return this.parent.getClosestProjectingParent();
        }
        isProjecting() {
            return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
        }
        calcProjection() {
            var _a;
            const lead = this.getLead();
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            let canSkip = true;
            /**
             * If this is a normal layout animation and neither this node nor its nearest projecting
             * is dirty then we can't skip.
             */ if (this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty)) canSkip = false;
            /**
             * If this is a shared layout animation and this node's shared projection is dirty then
             * we can't skip.
             */ if (isShared && (this.isSharedProjectionDirty || this.isTransformDirty)) canSkip = false;
            /**
             * If we have resolved the target this frame we must recalculate the
             * projection to ensure it visually represents the internal calculations.
             */ if (this.resolvedRelativeTargetAt === (0, $6491bdd13544fdda$export$fff89137e9e818ce).timestamp) canSkip = false;
            if (canSkip) return;
            const { layout: layout , layoutId: layoutId  } = this.options;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation);
            if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
            if (!this.layout || !(layout || layoutId)) return;
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, $44cebc6c5c69ba9d$export$c53fd88f45d77e4b)(this.layoutCorrected, this.layout.layoutBox);
            /**
             * Record previous tree scales before updating.
             */ const prevTreeScaleX = this.treeScale.x;
            const prevTreeScaleY = this.treeScale.y;
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, $4c951bbfa32a6f81$export$e2a980535c55eabb)(this.layoutCorrected, this.treeScale, this.path, isShared);
            /**
             * If this layer needs to perform scale correction but doesn't have a target,
             * use the layout as the target.
             */ if (lead.layout && !lead.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1)) {
                lead.target = lead.layout.layoutBox;
                lead.targetWithTransforms = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
            }
            const { target: target  } = lead;
            if (!target) {
                /**
                 * If we don't have a target to project into, but we were previously
                 * projecting, we want to remove the stored transform and schedule
                 * a render to ensure the elements reflect the removed transform.
                 */ if (this.prevProjectionDelta) {
                    this.createProjectionDeltas();
                    this.scheduleRender();
                }
                return;
            }
            if (!this.projectionDelta || !this.prevProjectionDelta) this.createProjectionDeltas();
            else {
                (0, $44cebc6c5c69ba9d$export$8ead6a7d6b225ef)(this.prevProjectionDelta.x, this.projectionDelta.x);
                (0, $44cebc6c5c69ba9d$export$8ead6a7d6b225ef)(this.prevProjectionDelta.y, this.projectionDelta.y);
            }
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, $d9901b0e7f584a90$export$c0d25e96fc67d310)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            if (this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY || !(0, $360ce5c67f749464$export$444620505e28fe92)(this.projectionDelta.x, this.prevProjectionDelta.x) || !(0, $360ce5c67f749464$export$444620505e28fe92)(this.projectionDelta.y, this.prevProjectionDelta.y)) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
            /**
             * Increase debug counter for recalculated projections
             */ if ($281d58aebf127403$var$isDebug) $281d58aebf127403$var$metrics.recalculatedProjection++;
        }
        hide() {
            this.isVisible = false;
        // TODO: Schedule render
        }
        show() {
            this.isVisible = true;
        // TODO: Schedule render
        }
        scheduleRender(notifyAll = true) {
            var _a;
            (_a = this.options.visualElement) === null || _a === void 0 || _a.scheduleRender();
            if (notifyAll) {
                const stack = this.getStack();
                stack && stack.scheduleRender();
            }
            if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
        }
        createProjectionDeltas() {
            this.prevProjectionDelta = (0, $93b39ae61dedc877$export$3d227df54007d73a)();
            this.projectionDelta = (0, $93b39ae61dedc877$export$3d227df54007d73a)();
            this.projectionDeltaWithTransform = (0, $93b39ae61dedc877$export$3d227df54007d73a)();
        }
        setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false) {
            const snapshot = this.snapshot;
            const snapshotLatestValues = snapshot ? snapshot.latestValues : {};
            const mixedValues = {
                ...this.latestValues
            };
            const targetDelta = (0, $93b39ae61dedc877$export$3d227df54007d73a)();
            if (!this.relativeParent || !this.relativeParent.options.layoutRoot) this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            const relativeLayout = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
            const snapshotSource = snapshot ? snapshot.source : undefined;
            const layoutSource = this.layout ? this.layout.source : undefined;
            const isSharedLayoutAnimation = snapshotSource !== layoutSource;
            const stack = this.getStack();
            const isOnlyMember = !stack || stack.members.length <= 1;
            const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some($281d58aebf127403$var$hasOpacityCrossfade));
            this.animationProgress = 0;
            let prevRelativeTarget;
            this.mixTargetDelta = (latest)=>{
                const progress = latest / 1000;
                $281d58aebf127403$export$91dbf443e1bf1de1(targetDelta.x, delta.x, progress);
                $281d58aebf127403$export$91dbf443e1bf1de1(targetDelta.y, delta.y, progress);
                this.setTargetDelta(targetDelta);
                if (this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout) {
                    (0, $d9901b0e7f584a90$export$2785bfcc929c5650)(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox);
                    $281d58aebf127403$export$6ffd3e6ae339a132(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress);
                    /**
                     * If this is an unchanged relative target we can consider the
                     * projection not dirty.
                     */ if (prevRelativeTarget && (0, $360ce5c67f749464$export$8d5cf76bb7daff09)(this.relativeTarget, prevRelativeTarget)) this.isProjectionDirty = false;
                    if (!prevRelativeTarget) prevRelativeTarget = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
                    (0, $44cebc6c5c69ba9d$export$c53fd88f45d77e4b)(prevRelativeTarget, this.relativeTarget);
                }
                if (isSharedLayoutAnimation) {
                    this.animationValues = mixedValues;
                    (0, $210c6abc2ab907de$export$739e279c17d51c3d)(mixedValues, snapshotLatestValues, this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                this.root.scheduleUpdateProjection();
                this.scheduleRender();
                this.animationProgress = progress;
            };
            this.mixTargetDelta(this.options.layoutRoot ? 1000 : 0);
        }
        startAnimation(options) {
            this.notifyListeners("animationStart");
            this.currentAnimation && this.currentAnimation.stop();
            if (this.resumingFrom && this.resumingFrom.currentAnimation) this.resumingFrom.currentAnimation.stop();
            if (this.pendingAnimation) {
                (0, $6491bdd13544fdda$export$ec99c0ef4978dccb)(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, $6491bdd13544fdda$export$2cef06c20297c17d).update(()=>{
                (0, $fb51e1392d812b31$export$97db156a3ed1593b).hasAnimatedSinceResize = true;
                this.currentAnimation = (0, $a676325df12b3ad9$export$335a17c977067b99)(0, $281d58aebf127403$var$animationTarget, {
                    ...options,
                    onUpdate: (latest)=>{
                        this.mixTargetDelta(latest);
                        options.onUpdate && options.onUpdate(latest);
                    },
                    onComplete: ()=>{
                        options.onComplete && options.onComplete();
                        this.completeAnimation();
                    }
                });
                if (this.resumingFrom) this.resumingFrom.currentAnimation = this.currentAnimation;
                this.pendingAnimation = undefined;
            });
        }
        completeAnimation() {
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            const stack = this.getStack();
            stack && stack.exitAnimationComplete();
            this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
            this.notifyListeners("animationComplete");
        }
        finishAnimation() {
            if (this.currentAnimation) {
                this.mixTargetDelta && this.mixTargetDelta($281d58aebf127403$var$animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        }
        applyTransformsToTarget() {
            const lead = this.getLead();
            let { targetWithTransforms: targetWithTransforms , target: target , layout: layout , latestValues: latestValues  } = lead;
            if (!targetWithTransforms || !target || !layout) return;
            /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */ if (this !== lead && this.layout && layout && $281d58aebf127403$var$shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                target = this.target || (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
                const xLength = (0, $d9901b0e7f584a90$export$c1c127004b72a37)(this.layout.layoutBox.x);
                target.x.min = lead.target.x.min;
                target.x.max = target.x.min + xLength;
                const yLength = (0, $d9901b0e7f584a90$export$c1c127004b72a37)(this.layout.layoutBox.y);
                target.y.min = lead.target.y.min;
                target.y.max = target.y.min + yLength;
            }
            (0, $44cebc6c5c69ba9d$export$c53fd88f45d77e4b)(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, $4c951bbfa32a6f81$export$58b16271041fbfb)(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */ (0, $d9901b0e7f584a90$export$c0d25e96fc67d310)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        }
        registerSharedNode(layoutId, node) {
            if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, $183043a6fc74a7d6$export$39be5b2d82fc9dc7)());
            const stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            const config = node.options.initialPromotionConfig;
            node.promote({
                transition: config ? config.transition : undefined,
                preserveFollowOpacity: config && config.shouldPreserveFollowOpacity ? config.shouldPreserveFollowOpacity(node) : undefined
            });
        }
        isLead() {
            const stack = this.getStack();
            return stack ? stack.lead === this : true;
        }
        getLead() {
            var _a;
            const { layoutId: layoutId  } = this.options;
            return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
        }
        getPrevLead() {
            var _a;
            const { layoutId: layoutId  } = this.options;
            return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : undefined;
        }
        getStack() {
            const { layoutId: layoutId  } = this.options;
            if (layoutId) return this.root.sharedNodes.get(layoutId);
        }
        promote({ needsReset: needsReset , transition: transition , preserveFollowOpacity: preserveFollowOpacity  } = {}) {
            const stack = this.getStack();
            if (stack) stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition) this.setOptions({
                transition: transition
            });
        }
        relegate() {
            const stack = this.getStack();
            if (stack) return stack.relegate(this);
            else return false;
        }
        resetSkewAndRotation() {
            const { visualElement: visualElement  } = this.options;
            if (!visualElement) return;
            // If there's no detected skew or rotation values, we can early return without a forced render.
            let hasDistortingTransform = false;
            /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */ const { latestValues: latestValues  } = visualElement;
            if (latestValues.z || latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ || latestValues.skewX || latestValues.skewY) hasDistortingTransform = true;
            // If there's no distorting values, we don't need to do any more.
            if (!hasDistortingTransform) return;
            const resetValues = {};
            if (latestValues.z) $281d58aebf127403$var$resetDistortingTransform("z", visualElement, resetValues, this.animationValues);
            // Check the skew and rotate value of all axes and reset to 0
            for(let i = 0; i < $281d58aebf127403$var$transformAxes.length; i++){
                $281d58aebf127403$var$resetDistortingTransform(`rotate${$281d58aebf127403$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
                $281d58aebf127403$var$resetDistortingTransform(`skew${$281d58aebf127403$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
            }
            // Force a render of this element to apply the transform with all skews and rotations
            // set to 0.
            visualElement.render();
            // Put back all the values we reset
            for(const key in resetValues){
                visualElement.setStaticValue(key, resetValues[key]);
                if (this.animationValues) this.animationValues[key] = resetValues[key];
            }
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        }
        getProjectionStyles(styleProp) {
            var _a, _b;
            if (!this.instance || this.isSVG) return undefined;
            if (!this.isVisible) return $281d58aebf127403$var$hiddenVisibility;
            const styles = {
                visibility: ""
            };
            const transformTemplate = this.getTransformTemplate();
            if (this.needsReset) {
                this.needsReset = false;
                styles.opacity = "";
                styles.pointerEvents = (0, $9e7923b7600c25b9$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                styles.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                return styles;
            }
            const lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                const emptyStyles = {};
                if (this.options.layoutId) {
                    emptyStyles.opacity = this.latestValues.opacity !== undefined ? this.latestValues.opacity : 1;
                    emptyStyles.pointerEvents = (0, $9e7923b7600c25b9$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                }
                if (this.hasProjected && !(0, $fed21f2a9fad1fb9$export$a545127cf1fbb600)(this.latestValues)) {
                    emptyStyles.transform = transformTemplate ? transformTemplate({}, "") : "none";
                    this.hasProjected = false;
                }
                return emptyStyles;
            }
            const valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            styles.transform = (0, $bec23b122ca5d293$export$d33653b270fe725c)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) styles.transform = transformTemplate(valuesToRender, styles.transform);
            const { x: x , y: y  } = this.projectionDelta;
            styles.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
            if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ styles.opacity = lead === this ? (_b = (_a = valuesToRender.opacity) !== null && _a !== void 0 ? _a : this.latestValues.opacity) !== null && _b !== void 0 ? _b : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
            else /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */ styles.opacity = lead === this ? valuesToRender.opacity !== undefined ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== undefined ? valuesToRender.opacityExit : 0;
            /**
             * Apply scale correction
             */ for(const key in 0, $93233d74f0d10a65$export$91ddd985b97788d1){
                if (valuesToRender[key] === undefined) continue;
                const { correct: correct , applyTo: applyTo  } = (0, $93233d74f0d10a65$export$91ddd985b97788d1)[key];
                /**
                 * Only apply scale correction to the value if we have an
                 * active projection transform. Otherwise these values become
                 * vulnerable to distortion if the element changes size without
                 * a corresponding layout animation.
                 */ const corrected = styles.transform === "none" ? valuesToRender[key] : correct(valuesToRender[key], lead);
                if (applyTo) {
                    const num = applyTo.length;
                    for(let i = 0; i < num; i++)styles[applyTo[i]] = corrected;
                } else styles[key] = corrected;
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) styles.pointerEvents = lead === this ? (0, $9e7923b7600c25b9$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "" : "none";
            return styles;
        }
        clearSnapshot() {
            this.resumeFrom = this.snapshot = undefined;
        }
        // Only run on root
        resetTree() {
            this.root.nodes.forEach((node)=>{
                var _a;
                return (_a = node.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop();
            });
            this.root.nodes.forEach($281d58aebf127403$var$clearMeasurements);
            this.root.sharedNodes.clear();
        }
    };
}
function $281d58aebf127403$var$updateLayout(node) {
    node.updateLayout();
}
function $281d58aebf127403$var$notifyLayoutUpdate(node) {
    var _a;
    const snapshot = ((_a = node.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) || node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        const { layoutBox: layout , measuredBox: measuredLayout  } = node.layout;
        const { animationType: animationType  } = node.options;
        const isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") (0, $c68037220032f1d8$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $d9901b0e7f584a90$export$c1c127004b72a37)(axisSnapshot);
            axisSnapshot.min = layout[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if ($281d58aebf127403$var$shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) (0, $c68037220032f1d8$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $d9901b0e7f584a90$export$c1c127004b72a37)(layout[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
            /**
                 * Ensure relative target gets resized and rerendererd
                 */ if (node.relativeTarget && !node.currentAnimation) {
                node.isProjectionDirty = true;
                node.relativeTarget[axis].max = node.relativeTarget[axis].min + length;
            }
        });
        const layoutDelta = (0, $93b39ae61dedc877$export$3d227df54007d73a)();
        (0, $d9901b0e7f584a90$export$c0d25e96fc67d310)(layoutDelta, layout, snapshot.layoutBox);
        const visualDelta = (0, $93b39ae61dedc877$export$3d227df54007d73a)();
        if (isShared) (0, $d9901b0e7f584a90$export$c0d25e96fc67d310)(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        else (0, $d9901b0e7f584a90$export$c0d25e96fc67d310)(visualDelta, layout, snapshot.layoutBox);
        const hasLayoutChanged = !(0, $360ce5c67f749464$export$a7ec7642fe550fb6)(layoutDelta);
        let hasRelativeTargetChanged = false;
        if (!node.resumeFrom) {
            const relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (relativeParent && !relativeParent.resumeFrom) {
                const { snapshot: parentSnapshot , layout: parentLayout  } = relativeParent;
                if (parentSnapshot && parentLayout) {
                    const relativeSnapshot = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
                    (0, $d9901b0e7f584a90$export$2785bfcc929c5650)(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
                    const relativeLayout = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
                    (0, $d9901b0e7f584a90$export$2785bfcc929c5650)(relativeLayout, layout, parentLayout.layoutBox);
                    if (!(0, $360ce5c67f749464$export$ef641b782d85522)(relativeSnapshot, relativeLayout)) hasRelativeTargetChanged = true;
                    if (relativeParent.options.layoutRoot) {
                        node.relativeTarget = relativeLayout;
                        node.relativeTargetOrigin = relativeSnapshot;
                        node.relativeParent = relativeParent;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeTargetChanged: hasRelativeTargetChanged
        });
    } else if (node.isLead()) {
        const { onExitComplete: onExitComplete  } = node.options;
        onExitComplete && onExitComplete();
    }
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function $281d58aebf127403$export$131f2f0cc5fe9609(node) {
    /**
     * Increase debug counter for nodes encountered this frame
     */ if ($281d58aebf127403$var$isDebug) $281d58aebf127403$var$metrics.totalNodes++;
    if (!node.parent) return;
    /**
     * If this node isn't projecting, propagate isProjectionDirty. It will have
     * no performance impact but it will allow the next child that *is* projecting
     * but *isn't* dirty to just check its parent to see if *any* ancestor needs
     * correcting.
     */ if (!node.isProjecting()) node.isProjectionDirty = node.parent.isProjectionDirty;
    /**
     * Propagate isSharedProjectionDirty and isTransformDirty
     * throughout the whole tree. A future revision can take another look at
     * this but for safety we still recalcualte shared nodes.
     */ node.isSharedProjectionDirty || (node.isSharedProjectionDirty = Boolean(node.isProjectionDirty || node.parent.isProjectionDirty || node.parent.isSharedProjectionDirty));
    node.isTransformDirty || (node.isTransformDirty = node.parent.isTransformDirty);
}
function $281d58aebf127403$export$c2664f37bc951031(node) {
    node.isProjectionDirty = node.isSharedProjectionDirty = node.isTransformDirty = false;
}
function $281d58aebf127403$var$clearSnapshot(node) {
    node.clearSnapshot();
}
function $281d58aebf127403$var$clearMeasurements(node) {
    node.clearMeasurements();
}
function $281d58aebf127403$var$clearIsLayoutDirty(node) {
    node.isLayoutDirty = false;
}
function $281d58aebf127403$var$resetTransformStyle(node) {
    const { visualElement: visualElement  } = node.options;
    if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) visualElement.notify("BeforeLayoutMeasure");
    node.resetTransform();
}
function $281d58aebf127403$var$finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
    node.isProjectionDirty = true;
}
function $281d58aebf127403$var$resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function $281d58aebf127403$var$calcProjection(node) {
    node.calcProjection();
}
function $281d58aebf127403$var$resetSkewAndRotation(node) {
    node.resetSkewAndRotation();
}
function $281d58aebf127403$var$removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function $281d58aebf127403$export$91dbf443e1bf1de1(output, delta, p) {
    output.translate = (0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(delta.translate, 0, p);
    output.scale = (0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function $281d58aebf127403$export$8f9f6b0c76c773c7(output, from, to, p) {
    output.min = (0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(from.min, to.min, p);
    output.max = (0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(from.max, to.max, p);
}
function $281d58aebf127403$export$6ffd3e6ae339a132(output, from, to, p) {
    $281d58aebf127403$export$8f9f6b0c76c773c7(output.x, from.x, to.x, p);
    $281d58aebf127403$export$8f9f6b0c76c773c7(output.y, from.y, to.y, p);
}
function $281d58aebf127403$var$hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
const $281d58aebf127403$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
const $281d58aebf127403$var$userAgentContains = (string)=>typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(string);
/**
 * Measured bounding boxes must be rounded in Safari and
 * left untouched in Chrome, otherwise non-integer layouts within scaled-up elements
 * can appear to jump.
 */ const $281d58aebf127403$var$roundPoint = $281d58aebf127403$var$userAgentContains("applewebkit/") && !$281d58aebf127403$var$userAgentContains("chrome/") ? Math.round : (0, $c13dd6518645747b$export$8793edee2d425525);
function $281d58aebf127403$var$roundAxis(axis) {
    // Round to the nearest .5 pixels to support subpixel layouts
    axis.min = $281d58aebf127403$var$roundPoint(axis.min);
    axis.max = $281d58aebf127403$var$roundPoint(axis.max);
}
function $281d58aebf127403$var$roundBox(box) {
    $281d58aebf127403$var$roundAxis(box.x);
    $281d58aebf127403$var$roundAxis(box.y);
}
function $281d58aebf127403$var$shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return animationType === "position" || animationType === "preserve-aspect" && !(0, $d9901b0e7f584a90$export$28d0384c4b79bde2)((0, $360ce5c67f749464$export$c5706146bc63213)(snapshot), (0, $360ce5c67f749464$export$c5706146bc63213)(layout), 0.2);
}
function $281d58aebf127403$var$checkNodeWasScrollRoot(node) {
    var _a;
    return node !== node.root && ((_a = node.scroll) === null || _a === void 0 ? void 0 : _a.wasRoot);
}




const $b2724fa5a1f79278$export$2d029a49a09b6177 = (0, $281d58aebf127403$export$a84b61f69daa9da0)({
    attachResizeListener: (ref, notify)=>(0, $5727f053dc302d4d$export$b1d829ddf82884aa)(ref, "resize", notify),
    measureScroll: ()=>({
            x: document.documentElement.scrollLeft || document.body.scrollLeft,
            y: document.documentElement.scrollTop || document.body.scrollTop
        }),
    checkIsScrollRoot: ()=>true
});


const $e8dff807472b9243$export$b91509fcf893b648 = {
    current: undefined
};
const $e8dff807472b9243$export$b61a9eb3dbde8858 = (0, $281d58aebf127403$export$a84b61f69daa9da0)({
    measureScroll: (instance)=>({
            x: instance.scrollLeft,
            y: instance.scrollTop
        }),
    defaultParent: ()=>{
        if (!$e8dff807472b9243$export$b91509fcf893b648.current) {
            const documentNode = new (0, $b2724fa5a1f79278$export$2d029a49a09b6177)({});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            $e8dff807472b9243$export$b91509fcf893b648.current = documentNode;
        }
        return $e8dff807472b9243$export$b91509fcf893b648.current;
    },
    resetTransform: (instance, value)=>{
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: (instance)=>Boolean(window.getComputedStyle(instance).position === "fixed")
});


const $5e0aeefdd70dc82e$export$d7d5d435647ed5a0 = {
    pan: {
        Feature: (0, $a23e02b288283422$export$b4f8f1ee75ce5859)
    },
    drag: {
        Feature: (0, $012c82f716440bf2$export$5d97dc2872682820),
        ProjectionNode: (0, $e8dff807472b9243$export$b61a9eb3dbde8858),
        MeasureLayout: $b6e93d5d187b3d6c$export$779f5fb01ad751cd
    }
};






function $d74f51ccafbc2725$var$handleHoverEvent(node, event, lifecycle) {
    const { props: props  } = node;
    if (node.animationState && props.whileHover) node.animationState.setActive("whileHover", lifecycle === "Start");
    const eventName = "onHover" + lifecycle;
    const callback = props[eventName];
    if (callback) (0, $6491bdd13544fdda$export$2cef06c20297c17d).postRender(()=>callback(event, (0, $c20245f8d567b28b$export$12f84bb882d06e1a)(event)));
}
class $d74f51ccafbc2725$export$93a81ea037eac456 extends (0, $8c269db61902fb68$export$6e91cf7616333d5) {
    mount() {
        const { current: current  } = this.node;
        if (!current) return;
        this.unmount = (0, $62aebe68f5a3cc52$export$3f60957f5dbf3876)(current, (startEvent)=>{
            $d74f51ccafbc2725$var$handleHoverEvent(this.node, startEvent, "Start");
            return (endEvent)=>$d74f51ccafbc2725$var$handleHoverEvent(this.node, endEvent, "End");
        });
    }
    unmount() {}
}





class $194e5f2fba7dd91c$export$d4826db40d47595b extends (0, $8c269db61902fb68$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.isActive = false;
    }
    onFocus() {
        let isFocusVisible = false;
        /**
         * If this element doesn't match focus-visible then don't
         * apply whileHover. But, if matches throws that focus-visible
         * is not a valid selector then in that browser outline styles will be applied
         * to the element by default and we want to match that behaviour with whileFocus.
         */ try {
            isFocusVisible = this.node.current.matches(":focus-visible");
        } catch (e) {
            isFocusVisible = true;
        }
        if (!isFocusVisible || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", true);
        this.isActive = true;
    }
    onBlur() {
        if (!this.isActive || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", false);
        this.isActive = false;
    }
    mount() {
        this.unmount = (0, $6cc9e4dbba39be5c$export$a4627e546088548d)((0, $5727f053dc302d4d$export$b1d829ddf82884aa)(this.node.current, "focus", ()=>this.onFocus()), (0, $5727f053dc302d4d$export$b1d829ddf82884aa)(this.node.current, "blur", ()=>this.onBlur()));
    }
    unmount() {}
}






function $7978956cdecaf1df$var$handlePressEvent(node, event, lifecycle) {
    const { props: props  } = node;
    if (node.animationState && props.whileTap) node.animationState.setActive("whileTap", lifecycle === "Start");
    const eventName = "onTap" + (lifecycle === "End" ? "" : lifecycle);
    const callback = props[eventName];
    if (callback) (0, $6491bdd13544fdda$export$2cef06c20297c17d).postRender(()=>callback(event, (0, $c20245f8d567b28b$export$12f84bb882d06e1a)(event)));
}
class $7978956cdecaf1df$export$f026abdbba7f0c9e extends (0, $8c269db61902fb68$export$6e91cf7616333d5) {
    mount() {
        const { current: current  } = this.node;
        if (!current) return;
        this.unmount = (0, $1fb501146082d657$export$dbe9198142dace0c)(current, (startEvent)=>{
            $7978956cdecaf1df$var$handlePressEvent(this.node, startEvent, "Start");
            return (endEvent, { success: success  })=>$7978956cdecaf1df$var$handlePressEvent(this.node, endEvent, success ? "End" : "Cancel");
        }, {
            useGlobalTarget: this.node.props.globalTapTarget
        });
    }
    unmount() {}
}



/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ const $a7da81711d7ddff5$var$observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ const $a7da81711d7ddff5$var$observers = new WeakMap();
const $a7da81711d7ddff5$var$fireObserverCallback = (entry)=>{
    const callback = $a7da81711d7ddff5$var$observerCallbacks.get(entry.target);
    callback && callback(entry);
};
const $a7da81711d7ddff5$var$fireAllObserverCallbacks = (entries)=>{
    entries.forEach($a7da81711d7ddff5$var$fireObserverCallback);
};
function $a7da81711d7ddff5$var$initIntersectionObserver({ root: root , ...options }) {
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!$a7da81711d7ddff5$var$observers.has(lookupRoot)) $a7da81711d7ddff5$var$observers.set(lookupRoot, {});
    const rootObservers = $a7da81711d7ddff5$var$observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver($a7da81711d7ddff5$var$fireAllObserverCallbacks, {
        root: root,
        ...options
    });
    return rootObservers[key];
}
function $a7da81711d7ddff5$export$b2bcd62fb7925aa5(element, options, callback) {
    const rootInteresectionObserver = $a7da81711d7ddff5$var$initIntersectionObserver(options);
    $a7da81711d7ddff5$var$observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return ()=>{
        $a7da81711d7ddff5$var$observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}


const $62d26f27ee79826d$var$thresholdNames = {
    some: 0,
    all: 1
};
class $62d26f27ee79826d$export$150851c8cc2f0c72 extends (0, $8c269db61902fb68$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.hasEnteredView = false;
        this.isInView = false;
    }
    startObserver() {
        this.unmount();
        const { viewport: viewport = {}  } = this.node.getProps();
        const { root: root , margin: rootMargin , amount: amount = "some" , once: once  } = viewport;
        const options = {
            root: root ? root.current : undefined,
            rootMargin: rootMargin,
            threshold: typeof amount === "number" ? amount : $62d26f27ee79826d$var$thresholdNames[amount]
        };
        const onIntersectionUpdate = (entry)=>{
            const { isIntersecting: isIntersecting  } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */ if (this.isInView === isIntersecting) return;
            this.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && this.hasEnteredView) return;
            else if (isIntersecting) this.hasEnteredView = true;
            if (this.node.animationState) this.node.animationState.setActive("whileInView", isIntersecting);
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ const { onViewportEnter: onViewportEnter , onViewportLeave: onViewportLeave  } = this.node.getProps();
            const callback = isIntersecting ? onViewportEnter : onViewportLeave;
            callback && callback(entry);
        };
        return (0, $a7da81711d7ddff5$export$b2bcd62fb7925aa5)(this.node.current, options, onIntersectionUpdate);
    }
    mount() {
        this.startObserver();
    }
    update() {
        if (typeof IntersectionObserver === "undefined") return;
        const { props: props , prevProps: prevProps  } = this.node;
        const hasOptionsChanged = [
            "amount",
            "margin",
            "root"
        ].some($62d26f27ee79826d$var$hasViewportOptionChanged(props, prevProps));
        if (hasOptionsChanged) this.startObserver();
    }
    unmount() {}
}
function $62d26f27ee79826d$var$hasViewportOptionChanged({ viewport: viewport = {}  }, { viewport: prevViewport = {}  } = {}) {
    return (name)=>viewport[name] !== prevViewport[name];
}


const $aadd72d7ca06bd3a$export$e5b72898e5a201f1 = {
    inView: {
        Feature: (0, $62d26f27ee79826d$export$150851c8cc2f0c72)
    },
    tap: {
        Feature: (0, $7978956cdecaf1df$export$f026abdbba7f0c9e)
    },
    focus: {
        Feature: (0, $194e5f2fba7dd91c$export$d4826db40d47595b)
    },
    hover: {
        Feature: (0, $d74f51ccafbc2725$export$93a81ea037eac456)
    }
};




const $17a320fc4896a503$export$b3219800bda33a1f = {
    layout: {
        ProjectionNode: (0, $e8dff807472b9243$export$b61a9eb3dbde8858),
        MeasureLayout: $b6e93d5d187b3d6c$export$779f5fb01ad751cd
    }
};




var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");
"use client";
/**
 * @public
 */ const $f69ceb430ae9345a$export$22a697fb29aac98d = (0, $bh6RR.createContext)({
    transformPagePoint: (p)=>p,
    isStatic: false,
    reducedMotion: "never"
});



var $bh6RR = parcelRequire("bh6RR");
"use client";
const $38e1c7c15d587098$export$2285bbca2c666415 = (0, $bh6RR.createContext)({});



var $bh6RR = parcelRequire("bh6RR");



var $bh6RR = parcelRequire("bh6RR");
const $0ec11121663cc82b$export$4e09c449d6c407f7 = typeof window !== "undefined";


const $56377e0c81527360$export$700979bc83e7db82 = (0, $0ec11121663cc82b$export$4e09c449d6c407f7) ? (0, $bh6RR.useLayoutEffect) : (0, $bh6RR.useEffect);



var $bh6RR = parcelRequire("bh6RR");
"use client";
const $6a5cdc65c5393968$export$40f10139ecf1f171 = (0, $bh6RR.createContext)({
    strict: false
});







function $05aa2ab8e054331c$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement, ProjectionNodeConstructor) {
    var _a, _b;
    const { visualElement: parent  } = (0, $bh6RR.useContext)((0, $38e1c7c15d587098$export$2285bbca2c666415));
    const lazyContext = (0, $bh6RR.useContext)((0, $6a5cdc65c5393968$export$40f10139ecf1f171));
    const presenceContext = (0, $bh6RR.useContext)((0, $12e60920c2394b39$export$f224e4635b6f8ce2));
    const reducedMotionConfig = (0, $bh6RR.useContext)((0, $f69ceb430ae9345a$export$22a697fb29aac98d)).reducedMotion;
    const visualElementRef = (0, $bh6RR.useRef)(null);
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState: visualState,
        parent: parent,
        props: props,
        presenceContext: presenceContext,
        blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
        reducedMotionConfig: reducedMotionConfig
    });
    const visualElement = visualElementRef.current;
    /**
     * Load Motion gesture and animation features. These are rendered as renderless
     * components so each feature can optionally make use of React lifecycle methods.
     */ const initialLayoutGroupConfig = (0, $bh6RR.useContext)((0, $b8a0e6b50203ba18$export$da5f7b802957459a));
    if (visualElement && !visualElement.projection && ProjectionNodeConstructor && (visualElement.type === "html" || visualElement.type === "svg")) $05aa2ab8e054331c$var$createProjectionNode(visualElementRef.current, props, ProjectionNodeConstructor, initialLayoutGroupConfig);
    const isMounted = (0, $bh6RR.useRef)(false);
    (0, $bh6RR.useInsertionEffect)(()=>{
        /**
         * Check the component has already mounted before calling
         * `update` unnecessarily. This ensures we skip the initial update.
         */ if (visualElement && isMounted.current) visualElement.update(props, presenceContext);
    });
    /**
     * Cache this value as we want to know whether HandoffAppearAnimations
     * was present on initial render - it will be deleted after this.
     */ const optimisedAppearId = props[0, $6b140fcbcf20767d$export$8592e1c077c890a6];
    const wantsHandoff = (0, $bh6RR.useRef)(Boolean(optimisedAppearId) && !((_a = window.MotionHandoffIsComplete) === null || _a === void 0 ? void 0 : _a.call(window, optimisedAppearId)) && ((_b = window.MotionHasOptimisedAnimation) === null || _b === void 0 ? void 0 : _b.call(window, optimisedAppearId)));
    (0, $56377e0c81527360$export$700979bc83e7db82)(()=>{
        if (!visualElement) return;
        isMounted.current = true;
        window.MotionIsMounted = true;
        visualElement.updateFeatures();
        (0, $3858c82cd1ca695a$export$bb76eed83315504c).render(visualElement.render);
        /**
         * Ideally this function would always run in a useEffect.
         *
         * However, if we have optimised appear animations to handoff from,
         * it needs to happen synchronously to ensure there's no flash of
         * incorrect styles in the event of a hydration error.
         *
         * So if we detect a situtation where optimised appear animations
         * are running, we use useLayoutEffect to trigger animations.
         */ if (wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
    });
    (0, $bh6RR.useEffect)(()=>{
        if (!visualElement) return;
        if (!wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
        if (wantsHandoff.current) {
            // This ensures all future calls to animateChanges() in this component will run in useEffect
            queueMicrotask(()=>{
                var _a;
                (_a = window.MotionHandoffMarkAsComplete) === null || _a === void 0 || _a.call(window, optimisedAppearId);
            });
            wantsHandoff.current = false;
        }
    });
    return visualElement;
}
function $05aa2ab8e054331c$var$createProjectionNode(visualElement, props, ProjectionNodeConstructor, initialPromotionConfig) {
    const { layoutId: layoutId , layout: layout , drag: drag , dragConstraints: dragConstraints , layoutScroll: layoutScroll , layoutRoot: layoutRoot  } = props;
    visualElement.projection = new ProjectionNodeConstructor(visualElement.latestValues, props["data-framer-portal-id"] ? undefined : $05aa2ab8e054331c$var$getClosestProjectingNode(visualElement.parent));
    visualElement.projection.setOptions({
        layoutId: layoutId,
        layout: layout,
        alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $0dc8dc297bc3aa83$export$dedd81df7bc1307)(dragConstraints),
        visualElement: visualElement,
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */ animationType: typeof layout === "string" ? layout : "both",
        initialPromotionConfig: initialPromotionConfig,
        layoutScroll: layoutScroll,
        layoutRoot: layoutRoot
    });
}
function $05aa2ab8e054331c$var$getClosestProjectingNode(visualElement) {
    if (!visualElement) return undefined;
    return visualElement.options.allowProjection !== false ? visualElement.projection : $05aa2ab8e054331c$var$getClosestProjectingNode(visualElement.parent);
}



var $bh6RR = parcelRequire("bh6RR");

/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $29bcaad27b8bb245$export$c684914703d321fd(visualState, visualElement, externalRef) {
    return (0, $bh6RR.useCallback)((instance)=>{
        instance && visualState.mount && visualState.mount(instance);
        if (visualElement) {
            if (instance) visualElement.mount(instance);
            else visualElement.unmount();
        }
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, $0dc8dc297bc3aa83$export$dedd81df7bc1307)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */ [
        visualElement
    ]);
}



var $bh6RR = parcelRequire("bh6RR");





function $a01dc07902ba23d1$export$4b3c3bd8d910d78d(props) {
    return (0, $6c424f3bd35daf15$export$aa71198ceeaf53ce)(props.animate) || (0, $eb6a0a2a824114cd$export$1405a65085f40b9).some((name)=>(0, $e4ec7857057a08b6$export$720b90e312cea233)(props[name]));
}
function $a01dc07902ba23d1$export$ce46fa4165cdec40(props) {
    return Boolean($a01dc07902ba23d1$export$4b3c3bd8d910d78d(props) || props.variants);
}


function $be811e3f75d8f6fc$export$12fc32fc096a04a3(props, context) {
    if ((0, $a01dc07902ba23d1$export$4b3c3bd8d910d78d)(props)) {
        const { initial: initial , animate: animate  } = props;
        return {
            initial: initial === false || (0, $e4ec7857057a08b6$export$720b90e312cea233)(initial) ? initial : undefined,
            animate: (0, $e4ec7857057a08b6$export$720b90e312cea233)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}


function $a6e92297d8c984af$export$c5638d843b37a176(props) {
    const { initial: initial , animate: animate  } = (0, $be811e3f75d8f6fc$export$12fc32fc096a04a3)(props, (0, $bh6RR.useContext)((0, $38e1c7c15d587098$export$2285bbca2c666415)));
    return (0, $bh6RR.useMemo)(()=>({
            initial: initial,
            animate: animate
        }), [
        $a6e92297d8c984af$var$variantLabelsAsDependency(initial),
        $a6e92297d8c984af$var$variantLabelsAsDependency(animate)
    ]);
}
function $a6e92297d8c984af$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}


const $145d8d26c6dc52b8$var$featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag"
    ],
    exit: [
        "exit"
    ],
    drag: [
        "drag",
        "dragControls"
    ],
    focus: [
        "whileFocus"
    ],
    hover: [
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ],
    tap: [
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ],
    pan: [
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ],
    inView: [
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ],
    layout: [
        "layout",
        "layoutId"
    ]
};
const $145d8d26c6dc52b8$export$65570e08d843624d = {};
for(const key in $145d8d26c6dc52b8$var$featureProps)$145d8d26c6dc52b8$export$65570e08d843624d[key] = {
    isEnabled: (props)=>$145d8d26c6dc52b8$var$featureProps[key].some((name)=>!!props[name])
};


function $8223c64d87d3460d$export$449561ec5703cdc8(features) {
    for(const key in features)(0, $145d8d26c6dc52b8$export$65570e08d843624d)[key] = {
        ...(0, $145d8d26c6dc52b8$export$65570e08d843624d)[key],
        ...features[key]
    };
}





const $92847778545e8ed0$export$28e2e4cce424ae23 = Symbol.for("motionComponentSymbol");




"use client";
/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function $0c5a031ea8dd3973$export$c3ad4a902bccc2d8({ preloadedFeatures: preloadedFeatures , createVisualElement: createVisualElement , useRender: useRender , useVisualState: useVisualState , Component: Component  }) {
    preloadedFeatures && (0, $8223c64d87d3460d$export$449561ec5703cdc8)(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        /**
         * If we need to measure the element we load this functionality in a
         * separate class component in order to gain access to getSnapshotBeforeUpdate.
         */ let MeasureLayout;
        const configAndProps = {
            ...(0, $bh6RR.useContext)((0, $f69ceb430ae9345a$export$22a697fb29aac98d)),
            ...props,
            layoutId: $0c5a031ea8dd3973$var$useLayoutId(props)
        };
        const { isStatic: isStatic  } = configAndProps;
        const context = (0, $a6e92297d8c984af$export$c5638d843b37a176)(props);
        const visualState = useVisualState(props, isStatic);
        if (!isStatic && (0, $0ec11121663cc82b$export$4e09c449d6c407f7)) {
            $0c5a031ea8dd3973$var$useStrictMode(configAndProps, preloadedFeatures);
            const layoutProjection = $0c5a031ea8dd3973$var$getProjectionFunctionality(configAndProps);
            MeasureLayout = layoutProjection.MeasureLayout;
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $05aa2ab8e054331c$export$dc0335d73ab0b115)(Component, visualState, configAndProps, createVisualElement, layoutProjection.ProjectionNode);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return (0, $d4dab640dcbe486c$exports.jsxs)((0, $38e1c7c15d587098$export$2285bbca2c666415).Provider, {
            value: context,
            children: [
                MeasureLayout && context.visualElement ? (0, $d4dab640dcbe486c$exports.jsx)(MeasureLayout, {
                    visualElement: context.visualElement,
                    ...configAndProps
                }) : null,
                useRender(Component, props, (0, $29bcaad27b8bb245$export$c684914703d321fd)(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement)
            ]
        });
    }
    const ForwardRefMotionComponent = (0, $bh6RR.forwardRef)(MotionComponent);
    ForwardRefMotionComponent[0, $92847778545e8ed0$export$28e2e4cce424ae23] = Component;
    return ForwardRefMotionComponent;
}
function $0c5a031ea8dd3973$var$useLayoutId({ layoutId: layoutId  }) {
    const layoutGroupId = (0, $bh6RR.useContext)((0, $364741b44296b530$export$a3579ca508007a95)).id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}
function $0c5a031ea8dd3973$var$useStrictMode(configAndProps, preloadedFeatures) {
    const isStrict = (0, $bh6RR.useContext)((0, $6a5cdc65c5393968$export$40f10139ecf1f171)).strict;
}
function $0c5a031ea8dd3973$var$getProjectionFunctionality(props) {
    const { drag: drag , layout: layout  } = (0, $145d8d26c6dc52b8$export$65570e08d843624d);
    if (!drag && !layout) return {};
    const combined = {
        ...drag,
        ...layout
    };
    return {
        MeasureLayout: (drag === null || drag === void 0 ? void 0 : drag.isEnabled(props)) || (layout === null || layout === void 0 ? void 0 : layout.isEnabled(props)) ? combined.MeasureLayout : undefined,
        ProjectionNode: combined.ProjectionNode
    };
}


/**
 * We keep these listed separately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ const $c47a60ce42aa9a7c$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view"
];


function $f9a5862a9160f78d$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $c47a60ce42aa9a7c$export$40209c4c512158e6).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/u.test(Component)) return true;
    return false;
}



function $46b26a876b49a8ee$export$1a32bf6229c258c0(element, { style: style , vars: vars  }, styleProp, projection) {
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    // Loop over any CSS variables and assign those.
    for(const key in vars)element.style.setProperty(key, vars[key]);
}


/**
 * A set of attribute names that are always read/written as camel case.
 */ const $896574d8c8ac028d$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);


function $50c74351dd8901bc$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $46b26a876b49a8ee$export$1a32bf6229c258c0)(element, renderState, undefined, projection);
    for(const key in renderState.attrs)element.setAttribute(!(0, $896574d8c8ac028d$export$28931db5d57958e5).has(key) ? (0, $002b84d235cc9e7f$export$9fd24a634729c672)(key) : key, renderState.attrs[key]);
}





function $3ba7f2184a7a36c2$export$6d27ce8e3de1c3cf(key, { layout: layout , layoutId: layoutId  }) {
    return (0, $05d385f303970557$export$7b42a0094fb00b6e).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, $93233d74f0d10a65$export$91ddd985b97788d1)[key] || key === "opacity");
}



function $c0a33d9fc770b07f$export$16da615486abaa45(props, prevProps, visualElement) {
    var _a;
    const { style: style  } = props;
    const newValues = {};
    for(const key in style)if ((0, $d449570363f09a53$export$605d60a2578142d3)(style[key]) || prevProps.style && (0, $d449570363f09a53$export$605d60a2578142d3)(prevProps.style[key]) || (0, $3ba7f2184a7a36c2$export$6d27ce8e3de1c3cf)(key, props) || ((_a = visualElement === null || visualElement === void 0 ? void 0 : visualElement.getValue(key)) === null || _a === void 0 ? void 0 : _a.liveStyle) !== undefined) newValues[key] = style[key];
    return newValues;
}



function $4c234d289d8baf9a$export$16da615486abaa45(props, prevProps, visualElement) {
    const newValues = (0, $c0a33d9fc770b07f$export$16da615486abaa45)(props, prevProps, visualElement);
    for(const key in props)if ((0, $d449570363f09a53$export$605d60a2578142d3)(props[key]) || (0, $d449570363f09a53$export$605d60a2578142d3)(prevProps[key])) {
        const targetKey = (0, $05d385f303970557$export$280dc01950909d86).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}



var $bh6RR = parcelRequire("bh6RR");




var $bh6RR = parcelRequire("bh6RR");
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $9237e2773f81c3d0$export$fe4300aa8eebea86(init) {
    const ref = (0, $bh6RR.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}





function $e82a2bc47b563e2e$var$makeState({ scrapeMotionValuesFromProps: scrapeMotionValuesFromProps , createRenderState: createRenderState , onMount: onMount  }, props, context, presenceContext) {
    const state = {
        latestValues: $e82a2bc47b563e2e$var$makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    if (onMount) state.mount = (instance)=>onMount(props, instance, state);
    return state;
}
const $e82a2bc47b563e2e$export$e91e107bc6d03a8e = (config)=>(props, isStatic)=>{
        const context = (0, $bh6RR.useContext)((0, $38e1c7c15d587098$export$2285bbca2c666415));
        const presenceContext = (0, $bh6RR.useContext)((0, $12e60920c2394b39$export$f224e4635b6f8ce2));
        const make = ()=>$e82a2bc47b563e2e$var$makeState(config, props, context, presenceContext);
        return isStatic ? make() : (0, $9237e2773f81c3d0$export$fe4300aa8eebea86)(make);
    };
function $e82a2bc47b563e2e$var$makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    const values = {};
    const motionValues = scrapeMotionValues(props, {});
    for(const key in motionValues)values[key] = (0, $9e7923b7600c25b9$export$fcc2206ecb6d74b)(motionValues[key]);
    let { initial: initial , animate: animate  } = props;
    const isControllingVariants$1 = (0, $a01dc07902ba23d1$export$4b3c3bd8d910d78d)(props);
    const isVariantNode$1 = (0, $a01dc07902ba23d1$export$ce46fa4165cdec40)(props);
    if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
        if (initial === undefined) initial = context.initial;
        if (animate === undefined) animate = context.animate;
    }
    let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    const variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $6c424f3bd35daf15$export$aa71198ceeaf53ce)(variantToSet)) {
        const list = Array.isArray(variantToSet) ? variantToSet : [
            variantToSet
        ];
        for(let i = 0; i < list.length; i++){
            const resolved = (0, $960c679efe64d12b$export$d68f140c4d9b48bc)(props, list[i]);
            if (resolved) {
                const { transitionEnd: transitionEnd , transition: transition , ...target } = resolved;
                for(const key in target){
                    let valueTarget = target[key];
                    if (Array.isArray(valueTarget)) {
                        /**
                         * Take final keyframe if the initial animation is blocked because
                         * we want to initialise at the end of that blocked animation.
                         */ const index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
                        valueTarget = valueTarget[index];
                    }
                    if (valueTarget !== null) values[key] = valueTarget;
                }
                for(const key in transitionEnd)values[key] = transitionEnd[key];
            }
        }
    }
    return values;
}


const $44dd7fb05ec6c3e6$export$8940b483cf52eeda = ()=>({
        style: {},
        transform: {},
        transformOrigin: {},
        vars: {}
    });


const $a6f7f4461a184c55$export$41be8b43e1c4d4f9 = ()=>({
        ...(0, $44dd7fb05ec6c3e6$export$8940b483cf52eeda)(),
        attrs: {}
    });



/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ const $40c56554da907737$export$453ef540a9a1bd6b = (value, type)=>{
    return type && typeof value === "number" ? type.transform(value) : value;
};



const $6330a89fb7e6648e$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
const $6330a89fb7e6648e$var$numTransforms = (0, $05d385f303970557$export$280dc01950909d86).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $6330a89fb7e6648e$export$bdc96e0d5c8f914(latestValues, transform, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    let transformIsDefault = true;
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(let i = 0; i < $6330a89fb7e6648e$var$numTransforms; i++){
        const key = (0, $05d385f303970557$export$280dc01950909d86)[i];
        const value = latestValues[key];
        if (value === undefined) continue;
        let valueIsDefault = true;
        if (typeof value === "number") valueIsDefault = value === (key.startsWith("scale") ? 1 : 0);
        else valueIsDefault = parseFloat(value) === 0;
        if (!valueIsDefault || transformTemplate) {
            const valueAsType = (0, $40c56554da907737$export$453ef540a9a1bd6b)(value, (0, $e26e0ac69c88d1e3$export$eec14432cd1cb67b)[key]);
            if (!valueIsDefault) {
                transformIsDefault = false;
                const transformName = $6330a89fb7e6648e$var$translateAlias[key] || key;
                transformString += `${transformName}(${valueAsType}) `;
            }
            if (transformTemplate) transform[key] = valueAsType;
        }
    }
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (transformIsDefault) transformString = "none";
    return transformString;
}






function $5a314cc097974a58$export$bb517f8b40f8e99d(state, latestValues, transformTemplate) {
    const { style: style , vars: vars , transformOrigin: transformOrigin  } = state;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept separately for further processing.
     */ for(const key in latestValues){
        const value = latestValues[key];
        if ((0, $05d385f303970557$export$7b42a0094fb00b6e).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            continue;
        } else if ((0, $9223341d00255d67$export$9de1236619d9e756)(key)) {
            vars[key] = value;
            continue;
        } else {
            // Convert the value to its default value type, ie 0 -> "0px"
            const valueAsType = (0, $40c56554da907737$export$453ef540a9a1bd6b)(value, (0, $e26e0ac69c88d1e3$export$eec14432cd1cb67b)[key]);
            if (key.startsWith("origin")) {
                // If this is a transform origin, flag and enable further transform-origin processing
                hasTransformOrigin = true;
                transformOrigin[key] = valueAsType;
            } else style[key] = valueAsType;
        }
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, $6330a89fb7e6648e$export$bdc96e0d5c8f914)(latestValues, state.transform, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        const { originX: originX = "50%" , originY: originY = "50%" , originZ: originZ = 0  } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}



function $72f78baea8d3959f$var$calcOrigin(origin, offset, size) {
    return typeof origin === "string" ? origin : (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008).transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */ function $72f78baea8d3959f$export$d4fbcfc8e5472155(dimensions, originX, originY) {
    const pxOriginX = $72f78baea8d3959f$var$calcOrigin(originX, dimensions.x, dimensions.width);
    const pxOriginY = $72f78baea8d3959f$var$calcOrigin(originY, dimensions.y, dimensions.height);
    return `${pxOriginX} ${pxOriginY}`;
}



const $3fd910e6a82125ad$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
const $3fd910e6a82125ad$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $3fd910e6a82125ad$export$311b43f666da1d82(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? $3fd910e6a82125ad$var$dashKeys : $3fd910e6a82125ad$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008).transform(-offset);
    // Build the dash array
    const pathLength = (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008).transform(length);
    const pathSpacing = (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008).transform(spacing);
    attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}


/**
 * Build SVG visual attrbutes, like cx and style.transform
 */ function $6f8e2d5207755192$export$5475d24f125d7053(state, { attrX: attrX , attrY: attrY , attrScale: attrScale , originX: originX , originY: originY , pathLength: pathLength , pathSpacing: pathSpacing = 1 , pathOffset: pathOffset = 0 , // This is object creation, which we try to avoid per-frame.
...latest }, isSVGTag, transformTemplate) {
    (0, $5a314cc097974a58$export$bb517f8b40f8e99d)(state, latest, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs: attrs , style: style , dimensions: dimensions  } = state;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */ if (attrs.transform) {
        if (dimensions) style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) style.transformOrigin = (0, $72f78baea8d3959f$export$d4fbcfc8e5472155)(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $3fd910e6a82125ad$export$311b43f666da1d82)(attrs, pathLength, pathSpacing, pathOffset, false);
}


const $5c8095c47c03f29b$export$6328ce7565ea1049 = (tag)=>typeof tag === "string" && tag.toLowerCase() === "svg";



const $ecbb32c06e7c035d$export$44dabd3fae512e85 = {
    useVisualState: (0, $e82a2bc47b563e2e$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: (0, $4c234d289d8baf9a$export$16da615486abaa45),
        createRenderState: (0, $a6f7f4461a184c55$export$41be8b43e1c4d4f9),
        onMount: (props, instance, { renderState: renderState , latestValues: latestValues  })=>{
            (0, $6491bdd13544fdda$export$2cef06c20297c17d).read(()=>{
                try {
                    renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
                } catch (e) {
                    // Most likely trying to measure an unrendered element under Firefox
                    renderState.dimensions = {
                        x: 0,
                        y: 0,
                        width: 0,
                        height: 0
                    };
                }
            });
            (0, $6491bdd13544fdda$export$2cef06c20297c17d).render(()=>{
                (0, $6f8e2d5207755192$export$5475d24f125d7053)(renderState, latestValues, (0, $5c8095c47c03f29b$export$6328ce7565ea1049)(instance.tagName), props.transformTemplate);
                (0, $50c74351dd8901bc$export$c5f8399d19a7394b)(instance, renderState);
            });
        }
    })
};





const $cb524d462e20deb3$export$e13ea21d87ea57c8 = {
    useVisualState: (0, $e82a2bc47b563e2e$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: $c0a33d9fc770b07f$export$16da615486abaa45,
        createRenderState: (0, $44dd7fb05ec6c3e6$export$8940b483cf52eeda)
    })
};



var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");




function $1988bd02b7e1d29b$export$40dafdb8630c956b(target, source, props) {
    for(const key in source)if (!(0, $d449570363f09a53$export$605d60a2578142d3)(source[key]) && !(0, $3ba7f2184a7a36c2$export$6d27ce8e3de1c3cf)(key, props)) target[key] = source[key];
}
function $1988bd02b7e1d29b$var$useInitialMotionValues({ transformTemplate: transformTemplate  }, visualState) {
    return (0, $bh6RR.useMemo)(()=>{
        const state = (0, $44dd7fb05ec6c3e6$export$8940b483cf52eeda)();
        (0, $5a314cc097974a58$export$bb517f8b40f8e99d)(state, visualState, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [
        visualState
    ]);
}
function $1988bd02b7e1d29b$var$useStyle(props, visualState) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $1988bd02b7e1d29b$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $1988bd02b7e1d29b$var$useInitialMotionValues(props, visualState));
    return style;
}
function $1988bd02b7e1d29b$export$57be0a314572d87d(props, visualState) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = $1988bd02b7e1d29b$var$useStyle(props, visualState);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    if (props.tabIndex === undefined && (props.onTap || props.onTapStart || props.whileTap)) htmlProps.tabIndex = 0;
    htmlProps.style = style;
    return htmlProps;
}


/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ const $a022688aad5e3d50$var$validMotionProps = new Set([
    "animate",
    "exit",
    "variants",
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "custom",
    "inherit",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "_dragX",
    "_dragY",
    "onHoverStart",
    "onHoverEnd",
    "onViewportEnter",
    "onViewportLeave",
    "globalTapTarget",
    "ignoreStrict",
    "viewport"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $a022688aad5e3d50$export$2f9c46555243bf04(key) {
    return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || key.startsWith("onLayout") || $a022688aad5e3d50$var$validMotionProps.has(key);
}


let $2d7757648940a601$var$shouldForward = (key)=>!(0, $a022688aad5e3d50$export$2f9c46555243bf04)(key);
function $2d7757648940a601$export$59d6962c470509a5(isValidProp) {
    if (!isValidProp) return;
    // Explicitly filter our events
    $2d7757648940a601$var$shouldForward = (key)=>key.startsWith("on") ? !(0, $a022688aad5e3d50$export$2f9c46555243bf04)(key) : isValidProp(key);
}

/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */ $2d7757648940a601$export$59d6962c470509a5((parcelRequire("e94ba")).default);
} catch (_a) {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $2d7757648940a601$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for(const key in props){
        /**
         * values is considered a valid prop by Emotion, so if it's present
         * this will be rendered out to the DOM unless explicitly filtered.
         *
         * We check the type as it could be used with the `feColorMatrix`
         * element, which we support.
         */ if (key === "values" && typeof props.values === "object") continue;
        if ($2d7757648940a601$var$shouldForward(key) || forwardMotionProps === true && (0, $a022688aad5e3d50$export$2f9c46555243bf04)(key) || !isDom && !(0, $a022688aad5e3d50$export$2f9c46555243bf04)(key) || // If trying to use native HTML drag events, forward drag listeners
        props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    }
    return filteredProps;
}




var $bh6RR = parcelRequire("bh6RR");




function $f708387b704893ba$export$84309c4f53cb1bd5(props, visualState, _isStatic, Component) {
    const visualProps = (0, $bh6RR.useMemo)(()=>{
        const state = (0, $a6f7f4461a184c55$export$41be8b43e1c4d4f9)();
        (0, $6f8e2d5207755192$export$5475d24f125d7053)(state, visualState, (0, $5c8095c47c03f29b$export$6328ce7565ea1049)(Component), props.transformTemplate);
        return {
            ...state.attrs,
            style: {
                ...state.style
            }
        };
    }, [
        visualState
    ]);
    if (props.style) {
        const rawStyles = {};
        (0, $1988bd02b7e1d29b$export$40dafdb8630c956b)(rawStyles, props.style, props);
        visualProps.style = {
            ...rawStyles,
            ...visualProps.style
        };
    }
    return visualProps;
}



function $890426a95a69aae0$export$5d29104eefd89cc8(forwardMotionProps = false) {
    const useRender = (Component, props, ref, { latestValues: latestValues  }, isStatic)=>{
        const useVisualProps = (0, $f9a5862a9160f78d$export$88f3fc2fd3766989)(Component) ? (0, $f708387b704893ba$export$84309c4f53cb1bd5) : (0, $1988bd02b7e1d29b$export$57be0a314572d87d);
        const visualProps = useVisualProps(props, latestValues, isStatic, Component);
        const filteredProps = (0, $2d7757648940a601$export$d697c39a2985a4c)(props, typeof Component === "string", forwardMotionProps);
        const elementProps = Component !== (0, $bh6RR.Fragment) ? {
            ...filteredProps,
            ...visualProps,
            ref: ref
        } : {};
        /**
         * If component has been handed a motion value as its child,
         * memoise its initial value and render that. Subsequent updates
         * will be handled by the onChange handler
         */ const { children: children  } = props;
        const renderedChildren = (0, $bh6RR.useMemo)(()=>(0, $d449570363f09a53$export$605d60a2578142d3)(children) ? children.get() : children, [
            children
        ]);
        return (0, $bh6RR.createElement)(Component, {
            ...elementProps,
            children: renderedChildren
        });
    };
    return useRender;
}


function $047ad38a006b91b1$export$d86feac869a7f0d5(preloadedFeatures, createVisualElement) {
    return function createMotionComponent(Component, { forwardMotionProps: forwardMotionProps  } = {
        forwardMotionProps: false
    }) {
        const baseConfig = (0, $f9a5862a9160f78d$export$88f3fc2fd3766989)(Component) ? (0, $ecbb32c06e7c035d$export$44dabd3fae512e85) : (0, $cb524d462e20deb3$export$e13ea21d87ea57c8);
        const config = {
            ...baseConfig,
            preloadedFeatures: preloadedFeatures,
            useRender: (0, $890426a95a69aae0$export$5d29104eefd89cc8)(forwardMotionProps),
            createVisualElement: createVisualElement,
            Component: Component
        };
        return (0, $0c5a031ea8dd3973$export$c3ad4a902bccc2d8)(config);
    };
}



var $bh6RR = parcelRequire("bh6RR");








// Does this device prefer reduced motion? Returns `null` server-side.
const $16faa30fcf534207$export$ff7706047246b98b = {
    current: null
};
const $16faa30fcf534207$export$6476d16e2fd2d0db = {
    current: false
};


function $8c52f85ab085b323$export$ca9f41fb23dded3d() {
    (0, $16faa30fcf534207$export$6476d16e2fd2d0db).current = true;
    if (!(0, $0ec11121663cc82b$export$4e09c449d6c407f7)) return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = ()=>(0, $16faa30fcf534207$export$ff7706047246b98b).current = motionMediaQuery.matches;
        motionMediaQuery.addListener(setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, $16faa30fcf534207$export$ff7706047246b98b).current = false;
}











function $c1ce9b34358097f3$export$9a552858d5197f6e(element, next, prev) {
    for(const key in next){
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0, $d449570363f09a53$export$605d60a2578142d3)(nextValue)) /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
        else if ((0, $d449570363f09a53$export$605d60a2578142d3)(prevValue)) /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $925342fde4532b85$export$ce8bdc721e76545f)(nextValue, {
            owner: element
        }));
        else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                if (existingValue.liveStyle === true) existingValue.jump(nextValue);
                else if (!existingValue.hasAnimated) existingValue.set(nextValue);
            } else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, (0, $925342fde4532b85$export$ce8bdc721e76545f)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(const key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}





const $7680e86648d809f1$export$bc2a978a17abfdde = new WeakMap();









/**
 * A list of all ValueTypes
 */ const $3f77fa41782f639b$var$valueTypes = [
    ...(0, $d03d4f627f09ffbd$export$d176691c1998a1f5),
    (0, $7a26ed3125820d32$export$35e9368ef982300f),
    (0, $a554c66132092e1c$export$83a0e34f1302825b)
];
/**
 * Tests a value against the list of ValueTypes
 */ const $3f77fa41782f639b$export$950e7e59ea1ffed7 = (v)=>$3f77fa41782f639b$var$valueTypes.find((0, $bce78752b9f7f913$export$6eae4d0a6a7ca7cd)(v));







const $59dc28bcfaa62e03$var$propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ class $59dc28bcfaa62e03$export$fa8b653c0f3714e5 {
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ scrapeMotionValuesFromProps(_props, _prevProps, _visualElement) {
        return {};
    }
    constructor({ parent: parent , props: props , presenceContext: presenceContext , reducedMotionConfig: reducedMotionConfig , blockInitialAnimation: blockInitialAnimation , visualState: visualState  }, options = {}){
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        this.KeyframeResolver = (0, $8a643b2da1c7bc40$export$74d34ca3182f1750);
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = ()=>this.notify("Update", this.latestValues);
        this.render = ()=>{
            if (!this.current) return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.renderScheduledAt = 0.0;
        this.scheduleRender = ()=>{
            const now = (0, $05b982fb85a2786e$export$2da9be4cfdb689b1).now();
            if (this.renderScheduledAt < now) {
                this.renderScheduledAt = now;
                (0, $6491bdd13544fdda$export$2cef06c20297c17d).render(this.render, false, true);
            }
        };
        const { latestValues: latestValues , renderState: renderState  } = visualState;
        this.latestValues = latestValues;
        this.baseTarget = {
            ...latestValues
        };
        this.initialValues = props.initial ? {
            ...latestValues
        } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.options = options;
        this.blockInitialAnimation = Boolean(blockInitialAnimation);
        this.isControllingVariants = (0, $a01dc07902ba23d1$export$4b3c3bd8d910d78d)(props);
        this.isVariantNode = (0, $a01dc07902ba23d1$export$ce46fa4165cdec40)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't necessarily a breaking change,
         * more a reflection of the test.
         */ const { willChange: willChange , ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {}, this);
        for(const key in initialMotionValues){
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $d449570363f09a53$export$605d60a2578142d3)(value)) value.set(latestValues[key], false);
        }
    }
    mount(instance) {
        this.current = instance;
        (0, $7680e86648d809f1$export$bc2a978a17abfdde).set(instance, this);
        if (this.projection && !this.projection.instance) this.projection.mount(instance);
        if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
        this.values.forEach((value, key)=>this.bindToMotionValue(key, value));
        if (!(0, $16faa30fcf534207$export$6476d16e2fd2d0db).current) (0, $8c52f85ab085b323$export$ca9f41fb23dded3d)();
        this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : (0, $16faa30fcf534207$export$ff7706047246b98b).current;
        if (this.parent) this.parent.children.add(this);
        this.update(this.props, this.presenceContext);
    }
    unmount() {
        (0, $7680e86648d809f1$export$bc2a978a17abfdde).delete(this.current);
        this.projection && this.projection.unmount();
        (0, $6491bdd13544fdda$export$ec99c0ef4978dccb)(this.notifyUpdate);
        (0, $6491bdd13544fdda$export$ec99c0ef4978dccb)(this.render);
        this.valueSubscriptions.forEach((remove)=>remove());
        this.valueSubscriptions.clear();
        this.removeFromVariantTree && this.removeFromVariantTree();
        this.parent && this.parent.children.delete(this);
        for(const key in this.events)this.events[key].clear();
        for(const key in this.features){
            const feature = this.features[key];
            if (feature) {
                feature.unmount();
                feature.isMounted = false;
            }
        }
        this.current = null;
    }
    bindToMotionValue(key, value) {
        if (this.valueSubscriptions.has(key)) this.valueSubscriptions.get(key)();
        const valueIsTransform = (0, $05d385f303970557$export$7b42a0094fb00b6e).has(key);
        const removeOnChange = value.on("change", (latestValue)=>{
            this.latestValues[key] = latestValue;
            this.props.onUpdate && (0, $6491bdd13544fdda$export$2cef06c20297c17d).preRender(this.notifyUpdate);
            if (valueIsTransform && this.projection) this.projection.isTransformDirty = true;
        });
        const removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
        let removeSyncCheck;
        if (window.MotionCheckAppearSync) removeSyncCheck = window.MotionCheckAppearSync(this, key, value);
        this.valueSubscriptions.set(key, ()=>{
            removeOnChange();
            removeOnRenderRequest();
            if (removeSyncCheck) removeSyncCheck();
            if (value.owner) value.stop();
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    updateFeatures() {
        let key = "animation";
        for(key in 0, $145d8d26c6dc52b8$export$65570e08d843624d){
            const featureDefinition = (0, $145d8d26c6dc52b8$export$65570e08d843624d)[key];
            if (!featureDefinition) continue;
            const { isEnabled: isEnabled , Feature: FeatureConstructor  } = featureDefinition;
            /**
             * If this feature is enabled but not active, make a new instance.
             */ if (!this.features[key] && FeatureConstructor && isEnabled(this.props)) this.features[key] = new FeatureConstructor(this);
            /**
             * If we have a feature, mount or update it.
             */ if (this.features[key]) {
                const feature = this.features[key];
                if (feature.isMounted) feature.update();
                else {
                    feature.mount();
                    feature.isMounted = true;
                }
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ update(props, presenceContext) {
        if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
        this.prevProps = this.props;
        this.props = props;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = presenceContext;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(let i = 0; i < $59dc28bcfaa62e03$var$propEventHandlers.length; i++){
            const key = $59dc28bcfaa62e03$var$propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listenerName = "on" + key;
            const listener = props[listenerName];
            if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
        }
        this.prevMotionValues = (0, $c1ce9b34358097f3$export$9a552858d5197f6e)(this, this.scrapeMotionValuesFromProps(props, this.prevProps, this), this.prevMotionValues);
        if (this.handleChildMotionValue) this.handleChildMotionValue();
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */ getVariant(name) {
        return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */ getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
    /**
     * Add a child visual element to our set of children.
     */ addVariantChild(child) {
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
            return ()=>closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */ addValue(key, value) {
        // Remove existing value if it exists
        const existingValue = this.values.get(key);
        if (value !== existingValue) {
            if (existingValue) this.removeValue(key);
            this.bindToMotionValue(key, value);
            this.values.set(key, value);
            this.latestValues[key] = value.get();
        }
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */ removeValue(key) {
        this.values.delete(key);
        const unsubscribe = this.valueSubscriptions.get(key);
        if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
        }
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */ hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) return this.props.values[key];
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = (0, $925342fde4532b85$export$ce8bdc721e76545f)(defaultValue === null ? undefined : defaultValue, {
                owner: this
            });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ readValue(key, target) {
        var _a;
        let value = this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : (_a = this.getBaseTargetFromProps(this.props, key)) !== null && _a !== void 0 ? _a : this.readValueFromInstance(this.current, key, this.options);
        if (value !== undefined && value !== null) {
            if (typeof value === "string" && ((0, $307e1e0a636b2ddb$export$65583ed5a868f2d9)(value) || (0, $e46637106d3b5fd8$export$ade84c85e44a6cb1)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
            value = parseFloat(value);
            else if (!(0, $3f77fa41782f639b$export$950e7e59ea1ffed7)(value) && (0, $a554c66132092e1c$export$83a0e34f1302825b).test(target)) value = (0, $1838583c06c42261$export$cea0cedcb94873b5)(key, target);
            this.setBaseTarget(key, (0, $d449570363f09a53$export$605d60a2578142d3)(value) ? value.get() : value);
        }
        return (0, $d449570363f09a53$export$605d60a2578142d3)(value) ? value.get() : value;
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ getBaseTarget(key) {
        var _a;
        const { initial: initial  } = this.props;
        let valueFromInitial;
        if (typeof initial === "string" || typeof initial === "object") {
            const variant = (0, $960c679efe64d12b$export$d68f140c4d9b48bc)(this.props, initial, (_a = this.presenceContext) === null || _a === void 0 ? void 0 : _a.custom);
            if (variant) valueFromInitial = variant[key];
        }
        /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !(0, $d449570363f09a53$export$605d60a2578142d3)(target)) return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $fe92d8ac7a8c9e00$export$e7dff9482a5fd23c)();
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        if (this.events[eventName]) this.events[eventName].notify(...args);
    }
}




class $f82c67e8782ea4e3$export$e49735c2a366bdc7 extends (0, $59dc28bcfaa62e03$export$fa8b653c0f3714e5) {
    constructor(){
        super(...arguments);
        this.KeyframeResolver = (0, $c8b2f05e40a653fe$export$4983792d11b61017);
    }
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        return props.style ? props.style[key] : undefined;
    }
    removeValueFromRenderState(key, { vars: vars , style: style  }) {
        delete vars[key];
        delete style[key];
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children: children  } = this.props;
        if ((0, $d449570363f09a53$export$605d60a2578142d3)(children)) this.childSubscription = children.on("change", (latest)=>{
            if (this.current) this.current.textContent = `${latest}`;
        });
    }
}


function $c22d56f4f698c1a8$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
class $c22d56f4f698c1a8$export$23fea75b03ac16b3 extends (0, $f82c67e8782ea4e3$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.type = "html";
        this.renderInstance = (0, $46b26a876b49a8ee$export$1a32bf6229c258c0);
    }
    readValueFromInstance(instance, key) {
        if ((0, $05d385f303970557$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $5244b39289cc5c6d$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        } else {
            const computedStyle = $c22d56f4f698c1a8$export$3735103072e4a80(instance);
            const value = ((0, $9223341d00255d67$export$9de1236619d9e756)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint: transformPagePoint  }) {
        return (0, $0b2600dd2e3d7275$export$d8718b6a7e5c624e)(instance, transformPagePoint);
    }
    build(renderState, latestValues, props) {
        (0, $5a314cc097974a58$export$bb517f8b40f8e99d)(renderState, latestValues, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $c0a33d9fc770b07f$export$16da615486abaa45)(props, prevProps, visualElement);
    }
}












class $86a41d187babab09$export$86bcdffbaf733d84 extends (0, $f82c67e8782ea4e3$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.type = "svg";
        this.isSVGTag = false;
        this.measureInstanceViewportBox = (0, $93b39ae61dedc877$export$6459fc9e86be362e);
    }
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if ((0, $05d385f303970557$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $5244b39289cc5c6d$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !(0, $896574d8c8ac028d$export$28931db5d57958e5).has(key) ? (0, $002b84d235cc9e7f$export$9fd24a634729c672)(key) : key;
        return instance.getAttribute(key);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $4c234d289d8baf9a$export$16da615486abaa45)(props, prevProps, visualElement);
    }
    build(renderState, latestValues, props) {
        (0, $6f8e2d5207755192$export$5475d24f125d7053)(renderState, latestValues, this.isSVGTag, props.transformTemplate);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $50c74351dd8901bc$export$c5f8399d19a7394b)(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = (0, $5c8095c47c03f29b$export$6328ce7565ea1049)(instance.tagName);
        super.mount(instance);
    }
}



const $584c8429f63c1575$export$56ba0183203348f5 = (Component, options)=>{
    return (0, $f9a5862a9160f78d$export$88f3fc2fd3766989)(Component) ? new (0, $86a41d187babab09$export$86bcdffbaf733d84)(options) : new (0, $c22d56f4f698c1a8$export$23fea75b03ac16b3)(options, {
        allowProjection: Component !== (0, $bh6RR.Fragment)
    });
};


const $ec34781bd544d1a0$export$46b7e4b9dc6110c3 = /*@__PURE__*/ (0, $047ad38a006b91b1$export$d86feac869a7f0d5)({
    ...(0, $61912b83da9ce72c$export$7f9953c70dacfd7f),
    ...(0, $aadd72d7ca06bd3a$export$e5b72898e5a201f1),
    ...(0, $5e0aeefdd70dc82e$export$d7d5d435647ed5a0),
    ...(0, $17a320fc4896a503$export$b3219800bda33a1f)
}, (0, $584c8429f63c1575$export$56ba0183203348f5));


const $08c9f1bffbd2aec7$export$e25e478948902b8b = /*@__PURE__*/ (0, $118ccf88bcfc51b9$export$3af29c0efb268f04)((0, $ec34781bd544d1a0$export$46b7e4b9dc6110c3));


function $9a660e92d1863a0e$var$Body() {
    const { moveHistory: moveHistory  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $7ead3b1a9a673b0a$export$58d75f9829cbe158));
    var whiteToMove = moveHistory.length % 2 === 0;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($9a660e92d1863a0e$var$Content, {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($9a660e92d1863a0e$var$Wrapper2, {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($9a660e92d1863a0e$var$BoardWrapper, {
                        layout: true,
                        initial: {
                            flex: 70,
                            marginTop: "0",
                            opacity: 1
                        },
                        animate: {
                            flex: whiteToMove ? 70 : 60,
                            marginTop: whiteToMove ? "0" : "50px",
                            opacity: whiteToMove ? 1.0 : 0.65
                        },
                        transition: {
                            duration: 0.5
                        },
                        flex: whiteToMove ? 70 : 60,
                        marginTop: whiteToMove ? "0" : "50px",
                        opacity: whiteToMove ? 1.0 : 0.65,
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $82bed5901a6d171c$export$2e2bcd8739ae039), {
                            boardId: "1",
                            initialOrientation: "white"
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($9a660e92d1863a0e$var$BoardWrapper, {
                        layout: true,
                        initial: {
                            flex: 60,
                            marginTop: "50px",
                            opacity: 0.65
                        },
                        animate: {
                            flex: whiteToMove ? 60 : 70,
                            marginTop: whiteToMove ? "50px" : "0",
                            opacity: whiteToMove ? 0.65 : 1
                        },
                        transition: {
                            duration: 0.5
                        },
                        flex: whiteToMove ? 60 : 70,
                        marginTop: whiteToMove ? "50px" : "0",
                        opacity: whiteToMove ? 0.65 : 1,
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $82bed5901a6d171c$export$2e2bcd8739ae039), {
                            boardId: "2",
                            initialOrientation: "black"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($9a660e92d1863a0e$var$MoveTableWrapper, {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $92686b3f28b72d7a$export$2e2bcd8739ae039), {})
            })
        ]
    });
}
const $9a660e92d1863a0e$var$ToMoveWrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).span`
  color: white;
`;
const $9a660e92d1863a0e$var$Wrapper2 = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  display: flex;
  width: 100%;
`;
const $9a660e92d1863a0e$var$BoardWrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039)((0, $08c9f1bffbd2aec7$export$e25e478948902b8b).div)`
  flex: ${(props)=>props.flex};
  background-color: #161512;
  padding-top: 60px;
  padding-left: 50px;
  padding-right: 50px;
`;
const $9a660e92d1863a0e$var$MoveTableWrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  flex: 15;
  background-color: #161512;
`;
const $9a660e92d1863a0e$var$Content = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  display: flex;
  height: 100%;
`;
var $9a660e92d1863a0e$export$2e2bcd8739ae039 = $9a660e92d1863a0e$var$Body;





function $5c4c715ef872aa13$var$App() {
    return(// <UserProvider>
    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $7ead3b1a9a673b0a$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($5c4c715ef872aa13$var$Wrapper, {
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2d9d74cd18324bdd$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $9a660e92d1863a0e$export$2e2bcd8739ae039), {})
            ]
        })
    }));
}
var $5c4c715ef872aa13$export$2e2bcd8739ae039 = $5c4c715ef872aa13$var$App;
const $5c4c715ef872aa13$var$Wrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  background-color: #161512;
  height: 100%;
`;






const $1f0dc3b9307be026$var$root = (0, $6fc264ec92100d3a$export$882461b6382ed46c)(document.querySelector("#root"));
$1f0dc3b9307be026$var$root.render(/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5c4c715ef872aa13$export$2e2bcd8739ae039), {}));


//# sourceMappingURL=index.fbccb2d3.js.map
